export const airbnb = {
  type: "FeatureCollection",
  name: "airbnb",
  crs: { type: "name", properties: { name: "urn:ogc:def:crs:OGC:1.3:CRS84" } },
  features: [
    {
      type: "Feature",
      properties: {
        id: 6623,
        name: "Venice Blue on Canal apartment",
        host_id: 15016,
        host_name: "Francesca",
        latitude: 45.43823,
        longitude: 12.32902,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32902, 45.43823]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6624,
        name: "Venice garden charme and canal view!",
        host_id: 15016,
        host_name: "Francesca",
        latitude: 45.43845,
        longitude: 12.32869,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32869, 45.43845]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12074,
        name: "Venice home to relax and emotions",
        host_id: 15016,
        host_name: "Francesca",
        latitude: 45.43827,
        longitude: 12.32764,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32764, 45.43827]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27116,
        name: "Charming room with balcony close to S. Mark's",
        host_id: 116144,
        host_name: "Gianni",
        latitude: 45.43221,
        longitude: 12.33411,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33411, 45.43221]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27574,
        name: "MINI APARTMENT 30 MT FROM GRAND CANAL",
        host_id: 119219,
        host_name: "Elisa",
        latitude: 45.44031,
        longitude: 12.32313,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32313, 45.44031]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32261,
        name:
          "Venice close to Biennale exhibition (M (Phone number hidden by Airbnb)",
        host_id: 139420,
        host_name: "Maura",
        latitude: 45.43451,
        longitude: 12.3565,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3565, 45.43451]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33934,
        name: "LOVELY APARTMENT IN THE CENTER",
        host_id: 119219,
        host_name: "Elisa",
        latitude: 45.4448,
        longitude: 12.33121,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33121, 45.4448]] },
    },
    {
      type: "Feature",
      properties: {
        id: 44527,
        name: "Historical Luxury Apartment on Calm Sunny Canal",
        host_id: 120215,
        host_name: "Marc & Elisabeth",
        latitude: 45.44754,
        longitude: 12.32918,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32918, 45.44754]] },
    },
    {
      type: "Feature",
      properties: {
        id: 44998,
        name: "Furlani Loft for up to 6",
        host_id: 198581,
        host_name: "Laura",
        latitude: 45.43854,
        longitude: 12.34959,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34959, 45.43854]] },
    },
    {
      type: "Feature",
      properties: {
        id: 45036,
        name: "San Toma Apartment - Venice",
        host_id: 198581,
        host_name: "Laura",
        latitude: 45.43723,
        longitude: 12.32451,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32451, 45.43723]] },
    },
    {
      type: "Feature",
      properties: {
        id: 46054,
        name: "Fuseri Apartment -Canal view",
        host_id: 198581,
        host_name: "Laura",
        latitude: 45.43439,
        longitude: 12.33509,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33509, 45.43439]] },
    },
    {
      type: "Feature",
      properties: {
        id: 46158,
        name: "Few steps from San Marco Square",
        host_id: 198581,
        host_name: "Laura",
        latitude: 45.43468,
        longitude: 12.33613,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33613, 45.43468]] },
    },
    {
      type: "Feature",
      properties: {
        id: 46171,
        name: "Apartment Cà d'Oro - Canal view",
        host_id: 198581,
        host_name: "Laura",
        latitude: 45.44185,
        longitude: 12.33355,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33355, 45.44185]] },
    },
    {
      type: "Feature",
      properties: {
        id: 47383,
        name: "Ca' Barba B&B: room n102 (jacuzzi shower)",
        host_id: 214390,
        host_name: "Alessandro",
        latitude: 45.43846,
        longitude: 12.33235,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33235, 45.43846]] },
    },
    {
      type: "Feature",
      properties: {
        id: 47549,
        name: "Ca' Barba Apartment",
        host_id: 215652,
        host_name: "Caterina E Alessandro",
        latitude: 45.43541,
        longitude: 12.3246,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3246, 45.43541]] },
    },
    {
      type: "Feature",
      properties: {
        id: 49656,
        name: "Ca' Foscari Apartment",
        host_id: 226598,
        host_name: "Andrea",
        latitude: 45.43505,
        longitude: 12.32668,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32668, 45.43505]] },
    },
    {
      type: "Feature",
      properties: {
        id: 51847,
        name: "Furlani Apartment",
        host_id: 198581,
        host_name: "Laura",
        latitude: 45.43546,
        longitude: 12.34636,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34636, 45.43546]] },
    },
    {
      type: "Feature",
      properties: {
        id: 55968,
        name: "Great canal view close to S.Marco",
        host_id: 264845,
        host_name: "Paola",
        latitude: 45.43699,
        longitude: 12.34741,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34741, 45.43699]] },
    },
    {
      type: "Feature",
      properties: {
        id: 56687,
        name: "Waterfront Charm in Central Venice",
        host_id: 268967,
        host_name: "Renato",
        latitude: 45.44525,
        longitude: 12.33166,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33166, 45.44525]] },
    },
    {
      type: "Feature",
      properties: {
        id: 60007,
        name: "Apartament alla Fenice a Venezia",
        host_id: 288678,
        host_name: "Furio",
        latitude: 45.43302,
        longitude: 12.332,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.332, 45.43302]] },
    },
    {
      type: "Feature",
      properties: {
        id: 60020,
        name: "Bed and Breakfast (Website hidden by Airbnb)",
        host_id: 288785,
        host_name: "Nicola",
        latitude: 45.44059,
        longitude: 12.32952,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32952, 45.44059]] },
    },
    {
      type: "Feature",
      properties: {
        id: 60304,
        name: "B&B  Venice Casa Baseggio",
        host_id: 290452,
        host_name: "Marco",
        latitude: 45.44334,
        longitude: 12.33483,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33483, 45.44334]] },
    },
    {
      type: "Feature",
      properties: {
        id: 61714,
        name: "B&B AL CANAL VENICE canal view",
        host_id: 289023,
        host_name: "Francesca",
        latitude: 45.42817,
        longitude: 12.3192,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3192, 45.42817]] },
    },
    {
      type: "Feature",
      properties: {
        id: 63267,
        name: "Appartamento con splendida vista sulla Laguna",
        host_id: 308732,
        host_name: "Cristina",
        latitude: 45.43818,
        longitude: 12.35032,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35032, 45.43818]] },
    },
    {
      type: "Feature",
      properties: {
        id: 65926,
        name: "APPARTAMENTO AL PERGOLO  CANAL VIEW",
        host_id: 289023,
        host_name: "Francesca",
        latitude: 45.43108,
        longitude: 12.32593,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32593, 45.43108]] },
    },
    {
      type: "Feature",
      properties: {
        id: 69375,
        name: "Armonia Apartment  Venice's flavour",
        host_id: 347332,
        host_name: "Guido",
        latitude: 45.44555,
        longitude: 12.32155,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32155, 45.44555]] },
    },
    {
      type: "Feature",
      properties: {
        id: 71735,
        name: "a stone's throw to St.Markwith WiFi",
        host_id: 368293,
        host_name: "Grazia",
        latitude: 45.43482,
        longitude: 12.33648,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33648, 45.43482]] },
    },
    {
      type: "Feature",
      properties: {
        id: 71870,
        name: "Biennale - Great & cosy flat",
        host_id: 369617,
        host_name: "Irene",
        latitude: 45.42906,
        longitude: 12.3582,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3582, 45.42906]] },
    },
    {
      type: "Feature",
      properties: {
        id: 71874,
        name: "rooms in Venice",
        host_id: 369642,
        host_name: "Valter",
        latitude: 45.44001,
        longitude: 12.32552,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32552, 45.44001]] },
    },
    {
      type: "Feature",
      properties: {
        id: 72000,
        name: "Unique green gem: private court, boat, concierge",
        host_id: 370543,
        host_name: "Diana",
        latitude: 45.43006,
        longitude: 12.35652,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35652, 45.43006]] },
    },
    {
      type: "Feature",
      properties: {
        id: 74042,
        name: "Low Cost Romantic Venice",
        host_id: 9609304,
        host_name: "Luca",
        latitude: 45.43463,
        longitude: 12.35122,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35122, 45.43463]] },
    },
    {
      type: "Feature",
      properties: {
        id: 74272,
        name: "Ca' Annalaura 2 with private court",
        host_id: 390175,
        host_name: "Monica",
        latitude: 45.43476,
        longitude: 12.34999,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34999, 45.43476]] },
    },
    {
      type: "Feature",
      properties: {
        id: 74873,
        name: "Al Campanile Madonna Dell'Orto: Apt BEIGE",
        host_id: 394892,
        host_name: "Hossep",
        latitude: 45.44699,
        longitude: 12.33227,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33227, 45.44699]] },
    },
    {
      type: "Feature",
      properties: {
        id: 75376,
        name: "Saint Mark apartment  in  Venice",
        host_id: 399883,
        host_name: "Monica",
        latitude: 45.43569,
        longitude: 12.33598,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33598, 45.43569]] },
    },
    {
      type: "Feature",
      properties: {
        id: 75760,
        name: "at Biennale Giardini - Cà Zaleta",
        host_id: 402656,
        host_name: "Luigi & Giovanna",
        latitude: 45.43119,
        longitude: 12.3571,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3571, 45.43119]] },
    },
    {
      type: "Feature",
      properties: {
        id: 75994,
        name: "San Bortolomio Apartment - WI FI",
        host_id: 399883,
        host_name: "Monica",
        latitude: 45.43669,
        longitude: 12.336,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.336, 45.43669]] },
    },
    {
      type: "Feature",
      properties: {
        id: 77188,
        name: "Ca' Annalaura 1 with private court",
        host_id: 390175,
        host_name: "Monica",
        latitude: 45.43385,
        longitude: 12.34786,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34786, 45.43385]] },
    },
    {
      type: "Feature",
      properties: {
        id: 77598,
        name: "Ca' Gioiosa",
        host_id: 416351,
        host_name: "Italo",
        latitude: 45.43103,
        longitude: 12.31997,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31997, 45.43103]] },
    },
    {
      type: "Feature",
      properties: {
        id: 77848,
        name: "ALLELUIA 33 - INDIVIDUAL ACCOMMODATION WITH LIFT",
        host_id: 119219,
        host_name: "Elisa",
        latitude: 45.4396,
        longitude: 12.32345,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32345, 45.4396]] },
    },
    {
      type: "Feature",
      properties: {
        id: 78706,
        name: "Al Campanile Madonna Dell'Orto: Apt. NERO",
        host_id: 394892,
        host_name: "Hossep",
        latitude: 45.44648,
        longitude: 12.33248,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33248, 45.44648]] },
    },
    {
      type: "Feature",
      properties: {
        id: 78833,
        name: "Al Campanile: Loft ROSSO",
        host_id: 394892,
        host_name: "Hossep",
        latitude: 45.44648,
        longitude: 12.33187,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33187, 45.44648]] },
    },
    {
      type: "Feature",
      properties: {
        id: 79717,
        name: "MINI LOFT WITH A ROOF BALCONY",
        host_id: 119219,
        host_name: "Elisa",
        latitude: 45.44015,
        longitude: 12.32307,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32307, 45.44015]] },
    },
    {
      type: "Feature",
      properties: {
        id: 80403,
        name: "Elegant apartment with privatgarden",
        host_id: 434492,
        host_name: "Lucia",
        latitude: 45.43286,
        longitude: 12.32043,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32043, 45.43286]] },
    },
    {
      type: "Feature",
      properties: {
        id: 83368,
        name: "Casa Granda in historical building",
        host_id: 208909,
        host_name: "Marta",
        latitude: 45.43678,
        longitude: 12.32752,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32752, 45.43678]] },
    },
    {
      type: "Feature",
      properties: {
        id: 83610,
        name: "GRANDIBEN: Biennale at your fingertips",
        host_id: 434231,
        host_name: "Magda",
        latitude: 45.43513,
        longitude: 12.34894,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34894, 45.43513]] },
    },
    {
      type: "Feature",
      properties: {
        id: 91525,
        name: "DIVYA - 1st class apartment",
        host_id: 494255,
        host_name: "Rosa",
        latitude: 45.43992,
        longitude: 12.33035,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33035, 45.43992]] },
    },
    {
      type: "Feature",
      properties: {
        id: 92159,
        name: "B&B. AL CANAL VENICE  green room garden view",
        host_id: 289023,
        host_name: "Francesca",
        latitude: 45.4275,
        longitude: 12.31935,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31935, 45.4275]] },
    },
    {
      type: "Feature",
      properties: {
        id: 95980,
        name: "22 Marzo by St. Mark's Square - 1-BR Apt",
        host_id: 510349,
        host_name: "Roberta",
        latitude: 45.43278,
        longitude: 12.33494,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33494, 45.43278]] },
    },
    {
      type: "Feature",
      properties: {
        id: 99238,
        name: "Ca' Risorta  ♡ Your romantic retreat",
        host_id: 419326,
        host_name: "Federica",
        latitude: 45.44394,
        longitude: 12.32904,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32904, 45.44394]] },
    },
    {
      type: "Feature",
      properties: {
        id: 103249,
        name: "Quiet and style in Venice",
        host_id: 208909,
        host_name: "Marta",
        latitude: 45.43723,
        longitude: 12.32718,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32718, 45.43723]] },
    },
    {
      type: "Feature",
      properties: {
        id: 110388,
        name: "Lovely private room in Venice, close to Biennale",
        host_id: 567508,
        host_name: "Nicola",
        latitude: 45.432,
        longitude: 12.356,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.356, 45.432]] },
    },
    {
      type: "Feature",
      properties: {
        id: 118751,
        name: "NEAR THE TRAIN STATION",
        host_id: 119219,
        host_name: "Elisa",
        latitude: 45.44086,
        longitude: 12.32321,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32321, 45.44086]] },
    },
    {
      type: "Feature",
      properties: {
        id: 130605,
        name: "Sweet dreams",
        host_id: 642936,
        host_name: "Maria",
        latitude: 45.43921,
        longitude: 12.32146,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32146, 45.43921]] },
    },
    {
      type: "Feature",
      properties: {
        id: 131244,
        name: "Giardino dei Melograni  Economy Room",
        host_id: 630328,
        host_name: "Kosher House",
        latitude: 45.44487,
        longitude: 12.32642,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32642, 45.44487]] },
    },
    {
      type: "Feature",
      properties: {
        id: 131822,
        name: "Giardino dei Melograni triple room",
        host_id: 630328,
        host_name: "Kosher House",
        latitude: 45.44634,
        longitude: 12.32597,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32597, 45.44634]] },
    },
    {
      type: "Feature",
      properties: {
        id: 131895,
        name: "Giardino dei Melograni DUS",
        host_id: 630328,
        host_name: "Kosher House",
        latitude: 45.44494,
        longitude: 12.32759,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32759, 45.44494]] },
    },
    {
      type: "Feature",
      properties: {
        id: 131939,
        name: "Giardino dei Melograni family room",
        host_id: 630328,
        host_name: "Kosher House",
        latitude: 45.44601,
        longitude: 12.32668,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32668, 45.44601]] },
    },
    {
      type: "Feature",
      properties: {
        id: 134035,
        name: "HAPPY AND LUMINOUS FLAT IN VENICE WITH TERRACE",
        host_id: 653451,
        host_name: "Sara",
        latitude: 45.43438,
        longitude: 12.34683,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34683, 45.43438]] },
    },
    {
      type: "Feature",
      properties: {
        id: 136713,
        name: "Ca' Del Mercante Grand Canal with Roof Terrace",
        host_id: 669047,
        host_name: "Viewsonvenice",
        latitude: 45.43556,
        longitude: 12.327,
        beds: 7,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.327, 45.43556]] },
    },
    {
      type: "Feature",
      properties: {
        id: 137087,
        name: "A true Venetian house near St. Mark",
        host_id: 264845,
        host_name: "Paola",
        latitude: 45.43655,
        longitude: 12.34655,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34655, 45.43655]] },
    },
    {
      type: "Feature",
      properties: {
        id: 139786,
        name: "Ca' Grassi 2 Charme Apartment",
        host_id: 669047,
        host_name: "Viewsonvenice",
        latitude: 45.43452,
        longitude: 12.32931,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32931, 45.43452]] },
    },
    {
      type: "Feature",
      properties: {
        id: 139802,
        name: "Ca' Grassi 1 Apartment for 4/5 Guests",
        host_id: 669047,
        host_name: "Viewsonvenice",
        latitude: 45.43314,
        longitude: 12.32859,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32859, 45.43314]] },
    },
    {
      type: "Feature",
      properties: {
        id: 140197,
        name: "Nest of Love- Near  RIALTO BRIDGE",
        host_id: 683035,
        host_name: "Paola",
        latitude: 45.43919,
        longitude: 12.33397,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33397, 45.43919]] },
    },
    {
      type: "Feature",
      properties: {
        id: 142085,
        name: "Widmann apartment in Venice centre",
        host_id: 690500,
        host_name: "Tisone",
        latitude: 45.44018,
        longitude: 12.33788,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33788, 45.44018]] },
    },
    {
      type: "Feature",
      properties: {
        id: 145324,
        name: "Double room with a View of the city",
        host_id: 703872,
        host_name: "Leonardo E Irene",
        latitude: 45.44324,
        longitude: 12.33954,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33954, 45.44324]] },
    },
    {
      type: "Feature",
      properties: {
        id: 145346,
        name: "DOUBLE ROOM WITH A PRIVATE BATHROOM, OWN ENTRANCE",
        host_id: 119219,
        host_name: "Elisa",
        latitude: 45.4421,
        longitude: 12.32146,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32146, 45.4421]] },
    },
    {
      type: "Feature",
      properties: {
        id: 146821,
        name: "Ca' dell' Ambasciatore Venezia",
        host_id: 709828,
        host_name: "Roberto",
        latitude: 45.43265,
        longitude: 12.35169,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35169, 45.43265]] },
    },
    {
      type: "Feature",
      properties: {
        id: 148066,
        name: "Happy Venice-elegant flat in S.Marc",
        host_id: 715286,
        host_name: "Roberto",
        latitude: 45.4345,
        longitude: 12.33721,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33721, 45.4345]] },
    },
    {
      type: "Feature",
      properties: {
        id: 148299,
        name: "ARABESQUE- DAMASCO 4 PERSONS",
        host_id: 716234,
        host_name: "Paola",
        latitude: 45.43601,
        longitude: 12.34373,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34373, 45.43601]] },
    },
    {
      type: "Feature",
      properties: {
        id: 148794,
        name: "elegant house of 500 in Venice",
        host_id: 685618,
        host_name: "Luisa",
        latitude: 45.44374,
        longitude: 12.33219,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33219, 45.44374]] },
    },
    {
      type: "Feature",
      properties: {
        id: 149749,
        name: "Venice, newly restored unit-apartm.",
        host_id: 722130,
        host_name: "Maddalena",
        latitude: 45.44041,
        longitude: 12.34096,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34096, 45.44041]] },
    },
    {
      type: "Feature",
      properties: {
        id: 155015,
        name: "nice and cozy open space apartment",
        host_id: 745553,
        host_name: "Rosanna E Francesca",
        latitude: 45.44184,
        longitude: 12.32786,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32786, 45.44184]] },
    },
    {
      type: "Feature",
      properties: {
        id: 156728,
        name: "Regina d'Oriente",
        host_id: 745553,
        host_name: "Rosanna E Francesca",
        latitude: 45.44077,
        longitude: 12.33096,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33096, 45.44077]] },
    },
    {
      type: "Feature",
      properties: {
        id: 160426,
        name: "Bright apartment in Venice with canal view",
        host_id: 766256,
        host_name: "Laura",
        latitude: 45.43322,
        longitude: 12.32072,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32072, 45.43322]] },
    },
    {
      type: "Feature",
      properties: {
        id: 163685,
        name: "Ca'Falcao - Air-conditioning & Wifi",
        host_id: 781124,
        host_name: "Nicolò",
        latitude: 45.44262,
        longitude: 12.32485,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32485, 45.44262]] },
    },
    {
      type: "Feature",
      properties: {
        id: 165705,
        name: "ARABESQUE DJERBA 1 PERS.IN VENICE",
        host_id: 716234,
        host_name: "Paola",
        latitude: 45.43712,
        longitude: 12.34393,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34393, 45.43712]] },
    },
    {
      type: "Feature",
      properties: {
        id: 166381,
        name: "Ca' Barba B&B: room n101",
        host_id: 214390,
        host_name: "Alessandro",
        latitude: 45.43996,
        longitude: 12.33265,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33265, 45.43996]] },
    },
    {
      type: "Feature",
      properties: {
        id: 167145,
        name: "Special apartment for loving people",
        host_id: 796717,
        host_name: "Nicola",
        latitude: 45.43405,
        longitude: 12.33528,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33528, 45.43405]] },
    },
    {
      type: "Feature",
      properties: {
        id: 167168,
        name: "Ca 'Barba FLAT - Rialto",
        host_id: 214390,
        host_name: "Alessandro",
        latitude: 45.43986,
        longitude: 12.33153,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33153, 45.43986]] },
    },
    {
      type: "Feature",
      properties: {
        id: 184374,
        name: "ARABESQUE MARRAKESH DOUBLE VENICE",
        host_id: 716234,
        host_name: "Paola",
        latitude: 45.4354,
        longitude: 12.34194,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34194, 45.4354]] },
    },
    {
      type: "Feature",
      properties: {
        id: 208801,
        name: "Bright apartment in the heat of Venice with WIFI",
        host_id: 1028258,
        host_name: "Sandra",
        latitude: 45.43704,
        longitude: 12.33873,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33873, 45.43704]] },
    },
    {
      type: "Feature",
      properties: {
        id: 215895,
        name: "Great view apartment very central",
        host_id: 9701290,
        host_name: "Nicoletta",
        latitude: 45.4413,
        longitude: 12.33764,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33764, 45.4413]] },
    },
    {
      type: "Feature",
      properties: {
        id: 217591,
        name: "Royal Apartments Ca' Pierre",
        host_id: 1123859,
        host_name: "Lorenzo",
        latitude: 45.43767,
        longitude: 12.34657,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34657, 45.43767]] },
    },
    {
      type: "Feature",
      properties: {
        id: 220238,
        name: "Large apartment for 4",
        host_id: 693554,
        host_name: "Valentina",
        latitude: 45.43275,
        longitude: 12.35308,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35308, 45.43275]] },
    },
    {
      type: "Feature",
      properties: {
        id: 234465,
        name: "Sunny house Venice",
        host_id: 1227993,
        host_name: "Giorgio",
        latitude: 45.43379,
        longitude: 12.32053,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32053, 45.43379]] },
    },
    {
      type: "Feature",
      properties: {
        id: 235221,
        name: "Attic with GrandCanal Views",
        host_id: 1229136,
        host_name: "Martina",
        latitude: 45.43386,
        longitude: 12.32865,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32865, 45.43386]] },
    },
    {
      type: "Feature",
      properties: {
        id: 237098,
        name: "Cozy Studio Venice Heart  FREE WIFI",
        host_id: 283131,
        host_name: "Anunxiata",
        latitude: 45.43695,
        longitude: 12.32982,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32982, 45.43695]] },
    },
    {
      type: "Feature",
      properties: {
        id: 238960,
        name: "CA' DOLCE *stunning Channel Views* Free wi-fi :-)",
        host_id: 283131,
        host_name: "Anunxiata",
        latitude: 45.44234,
        longitude: 12.33722,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33722, 45.44234]] },
    },
    {
      type: "Feature",
      properties: {
        id: 242296,
        name: "blacksmith's hearth",
        host_id: 1271580,
        host_name: "Adriana",
        latitude: 45.44606,
        longitude: 12.32429,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32429, 45.44606]] },
    },
    {
      type: "Feature",
      properties: {
        id: 246649,
        name: "Venitian apartment  new and clean!",
        host_id: 1275479,
        host_name: "Giorgia&Michele",
        latitude: 45.43775,
        longitude: 12.32251,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32251, 45.43775]] },
    },
    {
      type: "Feature",
      properties: {
        id: 256874,
        name: "b&b S.Marco Venice, canal view room",
        host_id: 1351366,
        host_name: "Marco E Alice",
        latitude: 45.4366,
        longitude: 12.34584,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34584, 45.4366]] },
    },
    {
      type: "Feature",
      properties: {
        id: 260204,
        name: "Conceptual Devices Apartment 2",
        host_id: 1365288,
        host_name: "Antonio",
        latitude: 45.44247,
        longitude: 12.32975,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32975, 45.44247]] },
    },
    {
      type: "Feature",
      properties: {
        id: 261432,
        name: "Rooftop Studio in Cannaregio (CDA1)",
        host_id: 1365288,
        host_name: "Antonio",
        latitude: 45.44378,
        longitude: 12.32905,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32905, 45.44378]] },
    },
    {
      type: "Feature",
      properties: {
        id: 261640,
        name: "balcony canal view central Venice",
        host_id: 1351366,
        host_name: "Marco E Alice",
        latitude: 45.43691,
        longitude: 12.34493,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34493, 45.43691]] },
    },
    {
      type: "Feature",
      properties: {
        id: 263796,
        name: "Dimora Canaletto - Casa dei Pittori",
        host_id: 1384217,
        host_name: "Simone - Francesco",
        latitude: 45.44022,
        longitude: 12.32676,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32676, 45.44022]] },
    },
    {
      type: "Feature",
      properties: {
        id: 265406,
        name: "large double room-> heart of Venice",
        host_id: 703872,
        host_name: "Leonardo E Irene",
        latitude: 45.44166,
        longitude: 12.3407,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3407, 45.44166]] },
    },
    {
      type: "Feature",
      properties: {
        id: 268865,
        name: "AltanaAlbaChiara BestViewOfVenice",
        host_id: 1408761,
        host_name: "Chiara",
        latitude: 45.43739,
        longitude: 12.3361,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3361, 45.43739]] },
    },
    {
      type: "Feature",
      properties: {
        id: 271400,
        name: "Cà 5393 SmArt: spacious sun bathed lovely house",
        host_id: 1420314,
        host_name: "Chantal",
        latitude: 45.43994,
        longitude: 12.34058,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34058, 45.43994]] },
    },
    {
      type: "Feature",
      properties: {
        id: 271402,
        name: "Cà 5393 Vintage, the coolest house in Venice!",
        host_id: 1420314,
        host_name: "Chantal",
        latitude: 45.44103,
        longitude: 12.34065,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34065, 45.44103]] },
    },
    {
      type: "Feature",
      properties: {
        id: 271409,
        name: "Cà 5393 Orange, cozy house at the ground floor",
        host_id: 1420314,
        host_name: "Chantal",
        latitude: 45.43989,
        longitude: 12.33936,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33936, 45.43989]] },
    },
    {
      type: "Feature",
      properties: {
        id: 271412,
        name: "Cà 5393 Chromotherapy, find new energy in colors!",
        host_id: 1420314,
        host_name: "Chantal",
        latitude: 45.44142,
        longitude: 12.33968,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33968, 45.44142]] },
    },
    {
      type: "Feature",
      properties: {
        id: 272585,
        name: "Apartment Fiori della Laguna",
        host_id: 1426634,
        host_name: "Claudia E Giorgio",
        latitude: 45.43081,
        longitude: 12.33545,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33545, 45.43081]] },
    },
    {
      type: "Feature",
      properties: {
        id: 275264,
        name: "LEONARDO stylish sunny canal view",
        host_id: 1438903,
        host_name: "Barbara",
        latitude: 45.44185,
        longitude: 12.34147,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34147, 45.44185]] },
    },
    {
      type: "Feature",
      properties: {
        id: 286068,
        name: "Romantic room with view between S.Marco and Rialto",
        host_id: 567508,
        host_name: "Nicola",
        latitude: 45.43712,
        longitude: 12.33912,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33912, 45.43712]] },
    },
    {
      type: "Feature",
      properties: {
        id: 286350,
        name: "Corte dei Santi - San Marco",
        host_id: 1490179,
        host_name: "Laura",
        latitude: 45.43852,
        longitude: 12.32876,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32876, 45.43852]] },
    },
    {
      type: "Feature",
      properties: {
        id: 286388,
        name: "Nice apartment in a building with a courtyard",
        host_id: 1490179,
        host_name: "Laura",
        latitude: 45.43591,
        longitude: 12.32362,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32362, 45.43591]] },
    },
    {
      type: "Feature",
      properties: {
        id: 286939,
        name: "Corte dei Santi - San Geremia",
        host_id: 1490179,
        host_name: "Laura",
        latitude: 45.43609,
        longitude: 12.32351,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32351, 45.43609]] },
    },
    {
      type: "Feature",
      properties: {
        id: 290426,
        name: "EXQUISITE,VENICE ,space & quiet",
        host_id: 1506785,
        host_name: "Eric",
        latitude: 45.43429,
        longitude: 12.32092,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32092, 45.43429]] },
    },
    {
      type: "Feature",
      properties: {
        id: 293520,
        name: "Heart of Venice, amazing  house!",
        host_id: 1517643,
        host_name: "Nicola",
        latitude: 45.43924,
        longitude: 12.32922,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32922, 45.43924]] },
    },
    {
      type: "Feature",
      properties: {
        id: 297137,
        name: "Matymarty's-Central Room WI-FI",
        host_id: 1509668,
        host_name: "Martina",
        latitude: 45.4408,
        longitude: 12.32646,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32646, 45.4408]] },
    },
    {
      type: "Feature",
      properties: {
        id: 298501,
        name: "A wonderful view on Venice lagoon",
        host_id: 1538707,
        host_name: "Andrea",
        latitude: 45.4444,
        longitude: 12.33806,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33806, 45.4444]] },
    },
    {
      type: "Feature",
      properties: {
        id: 298506,
        name: "A magic flat facing Venice lagoon",
        host_id: 1538707,
        host_name: "Andrea",
        latitude: 45.4429,
        longitude: 12.33946,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33946, 45.4429]] },
    },
    {
      type: "Feature",
      properties: {
        id: 299936,
        name: "B&B CA' DELLA CORTE IN VENICE",
        host_id: 1545612,
        host_name: "Enrica",
        latitude: 45.4357,
        longitude: 12.321,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.321, 45.4357]] },
    },
    {
      type: "Feature",
      properties: {
        id: 303040,
        name: "Venice-BB-Venezia  (Deluxe room)",
        host_id: 1560575,
        host_name: "Alessandro",
        latitude: 45.44351,
        longitude: 12.32713,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32713, 45.44351]] },
    },
    {
      type: "Feature",
      properties: {
        id: 303046,
        name: "Venice-BB-Venezia  (Superior room Historic center)",
        host_id: 1560575,
        host_name: "Alessandro",
        latitude: 45.44459,
        longitude: 12.3259,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3259, 45.44459]] },
    },
    {
      type: "Feature",
      properties: {
        id: 307700,
        name: "Grand Canal Mini Attic",
        host_id: 1229136,
        host_name: "Martina",
        latitude: 45.43349,
        longitude: 12.32975,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32975, 45.43349]] },
    },
    {
      type: "Feature",
      properties: {
        id: 309411,
        name: "Romantic view over venitian canals",
        host_id: 1275479,
        host_name: "Giorgia&Michele",
        latitude: 45.44076,
        longitude: 12.32452,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32452, 45.44076]] },
    },
    {
      type: "Feature",
      properties: {
        id: 311472,
        name: "Studioflat  near Biennale inVenice!",
        host_id: 1602219,
        host_name: "Alfonso",
        latitude: 45.42847,
        longitude: 12.35913,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35913, 45.42847]] },
    },
    {
      type: "Feature",
      properties: {
        id: 313461,
        name: "Sunny house in Venice",
        host_id: 1227993,
        host_name: "Giorgio",
        latitude: 45.43262,
        longitude: 12.32295,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32295, 45.43262]] },
    },
    {
      type: "Feature",
      properties: {
        id: 314094,
        name: "CA'LOMBARDO SAN MARCO VENICE CENTER",
        host_id: 1613872,
        host_name: "Amedeo",
        latitude: 45.43512,
        longitude: 12.33797,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33797, 45.43512]] },
    },
    {
      type: "Feature",
      properties: {
        id: 314923,
        name: "Rooms with shared bathroom in Venice",
        host_id: 1617572,
        host_name: "Silvia",
        latitude: 45.4322,
        longitude: 12.35236,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35236, 45.4322]] },
    },
    {
      type: "Feature",
      properties: {
        id: 315213,
        name: "Casinò Royal in Campo della Maddalena",
        host_id: 289615,
        host_name: "Valentina",
        latitude: 45.44397,
        longitude: 12.33114,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33114, 45.44397]] },
    },
    {
      type: "Feature",
      properties: {
        id: 317329,
        name: "Venice Flat Ganeo",
        host_id: 6747473,
        host_name: "Giovanna",
        latitude: 45.4274,
        longitude: 12.3614,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3614, 45.4274]] },
    },
    {
      type: "Feature",
      properties: {
        id: 321376,
        name: "Magic of Venice !",
        host_id: 1646068,
        host_name: "Fabiano",
        latitude: 45.44375,
        longitude: 12.32139,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32139, 45.44375]] },
    },
    {
      type: "Feature",
      properties: {
        id: 331151,
        name: "apartment Laura Rialto",
        host_id: 1688828,
        host_name: "Laura",
        latitude: 45.43788,
        longitude: 12.33746,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33746, 45.43788]] },
    },
    {
      type: "Feature",
      properties: {
        id: 332932,
        name: "Romantic apartment on the roofs...",
        host_id: 1445896,
        host_name: "Chiara",
        latitude: 45.43063,
        longitude: 12.35361,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35361, 45.43063]] },
    },
    {
      type: "Feature",
      properties: {
        id: 335226,
        name: "Ca' Dello Squero with Canal View",
        host_id: 669047,
        host_name: "Viewsonvenice",
        latitude: 45.42947,
        longitude: 12.32633,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32633, 45.42947]] },
    },
    {
      type: "Feature",
      properties: {
        id: 335961,
        name: "Romantic QUEEN House,Private Garden",
        host_id: 1364177,
        host_name: "Ivan.Gianni",
        latitude: 45.42771,
        longitude: 12.3609,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3609, 45.42771]] },
    },
    {
      type: "Feature",
      properties: {
        id: 340882,
        name: "Apt in Venice+ terrace in Castello",
        host_id: 1729833,
        host_name: "Alberto",
        latitude: 45.4343,
        longitude: 12.34674,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34674, 45.4343]] },
    },
    {
      type: "Feature",
      properties: {
        id: 341252,
        name: "VENETIAN INFINITY- PIAZZA SAN MARCO-CENTRO STORICO",
        host_id: 1731092,
        host_name: "Sabrina",
        latitude: 45.43432,
        longitude: 12.33935,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33935, 45.43432]] },
    },
    {
      type: "Feature",
      properties: {
        id: 343849,
        name: "Ca' Canaletto Venetian House",
        host_id: 669047,
        host_name: "Viewsonvenice",
        latitude: 45.43293,
        longitude: 12.32344,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32344, 45.43293]] },
    },
    {
      type: "Feature",
      properties: {
        id: 344046,
        name: "small flat close to Rialto Bridge",
        host_id: 1729833,
        host_name: "Alberto",
        latitude: 45.4388,
        longitude: 12.33727,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33727, 45.4388]] },
    },
    {
      type: "Feature",
      properties: {
        id: 346183,
        name: "2960 Ca Frari ( 7 beds ) wifi. a.c.",
        host_id: 1755160,
        host_name: "Davide",
        latitude: 45.43774,
        longitude: 12.32367,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32367, 45.43774]] },
    },
    {
      type: "Feature",
      properties: {
        id: 346257,
        name: "CA' ZUANE - Biennale - free wi-fi",
        host_id: 1755413,
        host_name: "Davide",
        latitude: 45.4305,
        longitude: 12.35809,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35809, 45.4305]] },
    },
    {
      type: "Feature",
      properties: {
        id: 348409,
        name: "SanMarco, 120mq the heart of Venice with terrace",
        host_id: 1765622,
        host_name: "Sebastiano",
        latitude: 45.43481,
        longitude: 12.33575,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33575, 45.43481]] },
    },
    {
      type: "Feature",
      properties: {
        id: 352392,
        name: "SPLENDID STAR SAN MARCO SQUARE",
        host_id: 1784535,
        host_name: "Monica",
        latitude: 45.43601,
        longitude: 12.33904,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33904, 45.43601]] },
    },
    {
      type: "Feature",
      properties: {
        id: 356388,
        name: "Casanova's room",
        host_id: 642936,
        host_name: "Maria",
        latitude: 45.43943,
        longitude: 12.32267,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32267, 45.43943]] },
    },
    {
      type: "Feature",
      properties: {
        id: 358332,
        name: "FEW STEPS FROM SAN MARCO- BLUE CANAL VIEW",
        host_id: 1813795,
        host_name: "Maura",
        latitude: 45.43509,
        longitude: 12.34168,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34168, 45.43509]] },
    },
    {
      type: "Feature",
      properties: {
        id: 360544,
        name: "a stone's throw from Frari church",
        host_id: 1823471,
        host_name: "Michele",
        latitude: 45.43602,
        longitude: 12.3288,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3288, 45.43602]] },
    },
    {
      type: "Feature",
      properties: {
        id: 365973,
        name: "Santa Margherita Big House Venice",
        host_id: 1784566,
        host_name: "Nicola And Maria Chiara",
        latitude: 45.4343,
        longitude: 12.32639,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32639, 45.4343]] },
    },
    {
      type: "Feature",
      properties: {
        id: 369257,
        name: "Appartamento centrale a Venezia 1",
        host_id: 1862349,
        host_name: "Elide",
        latitude: 45.43772,
        longitude: 12.34018,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34018, 45.43772]] },
    },
    {
      type: "Feature",
      properties: {
        id: 372379,
        name: "apartment in the center of Venice, canal view",
        host_id: 619545,
        host_name: "Silvia",
        latitude: 45.4393,
        longitude: 12.32936,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32936, 45.4393]] },
    },
    {
      type: "Feature",
      properties: {
        id: 375305,
        name: "San Marco Terrace in Venice",
        host_id: 1784566,
        host_name: "Nicola And Maria Chiara",
        latitude: 45.43473,
        longitude: 12.3224,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3224, 45.43473]] },
    },
    {
      type: "Feature",
      properties: {
        id: 376362,
        name: "La Galea: Silent, Romantic and large with 2 dbl WF",
        host_id: 1532147,
        host_name: "Giovanni & Patrizia",
        latitude: 45.43452,
        longitude: 12.31691,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31691, 45.43452]] },
    },
    {
      type: "Feature",
      properties: {
        id: 377562,
        name: "CA'PREZIOSA",
        host_id: 1897360,
        host_name: "Davide",
        latitude: 45.44232,
        longitude: 12.33948,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33948, 45.44232]] },
    },
    {
      type: "Feature",
      properties: {
        id: 378039,
        name: "Corte San Francesco",
        host_id: 745553,
        host_name: "Rosanna E Francesca",
        latitude: 45.43877,
        longitude: 12.3477,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3477, 45.43877]] },
    },
    {
      type: "Feature",
      properties: {
        id: 388399,
        name: "Charming Apartment with gran canal view in Rialto",
        host_id: 1943379,
        host_name: "P & R",
        latitude: 45.43876,
        longitude: 12.33178,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33178, 45.43876]] },
    },
    {
      type: "Feature",
      properties: {
        id: 412848,
        name: "Casa Annalisa in front of San Marco",
        host_id: 2054352,
        host_name: "Silvia",
        latitude: 45.42477,
        longitude: 12.33449,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33449, 45.42477]] },
    },
    {
      type: "Feature",
      properties: {
        id: 414370,
        name: "Elegant, Romantic & 4 Family: central Venice wifi.",
        host_id: 1532147,
        host_name: "Giovanni & Patrizia",
        latitude: 45.43262,
        longitude: 12.318,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.318, 45.43262]] },
    },
    {
      type: "Feature",
      properties: {
        id: 420146,
        name: "ELEGANT B&B IN THE MIDDLE OF VENICE",
        host_id: 2089352,
        host_name: "Silvia",
        latitude: 45.43661,
        longitude: 12.34663,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34663, 45.43661]] },
    },
    {
      type: "Feature",
      properties: {
        id: 423767,
        name: "In the peace of a secret garden...",
        host_id: 1981478,
        host_name: "Yaya",
        latitude: 45.44446,
        longitude: 12.32314,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32314, 45.44446]] },
    },
    {
      type: "Feature",
      properties: {
        id: 426097,
        name: "VENICIAN ROOM WITH TERRACE",
        host_id: 1878243,
        host_name: "Elisabetta",
        latitude: 45.44126,
        longitude: 12.34094,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34094, 45.44126]] },
    },
    {
      type: "Feature",
      properties: {
        id: 426305,
        name: "S. GIOVANNI E PAOLO QUIET & COMFORT",
        host_id: 1538707,
        host_name: "Andrea",
        latitude: 45.44173,
        longitude: 12.3407,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3407, 45.44173]] },
    },
    {
      type: "Feature",
      properties: {
        id: 429750,
        name: "Canalside flat in central Venice",
        host_id: 2136473,
        host_name: "David",
        latitude: 45.43215,
        longitude: 12.3227,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3227, 45.43215]] },
    },
    {
      type: "Feature",
      properties: {
        id: 431287,
        name: "APARTMENT GRAPPA PARADISE",
        host_id: 2138358,
        host_name: "Luca",
        latitude: 45.42816,
        longitude: 12.36206,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.36206, 45.42816]] },
    },
    {
      type: "Feature",
      properties: {
        id: 441868,
        name: "Magical view inside Venice.",
        host_id: 2193613,
        host_name: "Pierantonio",
        latitude: 45.44129,
        longitude: 12.32999,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32999, 45.44129]] },
    },
    {
      type: "Feature",
      properties: {
        id: 442154,
        name: "Summer Discounts! - Jewel Box with Private Garden",
        host_id: 2196999,
        host_name: "Barbara",
        latitude: 45.43183,
        longitude: 12.32288,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32288, 45.43183]] },
    },
    {
      type: "Feature",
      properties: {
        id: 452870,
        name: "Dolce Venezia Luxury Flat San Marco - free wifi",
        host_id: 283131,
        host_name: "Anunxiata",
        latitude: 45.43192,
        longitude: 12.33498,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33498, 45.43192]] },
    },
    {
      type: "Feature",
      properties: {
        id: 453896,
        name: "Big flat over venetian canal with great terrace",
        host_id: 674749,
        host_name: "Riccardo",
        latitude: 45.44112,
        longitude: 12.32461,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32461, 45.44112]] },
    },
    {
      type: "Feature",
      properties: {
        id: 463524,
        name: "Apartment two steps from St Mark sq",
        host_id: 1490179,
        host_name: "Laura",
        latitude: 45.43557,
        longitude: 12.33812,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33812, 45.43557]] },
    },
    {
      type: "Feature",
      properties: {
        id: 464154,
        name: "Ca'Biennale Apartment",
        host_id: 2306571,
        host_name: "Beatrice",
        latitude: 45.43071,
        longitude: 12.35624,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35624, 45.43071]] },
    },
    {
      type: "Feature",
      properties: {
        id: 468341,
        name: "Great flat with terrace",
        host_id: 2311463,
        host_name: "Silvia",
        latitude: 45.44066,
        longitude: 12.33847,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33847, 45.44066]] },
    },
    {
      type: "Feature",
      properties: {
        id: 474357,
        name: "Old Secret Venetian House & Garden",
        host_id: 2351876,
        host_name: "Ciro",
        latitude: 45.42681,
        longitude: 12.32077,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32077, 45.42681]] },
    },
    {
      type: "Feature",
      properties: {
        id: 476112,
        name: "Moisè Lounge JUST 90MT S.MARKS sq.",
        host_id: 2360430,
        host_name: "Centrale Venice Apartments",
        latitude: 45.434,
        longitude: 12.33559,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33559, 45.434]] },
    },
    {
      type: "Feature",
      properties: {
        id: 482466,
        name: "BRIGHT APARTMENT WITH TERRACE",
        host_id: 2368512,
        host_name: "Fra",
        latitude: 45.43221,
        longitude: 12.32231,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32231, 45.43221]] },
    },
    {
      type: "Feature",
      properties: {
        id: 483901,
        name: "Charming apt in Molino Stucky w/SPA",
        host_id: 2396006,
        host_name: "Marco",
        latitude: 45.4277,
        longitude: 12.31953,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31953, 45.4277]] },
    },
    {
      type: "Feature",
      properties: {
        id: 485892,
        name: "L0'ving in Venice 5 stars apartment",
        host_id: 2404710,
        host_name: "Silvana",
        latitude: 45.44221,
        longitude: 12.33448,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33448, 45.44221]] },
    },
    {
      type: "Feature",
      properties: {
        id: 486294,
        name: "Bright studio inthe heart of Venice",
        host_id: 1229136,
        host_name: "Martina",
        latitude: 45.43368,
        longitude: 12.32721,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32721, 45.43368]] },
    },
    {
      type: "Feature",
      properties: {
        id: 487484,
        name: "Impressive 3 Bedroom Apartment",
        host_id: 2412054,
        host_name: "Mpa",
        latitude: 45.44579,
        longitude: 12.32287,
        beds: 7,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32287, 45.44579]] },
    },
    {
      type: "Feature",
      properties: {
        id: 487634,
        name: "Charming large palazzo in center Venice",
        host_id: 2320717,
        host_name: "Edouard",
        latitude: 45.43917,
        longitude: 12.33679,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33679, 45.43917]] },
    },
    {
      type: "Feature",
      properties: {
        id: 487772,
        name: "MP",
        host_id: 2413479,
        host_name: "Mp",
        latitude: 45.44443,
        longitude: 12.32115,
        beds: 7,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32115, 45.44443]] },
    },
    {
      type: "Feature",
      properties: {
        id: 492901,
        name: "a short walk from piazza san marco",
        host_id: 6304868,
        host_name: "Roberta",
        latitude: 45.434,
        longitude: 12.3463,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3463, 45.434]] },
    },
    {
      type: "Feature",
      properties: {
        id: 494629,
        name: "CA' AFFRESCO stunning FAMILY FLAT by Saint Mark's!",
        host_id: 1438903,
        host_name: "Barbara",
        latitude: 45.43449,
        longitude: 12.33771,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33771, 45.43449]] },
    },
    {
      type: "Feature",
      properties: {
        id: 495857,
        name: "1 MatyMarty's W.  Central Room WI-FI",
        host_id: 1509668,
        host_name: "Martina",
        latitude: 45.44184,
        longitude: 12.32637,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32637, 45.44184]] },
    },
    {
      type: "Feature",
      properties: {
        id: 505177,
        name: "San Marco Terrace",
        host_id: 2490984,
        host_name: "Dominique",
        latitude: 45.43455,
        longitude: 12.34151,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34151, 45.43455]] },
    },
    {
      type: "Feature",
      properties: {
        id: 509641,
        name: "Large apartment in Jewish Ghetto with 3 bedrooms",
        host_id: 2508340,
        host_name: "Giacomo",
        latitude: 45.44554,
        longitude: 12.32599,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32599, 45.44554]] },
    },
    {
      type: "Feature",
      properties: {
        id: 511064,
        name: "Cozy apartment for 4 in Jewish Ghetto A/C & WIFI",
        host_id: 2508340,
        host_name: "Giacomo",
        latitude: 45.44586,
        longitude: 12.32605,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32605, 45.44586]] },
    },
    {
      type: "Feature",
      properties: {
        id: 522028,
        name: "Private room - super friendly flat",
        host_id: 2306935,
        host_name: "Jacopo",
        latitude: 45.43336,
        longitude: 12.3265,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3265, 45.43336]] },
    },
    {
      type: "Feature",
      properties: {
        id: 525119,
        name: "2 Bedrooms Apartment close to S.Marcuola, WI-FI",
        host_id: 2508340,
        host_name: "Giacomo",
        latitude: 45.44459,
        longitude: 12.32866,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32866, 45.44459]] },
    },
    {
      type: "Feature",
      properties: {
        id: 531274,
        name: "Feel like (Website hidden by Airbnb) Cannaregio",
        host_id: 2604353,
        host_name: "Marina",
        latitude: 45.44182,
        longitude: 12.33698,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33698, 45.44182]] },
    },
    {
      type: "Feature",
      properties: {
        id: 531863,
        name: "Venice - Apartment Gugghenheim",
        host_id: 2613819,
        host_name: "Fabio",
        latitude: 45.42967,
        longitude: 12.3319,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3319, 45.42967]] },
    },
    {
      type: "Feature",
      properties: {
        id: 534348,
        name: "Single Room",
        host_id: 571311,
        host_name: "Debora",
        latitude: 45.44009,
        longitude: 12.33717,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33717, 45.44009]] },
    },
    {
      type: "Feature",
      properties: {
        id: 534360,
        name: "Double Economy Room WITHOUT View",
        host_id: 571311,
        host_name: "Debora",
        latitude: 45.43996,
        longitude: 12.33594,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33594, 45.43996]] },
    },
    {
      type: "Feature",
      properties: {
        id: 534364,
        name: "Double Room Little Canal View",
        host_id: 571311,
        host_name: "Debora",
        latitude: 45.43914,
        longitude: 12.33677,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33677, 45.43914]] },
    },
    {
      type: "Feature",
      properties: {
        id: 534374,
        name: "Double Room overlook Canal Grande",
        host_id: 571311,
        host_name: "Debora",
        latitude: 45.43881,
        longitude: 12.33671,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33671, 45.43881]] },
    },
    {
      type: "Feature",
      properties: {
        id: 534382,
        name: "Triple Room Little Canal View",
        host_id: 571311,
        host_name: "Debora",
        latitude: 45.43874,
        longitude: 12.33765,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33765, 45.43874]] },
    },
    {
      type: "Feature",
      properties: {
        id: 534387,
        name: "Quadruple Room Little Canal View",
        host_id: 571311,
        host_name: "Debora",
        latitude: 45.43995,
        longitude: 12.33716,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33716, 45.43995]] },
    },
    {
      type: "Feature",
      properties: {
        id: 536332,
        name: "Apartment Arsenale - Venice Historical Centre",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.43377,
        longitude: 12.35001,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35001, 45.43377]] },
    },
    {
      type: "Feature",
      properties: {
        id: 540832,
        name: "Amazing view on the canal",
        host_id: 2658606,
        host_name: "Luca",
        latitude: 45.4388,
        longitude: 12.32575,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32575, 45.4388]] },
    },
    {
      type: "Feature",
      properties: {
        id: 544361,
        name: 'Summer Offer - "Life in Venice" w/ Private Garden',
        host_id: 2196999,
        host_name: "Barbara",
        latitude: 45.43224,
        longitude: 12.31584,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31584, 45.43224]] },
    },
    {
      type: "Feature",
      properties: {
        id: 544834,
        name: "Le Tango - in the heart of Venice",
        host_id: 2679233,
        host_name: "Caterina",
        latitude: 45.43591,
        longitude: 12.33168,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33168, 45.43591]] },
    },
    {
      type: "Feature",
      properties: {
        id: 556190,
        name: "Romantic Venice - Ca 'Ruzante -",
        host_id: 2735232,
        host_name: "Remigio",
        latitude: 45.43246,
        longitude: 12.35514,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35514, 45.43246]] },
    },
    {
      type: "Feature",
      properties: {
        id: 556657,
        name: "Cà del Pozzo - 5 mn from S.Marco sq",
        host_id: 2737238,
        host_name: "Annalisa E Emma",
        latitude: 45.43322,
        longitude: 12.33295,
        beds: 12,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33295, 45.43322]] },
    },
    {
      type: "Feature",
      properties: {
        id: 563510,
        name: "Apartment Altana, Amazing Grand Canal View",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.44067,
        longitude: 12.32308,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32308, 45.44067]] },
    },
    {
      type: "Feature",
      properties: {
        id: 567154,
        name: "Bright&comfy flat in Venice",
        host_id: 2790016,
        host_name: "Jyoti  Ch",
        latitude: 45.42644,
        longitude: 12.32425,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32425, 45.42644]] },
    },
    {
      type: "Feature",
      properties: {
        id: 574922,
        name: "Romantic Getaway Moments from the Rialto Bridge",
        host_id: 2635450,
        host_name: "Paola",
        latitude: 45.43911,
        longitude: 12.33248,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33248, 45.43911]] },
    },
    {
      type: "Feature",
      properties: {
        id: 583792,
        name: "ROMANTIC APARTMENT IN VENICE",
        host_id: 2602970,
        host_name: "Elena",
        latitude: 45.43218,
        longitude: 12.31739,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31739, 45.43218]] },
    },
    {
      type: "Feature",
      properties: {
        id: 584522,
        name: "Il cielo sopra Venezia",
        host_id: 2880230,
        host_name: "Andrea",
        latitude: 45.43224,
        longitude: 12.329,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.329, 45.43224]] },
    },
    {
      type: "Feature",
      properties: {
        id: 601350,
        name: "dimora tipica veneziana",
        host_id: 2975628,
        host_name: "Geraldine",
        latitude: 45.43747,
        longitude: 12.32925,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32925, 45.43747]] },
    },
    {
      type: "Feature",
      properties: {
        id: 603168,
        name: "Le Guglie LT in Venice",
        host_id: 2985972,
        host_name: "Paolo",
        latitude: 45.44404,
        longitude: 12.32537,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32537, 45.44404]] },
    },
    {
      type: "Feature",
      properties: {
        id: 617429,
        name: "Romantic B&B in Venice San Marco",
        host_id: 3060084,
        host_name: "Giacomo",
        latitude: 45.43456,
        longitude: 12.32992,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32992, 45.43456]] },
    },
    {
      type: "Feature",
      properties: {
        id: 618422,
        name: "Rialto Mercato with Canal Grande view",
        host_id: 3063776,
        host_name: "Maurizio",
        latitude: 45.43813,
        longitude: 12.33474,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33474, 45.43813]] },
    },
    {
      type: "Feature",
      properties: {
        id: 620968,
        name: "FEW STEPS FROM SAN MARCO- WISTERIA CANAL VIEW",
        host_id: 1813795,
        host_name: "Maura",
        latitude: 45.43714,
        longitude: 12.34183,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34183, 45.43714]] },
    },
    {
      type: "Feature",
      properties: {
        id: 623236,
        name: "Central dble bedrm ensuite bathrm",
        host_id: 1104205,
        host_name: "Lola",
        latitude: 45.43314,
        longitude: 12.3285,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3285, 45.43314]] },
    },
    {
      type: "Feature",
      properties: {
        id: 630388,
        name: "Carnival Venice Apartment in Venice center",
        host_id: 381172,
        host_name: "Marco",
        latitude: 45.43775,
        longitude: 12.34665,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34665, 45.43775]] },
    },
    {
      type: "Feature",
      properties: {
        id: 632128,
        name: "Comfortable, Cosy and Practical Studio",
        host_id: 3144850,
        host_name: "Laura",
        latitude: 45.43948,
        longitude: 12.32539,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32539, 45.43948]] },
    },
    {
      type: "Feature",
      properties: {
        id: 634707,
        name: "CA' Venezia",
        host_id: 606597,
        host_name: "Cristina",
        latitude: 45.429,
        longitude: 12.35663,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35663, 45.429]] },
    },
    {
      type: "Feature",
      properties: {
        id: 636637,
        name: "Ca' Augusta: Luxurius Family Home since 1800",
        host_id: 3174141,
        host_name: "Cristina",
        latitude: 45.43949,
        longitude: 12.33978,
        beds: 11,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33978, 45.43949]] },
    },
    {
      type: "Feature",
      properties: {
        id: 641360,
        name: "Very nice flat near Rialto Bridge",
        host_id: 3204162,
        host_name: "Andrea E Alessandra",
        latitude: 45.43903,
        longitude: 12.33519,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33519, 45.43903]] },
    },
    {
      type: "Feature",
      properties: {
        id: 644245,
        name: "Ca' Matilda",
        host_id: 3215960,
        host_name: "Manuel",
        latitude: 45.4403,
        longitude: 12.32324,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32324, 45.4403]] },
    },
    {
      type: "Feature",
      properties: {
        id: 648497,
        name: "RENOVATED APARTMENT FEW STEPS FROM RIALTO BRIDGE!",
        host_id: 3215031,
        host_name: "Cristina",
        latitude: 45.437,
        longitude: 12.3316,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3316, 45.437]] },
    },
    {
      type: "Feature",
      properties: {
        id: 649092,
        name: "Authentic Venetian Palace center",
        host_id: 2399510,
        host_name: "Marina",
        latitude: 45.44058,
        longitude: 12.33884,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33884, 45.44058]] },
    },
    {
      type: "Feature",
      properties: {
        id: 650767,
        name: "VENICE PIAZZA SAN MARCO",
        host_id: 3268637,
        host_name: "Massimo",
        latitude: 45.43476,
        longitude: 12.3409,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3409, 45.43476]] },
    },
    {
      type: "Feature",
      properties: {
        id: 652116,
        name: "Very central apartment in Venice",
        host_id: 3296218,
        host_name: "Vicri",
        latitude: 45.43731,
        longitude: 12.32733,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32733, 45.43731]] },
    },
    {
      type: "Feature",
      properties: {
        id: 652874,
        name: "Ca'Donzela near Rialto with Wi-Fi",
        host_id: 3281444,
        host_name: "Attilio & Arelis",
        latitude: 45.43854,
        longitude: 12.33329,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33329, 45.43854]] },
    },
    {
      type: "Feature",
      properties: {
        id: 672422,
        name: "REGINA ELENA  apartment with Jacuzzi in VENICE",
        host_id: 3343123,
        host_name: "Luciana",
        latitude: 45.44326,
        longitude: 12.32747,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32747, 45.44326]] },
    },
    {
      type: "Feature",
      properties: {
        id: 673910,
        name: "ENJOY THE VENICE'S CENTRE        .",
        host_id: 3437195,
        host_name: "Valentina",
        latitude: 45.44275,
        longitude: 12.32963,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32963, 45.44275]] },
    },
    {
      type: "Feature",
      properties: {
        id: 676323,
        name: "OTTIMA CAMERA VENEZIA CENTRO",
        host_id: 3437195,
        host_name: "Valentina",
        latitude: 45.44364,
        longitude: 12.33075,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33075, 45.44364]] },
    },
    {
      type: "Feature",
      properties: {
        id: 683030,
        name: "Ca'Elena Apartment for Holidays",
        host_id: 3458662,
        host_name: "Michele",
        latitude: 45.44236,
        longitude: 12.34116,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34116, 45.44236]] },
    },
    {
      type: "Feature",
      properties: {
        id: 686076,
        name: "Cannaregio, la vita della città! 1°",
        host_id: 3499666,
        host_name: "Alessandro",
        latitude: 45.44248,
        longitude: 12.32455,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32455, 45.44248]] },
    },
    {
      type: "Feature",
      properties: {
        id: 686102,
        name: "Campo S.Geremia e Lucia - Labia - 2",
        host_id: 3499666,
        host_name: "Alessandro",
        latitude: 45.44312,
        longitude: 12.3239,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3239, 45.44312]] },
    },
    {
      type: "Feature",
      properties: {
        id: 689490,
        name: "Ca' dei Zoti 1 - san Marco with luggage room",
        host_id: 2825961,
        host_name: "Maria Beatrice",
        latitude: 45.43327,
        longitude: 12.3282,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3282, 45.43327]] },
    },
    {
      type: "Feature",
      properties: {
        id: 690288,
        name: "1BR Apartment in Canareggio, Venice",
        host_id: 3526444,
        host_name: "Luca",
        latitude: 45.44495,
        longitude: 12.3232,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3232, 45.44495]] },
    },
    {
      type: "Feature",
      properties: {
        id: 693812,
        name: "Venetian Mood: SECRET GARDEN",
        host_id: 3549494,
        host_name: "Manuela",
        latitude: 45.4249,
        longitude: 12.33763,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33763, 45.4249]] },
    },
    {
      type: "Feature",
      properties: {
        id: 694828,
        name: "Ca' Duse pretty garden in Venice",
        host_id: 3556311,
        host_name: "Andrea",
        latitude: 45.43998,
        longitude: 12.34069,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34069, 45.43998]] },
    },
    {
      type: "Feature",
      properties: {
        id: 702745,
        name: "FEW STEPS FROM SAN MARCO-RED HEART OF VENICE",
        host_id: 1813795,
        host_name: "Maura",
        latitude: 45.43649,
        longitude: 12.34,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34, 45.43649]] },
    },
    {
      type: "Feature",
      properties: {
        id: 707115,
        name: "CA' DELL'ANGELO with rooftop view",
        host_id: 1438903,
        host_name: "Barbara",
        latitude: 45.43448,
        longitude: 12.33459,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33459, 45.43448]] },
    },
    {
      type: "Feature",
      properties: {
        id: 707434,
        name: "Welcome to The Venice Apartment!",
        host_id: 3206872,
        host_name: "Luciano",
        latitude: 45.43476,
        longitude: 12.32412,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32412, 45.43476]] },
    },
    {
      type: "Feature",
      properties: {
        id: 713783,
        name: "Flat Penelope 5 min walk to Rialto",
        host_id: 3674980,
        host_name: "Matteo E Luisa",
        latitude: 45.44097,
        longitude: 12.33977,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33977, 45.44097]] },
    },
    {
      type: "Feature",
      properties: {
        id: 713788,
        name: "Studio Canal...a charming place",
        host_id: 3674980,
        host_name: "Matteo E Luisa",
        latitude: 45.44006,
        longitude: 12.33847,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33847, 45.44006]] },
    },
    {
      type: "Feature",
      properties: {
        id: 714456,
        name: "A lovely apartment  in Venice",
        host_id: 3679500,
        host_name: "Adriana",
        latitude: 45.43792,
        longitude: 12.34735,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34735, 45.43792]] },
    },
    {
      type: "Feature",
      properties: {
        id: 719981,
        name: "Gothic Palace on canal no stair from station quiet",
        host_id: 3715828,
        host_name: "Fulvia",
        latitude: 45.44529,
        longitude: 12.31951,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31951, 45.44529]] },
    },
    {
      type: "Feature",
      properties: {
        id: 721517,
        name: "Lovisella 1BR-Apt- steps from St. Mark's Square",
        host_id: 510349,
        host_name: "Roberta",
        latitude: 45.4333,
        longitude: 12.33533,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33533, 45.4333]] },
    },
    {
      type: "Feature",
      properties: {
        id: 723218,
        name: "Colleoni Holidays - near Rialto Bridge, modern apt",
        host_id: 289615,
        host_name: "Valentina",
        latitude: 45.44034,
        longitude: 12.34011,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34011, 45.44034]] },
    },
    {
      type: "Feature",
      properties: {
        id: 724156,
        name: "CA' BECCARIE 2 - RIALTO & FREE WI-FI",
        host_id: 289615,
        host_name: "Valentina",
        latitude: 45.43967,
        longitude: 12.33353,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33353, 45.43967]] },
    },
    {
      type: "Feature",
      properties: {
        id: 724334,
        name: "CA' BECCARIE 1: RIALTO & FREE WIFI",
        host_id: 289615,
        host_name: "Valentina",
        latitude: 45.43978,
        longitude: 12.33425,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33425, 45.43978]] },
    },
    {
      type: "Feature",
      properties: {
        id: 741425,
        name: "PLEASANT AND IN WONDERFUL LOCATION!",
        host_id: 3880254,
        host_name: "Sabina",
        latitude: 45.43589,
        longitude: 12.32334,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32334, 45.43589]] },
    },
    {
      type: "Feature",
      properties: {
        id: 747693,
        name: "Casa della Sposa - Cà dei Celsi",
        host_id: 3925845,
        host_name: "Pier Giorgio E Paolo",
        latitude: 45.43755,
        longitude: 12.35033,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35033, 45.43755]] },
    },
    {
      type: "Feature",
      properties: {
        id: 747818,
        name: "House Rialto Venice",
        host_id: 3926719,
        host_name: "Cara",
        latitude: 45.44104,
        longitude: 12.33189,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33189, 45.44104]] },
    },
    {
      type: "Feature",
      properties: {
        id: 752918,
        name: "SAN GIACOMO 3 sunny with canal view",
        host_id: 1438903,
        host_name: "Barbara",
        latitude: 45.43909,
        longitude: 12.32718,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32718, 45.43909]] },
    },
    {
      type: "Feature",
      properties: {
        id: 753235,
        name: "SAN LORENZO TERRACE central with sunny terrace",
        host_id: 1438903,
        host_name: "Barbara",
        latitude: 45.43826,
        longitude: 12.34389,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34389, 45.43826]] },
    },
    {
      type: "Feature",
      properties: {
        id: 753936,
        name: "VENICE HEAVEN APARTMENTS- CA GIULIA WITH TERRACE",
        host_id: 1554828,
        host_name: "Veronica",
        latitude: 45.43429,
        longitude: 12.34139,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34139, 45.43429]] },
    },
    {
      type: "Feature",
      properties: {
        id: 754792,
        name: "Ca' degli Scalzi",
        host_id: 3215960,
        host_name: "Manuel",
        latitude: 45.44239,
        longitude: 12.32138,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32138, 45.44239]] },
    },
    {
      type: "Feature",
      properties: {
        id: 755201,
        name: "Lando's Holiday Home love nest",
        host_id: 3970595,
        host_name: "Michela",
        latitude: 45.43733,
        longitude: 12.33273,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33273, 45.43733]] },
    },
    {
      type: "Feature",
      properties: {
        id: 757455,
        name: "B&B Ca Corona Standard,  bagno privato  esterno.",
        host_id: 3909922,
        host_name: "Stefano & Laura",
        latitude: 45.43611,
        longitude: 12.34174,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34174, 45.43611]] },
    },
    {
      type: "Feature",
      properties: {
        id: 762335,
        name: "3 Min.Walk from St.Mark's Square C3",
        host_id: 4018771,
        host_name: "Francesco And Nina",
        latitude: 45.43723,
        longitude: 12.33925,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33925, 45.43723]] },
    },
    {
      type: "Feature",
      properties: {
        id: 767581,
        name: "3 Min.Walk from St.Mark's Square C2",
        host_id: 4018771,
        host_name: "Francesco And Nina",
        latitude: 45.43691,
        longitude: 12.34048,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34048, 45.43691]] },
    },
    {
      type: "Feature",
      properties: {
        id: 769007,
        name: "3 Min.Walk from St.Mark's Square C1",
        host_id: 4018771,
        host_name: "Francesco And Nina",
        latitude: 45.4368,
        longitude: 12.34022,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34022, 45.4368]] },
    },
    {
      type: "Feature",
      properties: {
        id: 769436,
        name: "CanAlvise, to discover or rediscover Venice",
        host_id: 3223223,
        host_name: "Chiara E Paolo",
        latitude: 45.44891,
        longitude: 12.32705,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32705, 45.44891]] },
    },
    {
      type: "Feature",
      properties: {
        id: 769492,
        name: "Quiet elegant and warm apartment in Venice",
        host_id: 2100864,
        host_name: "Fabiola",
        latitude: 45.43759,
        longitude: 12.3413,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3413, 45.43759]] },
    },
    {
      type: "Feature",
      properties: {
        id: 770392,
        name: "Cozy quiet Apt, City Center, WiFi!",
        host_id: 4064191,
        host_name: "Cecilia",
        latitude: 45.43499,
        longitude: 12.33246,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33246, 45.43499]] },
    },
    {
      type: "Feature",
      properties: {
        id: 772215,
        name: "LA CASA DI GEMMA",
        host_id: 745553,
        host_name: "Rosanna E Francesca",
        latitude: 45.44063,
        longitude: 12.32713,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32713, 45.44063]] },
    },
    {
      type: "Feature",
      properties: {
        id: 776996,
        name: "Enchanted Pearl Room center Venice",
        host_id: 4097735,
        host_name: "Roberto",
        latitude: 45.42748,
        longitude: 12.36158,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.36158, 45.42748]] },
    },
    {
      type: "Feature",
      properties: {
        id: 783211,
        name: "Dreamlike Garden room center Venice",
        host_id: 4097735,
        host_name: "Roberto",
        latitude: 45.42769,
        longitude: 12.36154,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.36154, 45.42769]] },
    },
    {
      type: "Feature",
      properties: {
        id: 783814,
        name: "Charming view Ca Dolce channel WIFI",
        host_id: 283131,
        host_name: "Anunxiata",
        latitude: 45.44123,
        longitude: 12.33616,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33616, 45.44123]] },
    },
    {
      type: "Feature",
      properties: {
        id: 784525,
        name: "Shiny apt at the heart of Venice",
        host_id: 4136657,
        host_name: "Stefano",
        latitude: 45.43867,
        longitude: 12.33586,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33586, 45.43867]] },
    },
    {
      type: "Feature",
      properties: {
        id: 784879,
        name: "Roof Terrace in the Ghetto",
        host_id: 2255199,
        host_name: "Francesca",
        latitude: 45.44666,
        longitude: 12.32577,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32577, 45.44666]] },
    },
    {
      type: "Feature",
      properties: {
        id: 785173,
        name: "Double bedroom in simple hotel",
        host_id: 2508340,
        host_name: "Giacomo",
        latitude: 45.44034,
        longitude: 12.32322,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32322, 45.44034]] },
    },
    {
      type: "Feature",
      properties: {
        id: 793697,
        name: "Cozy flat in the heart of Venice",
        host_id: 4181403,
        host_name: "Sara",
        latitude: 45.44445,
        longitude: 12.32835,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32835, 45.44445]] },
    },
    {
      type: "Feature",
      properties: {
        id: 798826,
        name: "Querini San Marco B&B - Studio 4",
        host_id: 4120295,
        host_name: "Michela",
        latitude: 45.43626,
        longitude: 12.34788,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34788, 45.43626]] },
    },
    {
      type: "Feature",
      properties: {
        id: 798846,
        name: "Querini San Marco B&B - Studio 5",
        host_id: 4120295,
        host_name: "Michela",
        latitude: 45.43573,
        longitude: 12.34687,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34687, 45.43573]] },
    },
    {
      type: "Feature",
      properties: {
        id: 798869,
        name: "Querini San Marco B&B - Studio 6",
        host_id: 4120295,
        host_name: "Michela",
        latitude: 45.43633,
        longitude: 12.34785,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34785, 45.43633]] },
    },
    {
      type: "Feature",
      properties: {
        id: 806862,
        name:
          "Mansarda con incantevole affaccio sul Canal Grande e sul Mercato di Rialto",
        host_id: 4217637,
        host_name: "Michela",
        latitude: 45.43918,
        longitude: 12.33325,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33325, 45.43918]] },
    },
    {
      type: "Feature",
      properties: {
        id: 807633,
        name: "VENICE, LOVELY APARTMENT DESIGN",
        host_id: 4249732,
        host_name: "Giorgio&Ida",
        latitude: 45.44057,
        longitude: 12.33147,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33147, 45.44057]] },
    },
    {
      type: "Feature",
      properties: {
        id: 809281,
        name: "Classic Venetian House 6 person",
        host_id: 4258092,
        host_name: "Sebastiano",
        latitude: 45.43628,
        longitude: 12.34701,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34701, 45.43628]] },
    },
    {
      type: "Feature",
      properties: {
        id: 816197,
        name: "Ai Tre Scalini",
        host_id: 4287661,
        host_name: "Francesca",
        latitude: 45.44716,
        longitude: 12.31939,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31939, 45.44716]] },
    },
    {
      type: "Feature",
      properties: {
        id: 819328,
        name: "San Marco's Nest",
        host_id: 4302881,
        host_name: "Elisa",
        latitude: 45.43791,
        longitude: 12.34188,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34188, 45.43791]] },
    },
    {
      type: "Feature",
      properties: {
        id: 830598,
        name: "The real Venice at Ca' Marietta",
        host_id: 4350749,
        host_name: "Roberto",
        latitude: 45.4455,
        longitude: 12.33069,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33069, 45.4455]] },
    },
    {
      type: "Feature",
      properties: {
        id: 831560,
        name:
          "Venezia Attico con Magica Terrazza M (Phone number hidden by Airbnb)",
        host_id: 1974309,
        host_name: "Anna",
        latitude: 45.43951,
        longitude: 12.32859,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32859, 45.43951]] },
    },
    {
      type: "Feature",
      properties: {
        id: 840779,
        name: "Center of Venice, near Biennale",
        host_id: 4390954,
        host_name: "Carlo",
        latitude: 45.43041,
        longitude: 12.3552,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3552, 45.43041]] },
    },
    {
      type: "Feature",
      properties: {
        id: 855214,
        name: "Arsenal, An attic like a ship on th",
        host_id: 3290752,
        host_name: "Licia",
        latitude: 45.43595,
        longitude: 12.34783,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34783, 45.43595]] },
    },
    {
      type: "Feature",
      properties: {
        id: 861429,
        name:
          "Nice and confortable room in Venice M (Phone number hidden by Airbnb)",
        host_id: 4512765,
        host_name: "Claudia",
        latitude: 45.43805,
        longitude: 12.32195,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32195, 45.43805]] },
    },
    {
      type: "Feature",
      properties: {
        id: 861952,
        name: "B&B Ca Corona Suite, near San Marco and Biennale.",
        host_id: 3909922,
        host_name: "Stefano & Laura",
        latitude: 45.4353,
        longitude: 12.34105,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34105, 45.4353]] },
    },
    {
      type: "Feature",
      properties: {
        id: 864638,
        name: "like venetians overlooking a canal",
        host_id: 4537737,
        host_name: "Tiziana",
        latitude: 45.43127,
        longitude: 12.35222,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35222, 45.43127]] },
    },
    {
      type: "Feature",
      properties: {
        id: 867034,
        name: "Venezia - Ghetto Vecchio",
        host_id: 4557370,
        host_name: "Giovanna",
        latitude: 45.44633,
        longitude: 12.32668,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32668, 45.44633]] },
    },
    {
      type: "Feature",
      properties: {
        id: 871494,
        name: "Venezian paradise",
        host_id: 2602970,
        host_name: "Elena",
        latitude: 45.43967,
        longitude: 12.33755,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33755, 45.43967]] },
    },
    {
      type: "Feature",
      properties: {
        id: 880052,
        name: "Maddalena",
        host_id: 4654141,
        host_name: "Giovanna",
        latitude: 45.44569,
        longitude: 12.32073,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32073, 45.44569]] },
    },
    {
      type: "Feature",
      properties: {
        id: 884350,
        name: "La Coccola apartment holiday Venice",
        host_id: 4684434,
        host_name: "Gabriella",
        latitude: 45.44272,
        longitude: 12.33537,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33537, 45.44272]] },
    },
    {
      type: "Feature",
      properties: {
        id: 890209,
        name: "Great Flat for 4 in central Venice!",
        host_id: 1040556,
        host_name: "Monica",
        latitude: 45.44273,
        longitude: 12.32488,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32488, 45.44273]] },
    },
    {
      type: "Feature",
      properties: {
        id: 895621,
        name: "Charming b&b in Venice",
        host_id: 4772693,
        host_name: "Paola",
        latitude: 45.43719,
        longitude: 12.34656,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34656, 45.43719]] },
    },
    {
      type: "Feature",
      properties: {
        id: 895952,
        name: "Casa Furlani with Garden",
        host_id: 632312,
        host_name: "Guillaume",
        latitude: 45.43498,
        longitude: 12.3472,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3472, 45.43498]] },
    },
    {
      type: "Feature",
      properties: {
        id: 897109,
        name: "TRUE VENICE APARTMENT in the most genuine district",
        host_id: 567508,
        host_name: "Nicola",
        latitude: 45.44568,
        longitude: 12.33007,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33007, 45.44568]] },
    },
    {
      type: "Feature",
      properties: {
        id: 899373,
        name: "Ca' Vecchio Pozzo casa di charme",
        host_id: 4801510,
        host_name: "Carlo",
        latitude: 45.43518,
        longitude: 12.33796,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33796, 45.43518]] },
    },
    {
      type: "Feature",
      properties: {
        id: 906370,
        name: "A COZY PLACE IN THE HEART OF VENICE",
        host_id: 4851546,
        host_name: "Francesca",
        latitude: 45.44667,
        longitude: 12.33144,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33144, 45.44667]] },
    },
    {
      type: "Feature",
      properties: {
        id: 906617,
        name: "La colonna gotica M (Phone number hidden by Airbnb)",
        host_id: 4853287,
        host_name: "Maurizia",
        latitude: 45.4315,
        longitude: 12.32034,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32034, 45.4315]] },
    },
    {
      type: "Feature",
      properties: {
        id: 907405,
        name: "Lovely apt in XVII century Palazzo",
        host_id: 4189569,
        host_name: "Gilda",
        latitude: 45.44146,
        longitude: 12.34174,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34174, 45.44146]] },
    },
    {
      type: "Feature",
      properties: {
        id: 909547,
        name: "Alle Guglie B&B. Cozy and elegant B&B",
        host_id: 4877513,
        host_name: "Antonio",
        latitude: 45.44499,
        longitude: 12.32483,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32483, 45.44499]] },
    },
    {
      type: "Feature",
      properties: {
        id: 909754,
        name: "Your home in Venice - 2 bedrooms 2 bathrooms",
        host_id: 4879104,
        host_name: "Giovanni",
        latitude: 45.43759,
        longitude: 12.34788,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34788, 45.43759]] },
    },
    {
      type: "Feature",
      properties: {
        id: 911981,
        name: "Live in Venice like a Venetian!",
        host_id: 4893459,
        host_name: "Roberta",
        latitude: 45.43721,
        longitude: 12.34779,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34779, 45.43721]] },
    },
    {
      type: "Feature",
      properties: {
        id: 916283,
        name: "Ca' Paradiso apartment -RIALTO",
        host_id: 4918762,
        host_name: "Riccardo",
        latitude: 45.43654,
        longitude: 12.33883,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33883, 45.43654]] },
    },
    {
      type: "Feature",
      properties: {
        id: 926604,
        name: "a garden on the water",
        host_id: 4986069,
        host_name: "Andrea",
        latitude: 45.44255,
        longitude: 12.33646,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33646, 45.44255]] },
    },
    {
      type: "Feature",
      properties: {
        id: 932119,
        name: "Apt Guggenheim: Breathtaking view on Grand Canal",
        host_id: 5022636,
        host_name: "Monica",
        latitude: 45.42964,
        longitude: 12.33196,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33196, 45.42964]] },
    },
    {
      type: "Feature",
      properties: {
        id: 941891,
        name: "Fabulous view over the Guglie bridge",
        host_id: 5093197,
        host_name: "Roberto",
        latitude: 45.4429,
        longitude: 12.32653,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32653, 45.4429]] },
    },
    {
      type: "Feature",
      properties: {
        id: 945052,
        name: "ca' di paolo",
        host_id: 123920,
        host_name: "Giorgio",
        latitude: 45.43204,
        longitude: 12.35481,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35481, 45.43204]] },
    },
    {
      type: "Feature",
      properties: {
        id: 948522,
        name: "Big bright room in the heart of Venice. Super view",
        host_id: 5113473,
        host_name: "Sara E Giovanni",
        latitude: 45.43696,
        longitude: 12.33781,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33781, 45.43696]] },
    },
    {
      type: "Feature",
      properties: {
        id: 949215,
        name: "Biennale of Arts, Luxury & Style",
        host_id: 5146501,
        host_name: "Stefano",
        latitude: 45.43172,
        longitude: 12.35507,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35507, 45.43172]] },
    },
    {
      type: "Feature",
      properties: {
        id: 953458,
        name: "Cà Giustina - beautiful canal view",
        host_id: 5176326,
        host_name: "Andrea",
        latitude: 45.43813,
        longitude: 12.34682,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34682, 45.43813]] },
    },
    {
      type: "Feature",
      properties: {
        id: 954068,
        name: "ca' vittoria",
        host_id: 123920,
        host_name: "Giorgio",
        latitude: 45.44723,
        longitude: 12.3279,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3279, 45.44723]] },
    },
    {
      type: "Feature",
      properties: {
        id: 962131,
        name: "Charming apartment in San Marco",
        host_id: 5240699,
        host_name: "Serena",
        latitude: 45.43489,
        longitude: 12.33781,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33781, 45.43489]] },
    },
    {
      type: "Feature",
      properties: {
        id: 963154,
        name: "Delightful apartment in San Marco",
        host_id: 5240699,
        host_name: "Serena",
        latitude: 45.4349,
        longitude: 12.33797,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33797, 45.4349]] },
    },
    {
      type: "Feature",
      properties: {
        id: 964344,
        name: 'room on the water "PERLA BIANCA"',
        host_id: 5256801,
        host_name: "Giusy",
        latitude: 45.445,
        longitude: 12.328,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.328, 45.445]] },
    },
    {
      type: "Feature",
      properties: {
        id: 970111,
        name: "Agli Artisti - Biennale -",
        host_id: 308647,
        host_name: "Federica",
        latitude: 45.43027,
        longitude: 12.35841,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35841, 45.43027]] },
    },
    {
      type: "Feature",
      properties: {
        id: 970116,
        name: '"Tiepolo Room"',
        host_id: 308647,
        host_name: "Federica",
        latitude: 45.43137,
        longitude: 12.35523,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35523, 45.43137]] },
    },
    {
      type: "Feature",
      properties: {
        id: 970938,
        name: "Atelier 5_cozy art double room",
        host_id: 5304725,
        host_name: "Masha & Claudio",
        latitude: 45.44648,
        longitude: 12.3227,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3227, 45.44648]] },
    },
    {
      type: "Feature",
      properties: {
        id: 972849,
        name: "New flat in Strada Nuova",
        host_id: 369617,
        host_name: "Irene",
        latitude: 45.44338,
        longitude: 12.32657,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32657, 45.44338]] },
    },
    {
      type: "Feature",
      properties: {
        id: 973340,
        name: "Atelier 5_cozy art single room",
        host_id: 5304725,
        host_name: "Masha & Claudio",
        latitude: 45.44676,
        longitude: 12.32163,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32163, 45.44676]] },
    },
    {
      type: "Feature",
      properties: {
        id: 975073,
        name: "Live Venice as a real Venetian",
        host_id: 5332703,
        host_name: "Giovanna",
        latitude: 45.44041,
        longitude: 12.3367,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3367, 45.44041]] },
    },
    {
      type: "Feature",
      properties: {
        id: 977590,
        name: "Central wide room with amazing view",
        host_id: 567508,
        host_name: "Nicola",
        latitude: 45.43704,
        longitude: 12.33839,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33839, 45.43704]] },
    },
    {
      type: "Feature",
      properties: {
        id: 979476,
        name: "2 bedrooms flat in Venice, Italy",
        host_id: 5361310,
        host_name: "Patrizia",
        latitude: 45.44638,
        longitude: 12.31929,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31929, 45.44638]] },
    },
    {
      type: "Feature",
      properties: {
        id: 983967,
        name: "PRIVATE TERRACE ON CANAL VIEW",
        host_id: 5395291,
        host_name: "Beatrice",
        latitude: 45.44442,
        longitude: 12.32937,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32937, 45.44442]] },
    },
    {
      type: "Feature",
      properties: {
        id: 985304,
        name: "Venezia-Palazzo della Sensa",
        host_id: 5405444,
        host_name: "Flavia",
        latitude: 45.44553,
        longitude: 12.32902,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32902, 45.44553]] },
    },
    {
      type: "Feature",
      properties: {
        id: 988502,
        name: "In the heart of Venice - Rialto",
        host_id: 5426455,
        host_name: "Cristiana",
        latitude: 45.43874,
        longitude: 12.33273,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33273, 45.43874]] },
    },
    {
      type: "Feature",
      properties: {
        id: 990809,
        name: "CA'FILCAMO",
        host_id: 1897360,
        host_name: "Davide",
        latitude: 45.43636,
        longitude: 12.34538,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34538, 45.43636]] },
    },
    {
      type: "Feature",
      properties: {
        id: 994201,
        name: "San Vio - Ancient Dwelling",
        host_id: 5377000,
        host_name: "Joan",
        latitude: 45.43085,
        longitude: 12.32907,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32907, 45.43085]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1000262,
        name: "Malcanton del Gaffaro apartment",
        host_id: 5515810,
        host_name: "Mario",
        latitude: 45.4361,
        longitude: 12.32207,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32207, 45.4361]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1002792,
        name: "Blue apartment venetian de Luxe",
        host_id: 5514357,
        host_name: "Alvise",
        latitude: 45.4344,
        longitude: 12.33776,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33776, 45.4344]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1005533,
        name: "Palazzetto San Lio - Palazzo",
        host_id: 5530301,
        host_name: "Chiara",
        latitude: 45.43862,
        longitude: 12.33848,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33848, 45.43862]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1005660,
        name: "San Marco suite with canal view",
        host_id: 5530875,
        host_name: "Maurizio",
        latitude: 45.43406,
        longitude: 12.33492,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33492, 45.43406]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1010763,
        name:
          "Stylish condo with a small terrace and a fantastic Dorsoduro location!",
        host_id: 4339678,
        host_name: "Vacasa Italy - Venice",
        latitude: 45.43165,
        longitude: 12.32832,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32832, 45.43165]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1011701,
        name: "San Felice,flat with large terrace",
        host_id: 5565167,
        host_name: "Elisa",
        latitude: 45.4438,
        longitude: 12.33257,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33257, 45.4438]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1012804,
        name: "Rialto-Bright & Panoramic Penthouse",
        host_id: 2486103,
        host_name: "Giorgia",
        latitude: 45.44126,
        longitude: 12.32803,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32803, 45.44126]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1020909,
        name: "Palazzetto San Lio, Rialto - Abbaino TA",
        host_id: 5530301,
        host_name: "Chiara",
        latitude: 45.4372,
        longitude: 12.33975,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33975, 45.4372]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1022676,
        name:
          "Newly restored Venetian condo - convenient location, walk to everything!",
        host_id: 4339678,
        host_name: "Vacasa Italy - Venice",
        latitude: 45.43734,
        longitude: 12.34595,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34595, 45.43734]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1027906,
        name: "Calla",
        host_id: 5656401,
        host_name: "Manila",
        latitude: 45.44619,
        longitude: 12.32886,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32886, 45.44619]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1034213,
        name: "Spectacular view on San Marco",
        host_id: 5691667,
        host_name: "Davide",
        latitude: 45.43565,
        longitude: 12.34259,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34259, 45.43565]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1038620,
        name: "Il meglio di Venezia",
        host_id: 3437195,
        host_name: "Valentina",
        latitude: 45.444,
        longitude: 12.33055,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33055, 45.444]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1041640,
        name: "Cute apartment with private garden & speedy WIFI",
        host_id: 2508340,
        host_name: "Giacomo",
        latitude: 45.44693,
        longitude: 12.32733,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32733, 45.44693]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1042025,
        name: "Large apartment for 4 near Zattere, view & WIFI",
        host_id: 2508340,
        host_name: "Giacomo",
        latitude: 45.42891,
        longitude: 12.33292,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33292, 45.42891]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1045123,
        name: "Palazzetto San Lio, Rialto - Baldacchino",
        host_id: 5530301,
        host_name: "Chiara",
        latitude: 45.43786,
        longitude: 12.33954,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33954, 45.43786]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1047699,
        name: "Steps from Rialto A1",
        host_id: 12531353,
        host_name: "Centrale Apartments",
        latitude: 45.43801,
        longitude: 12.33774,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33774, 45.43801]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1049446,
        name: "Ca'Vittoria: the heart of Venice",
        host_id: 5779233,
        host_name: "Alessandra",
        latitude: 45.44815,
        longitude: 12.32487,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32487, 45.44815]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1050178,
        name: "Charming b&b II",
        host_id: 4772693,
        host_name: "Paola",
        latitude: 45.43712,
        longitude: 12.34653,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34653, 45.43712]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1054462,
        name: "San Marco Apartment with Canal View",
        host_id: 5530875,
        host_name: "Maurizio",
        latitude: 45.43293,
        longitude: 12.33368,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33368, 45.43293]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1060820,
        name: "room with a terrace and a view",
        host_id: 5514708,
        host_name: "Mattis",
        latitude: 45.43457,
        longitude: 12.34306,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34306, 45.43457]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1062412,
        name: "Gradenigo House in the center of Venice.",
        host_id: 3970595,
        host_name: "Michela",
        latitude: 45.43643,
        longitude: 12.32688,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32688, 45.43643]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1064035,
        name: "Casa Letizia",
        host_id: 5857136,
        host_name: "Mirco",
        latitude: 45.43348,
        longitude: 12.32292,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32292, 45.43348]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1065409,
        name: "MODERN APARTMENT VENICE WITH TERRACE",
        host_id: 5862083,
        host_name: "Silvia",
        latitude: 45.43448,
        longitude: 12.32959,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32959, 45.43448]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1069320,
        name: "Central, sunny & comfortable with stunning views",
        host_id: 5812809,
        host_name: "Ingeborg",
        latitude: 45.4259,
        longitude: 12.3266,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3266, 45.4259]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1073684,
        name: "MODERN APARTMENT IN VENICE GF",
        host_id: 5862083,
        host_name: "Silvia",
        latitude: 45.43303,
        longitude: 12.32981,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32981, 45.43303]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1078680,
        name: "Steps from Rialto A2",
        host_id: 12531353,
        host_name: "Centrale Apartments",
        latitude: 45.43593,
        longitude: 12.3378,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3378, 45.43593]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1085165,
        name: "RIALTO TOP TERRACE,10mt S.Mark",
        host_id: 12531353,
        host_name: "Centrale Apartments",
        latitude: 45.4358,
        longitude: 12.33617,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33617, 45.4358]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1096654,
        name: "CA' PANADA luxury accomodation",
        host_id: 6026434,
        host_name: "Antonio",
        latitude: 45.44101,
        longitude: 12.34048,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34048, 45.44101]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1098076,
        name: "Exclusive Ca' Madonna Garden Home",
        host_id: 6034449,
        host_name: "Luisa",
        latitude: 45.43469,
        longitude: 12.32652,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32652, 45.43469]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1100254,
        name: "***VENEZIA - CORTE DELLA COMARE***",
        host_id: 5732682,
        host_name: "Rocco",
        latitude: 45.43159,
        longitude: 12.32743,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32743, 45.43159]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1119040,
        name: "Incantevole Venezia",
        host_id: 6141048,
        host_name: "Paolo Dal Cin",
        latitude: 45.44105,
        longitude: 12.32666,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32666, 45.44105]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1126573,
        name: "2Modern apartment, S.Marco, 3+1",
        host_id: 6180481,
        host_name: "Stefano",
        latitude: 45.43415,
        longitude: 12.34256,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34256, 45.43415]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1131662,
        name: "Beautiful flat in Venice / 4 people",
        host_id: 5395291,
        host_name: "Beatrice",
        latitude: 45.44749,
        longitude: 12.32706,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32706, 45.44749]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1142769,
        name: "PRETTY & CUTE - CA' D'ORO APARTMENT",
        host_id: 1863344,
        host_name: "Tobia",
        latitude: 45.44225,
        longitude: 12.33329,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33329, 45.44225]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1149625,
        name: "In the heart of Venice",
        host_id: 6289583,
        host_name: "Francesco",
        latitude: 45.44644,
        longitude: 12.33055,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33055, 45.44644]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1149803,
        name: "Corallo Holiday You'll love the patio on the canal",
        host_id: 6019189,
        host_name: "Federico",
        latitude: 45.44574,
        longitude: 12.3298,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3298, 45.44574]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1152739,
        name: "Close to train station,  charming garden",
        host_id: 3602985,
        host_name: "Eva",
        latitude: 45.44238,
        longitude: 12.32265,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32265, 45.44238]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1155248,
        name: "Appartamento Sant'Anna-Biennale",
        host_id: 6330522,
        host_name: "Nicoletta",
        latitude: 45.433,
        longitude: 12.35775,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35775, 45.433]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1156672,
        name: "Perfect location - Ca' Morosini",
        host_id: 6338514,
        host_name: "Ca' Morosini",
        latitude: 45.43338,
        longitude: 12.32952,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32952, 45.43338]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1163834,
        name: "3 Min.Walk from St.Mark's Square CL",
        host_id: 4018771,
        host_name: "Francesco And Nina",
        latitude: 45.4376,
        longitude: 12.33933,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33933, 45.4376]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1165622,
        name: "Giudecca Green Apartment VENICE",
        host_id: 6384200,
        host_name: "Rachel",
        latitude: 45.42602,
        longitude: 12.32387,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32387, 45.42602]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1169013,
        name: "Cà Molin, appartamento con affaccio sul canale",
        host_id: 294951,
        host_name: "VeniceVillas Di Enzo",
        latitude: 45.44173,
        longitude: 12.33239,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33239, 45.44173]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1169889,
        name: "Venice Canal view flat / 2 bedrooms",
        host_id: 5395291,
        host_name: "Beatrice",
        latitude: 45.44589,
        longitude: 12.32834,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32834, 45.44589]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1177309,
        name: "Red Rose : Big apartment in an historical palace",
        host_id: 6019189,
        host_name: "Federico",
        latitude: 45.44107,
        longitude: 12.32731,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32731, 45.44107]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1188334,
        name: "Elegant Canal-Side Apartment Close to St Mark's Square",
        host_id: 4893459,
        host_name: "Roberta",
        latitude: 45.43374,
        longitude: 12.33498,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33498, 45.43374]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1192129,
        name: "Elegant flat in the heart of Venice",
        host_id: 6516546,
        host_name: "Francesco",
        latitude: 45.43536,
        longitude: 12.33045,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33045, 45.43536]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1196659,
        name: "Bed and breakfast Canal view Venice",
        host_id: 6538340,
        host_name: "Fabio",
        latitude: 45.43713,
        longitude: 12.34602,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34602, 45.43713]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1214432,
        name: "Wi-fi available. Loft at San Marco.",
        host_id: 6629491,
        host_name: "Nicola E Martina",
        latitude: 45.43528,
        longitude: 12.33815,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33815, 45.43528]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1215753,
        name: "Amazing flat near S.Marco Square",
        host_id: 4925803,
        host_name: "Bernardo&Laura",
        latitude: 45.43572,
        longitude: 12.33881,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33881, 45.43572]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1215932,
        name: "Quadrifoglio -  Open-space",
        host_id: 6635807,
        host_name: "Giulia",
        latitude: 45.43077,
        longitude: 12.35615,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35615, 45.43077]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1224263,
        name: "Apartment in the center of Venice",
        host_id: 6678803,
        host_name: "Marco",
        latitude: 45.43633,
        longitude: 12.32978,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32978, 45.43633]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1227298,
        name: "Cosy apartment 2 mins St. MarK's Sq",
        host_id: 1856077,
        host_name: "Alvise",
        latitude: 45.43634,
        longitude: 12.34128,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34128, 45.43634]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1230451,
        name: "CENTRAL APARTMENT WITH LOVELY VIEW",
        host_id: 6516852,
        host_name: "Luli",
        latitude: 45.44308,
        longitude: 12.33173,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33173, 45.44308]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1230898,
        name: "VENISEJETAIME MACCHIATO center",
        host_id: 6713218,
        host_name: "Hugues",
        latitude: 45.43787,
        longitude: 12.33847,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33847, 45.43787]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1231456,
        name: "Venice center Formula ESPRESSO - VENICEILOVEYOU",
        host_id: 6713218,
        host_name: "Hugues",
        latitude: 45.43732,
        longitude: 12.34022,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34022, 45.43732]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1231563,
        name: "RESIDENZA AL POZZO rooms in Venice center, terrace",
        host_id: 6716496,
        host_name: "Florence",
        latitude: 45.43735,
        longitude: 12.32907,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32907, 45.43735]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1231584,
        name: "CONTEMPORARY APARTMENT IN VENICE FF",
        host_id: 5862083,
        host_name: "Silvia",
        latitude: 45.43445,
        longitude: 12.32895,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32895, 45.43445]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1233036,
        name: "SEA & GARDEN VIEWS- Free Wifi -",
        host_id: 283131,
        host_name: "Anunxiata",
        latitude: 45.43022,
        longitude: 12.35676,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35676, 45.43022]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1234585,
        name: "In the heart of Venice - Rialto 2",
        host_id: 5426455,
        host_name: "Cristiana",
        latitude: 45.43733,
        longitude: 12.33312,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33312, 45.43733]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1234812,
        name: "Apartment in the heart of Venice",
        host_id: 3215031,
        host_name: "Cristina",
        latitude: 45.43924,
        longitude: 12.3444,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3444, 45.43924]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1238329,
        name: "B&B Venice & Venice☆Romantic Room",
        host_id: 6798407,
        host_name: "Monica",
        latitude: 45.43851,
        longitude: 12.33734,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33734, 45.43851]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1250065,
        name: "Cute and fully restored apartment",
        host_id: 6709903,
        host_name: "Irene",
        latitude: 45.4456,
        longitude: 12.32563,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32563, 45.4456]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1257881,
        name: "San Basegio ai Squeri in Dorsoduro",
        host_id: 6851473,
        host_name: "Giovanni",
        latitude: 45.43191,
        longitude: 12.31829,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31829, 45.43191]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1261110,
        name: "Rialto Apartment with elevator",
        host_id: 1490179,
        host_name: "Laura",
        latitude: 45.43864,
        longitude: 12.33515,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33515, 45.43864]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1263726,
        name: "Cosy apartment close to St mark sq",
        host_id: 1490179,
        host_name: "Laura",
        latitude: 45.43504,
        longitude: 12.33857,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33857, 45.43504]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1266716,
        name: "CASA DAVIDE perfect location wi-fi",
        host_id: 6895356,
        host_name: "Davide",
        latitude: 45.43358,
        longitude: 12.35355,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35355, 45.43358]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1269492,
        name: "Ca D'Oro Venice cannaregio centre",
        host_id: 6909631,
        host_name: "Federico",
        latitude: 45.44135,
        longitude: 12.33534,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33534, 45.44135]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1275433,
        name: "A Cà Do Pozzi Venice cannaregio",
        host_id: 6909631,
        host_name: "Federico",
        latitude: 45.44091,
        longitude: 12.33648,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33648, 45.44091]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1285495,
        name: "Near San Marco, new and bright",
        host_id: 6993991,
        host_name: "Tania",
        latitude: 45.43736,
        longitude: 12.34402,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34402, 45.43736]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1290689,
        name: "Saint's Mark Apartment Venice",
        host_id: 5862083,
        host_name: "Silvia",
        latitude: 45.43346,
        longitude: 12.33607,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33607, 45.43346]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1293404,
        name: "2 bedrooms Apartment",
        host_id: 1617572,
        host_name: "Silvia",
        latitude: 45.43264,
        longitude: 12.35375,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35375, 45.43264]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1295650,
        name: "alloggi Venezia zona Biennale VE",
        host_id: 1602219,
        host_name: "Alfonso",
        latitude: 45.42907,
        longitude: 12.35927,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35927, 45.42907]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1299880,
        name: "Coccolo: little, warm atmosphere",
        host_id: 7067258,
        host_name: "Iisa",
        latitude: 45.42518,
        longitude: 12.3227,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3227, 45.42518]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1308374,
        name: "FENICEFLAT APARTMENT IN VENICE",
        host_id: 6926884,
        host_name: "Alessandro",
        latitude: 45.43525,
        longitude: 12.32984,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32984, 45.43525]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1316277,
        name: "Ca' Riva San Marco",
        host_id: 7161521,
        host_name: "Luisa",
        latitude: 45.43442,
        longitude: 12.34833,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34833, 45.43442]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1316352,
        name: "Appart. à Venise avec vue sur canal",
        host_id: 7217686,
        host_name: "Giovanna",
        latitude: 45.4315,
        longitude: 12.31814,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31814, 45.4315]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1320595,
        name: 'Lagoon " del\'orto " Flat - Just Restored  Feb.2017',
        host_id: 5128717,
        host_name: "Alvise",
        latitude: 45.44691,
        longitude: 12.33273,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33273, 45.44691]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1320888,
        name: "CASA SCARPA - A Venice house",
        host_id: 7171206,
        host_name: "Mirko",
        latitude: 45.43196,
        longitude: 12.32053,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32053, 45.43196]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1323282,
        name: "stylish apartment-style canal view",
        host_id: 5514357,
        host_name: "Alvise",
        latitude: 45.43379,
        longitude: 12.33112,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33112, 45.43379]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1325679,
        name: "CA'GIRASOLE WITH WI-FI",
        host_id: 3281444,
        host_name: "Attilio & Arelis",
        latitude: 45.43135,
        longitude: 12.35207,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35207, 45.43135]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1326131,
        name: "B&B Room 2 canal view",
        host_id: 6538340,
        host_name: "Fabio",
        latitude: 45.43596,
        longitude: 12.34473,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34473, 45.43596]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1329522,
        name: "Quintuple Room overlook Canal Grande with Private Terrace",
        host_id: 571311,
        host_name: "Debora",
        latitude: 45.43989,
        longitude: 12.3368,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3368, 45.43989]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1334825,
        name: "Michiel apartment in the Venezia Rialto area",
        host_id: 7544330,
        host_name: "Adriana",
        latitude: 45.43734,
        longitude: 12.32964,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32964, 45.43734]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1338530,
        name: "Apartment Bragora in Venice Center",
        host_id: 7258600,
        host_name: "Enrico",
        latitude: 45.43548,
        longitude: 12.34782,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34782, 45.43548]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1338551,
        name: "Charming vacation in Venice",
        host_id: 7258764,
        host_name: "Ugo",
        latitude: 45.43366,
        longitude: 12.3235,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3235, 45.43366]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1345923,
        name: "CasaGiulietta your home at Venice",
        host_id: 7125469,
        host_name: "Luca",
        latitude: 45.43103,
        longitude: 12.35578,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35578, 45.43103]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1350099,
        name: "Ca' dei Fuseri",
        host_id: 7325760,
        host_name: "Stefano",
        latitude: 45.43611,
        longitude: 12.33444,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33444, 45.43611]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1351007,
        name: "Nice flat in the heart of Venice",
        host_id: 7327268,
        host_name: "Roberta",
        latitude: 45.4343,
        longitude: 12.33059,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33059, 45.4343]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1353270,
        name: "Cà Morea-150 meters from Saint Mark square",
        host_id: 7345745,
        host_name: "Alvise",
        latitude: 45.43334,
        longitude: 12.33803,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33803, 45.43334]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1368196,
        name: "Central top apartment with view",
        host_id: 1490179,
        host_name: "Laura",
        latitude: 45.43569,
        longitude: 12.33681,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33681, 45.43569]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1375939,
        name: "Spectacular ancient house with garden!",
        host_id: 7455203,
        host_name: "Alessandro&Anna",
        latitude: 45.4457,
        longitude: 12.33356,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33356, 45.4457]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1377029,
        name: "Cosy apartment in the Venice center",
        host_id: 3296218,
        host_name: "Vicri",
        latitude: 45.43755,
        longitude: 12.32684,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32684, 45.43755]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1389133,
        name: "1-Sunny w/ balcony,4 guests,S.Marco",
        host_id: 6180481,
        host_name: "Stefano",
        latitude: 45.43511,
        longitude: 12.34109,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34109, 45.43511]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1390598,
        name: "elegant altana terrace apartment",
        host_id: 2975628,
        host_name: "Geraldine",
        latitude: 45.43025,
        longitude: 12.32839,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32839, 45.43025]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1392429,
        name:
          "Large apartment&terrace in S.Marco ID M (Phone number hidden by Airbnb)",
        host_id: 2227088,
        host_name: "Gabriele",
        latitude: 45.43233,
        longitude: 12.32972,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32972, 45.43233]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1396335,
        name: "Twin room next to Rialto Bridge",
        host_id: 6174080,
        host_name: "Nello",
        latitude: 45.43923,
        longitude: 12.34001,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34001, 45.43923]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1396694,
        name: "Rialto bridge, splendid attic",
        host_id: 7545741,
        host_name: "Stefano",
        latitude: 45.43876,
        longitude: 12.33448,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33448, 45.43876]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1410014,
        name: "Beautiful apartment with terrace",
        host_id: 7603585,
        host_name: "Marc",
        latitude: 45.4337,
        longitude: 12.31741,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31741, 45.4337]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1424680,
        name: "Testa Apartment",
        host_id: 7665431,
        host_name: "Pierre",
        latitude: 45.43947,
        longitude: 12.34026,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34026, 45.43947]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1424715,
        name: "Apartment in the heart of Venice",
        host_id: 7665431,
        host_name: "Pierre",
        latitude: 45.43914,
        longitude: 12.34011,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34011, 45.43914]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1426465,
        name: "La Dolce Venezia - 5min from S.Mark",
        host_id: 7672609,
        host_name: "Gian Luigi & Nicola",
        latitude: 45.43493,
        longitude: 12.34751,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34751, 45.43493]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1435089,
        name: "CA' SOFIA",
        host_id: 23309,
        host_name: "Francesco E Nicola",
        latitude: 45.44085,
        longitude: 12.32569,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32569, 45.44085]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1440915,
        name: "GIORGIA'S APARTAMENT",
        host_id: 7737829,
        host_name: "Giorgia",
        latitude: 45.43871,
        longitude: 12.33937,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33937, 45.43871]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1450344,
        name: "Bright apartment in the heart of Venice",
        host_id: 7773795,
        host_name: "Sandra",
        latitude: 45.43714,
        longitude: 12.34223,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34223, 45.43714]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1459783,
        name: "Amazing flat for 2 close to Rialto",
        host_id: 2508340,
        host_name: "Giacomo",
        latitude: 45.44129,
        longitude: 12.33029,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33029, 45.44129]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1461636,
        name: "Luminosissimo e restaurato!",
        host_id: 7833708,
        host_name: "Massimo",
        latitude: 45.44818,
        longitude: 12.32871,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32871, 45.44818]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1464535,
        name: "Vista sui tetti e su S.Marco",
        host_id: 7846371,
        host_name: "Franco",
        latitude: 45.43499,
        longitude: 12.34476,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34476, 45.43499]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1464816,
        name: "SAN MARCO (Doge 3): city center, Wi-Fi, A/C",
        host_id: 289615,
        host_name: "Valentina",
        latitude: 45.43576,
        longitude: 12.34585,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34585, 45.43576]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1465108,
        name: "Cozy room very bright and with a great view !",
        host_id: 5113473,
        host_name: "Sara E Giovanni",
        latitude: 45.4379,
        longitude: 12.3393,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3393, 45.4379]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1473757,
        name: "Duplex in Campo della Bragora - City center!",
        host_id: 289615,
        host_name: "Valentina",
        latitude: 45.43471,
        longitude: 12.34778,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34778, 45.43471]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1473843,
        name: "Doge 6: prestigious residence -the heart of Venice",
        host_id: 289615,
        host_name: "Valentina",
        latitude: 45.43544,
        longitude: 12.34591,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34591, 45.43544]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1482860,
        name: "Santa Margherita Guesthouse double1",
        host_id: 4474459,
        host_name: "Maria Chiara",
        latitude: 45.43336,
        longitude: 12.32226,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32226, 45.43336]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1484835,
        name: "Lovely canal view and private terrace!",
        host_id: 6019189,
        host_name: "Federico",
        latitude: 45.43804,
        longitude: 12.32491,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32491, 45.43804]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1486530,
        name: "Sunny Terrace! Near Rialto and St.Mark",
        host_id: 6019189,
        host_name: "Federico",
        latitude: 45.43818,
        longitude: 12.34192,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34192, 45.43818]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1492699,
        name: "accademia elegant",
        host_id: 2975628,
        host_name: "Geraldine",
        latitude: 45.43036,
        longitude: 12.33047,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33047, 45.43036]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1492997,
        name: "CA'BANDERUOLA",
        host_id: 1897360,
        host_name: "Davide",
        latitude: 45.43663,
        longitude: 12.33635,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33635, 45.43663]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1493790,
        name: "Luminosa Venezia! Spectacular view",
        host_id: 7978760,
        host_name: "Luca",
        latitude: 45.43655,
        longitude: 12.32402,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32402, 45.43655]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1495535,
        name: "Apartment Ai Miracoli",
        host_id: 7994036,
        host_name: "Stefano",
        latitude: 45.43984,
        longitude: 12.33717,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33717, 45.43984]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1500729,
        name: "ROOM for 2+private bath+WIFI",
        host_id: 8019503,
        host_name: "Cristina",
        latitude: 45.44448,
        longitude: 12.32117,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32117, 45.44448]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1502171,
        name: "Angel's view house in San Marco",
        host_id: 5514357,
        host_name: "Alvise",
        latitude: 45.43251,
        longitude: 12.33683,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33683, 45.43251]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1503769,
        name: "New **** Biennale Queen House ****",
        host_id: 1364177,
        host_name: "Ivan.Gianni",
        latitude: 45.42916,
        longitude: 12.36158,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.36158, 45.42916]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1507117,
        name: "Santa Margherita Guesthouse single1",
        host_id: 4474459,
        host_name: "Maria Chiara",
        latitude: 45.43192,
        longitude: 12.32219,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32219, 45.43192]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1512315,
        name: "The CONSERVATORY apartment",
        host_id: 8019503,
        host_name: "Cristina",
        latitude: 45.44457,
        longitude: 12.32163,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32163, 45.44457]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1518234,
        name: "Guest House Michelangelo",
        host_id: 4105465,
        host_name: "Michelangelo",
        latitude: 45.43068,
        longitude: 12.32337,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32337, 45.43068]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1526920,
        name: "appartamento Alla Corte Fiorita",
        host_id: 8147009,
        host_name: "Paolo",
        latitude: 45.4321,
        longitude: 12.32351,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32351, 45.4321]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1533624,
        name: "Casa Fiorita",
        host_id: 1966774,
        host_name: "Emiliano",
        latitude: 45.43682,
        longitude: 12.3495,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3495, 45.43682]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1544149,
        name: "Ca Orsola, the nest on the roof",
        host_id: 8229527,
        host_name: "Maddalena",
        latitude: 45.43496,
        longitude: 12.3456,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3456, 45.43496]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1555332,
        name: "Biennale appartamento grande",
        host_id: 7527885,
        host_name: "Silvano",
        latitude: 45.43054,
        longitude: 12.35728,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35728, 45.43054]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1567457,
        name: "Venice & Venice☆King Bed with Canal view",
        host_id: 6798407,
        host_name: "Monica",
        latitude: 45.44417,
        longitude: 12.32679,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32679, 45.44417]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1567814,
        name: "Romantic suite in Venice",
        host_id: 8339294,
        host_name: "Giulia",
        latitude: 45.44591,
        longitude: 12.32883,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32883, 45.44591]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1579510,
        name: "Ca'Mirta, ideal for families",
        host_id: 8229527,
        host_name: "Maddalena",
        latitude: 45.43648,
        longitude: 12.34043,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34043, 45.43648]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1581387,
        name: "Two rooms in the heart of Venice",
        host_id: 8342674,
        host_name: "Patrizia",
        latitude: 45.44557,
        longitude: 12.32361,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32361, 45.44557]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1581694,
        name: "DolceVita Apartments 111 San Marco",
        host_id: 8176475,
        host_name: "Eugenia",
        latitude: 45.43287,
        longitude: 12.32833,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32833, 45.43287]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1583452,
        name: "Apartment in venetian palace",
        host_id: 7767197,
        host_name: "Oscar",
        latitude: 45.44206,
        longitude: 12.33724,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33724, 45.44206]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1587248,
        name: "Elegant Romantic Attic in San Marco/Fenice Theatre",
        host_id: 5313056,
        host_name: "Manuela",
        latitude: 45.4344,
        longitude: 12.33657,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33657, 45.4344]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1599013,
        name: "little gem",
        host_id: 8524766,
        host_name: "Pietro",
        latitude: 45.44145,
        longitude: 12.3307,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3307, 45.44145]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1614255,
        name: "AMAZING CANAL VIEW - Venice Apartment",
        host_id: 8593139,
        host_name: "Aglaia",
        latitude: 45.43518,
        longitude: 12.324,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.324, 45.43518]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1615895,
        name: "Appartamento a Venezia, Dorsoduro",
        host_id: 8600460,
        host_name: "Alvise",
        latitude: 45.4346,
        longitude: 12.32583,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32583, 45.4346]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1627482,
        name: "Apartment Casa Marco Polo Canal View in Venice",
        host_id: 7258600,
        host_name: "Enrico",
        latitude: 45.43819,
        longitude: 12.3392,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3392, 45.43819]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1630395,
        name: "San Stae Dream Holiday",
        host_id: 6238110,
        host_name: "Marcello",
        latitude: 45.44132,
        longitude: 12.32966,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32966, 45.44132]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1631423,
        name: "LuxuryRomanticAtticFloorOnLagoon",
        host_id: 118119,
        host_name: "Sonia",
        latitude: 45.43861,
        longitude: 12.34625,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34625, 45.43861]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1638351,
        name: "Attic above the rooftops of Venice",
        host_id: 8700053,
        host_name: "Guglielmo",
        latitude: 45.43751,
        longitude: 12.34096,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34096, 45.43751]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1642213,
        name: "Cozy Flat in heart of Venice",
        host_id: 5113473,
        host_name: "Sara E Giovanni",
        latitude: 45.43795,
        longitude: 12.33877,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33877, 45.43795]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1658568,
        name: "Beautiful canal view - Rialto Loft",
        host_id: 289615,
        host_name: "Valentina",
        latitude: 45.43846,
        longitude: 12.33063,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33063, 45.43846]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1665038,
        name: "Ca' Rosa, Apartment in Venice",
        host_id: 8803163,
        host_name: "Francesca",
        latitude: 45.43632,
        longitude: 12.34126,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34126, 45.43632]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1675120,
        name: "Cozy & Comfy private room with A.C",
        host_id: 8865074,
        host_name: "Valerie",
        latitude: 45.44437,
        longitude: 12.32874,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32874, 45.44437]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1683211,
        name: "Ca' del Campanile",
        host_id: 8900655,
        host_name: "Yanet",
        latitude: 45.43845,
        longitude: 12.33358,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33358, 45.43845]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1696643,
        name: "Ca' d'Elisa (Castello)",
        host_id: 1389984,
        host_name: "Elisabetta",
        latitude: 45.43247,
        longitude: 12.35715,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35715, 45.43247]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1708704,
        name: "Ca' Azzurra between Piazzale Roma and the railway station",
        host_id: 9015672,
        host_name: "Elisa",
        latitude: 45.43659,
        longitude: 12.32478,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32478, 45.43659]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1709013,
        name: "Melusina Apartment center Venice",
        host_id: 9017175,
        host_name: "Andrea",
        latitude: 45.43763,
        longitude: 12.344,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.344, 45.43763]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1711864,
        name: "A modern apartment in Venice",
        host_id: 245974,
        host_name: "Furio",
        latitude: 45.43345,
        longitude: 12.31728,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31728, 45.43345]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1716615,
        name: "Apt Venice Centre-Wi-fi-air cond",
        host_id: 9051183,
        host_name: "Cristiano",
        latitude: 45.43296,
        longitude: 12.35299,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35299, 45.43296]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1721180,
        name: "Secret Venice, Venezia sconta-ITALY",
        host_id: 3070316,
        host_name: "Veronica",
        latitude: 45.43794,
        longitude: 12.35071,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35071, 45.43794]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1723763,
        name: "Al Balcone Fiorito",
        host_id: 9086038,
        host_name: "Michela",
        latitude: 45.43826,
        longitude: 12.32196,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32196, 45.43826]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1724702,
        name: "In the heart of Venice - Rialto 3",
        host_id: 5426455,
        host_name: "Cristiana",
        latitude: 45.43775,
        longitude: 12.33211,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33211, 45.43775]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1726877,
        name: "DolceVita Apartments 118 San Marco",
        host_id: 8176475,
        host_name: "Eugenia",
        latitude: 45.4347,
        longitude: 12.32857,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32857, 45.4347]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1726937,
        name: "DolceVita Apartments 117 San Marco",
        host_id: 8176475,
        host_name: "Eugenia",
        latitude: 45.43403,
        longitude: 12.32781,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32781, 45.43403]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1732548,
        name: "Bright and stylish in top location",
        host_id: 8669903,
        host_name: "Caterina",
        latitude: 45.43251,
        longitude: 12.32881,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32881, 45.43251]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1733701,
        name: "Venice & Venice☆ROOM WITH VIEW☆PRIVATE BATHROOM",
        host_id: 6798407,
        host_name: "Monica",
        latitude: 45.43855,
        longitude: 12.33719,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33719, 45.43855]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1736517,
        name: "Unique Gran Canal duplex penthouse",
        host_id: 9145139,
        host_name: "Giovanni",
        latitude: 45.43272,
        longitude: 12.33116,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33116, 45.43272]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1748702,
        name: "Cozy room near rail and bus station",
        host_id: 9201808,
        host_name: "Alice",
        latitude: 45.43996,
        longitude: 12.32344,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32344, 45.43996]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1753171,
        name: "Cà Tolentini",
        host_id: 6973711,
        host_name: "Valentina",
        latitude: 45.4382,
        longitude: 12.32064,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32064, 45.4382]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1755514,
        name: "Melusina Young - large terrace",
        host_id: 9017175,
        host_name: "Andrea",
        latitude: 45.43742,
        longitude: 12.34501,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34501, 45.43742]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1757532,
        name: "SAN MARCO WHITE APARTMENT",
        host_id: 8844295,
        host_name: "Eleonora",
        latitude: 45.43426,
        longitude: 12.32751,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32751, 45.43426]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1761640,
        name: "New Apartment in Old Venice",
        host_id: 8339294,
        host_name: "Giulia",
        latitude: 45.44418,
        longitude: 12.33021,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33021, 45.44418]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1762032,
        name: "Classic -three minutes from St. Mark's Square",
        host_id: 8844295,
        host_name: "Eleonora",
        latitude: 45.43656,
        longitude: 12.34237,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34237, 45.43656]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1763175,
        name: "Water notes all around - Purple Apartment,",
        host_id: 8844295,
        host_name: "Eleonora",
        latitude: 45.42597,
        longitude: 12.32298,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32298, 45.42597]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1765576,
        name: "A beautiful bright apartment 160 mq",
        host_id: 9278228,
        host_name: "Andrea",
        latitude: 45.43393,
        longitude: 12.33194,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33194, 45.43393]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1780426,
        name: "San Marco - December 8-15",
        host_id: 9346122,
        host_name: "Alessandra",
        latitude: 45.435,
        longitude: 12.33316,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33316, 45.435]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1782304,
        name: "Venezia, Arte & Cappuccino!",
        host_id: 6620102,
        host_name: "Emanuele",
        latitude: 45.43293,
        longitude: 12.33177,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33177, 45.43293]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1788678,
        name: "GREEN WATER APARTMENT VENICE",
        host_id: 8844295,
        host_name: "Eleonora",
        latitude: 45.42739,
        longitude: 12.32234,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32234, 45.42739]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1791811,
        name: "Melusina Budget with garden",
        host_id: 9017175,
        host_name: "Andrea",
        latitude: 45.4383,
        longitude: 12.34414,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34414, 45.4383]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1795193,
        name: "LOVELY APT in VENICE WITH GARDEN!",
        host_id: 2368512,
        host_name: "Fra",
        latitude: 45.44658,
        longitude: 12.32871,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32871, 45.44658]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1799959,
        name: "Stay IN THE HEART OF VENICE",
        host_id: 9438202,
        host_name: "Silvia",
        latitude: 45.43658,
        longitude: 12.34028,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34028, 45.43658]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1801026,
        name: "apartment with Venice and the south lagoon's view",
        host_id: 9442807,
        host_name: "Daniela",
        latitude: 45.42452,
        longitude: 12.32663,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32663, 45.42452]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1808804,
        name: "HANIA - Comfortable and very bright",
        host_id: 494255,
        host_name: "Rosa",
        latitude: 45.4435,
        longitude: 12.32845,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32845, 45.4435]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1812863,
        name: "VENISA - A short walk from Rialto",
        host_id: 494255,
        host_name: "Rosa",
        latitude: 45.43909,
        longitude: 12.3327,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3327, 45.43909]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1815924,
        name: "Apartment in Corte Moro Lin.",
        host_id: 5377000,
        host_name: "Joan",
        latitude: 45.43681,
        longitude: 12.32942,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32942, 45.43681]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1816508,
        name: "Ca' Guardi - Casa dei Pittori",
        host_id: 1384217,
        host_name: "Simone - Francesco",
        latitude: 45.43979,
        longitude: 12.32832,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32832, 45.43979]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1816521,
        name: "Ca' Tiepolo - Casa dei Pittori",
        host_id: 1384217,
        host_name: "Simone - Francesco",
        latitude: 45.43984,
        longitude: 12.32782,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32782, 45.43984]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1816532,
        name: "Dimora Tintoretto - Casa dei Pittori",
        host_id: 1384217,
        host_name: "Simone - Francesco",
        latitude: 45.43978,
        longitude: 12.32795,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32795, 45.43978]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1834997,
        name: "Piccolo Palazzetto del 1700",
        host_id: 9594397,
        host_name: "Davide",
        latitude: 45.44284,
        longitude: 12.33476,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33476, 45.44284]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1871720,
        name: "VENICE CASA SORTENI",
        host_id: 9753694,
        host_name: "Paolo",
        latitude: 45.4277,
        longitude: 12.36271,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.36271, 45.4277]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1888340,
        name: "Elegant residence near Rialto",
        host_id: 1498253,
        host_name: "Franco",
        latitude: 45.43933,
        longitude: 12.33454,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33454, 45.43933]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1900562,
        name: "Ca' Melusina Castello Apartment",
        host_id: 9017175,
        host_name: "Andrea",
        latitude: 45.43808,
        longitude: 12.34382,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34382, 45.43808]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1900791,
        name: "Studio Garden Castello Apartment",
        host_id: 9017175,
        host_name: "Andrea",
        latitude: 45.43876,
        longitude: 12.3436,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3436, 45.43876]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1922670,
        name: "Bragadin della palma at Dorsoduro",
        host_id: 9963282,
        host_name: "Andrea",
        latitude: 45.42929,
        longitude: 12.32833,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32833, 45.42929]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1925235,
        name: "spacious, restored and bright!",
        host_id: 7833708,
        host_name: "Massimo",
        latitude: 45.44781,
        longitude: 12.32752,
        beds: 9,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32752, 45.44781]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1947387,
        name: "Apartment FENICEFLAT",
        host_id: 10071335,
        host_name: "Alessandro",
        latitude: 45.43358,
        longitude: 12.33324,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33324, 45.43358]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1949678,
        name: "Casa Boheme Central Venice Wi-Fi",
        host_id: 10082020,
        host_name: "Vittoria",
        latitude: 45.43737,
        longitude: 12.34205,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34205, 45.43737]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1958392,
        name: "Meravigliosa camera con bagno turco",
        host_id: 2508340,
        host_name: "Giacomo",
        latitude: 45.43986,
        longitude: 12.32194,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32194, 45.43986]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1968248,
        name: "Wonderful flat - Venice for four!",
        host_id: 703872,
        host_name: "Leonardo E Irene",
        latitude: 45.44199,
        longitude: 12.34171,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34171, 45.44199]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1973495,
        name: "AL TEATRO - A 3 mins walk to St. Mark's square!",
        host_id: 10189388,
        host_name: "Raffaella",
        latitude: 45.43355,
        longitude: 12.33396,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33396, 45.43355]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1974456,
        name: "San Marco Panoramic Apartment",
        host_id: 7268095,
        host_name: "Pietro",
        latitude: 45.43262,
        longitude: 12.33269,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33269, 45.43262]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1982665,
        name: "Castello bnb best place",
        host_id: 620628,
        host_name: "Nino",
        latitude: 45.43515,
        longitude: 12.34656,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34656, 45.43515]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1982896,
        name: "Castello bnb best location Venice",
        host_id: 620628,
        host_name: "Nino",
        latitude: 45.43579,
        longitude: 12.34627,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34627, 45.43579]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1997702,
        name: "Charming Flat in Molino Stucky",
        host_id: 1891068,
        host_name: "Simone",
        latitude: 45.4281,
        longitude: 12.31863,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31863, 45.4281]] },
    },
    {
      type: "Feature",
      properties: {
        id: 1999538,
        name: "3 minutes Rialto Bridge, renovated",
        host_id: 10300793,
        host_name: "Federica",
        latitude: 45.43785,
        longitude: 12.33239,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33239, 45.43785]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2004220,
        name: "ROMANTIC STUDIO near RIALTO, WI-FI conditioned air",
        host_id: 10319031,
        host_name: "Pier",
        latitude: 45.4364,
        longitude: 12.33026,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33026, 45.4364]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2025659,
        name: "B&B LEONARDO - Heart of Venice!",
        host_id: 2815415,
        host_name: "Leonardo",
        latitude: 45.43277,
        longitude: 12.32633,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32633, 45.43277]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2027277,
        name: "Melodia Apt. - Venice, in the heart",
        host_id: 347332,
        host_name: "Guido",
        latitude: 45.44071,
        longitude: 12.33175,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33175, 45.44071]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2029685,
        name: "Rialto Apartment with elevator&view",
        host_id: 1490179,
        host_name: "Laura",
        latitude: 45.4384,
        longitude: 12.33418,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33418, 45.4384]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2035612,
        name: "VENICE - CENTRAL LOCATED NEAR THE OPERA HOUSE",
        host_id: 10333185,
        host_name: "Francesca",
        latitude: 45.43388,
        longitude: 12.33339,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33339, 45.43388]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2039852,
        name: "(Website hidden by Airbnb)",
        host_id: 10463902,
        host_name: "Giulia",
        latitude: 45.44137,
        longitude: 12.32515,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32515, 45.44137]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2048743,
        name: "Sinfonia Apartment",
        host_id: 347332,
        host_name: "Guido",
        latitude: 45.44061,
        longitude: 12.33233,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33233, 45.44061]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2050246,
        name: "Apartment in Ca' Paruta",
        host_id: 10507761,
        host_name: "Pietro Giovanni",
        latitude: 45.43456,
        longitude: 12.32533,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32533, 45.43456]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2073228,
        name: "A nest for two: Domus Venetiae",
        host_id: 299424,
        host_name: "Michele",
        latitude: 45.44458,
        longitude: 12.32225,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32225, 45.44458]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2090555,
        name: "Stunning San Marco",
        host_id: 10669989,
        host_name: "Elena",
        latitude: 45.43618,
        longitude: 12.3391,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3391, 45.43618]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2099655,
        name: "CA' DEL NONNO - Romantic apartment near San Marco",
        host_id: 10189388,
        host_name: "Raffaella",
        latitude: 45.43578,
        longitude: 12.3412,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3412, 45.43578]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2100925,
        name: "Ca' de l'Oca, a jewel apt in Venice",
        host_id: 5146501,
        host_name: "Stefano",
        latitude: 45.44173,
        longitude: 12.33489,
        beds: 7,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33489, 45.44173]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2103960,
        name: "Venezia Arsenale Biennale",
        host_id: 10727560,
        host_name: "Agostino",
        latitude: 45.43284,
        longitude: 12.35002,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35002, 45.43284]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2110857,
        name: "Rialto terrace with stunning view over Venice",
        host_id: 10764443,
        host_name: "Mila & Ruzbeh",
        latitude: 45.43824,
        longitude: 12.33209,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33209, 45.43824]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2116417,
        name: "Ghetto Novissimo - Appartamento con wifi",
        host_id: 10790870,
        host_name: "Marco",
        latitude: 45.44499,
        longitude: 12.32696,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32696, 45.44499]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2118033,
        name: "★★威尼斯水城客房3 ★★强烈推荐!♥♥威尼斯华人旅馆",
        host_id: 10779919,
        host_name: "威尼斯意家缘旅馆",
        latitude: 45.43139,
        longitude: 12.35217,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35217, 45.43139]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2123898,
        name: "Il Palazzo della Statua",
        host_id: 10831537,
        host_name: "Paola",
        latitude: 45.43587,
        longitude: 12.34445,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34445, 45.43587]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2136532,
        name: "Venice Central Canal & Garden views",
        host_id: 8766481,
        host_name: "Agnes",
        latitude: 45.44145,
        longitude: 12.33387,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33387, 45.44145]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2151599,
        name: "Great view over Ghetto square",
        host_id: 9806658,
        host_name: "Kristina",
        latitude: 45.44626,
        longitude: 12.3266,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3266, 45.44626]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2153244,
        name: "St. Mark's Square in 100 steps",
        host_id: 10988715,
        host_name: "Andrea",
        latitude: 45.43421,
        longitude: 12.33698,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33698, 45.43421]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2156521,
        name: "Centralissimo Venezia 4+2",
        host_id: 11005642,
        host_name: "Monica",
        latitude: 45.43731,
        longitude: 12.34029,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34029, 45.43731]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2157923,
        name: "Cozy Apartment 3Rooms Biennale Area",
        host_id: 11011765,
        host_name: "Diego",
        latitude: 45.43199,
        longitude: 12.35416,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35416, 45.43199]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2158295,
        name: "Appartamento con Terrazza",
        host_id: 10793908,
        host_name: "Leone",
        latitude: 45.43988,
        longitude: 12.32859,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32859, 45.43988]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2162550,
        name: "Rialto / SanPolo Boutique Apartment",
        host_id: 11034361,
        host_name: "Luca",
        latitude: 45.43928,
        longitude: 12.33191,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33191, 45.43928]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2174230,
        name: "Your home in Venice",
        host_id: 9645735,
        host_name: "Sonia Alice",
        latitude: 45.4469,
        longitude: 12.31995,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31995, 45.4469]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2174779,
        name: "Flat for 4 people few minutes from the Station",
        host_id: 674749,
        host_name: "Riccardo",
        latitude: 45.44532,
        longitude: 12.32764,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32764, 45.44532]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2177166,
        name: "Rialto Mercato Melusina apartment 1",
        host_id: 9017175,
        host_name: "Andrea",
        latitude: 45.43999,
        longitude: 12.33404,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33404, 45.43999]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2178655,
        name: "GRAN CANAL apartment.",
        host_id: 1784535,
        host_name: "Monica",
        latitude: 45.43977,
        longitude: 12.33111,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33111, 45.43977]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2202556,
        name: "Couzy house in Venice",
        host_id: 6620102,
        host_name: "Emanuele",
        latitude: 45.43717,
        longitude: 12.3224,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3224, 45.43717]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2206242,
        name: '" Alloggio Casa Loredan 1"',
        host_id: 7345605,
        host_name: "Cristina",
        latitude: 45.43477,
        longitude: 12.32386,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32386, 45.43477]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2207546,
        name: "Ca' Querini - Apartment",
        host_id: 4120295,
        host_name: "Michela",
        latitude: 45.4343,
        longitude: 12.34781,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34781, 45.4343]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2208448,
        name: "Beautiful loft with terrace",
        host_id: 11264773,
        host_name: "Daniella",
        latitude: 45.43717,
        longitude: 12.33851,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33851, 45.43717]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2212002,
        name: "Ca' Melusina Large Family apartment",
        host_id: 9017175,
        host_name: "Andrea",
        latitude: 45.43756,
        longitude: 12.3454,
        beds: 7,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3454, 45.43756]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2224008,
        name: "Loft near Rialto with canal view",
        host_id: 5395291,
        host_name: "Beatrice",
        latitude: 45.43972,
        longitude: 12.33895,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33895, 45.43972]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2224828,
        name: "Zattere luxury apartment 2 bedrooms.",
        host_id: 11353579,
        host_name: "Giorgio",
        latitude: 45.42888,
        longitude: 12.33254,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33254, 45.42888]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2224849,
        name: "Zattere luxury water front apart.",
        host_id: 11353579,
        host_name: "Giorgio",
        latitude: 45.42941,
        longitude: 12.33094,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33094, 45.42941]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2236237,
        name: "Arsenale apartment",
        host_id: 399883,
        host_name: "Monica",
        latitude: 45.433,
        longitude: 12.34873,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34873, 45.433]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2238910,
        name: "Casa Sofia",
        host_id: 11433351,
        host_name: "Paolo",
        latitude: 45.44121,
        longitude: 12.33498,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33498, 45.44121]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2245915,
        name: "Rialto Mercato Melusina apartment 2",
        host_id: 9017175,
        host_name: "Andrea",
        latitude: 45.43859,
        longitude: 12.33533,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33533, 45.43859]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2252350,
        name: "BRIGHT & AMPLE APARTMENT",
        host_id: 11500023,
        host_name: "Andrea",
        latitude: 45.428,
        longitude: 12.35979,
        beds: 7,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35979, 45.428]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2253136,
        name: "apartment Laura San Marco",
        host_id: 1688828,
        host_name: "Laura",
        latitude: 45.43707,
        longitude: 12.34092,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34092, 45.43707]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2253981,
        name: "ROMANTIC STUDIO 5 minutes RIALTO Bridge free WI-FI",
        host_id: 10319031,
        host_name: "Pier",
        latitude: 45.43739,
        longitude: 12.33001,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33001, 45.43739]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2260153,
        name: "MIMMA - Multi-sensory shower, close to St. Mark",
        host_id: 10189388,
        host_name: "Raffaella",
        latitude: 45.43309,
        longitude: 12.33504,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33504, 45.43309]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2260596,
        name: "CHARMING STUDIO 5 minutes FROM RIALTO, FREE WI-FI",
        host_id: 10319031,
        host_name: "Pier",
        latitude: 45.43764,
        longitude: 12.3315,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3315, 45.43764]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2261663,
        name: "Cozy brand new studio",
        host_id: 9701290,
        host_name: "Nicoletta",
        latitude: 45.43984,
        longitude: 12.33977,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33977, 45.43984]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2266770,
        name: "Rio Tera' San Leonardo Venezia",
        host_id: 11574776,
        host_name: "Marcello Luigina",
        latitude: 45.44133,
        longitude: 12.32877,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32877, 45.44133]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2281457,
        name: "New stylish loft with balcony",
        host_id: 9701290,
        host_name: "Nicoletta",
        latitude: 45.43989,
        longitude: 12.34109,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34109, 45.43989]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2287664,
        name: "Studio Venezia 2034",
        host_id: 11687040,
        host_name: "Marilia",
        latitude: 45.43319,
        longitude: 12.35386,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35386, 45.43319]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2295890,
        name: "Grand canal Apartment",
        host_id: 399883,
        host_name: "Monica",
        latitude: 45.43864,
        longitude: 12.33318,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33318, 45.43864]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2301129,
        name: "MALIBRAN wonderful room in Venice.",
        host_id: 11753298,
        host_name: "Liviana",
        latitude: 45.43738,
        longitude: 12.33906,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33906, 45.43738]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2308038,
        name: "DolceVita Apartments 161 Rialto",
        host_id: 8176475,
        host_name: "Eugenia",
        latitude: 45.43807,
        longitude: 12.33967,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33967, 45.43807]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2308090,
        name: "CA' REDENTORE stylish flat with canal view!",
        host_id: 1438903,
        host_name: "Barbara",
        latitude: 45.42942,
        longitude: 12.33131,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33131, 45.42942]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2318725,
        name: "Your own authentic Venetian home",
        host_id: 5846792,
        host_name: "Anthony Peter",
        latitude: 45.44625,
        longitude: 12.33056,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33056, 45.44625]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2322764,
        name: "Cannaregio apartment Venier",
        host_id: 11864207,
        host_name: "Rossella",
        latitude: 45.44164,
        longitude: 12.3395,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3395, 45.44164]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2322785,
        name: "Beautiful views on Venice",
        host_id: 11864228,
        host_name: "Orsola",
        latitude: 45.43629,
        longitude: 12.33955,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33955, 45.43629]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2323678,
        name: "Apartment in San Marco area",
        host_id: 11868414,
        host_name: "Leonardo",
        latitude: 45.43638,
        longitude: 12.33073,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33073, 45.43638]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2332443,
        name: "Arsenale, Beautiful View. 3",
        host_id: 11913000,
        host_name: "Francesca",
        latitude: 45.43369,
        longitude: 12.34923,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34923, 45.43369]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2335895,
        name: "Home to the Biennale Gardens",
        host_id: 11930764,
        host_name: "Elettra Elena",
        latitude: 45.43228,
        longitude: 12.3562,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3562, 45.43228]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2335966,
        name: "Rialto: a typically Venetian",
        host_id: 5980615,
        host_name: "Adriana",
        latitude: 45.4392,
        longitude: 12.3319,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3319, 45.4392]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2338769,
        name:
          "Tre terrazze nel cuore di Venezia. ID:M (Phone number hidden by Airbnb)",
        host_id: 10356311,
        host_name: "Giovanna",
        latitude: 45.4405,
        longitude: 12.33704,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33704, 45.4405]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2345537,
        name: "Arsenale, Biennale.  Comfortabl and cozy. 1",
        host_id: 11913000,
        host_name: "Francesca",
        latitude: 45.43376,
        longitude: 12.35049,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35049, 45.43376]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2346139,
        name: "Arsenale - Enchanting view. 5",
        host_id: 11913000,
        host_name: "Francesca",
        latitude: 45.4353,
        longitude: 12.35091,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35091, 45.4353]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2346194,
        name: "Arsenale Amazing dual view, dual floors apart - 4",
        host_id: 11913000,
        host_name: "Francesca",
        latitude: 45.43528,
        longitude: 12.34901,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34901, 45.43528]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2346233,
        name: "Arsenale.  Quiet,  lovely view,  2 bedroom -  2",
        host_id: 11913000,
        host_name: "Francesca",
        latitude: 45.43444,
        longitude: 12.34879,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34879, 45.43444]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2349220,
        name: "Cozy two-bedroom apartment.",
        host_id: 11388964,
        host_name: "Chiara",
        latitude: 45.43784,
        longitude: 12.33791,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33791, 45.43784]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2349345,
        name: "Rialto elegant apartment",
        host_id: 11625575,
        host_name: "Nicoletta",
        latitude: 45.4399,
        longitude: 12.33316,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33316, 45.4399]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2361042,
        name: "A view over the Venetian rooftops!",
        host_id: 12057457,
        host_name: "Marina",
        latitude: 45.43149,
        longitude: 12.32045,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32045, 45.43149]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2363425,
        name: "Ca' Barbaria S. Marco view room",
        host_id: 12072143,
        host_name: "Ca'Barbaria",
        latitude: 45.43916,
        longitude: 12.34421,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34421, 45.43916]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2363690,
        name: "10 minuts from Rialto Bridge",
        host_id: 12073381,
        host_name: "Paolo",
        latitude: 45.44287,
        longitude: 12.33953,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33953, 45.44287]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2366302,
        name: "Characteristic view of Venice",
        host_id: 7787037,
        host_name: "Paola",
        latitude: 45.44432,
        longitude: 12.33672,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33672, 45.44432]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2371050,
        name: "The house of Miracles",
        host_id: 12113075,
        host_name: "Roberto",
        latitude: 45.44039,
        longitude: 12.3369,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3369, 45.44039]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2377412,
        name: "HERMITAGE - Terrace on the Grand Canal.",
        host_id: 10189388,
        host_name: "Raffaella",
        latitude: 45.44105,
        longitude: 12.33576,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33576, 45.44105]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2377443,
        name: "Deep in the Green - Biennale",
        host_id: 4654704,
        host_name: "Nicola",
        latitude: 45.426,
        longitude: 12.36374,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.36374, 45.426]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2377469,
        name: "sweet home with garden",
        host_id: 12145490,
        host_name: "Micaela",
        latitude: 45.43832,
        longitude: 12.32375,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32375, 45.43832]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2377640,
        name: "Canal Sight - Cosy Small Apartment in Rialto Zone",
        host_id: 12146304,
        host_name: "Laura",
        latitude: 45.44105,
        longitude: 12.33107,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33107, 45.44105]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2402601,
        name: "Apartment in the heart of Venice",
        host_id: 12279519,
        host_name: "Barbara",
        latitude: 45.44264,
        longitude: 12.33802,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33802, 45.44264]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2409388,
        name: "Cosy  flat with canal view - Rialto",
        host_id: 1856077,
        host_name: "Alvise",
        latitude: 45.43963,
        longitude: 12.33339,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33339, 45.43963]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2414379,
        name: "Ca' sull'acqua",
        host_id: 9372174,
        host_name: "Anahi",
        latitude: 45.44221,
        longitude: 12.34198,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34198, 45.44221]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2428828,
        name: "CA' PROVERBI - Duplex flat in historic Palace",
        host_id: 10189388,
        host_name: "Raffaella",
        latitude: 45.44111,
        longitude: 12.33858,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33858, 45.44111]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2429883,
        name: "Delfina contemporary chic",
        host_id: 12419335,
        host_name: "Annalisa",
        latitude: 45.43205,
        longitude: 12.35162,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35162, 45.43205]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2451238,
        name: "Zattere Canal B - The Place to be!",
        host_id: 12533143,
        host_name: "Zattere Venice Apartments",
        latitude: 45.42926,
        longitude: 12.33076,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33076, 45.42926]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2456588,
        name: "CA' DELLA TORRE - Behind St. Mark, canal view",
        host_id: 10189388,
        host_name: "Raffaella",
        latitude: 45.43562,
        longitude: 12.33796,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33796, 45.43562]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2456625,
        name: "CA' DEL PRINCIPE - Balcony and canal view.",
        host_id: 10189388,
        host_name: "Raffaella",
        latitude: 45.44368,
        longitude: 12.33649,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33649, 45.44368]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2458244,
        name: "Appartement Fenice I",
        host_id: 12569265,
        host_name: "Fiorella",
        latitude: 45.43277,
        longitude: 12.3375,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3375, 45.43277]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2458435,
        name: "Appartement Fenice II A",
        host_id: 12569265,
        host_name: "Fiorella",
        latitude: 45.43459,
        longitude: 12.33333,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33333, 45.43459]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2458454,
        name: "San Rocco Apartment, with canal view",
        host_id: 6973711,
        host_name: "Valentina",
        latitude: 45.43716,
        longitude: 12.32324,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32324, 45.43716]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2458625,
        name: "Appartement Fenice II B",
        host_id: 12569265,
        host_name: "Fiorella",
        latitude: 45.43442,
        longitude: 12.33333,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33333, 45.43442]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2463016,
        name: "FAMILY FLAT - Three minutes from S. Mark's Square",
        host_id: 8844295,
        host_name: "Eleonora",
        latitude: 45.43622,
        longitude: 12.34081,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34081, 45.43622]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2477498,
        name: "Typical House with terrace ID M (Phone number hidden by Airbnb)",
        host_id: 8844295,
        host_name: "Eleonora",
        latitude: 45.43618,
        longitude: 12.34221,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34221, 45.43618]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2481023,
        name: "Central Modern Studio",
        host_id: 12692163,
        host_name: "Mario",
        latitude: 45.43462,
        longitude: 12.34543,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34543, 45.43462]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2481807,
        name: "Central Modern Apartment",
        host_id: 12692163,
        host_name: "Mario",
        latitude: 45.43677,
        longitude: 12.34485,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34485, 45.43677]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2503722,
        name: "Bright  apartment in Sestiere Dorsoduro, Free Wifi",
        host_id: 1711822,
        host_name: "Lucia",
        latitude: 45.43276,
        longitude: 12.31889,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31889, 45.43276]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2506074,
        name: "Dosoduro - Apartment on a patio",
        host_id: 6830844,
        host_name: "Marie",
        latitude: 45.42919,
        longitude: 12.33112,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33112, 45.42919]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2510812,
        name: "Charming b&b with view close to St. Mark's Square",
        host_id: 116144,
        host_name: "Gianni",
        latitude: 45.433,
        longitude: 12.33276,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33276, 45.433]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2522654,
        name: "Fantastic apartment in Dorsoduro",
        host_id: 11200880,
        host_name: "Marjolijn",
        latitude: 45.4289,
        longitude: 12.33299,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33299, 45.4289]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2523588,
        name: "Apartment with enchanting view on roofs and canals",
        host_id: 4654704,
        host_name: "Nicola",
        latitude: 45.43676,
        longitude: 12.3498,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3498, 45.43676]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2534377,
        name: "Residenza Dani",
        host_id: 12979449,
        host_name: "Daniela",
        latitude: 45.43209,
        longitude: 12.35542,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35542, 45.43209]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2535198,
        name: "Venice – A noble home right on the Grand Canal.",
        host_id: 12982391,
        host_name: "Alex (Alessandro)",
        latitude: 45.43665,
        longitude: 12.32793,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32793, 45.43665]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2541205,
        name: "SAN POLO APARTMENT",
        host_id: 5395291,
        host_name: "Beatrice",
        latitude: 45.4398,
        longitude: 12.32912,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32912, 45.4398]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2541450,
        name: "GIUDECCA",
        host_id: 12982157,
        host_name: "Locappart",
        latitude: 45.42478,
        longitude: 12.33095,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33095, 45.42478]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2554992,
        name: "Ca' Salute - In the heart of Venice",
        host_id: 13083139,
        host_name: "Alvise",
        latitude: 45.42878,
        longitude: 12.33334,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33334, 45.42878]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2555676,
        name: "Romantic house at the Zattere",
        host_id: 10194247,
        host_name: "Cristina",
        latitude: 45.42925,
        longitude: 12.33155,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33155, 45.42925]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2556380,
        name: "Charm, smart in the heart of Venice",
        host_id: 13088946,
        host_name: "Stefano",
        latitude: 45.42731,
        longitude: 12.31864,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31864, 45.42731]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2556475,
        name: "Sunny and Quite: perfect for family",
        host_id: 13089519,
        host_name: "Sebastiano",
        latitude: 45.43311,
        longitude: 12.31709,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31709, 45.43311]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2559866,
        name: "Corner canal first floor apartment Ca' dei Canali",
        host_id: 13084422,
        host_name: "Michela",
        latitude: 45.432,
        longitude: 12.32261,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32261, 45.432]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2567668,
        name: "Cosy romantic room in Rialto",
        host_id: 12333430,
        host_name: "Agata",
        latitude: 45.43766,
        longitude: 12.33754,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33754, 45.43766]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2577277,
        name: "Dimora Furlani (canal view)",
        host_id: 632312,
        host_name: "Guillaume",
        latitude: 45.43531,
        longitude: 12.34516,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34516, 45.43531]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2587927,
        name:
          "San Martino Apartment,near S.Marco(M (Phone number hidden by Airbnb)",
        host_id: 13251582,
        host_name: "Riccardo & Chiara",
        latitude: 45.43605,
        longitude: 12.34843,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34843, 45.43605]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2589159,
        name: "Romite",
        host_id: 12982157,
        host_name: "Locappart",
        latitude: 45.43039,
        longitude: 12.32385,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32385, 45.43039]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2596383,
        name: "SANT' AGOSTINO",
        host_id: 12982157,
        host_name: "Locappart",
        latitude: 45.43715,
        longitude: 12.32784,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32784, 45.43715]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2597262,
        name: "Venice Biennale Terrace",
        host_id: 7414069,
        host_name: "Adriano",
        latitude: 45.43275,
        longitude: 12.35246,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35246, 45.43275]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2597953,
        name: "SEVERO",
        host_id: 12982157,
        host_name: "Locappart",
        latitude: 45.43638,
        longitude: 12.34206,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34206, 45.43638]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2597984,
        name: "Silvestro",
        host_id: 12982157,
        host_name: "Locappart",
        latitude: 45.4377,
        longitude: 12.3334,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3334, 45.4377]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2598013,
        name: "Rialto Market double room",
        host_id: 8862107,
        host_name: "Maurizio",
        latitude: 45.43925,
        longitude: 12.33306,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33306, 45.43925]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2598016,
        name: "TEDESCHI",
        host_id: 12982157,
        host_name: "Locappart",
        latitude: 45.43901,
        longitude: 12.32543,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32543, 45.43901]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2603405,
        name: "SIMEONE IV PICCOLO",
        host_id: 12982157,
        host_name: "Locappart",
        latitude: 45.44051,
        longitude: 12.32411,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32411, 45.44051]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2603624,
        name: "LANA",
        host_id: 12982157,
        host_name: "Locappart",
        latitude: 45.43918,
        longitude: 12.3236,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3236, 45.43918]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2604417,
        name: "Lovely apartment with 2 terraces",
        host_id: 11864228,
        host_name: "Orsola",
        latitude: 45.43779,
        longitude: 12.33858,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33858, 45.43779]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2604449,
        name: "Private garden in Venice",
        host_id: 11864228,
        host_name: "Orsola",
        latitude: 45.43138,
        longitude: 12.3255,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3255, 45.43138]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2605081,
        name: "Apt Salute: spacious and sunny overlook on Zattere",
        host_id: 5022636,
        host_name: "Monica",
        latitude: 45.42902,
        longitude: 12.33227,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33227, 45.42902]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2610193,
        name: "Very central apartment for 4 people",
        host_id: 11864228,
        host_name: "Orsola",
        latitude: 45.43726,
        longitude: 12.34075,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34075, 45.43726]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2614032,
        name: "Appartamento centrale a Venezia 2",
        host_id: 1862349,
        host_name: "Elide",
        latitude: 45.43785,
        longitude: 12.3401,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3401, 45.43785]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2615789,
        name: "dorsoduro461 giardino",
        host_id: 13396685,
        host_name: "Francesco",
        latitude: 45.42895,
        longitude: 12.33279,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33279, 45.42895]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2624054,
        name: "CASANOVA PENTHOUSE in the HEART of VENICE-RIALTO",
        host_id: 13439503,
        host_name: "Elisabetta",
        latitude: 45.43873,
        longitude: 12.33784,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33784, 45.43873]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2630682,
        name: "Elegant apartment garden canal view",
        host_id: 434492,
        host_name: "Lucia",
        latitude: 45.43694,
        longitude: 12.31644,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31644, 45.43694]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2630901,
        name: "Venice city centre, Casallegra",
        host_id: 13475821,
        host_name: "Massimiliano",
        latitude: 45.43704,
        longitude: 12.34369,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34369, 45.43704]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2632418,
        name: "CentralSuite with Private Bath",
        host_id: 1300751,
        host_name: "Frederico",
        latitude: 45.43641,
        longitude: 12.32564,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32564, 45.43641]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2635306,
        name: "DIETRO PIAZZA SAN MARCO chiedi OFFERTA SPECIALE",
        host_id: 13193266,
        host_name: "Lucia",
        latitude: 45.43503,
        longitude: 12.33362,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33362, 45.43503]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2635900,
        name: "Ca Rio Marin",
        host_id: 13497609,
        host_name: "Rita",
        latitude: 45.43977,
        longitude: 12.32257,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32257, 45.43977]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2646538,
        name: "Cozy Studio Accademia bridge,10min San Marco",
        host_id: 3145348,
        host_name: "Elena",
        latitude: 45.43264,
        longitude: 12.32892,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32892, 45.43264]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2648218,
        name: "SCRIGNO - Flat for 2 in the Jewish Ghetto",
        host_id: 10189388,
        host_name: "Raffaella",
        latitude: 45.44479,
        longitude: 12.32503,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32503, 45.44479]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2655675,
        name: "Brand new flat in the centre Venice",
        host_id: 13593891,
        host_name: "Martino",
        latitude: 45.43669,
        longitude: 12.32281,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32281, 45.43669]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2669217,
        name: "CA' STELLA - Close to F.te Nove, square view",
        host_id: 10189388,
        host_name: "Raffaella",
        latitude: 45.44021,
        longitude: 12.33897,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33897, 45.44021]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2699532,
        name: "ART Painting Apartment - CANAL VIEW",
        host_id: 10988715,
        host_name: "Andrea",
        latitude: 45.44709,
        longitude: 12.32513,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32513, 45.44709]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2704532,
        name: "Canal and St. Mark's view!Wonderful flat",
        host_id: 369617,
        host_name: "Irene",
        latitude: 45.44104,
        longitude: 12.33931,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33931, 45.44104]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2711607,
        name: "Stucky palace elegant apartment",
        host_id: 9971120,
        host_name: "Silvia",
        latitude: 45.42828,
        longitude: 12.31778,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31778, 45.42828]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2732811,
        name: "Cà Sale Garden",
        host_id: 5816996,
        host_name: "Giovanna",
        latitude: 45.4293,
        longitude: 12.33106,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33106, 45.4293]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2733967,
        name: "Cà Sale Canal",
        host_id: 5816996,
        host_name: "Giovanna",
        latitude: 45.42889,
        longitude: 12.33312,
        beds: 8,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33312, 45.42889]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2735280,
        name: "CaRina two steps away from San Marco.",
        host_id: 13996037,
        host_name: "Elisa",
        latitude: 45.43538,
        longitude: 12.34579,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34579, 45.43538]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2735333,
        name: "Ca' Fortuny apartment in San Marco",
        host_id: 12113015,
        host_name: "Mario",
        latitude: 45.43538,
        longitude: 12.33161,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33161, 45.43538]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2736817,
        name: "Cà Sale Premium",
        host_id: 5816996,
        host_name: "Giovanna",
        latitude: 45.42966,
        longitude: 12.33305,
        beds: 13,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33305, 45.42966]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2737073,
        name: 'Un "nido" nell\'emozionante Venezia.',
        host_id: 14004630,
        host_name: "Rossella",
        latitude: 45.44226,
        longitude: 12.33968,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33968, 45.44226]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2744684,
        name: "Canal view near Biennale Wi-fi",
        host_id: 10072655,
        host_name: "Mario Apartment",
        latitude: 45.43895,
        longitude: 12.34511,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34511, 45.43895]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2745945,
        name: "Apartment in the middle of Venice",
        host_id: 4890499,
        host_name: "Sandrine",
        latitude: 45.43697,
        longitude: 12.33739,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33739, 45.43697]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2751476,
        name: "LEONILLA'S STUDIO VENICE/BIENNALE WIFI-AC",
        host_id: 8675069,
        host_name: "Gianluca",
        latitude: 45.43776,
        longitude: 12.34645,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34645, 45.43776]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2752257,
        name: "Cosy apartment with garden",
        host_id: 5275950,
        host_name: "Valentina",
        latitude: 45.43543,
        longitude: 12.34302,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34302, 45.43543]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2753359,
        name: "San Marco X 2! In the heart of Venezia!",
        host_id: 14083399,
        host_name: "Katyna",
        latitude: 45.43607,
        longitude: 12.33612,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33612, 45.43607]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2766585,
        name: "Amazing brand new flat with speedy wifi & full a/c",
        host_id: 2508340,
        host_name: "Giacomo",
        latitude: 45.44031,
        longitude: 12.32465,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32465, 45.44031]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2767723,
        name: "Tiziano room",
        host_id: 308647,
        host_name: "Federica",
        latitude: 45.42938,
        longitude: 12.35712,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35712, 45.42938]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2768245,
        name: "Casa Maria",
        host_id: 14157291,
        host_name: "Anna",
        latitude: 45.43979,
        longitude: 12.33894,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33894, 45.43979]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2768764,
        name: "Dal musicista - Veneziana",
        host_id: 14159304,
        host_name: "Davide",
        latitude: 45.42583,
        longitude: 12.33757,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33757, 45.42583]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2772734,
        name: "Sognando Venezia",
        host_id: 14179647,
        host_name: "Andrea",
        latitude: 45.44677,
        longitude: 12.32178,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32178, 45.44677]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2778812,
        name: "Typical Venetian house on the canal",
        host_id: 14212454,
        host_name: "Paolo",
        latitude: 45.44007,
        longitude: 12.34056,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34056, 45.44007]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2783287,
        name: "La Mansarda",
        host_id: 14232639,
        host_name: "Stefano",
        latitude: 45.44353,
        longitude: 12.32755,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32755, 45.44353]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2789898,
        name: "BEAUTIFUL, COMFORTABLE, ONE-OF-A-KIND LAGOON VIEWS",
        host_id: 14269771,
        host_name: "Mina",
        latitude: 45.4387,
        longitude: 12.34793,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34793, 45.4387]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2798293,
        name: "Ca' Erizzo dream apartment in Biennale area",
        host_id: 12113015,
        host_name: "Mario",
        latitude: 45.43396,
        longitude: 12.34961,
        beds: 7,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34961, 45.43396]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2800419,
        name: "Rialto Mercato Large Family apartment",
        host_id: 9017175,
        host_name: "Andrea",
        latitude: 45.43971,
        longitude: 12.33407,
        beds: 7,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33407, 45.43971]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2801730,
        name: "Charming apartment in Cannaregio",
        host_id: 12113015,
        host_name: "Mario",
        latitude: 45.43963,
        longitude: 12.33723,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33723, 45.43963]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2805609,
        name: "Ca' del Remo",
        host_id: 2138358,
        host_name: "Luca",
        latitude: 45.42897,
        longitude: 12.36068,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.36068, 45.42897]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2807505,
        name: "Casa Olivia - Central and Stylish",
        host_id: 14360433,
        host_name: "Alice",
        latitude: 45.44228,
        longitude: 12.33933,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33933, 45.44228]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2810199,
        name: "Polo room , Biennale area",
        host_id: 308647,
        host_name: "Federica",
        latitude: 45.43078,
        longitude: 12.3551,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3551, 45.43078]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2812241,
        name: "Jacopo Like a Little 1 Bdr House",
        host_id: 393913,
        host_name: "Luca",
        latitude: 45.43874,
        longitude: 12.32447,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32447, 45.43874]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2820115,
        name: "Ca' Giove, a quiet corner in Venice",
        host_id: 14427287,
        host_name: "Marzia",
        latitude: 45.43142,
        longitude: 12.31999,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31999, 45.43142]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2827956,
        name: "Gagiandra - With Altana (Terrace)",
        host_id: 14467437,
        host_name: "Elvira",
        latitude: 45.43673,
        longitude: 12.34219,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34219, 45.43673]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2834691,
        name: "Real Venetian Home Great Location Near Rialto❤️",
        host_id: 9852012,
        host_name: "Paolo",
        latitude: 45.44154,
        longitude: 12.3371,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3371, 45.44154]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2840449,
        name: "charming room in Rialto",
        host_id: 14529918,
        host_name: "Massimiliano",
        latitude: 45.43859,
        longitude: 12.33342,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33342, 45.43859]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2871803,
        name: "Rialto Mercato Venice Hause",
        host_id: 3926719,
        host_name: "Cara",
        latitude: 45.4396,
        longitude: 12.33048,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33048, 45.4396]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2873890,
        name: "Sumptuously Decorated Apartment close to Rialto",
        host_id: 12497228,
        host_name: "Canal Grande",
        latitude: 45.43857,
        longitude: 12.33004,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33004, 45.43857]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2884914,
        name: "Charme in palazzo del '400",
        host_id: 14744218,
        host_name: "Mariano",
        latitude: 45.4466,
        longitude: 12.33092,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33092, 45.4466]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2903035,
        name: "SAN MARCO- RIALTO WITH WI-FI",
        host_id: 3268637,
        host_name: "Massimo",
        latitude: 45.43654,
        longitude: 12.33725,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33725, 45.43654]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2913664,
        name: "Ca' Formosa  San Marco apartment with canal views",
        host_id: 12113015,
        host_name: "Mario",
        latitude: 45.43569,
        longitude: 12.34117,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34117, 45.43569]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2924501,
        name: "Like Royalty: WIFI, AC, Canal Views",
        host_id: 3018739,
        host_name: "Bianca",
        latitude: 45.43764,
        longitude: 12.32177,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32177, 45.43764]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2928351,
        name: "Luxury Venice Apartment",
        host_id: 14954297,
        host_name: "Elisa",
        latitude: 45.44208,
        longitude: 12.3322,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3322, 45.44208]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2946568,
        name: "In pieno centro con splendida vista",
        host_id: 15042744,
        host_name: "Stefania",
        latitude: 45.43984,
        longitude: 12.33933,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33933, 45.43984]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2946723,
        name: "VIVALDI SUITE in the HEART of VENICE-RIALTO",
        host_id: 13439503,
        host_name: "Elisabetta",
        latitude: 45.43882,
        longitude: 12.3377,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3377, 45.43882]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2952728,
        name: "ATTICO BIENNALE NUOVISSIMO wifi free",
        host_id: 13453584,
        host_name: "Francesca",
        latitude: 45.43203,
        longitude: 12.35166,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35166, 45.43203]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2960899,
        name: "Ca' Traviavista S",
        host_id: 15112827,
        host_name: "Marco",
        latitude: 45.43582,
        longitude: 12.34358,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34358, 45.43582]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2962359,
        name: "Venice Home Gallery",
        host_id: 13996037,
        host_name: "Elisa",
        latitude: 45.44048,
        longitude: 12.32563,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32563, 45.44048]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2975771,
        name: "Bright and cosy centrally located - X103",
        host_id: 15178567,
        host_name: "Paolo",
        latitude: 45.43782,
        longitude: 12.33848,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33848, 45.43782]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2981202,
        name: "Modern & comfy 2 bedrooms 2 bathrs X6103",
        host_id: 15178567,
        host_name: "Paolo",
        latitude: 45.43791,
        longitude: 12.34022,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34022, 45.43791]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2981671,
        name: "Modern and bright apartment",
        host_id: 1490179,
        host_name: "Laura",
        latitude: 45.44409,
        longitude: 12.32228,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32228, 45.44409]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2984300,
        name: "BIRI STUDIO NEAR RIALTO BRIDGE",
        host_id: 1878243,
        host_name: "Elisabetta",
        latitude: 45.43969,
        longitude: 12.33952,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33952, 45.43969]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2986063,
        name: "Cosy aprt.with private courtyard",
        host_id: 8339294,
        host_name: "Giulia",
        latitude: 45.44587,
        longitude: 12.33048,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33048, 45.44587]] },
    },
    {
      type: "Feature",
      properties: {
        id: 2992969,
        name: "A ROMANTIC STUDIO IN THE HEART OF VENICE",
        host_id: 3429853,
        host_name: "Cinzia",
        latitude: 45.43634,
        longitude: 12.34201,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34201, 45.43634]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3003073,
        name: "Modern central apt with terrace X401",
        host_id: 15178567,
        host_name: "Paolo",
        latitude: 45.43769,
        longitude: 12.33991,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33991, 45.43769]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3007237,
        name: "Venetian Style Canal-view apartment x201",
        host_id: 15178567,
        host_name: "Paolo",
        latitude: 45.43826,
        longitude: 12.33838,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33838, 45.43826]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3007300,
        name: "Top Location S. Mark Square 1",
        host_id: 4806020,
        host_name: "Iber",
        latitude: 45.43302,
        longitude: 12.33746,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33746, 45.43302]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3007400,
        name: "FOSCARI SUITE in the HEART of VENICE-RIALTO",
        host_id: 13439503,
        host_name: "Elisabetta",
        latitude: 45.43867,
        longitude: 12.33776,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33776, 45.43867]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3007613,
        name: "See Venice from roof-top terrace - X3201",
        host_id: 15178567,
        host_name: "Paolo",
        latitude: 45.43669,
        longitude: 12.34037,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34037, 45.43669]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3009703,
        name: "Giustinian",
        host_id: 15337957,
        host_name: "Marie",
        latitude: 45.43192,
        longitude: 12.32944,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32944, 45.43192]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3017842,
        name: "Appartamento con vista canale in palazzo del XVI secolo.",
        host_id: 15378291,
        host_name: "Elisabetta",
        latitude: 45.43836,
        longitude: 12.34282,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34282, 45.43836]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3020830,
        name: "The classic Venetian house",
        host_id: 15393127,
        host_name: "Daniele",
        latitude: 45.43913,
        longitude: 12.33984,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33984, 45.43913]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3026510,
        name: "Ca Greci  between Biennale & S.Mark Square, 2 room",
        host_id: 5332195,
        host_name: "Alessandro",
        latitude: 45.43488,
        longitude: 12.34674,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34674, 45.43488]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3026797,
        name: "Cozy flat near rail and bus station",
        host_id: 9201808,
        host_name: "Alice",
        latitude: 45.43807,
        longitude: 12.32169,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32169, 45.43807]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3026979,
        name:
          "San Stae Apartment,near Rialto (M (Phone number hidden by Airbnb)",
        host_id: 13251582,
        host_name: "Riccardo & Chiara",
        latitude: 45.43948,
        longitude: 12.32861,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32861, 45.43948]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3034703,
        name: "Modern and Central Studio apart. X102",
        host_id: 15178567,
        host_name: "Paolo",
        latitude: 45.43816,
        longitude: 12.33825,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33825, 45.43816]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3037526,
        name: "Charming Venetian style canal view - X6202",
        host_id: 15178567,
        host_name: "Paolo",
        latitude: 45.43794,
        longitude: 12.33878,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33878, 45.43794]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3039530,
        name: "Giudecca - Wonderful Location",
        host_id: 14712011,
        host_name: "Maria",
        latitude: 45.42688,
        longitude: 12.32204,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32204, 45.42688]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3043430,
        name: "2-ROOM APARTMENT WITH VIEW OF THE CANAL",
        host_id: 15497690,
        host_name: "Massimo",
        latitude: 45.44124,
        longitude: 12.33999,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33999, 45.44124]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3044146,
        name: "Magic View",
        host_id: 15501847,
        host_name: "Ludovica",
        latitude: 45.44128,
        longitude: 12.34063,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34063, 45.44128]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3045735,
        name: "Lovely flat in Castello",
        host_id: 15501847,
        host_name: "Ludovica",
        latitude: 45.43414,
        longitude: 12.35783,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35783, 45.43414]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3046348,
        name: "Monolocale vista giardino",
        host_id: 15511096,
        host_name: "Paolo",
        latitude: 45.43397,
        longitude: 12.33177,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33177, 45.43397]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3054444,
        name: "Elegant apt with private patio! Near Frari square",
        host_id: 6019189,
        host_name: "Federico",
        latitude: 45.43736,
        longitude: 12.32277,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32277, 45.43736]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3054903,
        name: "SWEET HOME: BRIGHT AND CANAL VIEW!",
        host_id: 3880254,
        host_name: "Sabina",
        latitude: 45.44693,
        longitude: 12.32719,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32719, 45.44693]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3076142,
        name: "Ca' Vistatravi L",
        host_id: 15112827,
        host_name: "Marco",
        latitude: 45.43469,
        longitude: 12.34383,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34383, 45.43469]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3078146,
        name: "Charming Garden cozy studio",
        host_id: 283131,
        host_name: "Anunxiata",
        latitude: 45.44597,
        longitude: 12.32854,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32854, 45.44597]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3082139,
        name: "Venetian Pleasure near Rialto Venice",
        host_id: 15682327,
        host_name: "Cristian",
        latitude: 45.43929,
        longitude: 12.34086,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34086, 45.43929]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3086551,
        name: "elegant loft between San Marco Square and Biennale",
        host_id: 5980615,
        host_name: "Adriana",
        latitude: 45.43646,
        longitude: 12.34632,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34632, 45.43646]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3092033,
        name: "Apartment Manin",
        host_id: 5024785,
        host_name: "Alessandro",
        latitude: 45.43974,
        longitude: 12.32949,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32949, 45.43974]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3108724,
        name: "★ Double bedroom w/private bathroom",
        host_id: 15802162,
        host_name: "Anna",
        latitude: 45.43377,
        longitude: 12.32312,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32312, 45.43377]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3121226,
        name: "Ca' dei Giugie-near Biennale free WiFi",
        host_id: 4338442,
        host_name: "Marina E Federico",
        latitude: 45.42799,
        longitude: 12.35983,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35983, 45.42799]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3145276,
        name: "Apt Stivaletto Rialto Brige",
        host_id: 15967968,
        host_name: "Gianluca",
        latitude: 45.43721,
        longitude: 12.33403,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33403, 45.43721]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3152680,
        name: "a private room in a bohemiene apartment",
        host_id: 6072487,
        host_name: "Silvia",
        latitude: 45.44106,
        longitude: 12.33928,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33928, 45.44106]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3169118,
        name: "Relax on a terrace with canal view! X82",
        host_id: 15178567,
        host_name: "Paolo",
        latitude: 45.43616,
        longitude: 12.33997,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33997, 45.43616]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3178062,
        name: "• Double bedroom with private bathroom •",
        host_id: 15802162,
        host_name: "Anna",
        latitude: 45.43359,
        longitude: 12.32191,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32191, 45.43359]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3180565,
        name: "Flat with canal view and courtyard",
        host_id: 1490179,
        host_name: "Laura",
        latitude: 45.43429,
        longitude: 12.31914,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31914, 45.43429]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3195851,
        name: "Quiet and comfortable apart for 3 - X203",
        host_id: 15178567,
        host_name: "Paolo",
        latitude: 45.44121,
        longitude: 12.33556,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33556, 45.44121]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3195989,
        name: "Charming little terrace on the roof X3202",
        host_id: 15178567,
        host_name: "Paolo",
        latitude: 45.43806,
        longitude: 12.33991,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33991, 45.43806]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3204920,
        name: "Appartamento veneziano a San Stae",
        host_id: 15571360,
        host_name: "Mariangela",
        latitude: 45.4413,
        longitude: 12.32986,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32986, 45.4413]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3206143,
        name: "Bilocale luminoso e accogliente",
        host_id: 16244530,
        host_name: "Antonella",
        latitude: 45.43347,
        longitude: 12.35795,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35795, 45.43347]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3214099,
        name: "Venetian Duplex Apartment",
        host_id: 15520667,
        host_name: "Masha",
        latitude: 45.44469,
        longitude: 12.33315,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33315, 45.44469]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3217451,
        name: "Sunny, wide and central apartment",
        host_id: 2847482,
        host_name: "Maria",
        latitude: 45.44282,
        longitude: 12.32696,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32696, 45.44282]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3218849,
        name: "2-ROOM APARTMENT CA' DEL SOL",
        host_id: 15497690,
        host_name: "Massimo",
        latitude: 45.44102,
        longitude: 12.34131,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34131, 45.44102]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3221895,
        name:
          "Tiziano Apartment, near S.Marco (M (Phone number hidden by Airbnb)",
        host_id: 13251582,
        host_name: "Riccardo & Chiara",
        latitude: 45.43612,
        longitude: 12.34991,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34991, 45.43612]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3228393,
        name: "Ca' Fenice 1 Centralissimo",
        host_id: 16267348,
        host_name: "Elisabetta",
        latitude: 45.43318,
        longitude: 12.33565,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33565, 45.43318]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3262165,
        name: "Bright &comfortable in top location",
        host_id: 8669903,
        host_name: "Caterina",
        latitude: 45.43267,
        longitude: 12.32867,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32867, 45.43267]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3284563,
        name: "Cosy Apt in the heart of Venice",
        host_id: 6179616,
        host_name: "Carlo",
        latitude: 45.43744,
        longitude: 12.32888,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32888, 45.43744]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3288528,
        name: "La casa delle tartarughe",
        host_id: 14475032,
        host_name: "Alessandra",
        latitude: 45.42678,
        longitude: 12.32441,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32441, 45.42678]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3295575,
        name: "Casa Verde - Biennale Venice",
        host_id: 16310422,
        host_name: "Veronica",
        latitude: 45.42955,
        longitude: 12.35972,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35972, 45.42955]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3298802,
        name: "CA' ZACCARIA - Renovated flat a 5 mins to St. Mark",
        host_id: 10189388,
        host_name: "Raffaella",
        latitude: 45.43592,
        longitude: 12.34415,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34415, 45.43592]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3300171,
        name: "JOLIE - 3 bedded flat 5 minute walk to Rialto!",
        host_id: 10189388,
        host_name: "Raffaella",
        latitude: 45.44104,
        longitude: 12.33667,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33667, 45.44104]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3301121,
        name: "Romantic apartment, wi-fi center Ve",
        host_id: 10072655,
        host_name: "Mario Apartment",
        latitude: 45.43927,
        longitude: 12.3247,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3247, 45.43927]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3306429,
        name: "Ca' Fenice 2",
        host_id: 16267348,
        host_name: "Elisabetta",
        latitude: 45.433,
        longitude: 12.33385,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33385, 45.433]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3307417,
        name: "Charmant & Lovely... in Venezia....",
        host_id: 16702030,
        host_name: "Adriano",
        latitude: 45.43894,
        longitude: 12.33104,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33104, 45.43894]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3308306,
        name: "Flat at 2 minutes only from San Marco square",
        host_id: 16705466,
        host_name: "Nikos",
        latitude: 45.4346,
        longitude: 12.34162,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34162, 45.4346]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3309714,
        name: "Ca' Valeria - Magic of Venice",
        host_id: 16711666,
        host_name: "Valeria- Daniele",
        latitude: 45.43702,
        longitude: 12.33305,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33305, 45.43702]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3313230,
        name: "Historic 14th century Luxury Apartment",
        host_id: 5196424,
        host_name: "Scilla",
        latitude: 45.43337,
        longitude: 12.3229,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3229, 45.43337]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3314867,
        name: "ca san pietro 2",
        host_id: 16737858,
        host_name: "Marta",
        latitude: 45.43418,
        longitude: 12.35986,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35986, 45.43418]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3314930,
        name: "Appartamento con spazio esterno",
        host_id: 16737858,
        host_name: "Marta",
        latitude: 45.43412,
        longitude: 12.3597,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3597, 45.43412]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3323891,
        name: "IL MOLINO APARTMENT (GIUDECCA)",
        host_id: 16781199,
        host_name: "Riccardo",
        latitude: 45.4274,
        longitude: 12.31967,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31967, 45.4274]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3330235,
        name: 'VENICE - CANNAREGIO "SAN LEONARDO"',
        host_id: 15374653,
        host_name: "Mirella",
        latitude: 45.44483,
        longitude: 12.32615,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32615, 45.44483]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3336816,
        name: "Maria's Home",
        host_id: 16846543,
        host_name: "Silvia",
        latitude: 45.44333,
        longitude: 12.32834,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32834, 45.44333]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3338215,
        name: "CA' VISCONTI - Quiet place a 7 mins to Rialto",
        host_id: 10189388,
        host_name: "Raffaella",
        latitude: 45.44157,
        longitude: 12.33682,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33682, 45.44157]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3356926,
        name: "Luxurious Palazzo in Venice",
        host_id: 16939330,
        host_name: "Riccardo",
        latitude: 45.4381,
        longitude: 12.33027,
        beds: 10,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33027, 45.4381]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3358157,
        name: "Venier 2 with pretty garden and canal view",
        host_id: 289615,
        host_name: "Valentina",
        latitude: 45.42993,
        longitude: 12.3304,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3304, 45.42993]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3358351,
        name: "Venier 3: design canal view & garden",
        host_id: 289615,
        host_name: "Valentina",
        latitude: 45.4298,
        longitude: 12.33048,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33048, 45.4298]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3358664,
        name: "Venier 4 in Dorsoduro - canal view & garden",
        host_id: 289615,
        host_name: "Valentina",
        latitude: 45.43118,
        longitude: 12.3298,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3298, 45.43118]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3358802,
        name: "NEW! Double room + private bathroom",
        host_id: 16946379,
        host_name: "Lolli",
        latitude: 45.42929,
        longitude: 12.32981,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32981, 45.42929]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3359937,
        name: "The Merchant of Venice House",
        host_id: 16948380,
        host_name: "Savina",
        latitude: 45.43436,
        longitude: 12.35093,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35093, 45.43436]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3362532,
        name: "Elegante monolocale in centro città",
        host_id: 16826239,
        host_name: "Laura",
        latitude: 45.44172,
        longitude: 12.33786,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33786, 45.44172]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3375827,
        name: "NEW!Room+bathroom in a private flat",
        host_id: 16946379,
        host_name: "Lolli",
        latitude: 45.43031,
        longitude: 12.32951,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32951, 45.43031]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3376807,
        name: "Ca' dei Mori apartment",
        host_id: 17026198,
        host_name: "Sergio",
        latitude: 45.4483,
        longitude: 12.3274,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3274, 45.4483]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3382998,
        name: "Ca’ Franchi 1st Floor",
        host_id: 17065883,
        host_name: "Martina",
        latitude: 45.43816,
        longitude: 12.34291,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34291, 45.43816]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3383300,
        name: "Ca’ Franchi 2nd Floor",
        host_id: 17065883,
        host_name: "Martina",
        latitude: 45.43681,
        longitude: 12.34206,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34206, 45.43681]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3407690,
        name: "Zattere Canal A - The place to be!",
        host_id: 12533143,
        host_name: "Zattere Venice Apartments",
        latitude: 45.42885,
        longitude: 12.32928,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32928, 45.42885]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3407702,
        name: "Le Guglie LT, Rooms in Venice",
        host_id: 2985972,
        host_name: "Paolo",
        latitude: 45.44356,
        longitude: 12.3245,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3245, 45.44356]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3409350,
        name: "Residenza Venier Accademia_Large 3-bedroom apart",
        host_id: 289615,
        host_name: "Valentina",
        latitude: 45.43112,
        longitude: 12.32872,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32872, 45.43112]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3418870,
        name: "ROMANTIC RUBINO ROOM WHIT PRIVATE BATHROOM",
        host_id: 5256801,
        host_name: "Giusy",
        latitude: 45.44462,
        longitude: 12.33034,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33034, 45.44462]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3419909,
        name: "Mansarda Venezia centro storico",
        host_id: 15737853,
        host_name: "Daniela",
        latitude: 45.44234,
        longitude: 12.32279,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32279, 45.44234]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3427877,
        name: "Ca'Martina",
        host_id: 17966260,
        host_name: "Riccardo, Flavio E Michela.",
        latitude: 45.44387,
        longitude: 12.32424,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32424, 45.44387]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3447247,
        name: "Large and bright apt with a nice view at Zattere",
        host_id: 17372862,
        host_name: "Isabella & Andrea",
        latitude: 45.43058,
        longitude: 12.32254,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32254, 45.43058]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3452436,
        name: "Cà Biennale: Breathe in the authentic Venice!",
        host_id: 17399577,
        host_name: "Fabrizio",
        latitude: 45.43171,
        longitude: 12.35481,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35481, 45.43171]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3481039,
        name: "Walk to St. Mark's Square from an Elegant Apartment",
        host_id: 17534457,
        host_name: "Abaca",
        latitude: 45.43449,
        longitude: 12.33986,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33986, 45.43449]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3492884,
        name: "Cozy room/private bathroom in the heart of Venice",
        host_id: 14143599,
        host_name: "Casa Frutariol",
        latitude: 45.44123,
        longitude: 12.33824,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33824, 45.44123]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3495320,
        name: "San Marco - Venetian Apartment",
        host_id: 2637692,
        host_name: "Patricia G.",
        latitude: 45.43226,
        longitude: 12.33023,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33023, 45.43226]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3509158,
        name: "Best View in Town Apartment",
        host_id: 17668611,
        host_name: "Francesca Maria Alagia",
        latitude: 45.44213,
        longitude: 12.33209,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33209, 45.44213]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3514186,
        name: "Ca' Terrazza Marcello",
        host_id: 15112827,
        host_name: "Marco",
        latitude: 45.43721,
        longitude: 12.3443,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3443, 45.43721]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3514340,
        name: "Ca' Canale View Elia",
        host_id: 15112827,
        host_name: "Marco",
        latitude: 45.43575,
        longitude: 12.34227,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34227, 45.43575]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3518072,
        name: "B&B Room in Venice close San Marco",
        host_id: 17596589,
        host_name: "Claudete & Andrea",
        latitude: 45.43543,
        longitude: 12.33924,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33924, 45.43543]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3527969,
        name: "VENICE CENTRE: Wi-Fi, Rialto, Air Conditioned",
        host_id: 17762135,
        host_name: "Edoardo",
        latitude: 45.43783,
        longitude: 12.34,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34, 45.43783]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3543279,
        name: "Santa Margherita Guesthouse double2",
        host_id: 4474459,
        host_name: "Maria Chiara",
        latitude: 45.43195,
        longitude: 12.32217,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32217, 45.43195]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3543396,
        name: "Ca' Flor pretty at Rialto Mercato",
        host_id: 3281444,
        host_name: "Attilio & Arelis",
        latitude: 45.43953,
        longitude: 12.332,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.332, 45.43953]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3552694,
        name: "MODERN, CENTRAL APARTMENT",
        host_id: 17885225,
        host_name: "Alessandro",
        latitude: 45.43409,
        longitude: 12.33285,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33285, 45.43409]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3553983,
        name: "Salute, Luxury House, Magic View",
        host_id: 17804789,
        host_name: "Marinella",
        latitude: 45.43089,
        longitude: 12.33508,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33508, 45.43089]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3559131,
        name: "Cozy apartment in Rialto market area, with terrace",
        host_id: 17918144,
        host_name: "Elisabetta",
        latitude: 45.43985,
        longitude: 12.33306,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33306, 45.43985]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3568445,
        name: "Ca'Letizia  - home sweet home",
        host_id: 17966260,
        host_name: "Riccardo, Flavio E Michela.",
        latitude: 45.44378,
        longitude: 12.32448,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32448, 45.44378]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3575716,
        name: "Elegant, in Historic Palazzo",
        host_id: 1229136,
        host_name: "Martina",
        latitude: 45.4331,
        longitude: 12.32866,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32866, 45.4331]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3576296,
        name: "SPLENDID STAR.....san mark's square",
        host_id: 1784535,
        host_name: "Monica",
        latitude: 45.43591,
        longitude: 12.33922,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33922, 45.43591]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3589795,
        name: "Venice little canal a/c wifi",
        host_id: 18084666,
        host_name: "Carlo Alberto",
        latitude: 45.44369,
        longitude: 12.33506,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33506, 45.44369]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3592563,
        name: "Canal view, central and spacious.",
        host_id: 5530875,
        host_name: "Maurizio",
        latitude: 45.43697,
        longitude: 12.34429,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34429, 45.43697]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3597934,
        name: "Central New Spacious Bright Apt",
        host_id: 5530875,
        host_name: "Maurizio",
        latitude: 45.43827,
        longitude: 12.34407,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34407, 45.43827]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3600493,
        name: "Spacious, bright, Giudecca Canal",
        host_id: 1258980,
        host_name: "Paolo",
        latitude: 45.42506,
        longitude: 12.32916,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32916, 45.42506]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3601326,
        name: "Typical restored Venetian apt | 5min | 1 min⛴",
        host_id: 9852012,
        host_name: "Paolo",
        latitude: 45.44417,
        longitude: 12.32697,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32697, 45.44417]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3602636,
        name: "Huge double room in Venice near train station",
        host_id: 18151381,
        host_name: "Fran",
        latitude: 45.43642,
        longitude: 12.31974,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31974, 45.43642]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3606859,
        name: "Santa Margherita Guesthouse double3",
        host_id: 4474459,
        host_name: "Maria Chiara",
        latitude: 45.43349,
        longitude: 12.32345,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32345, 45.43349]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3618533,
        name: "Santa Margherita Guesthouse single2",
        host_id: 4474459,
        host_name: "Maria Chiara",
        latitude: 45.43181,
        longitude: 12.32329,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32329, 45.43181]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3630373,
        name: "Home Venice Apartments - S. Marco 2",
        host_id: 7619802,
        host_name: "Stefania",
        latitude: 45.43467,
        longitude: 12.33401,
        beds: 7,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33401, 45.43467]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3634186,
        name: "Home Venice Apartments - S. Samuele",
        host_id: 7619802,
        host_name: "Stefania",
        latitude: 45.43407,
        longitude: 12.32878,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32878, 45.43407]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3640799,
        name: "Home Venice Apartments - Penthouse",
        host_id: 7619802,
        host_name: "Stefania",
        latitude: 45.43175,
        longitude: 12.33389,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33389, 45.43175]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3641725,
        name: "Ca’ Franchi",
        host_id: 17065883,
        host_name: "Martina",
        latitude: 45.43719,
        longitude: 12.34081,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34081, 45.43719]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3648454,
        name: "Santa Margherita Guesthouse single3",
        host_id: 4474459,
        host_name: "Maria Chiara",
        latitude: 45.43248,
        longitude: 12.3217,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3217, 45.43248]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3648689,
        name: "Venezia Biennale",
        host_id: 9593976,
        host_name: "Paola",
        latitude: 45.4351,
        longitude: 12.3565,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3565, 45.4351]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3649205,
        name: "Charming penthouse, Canal view!",
        host_id: 18030756,
        host_name: "Andrea",
        latitude: 45.43197,
        longitude: 12.32556,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32556, 45.43197]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3664940,
        name: "San Marco flat",
        host_id: 18582003,
        host_name: "Elena",
        latitude: 45.43437,
        longitude: 12.32972,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32972, 45.43437]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3670650,
        name: "Double Room, Venice Biennale.",
        host_id: 18629582,
        host_name: "Luigi",
        latitude: 45.43018,
        longitude: 12.35665,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35665, 45.43018]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3680628,
        name: "A super quiet Single room in Venice near Bus/Train",
        host_id: 18151381,
        host_name: "Fran",
        latitude: 45.4385,
        longitude: 12.32238,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32238, 45.4385]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3680697,
        name: "Apartment Ca' Regina",
        host_id: 13123519,
        host_name: "Enrico",
        latitude: 45.44098,
        longitude: 12.33056,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33056, 45.44098]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3682671,
        name: "CASAFURATOLA, in the heart of Venice",
        host_id: 18723296,
        host_name: "Mario",
        latitude: 45.43848,
        longitude: 12.33049,
        beds: 7,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33049, 45.43848]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3692698,
        name: "Ca' dell'Orsa",
        host_id: 10407435,
        host_name: "Orsetta",
        latitude: 45.4371,
        longitude: 12.34768,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34768, 45.4371]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3707848,
        name: "Casafuratolina, in the heart of Venice.",
        host_id: 18723296,
        host_name: "Mario",
        latitude: 45.43862,
        longitude: 12.33246,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33246, 45.43862]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3709382,
        name: "Tilly'sHouse tra Rialto e San Marco",
        host_id: 5990794,
        host_name: "Francesca",
        latitude: 45.4374,
        longitude: 12.33552,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33552, 45.4374]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3726455,
        name: "Da Carlo a Venezia",
        host_id: 19037111,
        host_name: "Elżbieta",
        latitude: 45.4376,
        longitude: 12.33057,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33057, 45.4376]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3733462,
        name: "Charming Apartment in Venetian Palace,Wifi,2 Rooms",
        host_id: 2508340,
        host_name: "Giacomo",
        latitude: 45.44501,
        longitude: 12.33144,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33144, 45.44501]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3736320,
        name: "Ca' ALLEGRA apartment near Rialto",
        host_id: 18717569,
        host_name: "Marzia",
        latitude: 45.43683,
        longitude: 12.33185,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33185, 45.43683]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3738786,
        name: "Residenza Tiziano App. Giorgia",
        host_id: 19112973,
        host_name: "Nicola",
        latitude: 45.4418,
        longitude: 12.34026,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34026, 45.4418]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3743534,
        name: "Residenza Tiziano App. Annalisa",
        host_id: 19112973,
        host_name: "Nicola",
        latitude: 45.44186,
        longitude: 12.33926,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33926, 45.44186]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3743704,
        name: "Residenza Tiziano App. Nicola",
        host_id: 19112973,
        host_name: "Nicola",
        latitude: 45.44171,
        longitude: 12.33906,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33906, 45.44171]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3753686,
        name: "Charming flat with channel view",
        host_id: 2508340,
        host_name: "Giacomo",
        latitude: 45.44411,
        longitude: 12.33322,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33322, 45.44411]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3756513,
        name: "Venice center, canal view Formula CAPPUCCINO",
        host_id: 6713218,
        host_name: "Hugues",
        latitude: 45.43842,
        longitude: 12.33939,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33939, 45.43842]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3769807,
        name: "NEW!VENICE 2 MINUTES FROM RIALTO BRIDGE!",
        host_id: 3215031,
        host_name: "Cristina",
        latitude: 45.43791,
        longitude: 12.33043,
        beds: 8,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33043, 45.43791]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3777330,
        name: "8 min Walk from Rialto, Ground floor, Canal View",
        host_id: 19371948,
        host_name: "Lotus Apartments Family",
        latitude: 45.44119,
        longitude: 12.34073,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34073, 45.44119]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3796400,
        name: "Secret garden with Grand Canal view",
        host_id: 1229136,
        host_name: "Martina",
        latitude: 45.43265,
        longitude: 12.32893,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32893, 45.43265]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3803768,
        name: "Appartamento Guglie",
        host_id: 19545904,
        host_name: "Marina",
        latitude: 45.4434,
        longitude: 12.32298,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32298, 45.4434]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3814415,
        name: "Bright apartment 5 min. Piazza S.Marco - Ca' Luca",
        host_id: 19610632,
        host_name: "Luca",
        latitude: 45.43566,
        longitude: 12.33428,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33428, 45.43566]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3823067,
        name: "Moisè Terrace! 90mt SMark's square!",
        host_id: 2360430,
        host_name: "Centrale Venice Apartments",
        latitude: 45.43396,
        longitude: 12.33727,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33727, 45.43396]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3824395,
        name: "Ca' Sambo- near s.mark square",
        host_id: 19675394,
        host_name: "Chahida",
        latitude: 45.43713,
        longitude: 12.34254,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34254, 45.43713]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3837352,
        name: "QUIET ROOM GREAT LOCATION PRIVATE TOILET A/C WI-FI",
        host_id: 18304362,
        host_name: "Eugenio",
        latitude: 45.44518,
        longitude: 12.32928,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32928, 45.44518]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3838589,
        name: "Suggestive dwelling in San Marco",
        host_id: 19745962,
        host_name: "Lidia",
        latitude: 45.43382,
        longitude: 12.33854,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33854, 45.43382]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3855355,
        name: "DolceVita Apartments N. 181 Canal View",
        host_id: 8176475,
        host_name: "Eugenia",
        latitude: 45.44118,
        longitude: 12.33,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33, 45.44118]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3882117,
        name: "Centre of Venice, St Mark's view",
        host_id: 19096219,
        host_name: "Jean-Luc",
        latitude: 45.43897,
        longitude: 12.33829,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33829, 45.43897]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3885539,
        name: "Canal view Dorsoduro Zattere",
        host_id: 20093194,
        host_name: "Gabriele Maria",
        latitude: 45.4315,
        longitude: 12.3231,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3231, 45.4315]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3889652,
        name: "Giudecca Lovely flat",
        host_id: 20123184,
        host_name: "Claudia",
        latitude: 45.42367,
        longitude: 12.32792,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32792, 45.42367]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3901271,
        name: "cosy apartment close to Biennale",
        host_id: 19884716,
        host_name: "Giannunzio",
        latitude: 45.43244,
        longitude: 12.35358,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35358, 45.43244]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3904432,
        name: "Apartment Ca' Petrona",
        host_id: 20219231,
        host_name: "Mara E Federica",
        latitude: 45.44547,
        longitude: 12.32166,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32166, 45.44547]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3908933,
        name: "SECRET GARDEN house near laBiennale",
        host_id: 1438903,
        host_name: "Barbara",
        latitude: 45.4337,
        longitude: 12.3559,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3559, 45.4337]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3919893,
        name: "CA' DONA' DEL SPEZIER - Venice city center - ITALY",
        host_id: 11796928,
        host_name: "Alessandra",
        latitude: 45.4379,
        longitude: 12.32712,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32712, 45.4379]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3920220,
        name: "Ai Tagliapietra - Room 1",
        host_id: 20307522,
        host_name: "Lorenzo",
        latitude: 45.43642,
        longitude: 12.34212,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34212, 45.43642]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3934281,
        name:
          "Condo with two balconies and a wonderful, walkable Cannaregio location!",
        host_id: 4339678,
        host_name: "Vacasa Italy - Venice",
        latitude: 45.4444,
        longitude: 12.32374,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32374, 45.4444]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3936277,
        name: "L'altalena di Francesca",
        host_id: 745553,
        host_name: "Rosanna E Francesca",
        latitude: 45.44115,
        longitude: 12.33803,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33803, 45.44115]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3942663,
        name: "Venice Friends",
        host_id: 13027859,
        host_name: "Diego",
        latitude: 45.44407,
        longitude: 12.32809,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32809, 45.44407]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3988503,
        name: "Cosy, truly Venetian St.Mark's area - Greci X3102",
        host_id: 15178567,
        host_name: "Paolo",
        latitude: 45.43683,
        longitude: 12.33851,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33851, 45.43683]] },
    },
    {
      type: "Feature",
      properties: {
        id: 3991760,
        name: "The Dodi house",
        host_id: 20505521,
        host_name: "Donatella",
        latitude: 45.44746,
        longitude: 12.32916,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32916, 45.44746]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4010808,
        name: "Penthouse in Palazzo Albrizzi",
        host_id: 20795699,
        host_name: "Orsola",
        latitude: 45.43803,
        longitude: 12.33205,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33205, 45.43803]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4012810,
        name: "Luxury house canal view, terrace",
        host_id: 20806023,
        host_name: "Alice",
        latitude: 45.4417,
        longitude: 12.33875,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33875, 45.4417]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4012955,
        name:
          "Cozy Nest In The Heart Of Rialto M (Phone number hidden by Airbnb)",
        host_id: 20806166,
        host_name: "Giovanna",
        latitude: 45.43892,
        longitude: 12.33087,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33087, 45.43892]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4019505,
        name: "Ca San Simeon",
        host_id: 20839943,
        host_name: "Costante",
        latitude: 45.44052,
        longitude: 12.32426,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32426, 45.44052]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4020175,
        name: "Close to San Marco - CANAL VIEW",
        host_id: 289615,
        host_name: "Valentina",
        latitude: 45.43605,
        longitude: 12.34642,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34642, 45.43605]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4027439,
        name:
          "Elegant first-floor condo with great perks right in the heart of Venice!",
        host_id: 4339678,
        host_name: "Vacasa Italy - Venice",
        latitude: 45.43786,
        longitude: 12.33769,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33769, 45.43786]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4035865,
        name: "A rare villa with exclusive garden",
        host_id: 20924947,
        host_name: "Pierpaolo",
        latitude: 45.43849,
        longitude: 12.34907,
        beds: 8,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34907, 45.43849]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4044438,
        name: "Ca' Barba B&B: Jacuzzi room (Jacuzzi bath tub)",
        host_id: 214390,
        host_name: "Alessandro",
        latitude: 45.44004,
        longitude: 12.33169,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33169, 45.44004]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4046874,
        name: "Ciprea - room oriente",
        host_id: 20983059,
        host_name: "Ciprea",
        latitude: 45.43039,
        longitude: 12.35782,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35782, 45.43039]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4054500,
        name: "Colorful Apartment Overlooking the Rio Marin Canal",
        host_id: 21027135,
        host_name: "Elena",
        latitude: 45.44051,
        longitude: 12.32514,
        beds: 7,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32514, 45.44051]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4067549,
        name: "Deluxe Apartment",
        host_id: 21094861,
        host_name: "Alberto",
        latitude: 45.44439,
        longitude: 12.33411,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33411, 45.44439]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4071362,
        name: "Accademia: oriental style house",
        host_id: 21042251,
        host_name: "Luka",
        latitude: 45.4298,
        longitude: 12.33192,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33192, 45.4298]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4091007,
        name: "Dorsoduro Romantic Suite",
        host_id: 9899783,
        host_name: "Sarah",
        latitude: 45.43466,
        longitude: 12.31709,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31709, 45.43466]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4097464,
        name: "Bragora apartment",
        host_id: 7619802,
        host_name: "Stefania",
        latitude: 45.43495,
        longitude: 12.34901,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34901, 45.43495]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4140009,
        name: "STELLA MARINA 1  APARTMENT",
        host_id: 21356512,
        host_name: "Cristina",
        latitude: 45.42713,
        longitude: 12.3199,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3199, 45.42713]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4141116,
        name: "Ai Tagliapietra - Room 2",
        host_id: 20307522,
        host_name: "Lorenzo",
        latitude: 45.43575,
        longitude: 12.34179,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34179, 45.43575]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4141310,
        name: "Ai Tagliapietra - Room 3",
        host_id: 20307522,
        host_name: "Lorenzo",
        latitude: 45.43662,
        longitude: 12.34251,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34251, 45.43662]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4144479,
        name: "CIPREA camera ASTRATTA",
        host_id: 20983059,
        host_name: "Ciprea",
        latitude: 45.4322,
        longitude: 12.35657,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35657, 45.4322]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4146739,
        name: "Palazzetto da Schio - Apartment with Garden View",
        host_id: 13213656,
        host_name: "Elisabetta",
        latitude: 45.42939,
        longitude: 12.33379,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33379, 45.42939]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4148935,
        name: "Wonderful canal view in the center!",
        host_id: 18030756,
        host_name: "Andrea",
        latitude: 45.42977,
        longitude: 12.32519,
        beds: 7,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32519, 45.42977]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4149640,
        name: "Lovely studio in a Venice historical palace",
        host_id: 6019189,
        host_name: "Federico",
        latitude: 45.4415,
        longitude: 12.32811,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32811, 45.4415]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4169522,
        name: "Your home in quiet neighborhood",
        host_id: 2847482,
        host_name: "Maria",
        latitude: 45.447,
        longitude: 12.31975,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31975, 45.447]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4170994,
        name: "Magia veneziana studio",
        host_id: 21643715,
        host_name: "Silvia",
        latitude: 45.44257,
        longitude: 12.33912,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33912, 45.44257]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4181213,
        name: "Apartment Cà Rielo - Venice",
        host_id: 21690597,
        host_name: "Alessandro & Roberto",
        latitude: 45.44438,
        longitude: 12.32256,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32256, 45.44438]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4181499,
        name: "BIENNALE - Sant’Elena Park - 3 Bedrooms",
        host_id: 393913,
        host_name: "Luca",
        latitude: 45.42677,
        longitude: 12.35953,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35953, 45.42677]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4184907,
        name: "Shepard from Venice italy HI :-)",
        host_id: 21712800,
        host_name: "Shepard",
        latitude: 45.42909,
        longitude: 12.33098,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33098, 45.42909]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4188698,
        name: "Accademia - San Vio Apartment",
        host_id: 21725384,
        host_name: "Mattia",
        latitude: 45.42924,
        longitude: 12.32942,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32942, 45.42924]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4200733,
        name: "Ca' Lezze, in the heart of Venice",
        host_id: 21794895,
        host_name: "Rodolfo",
        latitude: 45.44242,
        longitude: 12.33343,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33343, 45.44242]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4211904,
        name: "BETWEEN RIALTO AND ST. MARK SQUARE",
        host_id: 21858179,
        host_name: "Boneve",
        latitude: 45.43708,
        longitude: 12.33938,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33938, 45.43708]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4212580,
        name: "Fenice Theater near the old theater",
        host_id: 21861574,
        host_name: "Valentino",
        latitude: 45.43402,
        longitude: 12.33266,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33266, 45.43402]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4214105,
        name: "S. Marco/Biennale Boutique Apartment",
        host_id: 21869007,
        host_name: "Eleonora",
        latitude: 45.43595,
        longitude: 12.34813,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34813, 45.43595]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4216103,
        name: "Maschere Venezia",
        host_id: 1974309,
        host_name: "Anna",
        latitude: 45.44096,
        longitude: 12.33009,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33009, 45.44096]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4216893,
        name: "Cozy 1bed, great location, sea view",
        host_id: 21885006,
        host_name: "Lisa",
        latitude: 45.44711,
        longitude: 12.31973,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31973, 45.44711]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4256418,
        name: "Beautiful Building with canal view!",
        host_id: 18030756,
        host_name: "Andrea",
        latitude: 45.43019,
        longitude: 12.32495,
        beds: 12,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32495, 45.43019]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4259339,
        name: "Ca' Maddalena B&B - Princess room",
        host_id: 22106152,
        host_name: "Ivonne",
        latitude: 45.44136,
        longitude: 12.34015,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34015, 45.44136]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4272477,
        name: "Palazzetto da Schio Apartment with Canal View",
        host_id: 13213656,
        host_name: "Elisabetta",
        latitude: 45.43015,
        longitude: 12.33224,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33224, 45.43015]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4272967,
        name: "Attic with big  terrace in Giudecca",
        host_id: 22184649,
        host_name: "Marianna",
        latitude: 45.42434,
        longitude: 12.32632,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32632, 45.42434]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4275704,
        name: "Al Campiello dei Meloni",
        host_id: 22197834,
        host_name: "Davide",
        latitude: 45.43764,
        longitude: 12.33029,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33029, 45.43764]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4290117,
        name: "DIMORA 900 elegant 3 bed room apartment",
        host_id: 745553,
        host_name: "Rosanna E Francesca",
        latitude: 45.44164,
        longitude: 12.34025,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34025, 45.44164]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4297779,
        name: "CASADUEOTTANTA fra arte e  biennale",
        host_id: 22155496,
        host_name: "Sonia",
        latitude: 45.43398,
        longitude: 12.35855,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35855, 45.43398]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4301644,
        name: "Beautiful apartment in Palace",
        host_id: 22328563,
        host_name: "Marcella",
        latitude: 45.44238,
        longitude: 12.33731,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33731, 45.44238]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4314809,
        name: "VENICE CENTRE: Wi-Fi, Rialto, Air Conditioned",
        host_id: 17762135,
        host_name: "Edoardo",
        latitude: 45.43853,
        longitude: 12.33339,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33339, 45.43853]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4327560,
        name: "Palazzetto da Schio - Top Floor with Canal View",
        host_id: 13213656,
        host_name: "Elisabetta",
        latitude: 45.42951,
        longitude: 12.33354,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33354, 45.42951]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4329456,
        name: "Blue Room",
        host_id: 22106152,
        host_name: "Ivonne",
        latitude: 45.44091,
        longitude: 12.33824,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33824, 45.44091]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4329471,
        name: "Pink Room",
        host_id: 22106152,
        host_name: "Ivonne",
        latitude: 45.44177,
        longitude: 12.33867,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33867, 45.44177]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4339964,
        name: "MAESTRALE, btw S.Marco and Rialto.",
        host_id: 21835799,
        host_name: "Martina",
        latitude: 45.43903,
        longitude: 12.34244,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34244, 45.43903]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4341401,
        name: "Most convenient apartment in Venice",
        host_id: 20580554,
        host_name: "Caroline & Jacopo",
        latitude: 45.44304,
        longitude: 12.32114,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32114, 45.44304]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4345878,
        name: "LIBECCIO, btw S.Marco and Rialto.",
        host_id: 21835799,
        host_name: "Martina",
        latitude: 45.43611,
        longitude: 12.3513,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3513, 45.43611]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4346537,
        name: "Palazzetto da Schio - Top Floor with Garden View",
        host_id: 13213656,
        host_name: "Elisabetta",
        latitude: 45.43033,
        longitude: 12.33296,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33296, 45.43033]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4358462,
        name: "A VENICE HOME",
        host_id: 22623713,
        host_name: "Rupu",
        latitude: 45.43748,
        longitude: 12.33443,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33443, 45.43748]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4360846,
        name: "Venice Rainbow Apartment (Rialto 1)",
        host_id: 22623713,
        host_name: "Rupu",
        latitude: 45.43921,
        longitude: 12.33411,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33411, 45.43921]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4362378,
        name: "SANTI APOSTOLI - Duplex flat with 2 bathrooms",
        host_id: 10189388,
        host_name: "Raffaella",
        latitude: 45.44174,
        longitude: 12.33609,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33609, 45.44174]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4382011,
        name: "CA' ELENA - apt con ascensore vicino a F.Nove",
        host_id: 10189388,
        host_name: "Raffaella",
        latitude: 45.44116,
        longitude: 12.34055,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34055, 45.44116]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4382392,
        name: "Ca' San Silvestro",
        host_id: 10692765,
        host_name: "Laura",
        latitude: 45.43855,
        longitude: 12.33387,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33387, 45.43855]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4382992,
        name: "Luxury Loft in Venice Cannareggio",
        host_id: 3809491,
        host_name: "Pierluigi",
        latitude: 45.44228,
        longitude: 12.33916,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33916, 45.44228]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4401635,
        name: "B&B in centro storico venezia",
        host_id: 22848495,
        host_name: "Francesco",
        latitude: 45.44245,
        longitude: 12.33431,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33431, 45.44245]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4401688,
        name: "atmosfera veneziana",
        host_id: 22848495,
        host_name: "Francesco",
        latitude: 45.44262,
        longitude: 12.33538,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33538, 45.44262]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4405965,
        name: "Ca' del Sorriso - the smiling house",
        host_id: 22872469,
        host_name: "Marzia",
        latitude: 45.43322,
        longitude: 12.31851,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31851, 45.43322]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4406889,
        name: "Gran Canal nice apartment",
        host_id: 22876518,
        host_name: "Stefania",
        latitude: 45.43233,
        longitude: 12.33015,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33015, 45.43233]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4407302,
        name: "Ognissanti Terrace IP (Phone number hidden by Airbnb)",
        host_id: 15005402,
        host_name: "Veronica",
        latitude: 45.43035,
        longitude: 12.32494,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32494, 45.43035]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4407688,
        name: "Casa Marcorà IP (Phone number hidden by Airbnb)",
        host_id: 15005402,
        host_name: "Veronica",
        latitude: 45.4327,
        longitude: 12.35203,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35203, 45.4327]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4407941,
        name: "Al Mercà Holidays",
        host_id: 15005402,
        host_name: "Veronica",
        latitude: 45.43858,
        longitude: 12.33353,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33353, 45.43858]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4408634,
        name: "Bright and clean room, amazing view",
        host_id: 22884126,
        host_name: "Giugi",
        latitude: 45.43899,
        longitude: 12.33992,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33992, 45.43899]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4408968,
        name: "Marina IP (Phone number hidden by Airbnb)",
        host_id: 15005402,
        host_name: "Veronica",
        latitude: 45.43152,
        longitude: 12.35759,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35759, 45.43152]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4416010,
        name: "Venice Romantic home .. lovely view",
        host_id: 22921103,
        host_name: "Andrea",
        latitude: 45.43735,
        longitude: 12.32556,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32556, 45.43735]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4419716,
        name: "Pure Elegance in the ♥ of Venice",
        host_id: 22942494,
        host_name: "Daniela",
        latitude: 45.4396,
        longitude: 12.33892,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33892, 45.4396]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4425500,
        name: "Marco Polo room,Biennale of Art,Venice",
        host_id: 22974469,
        host_name: "Fede",
        latitude: 45.43159,
        longitude: 12.35683,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35683, 45.43159]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4432891,
        name: "Angelo Raffaele(university)",
        host_id: 23013624,
        host_name: "Federica",
        latitude: 45.43354,
        longitude: 12.31675,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31675, 45.43354]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4435305,
        name: "Lovely studio in a superb spot",
        host_id: 13454405,
        host_name: "Laleh",
        latitude: 45.43088,
        longitude: 12.33484,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33484, 45.43088]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4435966,
        name: "Canaletto Room, Biennal of Art, Venice",
        host_id: 22974469,
        host_name: "Fede",
        latitude: 45.42995,
        longitude: 12.35813,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35813, 45.42995]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4436167,
        name: "Art Decò Room,Venice Biennal of Art",
        host_id: 22974469,
        host_name: "Fede",
        latitude: 45.43207,
        longitude: 12.35636,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35636, 45.43207]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4444685,
        name: "Ca Cristallina a 5 minuti da Rialto",
        host_id: 1759757,
        host_name: "Sara&Luca",
        latitude: 45.43783,
        longitude: 12.32776,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32776, 45.43783]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4446013,
        name: "Casanpietro",
        host_id: 16737858,
        host_name: "Marta",
        latitude: 45.43258,
        longitude: 12.36009,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.36009, 45.43258]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4460925,
        name: "5 MINUTES WALK FROM ST. MARK SQUARE",
        host_id: 19221008,
        host_name: "Olimpia",
        latitude: 45.43955,
        longitude: 12.33181,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33181, 45.43955]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4468071,
        name: "Favolosa stanza con vista  in VENICE Home lovers",
        host_id: 23182155,
        host_name: "Stefano Roberta",
        latitude: 45.43786,
        longitude: 12.32613,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32613, 45.43786]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4471990,
        name: "Home Venice Apartments - Piazzale Roma",
        host_id: 7619802,
        host_name: "Stefania",
        latitude: 45.43764,
        longitude: 12.31886,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31886, 45.43764]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4473558,
        name: "Leoncini flat with a nice canal view",
        host_id: 16705466,
        host_name: "Nikos",
        latitude: 45.43552,
        longitude: 12.34231,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34231, 45.43552]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4487318,
        name: "APARTMENT STELLA MARINA 2",
        host_id: 21356512,
        host_name: "Cristina",
        latitude: 45.42794,
        longitude: 12.31995,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31995, 45.42794]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4487570,
        name: "ALI: Your Home in Venice!",
        host_id: 21156523,
        host_name: "Nicoletta",
        latitude: 45.43687,
        longitude: 12.34268,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34268, 45.43687]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4497116,
        name: "Cozy flat in St Mark",
        host_id: 2227088,
        host_name: "Gabriele",
        latitude: 45.43213,
        longitude: 12.32988,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32988, 45.43213]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4497821,
        name:
          "Modern flat in the center of Venice ID M (Phone number hidden by Airbnb)",
        host_id: 2227088,
        host_name: "Gabriele",
        latitude: 45.43291,
        longitude: 12.32901,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32901, 45.43291]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4499785,
        name: "Ca' Tron Apartment, next to Rialto",
        host_id: 23338072,
        host_name: "Orfeo",
        latitude: 45.44067,
        longitude: 12.32899,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32899, 45.44067]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4505209,
        name: "Casa del Pittore Rialto (L.T. M (Phone number hidden by Airbnb)",
        host_id: 5618111,
        host_name: "EasySuite",
        latitude: 45.43974,
        longitude: 12.33729,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33729, 45.43974]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4505994,
        name: "GLAMOR APARTMENT AT ST.MARCO SQUARE",
        host_id: 23367216,
        host_name: "Romy",
        latitude: 45.4358,
        longitude: 12.33768,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33768, 45.4358]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4506282,
        name: "CHARM ROOM IN SAN MARCO SQUARE",
        host_id: 23367216,
        host_name: "Romy",
        latitude: 45.43722,
        longitude: 12.33644,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33644, 45.43722]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4506718,
        name: "BEAUTIFUL RELAX ACCADEMIA WIFI",
        host_id: 23370300,
        host_name: "Anna",
        latitude: 45.42982,
        longitude: 12.33003,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33003, 45.42982]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4512782,
        name: "LUXURY APARTMENT WITH AMAZING VIEW",
        host_id: 23399965,
        host_name: "Laura",
        latitude: 45.44332,
        longitude: 12.33226,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33226, 45.44332]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4513560,
        name: "Casa Lia (L.T. M (Phone number hidden by Airbnb)",
        host_id: 5618111,
        host_name: "EasySuite",
        latitude: 45.44009,
        longitude: 12.33649,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33649, 45.44009]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4513792,
        name: "Cà Aldo",
        host_id: 294951,
        host_name: "VeniceVillas Di Enzo",
        latitude: 45.43515,
        longitude: 12.34919,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34919, 45.43515]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4514733,
        name: "Feel at home in Venice!",
        host_id: 21156523,
        host_name: "Nicoletta",
        latitude: 45.4364,
        longitude: 12.34269,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34269, 45.4364]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4515452,
        name: "Attic suite with turret to Sts John and Paul",
        host_id: 19197376,
        host_name: "Adriana",
        latitude: 45.43896,
        longitude: 12.3435,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3435, 45.43896]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4523238,
        name: "RESIDENZA CAMPIELLO: luxury and free wi-fi",
        host_id: 3736168,
        host_name: "EasyRentals",
        latitude: 45.443,
        longitude: 12.32291,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32291, 45.443]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4524630,
        name: "The Arsenal flat",
        host_id: 3972291,
        host_name: "Caroline E Marco",
        latitude: 45.4347,
        longitude: 12.34772,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34772, 45.4347]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4529183,
        name: "GRAND CANAL TERRASSE",
        host_id: 22427385,
        host_name: "François",
        latitude: 45.43645,
        longitude: 12.33101,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33101, 45.43645]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4530043,
        name: "Palazzina Canal",
        host_id: 3972291,
        host_name: "Caroline E Marco",
        latitude: 45.44551,
        longitude: 12.32394,
        beds: 7,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32394, 45.44551]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4533866,
        name: "Accogliente casa di fronte a ghetto",
        host_id: 23508755,
        host_name: "Jacopo",
        latitude: 45.44686,
        longitude: 12.32781,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32781, 45.44686]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4544830,
        name: "CA' SOLE - Bright and charming apartment.",
        host_id: 10189388,
        host_name: "Raffaella",
        latitude: 45.44419,
        longitude: 12.33052,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33052, 45.44419]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4545577,
        name: "Ca' Coriandolo",
        host_id: 3972291,
        host_name: "Caroline E Marco",
        latitude: 45.43167,
        longitude: 12.32986,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32986, 45.43167]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4551974,
        name: "Apartment next to St. Mark's Square",
        host_id: 17043681,
        host_name: "Riccardo",
        latitude: 45.43546,
        longitude: 12.3412,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3412, 45.43546]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4560040,
        name: "Charming house in  Venice",
        host_id: 23508755,
        host_name: "Jacopo",
        latitude: 45.447,
        longitude: 12.32713,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32713, 45.447]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4563340,
        name: "Ca'Affresco",
        host_id: 3972291,
        host_name: "Caroline E Marco",
        latitude: 45.4331,
        longitude: 12.3315,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3315, 45.4331]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4568790,
        name: "ROOM IN guest house",
        host_id: 23652890,
        host_name: "Paolo",
        latitude: 45.43927,
        longitude: 12.33304,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33304, 45.43927]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4570139,
        name: "Lion's APT1",
        host_id: 3972291,
        host_name: "Caroline E Marco",
        latitude: 45.43659,
        longitude: 12.33929,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33929, 45.43659]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4571548,
        name: "Lion's 2",
        host_id: 3972291,
        host_name: "Caroline E Marco",
        latitude: 45.43719,
        longitude: 12.33818,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33818, 45.43719]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4571920,
        name: "Lion's 3",
        host_id: 3972291,
        host_name: "Caroline E Marco",
        latitude: 45.43824,
        longitude: 12.33822,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33822, 45.43824]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4572214,
        name: "Lion's 4",
        host_id: 3972291,
        host_name: "Caroline E Marco",
        latitude: 45.43689,
        longitude: 12.3381,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3381, 45.43689]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4572534,
        name: "Lion's 5",
        host_id: 3972291,
        host_name: "Caroline E Marco",
        latitude: 45.43843,
        longitude: 12.33856,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33856, 45.43843]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4572750,
        name: "Casa dell'albero",
        host_id: 3972291,
        host_name: "Caroline E Marco",
        latitude: 45.43425,
        longitude: 12.33179,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33179, 45.43425]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4578851,
        name: "Ca' Rialtina",
        host_id: 3972291,
        host_name: "Caroline E Marco",
        latitude: 45.44061,
        longitude: 12.33175,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33175, 45.44061]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4578969,
        name: "Viva Venezia2",
        host_id: 23736982,
        host_name: "Franco",
        latitude: 45.44025,
        longitude: 12.32483,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32483, 45.44025]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4580110,
        name: "Viva Venezia3",
        host_id: 23736982,
        host_name: "Franco",
        latitude: 45.44072,
        longitude: 12.32513,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32513, 45.44072]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4583866,
        name: "Rialto (URL HIDDEN) the very heart",
        host_id: 1784535,
        host_name: "Monica",
        latitude: 45.4381,
        longitude: 12.33262,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33262, 45.4381]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4584355,
        name: "CA'ORLINA  Terraced apt between St.Mark and Rialto",
        host_id: 10189388,
        host_name: "Raffaella",
        latitude: 45.43543,
        longitude: 12.33916,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33916, 45.43543]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4590242,
        name: "Rialto  IP (Phone number hidden by Airbnb)",
        host_id: 15005402,
        host_name: "Veronica",
        latitude: 45.43686,
        longitude: 12.33662,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33662, 45.43686]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4590495,
        name: "Al Pozzo",
        host_id: 15005402,
        host_name: "Veronica",
        latitude: 45.43643,
        longitude: 12.32528,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32528, 45.43643]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4611618,
        name:
          "Ambiente appartato in vecchia zona industriale nell'isola della Giudecca",
        host_id: 21356512,
        host_name: "Cristina",
        latitude: 45.42638,
        longitude: 12.3218,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3218, 45.42638]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4614539,
        name: "Lovely apartment near St.Mark",
        host_id: 23861816,
        host_name: "Martina",
        latitude: 45.43192,
        longitude: 12.33268,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33268, 45.43192]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4626689,
        name: "Panoramic and bright Room",
        host_id: 22884126,
        host_name: "Giugi",
        latitude: 45.43746,
        longitude: 12.34048,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34048, 45.43746]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4634873,
        name: "viva venezia1",
        host_id: 23736982,
        host_name: "Franco",
        latitude: 45.44172,
        longitude: 12.32647,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32647, 45.44172]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4646641,
        name: "SMALL, COZY, CHEAP APARTMENT-STUDIO",
        host_id: 3880254,
        host_name: "Sabina",
        latitude: 45.43715,
        longitude: 12.32307,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32307, 45.43715]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4648945,
        name: "GESUITI CANNAREGIO - CHARMING APT",
        host_id: 17636637,
        host_name: "Gloria",
        latitude: 45.4422,
        longitude: 12.33993,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33993, 45.4422]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4673240,
        name: "Splendido piano nobile di palazzo",
        host_id: 24174921,
        host_name: "Fulvio",
        latitude: 45.43888,
        longitude: 12.33975,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33975, 45.43888]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4674092,
        name: "ACCADEMIA",
        host_id: 15337957,
        host_name: "Marie",
        latitude: 45.433,
        longitude: 12.32952,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32952, 45.433]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4684475,
        name: "Bellissima abitazione all'Accademia",
        host_id: 24222520,
        host_name: "Daniela",
        latitude: 45.43362,
        longitude: 12.32527,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32527, 45.43362]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4693096,
        name: "Bellissimo appartamento con Altana",
        host_id: 24222520,
        host_name: "Daniela",
        latitude: 45.43251,
        longitude: 12.326,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.326, 45.43251]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4707790,
        name: "Large room in Venice king size bed near bus/train",
        host_id: 18151381,
        host_name: "Fran",
        latitude: 45.43631,
        longitude: 12.33662,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33662, 45.43631]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4725205,
        name: "Modern house in the heart of Venice",
        host_id: 23508755,
        host_name: "Jacopo",
        latitude: 45.44262,
        longitude: 12.33205,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33205, 45.44262]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4759059,
        name: "Venezia laterale",
        host_id: 3859281,
        host_name: "Adriano",
        latitude: 45.42391,
        longitude: 12.32463,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32463, 45.42391]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4762056,
        name: "Procuratie Uno, Elegant and Bright Apartment in Cannaregio",
        host_id: 24571049,
        host_name: "Simone",
        latitude: 45.44326,
        longitude: 12.32522,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32522, 45.44326]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4762721,
        name: "GUARDI - Cosy flat near Biennale and San Marco",
        host_id: 10189388,
        host_name: "Raffaella",
        latitude: 45.43615,
        longitude: 12.34754,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34754, 45.43615]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4763093,
        name: "Mansard/studio flat in Venice",
        host_id: 24575730,
        host_name: "Donata",
        latitude: 45.43866,
        longitude: 12.31797,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31797, 45.43866]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4769375,
        name: "Charming apartment in the heart of Venice",
        host_id: 4650509,
        host_name: "Alvise",
        latitude: 45.43371,
        longitude: 12.35246,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35246, 45.43371]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4771629,
        name: "SCALA REALE - Terraced apartment near to Casino'",
        host_id: 10189388,
        host_name: "Raffaella",
        latitude: 45.4429,
        longitude: 12.33133,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33133, 45.4429]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4790802,
        name: "Design LOFT Rialto & Ca d'Oro",
        host_id: 20093194,
        host_name: "Gabriele Maria",
        latitude: 45.44355,
        longitude: 12.33701,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33701, 45.44355]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4791402,
        name: "Venice, your home!",
        host_id: 16314125,
        host_name: "Elena",
        latitude: 45.43344,
        longitude: 12.32174,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32174, 45.43344]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4796852,
        name: "Nice holiday apartment in Venice - San Polo, Frari",
        host_id: 24719172,
        host_name: "Carlotta",
        latitude: 45.43887,
        longitude: 12.32715,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32715, 45.43887]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4798589,
        name: "Beautiful house in Venice",
        host_id: 23508755,
        host_name: "Jacopo",
        latitude: 45.44423,
        longitude: 12.33265,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33265, 45.44423]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4799644,
        name: "Cà del Fotografo 2 Bedroom in Strada Nuova",
        host_id: 709828,
        host_name: "Roberto",
        latitude: 45.44031,
        longitude: 12.3353,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3353, 45.44031]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4822413,
        name: "Venice San Marco -Palazzo Grassi- Central location",
        host_id: 24729479,
        host_name: "Marina",
        latitude: 45.43311,
        longitude: 12.32907,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32907, 45.43311]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4836068,
        name: "Casa Chiara in a quiet neiborhoud near Biennale",
        host_id: 19860943,
        host_name: "Rita",
        latitude: 45.43187,
        longitude: 12.35187,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35187, 45.43187]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4836518,
        name: "Casa Serena in a quiet neiborhoud near Biennale",
        host_id: 19860943,
        host_name: "Rita",
        latitude: 45.43386,
        longitude: 12.35138,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35138, 45.43386]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4838167,
        name: "appartement dans palais venitien",
        host_id: 24900597,
        host_name: "Pierre",
        latitude: 45.43754,
        longitude: 12.34862,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34862, 45.43754]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4846915,
        name: "Ve-nice Suite Apartment SM2019",
        host_id: 22423242,
        host_name: "Stefano",
        latitude: 45.43256,
        longitude: 12.3336,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3336, 45.43256]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4856067,
        name: "★★威尼斯水城客房1 ★★强烈推荐 ♥♥威尼斯华人旅馆",
        host_id: 10779919,
        host_name: "威尼斯意家缘旅馆",
        latitude: 45.43169,
        longitude: 12.35254,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35254, 45.43169]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4856323,
        name: "★★威尼斯水城客房2 ★★强烈推荐!♥♥威尼斯华人旅馆",
        host_id: 10779919,
        host_name: "威尼斯意家缘旅馆",
        latitude: 45.43217,
        longitude: 12.35083,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35083, 45.43217]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4862345,
        name: "Ca' D'oro",
        host_id: 24934729,
        host_name: "Angelo",
        latitude: 45.44328,
        longitude: 12.32716,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32716, 45.44328]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4867548,
        name: "Nice room in the city center",
        host_id: 4635177,
        host_name: "Paolo",
        latitude: 45.43978,
        longitude: 12.32366,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32366, 45.43978]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4867567,
        name: "MODERN, DIFFERENT, CENTRAL",
        host_id: 25037552,
        host_name: "Elisabetta",
        latitude: 45.43725,
        longitude: 12.33861,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33861, 45.43725]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4870149,
        name: "QUIET ROOM WITH TERRACE PERFECT LOCATION A/C -WiFi",
        host_id: 18304362,
        host_name: "Eugenio",
        latitude: 45.4458,
        longitude: 12.32792,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32792, 45.4458]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4871612,
        name: "Ca' Laura Suite local quiet and peaceful",
        host_id: 24816549,
        host_name: "Francesca E Cristian",
        latitude: 45.43507,
        longitude: 12.34904,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34904, 45.43507]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4877650,
        name: "Centralissimo Ca' Sant' Angelo",
        host_id: 16267348,
        host_name: "Elisabetta",
        latitude: 45.43304,
        longitude: 12.33355,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33355, 45.43304]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4878696,
        name: "Frari Apartment",
        host_id: 5857136,
        host_name: "Mirco",
        latitude: 45.43677,
        longitude: 12.32875,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32875, 45.43677]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4883419,
        name: "Canal View Arsenal Entrance 110 sqm",
        host_id: 25123388,
        host_name: "Olivier",
        latitude: 45.43582,
        longitude: 12.35035,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35035, 45.43582]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4884247,
        name: "Sunny room",
        host_id: 4635177,
        host_name: "Paolo",
        latitude: 45.43942,
        longitude: 12.32533,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32533, 45.43942]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4889387,
        name: "Wonderful central flat",
        host_id: 25156218,
        host_name: "Francesca",
        latitude: 45.43958,
        longitude: 12.33912,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33912, 45.43958]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4890371,
        name: "Amazing attic studio",
        host_id: 25156218,
        host_name: "Francesca",
        latitude: 45.43876,
        longitude: 12.33873,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33873, 45.43876]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4904112,
        name: "Ca' San Marco, 20 meters from San Mark Square!",
        host_id: 12113015,
        host_name: "Mario",
        latitude: 45.43484,
        longitude: 12.34095,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34095, 45.43484]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4908278,
        name: "Art Biennale apartment",
        host_id: 25271330,
        host_name: "Alex",
        latitude: 45.43121,
        longitude: 12.3551,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3551, 45.43121]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4913978,
        name: "DIMORA TIPICA VENEZIANA",
        host_id: 25305665,
        host_name: "Silvana",
        latitude: 45.44071,
        longitude: 12.34151,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34151, 45.44071]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4919531,
        name: "B&B Emimì, comfort and independence",
        host_id: 25338050,
        host_name: "Caterina",
        latitude: 45.43752,
        longitude: 12.32368,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32368, 45.43752]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4921887,
        name: "B&B S.Stae - (flying bird room)",
        host_id: 25350552,
        host_name: "Genovina",
        latitude: 45.44165,
        longitude: 12.32984,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32984, 45.44165]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4929237,
        name: "between Biennale and San Marco square",
        host_id: 619545,
        host_name: "Silvia",
        latitude: 45.43496,
        longitude: 12.34762,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34762, 45.43496]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4944127,
        name: "Anonimo Veneziano Suite",
        host_id: 9899783,
        host_name: "Sarah",
        latitude: 45.4348,
        longitude: 12.31782,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31782, 45.4348]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4945485,
        name: "Guglie Luxury Apartment",
        host_id: 24669207,
        host_name: "Milo",
        latitude: 45.44405,
        longitude: 12.32195,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32195, 45.44405]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4945854,
        name: "Ca Molin - Double Balcony Room - Canal view",
        host_id: 25085773,
        host_name: "Gin",
        latitude: 45.43672,
        longitude: 12.32342,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32342, 45.43672]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4946172,
        name: "Ca' Mirò your penthouse with terrace",
        host_id: 25493749,
        host_name: "Laura",
        latitude: 45.4415,
        longitude: 12.32661,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32661, 45.4415]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4947604,
        name: "Ca' Marco Polo apartments",
        host_id: 25497334,
        host_name: "Vanni",
        latitude: 45.43209,
        longitude: 12.35269,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35269, 45.43209]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4949254,
        name: "Bright apartment in Venice.",
        host_id: 25509024,
        host_name: "Gianluigi",
        latitude: 45.4458,
        longitude: 12.3213,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3213, 45.4458]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4957111,
        name: "Aea Corte Apartment",
        host_id: 13027859,
        host_name: "Diego",
        latitude: 45.43829,
        longitude: 12.34631,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34631, 45.43829]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4961054,
        name: "Canal view apartment with wifi & airconditioning",
        host_id: 24706907,
        host_name: "Carmen",
        latitude: 45.44681,
        longitude: 12.32288,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32288, 45.44681]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4962439,
        name: "In the heart of Venice",
        host_id: 25581367,
        host_name: "Adriano",
        latitude: 45.44367,
        longitude: 12.32225,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32225, 45.44367]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4982513,
        name: "This is your flat in Venice! Your truly home away!",
        host_id: 15351880,
        host_name: "Ivan Flavio",
        latitude: 45.4444,
        longitude: 12.33044,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33044, 45.4444]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4987151,
        name: "CASA BARACCO, apartment GIOVANNI, DORSODURO",
        host_id: 25235283,
        host_name: "Ugo",
        latitude: 45.43416,
        longitude: 12.32386,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32386, 45.43416]] },
    },
    {
      type: "Feature",
      properties: {
        id: 4995876,
        name: "cozy room in Venice",
        host_id: 25756873,
        host_name: "Monica",
        latitude: 45.44033,
        longitude: 12.32722,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32722, 45.44033]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5001728,
        name: "A dream in Castello,  terrace and air conditioning",
        host_id: 12113015,
        host_name: "Mario",
        latitude: 45.43153,
        longitude: 12.32813,
        beds: 7,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32813, 45.43153]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5001779,
        name: "Venezia Venice studio tre archi",
        host_id: 25792875,
        host_name: "Francesco",
        latitude: 45.44705,
        longitude: 12.32119,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32119, 45.44705]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5003167,
        name: "EleHouse - Romantic apartment in Venice",
        host_id: 25799987,
        host_name: "Elena",
        latitude: 45.43529,
        longitude: 12.31956,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31956, 45.43529]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5012528,
        name: "Water Views From Romantic Dorsoduro Apartment",
        host_id: 3050643,
        host_name: "Anna",
        latitude: 45.43205,
        longitude: 12.31634,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31634, 45.43205]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5024031,
        name: "ampia stanza tripla",
        host_id: 25756873,
        host_name: "Monica",
        latitude: 45.44152,
        longitude: 12.32938,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32938, 45.44152]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5025859,
        name: "CA' DEI SCUDI - an authentic stunning view!",
        host_id: 25929669,
        host_name: "Lucio",
        latitude: 45.43628,
        longitude: 12.34677,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34677, 45.43628]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5033959,
        name: "Ca'Flavia ideal for family near San Marco  Rialto",
        host_id: 25986688,
        host_name: "Flavia",
        latitude: 45.4394,
        longitude: 12.34364,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34364, 45.4394]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5036409,
        name: "Cà D'Oro Apartment (Second Floor)",
        host_id: 25998480,
        host_name: "Cristina",
        latitude: 45.44195,
        longitude: 12.33447,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33447, 45.44195]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5062628,
        name: "Ca' Biennial bright apartment with terrace",
        host_id: 26144409,
        host_name: "Alberto",
        latitude: 45.42984,
        longitude: 12.35572,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35572, 45.42984]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5067331,
        name:
          "Dolce Vita in einem Häuschen abseits der touristischen Massen, nahe Biennale",
        host_id: 4247965,
        host_name: "Silvia",
        latitude: 45.43732,
        longitude: 12.3484,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3484, 45.43732]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5077194,
        name: "Single room  Venice center",
        host_id: 6338514,
        host_name: "Ca' Morosini",
        latitude: 45.43478,
        longitude: 12.33023,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33023, 45.43478]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5084445,
        name: "Appartamento zona S.Marco - Venezia",
        host_id: 26262747,
        host_name: "Adolfo",
        latitude: 45.43221,
        longitude: 12.33238,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33238, 45.43221]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5092673,
        name: "Perfect location Venice",
        host_id: 6338514,
        host_name: "Ca' Morosini",
        latitude: 45.43488,
        longitude: 12.33156,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33156, 45.43488]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5099225,
        name: "Ca' Moro: Luxury and AWESOME PRIVATE TERRACE",
        host_id: 10988715,
        host_name: "Andrea",
        latitude: 45.44337,
        longitude: 12.33177,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33177, 45.44337]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5100178,
        name: "Central romantic Venetian-styled apartment",
        host_id: 4654704,
        host_name: "Nicola",
        latitude: 45.43616,
        longitude: 12.35009,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35009, 45.43616]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5124098,
        name: "Clock Residence close to St. Mark's Square",
        host_id: 289615,
        host_name: "Valentina",
        latitude: 45.43518,
        longitude: 12.33944,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33944, 45.43518]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5138847,
        name: 'Venice "Ae Maschere"',
        host_id: 13027859,
        host_name: "Diego",
        latitude: 45.44375,
        longitude: 12.32692,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32692, 45.44375]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5140061,
        name: "Renovated apartment with terrace.",
        host_id: 13987344,
        host_name: "Raffaella",
        latitude: 45.43711,
        longitude: 12.32475,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32475, 45.43711]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5157327,
        name: "Mimi'studio",
        host_id: 26671279,
        host_name: "Pietro",
        latitude: 45.43037,
        longitude: 12.33463,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33463, 45.43037]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5179476,
        name: "Three Bedrooms in Cannaregio district",
        host_id: 674749,
        host_name: "Riccardo",
        latitude: 45.4427,
        longitude: 12.32843,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32843, 45.4427]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5188488,
        name: "Ca’ Malatin – Casa Vacanza",
        host_id: 26837840,
        host_name: "Haydee Elena",
        latitude: 45.43776,
        longitude: 12.34813,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34813, 45.43776]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5190666,
        name: "Ca' Silvana",
        host_id: 3556311,
        host_name: "Andrea",
        latitude: 45.43985,
        longitude: 12.33999,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33999, 45.43985]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5191614,
        name: "new independent apartment on S.Rocco Frari",
        host_id: 18981467,
        host_name: "Salvatore",
        latitude: 45.43514,
        longitude: 12.32392,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32392, 45.43514]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5193521,
        name: "B&B S.Stae - (walking bird room)",
        host_id: 25350552,
        host_name: "Genovina",
        latitude: 45.44001,
        longitude: 12.32995,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32995, 45.44001]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5197872,
        name: "Ca' Manin",
        host_id: 26889678,
        host_name: "Rossella",
        latitude: 45.43963,
        longitude: 12.32326,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32326, 45.43963]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5211678,
        name: "BARBARIA huge TERRACE in Castello!",
        host_id: 1438903,
        host_name: "Barbara",
        latitude: 45.43976,
        longitude: 12.34526,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34526, 45.43976]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5212843,
        name: "CA FENICE",
        host_id: 401113,
        host_name: "Elia",
        latitude: 45.4347,
        longitude: 12.33289,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33289, 45.4347]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5219509,
        name: "In the heart of Venice",
        host_id: 6183257,
        host_name: "Olivier Nicolas",
        latitude: 45.43922,
        longitude: 12.32817,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32817, 45.43922]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5233583,
        name: "CA' BARBO ROMANTIC APARTMENT IN VENICE HEART",
        host_id: 27085928,
        host_name: "Simone",
        latitude: 45.43633,
        longitude: 12.32302,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32302, 45.43633]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5237608,
        name: "Zattere luxury large apart with fabulous views",
        host_id: 11353579,
        host_name: "Giorgio",
        latitude: 45.42941,
        longitude: 12.33071,
        beds: 7,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33071, 45.42941]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5244180,
        name: 'Casa Eden - Suite "La Rosa"',
        host_id: 27141986,
        host_name: "Dino",
        latitude: 45.42638,
        longitude: 12.33913,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33913, 45.42638]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5244934,
        name: 'Casa Eden - "Il Tulipano suite"',
        host_id: 27141986,
        host_name: "Dino",
        latitude: 45.42771,
        longitude: 12.34067,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34067, 45.42771]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5253525,
        name: "Lagoon Gem",
        host_id: 8524766,
        host_name: "Pietro",
        latitude: 45.4467,
        longitude: 12.3335,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3335, 45.4467]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5253772,
        name: 'Casa Eden - Suite "Il Gelsomino"',
        host_id: 27141986,
        host_name: "Dino",
        latitude: 45.42672,
        longitude: 12.33917,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33917, 45.42672]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5257636,
        name: "Romantico openspace",
        host_id: 26534556,
        host_name: "Alberta",
        latitude: 45.44197,
        longitude: 12.33434,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33434, 45.44197]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5265701,
        name: "Ca'Bernardino",
        host_id: 26144409,
        host_name: "Alberto",
        latitude: 45.44579,
        longitude: 12.32325,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32325, 45.44579]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5265904,
        name: "Ca' Dell'Artista Apartment",
        host_id: 669047,
        host_name: "Viewsonvenice",
        latitude: 45.43229,
        longitude: 12.32522,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32522, 45.43229]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5266510,
        name: "Ca' dei Greci",
        host_id: 22746485,
        host_name: "Federica",
        latitude: 45.43515,
        longitude: 12.34465,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34465, 45.43515]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5267638,
        name: "Venice centre, modern apartment",
        host_id: 27266211,
        host_name: "Giorgia",
        latitude: 45.44389,
        longitude: 12.32036,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32036, 45.44389]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5268522,
        name: "Your warm and cozy home with A/C and Wi-Fi free",
        host_id: 27270231,
        host_name: "Sandra",
        latitude: 45.4419,
        longitude: 12.33928,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33928, 45.4419]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5275939,
        name: "San Lorenzo Canal View apartment",
        host_id: 27081641,
        host_name: "Irene",
        latitude: 45.43608,
        longitude: 12.34484,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34484, 45.43608]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5302362,
        name: "Apartment Madonna dell'Orto",
        host_id: 27463442,
        host_name: "Marino",
        latitude: 45.44557,
        longitude: 12.33025,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33025, 45.44557]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5303501,
        name: "Cozy room in Gran Canal palace",
        host_id: 27468706,
        host_name: "Valeria",
        latitude: 45.443,
        longitude: 12.32599,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32599, 45.443]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5312166,
        name: "️Rare Loft/Own patio! 1min ⛴Grand Canal /5 min",
        host_id: 9852012,
        host_name: "Paolo",
        latitude: 45.4405,
        longitude: 12.32573,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32573, 45.4405]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5314381,
        name: '" Casa Zanchi - 2 "',
        host_id: 7345605,
        host_name: "Cristina",
        latitude: 45.4343,
        longitude: 12.325,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.325, 45.4343]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5314691,
        name: "Monolocale vista Campo Sant'Angelo",
        host_id: 15511096,
        host_name: "Paolo",
        latitude: 45.43476,
        longitude: 12.33276,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33276, 45.43476]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5314916,
        name: "Bilocale vista giardino",
        host_id: 15511096,
        host_name: "Paolo",
        latitude: 45.43479,
        longitude: 12.33285,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33285, 45.43479]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5315057,
        name: "Apartment city view",
        host_id: 15511096,
        host_name: "Paolo",
        latitude: 45.43358,
        longitude: 12.33328,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33328, 45.43358]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5317049,
        name: "Parentesi nel cuore di Venezia",
        host_id: 27543599,
        host_name: "Andrea",
        latitude: 45.43694,
        longitude: 12.34,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34, 45.43694]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5317772,
        name: "DolceVita Apartments N. 185",
        host_id: 8176475,
        host_name: "Eugenia",
        latitude: 45.44199,
        longitude: 12.32932,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32932, 45.44199]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5321505,
        name: "Ca' San Sebastiano Charming Apartment Overlooking the Canal",
        host_id: 669047,
        host_name: "Viewsonvenice",
        latitude: 45.43091,
        longitude: 12.32104,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32104, 45.43091]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5337417,
        name: "Cà Olivieri",
        host_id: 27660927,
        host_name: "Elisabetta",
        latitude: 45.4316,
        longitude: 12.3262,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3262, 45.4316]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5343674,
        name: "ROOM ON THE WATER FOR 1 PERSON",
        host_id: 5256801,
        host_name: "Giusy",
        latitude: 45.44641,
        longitude: 12.33192,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33192, 45.44641]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5360928,
        name: "Delizioso trilocale zona Ca'Foscari",
        host_id: 27790287,
        host_name: "Luz Karime",
        latitude: 45.43587,
        longitude: 12.32509,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32509, 45.43587]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5365664,
        name: "Signorile su corte veneziana",
        host_id: 27817620,
        host_name: "Alfonso",
        latitude: 45.43383,
        longitude: 12.33067,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33067, 45.43383]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5368630,
        name: "New Private Double Room & Bathroom",
        host_id: 5332195,
        host_name: "Alessandro",
        latitude: 45.43585,
        longitude: 12.34707,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34707, 45.43585]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5393506,
        name: "Penthouse with Views Filled with Art, Books, and Antiques",
        host_id: 14083399,
        host_name: "Katyna",
        latitude: 45.43461,
        longitude: 12.33762,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33762, 45.43461]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5397771,
        name: "NEW TWO BEDROOM LOW COST, WIFI",
        host_id: 10651006,
        host_name: "Alexe",
        latitude: 45.42626,
        longitude: 12.32608,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32608, 45.42626]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5401000,
        name: "1 bedroom Deluxe Apartment",
        host_id: 1617572,
        host_name: "Silvia",
        latitude: 45.43298,
        longitude: 12.35652,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35652, 45.43298]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5401605,
        name: "Apartament 900m far from San Marco Square",
        host_id: 1617572,
        host_name: "Silvia",
        latitude: 45.43275,
        longitude: 12.35279,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35279, 45.43275]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5402038,
        name: "San Pietro Apartment",
        host_id: 1617572,
        host_name: "Silvia",
        latitude: 45.43502,
        longitude: 12.3582,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3582, 45.43502]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5409458,
        name: "NEW OPEN TOP LOCATION 2 SAN MARK SQ",
        host_id: 4806020,
        host_name: "Iber",
        latitude: 45.43481,
        longitude: 12.33754,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33754, 45.43481]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5412024,
        name: "6 WINDOWS! GRAND CANAL PANORAMA VIEW, Aircond Wifi",
        host_id: 17534457,
        host_name: "Abaca",
        latitude: 45.43653,
        longitude: 12.33144,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33144, 45.43653]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5425891,
        name: "Palladio terrace: elegant with spectacular view",
        host_id: 28145404,
        host_name: "Marco & Monica",
        latitude: 45.43053,
        longitude: 12.33236,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33236, 45.43053]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5427581,
        name: "Home Sweet Home",
        host_id: 28153967,
        host_name: "Alessandra",
        latitude: 45.432,
        longitude: 12.32607,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32607, 45.432]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5428344,
        name: "SAN BARTOLOMIO - Only a 50 meters to Rialto bridge",
        host_id: 10189388,
        host_name: "Raffaella",
        latitude: 45.43755,
        longitude: 12.33639,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33639, 45.43755]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5428929,
        name: "SAGREDO HOUSE",
        host_id: 21915670,
        host_name: "Elda",
        latitude: 45.43817,
        longitude: 12.33105,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33105, 45.43817]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5429268,
        name: "San Marco Square - Art Apartments Venice",
        host_id: 28162920,
        host_name: "Beatriz",
        latitude: 45.43572,
        longitude: 12.3387,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3387, 45.43572]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5445033,
        name: "VENICE HEAVEN APARTMENTS - CA MATILDE",
        host_id: 1554828,
        host_name: "Veronica",
        latitude: 45.43328,
        longitude: 12.32929,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32929, 45.43328]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5450931,
        name: "STELLA MARINA 4  APARTMENT",
        host_id: 21356512,
        host_name: "Cristina",
        latitude: 45.42721,
        longitude: 12.32049,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32049, 45.42721]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5462213,
        name: "Lovely Canal View, 3 bedroom, 10 people",
        host_id: 13012838,
        host_name: "Paola",
        latitude: 45.4255,
        longitude: 12.32371,
        beds: 8,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32371, 45.4255]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5462631,
        name: "Jewish Square Ghetto - Art Apartments Venice",
        host_id: 28162920,
        host_name: "Beatriz",
        latitude: 45.44423,
        longitude: 12.32653,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32653, 45.44423]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5472292,
        name: "I Felzi, a charming relax in Venice",
        host_id: 20457930,
        host_name: "Roberto",
        latitude: 45.4417,
        longitude: 12.33985,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33985, 45.4417]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5473403,
        name: "Single room in a quiet location",
        host_id: 26297358,
        host_name: "Erica",
        latitude: 45.43277,
        longitude: 12.31891,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31891, 45.43277]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5473610,
        name: "CA'AFFRESCO 2",
        host_id: 3972291,
        host_name: "Caroline E Marco",
        latitude: 45.43279,
        longitude: 12.32954,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32954, 45.43279]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5476332,
        name: "Ca'dei Fioi, historical building from '500",
        host_id: 28400172,
        host_name: "Giacomo",
        latitude: 45.43487,
        longitude: 12.31988,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31988, 45.43487]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5479931,
        name: "Charme in the Heart of Venice",
        host_id: 28417349,
        host_name: "Ivan",
        latitude: 45.43589,
        longitude: 12.34354,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34354, 45.43589]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5486233,
        name: "CA' LETIZIA  Apartment in typical Venetian style",
        host_id: 28449302,
        host_name: "Andrea",
        latitude: 45.44418,
        longitude: 12.33069,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33069, 45.44418]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5489995,
        name: "Flat 201 San Marco",
        host_id: 28440916,
        host_name: "Olga",
        latitude: 45.43253,
        longitude: 12.33292,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33292, 45.43253]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5513695,
        name: "Most Prestigious Address In Venice",
        host_id: 28542421,
        host_name: "Veronica",
        latitude: 45.43466,
        longitude: 12.33894,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33894, 45.43466]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5517003,
        name: "Venice on the Grand Canal",
        host_id: 19092207,
        host_name: "Mila",
        latitude: 45.43673,
        longitude: 12.33048,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33048, 45.43673]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5518114,
        name: "Luminoso confortevole appartamento",
        host_id: 28618552,
        host_name: "Alessandra",
        latitude: 45.43219,
        longitude: 12.32591,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32591, 45.43219]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5518606,
        name: "Renovated APARTMENT",
        host_id: 25980105,
        host_name: "Annalisa",
        latitude: 45.43854,
        longitude: 12.3267,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3267, 45.43854]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5520923,
        name: "CRUISE PORT, LAGOON, UNIVERSITY with canal view",
        host_id: 17534457,
        host_name: "Abaca",
        latitude: 45.43364,
        longitude: 12.31804,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31804, 45.43364]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5535456,
        name: "CHARM & CHIC",
        host_id: 28702177,
        host_name: "Silva",
        latitude: 45.43414,
        longitude: 12.34843,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34843, 45.43414]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5543532,
        name: "Secret Fenice, in the heart of Venice.",
        host_id: 28743242,
        host_name: "Maurizio",
        latitude: 45.43437,
        longitude: 12.33353,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33353, 45.43437]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5547849,
        name: "Home Venice Apartments - S. Polo",
        host_id: 7619802,
        host_name: "Stefania",
        latitude: 45.43843,
        longitude: 12.33162,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33162, 45.43843]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5552668,
        name: "San Luca apartment",
        host_id: 7619802,
        host_name: "Stefania",
        latitude: 45.43692,
        longitude: 12.33515,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33515, 45.43692]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5561772,
        name: "Real Venice, Romantic alla Celestia",
        host_id: 28833404,
        host_name: "Adriana",
        latitude: 45.43768,
        longitude: 12.35074,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35074, 45.43768]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5568794,
        name: "Ca' Brighella, really  3 min from St.Mark's square",
        host_id: 26191936,
        host_name: "Manuela",
        latitude: 45.43597,
        longitude: 12.34153,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34153, 45.43597]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5569054,
        name: "100 STEPS FROM ST MARK'S SQUARE!",
        host_id: 28871404,
        host_name: "Michela",
        latitude: 45.4368,
        longitude: 12.34142,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34142, 45.4368]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5583291,
        name: "The house above the glass factory",
        host_id: 6620102,
        host_name: "Emanuele",
        latitude: 45.4463,
        longitude: 12.32167,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32167, 45.4463]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5585075,
        name: "Apartment overlooking the canal",
        host_id: 3172703,
        host_name: "Sofia",
        latitude: 45.44509,
        longitude: 12.32901,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32901, 45.44509]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5585819,
        name: "New&Cozy Venice apartment with Wifi",
        host_id: 4905300,
        host_name: "Martina",
        latitude: 45.44834,
        longitude: 12.32792,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32792, 45.44834]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5599591,
        name: "Central and quiet, Zanipolo area",
        host_id: 15178567,
        host_name: "Paolo",
        latitude: 45.43631,
        longitude: 12.34058,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34058, 45.43631]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5600945,
        name: "St.Lio - peaceful and cery central",
        host_id: 15178567,
        host_name: "Paolo",
        latitude: 45.4383,
        longitude: 12.34031,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34031, 45.4383]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5608107,
        name: "Apartment close to Ghetto",
        host_id: 29075283,
        host_name: "Mascia",
        latitude: 45.4443,
        longitude: 12.32966,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32966, 45.4443]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5625308,
        name: "Microvenice Guesthouse",
        host_id: 29156085,
        host_name: "Anna",
        latitude: 45.43315,
        longitude: 12.33632,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33632, 45.43315]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5630023,
        name: "Grand Canal Apartment Suite",
        host_id: 29176851,
        host_name: "Brittany",
        latitude: 45.44077,
        longitude: 12.32921,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32921, 45.44077]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5634275,
        name: "New lovely clean apartment on canal",
        host_id: 26717354,
        host_name: "Riccardo",
        latitude: 45.4354,
        longitude: 12.31906,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31906, 45.4354]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5634912,
        name: "Best location venice family &  group",
        host_id: 27990266,
        host_name: "Ai",
        latitude: 45.43679,
        longitude: 12.34069,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34069, 45.43679]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5641271,
        name: 'app. Venezia 40mq "alla lista"',
        host_id: 29231597,
        host_name: "Alessandro &  Sabrina",
        latitude: 45.44033,
        longitude: 12.32413,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32413, 45.44033]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5646746,
        name: "Welcoming Apartment for Family and Friends",
        host_id: 27686711,
        host_name: "Romano Eugenio",
        latitude: 45.43625,
        longitude: 12.32432,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32432, 45.43625]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5648178,
        name: "Angels House",
        host_id: 29271096,
        host_name: "Ari",
        latitude: 45.43515,
        longitude: 12.3291,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3291, 45.43515]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5653637,
        name: "Ca'Rosa - Italian BREAKFAST on demand",
        host_id: 19371948,
        host_name: "Lotus Apartments Family",
        latitude: 45.43648,
        longitude: 12.32708,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32708, 45.43648]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5654287,
        name: "Canal view! Authentic Venetian Home near Rialto",
        host_id: 9852012,
        host_name: "Paolo",
        latitude: 45.43973,
        longitude: 12.33164,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33164, 45.43973]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5656882,
        name: "Biennale Apartment",
        host_id: 29320121,
        host_name: "Samir - Francesca",
        latitude: 45.42922,
        longitude: 12.36048,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.36048, 45.42922]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5657232,
        name: "High View apartment",
        host_id: 29271096,
        host_name: "Ari",
        latitude: 45.43538,
        longitude: 12.33238,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33238, 45.43538]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5657345,
        name: "Only 50 meters from Piazza San Marco",
        host_id: 28552652,
        host_name: "Luciana",
        latitude: 45.43544,
        longitude: 12.33612,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33612, 45.43544]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5657902,
        name: "Ca' Barbaria Artist room",
        host_id: 12072143,
        host_name: "Ca'Barbaria",
        latitude: 45.43961,
        longitude: 12.343,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.343, 45.43961]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5663077,
        name: "Cozy bedroom next to Piazza S.Marco",
        host_id: 11235412,
        host_name: "Alessandra",
        latitude: 45.43225,
        longitude: 12.3332,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3332, 45.43225]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5669720,
        name: "Sunny San Basilio - Dorsoduro Haven",
        host_id: 29176851,
        host_name: "Brittany",
        latitude: 45.43212,
        longitude: 12.31931,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31931, 45.43212]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5679367,
        name: "Apartment with astonishing view",
        host_id: 22884126,
        host_name: "Giugi",
        latitude: 45.44007,
        longitude: 12.3371,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3371, 45.44007]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5687970,
        name: "Quiet room on Giudecca Island",
        host_id: 29492410,
        host_name: "Cesar",
        latitude: 45.42502,
        longitude: 12.32335,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32335, 45.42502]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5691428,
        name: "Loft alla Fenice   M (Phone number hidden by Airbnb)",
        host_id: 29271096,
        host_name: "Ari",
        latitude: 45.43384,
        longitude: 12.32995,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32995, 45.43384]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5692165,
        name: "Ca' Geremia – nice apartment in a premier location",
        host_id: 25128793,
        host_name: "_mdm_",
        latitude: 45.44227,
        longitude: 12.32278,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32278, 45.44227]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5703698,
        name: "Venezia Giudecca, a studio house with a view!",
        host_id: 29571251,
        host_name: "Emma",
        latitude: 45.42739,
        longitude: 12.32169,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32169, 45.42739]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5715862,
        name: "Sunrise Apartment  M (Phone number hidden by Airbnb)",
        host_id: 29271096,
        host_name: "Ari",
        latitude: 45.43453,
        longitude: 12.32974,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32974, 45.43453]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5715910,
        name: "Little home in history palace",
        host_id: 22328563,
        host_name: "Marcella",
        latitude: 45.43949,
        longitude: 12.33686,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33686, 45.43949]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5724915,
        name: "Carmini movida",
        host_id: 21861574,
        host_name: "Valentino",
        latitude: 45.43212,
        longitude: 12.32283,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32283, 45.43212]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5726471,
        name: "Triple large Harry's",
        host_id: 23182155,
        host_name: "Stefano Roberta",
        latitude: 45.44359,
        longitude: 12.33561,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33561, 45.44359]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5726699,
        name: "Suite bagno privato e vista laguna Harry's",
        host_id: 23182155,
        host_name: "Stefano Roberta",
        latitude: 45.44367,
        longitude: 12.33618,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33618, 45.44367]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5734857,
        name: "Cozy apartment with canal view",
        host_id: 29735190,
        host_name: "Michele",
        latitude: 45.43332,
        longitude: 12.33655,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33655, 45.43332]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5735603,
        name: "Cà Ludovica",
        host_id: 29723408,
        host_name: "Matteo",
        latitude: 45.43983,
        longitude: 12.33704,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33704, 45.43983]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5735977,
        name: "SKY APARTMENT - High Tide Exempt",
        host_id: 29706566,
        host_name: "Margherita & Valentina",
        latitude: 45.43935,
        longitude: 12.33196,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33196, 45.43935]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5737700,
        name: "Near bus and train station",
        host_id: 29755603,
        host_name: "Giuliano",
        latitude: 45.44082,
        longitude: 12.32499,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32499, 45.44082]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5743784,
        name: "Casa Ciò - 4 minutes from Railway S",
        host_id: 29791635,
        host_name: "Paolo",
        latitude: 45.44447,
        longitude: 12.32052,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32052, 45.44447]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5748849,
        name: "la suite del doge",
        host_id: 29821347,
        host_name: "Francesca",
        latitude: 45.43488,
        longitude: 12.33787,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33787, 45.43488]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5752976,
        name: "APARTMENT BY CANAL GRANDE IN THE HEART OF VENICE",
        host_id: 29845371,
        host_name: "Marisa",
        latitude: 45.4409,
        longitude: 12.32856,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32856, 45.4409]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5757476,
        name: "Literally 20 meters from San Marco square!",
        host_id: 12113015,
        host_name: "Mario",
        latitude: 45.43559,
        longitude: 12.33833,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33833, 45.43559]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5768872,
        name: "TERRACE!, TERRACE 360' STYLISH, 3bed, aircond wifi",
        host_id: 17534457,
        host_name: "Abaca",
        latitude: 45.43493,
        longitude: 12.35628,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35628, 45.43493]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5791611,
        name: "lovely apartment centre of venice",
        host_id: 10288973,
        host_name: "Morena",
        latitude: 45.44374,
        longitude: 12.32902,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32902, 45.44374]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5798848,
        name: "Rialto Franklin",
        host_id: 29918538,
        host_name: "Youinvenice",
        latitude: 45.43761,
        longitude: 12.3371,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3371, 45.43761]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5800929,
        name: "Venis Terrace Canal view",
        host_id: 29918538,
        host_name: "Youinvenice",
        latitude: 45.43507,
        longitude: 12.34528,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34528, 45.43507]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5809349,
        name: "B&B IN VENICE BACK TO SAN MARCO",
        host_id: 30141587,
        host_name: "Fiorella",
        latitude: 45.43424,
        longitude: 12.34108,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34108, 45.43424]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5818032,
        name: "Cozy apartment near Rialto - S Mark",
        host_id: 5395291,
        host_name: "Beatrice",
        latitude: 45.44237,
        longitude: 12.33904,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33904, 45.44237]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5818801,
        name: "Dogaressa",
        host_id: 30197008,
        host_name: "Marina",
        latitude: 45.42769,
        longitude: 12.32039,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32039, 45.42769]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5831686,
        name: "AMAZING LOVELY CENTRAL VENICE NEST",
        host_id: 9438202,
        host_name: "Silvia",
        latitude: 45.4374,
        longitude: 12.34197,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34197, 45.4374]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5834268,
        name: "50 STEPS FROM ST. MARK'S SQUARE",
        host_id: 30283716,
        host_name: "Piero - Andrea",
        latitude: 45.435,
        longitude: 12.33969,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33969, 45.435]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5835421,
        name: "Central flat in a typical Venice",
        host_id: 5128717,
        host_name: "Alvise",
        latitude: 45.43687,
        longitude: 12.33627,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33627, 45.43687]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5845253,
        name: "Calle Botteri",
        host_id: 29918538,
        host_name: "Youinvenice",
        latitude: 45.43888,
        longitude: 12.33461,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33461, 45.43888]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5857348,
        name: "Dolcevita Apartments 241 Biennale",
        host_id: 8176475,
        host_name: "Eugenia",
        latitude: 45.43149,
        longitude: 12.35657,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35657, 45.43149]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5866691,
        name: "Penthouse with Terrace: Lagoon view - free Wifi",
        host_id: 30462302,
        host_name: "Sandro",
        latitude: 45.43321,
        longitude: 12.35234,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35234, 45.43321]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5880707,
        name: "Apartment/house in Venice",
        host_id: 4486181,
        host_name: "Federico",
        latitude: 45.43046,
        longitude: 12.35684,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35684, 45.43046]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5890744,
        name: "stanza singola",
        host_id: 25756873,
        host_name: "Monica",
        latitude: 45.44002,
        longitude: 12.32741,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32741, 45.44002]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5903373,
        name: "Boende med trädgård i Venedig",
        host_id: 30661213,
        host_name: "Per",
        latitude: 45.43189,
        longitude: 12.35245,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35245, 45.43189]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5903571,
        name: "doppia Da Marinella dependanc",
        host_id: 30586629,
        host_name: "Andrea",
        latitude: 45.43863,
        longitude: 12.33945,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33945, 45.43863]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5925368,
        name: "A gorgeous and restored apartment",
        host_id: 30767560,
        host_name: "Adriana",
        latitude: 45.4365,
        longitude: 12.3484,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3484, 45.4365]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5935593,
        name: "Ca del Parco, Biennale of Venice",
        host_id: 294951,
        host_name: "VeniceVillas Di Enzo",
        latitude: 45.42708,
        longitude: 12.36143,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.36143, 45.42708]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5939655,
        name: "San Marco Venice Flat",
        host_id: 620628,
        host_name: "Nino",
        latitude: 45.43619,
        longitude: 12.3385,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3385, 45.43619]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5949835,
        name: "Frari Luxury Apartment",
        host_id: 6973711,
        host_name: "Valentina",
        latitude: 45.43509,
        longitude: 12.32583,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32583, 45.43509]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5954179,
        name: "Barba Bepi Charming Studio",
        host_id: 30906790,
        host_name: "Martino",
        latitude: 45.43298,
        longitude: 12.32388,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32388, 45.43298]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5954552,
        name: "Close to Biennale and San Mark' Sq",
        host_id: 369617,
        host_name: "Irene",
        latitude: 45.43496,
        longitude: 12.34691,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34691, 45.43496]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5962685,
        name: "Venice Charme & Chic !",
        host_id: 30953959,
        host_name: "CàRina",
        latitude: 45.434,
        longitude: 12.31201,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31201, 45.434]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5971984,
        name: "IL GIGLIO DI VIDA in SAN MARCO",
        host_id: 22947724,
        host_name: "Roberto",
        latitude: 45.43251,
        longitude: 12.33386,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33386, 45.43251]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5977742,
        name: "Private charming apartment",
        host_id: 30906790,
        host_name: "Martino",
        latitude: 45.43196,
        longitude: 12.32381,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32381, 45.43196]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5978127,
        name: "Cozy and friendly room in Venice",
        host_id: 21094325,
        host_name: "Gianna",
        latitude: 45.42548,
        longitude: 12.3266,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3266, 45.42548]] },
    },
    {
      type: "Feature",
      properties: {
        id: 5983373,
        name: "Elegante mansarda stile veneziano",
        host_id: 30906790,
        host_name: "Martino",
        latitude: 45.43308,
        longitude: 12.32293,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32293, 45.43308]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6001319,
        name: 'Matrimoniale "Marinella" dependance',
        host_id: 30586629,
        host_name: "Andrea",
        latitude: 45.43852,
        longitude: 12.3384,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3384, 45.43852]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6001442,
        name: "matrimoniale/tripla dependance",
        host_id: 30586629,
        host_name: "Andrea",
        latitude: 45.43848,
        longitude: 12.33809,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33809, 45.43848]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6001530,
        name: 'Suite "Da Marinella" dependance',
        host_id: 30586629,
        host_name: "Andrea",
        latitude: 45.43797,
        longitude: 12.3395,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3395, 45.43797]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6002811,
        name: "Calle Madona, luxury waterside flat",
        host_id: 2867378,
        host_name: "Helen",
        latitude: 45.43348,
        longitude: 12.3165,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3165, 45.43348]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6009268,
        name: "Ca' Del Monastero 1 Apartment for 4 Guests!",
        host_id: 669047,
        host_name: "Viewsonvenice",
        latitude: 45.44116,
        longitude: 12.32685,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32685, 45.44116]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6011213,
        name: "Ca' Del Monastero 4 Apartment for 8 Guests!",
        host_id: 669047,
        host_name: "Viewsonvenice",
        latitude: 45.44189,
        longitude: 12.32704,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32704, 45.44189]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6012249,
        name: "San Filippo lovely place in the heart of Venice",
        host_id: 19860943,
        host_name: "Rita",
        latitude: 45.43605,
        longitude: 12.34183,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34183, 45.43605]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6017071,
        name: "CENTRAL AREA, NEAR ST. MARK SQUARE",
        host_id: 31233013,
        host_name: "Esmeralda",
        latitude: 45.43375,
        longitude: 12.33379,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33379, 45.43375]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6025872,
        name: "romantic design house on the water",
        host_id: 31276705,
        host_name: "Mila",
        latitude: 45.44293,
        longitude: 12.33538,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33538, 45.44293]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6026584,
        name: "Biennale Luxury Apartment",
        host_id: 193059,
        host_name: "Oliva Nera",
        latitude: 45.43483,
        longitude: 12.34458,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34458, 45.43483]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6035398,
        name: "Central apt convenient 1st floor 2 bath - X3103",
        host_id: 15178567,
        host_name: "Paolo",
        latitude: 45.4379,
        longitude: 12.33837,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33837, 45.4379]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6040671,
        name: "COMFORT StMARK'S to ARSENALE 4pax wifi aircond",
        host_id: 17534457,
        host_name: "Abaca",
        latitude: 45.43468,
        longitude: 12.34658,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34658, 45.43468]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6042521,
        name: "luminosa twin su edificio storico",
        host_id: 25756873,
        host_name: "Monica",
        latitude: 45.44147,
        longitude: 12.32702,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32702, 45.44147]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6047604,
        name: "B&B Casa Baseggio - double room 2",
        host_id: 290452,
        host_name: "Marco",
        latitude: 45.44335,
        longitude: 12.3353,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3353, 45.44335]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6049269,
        name: "San Marco Tower",
        host_id: 4258092,
        host_name: "Sebastiano",
        latitude: 45.43513,
        longitude: 12.33654,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33654, 45.43513]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6050330,
        name: "Appartamento sul ponte",
        host_id: 31397318,
        host_name: "Serena",
        latitude: 45.44129,
        longitude: 12.33686,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33686, 45.44129]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6057450,
        name: "FAMILY roomm close Rialto bridge",
        host_id: 23652890,
        host_name: "Paolo",
        latitude: 45.43773,
        longitude: 12.33329,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33329, 45.43773]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6062910,
        name: "Apartment IL BARBAGIANO",
        host_id: 26671279,
        host_name: "Pietro",
        latitude: 45.43112,
        longitude: 12.32326,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32326, 45.43112]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6063820,
        name: "Sunny Room for You in the Heart of Venice",
        host_id: 31464362,
        host_name: "Marta & Bibi",
        latitude: 45.43989,
        longitude: 12.32939,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32939, 45.43989]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6064400,
        name: "Great location 3 luky, large room",
        host_id: 31276705,
        host_name: "Mila",
        latitude: 45.44428,
        longitude: 12.32996,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32996, 45.44428]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6064402,
        name: "Great location6 large sunny room wifi private bath",
        host_id: 31276705,
        host_name: "Mila",
        latitude: 45.44444,
        longitude: 12.33051,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33051, 45.44444]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6064804,
        name: "Romantic dreams come true back to the 16th century",
        host_id: 13439627,
        host_name: "Kathrin",
        latitude: 45.43895,
        longitude: 12.33782,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33782, 45.43895]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6086105,
        name: "ROOM 4 pax +KITCHEN+TOILET+WIFI",
        host_id: 8019503,
        host_name: "Cristina",
        latitude: 45.44527,
        longitude: 12.32172,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32172, 45.44527]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6086744,
        name: "Romantic room with two beds.",
        host_id: 24222520,
        host_name: "Daniela",
        latitude: 45.43197,
        longitude: 12.3271,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3271, 45.43197]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6087829,
        name: "VENETIAN HOUSE WITH TERRACE",
        host_id: 5862083,
        host_name: "Silvia",
        latitude: 45.43569,
        longitude: 12.32754,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32754, 45.43569]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6089830,
        name: "Single room 7 minutes from train station",
        host_id: 31604029,
        host_name: "Vincent",
        latitude: 45.43989,
        longitude: 12.32589,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32589, 45.43989]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6090582,
        name: "Double room, 7 minutes from the station.",
        host_id: 31604029,
        host_name: "Vincent",
        latitude: 45.44108,
        longitude: 12.32416,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32416, 45.44108]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6091031,
        name: "double room with 2 bed separate",
        host_id: 31604029,
        host_name: "Vincent",
        latitude: 45.44129,
        longitude: 12.3246,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3246, 45.44129]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6098705,
        name: "Home Venice Apartments - Rivo Alto",
        host_id: 7619802,
        host_name: "Stefania",
        latitude: 45.43741,
        longitude: 12.33429,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33429, 45.43741]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6099635,
        name:
          "Splendido tranquillo appartamento con vista vicino San Marco Michelle in Venice",
        host_id: 11607112,
        host_name: "Michele",
        latitude: 45.43504,
        longitude: 12.34892,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34892, 45.43504]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6106432,
        name: "Charming studio + private garden!",
        host_id: 7833708,
        host_name: "Massimo",
        latitude: 45.44614,
        longitude: 12.32679,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32679, 45.44614]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6109784,
        name: "Attic for 6 people with 2 terraces",
        host_id: 11864228,
        host_name: "Orsola",
        latitude: 45.43809,
        longitude: 12.34007,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34007, 45.43809]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6110243,
        name: "Ca' Del Rio a Real Venetian Apartment",
        host_id: 669047,
        host_name: "Viewsonvenice",
        latitude: 45.43135,
        longitude: 12.32657,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32657, 45.43135]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6112657,
        name: "Casa Alma: Stylish place ideal for the Biennale.",
        host_id: 31703273,
        host_name: "Marika",
        latitude: 45.43619,
        longitude: 12.34903,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34903, 45.43619]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6116727,
        name: "Ca' Mia",
        host_id: 3865435,
        host_name: "Gaia",
        latitude: 45.44058,
        longitude: 12.32274,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32274, 45.44058]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6119400,
        name: "Venice Rainbow Apartment (San Marco 2)",
        host_id: 22623713,
        host_name: "Rupu",
        latitude: 45.43517,
        longitude: 12.34308,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34308, 45.43517]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6122375,
        name: "SANTA MARGHERITA SQUARE",
        host_id: 31767434,
        host_name: "Carlo Antonio",
        latitude: 45.43329,
        longitude: 12.32014,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32014, 45.43329]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6124376,
        name: "Lovable mini suite - great position",
        host_id: 3296218,
        host_name: "Vicri",
        latitude: 45.44364,
        longitude: 12.3293,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3293, 45.44364]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6127700,
        name: "CA' GENGI - ART&FOOD GALLERY",
        host_id: 31464362,
        host_name: "Marta & Bibi",
        latitude: 45.44033,
        longitude: 12.33064,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33064, 45.44033]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6129601,
        name: "Apartment Biennale Giardini",
        host_id: 31799362,
        host_name: "Carlotta",
        latitude: 45.42953,
        longitude: 12.35565,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35565, 45.42953]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6138193,
        name: "sweet home in the center, 2 bedroom",
        host_id: 5332195,
        host_name: "Alessandro",
        latitude: 45.43843,
        longitude: 12.33849,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33849, 45.43843]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6139812,
        name: "A WONDERFUL & BIG HOUSE at ZATTERE",
        host_id: 23370300,
        host_name: "Anna",
        latitude: 45.43059,
        longitude: 12.32838,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32838, 45.43059]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6152631,
        name: "Ca' delle tartarughe a Dorsoduro",
        host_id: 31915994,
        host_name: "Olga",
        latitude: 45.43416,
        longitude: 12.31948,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31948, 45.43416]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6154173,
        name: "Luxury Suite near San Marco Rialto",
        host_id: 31922692,
        host_name: "Iryna",
        latitude: 45.4394,
        longitude: 12.34402,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34402, 45.4394]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6158973,
        name: "Angels Apartment central location 2 double bedroom",
        host_id: 5332195,
        host_name: "Alessandro",
        latitude: 45.4363,
        longitude: 12.34004,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34004, 45.4363]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6166441,
        name: "Sunny Venetian apartment with lovely canal view!",
        host_id: 31991252,
        host_name: "Neil",
        latitude: 45.42573,
        longitude: 12.32829,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32829, 45.42573]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6167980,
        name: "Ca' Cicogna: new, bright & charming",
        host_id: 10988715,
        host_name: "Andrea",
        latitude: 45.4379,
        longitude: 12.34226,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34226, 45.4379]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6188859,
        name: "CA' MAGHERITA",
        host_id: 31767434,
        host_name: "Carlo Antonio",
        latitude: 45.43471,
        longitude: 12.31821,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31821, 45.43471]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6192299,
        name: "Charme apt 5 min from S. Marco",
        host_id: 32114188,
        host_name: "Chiara",
        latitude: 45.43605,
        longitude: 12.34517,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34517, 45.43605]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6192604,
        name: "Ca' Del Monastero 2 Apartment for 4 Guests!",
        host_id: 669047,
        host_name: "Viewsonvenice",
        latitude: 45.44196,
        longitude: 12.32706,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32706, 45.44196]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6194281,
        name: "Gradisca house",
        host_id: 32122972,
        host_name: "Alvise",
        latitude: 45.44032,
        longitude: 12.32439,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32439, 45.44032]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6198211,
        name: "Ca' Del Monastero 3 Apartment for 4 Guests!",
        host_id: 669047,
        host_name: "Viewsonvenice",
        latitude: 45.44031,
        longitude: 12.32519,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32519, 45.44031]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6198716,
        name: "Ca' Del Monastero 5 Apartment for 4 Guests!",
        host_id: 669047,
        host_name: "Viewsonvenice",
        latitude: 45.44048,
        longitude: 12.32789,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32789, 45.44048]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6218532,
        name: "Rialto,Center, Ca' delle Maschere, as at your home",
        host_id: 32250682,
        host_name: "Luciano",
        latitude: 45.43735,
        longitude: 12.33389,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33389, 45.43735]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6225110,
        name: "DolceVita Apartments N. 245",
        host_id: 8176475,
        host_name: "Eugenia",
        latitude: 45.44449,
        longitude: 12.33098,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33098, 45.44449]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6225711,
        name: "San Giobbe's apartment",
        host_id: 13657045,
        host_name: "Chiara",
        latitude: 45.44404,
        longitude: 12.32147,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32147, 45.44404]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6240526,
        name: "THE ARCH cozy apartment with the charm of history",
        host_id: 10988715,
        host_name: "Andrea",
        latitude: 45.43843,
        longitude: 12.32599,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32599, 45.43843]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6254591,
        name: "Sunny and centrale apartment!",
        host_id: 28307832,
        host_name: "Alessandra",
        latitude: 45.43866,
        longitude: 12.34075,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34075, 45.43866]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6255389,
        name: "The Pearl, studio in Venice",
        host_id: 32491484,
        host_name: "Leone",
        latitude: 45.43512,
        longitude: 12.33283,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33283, 45.43512]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6276066,
        name: "Venice Rainbow canal view apartment (San Marco)",
        host_id: 22623713,
        host_name: "Rupu",
        latitude: 45.43614,
        longitude: 12.3435,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3435, 45.43614]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6290360,
        name: "Venice ..biennale room :)",
        host_id: 32702994,
        host_name: "Teodora",
        latitude: 45.43767,
        longitude: 12.34948,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34948, 45.43767]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6295327,
        name: "DolceVita Apartments N. 250",
        host_id: 8176475,
        host_name: "Eugenia",
        latitude: 45.4349,
        longitude: 12.34376,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34376, 45.4349]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6296847,
        name: "Apartment Bellini  (Venice Historical Centre)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.44324,
        longitude: 12.3284,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3284, 45.44324]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6310931,
        name: "Feel at home in Venice",
        host_id: 32830351,
        host_name: "Sandro E Maddalena",
        latitude: 45.43514,
        longitude: 12.31767,
        beds: 7,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31767, 45.43514]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6311371,
        name: "Mazzoni Design (near Train Station)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.44187,
        longitude: 12.31934,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31934, 45.44187]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6320198,
        name: "GRIMANI Classic apartment",
        host_id: 32887555,
        host_name: "Residence Corte Grimani",
        latitude: 45.43426,
        longitude: 12.33666,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33666, 45.43426]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6322009,
        name: 'Aria e Luce - room "Crepuscolo"',
        host_id: 10598888,
        host_name: "Arianna & Luca",
        latitude: 45.43852,
        longitude: 12.34319,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34319, 45.43852]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6322466,
        name: 'Aria e Luce - room "Zèfiro"',
        host_id: 10598888,
        host_name: "Arianna & Luca",
        latitude: 45.43788,
        longitude: 12.34231,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34231, 45.43788]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6322605,
        name: 'Aria e Luce - Room "Scirocco"',
        host_id: 10598888,
        host_name: "Arianna & Luca",
        latitude: 45.43655,
        longitude: 12.3432,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3432, 45.43655]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6324014,
        name: "WHERE GRAND CANAL STARTS panoramic view, 5pax,wifi",
        host_id: 17534457,
        host_name: "Abaca",
        latitude: 45.43857,
        longitude: 12.3196,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3196, 45.43857]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6331625,
        name: "Ca'Felice - Romantic flat in Venice city center",
        host_id: 23552336,
        host_name: "Maddalena",
        latitude: 45.43666,
        longitude: 12.32985,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32985, 45.43666]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6333933,
        name: "Nice Bright flat near San Marco",
        host_id: 32850879,
        host_name: "Malcom",
        latitude: 45.43491,
        longitude: 12.34234,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34234, 45.43491]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6352561,
        name: "Whole house in a typical Venetian district",
        host_id: 33095107,
        host_name: "Barbara",
        latitude: 45.43087,
        longitude: 12.35512,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35512, 45.43087]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6360811,
        name: "Only a stone's throw from San Marco",
        host_id: 33138225,
        host_name: "Tommaso",
        latitude: 45.43406,
        longitude: 12.33482,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33482, 45.43406]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6361716,
        name: "Apartment in a typical Venetian Palace",
        host_id: 2847482,
        host_name: "Maria",
        latitude: 45.44348,
        longitude: 12.33181,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33181, 45.44348]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6375400,
        name: "Apartment in the center of Venice",
        host_id: 14213747,
        host_name: "Teresa",
        latitude: 45.4354,
        longitude: 12.32426,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32426, 45.4354]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6383810,
        name: "Romantic mini suite_great position",
        host_id: 3296218,
        host_name: "Vicri",
        latitude: 45.44419,
        longitude: 12.3276,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3276, 45.44419]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6384481,
        name: "Comfortable suite - great position",
        host_id: 3296218,
        host_name: "Vicri",
        latitude: 45.44443,
        longitude: 12.32736,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32736, 45.44443]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6388042,
        name: "With style in San Marco Square",
        host_id: 33138225,
        host_name: "Tommaso",
        latitude: 45.43394,
        longitude: 12.33635,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33635, 45.43394]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6389539,
        name: "VENICE GIARDINI BIENNALE APARTMENT",
        host_id: 5862083,
        host_name: "Silvia",
        latitude: 45.43156,
        longitude: 12.35516,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35516, 45.43156]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6396100,
        name: "Appartamento artistico",
        host_id: 31584851,
        host_name: "Hélène",
        latitude: 45.43322,
        longitude: 12.31424,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31424, 45.43322]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6398170,
        name: "AT RIALTO BRIDGE: ELEGANT, SPACIOUS",
        host_id: 33361636,
        host_name: "Antonio",
        latitude: 45.43799,
        longitude: 12.33523,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33523, 45.43799]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6411645,
        name: "San Giacomo Apartment",
        host_id: 5857136,
        host_name: "Mirco",
        latitude: 45.44081,
        longitude: 12.32743,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32743, 45.44081]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6419561,
        name: "Giudecca Living",
        host_id: 10014080,
        host_name: "Larry",
        latitude: 45.4255,
        longitude: 12.32718,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32718, 45.4255]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6420800,
        name: "Luxury apartment in PiazzaSan Marco",
        host_id: 10909648,
        host_name: "Francesco",
        latitude: 45.43412,
        longitude: 12.33587,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33587, 45.43412]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6451145,
        name: "ART & BEACH  wifi free",
        host_id: 12891675,
        host_name: "Mauro",
        latitude: 45.43228,
        longitude: 12.35477,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35477, 45.43228]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6456182,
        name: "Sant'Agostin Square - Art Apartments Venice",
        host_id: 28162920,
        host_name: "Beatriz",
        latitude: 45.43899,
        longitude: 12.32895,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32895, 45.43899]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6459317,
        name: "Secret Venice Room with Canal View",
        host_id: 33732689,
        host_name: "Invisible Venice",
        latitude: 45.44245,
        longitude: 12.334,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.334, 45.44245]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6459331,
        name: "Water view apt. in Molino Stucky",
        host_id: 28963983,
        host_name: "Chiara",
        latitude: 45.42824,
        longitude: 12.31766,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31766, 45.42824]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6473576,
        name: "Biennale Apartment -  Top House",
        host_id: 33818877,
        host_name: "Luciano",
        latitude: 45.43163,
        longitude: 12.35225,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35225, 45.43163]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6473703,
        name: "Giovanni residence",
        host_id: 5618111,
        host_name: "EasySuite",
        latitude: 45.43656,
        longitude: 12.32216,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32216, 45.43656]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6488939,
        name: "Your floating flat in Venice",
        host_id: 33821194,
        host_name: "Laura",
        latitude: 45.42868,
        longitude: 12.36521,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.36521, 45.42868]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6497289,
        name: "Corte Dei Servi",
        host_id: 32749544,
        host_name: "Sebastiano",
        latitude: 45.43181,
        longitude: 12.32727,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32727, 45.43181]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6507165,
        name: "LUXURY FLAT : BALCONY ON THE WATER",
        host_id: 28917209,
        host_name: "Stefano",
        latitude: 45.44557,
        longitude: 12.33017,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33017, 45.44557]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6521535,
        name: "Comfortable and bright apartment.",
        host_id: 34106604,
        host_name: "Carla Giovanna",
        latitude: 45.44084,
        longitude: 12.32509,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32509, 45.44084]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6521960,
        name: "Sleeper Venice Room with Canal view",
        host_id: 33732689,
        host_name: "Invisible Venice",
        latitude: 45.44271,
        longitude: 12.33419,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33419, 45.44271]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6530817,
        name: "Corte Lucatella apartment",
        host_id: 34158789,
        host_name: "Marco",
        latitude: 45.43492,
        longitude: 12.34072,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34072, 45.43492]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6541890,
        name: "La Ca Boldo, au coeur de Venise",
        host_id: 22632812,
        host_name: "Alain",
        latitude: 45.44047,
        longitude: 12.32926,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32926, 45.44047]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6547548,
        name: "Romantic flat in San Marco",
        host_id: 2227088,
        host_name: "Gabriele",
        latitude: 45.43255,
        longitude: 12.32861,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32861, 45.43255]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6571055,
        name: "Terrace on the Canale di San Pietro",
        host_id: 34364066,
        host_name: "Mike",
        latitude: 45.43442,
        longitude: 12.3567,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3567, 45.43442]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6579361,
        name: "Center! Large LUX Room 1min to San Marco",
        host_id: 1237620,
        host_name: "Royal Loft",
        latitude: 45.43433,
        longitude: 12.33878,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33878, 45.43433]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6584158,
        name: "Canal view, Santa Croce, POP ART house",
        host_id: 12333256,
        host_name: "Marco",
        latitude: 45.43928,
        longitude: 12.32581,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32581, 45.43928]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6598038,
        name: "Amazing Royal Loft. Center! San Marco! with a View",
        host_id: 1237620,
        host_name: "Royal Loft",
        latitude: 45.43639,
        longitude: 12.33842,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33842, 45.43639]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6630468,
        name: "Residence San Marco -  Canal View",
        host_id: 1517430,
        host_name: "Dimitri And Alessia",
        latitude: 45.43378,
        longitude: 12.33431,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33431, 45.43378]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6634377,
        name: "Rooftop flat with terrace",
        host_id: 34726009,
        host_name: "Cristina",
        latitude: 45.43481,
        longitude: 12.33002,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33002, 45.43481]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6635001,
        name: "Apartment Venetian palace",
        host_id: 34728844,
        host_name: "Linda",
        latitude: 45.43808,
        longitude: 12.32759,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32759, 45.43808]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6657921,
        name: "Cozy San Basilio with Garden View",
        host_id: 29176851,
        host_name: "Brittany",
        latitude: 45.43191,
        longitude: 12.31957,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31957, 45.43191]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6666575,
        name: "cosy mansard, private bathroom, very central",
        host_id: 12854966,
        host_name: "Francesca",
        latitude: 45.43889,
        longitude: 12.33654,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33654, 45.43889]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6677184,
        name: "Central special courtyard house",
        host_id: 10417608,
        host_name: "Omri",
        latitude: 45.44223,
        longitude: 12.33153,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33153, 45.44223]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6712947,
        name: "❤推荐ROOM ARSENALE in HEART OF VENICE",
        host_id: 35144066,
        host_name: "Xie",
        latitude: 45.43354,
        longitude: 12.34879,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34879, 45.43354]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6720560,
        name: "Luxury Rialto apartment 3",
        host_id: 7619802,
        host_name: "Stefania",
        latitude: 45.43849,
        longitude: 12.33436,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33436, 45.43849]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6735375,
        name: "LOFT IN VENICE HEART",
        host_id: 3429853,
        host_name: "Cinzia",
        latitude: 45.43658,
        longitude: 12.34173,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34173, 45.43658]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6736696,
        name: "San Marco unique gondola views",
        host_id: 35279206,
        host_name: "LMV - Exclusive Venice Apartments",
        latitude: 45.43317,
        longitude: 12.33379,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33379, 45.43317]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6739359,
        name: "TIMONE-Bright canal view apt in Cannaregio.",
        host_id: 10189388,
        host_name: "Raffaella",
        latitude: 45.44522,
        longitude: 12.33292,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33292, 45.44522]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6741034,
        name: "BANDIERA OF ARSENALE",
        host_id: 22947724,
        host_name: "Roberto",
        latitude: 45.43317,
        longitude: 12.34873,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34873, 45.43317]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6773913,
        name: "Heart of Venice! San Marco! Gondola Room. WIFI.",
        host_id: 1237620,
        host_name: "Royal Loft",
        latitude: 45.43514,
        longitude: 12.33903,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33903, 45.43514]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6779888,
        name: "luxury house very central with view",
        host_id: 31276705,
        host_name: "Mila",
        latitude: 45.43427,
        longitude: 12.34305,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34305, 45.43427]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6780661,
        name: "Luxury Rialto apartment 1",
        host_id: 7619802,
        host_name: "Stefania",
        latitude: 45.43799,
        longitude: 12.33448,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33448, 45.43799]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6782983,
        name: "Sissi Suite",
        host_id: 5857136,
        host_name: "Mirco",
        latitude: 45.43563,
        longitude: 12.34061,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34061, 45.43563]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6786873,
        name: "ATTICO CORTE SEGRETA VENEZIA",
        host_id: 12027987,
        host_name: "Michela & Stefano",
        latitude: 45.43955,
        longitude: 12.33912,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33912, 45.43955]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6787333,
        name: "Residenza All'Antiquario-Room Caterina",
        host_id: 35535185,
        host_name: "Manfredi",
        latitude: 45.44062,
        longitude: 12.32912,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32912, 45.44062]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6791981,
        name: "Design Apartment Overlooking the Canal",
        host_id: 35553140,
        host_name: "Chiara",
        latitude: 45.4374,
        longitude: 12.33993,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33993, 45.4374]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6793335,
        name: "Large Deluxe Apartment overlooking the Canal",
        host_id: 35553140,
        host_name: "Chiara",
        latitude: 45.43667,
        longitude: 12.34016,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34016, 45.43667]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6801426,
        name: "Specchieri Suite - San Marco",
        host_id: 5857136,
        host_name: "Mirco",
        latitude: 45.43459,
        longitude: 12.33918,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33918, 45.43459]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6804322,
        name: "Residenza All'Antiquario Suite Antonio",
        host_id: 35535185,
        host_name: "Manfredi",
        latitude: 45.4399,
        longitude: 12.33058,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33058, 45.4399]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6804340,
        name: "Residenza All'Antiquario-Room Battista",
        host_id: 35535185,
        host_name: "Manfredi",
        latitude: 45.44054,
        longitude: 12.32977,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32977, 45.44054]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6807287,
        name: "Gradenigo Marin",
        host_id: 22632812,
        host_name: "Alain",
        latitude: 45.44073,
        longitude: 12.32282,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32282, 45.44073]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6828778,
        name: "Ca'Barbaro vicino Guggenheim",
        host_id: 35304359,
        host_name: "Gianfranco",
        latitude: 45.42976,
        longitude: 12.33182,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33182, 45.42976]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6835007,
        name: "A Venezia SleepOver with boat tour.",
        host_id: 35809942,
        host_name: "Daryl",
        latitude: 45.43599,
        longitude: 12.35055,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35055, 45.43599]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6839203,
        name: "Home Venice Apartments - Rialto 2",
        host_id: 7619802,
        host_name: "Stefania",
        latitude: 45.4385,
        longitude: 12.33379,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33379, 45.4385]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6839737,
        name: "Renato apartment",
        host_id: 35842500,
        host_name: "Leonardo",
        latitude: 45.44177,
        longitude: 12.32736,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32736, 45.44177]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6840377,
        name: "Ca' d'Oriente - romantic studio in central Venice",
        host_id: 35845363,
        host_name: "Natalie",
        latitude: 45.43097,
        longitude: 12.3265,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3265, 45.43097]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6856271,
        name: "Ca' Celestia",
        host_id: 13968081,
        host_name: "Monica",
        latitude: 45.43796,
        longitude: 12.34838,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34838, 45.43796]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6861742,
        name: "50 STEPS TO ST. MARK'S SQUARE",
        host_id: 30283716,
        host_name: "Piero - Andrea",
        latitude: 45.43657,
        longitude: 12.34094,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34094, 45.43657]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6871770,
        name: "Giudecca San Biagio Ground Floor Apt",
        host_id: 36014159,
        host_name: "Paolo",
        latitude: 45.42699,
        longitude: 12.32319,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32319, 45.42699]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6878247,
        name: "Room with private bathroom  !",
        host_id: 17596589,
        host_name: "Claudete & Andrea",
        latitude: 45.43545,
        longitude: 12.33404,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33404, 45.43545]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6892426,
        name: "Venice Hazel Locazione Turistica Single Room",
        host_id: 17684080,
        host_name: "Rupu",
        latitude: 45.4349,
        longitude: 12.34465,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34465, 45.4349]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6892734,
        name: "Apartment Giglio with Terrace Venice",
        host_id: 7258600,
        host_name: "Enrico",
        latitude: 45.43174,
        longitude: 12.33251,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33251, 45.43174]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6904322,
        name: "Ca'Mario Flat fondamenta Cannaregio",
        host_id: 36183957,
        host_name: "Cinzia",
        latitude: 45.44598,
        longitude: 12.32277,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32277, 45.44598]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6917108,
        name: "Amazing home ( sleeps 6, 3 ba) central Venice",
        host_id: 36254380,
        host_name: "Laura Rangoni Machiavelli",
        latitude: 45.43777,
        longitude: 12.32977,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32977, 45.43777]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6919352,
        name: "B&B-Double room share bathroom",
        host_id: 17596589,
        host_name: "Claudete & Andrea",
        latitude: 45.43537,
        longitude: 12.33353,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33353, 45.43537]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6920769,
        name: "Classic",
        host_id: 14159304,
        host_name: "Davide",
        latitude: 45.42498,
        longitude: 12.33877,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33877, 45.42498]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6932592,
        name: "A gem between Rialto and San Marco",
        host_id: 36344083,
        host_name: "Valeria",
        latitude: 45.43945,
        longitude: 12.34061,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34061, 45.43945]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6933594,
        name: "Rialto Dream - Wi-Fi",
        host_id: 36324248,
        host_name: "Giovanni",
        latitude: 45.43773,
        longitude: 12.33926,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33926, 45.43773]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6944952,
        name: "WINARETTA",
        host_id: 15337957,
        host_name: "Marie",
        latitude: 45.42966,
        longitude: 12.32854,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32854, 45.42966]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6945804,
        name: "(Website hidden by Airbnb) Secret Garden",
        host_id: 32749544,
        host_name: "Sebastiano",
        latitude: 45.43264,
        longitude: 12.32731,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32731, 45.43264]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6969152,
        name: "Ca Felice - Secret spot in the heart of Venice",
        host_id: 36540828,
        host_name: "Sibylle Antonia",
        latitude: 45.44292,
        longitude: 12.32936,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32936, 45.44292]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6971128,
        name: "TWO BEDROOMS  CANAL VIEW SAN MARCO",
        host_id: 12244227,
        host_name: "Roberto",
        latitude: 45.43806,
        longitude: 12.34625,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34625, 45.43806]] },
    },
    {
      type: "Feature",
      properties: {
        id: 6987387,
        name: "CASA SERENA, very close to Biennale",
        host_id: 36633893,
        host_name: "Harald And Valeria",
        latitude: 45.43366,
        longitude: 12.35293,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35293, 45.43366]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7000071,
        name: "Venice Altanina",
        host_id: 29918538,
        host_name: "Youinvenice",
        latitude: 45.4373,
        longitude: 12.34747,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34747, 45.4373]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7005013,
        name: "The venetian Penthouse",
        host_id: 3972291,
        host_name: "Caroline E Marco",
        latitude: 45.43419,
        longitude: 12.33141,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33141, 45.43419]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7031652,
        name: 'Aria e Luce - Suite "Dei Venti"',
        host_id: 10598888,
        host_name: "Arianna & Luca",
        latitude: 45.43831,
        longitude: 12.34181,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34181, 45.43831]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7061986,
        name: "Cute flat in the heart of Venice",
        host_id: 37030368,
        host_name: "Tania",
        latitude: 45.44635,
        longitude: 12.32216,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32216, 45.44635]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7061996,
        name: "Venice Hazel Locaz. Turistica Triple Private Room",
        host_id: 17684080,
        host_name: "Rupu",
        latitude: 45.43479,
        longitude: 12.34304,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34304, 45.43479]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7080860,
        name: "Ca' Del Glicine",
        host_id: 669047,
        host_name: "Viewsonvenice",
        latitude: 45.44067,
        longitude: 12.34009,
        beds: 10,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34009, 45.44067]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7083696,
        name: "BALCONY-GHETTO 2pax internet aircond, wifi",
        host_id: 36053748,
        host_name: "Mick",
        latitude: 45.44696,
        longitude: 12.32397,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32397, 45.44696]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7126942,
        name: "CA' LUDOVICA-Bright family apartment - 4 Sleep.",
        host_id: 10189388,
        host_name: "Raffaella",
        latitude: 45.44147,
        longitude: 12.33935,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33935, 45.44147]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7132497,
        name: "Private Private Room Int.",
        host_id: 37356947,
        host_name: "Nicola",
        latitude: 45.43578,
        longitude: 12.34237,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34237, 45.43578]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7140675,
        name: "App. CampielloBarbaro in Venice",
        host_id: 37395876,
        host_name: "Sergio",
        latitude: 45.42931,
        longitude: 12.33259,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33259, 45.42931]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7140959,
        name: "App. Cà Canziani - Venice-flat",
        host_id: 37395876,
        host_name: "Sergio",
        latitude: 45.42979,
        longitude: 12.33307,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33307, 45.42979]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7154840,
        name: "Central apartment Venice",
        host_id: 35359376,
        host_name: "Emanuela",
        latitude: 45.4403,
        longitude: 12.33992,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33992, 45.4403]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7161107,
        name: "Classic Dorsoduro's Appartment",
        host_id: 27660927,
        host_name: "Elisabetta",
        latitude: 45.43035,
        longitude: 12.32706,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32706, 45.43035]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7168638,
        name: "GRAND CANAL LOVE NEST#2, deck, aircond, Wifi",
        host_id: 36053748,
        host_name: "Mick",
        latitude: 45.43706,
        longitude: 12.32908,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32908, 45.43706]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7212771,
        name: "Comfortable Canal View Apartment",
        host_id: 21628642,
        host_name: "Leonardo",
        latitude: 45.44718,
        longitude: 12.32328,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32328, 45.44718]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7215726,
        name: "San Marco, Calle delle Rasse -- Wi-Fi",
        host_id: 36324248,
        host_name: "Giovanni",
        latitude: 45.43453,
        longitude: 12.34184,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34184, 45.43453]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7223658,
        name: "RED EMOTION - ROOM IN VENICE CENTER",
        host_id: 37814406,
        host_name: "Jenny",
        latitude: 45.43569,
        longitude: 12.31832,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31832, 45.43569]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7235391,
        name: "Cozy bright apartment",
        host_id: 33389445,
        host_name: "Goffredo",
        latitude: 45.43534,
        longitude: 12.3484,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3484, 45.43534]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7236712,
        name: "Palazzo Foscarini elegant apartmen.",
        host_id: 15758689,
        host_name: "Anna",
        latitude: 45.43282,
        longitude: 12.32209,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32209, 45.43282]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7238292,
        name: "MOON&LAGOON - ROOM IN VENICE CENTER",
        host_id: 37814406,
        host_name: "Jenny",
        latitude: 45.43628,
        longitude: 12.31933,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31933, 45.43628]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7239705,
        name: "LOVELY TIME - ROOM IN VENICE CENTER",
        host_id: 37814406,
        host_name: "Jenny",
        latitude: 45.43571,
        longitude: 12.31933,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31933, 45.43571]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7243749,
        name: 'NEW NEW!!! "THE SMALL HOME"',
        host_id: 25843433,
        host_name: "Carolina",
        latitude: 45.43671,
        longitude: 12.33445,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33445, 45.43671]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7269190,
        name: "Ve.N.I.Ce Cera Palazzo Grimani",
        host_id: 37864680,
        host_name: "Ve.N.I.Ce Immobiliare Cera",
        latitude: 45.43225,
        longitude: 12.33358,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33358, 45.43225]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7270153,
        name: "Sailor's Loft Accademia",
        host_id: 37955209,
        host_name: "Tea",
        latitude: 45.43088,
        longitude: 12.32979,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32979, 45.43088]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7270857,
        name: "Apartment @ Molino Stucky, Giudecca",
        host_id: 19633948,
        host_name: "Domenico",
        latitude: 45.42735,
        longitude: 12.3191,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3191, 45.42735]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7275955,
        name: "Venice, Fisherman's apartment,quit,Dorsoduro",
        host_id: 38094481,
        host_name: "Elena",
        latitude: 45.43199,
        longitude: 12.32556,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32556, 45.43199]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7286111,
        name: "Zattere luxury fully accessible water front 3 bdrs",
        host_id: 11353579,
        host_name: "Giorgio",
        latitude: 45.42874,
        longitude: 12.33247,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33247, 45.42874]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7286266,
        name: "Zattere Luxury apartment 3 bedrooms",
        host_id: 11353579,
        host_name: "Giorgio",
        latitude: 45.42887,
        longitude: 12.33245,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33245, 45.42887]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7312362,
        name: "Luxury S&A San Marco Palace, 3mins from the square",
        host_id: 38311524,
        host_name: "Luca",
        latitude: 45.43528,
        longitude: 12.34515,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34515, 45.43528]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7314165,
        name: "Casa Zucchi Appartamento sul Canal Grande",
        host_id: 35773124,
        host_name: "Mariacaterina",
        latitude: 45.43249,
        longitude: 12.3318,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3318, 45.43249]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7318177,
        name: "New!!! Red House with Canal view",
        host_id: 38338874,
        host_name: "Marco",
        latitude: 45.43233,
        longitude: 12.35005,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35005, 45.43233]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7324080,
        name: "Large Private Room opposite Ca'D'Oro Palace",
        host_id: 38365694,
        host_name: "Mara",
        latitude: 45.44164,
        longitude: 12.33446,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33446, 45.44164]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7328002,
        name: "ARRIVING BY TRAIN 4pax, aircond, WiFi",
        host_id: 36053748,
        host_name: "Mick",
        latitude: 45.4398,
        longitude: 12.32251,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32251, 45.4398]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7351160,
        name: "aunt's home - la casa della zia",
        host_id: 38519147,
        host_name: "Maria Cristina",
        latitude: 45.43811,
        longitude: 12.324,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.324, 45.43811]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7355365,
        name: "Ca' Frezzeria",
        host_id: 34360885,
        host_name: "Samuel",
        latitude: 45.43423,
        longitude: 12.33593,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33593, 45.43423]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7359491,
        name: "Via Garibaldi Biennale",
        host_id: 29918538,
        host_name: "Youinvenice",
        latitude: 45.43133,
        longitude: 12.35322,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35322, 45.43133]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7375963,
        name: "QUADRUPLE ROOM canal view",
        host_id: 33732689,
        host_name: "Invisible Venice",
        latitude: 45.44405,
        longitude: 12.33438,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33438, 45.44405]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7377084,
        name: "Large double room, Giudecca 323.",
        host_id: 38646475,
        host_name: "Paola",
        latitude: 45.42516,
        longitude: 12.32798,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32798, 45.42516]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7377975,
        name: "Wi-fi & TV sat, hydro massage shower",
        host_id: 34106604,
        host_name: "Carla Giovanna",
        latitude: 45.44154,
        longitude: 12.32488,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32488, 45.44154]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7387026,
        name: "Your Room with Canal view in Venice",
        host_id: 33732689,
        host_name: "Invisible Venice",
        latitude: 45.44453,
        longitude: 12.33405,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33405, 45.44453]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7397041,
        name: "Great central apt with big terrace",
        host_id: 2635682,
        host_name: "Marco",
        latitude: 45.43652,
        longitude: 12.33943,
        beds: 8,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33943, 45.43652]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7397263,
        name: "Ancient Venetian style apartment",
        host_id: 26153558,
        host_name: "Alberto",
        latitude: 45.44156,
        longitude: 12.33523,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33523, 45.44156]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7398139,
        name: "CA' DEL MORO - Between the Biennale and St. Mark!",
        host_id: 10189388,
        host_name: "Raffaella",
        latitude: 45.43611,
        longitude: 12.34708,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34708, 45.43611]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7400250,
        name: "APARTMENT AT THE BIENNALE",
        host_id: 38773814,
        host_name: "Elda",
        latitude: 45.43296,
        longitude: 12.35082,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35082, 45.43296]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7431855,
        name: "Campiello Tron.",
        host_id: 35938893,
        host_name: "Gilberto",
        latitude: 45.43386,
        longitude: 12.31547,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31547, 45.43386]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7442465,
        name: "Ve.N.I.Ce Cera Casa De La Vida",
        host_id: 37864680,
        host_name: "Ve.N.I.Ce Immobiliare Cera",
        latitude: 45.43495,
        longitude: 12.32427,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32427, 45.43495]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7443012,
        name: "Ve.N.I.Ce Cera Ca' De La Mandola",
        host_id: 37864680,
        host_name: "Ve.N.I.Ce Immobiliare Cera",
        latitude: 45.43556,
        longitude: 12.33225,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33225, 45.43556]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7447670,
        name: "appartamento di charme",
        host_id: 39002767,
        host_name: "Attilio",
        latitude: 45.44001,
        longitude: 12.34084,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34084, 45.44001]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7470460,
        name: "Appartamento de lo strologo",
        host_id: 39128601,
        host_name: "Jacopo",
        latitude: 45.44392,
        longitude: 12.32927,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32927, 45.44392]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7474290,
        name: "❤推荐ROOM ARSENALE in HEART OF VENICE",
        host_id: 35144066,
        host_name: "Xie",
        latitude: 45.43378,
        longitude: 12.34909,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34909, 45.43378]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7486905,
        name: "Your home near Accademia",
        host_id: 22555548,
        host_name: "JiaHang",
        latitude: 45.42968,
        longitude: 12.33106,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33106, 45.42968]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7490511,
        name: "MyPlace Ponte Lion Standard App.",
        host_id: 26102869,
        host_name: "My Sweetplace S.R.L.",
        latitude: 45.4373,
        longitude: 12.34456,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34456, 45.4373]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7492278,
        name: "Harmony SB",
        host_id: 39240019,
        host_name: "Marcello",
        latitude: 45.43255,
        longitude: 12.31849,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31849, 45.43255]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7493028,
        name: "Appartamento Verde",
        host_id: 36457323,
        host_name: "Rossella & Giulio",
        latitude: 45.44174,
        longitude: 12.34101,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34101, 45.44174]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7494178,
        name: "Just 10 minutes from Rialto Bridge",
        host_id: 36846039,
        host_name: "Veronica",
        latitude: 45.44388,
        longitude: 12.33789,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33789, 45.44388]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7498644,
        name: "ELISA",
        host_id: 15337957,
        host_name: "Marie",
        latitude: 45.4305,
        longitude: 12.32866,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32866, 45.4305]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7500294,
        name: "Sant'Aponal: nel cuore di Venezia",
        host_id: 2847482,
        host_name: "Maria",
        latitude: 45.43695,
        longitude: 12.33274,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33274, 45.43695]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7504380,
        name: "Ca' del Giardino, flat with garden",
        host_id: 39311197,
        host_name: "Federica",
        latitude: 45.43872,
        longitude: 12.3256,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3256, 45.43872]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7510046,
        name: "Truly Venice Apartment",
        host_id: 37381363,
        host_name: "Horacio",
        latitude: 45.44035,
        longitude: 12.33261,
        beds: 8,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33261, 45.44035]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7511803,
        name: "Homey spacious apartment, comfortable and central",
        host_id: 4654704,
        host_name: "Nicola",
        latitude: 45.44087,
        longitude: 12.3346,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3346, 45.44087]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7524616,
        name: "Central double room in Venice",
        host_id: 39431094,
        host_name: "Armina",
        latitude: 45.44182,
        longitude: 12.32677,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32677, 45.44182]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7555273,
        name: "Apt. Ca Maria Pia",
        host_id: 39600986,
        host_name: "Christine",
        latitude: 45.44136,
        longitude: 12.33297,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33297, 45.44136]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7558369,
        name: "Apt. Ca Maria - Castello",
        host_id: 39600986,
        host_name: "Christine",
        latitude: 45.44001,
        longitude: 12.34413,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34413, 45.44001]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7559409,
        name: "Appartamento Azzurro. Two bathrooms",
        host_id: 36457323,
        host_name: "Rossella & Giulio",
        latitude: 45.44138,
        longitude: 12.34136,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34136, 45.44138]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7568948,
        name: "Garibaldi Cinema House - Biennale Zone",
        host_id: 7672609,
        host_name: "Gian Luigi & Nicola",
        latitude: 45.43289,
        longitude: 12.35558,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35558, 45.43289]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7573969,
        name: "Dorsoduro/Luxury/AC/Huge Terrazzo",
        host_id: 39709985,
        host_name: "Gerard",
        latitude: 45.43431,
        longitude: 12.31825,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31825, 45.43431]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7578003,
        name: "Cosy Room with W/C",
        host_id: 32482509,
        host_name: "Elisabeth",
        latitude: 45.44448,
        longitude: 12.32197,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32197, 45.44448]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7609968,
        name: "Historical flat Casa Venier",
        host_id: 39910319,
        host_name: "Alberto",
        latitude: 45.4353,
        longitude: 12.34635,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34635, 45.4353]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7610529,
        name: "Historical flat Casa Venier A",
        host_id: 39910319,
        host_name: "Alberto",
        latitude: 45.4366,
        longitude: 12.34644,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34644, 45.4366]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7613713,
        name: "San Marco Venezia Campo Sant'Angelo",
        host_id: 39929805,
        host_name: "Katia",
        latitude: 45.43296,
        longitude: 12.33288,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33288, 45.43296]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7624650,
        name: "San Giorgio Apartment in the heart of Venice",
        host_id: 39921225,
        host_name: "Stefania",
        latitude: 45.43451,
        longitude: 12.34641,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34641, 45.43451]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7670387,
        name: "B&B LeTerese- Room Miranda with canal view",
        host_id: 1666986,
        host_name: "Antonella",
        latitude: 45.43204,
        longitude: 12.31504,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31504, 45.43204]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7692223,
        name: "DolceVita Apartments N. 192: Penthouse San Marco",
        host_id: 8176475,
        host_name: "Eugenia",
        latitude: 45.43576,
        longitude: 12.33803,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33803, 45.43576]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7718939,
        name: "Casa in Laguna con bella terrazza",
        host_id: 34158789,
        host_name: "Marco",
        latitude: 45.43802,
        longitude: 12.34617,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34617, 45.43802]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7738227,
        name: "La Mansarda di Eliseo",
        host_id: 39115325,
        host_name: "Stefania",
        latitude: 45.43569,
        longitude: 12.3282,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3282, 45.43569]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7744599,
        name: "Your B&B close to the Biennale",
        host_id: 40707541,
        host_name: "Leonardo",
        latitude: 45.43683,
        longitude: 12.34708,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34708, 45.43683]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7746234,
        name: "The Warehouse: comfortably modern.",
        host_id: 40718055,
        host_name: "Anna",
        latitude: 45.43344,
        longitude: 12.31826,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31826, 45.43344]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7747831,
        name: "La Calma Apartment in Venice",
        host_id: 6759756,
        host_name: "Rudi",
        latitude: 45.44145,
        longitude: 12.3351,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3351, 45.44145]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7757043,
        name: "Appartamento Palazzo Canal Grande",
        host_id: 40786720,
        host_name: "Elisabetta",
        latitude: 45.43341,
        longitude: 12.32577,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32577, 45.43341]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7757492,
        name: "S. Barnaba Apartment",
        host_id: 31630574,
        host_name: "Tania",
        latitude: 45.43362,
        longitude: 12.32472,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32472, 45.43362]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7782292,
        name: "Peace and comfort 2-Ca'della Sensa",
        host_id: 4618179,
        host_name: "Christine",
        latitude: 45.44559,
        longitude: 12.32743,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32743, 45.44559]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7807219,
        name: "UNA NOTTE CON MARILYN",
        host_id: 7739710,
        host_name: "Célia",
        latitude: 45.42886,
        longitude: 12.36267,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.36267, 45.42886]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7827966,
        name: "Mario Apartment 2 Wi-Fi",
        host_id: 10072655,
        host_name: "Mario Apartment",
        latitude: 45.43896,
        longitude: 12.32923,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32923, 45.43896]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7848012,
        name: "Studio in Ghetto with canal view",
        host_id: 41354846,
        host_name: "Ermanno",
        latitude: 45.44475,
        longitude: 12.32865,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32865, 45.44475]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7853686,
        name: 'Room in a house "Ai Giocattoli"',
        host_id: 41385857,
        host_name: "Luca Pietro",
        latitude: 45.44277,
        longitude: 12.33887,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33887, 45.44277]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7857693,
        name: "VERY NICE TO MEET YOU!",
        host_id: 3177129,
        host_name: "Giovanna",
        latitude: 45.43449,
        longitude: 12.3413,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3413, 45.43449]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7866901,
        name: "Biennale of Venice apartment wifi",
        host_id: 10072655,
        host_name: "Mario Apartment",
        latitude: 45.43644,
        longitude: 12.34842,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34842, 45.43644]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7873268,
        name: "Enjoy your stay in ❤ Venice ❤",
        host_id: 198581,
        host_name: "Laura",
        latitude: 45.43685,
        longitude: 12.32738,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32738, 45.43685]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7883694,
        name: "21 STEPS FROM ST. MARK SQUARE!!",
        host_id: 41559211,
        host_name: "Venice",
        latitude: 45.43436,
        longitude: 12.33705,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33705, 45.43436]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7892994,
        name: "Lovely Room in the Heart of Venice",
        host_id: 33732689,
        host_name: "Invisible Venice",
        latitude: 45.44442,
        longitude: 12.33323,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33323, 45.44442]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7904984,
        name: "Central and modern apartment",
        host_id: 41684464,
        host_name: "VeneziaImmobiliare Sas Di",
        latitude: 45.44504,
        longitude: 12.32143,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32143, 45.44504]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7912117,
        name: "Cà Rolina Biennale San Marco",
        host_id: 10236261,
        host_name: "Federico",
        latitude: 45.43963,
        longitude: 12.34526,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34526, 45.43963]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7913488,
        name: "Attico + Terrazza, asc.: Cannaregio",
        host_id: 41668952,
        host_name: "Francesco",
        latitude: 45.44406,
        longitude: 12.32196,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32196, 45.44406]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7923840,
        name: "Unforgettable Venetian Canal Views",
        host_id: 41785109,
        host_name: "Davide",
        latitude: 45.43709,
        longitude: 12.31978,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31978, 45.43709]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7930853,
        name: "SAN MARCO ECONOMY - In Venice city centre",
        host_id: 10189388,
        host_name: "Raffaella",
        latitude: 45.43545,
        longitude: 12.33125,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33125, 45.43545]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7933241,
        name: "Wonderful flat in Venetian style",
        host_id: 41711000,
        host_name: "Betty E Oscar",
        latitude: 45.43638,
        longitude: 12.32557,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32557, 45.43638]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7937417,
        name: "DELIGHTFUL CANAL VIEW APARTMENT",
        host_id: 4018771,
        host_name: "Francesco And Nina",
        latitude: 45.44306,
        longitude: 12.3345,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3345, 45.44306]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7942842,
        name: "Ca' Del Capitello - Fondamenta Della Misericordia",
        host_id: 10174216,
        host_name: "Furio",
        latitude: 45.44476,
        longitude: 12.32631,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32631, 45.44476]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7945076,
        name: "Beautiful and quiet house",
        host_id: 1843823,
        host_name: "Benedetta",
        latitude: 45.43353,
        longitude: 12.33064,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33064, 45.43353]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7952792,
        name: "Typical Venetian (wifi) apartment",
        host_id: 10072655,
        host_name: "Mario Apartment",
        latitude: 45.44643,
        longitude: 12.32734,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32734, 45.44643]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7969977,
        name: "VEryNICE  tra campielli e canali di Venezia",
        host_id: 42055334,
        host_name: "Paola",
        latitude: 45.44013,
        longitude: 12.33886,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33886, 45.44013]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7979035,
        name: "stanza privata a venezia",
        host_id: 10081954,
        host_name: "Lotta Ortheil",
        latitude: 45.43374,
        longitude: 12.35532,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35532, 45.43374]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7992019,
        name: "Venice Penthouse Canal View - WiFi - A/C",
        host_id: 17762135,
        host_name: "Edoardo",
        latitude: 45.43798,
        longitude: 12.32932,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32932, 45.43798]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7994922,
        name: "Opens out on the Canale di Cannaregio, 1st floor",
        host_id: 42201697,
        host_name: "Martine",
        latitude: 45.44254,
        longitude: 12.33155,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33155, 45.44254]] },
    },
    {
      type: "Feature",
      properties: {
        id: 7995323,
        name: "3 bedrooms apartment in the Biennale area",
        host_id: 1617572,
        host_name: "Silvia",
        latitude: 45.43791,
        longitude: 12.34188,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34188, 45.43791]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8004575,
        name: "Lovely in San Marco - Wi-Fi",
        host_id: 36324248,
        host_name: "Giovanni",
        latitude: 45.43357,
        longitude: 12.33614,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33614, 45.43357]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8005560,
        name: "stanza privata con 2 letti singoli",
        host_id: 42266104,
        host_name: "Maria",
        latitude: 45.44029,
        longitude: 12.32616,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32616, 45.44029]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8019312,
        name: "camera con bagno venezia",
        host_id: 42345791,
        host_name: "Anna",
        latitude: 45.43372,
        longitude: 12.32468,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32468, 45.43372]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8030678,
        name: "GIUDECCA: LAST MINUTE FESTIVAL",
        host_id: 3243904,
        host_name: "Benedetta",
        latitude: 45.42559,
        longitude: 12.32737,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32737, 45.42559]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8037623,
        name: "AI PUGNI APARTMENT",
        host_id: 15758689,
        host_name: "Anna",
        latitude: 45.43405,
        longitude: 12.32482,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32482, 45.43405]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8075834,
        name: "Casa Allegra, near the centre",
        host_id: 42660204,
        host_name: "Loredana",
        latitude: 45.44418,
        longitude: 12.33328,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33328, 45.44418]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8110137,
        name: "Casa on canal, cozy home-canal view",
        host_id: 26404861,
        host_name: "Marika",
        latitude: 45.43642,
        longitude: 12.32437,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32437, 45.43642]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8110162,
        name: "large privat bath in great location",
        host_id: 31276705,
        host_name: "Mila",
        latitude: 45.44464,
        longitude: 12.32975,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32975, 45.44464]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8110382,
        name: "Simpatico monolocale a Venezia",
        host_id: 31520151,
        host_name: "Violetta",
        latitude: 45.44346,
        longitude: 12.33582,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33582, 45.44346]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8137049,
        name: "Casa Veronica-Venice's heart",
        host_id: 42965837,
        host_name: "Veronica",
        latitude: 45.43942,
        longitude: 12.32923,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32923, 45.43942]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8150952,
        name: "Exceptional Penthouse Apartment Overlooking the Grand Canal",
        host_id: 23810951,
        host_name: "Claudio",
        latitude: 45.43806,
        longitude: 12.33411,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33411, 45.43806]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8163491,
        name: "S.Marco, independent room with terrace & bathroom",
        host_id: 25929924,
        host_name: "Al",
        latitude: 45.4345,
        longitude: 12.33494,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33494, 45.4345]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8168561,
        name: "Cosy and central flat",
        host_id: 43101296,
        host_name: "Maria Cristina",
        latitude: 45.44063,
        longitude: 12.32696,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32696, 45.44063]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8222905,
        name: "Skipper's Place",
        host_id: 43356965,
        host_name: "Elena",
        latitude: 45.43027,
        longitude: 12.32998,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32998, 45.43027]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8243945,
        name: "Apartament Venice",
        host_id: 43475976,
        host_name: "Hanna",
        latitude: 45.43489,
        longitude: 12.33731,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33731, 45.43489]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8278121,
        name: "MyPlace Ponte Lion with terrace",
        host_id: 26102869,
        host_name: "My Sweetplace S.R.L.",
        latitude: 45.43702,
        longitude: 12.34568,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34568, 45.43702]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8279036,
        name: "Ca'Rialto",
        host_id: 10909648,
        host_name: "Francesco",
        latitude: 45.43651,
        longitude: 12.33035,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33035, 45.43651]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8280321,
        name: "MyPlace Ponte Lion Maisonette",
        host_id: 26102869,
        host_name: "My Sweetplace S.R.L.",
        latitude: 45.43526,
        longitude: 12.34394,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34394, 45.43526]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8284635,
        name: "Ca' La Boheme",
        host_id: 34360885,
        host_name: "Samuel",
        latitude: 45.43205,
        longitude: 12.325,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.325, 45.43205]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8301050,
        name: "MyPlace Ponte Lion Deluxe App.",
        host_id: 26102869,
        host_name: "My Sweetplace S.R.L.",
        latitude: 45.43516,
        longitude: 12.34527,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34527, 45.43516]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8301408,
        name: "MyPlace Ponte Lion Apartment",
        host_id: 26102869,
        host_name: "My Sweetplace S.R.L.",
        latitude: 45.43594,
        longitude: 12.34501,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34501, 45.43594]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8301935,
        name: "Attico Miracoli",
        host_id: 43771057,
        host_name: "Sviluppo 29",
        latitude: 45.4404,
        longitude: 12.33687,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33687, 45.4404]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8307927,
        name:
          "Ca' del Vin la vostra casa a Rialto. M (Phone number hidden by Airbnb)",
        host_id: 43716376,
        host_name: "Gianni",
        latitude: 45.43865,
        longitude: 12.33443,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33443, 45.43865]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8316114,
        name: "Comfortable apartment in Rialto",
        host_id: 43843547,
        host_name: "Matteo",
        latitude: 45.43852,
        longitude: 12.33346,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33346, 45.43852]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8321476,
        name: "Amazing Biennale S Marc romantic canal view flat",
        host_id: 43866603,
        host_name: "Barbara",
        latitude: 45.43699,
        longitude: 12.34924,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34924, 45.43699]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8324279,
        name: "Venice in the house",
        host_id: 43882598,
        host_name: "Tommaso",
        latitude: 45.43879,
        longitude: 12.33153,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33153, 45.43879]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8331583,
        name: "Camera Diamante Blu Rialto (brand new)",
        host_id: 2053550,
        host_name: "Stefania",
        latitude: 45.43653,
        longitude: 12.33166,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33166, 45.43653]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8333530,
        name: "Imperial Suite Canal View",
        host_id: 43929434,
        host_name: "Manuel E Michela",
        latitude: 45.4356,
        longitude: 12.34738,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34738, 45.4356]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8336912,
        name: "Typical Venetian Apartment, Cannaregio",
        host_id: 43945952,
        host_name: "Arben",
        latitude: 45.44733,
        longitude: 12.32528,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32528, 45.44733]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8362117,
        name: "Casa Lucia, luxury furnished and central",
        host_id: 42454908,
        host_name: "Silvia",
        latitude: 45.43526,
        longitude: 12.33253,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33253, 45.43526]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8363189,
        name: "Loft Casa Aurora",
        host_id: 44079946,
        host_name: "Carlos Aurora",
        latitude: 45.44488,
        longitude: 12.33371,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33371, 45.44488]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8378294,
        name: "Historical flat near Cà d'Oro Palace",
        host_id: 11876634,
        host_name: "Lucia E Riccardo",
        latitude: 45.44158,
        longitude: 12.33588,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33588, 45.44158]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8379825,
        name: "In the heart of Venice, Rialto",
        host_id: 44161864,
        host_name: "Carlo",
        latitude: 45.43672,
        longitude: 12.33607,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33607, 45.43672]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8397634,
        name: "Palazzo Smith Valmarana",
        host_id: 34712560,
        host_name: "Stefano",
        latitude: 45.4396,
        longitude: 12.33699,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33699, 45.4396]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8397733,
        name: "Ampio e funzionale appartamento a un passo da Piazza San Marco",
        host_id: 430236,
        host_name: "Paola",
        latitude: 45.43341,
        longitude: 12.33482,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33482, 45.43341]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8404426,
        name: "At the entrance Venice-2 bathrooms-fully equipped",
        host_id: 44274762,
        host_name: "Alberto",
        latitude: 45.44389,
        longitude: 12.31809,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31809, 45.44389]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8413310,
        name: "Classy Palazzo Badoer Studio Apartment",
        host_id: 44076744,
        host_name: "Marzia",
        latitude: 45.43746,
        longitude: 12.32575,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32575, 45.43746]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8415086,
        name:
          "Ca' Dada con vista su canale  ID: M (Phone number hidden by Airbnb)",
        host_id: 44324218,
        host_name: "Margherita",
        latitude: 45.43846,
        longitude: 12.32863,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32863, 45.43846]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8415088,
        name: "St. Mark's Square,A/C,Comfort,Cosy,Wifi...",
        host_id: 44325314,
        host_name: "Corinne",
        latitude: 45.43342,
        longitude: 12.33489,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33489, 45.43342]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8415289,
        name: "SWEET APARTMENT",
        host_id: 2602970,
        host_name: "Elena",
        latitude: 45.43805,
        longitude: 12.35538,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35538, 45.43805]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8419894,
        name: "Venice Giardini terrace and view",
        host_id: 44346264,
        host_name: "Veronique",
        latitude: 45.43242,
        longitude: 12.35161,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35161, 45.43242]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8442335,
        name: "A separate and quiet house",
        host_id: 25446696,
        host_name: "Laura",
        latitude: 45.43292,
        longitude: 12.3539,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3539, 45.43292]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8450312,
        name: "Sanctuary in Cool Dorsoduro with Private Backyard",
        host_id: 1805539,
        host_name: "Julian",
        latitude: 45.43194,
        longitude: 12.32228,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32228, 45.43194]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8494536,
        name: "Mercanti 3526 comfortable canal view apartment",
        host_id: 21959178,
        host_name: "Mattia",
        latitude: 45.4449,
        longitude: 12.33354,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33354, 45.4449]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8496973,
        name: "Newly renovated+WIFI Historic center Entire flat",
        host_id: 2118409,
        host_name: "Francesca",
        latitude: 45.43921,
        longitude: 12.32579,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32579, 45.43921]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8510757,
        name: "Ca' Rossini 1 Apartment",
        host_id: 669047,
        host_name: "Viewsonvenice",
        latitude: 45.43572,
        longitude: 12.33182,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33182, 45.43572]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8511172,
        name: "Ca' Rossini 2 Apartment for 4 Guests",
        host_id: 669047,
        host_name: "Viewsonvenice",
        latitude: 45.4348,
        longitude: 12.33239,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33239, 45.4348]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8511779,
        name: "Handy apartment, historical Venice",
        host_id: 9558269,
        host_name: "Nicola",
        latitude: 45.44127,
        longitude: 12.33641,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33641, 45.44127]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8512972,
        name: "Ponte delle Tette 1 Double Bedroom",
        host_id: 393913,
        host_name: "Luca",
        latitude: 45.43861,
        longitude: 12.33032,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33032, 45.43861]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8514014,
        name: "Ca' delle Carozze",
        host_id: 44832403,
        host_name: "Gérard-Julien",
        latitude: 45.43433,
        longitude: 12.32911,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32911, 45.43433]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8526323,
        name: "Apartment 10 minutes from Rialto Bridge",
        host_id: 44324629,
        host_name: "Francesca",
        latitude: 45.43988,
        longitude: 12.3267,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3267, 45.43988]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8543433,
        name: "Ca' Belle Arti Apartment",
        host_id: 669047,
        host_name: "Viewsonvenice",
        latitude: 45.43014,
        longitude: 12.3295,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3295, 45.43014]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8544305,
        name: "Entrance of Venice, Cosy, Quiet,Wifi, Terrace",
        host_id: 44852663,
        host_name: "Luciano",
        latitude: 45.44421,
        longitude: 12.32764,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32764, 45.44421]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8547877,
        name: "Cupido apartment, view of Canal Grande",
        host_id: 44990889,
        host_name: "Anna",
        latitude: 45.44386,
        longitude: 12.32786,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32786, 45.44386]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8547913,
        name: "Felicity Canal Grande View",
        host_id: 44990889,
        host_name: "Anna",
        latitude: 45.44315,
        longitude: 12.32765,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32765, 45.44315]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8561757,
        name: "La grande casa di Calle S. Caterina",
        host_id: 36846039,
        host_name: "Veronica",
        latitude: 45.44372,
        longitude: 12.33766,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33766, 45.44372]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8585743,
        name: "Appartamento La Palma",
        host_id: 40786720,
        host_name: "Elisabetta",
        latitude: 45.4379,
        longitude: 12.32722,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32722, 45.4379]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8617509,
        name: "Stunning, in the heart of Venice",
        host_id: 45332807,
        host_name: "Ester Maria",
        latitude: 45.44093,
        longitude: 12.32648,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32648, 45.44093]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8619939,
        name: "San Marco Venezia bellissimo app",
        host_id: 45343814,
        host_name: "Andreina",
        latitude: 45.43525,
        longitude: 12.33507,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33507, 45.43525]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8625916,
        name: "Ca' Gabriella",
        host_id: 45370570,
        host_name: "Chiara",
        latitude: 45.43731,
        longitude: 12.34163,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34163, 45.43731]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8637296,
        name: "Cà San Marco",
        host_id: 43854158,
        host_name: "Aristide",
        latitude: 45.43262,
        longitude: 12.3373,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3373, 45.43262]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8640382,
        name: "Savorgnan Tricamere con terrazza",
        host_id: 5857136,
        host_name: "Mirco",
        latitude: 45.44491,
        longitude: 12.32237,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32237, 45.44491]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8641186,
        name: "Appartamento  nel cuore di Venezia.",
        host_id: 19949792,
        host_name: "Luisa",
        latitude: 45.44332,
        longitude: 12.33232,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33232, 45.44332]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8644501,
        name: "Cosy apartment for couples super speedy WIFI & a/c",
        host_id: 2508340,
        host_name: "Giacomo",
        latitude: 45.44675,
        longitude: 12.32231,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32231, 45.44675]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8657702,
        name: "Saint Mark's Terrace - Skyline",
        host_id: 29176851,
        host_name: "Brittany",
        latitude: 45.4351,
        longitude: 12.33862,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33862, 45.4351]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8676557,
        name: "Cà Neni: holidays & relax in Venice",
        host_id: 45571612,
        host_name: "Paolo",
        latitude: 45.43801,
        longitude: 12.344,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.344, 45.43801]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8678116,
        name: "Indipendent house in Venice",
        host_id: 39588782,
        host_name: "Giulio",
        latitude: 45.42892,
        longitude: 12.33177,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33177, 45.42892]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8681909,
        name: "Canal-side apartment with roof deck",
        host_id: 45556824,
        host_name: "Deborah",
        latitude: 45.43245,
        longitude: 12.31889,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31889, 45.43245]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8693866,
        name: "RESIDENZA DONDEL: FREE WIFI & NEAR SAN MARCO",
        host_id: 3736168,
        host_name: "EasyRentals",
        latitude: 45.4334,
        longitude: 12.35302,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35302, 45.4334]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8694159,
        name: "Charming Penthouse with terrace",
        host_id: 5656401,
        host_name: "Manila",
        latitude: 45.4412,
        longitude: 12.3351,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3351, 45.4412]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8706007,
        name: "The Blue Room",
        host_id: 45701831,
        host_name: "Federica",
        latitude: 45.44633,
        longitude: 12.33265,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33265, 45.44633]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8707998,
        name: "NICE APARTMENT",
        host_id: 2602970,
        host_name: "Elena",
        latitude: 45.43757,
        longitude: 12.35636,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35636, 45.43757]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8713991,
        name: "La Casetta Apartment",
        host_id: 33994702,
        host_name: "Antonella",
        latitude: 45.44251,
        longitude: 12.33858,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33858, 45.44251]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8731464,
        name: "Secret Garden Suite",
        host_id: 40786720,
        host_name: "Elisabetta",
        latitude: 45.43477,
        longitude: 12.32626,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32626, 45.43477]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8732320,
        name: "Bollicine Sparkling Apartment",
        host_id: 1408761,
        host_name: "Chiara",
        latitude: 45.43726,
        longitude: 12.33032,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33032, 45.43726]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8736169,
        name: "appartamento signorile in centro",
        host_id: 31657413,
        host_name: "Giada",
        latitude: 45.43302,
        longitude: 12.33236,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33236, 45.43302]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8771122,
        name: "50 steps from St.Mark's Square",
        host_id: 42442454,
        host_name: "Claudia",
        latitude: 45.43408,
        longitude: 12.33575,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33575, 45.43408]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8773861,
        name: "View the Grand Canal from Luxury Palace Apartment",
        host_id: 44990889,
        host_name: "Anna",
        latitude: 45.4438,
        longitude: 12.32656,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32656, 45.4438]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8794503,
        name: "Casa Loredana",
        host_id: 46086362,
        host_name: "Marco",
        latitude: 45.43364,
        longitude: 12.35678,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35678, 45.43364]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8809559,
        name: "Poeti e contemplativi a Cannaregio",
        host_id: 28786777,
        host_name: "Fiorenza",
        latitude: 45.44441,
        longitude: 12.33076,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33076, 45.44441]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8823494,
        name: "pink venetian very central",
        host_id: 31276705,
        host_name: "Mila",
        latitude: 45.43679,
        longitude: 12.34278,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34278, 45.43679]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8825687,
        name: "Sagredo Suite",
        host_id: 5857136,
        host_name: "Mirco",
        latitude: 45.439,
        longitude: 12.34814,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34814, 45.439]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8836022,
        name: "Cosy home overlooking Venice lagoon",
        host_id: 39227348,
        host_name: "Tessa",
        latitude: 45.42629,
        longitude: 12.36018,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.36018, 45.42629]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8854140,
        name: "Your B&B close to the Biennale 2",
        host_id: 40707541,
        host_name: "Leonardo",
        latitude: 45.43697,
        longitude: 12.34861,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34861, 45.43697]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8854773,
        name: "Corte degli Oleandri",
        host_id: 46361691,
        host_name: "Irene",
        latitude: 45.43842,
        longitude: 12.32103,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32103, 45.43842]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8864203,
        name: "Soak up the History at a 17th-century Venetian Palazzo",
        host_id: 4495122,
        host_name: "Luca",
        latitude: 45.44127,
        longitude: 12.33718,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33718, 45.44127]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8883521,
        name: "Casa Morosini - Apartment Casanova",
        host_id: 46466051,
        host_name: "Alberto",
        latitude: 45.44032,
        longitude: 12.32822,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32822, 45.44032]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8884707,
        name: "In the heart of cannaregio",
        host_id: 20685673,
        host_name: "Gabriel",
        latitude: 45.44329,
        longitude: 12.33205,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33205, 45.44329]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8893375,
        name: "Suite Tower Rialto",
        host_id: 46528252,
        host_name: "Alex",
        latitude: 45.43963,
        longitude: 12.33352,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33352, 45.43963]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8934329,
        name: "AI SOGNATORI VENEZIA - CANAL VIEW",
        host_id: 23598673,
        host_name: "Patricia",
        latitude: 45.43797,
        longitude: 12.32995,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32995, 45.43797]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8960236,
        name: "An Oasis in the Heart of Venice",
        host_id: 46829903,
        host_name: "Miles",
        latitude: 45.4399,
        longitude: 12.33638,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33638, 45.4399]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8966009,
        name: "Shabby Rouge-Single/Double- Guglie",
        host_id: 4799502,
        host_name: "Alice",
        latitude: 45.4446,
        longitude: 12.32556,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32556, 45.4446]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8967445,
        name: "Yellow Bistrot - Single room-Guglie",
        host_id: 4799502,
        host_name: "Alice",
        latitude: 45.44311,
        longitude: 12.32537,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32537, 45.44311]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8976493,
        name: "Blue Liberty-Private bathroom",
        host_id: 4799502,
        host_name: "Alice",
        latitude: 45.44371,
        longitude: 12.32603,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32603, 45.44371]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8978848,
        name: "Fantastic Penthouse Canareggio Area",
        host_id: 46914920,
        host_name: "Andrea",
        latitude: 45.43017,
        longitude: 12.32593,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32593, 45.43017]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8985892,
        name: "Piccolo appartamento Venezia centro",
        host_id: 46943946,
        host_name: "Francesca",
        latitude: 45.43434,
        longitude: 12.32676,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32676, 45.43434]] },
    },
    {
      type: "Feature",
      properties: {
        id: 8997441,
        name: "Storica dimora nel cuore di Venezia",
        host_id: 46995286,
        host_name: "Andrea",
        latitude: 45.4352,
        longitude: 12.32413,
        beds: 7,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32413, 45.4352]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9002601,
        name: "Calle delle Vele lovely apartment",
        host_id: 47015309,
        host_name: "Germana",
        latitude: 45.442,
        longitude: 12.33576,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33576, 45.442]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9003118,
        name: "Stanza in Campo S.Polo Appartamento",
        host_id: 47016421,
        host_name: "Carlo",
        latitude: 45.4373,
        longitude: 12.33204,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33204, 45.4373]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9011339,
        name: '"BIGHOUSE" VENICE NEW AND LUXURY FLAT',
        host_id: 29357340,
        host_name: "Nello",
        latitude: 45.43578,
        longitude: 12.342,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.342, 45.43578]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9039288,
        name: "Charming apartment close to Rialto",
        host_id: 47005691,
        host_name: "Guido",
        latitude: 45.44244,
        longitude: 12.34061,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34061, 45.44244]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9044935,
        name: "Venice San Marco Apartment",
        host_id: 47196919,
        host_name: "Leopoldo",
        latitude: 45.43414,
        longitude: 12.33824,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33824, 45.43414]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9045303,
        name: "Stanza privata in appartamento",
        host_id: 42266104,
        host_name: "Maria",
        latitude: 45.44019,
        longitude: 12.3278,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3278, 45.44019]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9053589,
        name: "Anat Ganor",
        host_id: 25532196,
        host_name: "Anat",
        latitude: 45.42869,
        longitude: 12.33179,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33179, 45.42869]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9058492,
        name: "Central spacious apartment with patio X701",
        host_id: 15178567,
        host_name: "Paolo",
        latitude: 45.43784,
        longitude: 12.33983,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33983, 45.43784]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9058807,
        name: "Venice Rialto downtown Wi-Fi  FREE",
        host_id: 47257291,
        host_name: "Elisabetta",
        latitude: 45.43745,
        longitude: 12.33221,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33221, 45.43745]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9069766,
        name: "Venetian style room",
        host_id: 11399969,
        host_name: "Barbara",
        latitude: 45.43383,
        longitude: 12.3322,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3322, 45.43383]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9073500,
        name: "S. Stae Apartment",
        host_id: 47322920,
        host_name: "Mario & Esmeralda",
        latitude: 45.4408,
        longitude: 12.33111,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33111, 45.4408]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9090191,
        name: "VERY COSY&QUIET IN LOVELY&AUTHENTIC AREA",
        host_id: 47397935,
        host_name: "Alain",
        latitude: 45.43253,
        longitude: 12.35542,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35542, 45.43253]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9102681,
        name: "Venice Aseo Canal View WIFI",
        host_id: 29918538,
        host_name: "Youinvenice",
        latitude: 45.44635,
        longitude: 12.33063,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33063, 45.44635]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9104416,
        name: "Zen bright flat in Castello area",
        host_id: 47458448,
        host_name: "Riccardo",
        latitude: 45.43222,
        longitude: 12.35683,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35683, 45.43222]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9106293,
        name: "Lovely friendly Linda room",
        host_id: 47464104,
        host_name: "Linda",
        latitude: 45.43874,
        longitude: 12.34575,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34575, 45.43874]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9107354,
        name: "Una casa nel cuore di Venezia",
        host_id: 6029259,
        host_name: "Andrea",
        latitude: 45.43654,
        longitude: 12.32213,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32213, 45.43654]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9108262,
        name: "B&B VENICE CORTE VECCHIA : SAN VIO",
        host_id: 47449955,
        host_name: "Tokuro",
        latitude: 45.42931,
        longitude: 12.33132,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33132, 45.42931]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9108292,
        name: "B&B VENICE CORTE VECCHIA : LA CORTE",
        host_id: 47449955,
        host_name: "Tokuro",
        latitude: 45.43017,
        longitude: 12.33092,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33092, 45.43017]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9122510,
        name: "B&B VENICE CORTE VECCHIA : CARBONA",
        host_id: 47449955,
        host_name: "Tokuro",
        latitude: 45.42902,
        longitude: 12.33122,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33122, 45.42902]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9124604,
        name: "Le Venise des Vénitiens chez Guido",
        host_id: 38992365,
        host_name: "Guido",
        latitude: 45.43482,
        longitude: 12.32284,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32284, 45.43482]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9124905,
        name:
          "newcasa splendida biennale giardini ID M (Phone number hidden by Airbnb)",
        host_id: 47537231,
        host_name: "Nicoletta",
        latitude: 45.432,
        longitude: 12.35724,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35724, 45.432]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9127914,
        name: "Budget cosy Studio near Rialto bridge",
        host_id: 47549577,
        host_name: "Silvia",
        latitude: 45.43735,
        longitude: 12.33178,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33178, 45.43735]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9128571,
        name: "Casa della Crea with canal view",
        host_id: 632312,
        host_name: "Guillaume",
        latitude: 45.44511,
        longitude: 12.32087,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32087, 45.44511]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9134897,
        name: "very central very venetian green",
        host_id: 31276705,
        host_name: "Mila",
        latitude: 45.43542,
        longitude: 12.34275,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34275, 45.43542]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9142974,
        name: "DolceVita Apartments N 285 Biennale",
        host_id: 8176475,
        host_name: "Eugenia",
        latitude: 45.43326,
        longitude: 12.35737,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35737, 45.43326]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9152055,
        name: "family apartment with CAR PARK",
        host_id: 14114346,
        host_name: "Lost In",
        latitude: 45.43764,
        longitude: 12.31897,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31897, 45.43764]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9158679,
        name: "Canal view near Smarco Square wi-fi",
        host_id: 10072655,
        host_name: "Mario Apartment",
        latitude: 45.4373,
        longitude: 12.34264,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34264, 45.4373]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9161055,
        name: "An attic among the rooftops of San Marco",
        host_id: 47687671,
        host_name: "Roberta",
        latitude: 45.4349,
        longitude: 12.34198,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34198, 45.4349]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9165710,
        name: "AI SOGNATORI VENICE - DOUBLE VIEW",
        host_id: 23598673,
        host_name: "Patricia",
        latitude: 45.43903,
        longitude: 12.32884,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32884, 45.43903]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9166645,
        name: "Nice mini apartment",
        host_id: 47708701,
        host_name: "Max",
        latitude: 45.4462,
        longitude: 12.31973,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31973, 45.4462]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9194369,
        name: "San Marco Suite with Canal View",
        host_id: 47828661,
        host_name: "Andrea",
        latitude: 45.43347,
        longitude: 12.33554,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33554, 45.43347]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9196021,
        name: '"LA CORTE" to Venice',
        host_id: 47836560,
        host_name: "Rosanna",
        latitude: 45.4461,
        longitude: 12.32945,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32945, 45.4461]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9211208,
        name: "Luminoso appartamento con ampio cortile privato",
        host_id: 46954103,
        host_name: "Fabio&Linda",
        latitude: 45.43848,
        longitude: 12.34782,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34782, 45.43848]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9215979,
        name: "MARTY GUEST HOUSE VENEZIA: SAN MARCO - LA SUITE",
        host_id: 41520379,
        host_name: "Arianna",
        latitude: 45.43372,
        longitude: 12.32822,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32822, 45.43372]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9221588,
        name: "Biennale 252 - 20 min from S. Marco",
        host_id: 5857136,
        host_name: "Mirco",
        latitude: 45.43178,
        longitude: 12.35857,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35857, 45.43178]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9221933,
        name: "Canal view and private patio!",
        host_id: 6019189,
        host_name: "Federico",
        latitude: 45.44004,
        longitude: 12.32464,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32464, 45.44004]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9226520,
        name: "Ca' Novo - Luxury Accommodation",
        host_id: 47967886,
        host_name: "Barnaba",
        latitude: 45.43763,
        longitude: 12.33485,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33485, 45.43763]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9235177,
        name: "elegant charming design Irish flat",
        host_id: 31276705,
        host_name: "Mila",
        latitude: 45.44304,
        longitude: 12.33069,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33069, 45.44304]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9242824,
        name: "Da Enry e Simo",
        host_id: 36874382,
        host_name: "Paolo Enrico Simone",
        latitude: 45.44531,
        longitude: 12.32916,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32916, 45.44531]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9250324,
        name: "Venezia Appartamento Campo Ruga 314",
        host_id: 16415177,
        host_name: "Angelo",
        latitude: 45.43322,
        longitude: 12.35675,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35675, 45.43322]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9253183,
        name: "RESIDENZA LEON D' ORO: FREE WIFI",
        host_id: 3736168,
        host_name: "EasyRentals",
        latitude: 45.44292,
        longitude: 12.32391,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32391, 45.44292]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9255501,
        name: "Best location Venice Female",
        host_id: 27990266,
        host_name: "Ai",
        latitude: 45.43682,
        longitude: 12.34081,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34081, 45.43682]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9256272,
        name: "Best location in Venice",
        host_id: 27990266,
        host_name: "Ai",
        latitude: 45.436,
        longitude: 12.3385,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3385, 45.436]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9257437,
        name: "charming elegant IRISH Flat In the Centre",
        host_id: 48092742,
        host_name: "Roby",
        latitude: 45.44269,
        longitude: 12.33426,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33426, 45.44269]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9266518,
        name: "Cosy double in Venice ( true venetian experience )",
        host_id: 1232519,
        host_name: "Natale",
        latitude: 45.44153,
        longitude: 12.33755,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33755, 45.44153]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9266647,
        name: "Venice Rainbow apartment (Rialto 2)",
        host_id: 22623713,
        host_name: "Rupu",
        latitude: 45.43786,
        longitude: 12.33343,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33343, 45.43786]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9269272,
        name: "Venice centre, modern apartment",
        host_id: 27266211,
        host_name: "Giorgia",
        latitude: 45.44304,
        longitude: 12.32068,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32068, 45.44304]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9272095,
        name: "Casanova suite With View on Canal",
        host_id: 48092742,
        host_name: "Roby",
        latitude: 45.43211,
        longitude: 12.35662,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35662, 45.43211]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9285934,
        name: "Imperial Italian Design Room",
        host_id: 48092742,
        host_name: "Roby",
        latitude: 45.44401,
        longitude: 12.33,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33, 45.44401]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9304596,
        name: "Venice Speon San Marco",
        host_id: 29918538,
        host_name: "Youinvenice",
        latitude: 45.4358,
        longitude: 12.3374,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3374, 45.4358]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9306056,
        name: "Appartement à 10 mn de Place S.Marc",
        host_id: 27790374,
        host_name: "Beatrice",
        latitude: 45.43663,
        longitude: 12.34723,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34723, 45.43663]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9306259,
        name: "Charming 3bdr flat with balcony in Venice",
        host_id: 11505507,
        host_name: "Alexandra",
        latitude: 45.44383,
        longitude: 12.31941,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31941, 45.44383]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9343775,
        name: "50 STEPS FROM RIALTO BRIDGE",
        host_id: 30283716,
        host_name: "Piero - Andrea",
        latitude: 45.43763,
        longitude: 12.33279,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33279, 45.43763]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9353622,
        name: "Cà Morena,apartment for relax",
        host_id: 14117590,
        host_name: "Moreno",
        latitude: 45.43724,
        longitude: 12.32803,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32803, 45.43724]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9361240,
        name: "Venice historic center entire appartment",
        host_id: 48482767,
        host_name: "Marco",
        latitude: 45.44002,
        longitude: 12.34266,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34266, 45.44002]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9366647,
        name: "DolceVita Apartments 287 San Marco",
        host_id: 8176475,
        host_name: "Eugenia",
        latitude: 45.43514,
        longitude: 12.33267,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33267, 45.43514]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9380650,
        name: "Suite Doge Marcello. Rialto Bridge.  Santa Marina",
        host_id: 8862107,
        host_name: "Maurizio",
        latitude: 45.43723,
        longitude: 12.33885,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33885, 45.43723]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9400256,
        name: "A gothic magnificence upon Rialto's canals!",
        host_id: 43101354,
        host_name: "Cristiana",
        latitude: 45.43803,
        longitude: 12.33849,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33849, 45.43803]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9405082,
        name: "Hemingway - Charming flat in Venice",
        host_id: 18578747,
        host_name: "Solange",
        latitude: 45.43346,
        longitude: 12.31843,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31843, 45.43346]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9419714,
        name: "Bohémian apartment in the heart of Venice",
        host_id: 6072487,
        host_name: "Silvia",
        latitude: 45.44235,
        longitude: 12.3394,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3394, 45.44235]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9425327,
        name: "CA’ DI LEO, NOBLE VENETIAN RESIDENCE",
        host_id: 294951,
        host_name: "VeniceVillas Di Enzo",
        latitude: 45.43592,
        longitude: 12.34027,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34027, 45.43592]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9457650,
        name: "Casa Luminosa",
        host_id: 5857136,
        host_name: "Mirco",
        latitude: 45.43894,
        longitude: 12.32567,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32567, 45.43894]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9458326,
        name: "Cà Tentor appartamento a Rialto",
        host_id: 49013797,
        host_name: "Fabiana",
        latitude: 45.43696,
        longitude: 12.3369,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3369, 45.43696]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9474547,
        name: "Venezian House",
        host_id: 49102301,
        host_name: "Moha",
        latitude: 45.43915,
        longitude: 12.31427,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31427, 45.43915]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9483564,
        name: "CA BIENNALE wifi apartment",
        host_id: 49154952,
        host_name: "Maurizio",
        latitude: 45.43188,
        longitude: 12.351,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.351, 45.43188]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9486116,
        name: "Ca' Valmarana",
        host_id: 49167377,
        host_name: "Roberta",
        latitude: 45.43798,
        longitude: 12.33237,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33237, 45.43798]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9486637,
        name: "Casa Furlani grande",
        host_id: 632312,
        host_name: "Guillaume",
        latitude: 45.43686,
        longitude: 12.34662,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34662, 45.43686]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9487623,
        name: "CA TANA Wifi apartment",
        host_id: 49154952,
        host_name: "Maurizio",
        latitude: 45.43402,
        longitude: 12.35174,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35174, 45.43402]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9489068,
        name: "Bilocale carino in centro Venezia",
        host_id: 49181269,
        host_name: "Andrea",
        latitude: 45.42964,
        longitude: 12.35891,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35891, 45.42964]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9517420,
        name: "Charming and Modern Venice Centre",
        host_id: 49314019,
        host_name: "Silena",
        latitude: 45.43826,
        longitude: 12.34553,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34553, 45.43826]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9527124,
        name: "Venezian local",
        host_id: 49102301,
        host_name: "Moha",
        latitude: 45.4398,
        longitude: 12.32719,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32719, 45.4398]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9535987,
        name: "Ca' Dell'Opera Luxury Apartment",
        host_id: 669047,
        host_name: "Viewsonvenice",
        latitude: 45.42882,
        longitude: 12.33127,
        beds: 8,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33127, 45.42882]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9570457,
        name: "KEY LOCATION! Near Palazzo Grassi and San Marco!",
        host_id: 49546184,
        host_name: "Antonio&Luisa",
        latitude: 45.43318,
        longitude: 12.32817,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32817, 45.43318]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9576197,
        name: "Best location in Venice female only",
        host_id: 27990266,
        host_name: "Ai",
        latitude: 45.43514,
        longitude: 12.34088,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34088, 45.43514]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9588952,
        name: "Soggiorno nel cuore di Venezia",
        host_id: 49631872,
        host_name: "Francesca",
        latitude: 45.44419,
        longitude: 12.3289,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3289, 45.44419]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9607928,
        name: "Venice room WITH BRAKFAST",
        host_id: 14114346,
        host_name: "Lost In",
        latitude: 45.438,
        longitude: 12.32076,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32076, 45.438]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9608713,
        name: "Venice room",
        host_id: 14114346,
        host_name: "Lost In",
        latitude: 45.43719,
        longitude: 12.3176,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3176, 45.43719]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9623669,
        name: "ROOFTOP Residence - Canal Grande",
        host_id: 49780429,
        host_name: "D&V",
        latitude: 45.43983,
        longitude: 12.33131,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33131, 45.43983]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9625712,
        name:
          "Quaint condo in central Venice with gorgeous views and easy access to sights!",
        host_id: 4339678,
        host_name: "Vacasa Italy - Venice",
        latitude: 45.43812,
        longitude: 12.33689,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33689, 45.43812]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9640644,
        name: "Guggenheim with Canal View - Art Apartments Venice",
        host_id: 28162920,
        host_name: "Beatriz",
        latitude: 45.43029,
        longitude: 12.33318,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33318, 45.43029]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9640894,
        name: "Biennale - Art Apartments Venice",
        host_id: 28162920,
        host_name: "Beatriz",
        latitude: 45.43541,
        longitude: 12.34678,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34678, 45.43541]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9642040,
        name: "A WEEK IN CENTRAL SAN MARCO SUITE",
        host_id: 49471384,
        host_name: "Omar",
        latitude: 45.4351,
        longitude: 12.33672,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33672, 45.4351]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9644525,
        name: "CA BRAGADIN with lift, wifi apartment",
        host_id: 49154952,
        host_name: "Maurizio",
        latitude: 45.44327,
        longitude: 12.33306,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33306, 45.44327]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9657046,
        name: "ciprea",
        host_id: 20983059,
        host_name: "Ciprea",
        latitude: 45.43128,
        longitude: 12.35603,
        beds: 7,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35603, 45.43128]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9660384,
        name: "Comfort & Pleasure STORAGE FOR BAGS",
        host_id: 49930101,
        host_name: "Elena",
        latitude: 45.4362,
        longitude: 12.34692,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34692, 45.4362]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9661017,
        name: "Charming apartment in Venice with canal views",
        host_id: 35279206,
        host_name: "LMV - Exclusive Venice Apartments",
        latitude: 45.43387,
        longitude: 12.33611,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33611, 45.43387]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9673914,
        name: "Dimora Marciana San Marco Square Superior DBL",
        host_id: 49986250,
        host_name: "Dimora",
        latitude: 45.43361,
        longitude: 12.33683,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33683, 45.43361]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9675219,
        name: "Ca' Nal - GONDOLA - S.Mark -Rialto",
        host_id: 49990117,
        host_name: "Alberta",
        latitude: 45.43724,
        longitude: 12.33748,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33748, 45.43724]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9696001,
        name: "Dream of Venice",
        host_id: 50072669,
        host_name: "Linda",
        latitude: 45.43264,
        longitude: 12.3524,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3524, 45.43264]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9703606,
        name: "Casa MIA-Venezia",
        host_id: 50104909,
        host_name: "Antonella",
        latitude: 45.42573,
        longitude: 12.32697,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32697, 45.42573]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9706549,
        name: "Residence Lagoon - Amazing view of lagoon",
        host_id: 50118656,
        host_name: "Valentino",
        latitude: 45.42387,
        longitude: 12.32659,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32659, 45.42387]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9706595,
        name: "CASTELLO THE VENICE'S HEART",
        host_id: 50118636,
        host_name: "Calliope",
        latitude: 45.43416,
        longitude: 12.34915,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34915, 45.43416]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9721372,
        name: "Luxury Split Level Family Suite Near Rialto Bridge",
        host_id: 41370935,
        host_name: "Corte",
        latitude: 45.43886,
        longitude: 12.33012,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33012, 45.43886]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9721487,
        name: "Luxury Family Suite Near Rialto Bridge",
        host_id: 41370935,
        host_name: "Corte",
        latitude: 45.43977,
        longitude: 12.33177,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33177, 45.43977]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9727843,
        name: "Ca' Nal -BRAGOZZO- S.Mark - Rialto",
        host_id: 49990117,
        host_name: "Alberta",
        latitude: 45.4351,
        longitude: 12.33667,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33667, 45.4351]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9728717,
        name: "Ca' Nal -SANPIEROTA- S.Mark - Rialto",
        host_id: 49990117,
        host_name: "Alberta",
        latitude: 45.4356,
        longitude: 12.33817,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33817, 45.4356]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9741322,
        name: "Ca' Nal - SANDOLO - S.Mark - Rialto",
        host_id: 49990117,
        host_name: "Alberta",
        latitude: 45.43584,
        longitude: 12.33826,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33826, 45.43584]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9741873,
        name: "Ca'Nal-PUPPARIN with altana terrace S.Mark view",
        host_id: 49990117,
        host_name: "Alberta",
        latitude: 45.43512,
        longitude: 12.33842,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33842, 45.43512]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9743144,
        name: "Tintoretto Canal View WiFi Free",
        host_id: 50266229,
        host_name: "Giulia",
        latitude: 45.44439,
        longitude: 12.33296,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33296, 45.44439]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9744920,
        name: "Ca' Del Barba Frutariol",
        host_id: 34360885,
        host_name: "Samuel",
        latitude: 45.44204,
        longitude: 12.339,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.339, 45.44204]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9746346,
        name: "Ve.N.I.Ce Cera Casa Del Sol-Rialto",
        host_id: 37864680,
        host_name: "Ve.N.I.Ce Immobiliare Cera",
        latitude: 45.43773,
        longitude: 12.3326,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3326, 45.43773]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9747748,
        name: "Ca' Navagero 1-Riva degli Schiavoni",
        host_id: 50282865,
        host_name: "Alberta",
        latitude: 45.43466,
        longitude: 12.34477,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34477, 45.43466]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9748627,
        name: "Ca' Navagero 2-Riva degli Schiavoni",
        host_id: 50282865,
        host_name: "Alberta",
        latitude: 45.435,
        longitude: 12.34496,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34496, 45.435]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9764045,
        name: "Luxury San Marco Apartment",
        host_id: 50349340,
        host_name: "Sebastiano",
        latitude: 45.43423,
        longitude: 12.33594,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33594, 45.43423]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9764400,
        name: "Bed & Breakfast Santo Stefano-Calle Crosera VE",
        host_id: 50351368,
        host_name: "Ven",
        latitude: 45.43393,
        longitude: 12.33092,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33092, 45.43393]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9770775,
        name: "Tower Suite San Marco Apartment",
        host_id: 50349340,
        host_name: "Sebastiano",
        latitude: 45.43531,
        longitude: 12.3359,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3359, 45.43531]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9782838,
        name: "Romantic Escapade in Venice",
        host_id: 26963742,
        host_name: "Enrico",
        latitude: 45.43473,
        longitude: 12.33244,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33244, 45.43473]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9793810,
        name: "Rialto twins house, Venice center.",
        host_id: 1729833,
        host_name: "Alberto",
        latitude: 45.43757,
        longitude: 12.33122,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33122, 45.43757]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9799776,
        name: "Appartamento per vacanze a Venezia",
        host_id: 50499932,
        host_name: "Milo",
        latitude: 45.4327,
        longitude: 12.31648,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31648, 45.4327]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9801176,
        name: "Ca' della Fava, Rialto San Marco Canal View Palace",
        host_id: 37211726,
        host_name: null,
        latitude: 45.43754,
        longitude: 12.33903,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33903, 45.43754]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9802687,
        name: "Luxury Suite Near Rialto Bridge",
        host_id: 41370935,
        host_name: "Corte",
        latitude: 45.4403,
        longitude: 12.32972,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32972, 45.4403]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9806002,
        name: "SMERALDO M (Phone number hidden by Airbnb)",
        host_id: 29271096,
        host_name: "Ari",
        latitude: 45.43484,
        longitude: 12.32873,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32873, 45.43484]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9816247,
        name: "Ca dei Zoti 2 - San Marco with luggages room",
        host_id: 2825961,
        host_name: "Maria Beatrice",
        latitude: 45.43298,
        longitude: 12.32883,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32883, 45.43298]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9817138,
        name: "Comfortable arrangement in Venice",
        host_id: 50569236,
        host_name: "Francesco",
        latitude: 45.42533,
        longitude: 12.32499,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32499, 45.42533]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9821595,
        name: "FEEL@HOME Venice BIENNALE",
        host_id: 20319964,
        host_name: "Marco",
        latitude: 45.4325,
        longitude: 12.35382,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35382, 45.4325]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9823137,
        name: "Designed Luxury Venetian Apartment",
        host_id: 193059,
        host_name: "Oliva Nera",
        latitude: 45.43616,
        longitude: 12.34552,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34552, 45.43616]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9830370,
        name: "Nice and cozy apartment in residential area !!!",
        host_id: 50629170,
        host_name: "Alessia",
        latitude: 45.42431,
        longitude: 12.32588,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32588, 45.42431]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9856969,
        name: "HD Apartment I",
        host_id: 50739522,
        host_name: "Hanna",
        latitude: 45.43471,
        longitude: 12.32945,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32945, 45.43471]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9861952,
        name: "New charming private ensuite room.",
        host_id: 8865074,
        host_name: "Valerie",
        latitude: 45.44678,
        longitude: 12.3272,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3272, 45.44678]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9870560,
        name: "House on the water in Venice",
        host_id: 50796723,
        host_name: "Federico",
        latitude: 45.43072,
        longitude: 12.32854,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32854, 45.43072]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9878614,
        name: "Typical aparment in San Marco M (Phone number hidden by Airbnb)",
        host_id: 20806166,
        host_name: "Giovanna",
        latitude: 45.43656,
        longitude: 12.34138,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34138, 45.43656]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9878674,
        name: "Nice and cozy bedroom in Venice!",
        host_id: 22583902,
        host_name: "Federica",
        latitude: 45.42694,
        longitude: 12.32288,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32288, 45.42694]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9889903,
        name: "Feeling at home in Venice",
        host_id: 49492029,
        host_name: "Paolo",
        latitude: 45.43842,
        longitude: 12.34659,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34659, 45.43842]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9892432,
        name: "Nido d' amore a due ponti da Rialto",
        host_id: 50885316,
        host_name: "Francesca",
        latitude: 45.43634,
        longitude: 12.32971,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32971, 45.43634]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9894178,
        name: "Graziosa casa vicino a  San Marco.",
        host_id: 50891610,
        host_name: "Fabrizio",
        latitude: 45.43354,
        longitude: 12.35132,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35132, 45.43354]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9899916,
        name: "CA' TERLOTTA",
        host_id: 50914489,
        host_name: "Andrea",
        latitude: 45.43632,
        longitude: 12.33901,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33901, 45.43632]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9909921,
        name: 'BE HOME SELF CHECK IN "SHORT-LONG TERM WELCOME"',
        host_id: 50956593,
        host_name: "Cristina",
        latitude: 45.44039,
        longitude: 12.32837,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32837, 45.44039]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9912450,
        name: "Venetian Elegant and Charming Suite",
        host_id: 6019189,
        host_name: "Federico",
        latitude: 45.43689,
        longitude: 12.32522,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32522, 45.43689]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9912737,
        name: "Style 1: spacious, modern and with every comfort",
        host_id: 289615,
        host_name: "Valentina",
        latitude: 45.44295,
        longitude: 12.32222,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32222, 45.44295]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9912887,
        name: "Spacious flat close to train station & free WIFI",
        host_id: 289615,
        host_name: "Valentina",
        latitude: 45.44308,
        longitude: 12.31991,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31991, 45.44308]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9917537,
        name: "Adorable flat close to St. Barnaba",
        host_id: 12497228,
        host_name: "Canal Grande",
        latitude: 45.43252,
        longitude: 12.32531,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32531, 45.43252]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9920412,
        name: "My Friend, Venice Canal View",
        host_id: 13027859,
        host_name: "Diego",
        latitude: 45.44688,
        longitude: 12.31912,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31912, 45.44688]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9921027,
        name: "Sant'Aponal Flat near Rialto Bridge",
        host_id: 399883,
        host_name: "Monica",
        latitude: 45.43888,
        longitude: 12.33278,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33278, 45.43888]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9925743,
        name: "Testa d'Oro 1",
        host_id: 51021330,
        host_name: "Francesco",
        latitude: 45.43721,
        longitude: 12.33544,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33544, 45.43721]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9954327,
        name: "NEW CENTRAL ATTIC WITH ALTANA",
        host_id: 21835799,
        host_name: "Martina",
        latitude: 45.43932,
        longitude: 12.34384,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34384, 45.43932]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9954595,
        name: "Lilia - Apartment in Venice",
        host_id: 5656401,
        host_name: "Manila",
        latitude: 45.44444,
        longitude: 12.32842,
        beds: 8,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32842, 45.44444]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9956196,
        name: "Camelia - Boutique Apartments",
        host_id: 5656401,
        host_name: "Manila",
        latitude: 45.4458,
        longitude: 12.32836,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32836, 45.4458]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9965937,
        name: "BIENNALE EASY aircond, 2pax wifi,courtyard",
        host_id: 17534457,
        host_name: "Abaca",
        latitude: 45.43395,
        longitude: 12.3586,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3586, 45.43395]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9968217,
        name: "Residenza Formosa 3",
        host_id: 632312,
        host_name: "Guillaume",
        latitude: 45.43767,
        longitude: 12.34259,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34259, 45.43767]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9983438,
        name: "Shared Double Bathroom",
        host_id: 25022476,
        host_name: "Antonio",
        latitude: 45.43801,
        longitude: 12.33127,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33127, 45.43801]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9987541,
        name: "Matrimoniale Best Holidays Venice",
        host_id: 25022476,
        host_name: "Antonio",
        latitude: 45.43988,
        longitude: 12.33124,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33124, 45.43988]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9988301,
        name: "Tripla Best Holidays Venice",
        host_id: 25022476,
        host_name: "Antonio",
        latitude: 45.44007,
        longitude: 12.33171,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33171, 45.44007]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9993440,
        name: "Residenza Giudecca Molino Stucky",
        host_id: 51341661,
        host_name: "Maurizio",
        latitude: 45.42749,
        longitude: 12.32082,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32082, 45.42749]] },
    },
    {
      type: "Feature",
      properties: {
        id: 9996205,
        name: "CA' SOL VIEW ON CANAL GRANDE",
        host_id: 3281444,
        host_name: "Attilio & Arelis",
        latitude: 45.43892,
        longitude: 12.33504,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33504, 45.43892]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10002488,
        name: "Appartamento Rosso",
        host_id: 36457323,
        host_name: "Rossella & Giulio",
        latitude: 45.4421,
        longitude: 12.33995,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33995, 45.4421]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10004997,
        name: "Lofty flat with rooftop view by Frari's",
        host_id: 51394011,
        host_name: "Davide",
        latitude: 45.43636,
        longitude: 12.32955,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32955, 45.43636]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10009859,
        name: "Marcopolo Studio",
        host_id: 20256253,
        host_name: "Chiara",
        latitude: 45.44324,
        longitude: 12.32626,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32626, 45.44324]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10010200,
        name: "Tintoretto Apartment",
        host_id: 20256253,
        host_name: "Chiara",
        latitude: 45.44307,
        longitude: 12.32513,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32513, 45.44307]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10017979,
        name: "Campo Santa Margherita a Venezia",
        host_id: 41852772,
        host_name: "Maria Carola",
        latitude: 45.43355,
        longitude: 12.32303,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32303, 45.43355]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10027171,
        name: "Porta Orientalis Studio 1",
        host_id: 20256253,
        host_name: "Chiara",
        latitude: 45.44327,
        longitude: 12.32513,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32513, 45.44327]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10046189,
        name: "Stunning views",
        host_id: 51507762,
        host_name: "Lilia",
        latitude: 45.43185,
        longitude: 12.32732,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32732, 45.43185]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10046490,
        name: "Canal View - Wi-Fi",
        host_id: 36324248,
        host_name: "Giovanni",
        latitude: 45.43921,
        longitude: 12.32744,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32744, 45.43921]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10047867,
        name: "San Marco studio, located in a very strategic street",
        host_id: 35279206,
        host_name: "LMV - Exclusive Venice Apartments",
        latitude: 45.43261,
        longitude: 12.3356,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3356, 45.43261]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10049943,
        name: "Cà Venissa",
        host_id: 11864207,
        host_name: "Rossella",
        latitude: 45.43665,
        longitude: 12.33021,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33021, 45.43665]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10062009,
        name: "Venetian life - heart of Venice",
        host_id: 685637,
        host_name: "Chris",
        latitude: 45.44303,
        longitude: 12.32845,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32845, 45.44303]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10063279,
        name: "Loft Regina",
        host_id: 5857136,
        host_name: "Mirco",
        latitude: 45.43858,
        longitude: 12.33126,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33126, 45.43858]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10079867,
        name: "Charming Venice  apartment Santa Margherita Square",
        host_id: 35279206,
        host_name: "LMV - Exclusive Venice Apartments",
        latitude: 45.43296,
        longitude: 12.31869,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31869, 45.43296]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10081454,
        name: "Fresia - Apartment in Venice",
        host_id: 5656401,
        host_name: "Manila",
        latitude: 45.44394,
        longitude: 12.32677,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32677, 45.44394]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10098003,
        name: "Beautiful apartment with terrace",
        host_id: 6620102,
        host_name: "Emanuele",
        latitude: 45.44034,
        longitude: 12.32385,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32385, 45.44034]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10112295,
        name: "Brand new apartment for couples",
        host_id: 2508340,
        host_name: "Giacomo",
        latitude: 45.44425,
        longitude: 12.33491,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33491, 45.44425]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10114617,
        name: "AI LEONCINI - San Marco, belltower view, elevator",
        host_id: 10189388,
        host_name: "Raffaella",
        latitude: 45.43499,
        longitude: 12.33951,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33951, 45.43499]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10114926,
        name: "Venice House",
        host_id: 51908098,
        host_name: "Marco",
        latitude: 45.43895,
        longitude: 12.32753,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32753, 45.43895]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10117414,
        name: "Palazzetto Duodo o Barbarigo - San Marco Venezia",
        host_id: 39129966,
        host_name: "Rita",
        latitude: 45.43275,
        longitude: 12.33154,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33154, 45.43275]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10119098,
        name: "Lovely new apartment for couples",
        host_id: 2508340,
        host_name: "Giacomo",
        latitude: 45.4438,
        longitude: 12.33503,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33503, 45.4438]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10120136,
        name: "Casa Diamante Blu Rialto",
        host_id: 2053550,
        host_name: "Stefania",
        latitude: 45.43782,
        longitude: 12.33338,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33338, 45.43782]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10121382,
        name: "Charmant brand new apartment + lift & lagoon view",
        host_id: 2508340,
        host_name: "Giacomo",
        latitude: 45.44362,
        longitude: 12.33537,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33537, 45.44362]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10122248,
        name: "Gorgeous new apartment with terrace",
        host_id: 2508340,
        host_name: "Giacomo",
        latitude: 45.44499,
        longitude: 12.33407,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33407, 45.44499]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10133921,
        name: "Lovely apartment with lagoon view",
        host_id: 2508340,
        host_name: "Giacomo",
        latitude: 45.44476,
        longitude: 12.33466,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33466, 45.44476]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10148938,
        name: "Cosy little apartment",
        host_id: 17502711,
        host_name: "Valeria",
        latitude: 45.4349,
        longitude: 12.31869,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31869, 45.4349]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10155454,
        name: "Appartamento in Ghetto da 55 mq",
        host_id: 52122654,
        host_name: "Luca",
        latitude: 45.44406,
        longitude: 12.32463,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32463, 45.44406]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10155481,
        name: "Appartamento in Ghetto da 72mq",
        host_id: 52122654,
        host_name: "Luca",
        latitude: 45.44449,
        longitude: 12.32552,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32552, 45.44449]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10162020,
        name: "Spacious Apartment in the historic city of Venice",
        host_id: 43658105,
        host_name: "Marco & Roberta",
        latitude: 45.432,
        longitude: 12.35832,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35832, 45.432]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10169122,
        name: "Casa Felice: terrace&WiFi",
        host_id: 6654661,
        host_name: "Rita",
        latitude: 45.44112,
        longitude: 12.33756,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33756, 45.44112]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10170266,
        name: "Luxury flat on the water",
        host_id: 48092742,
        host_name: "Roby",
        latitude: 45.44012,
        longitude: 12.33941,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33941, 45.44012]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10184527,
        name: "Sleep 4 Venice Third Floor",
        host_id: 22940319,
        host_name: "Albatroservices",
        latitude: 45.43935,
        longitude: 12.33372,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33372, 45.43935]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10185128,
        name: "Venetian Style Third Floor",
        host_id: 22940319,
        host_name: "Albatroservices",
        latitude: 45.43956,
        longitude: 12.33339,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33339, 45.43956]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10203180,
        name: "Ca' Sant' Angelo Terrace",
        host_id: 16267348,
        host_name: "Elisabetta",
        latitude: 45.43326,
        longitude: 12.33364,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33364, 45.43326]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10203413,
        name: "LUXURY apt in S.MARK",
        host_id: 42065498,
        host_name: "Gaia",
        latitude: 45.43303,
        longitude: 12.33769,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33769, 45.43303]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10216153,
        name: "Carbona3732 Apartment in Center Venice",
        host_id: 52495162,
        host_name: "Carlotta",
        latitude: 45.4342,
        longitude: 12.33212,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33212, 45.4342]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10257793,
        name: "Casa ai Preti",
        host_id: 46086362,
        host_name: "Marco",
        latitude: 45.43379,
        longitude: 12.35411,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35411, 45.43379]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10258217,
        name: "Ca' dei Fuseri 2",
        host_id: 7325760,
        host_name: "Stefano",
        latitude: 45.43409,
        longitude: 12.33473,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33473, 45.43409]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10261493,
        name: "Ca TANA MAXI wifi apartment",
        host_id: 49154952,
        host_name: "Maurizio",
        latitude: 45.43228,
        longitude: 12.3512,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3512, 45.43228]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10265849,
        name: "FEW STEPS FROM REAL VENICE",
        host_id: 41559211,
        host_name: "Venice",
        latitude: 45.43157,
        longitude: 12.35545,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35545, 45.43157]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10269202,
        name: "Casa Isabella",
        host_id: 52800995,
        host_name: "Marco",
        latitude: 45.4324,
        longitude: 12.3253,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3253, 45.4324]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10279818,
        name: "Enjoy... San Marcuola",
        host_id: 52868600,
        host_name: "Fiorenza",
        latitude: 45.4435,
        longitude: 12.32827,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32827, 45.4435]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10280273,
        name: "The apartment is in the heart of Venice.",
        host_id: 26420663,
        host_name: "Roberto",
        latitude: 45.43758,
        longitude: 12.32593,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32593, 45.43758]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10290086,
        name: "St.Mark's Square apartment",
        host_id: 30149755,
        host_name: "Rachele",
        latitude: 45.43608,
        longitude: 12.33881,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33881, 45.43608]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10292539,
        name: "San Girolamo apartament",
        host_id: 3957712,
        host_name: "Manuel",
        latitude: 45.44667,
        longitude: 12.32506,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32506, 45.44667]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10302503,
        name: "Dimora Marciana San Marco Square Junior Suite",
        host_id: 49986250,
        host_name: "Dimora",
        latitude: 45.4345,
        longitude: 12.33704,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33704, 45.4345]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10308581,
        name: "VIOLETTE: romantica Venezia al Ghetto Vecchio",
        host_id: 11890999,
        host_name: "Sara",
        latitude: 45.44265,
        longitude: 12.32753,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32753, 45.44265]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10321107,
        name: "Corte Foscarini Elegant Apartment",
        host_id: 15758689,
        host_name: "Anna",
        latitude: 45.43476,
        longitude: 12.3191,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3191, 45.43476]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10327212,
        name: "Arioso appartamento con vista sul ponte di Rialto",
        host_id: 51021330,
        host_name: "Francesco",
        latitude: 45.43699,
        longitude: 12.33546,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33546, 45.43699]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10330648,
        name: "Da Chiara. Venice. Canal View",
        host_id: 53157873,
        host_name: "Chiara",
        latitude: 45.43614,
        longitude: 12.31967,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31967, 45.43614]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10338243,
        name: "Leone Marciano Apartment in 17th-Century Palace",
        host_id: 53202475,
        host_name: "Antonio E Elisabetta",
        latitude: 45.4336,
        longitude: 12.34769,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34769, 45.4336]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10344146,
        name: "Cà Greta",
        host_id: 46995286,
        host_name: "Andrea",
        latitude: 45.4346,
        longitude: 12.3242,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3242, 45.4346]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10349472,
        name: "Casa Dolcedoro",
        host_id: 53265543,
        host_name: "Domenico",
        latitude: 45.44396,
        longitude: 12.32093,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32093, 45.44396]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10354583,
        name: "Beautiful and airy apartment with a view.",
        host_id: 15275769,
        host_name: "Carlo",
        latitude: 45.44126,
        longitude: 12.33767,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33767, 45.44126]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10372531,
        name: "Lovely apartment nearby Redentore",
        host_id: 53083016,
        host_name: "Luisa",
        latitude: 45.42421,
        longitude: 12.3307,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3307, 45.42421]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10385794,
        name: "Grand Canal view apartment",
        host_id: 53454287,
        host_name: "Vale",
        latitude: 45.44294,
        longitude: 12.32582,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32582, 45.44294]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10406840,
        name: "AnticaVenezia",
        host_id: 53587521,
        host_name: "Cristina",
        latitude: 45.4378,
        longitude: 12.33922,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33922, 45.4378]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10425961,
        name: "Charming gondola apartment",
        host_id: 37978394,
        host_name: "Simonetta",
        latitude: 45.44306,
        longitude: 12.3294,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3294, 45.44306]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10433363,
        name: "Casa Lara, a quiet corner of Venice",
        host_id: 48003070,
        host_name: "Valeria",
        latitude: 45.43763,
        longitude: 12.35003,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35003, 45.43763]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10447296,
        name: "Bright flat, heart of Venice!",
        host_id: 53813377,
        host_name: "Claudia",
        latitude: 45.44187,
        longitude: 12.32822,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32822, 45.44187]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10460428,
        name: "3-Restored for 3+1, S.Mark Sq.",
        host_id: 6180481,
        host_name: "Stefano",
        latitude: 45.43498,
        longitude: 12.34177,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34177, 45.43498]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10460630,
        name: "4Flat w/terrace, S.Marco, wifi, 3+1",
        host_id: 6180481,
        host_name: "Stefano",
        latitude: 45.43598,
        longitude: 12.34243,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34243, 45.43598]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10480832,
        name: "AI SOGNATORI VENEZIA - FAMILY ROOM WITH VIEW CANAL",
        host_id: 23598673,
        host_name: "Patricia",
        latitude: 45.43873,
        longitude: 12.32948,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32948, 45.43873]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10507451,
        name: "Venice Style Residence_Modern & spacious apart.",
        host_id: 289615,
        host_name: "Valentina",
        latitude: 45.44208,
        longitude: 12.32063,
        beds: 11,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32063, 45.44208]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10530687,
        name: "Elegant & Cozy - 5 min from Station/Water bus",
        host_id: 54303606,
        host_name: "Massimo",
        latitude: 45.43951,
        longitude: 12.32381,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32381, 45.43951]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10533551,
        name: "In the heart of La Marinaressa",
        host_id: 54317980,
        host_name: "Martina & Valeria",
        latitude: 45.432,
        longitude: 12.35253,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35253, 45.432]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10533854,
        name: "Lovely canal view near Rialto",
        host_id: 1903880,
        host_name: "Sara",
        latitude: 45.44129,
        longitude: 12.33503,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33503, 45.44129]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10538509,
        name: "CA' DERAI  -  San Marcuola  Casinò",
        host_id: 21973212,
        host_name: "Ca Derai",
        latitude: 45.44409,
        longitude: 12.32951,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32951, 45.44409]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10539343,
        name: "San Polo, feel the center!",
        host_id: 53813377,
        host_name: "Claudia",
        latitude: 45.43596,
        longitude: 12.32851,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32851, 45.43596]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10561834,
        name: "Easily accessible Venice condo with gorgeous canal views!",
        host_id: 4339678,
        host_name: "Vacasa Italy - Venice",
        latitude: 45.44101,
        longitude: 12.33676,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33676, 45.44101]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10579776,
        name: "Cà de la Trifora NEW WITH A/C!!!",
        host_id: 54581260,
        host_name: "Antonio",
        latitude: 45.43609,
        longitude: 12.34205,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34205, 45.43609]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10602727,
        name: "Ca' del Dose charming apartment",
        host_id: 12113015,
        host_name: "Mario",
        latitude: 45.4371,
        longitude: 12.34078,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34078, 45.4371]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10603608,
        name: "Apartment near Rialto bridge",
        host_id: 54713246,
        host_name: "Monica",
        latitude: 45.43999,
        longitude: 12.33288,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33288, 45.43999]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10644676,
        name: "MAISON DU CINEMA (IP (Phone number hidden by Airbnb)",
        host_id: 54962703,
        host_name: "Gabriele",
        latitude: 45.44113,
        longitude: 12.33662,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33662, 45.44113]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10647098,
        name: "Cà D'Oro Apartment (Third Floor)",
        host_id: 25998480,
        host_name: "Cristina",
        latitude: 45.44118,
        longitude: 12.33685,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33685, 45.44118]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10674585,
        name: "Ca San Simeon 2",
        host_id: 20839943,
        host_name: "Costante",
        latitude: 45.44054,
        longitude: 12.32519,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32519, 45.44054]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10687569,
        name: "CA' DELLA PORPORA 1 @ GUGLIE BRIDGE",
        host_id: 16838381,
        host_name: "Arianna",
        latitude: 45.44736,
        longitude: 12.3209,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3209, 45.44736]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10714137,
        name:
          "Elegant second-floor Venetian rental near shops & galleries - walk to everything",
        host_id: 4339678,
        host_name: "Vacasa Italy - Venice",
        latitude: 45.43046,
        longitude: 12.33337,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33337, 45.43046]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10715120,
        name: "Spacious & Modern 3 bedroom apartment & AC",
        host_id: 289615,
        host_name: "Valentina",
        latitude: 45.44318,
        longitude: 12.32595,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32595, 45.44318]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10716519,
        name: "CA' DELLA PORPORA @ GUGLIE",
        host_id: 16838381,
        host_name: "Arianna",
        latitude: 45.44616,
        longitude: 12.32291,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32291, 45.44616]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10718410,
        name:
          "Renovated Venetian studio w/ city views - walking distance to everything!",
        host_id: 4339678,
        host_name: "Vacasa Italy - Venice",
        latitude: 45.43663,
        longitude: 12.34076,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34076, 45.43663]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10719222,
        name: "Zattere Premium",
        host_id: 35279206,
        host_name: "LMV - Exclusive Venice Apartments",
        latitude: 45.43008,
        longitude: 12.32731,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32731, 45.43008]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10720482,
        name: "Deluxe Venice apartment",
        host_id: 35279206,
        host_name: "LMV - Exclusive Venice Apartments",
        latitude: 45.43006,
        longitude: 12.32664,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32664, 45.43006]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10723361,
        name: "La Masena",
        host_id: 55418775,
        host_name: "Lisa",
        latitude: 45.44407,
        longitude: 12.33586,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33586, 45.44407]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10724090,
        name: "Casa Studio Venezia",
        host_id: 21670809,
        host_name: "Rosa",
        latitude: 45.43923,
        longitude: 12.34437,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34437, 45.43923]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10736941,
        name: "Cavana Residence",
        host_id: 5618111,
        host_name: "EasySuite",
        latitude: 45.43189,
        longitude: 12.3206,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3206, 45.43189]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10741315,
        name: "Santa Marina WIFI",
        host_id: 29918538,
        host_name: "Youinvenice",
        latitude: 45.43738,
        longitude: 12.33826,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33826, 45.43738]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10742343,
        name: "Biennale Apartment IP (Phone number hidden by Airbnb)",
        host_id: 15005402,
        host_name: "Veronica",
        latitude: 45.4328,
        longitude: 12.35814,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35814, 45.4328]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10749341,
        name: "Apartment in the Centre of Venice",
        host_id: 55574304,
        host_name: "Elle",
        latitude: 45.43543,
        longitude: 12.32375,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32375, 45.43543]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10761020,
        name: "Cannaregio apartment",
        host_id: 5395291,
        host_name: "Beatrice",
        latitude: 45.44759,
        longitude: 12.3222,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3222, 45.44759]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10765801,
        name: "Casa Elsa (L.T. M (Phone number hidden by Airbnb)",
        host_id: 5618111,
        host_name: "EasySuite",
        latitude: 45.43313,
        longitude: 12.33921,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33921, 45.43313]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10778696,
        name: "Apartment San Samuele 2 + 2 people",
        host_id: 37356947,
        host_name: "Nicola",
        latitude: 45.43239,
        longitude: 12.33016,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33016, 45.43239]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10779224,
        name: "AL PONTE DEL BATELO-VENEZIA CENTRO",
        host_id: 37408687,
        host_name: "Myriam",
        latitude: 45.4463,
        longitude: 12.32263,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32263, 45.4463]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10795221,
        name: "Appartamento luminoso e centrale",
        host_id: 25315524,
        host_name: "Cristina",
        latitude: 45.43453,
        longitude: 12.33666,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33666, 45.43453]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10795942,
        name: "Ca' Tasso Holidays House",
        host_id: 55873052,
        host_name: "Lorenzo & Nikolas",
        latitude: 45.44213,
        longitude: 12.32731,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32731, 45.44213]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10797928,
        name: "Apartment in the heart of Venice",
        host_id: 55885949,
        host_name: "Matteo",
        latitude: 45.43478,
        longitude: 12.33222,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33222, 45.43478]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10800584,
        name: "San Lio Suite: Close to S. Marco square & Wi-Fi",
        host_id: 55903142,
        host_name: "Emanuela",
        latitude: 45.43737,
        longitude: 12.33893,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33893, 45.43737]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10803528,
        name: "Giardini",
        host_id: 26144409,
        host_name: "Alberto",
        latitude: 45.43057,
        longitude: 12.35807,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35807, 45.43057]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10818768,
        name:
          "Modern condo with a shared garden & canal views, close to Santa Maria Formosa!",
        host_id: 4339678,
        host_name: "Vacasa Italy - Venice",
        latitude: 45.43809,
        longitude: 12.3412,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3412, 45.43809]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10820972,
        name:
          "Venice  Altanella charming rooftop   M (Phone number hidden by Airbnb)",
        host_id: 1974309,
        host_name: "Anna",
        latitude: 45.44141,
        longitude: 12.32975,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32975, 45.44141]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10821413,
        name: "Among the roofs of Venice...",
        host_id: 14577831,
        host_name: "Giulia",
        latitude: 45.43174,
        longitude: 12.3545,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3545, 45.43174]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10828508,
        name: "Biennale Suite very lovely flat",
        host_id: 56069676,
        host_name: "Nicola",
        latitude: 45.43264,
        longitude: 12.3529,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3529, 45.43264]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10842594,
        name: "ST. MARK SQUARE - WITH LITTLE PRIVATE GARDEN",
        host_id: 21858179,
        host_name: "Boneve",
        latitude: 45.43675,
        longitude: 12.33944,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33944, 45.43675]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10848085,
        name: "Great appartment close to Rialto!",
        host_id: 21124767,
        host_name: "Judith",
        latitude: 45.43942,
        longitude: 12.33728,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33728, 45.43942]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10855812,
        name: "CHARMING CANAL VIEW APARTMENT",
        host_id: 1392089,
        host_name: "My Magic",
        latitude: 45.43584,
        longitude: 12.32561,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32561, 45.43584]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10861511,
        name: "Single independent room in Venice",
        host_id: 56023447,
        host_name: "Silvia",
        latitude: 45.43239,
        longitude: 12.32431,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32431, 45.43239]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10866705,
        name: "traditional apartment with terrace",
        host_id: 56297353,
        host_name: "Marko",
        latitude: 45.43368,
        longitude: 12.32947,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32947, 45.43368]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10867245,
        name: "venetian home",
        host_id: 56299776,
        host_name: "Maria",
        latitude: 45.43964,
        longitude: 12.3231,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3231, 45.43964]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10882614,
        name: "Dream Venice",
        host_id: 56386179,
        host_name: "Marco",
        latitude: 45.43868,
        longitude: 12.33366,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33366, 45.43868]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10892697,
        name: "Casa Claudia (L.T. M (Phone number hidden by Airbnb)",
        host_id: 5618111,
        host_name: "EasySuite",
        latitude: 45.43831,
        longitude: 12.33419,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33419, 45.43831]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10893550,
        name: "Ca' della Tana charming apartment in Biennale area",
        host_id: 12113015,
        host_name: "Mario",
        latitude: 45.43256,
        longitude: 12.35278,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35278, 45.43256]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10913250,
        name: "Wonderful flat on 2 levels with terrace, Venice",
        host_id: 11505507,
        host_name: "Alexandra",
        latitude: 45.44395,
        longitude: 12.32062,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32062, 45.44395]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10918311,
        name: "Sweet Dreams on Rialto Bridge GG",
        host_id: 56593037,
        host_name: "Daniela",
        latitude: 45.43741,
        longitude: 12.3359,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3359, 45.43741]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10918451,
        name: "casa MARGHERITA",
        host_id: 56593795,
        host_name: "Elena",
        latitude: 45.43564,
        longitude: 12.32361,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32361, 45.43564]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10919831,
        name: "ENTRANCE VENEZIA, VERY QUIET, SPACIOUS, WIFI, A/C.",
        host_id: 55246113,
        host_name: "Franco",
        latitude: 45.4438,
        longitude: 12.32172,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32172, 45.4438]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10920360,
        name: "Sweet Dreams on Rialto Bridge GR RED GEMM",
        host_id: 56593037,
        host_name: "Daniela",
        latitude: 45.4373,
        longitude: 12.33603,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33603, 45.4373]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10923550,
        name: "3 bedroom apartment and 3 bathrooms",
        host_id: 47683665,
        host_name: "Alberto",
        latitude: 45.43184,
        longitude: 12.33013,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33013, 45.43184]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10953715,
        name: "Nice room in Venice!",
        host_id: 4512765,
        host_name: "Claudia",
        latitude: 45.4384,
        longitude: 12.32053,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32053, 45.4384]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10953865,
        name: "Elegant Rooms Piazza San Marco!",
        host_id: 45896811,
        host_name: "Caterina",
        latitude: 45.43622,
        longitude: 12.34089,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34089, 45.43622]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10958233,
        name: "Apartment in the heart of Venice",
        host_id: 6350178,
        host_name: "Cristina",
        latitude: 45.43798,
        longitude: 12.32735,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32735, 45.43798]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10976716,
        name: "LEO APARTAMENT  M (Phone number hidden by Airbnb)",
        host_id: 29271096,
        host_name: "Ari",
        latitude: 45.43333,
        longitude: 12.33115,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33115, 45.43333]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10980490,
        name: "Ca' Contarini studio in San Marco",
        host_id: 12113015,
        host_name: "Mario",
        latitude: 45.43339,
        longitude: 12.32834,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32834, 45.43339]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10980926,
        name: "CA' TEATRO: LUXURY SUITE IN S.MARCO",
        host_id: 289615,
        host_name: "Valentina",
        latitude: 45.43744,
        longitude: 12.33685,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33685, 45.43744]] },
    },
    {
      type: "Feature",
      properties: {
        id: 10981041,
        name: "ORIGINAL STUCKY",
        host_id: 56971841,
        host_name: "Maria Claudia",
        latitude: 45.42807,
        longitude: 12.32025,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32025, 45.42807]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11005691,
        name: "Bright studio to Redentore",
        host_id: 57108832,
        host_name: "Gianluca",
        latitude: 45.4244,
        longitude: 12.3347,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3347, 45.4244]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11008096,
        name: "Venice Tre Archi",
        host_id: 13027859,
        host_name: "Diego",
        latitude: 45.44731,
        longitude: 12.31947,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31947, 45.44731]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11013793,
        name: "Double and Triple Room large and comfortable",
        host_id: 45896811,
        host_name: "Caterina",
        latitude: 45.43419,
        longitude: 12.34211,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34211, 45.43419]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11032038,
        name: "Anna Ai Frari Residence",
        host_id: 57249358,
        host_name: "Roberta",
        latitude: 45.43688,
        longitude: 12.32575,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32575, 45.43688]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11086232,
        name: "Double room private bathroom Venice",
        host_id: 6338514,
        host_name: "Ca' Morosini",
        latitude: 45.43454,
        longitude: 12.33263,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33263, 45.43454]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11099450,
        name: "Venice Life",
        host_id: 5857136,
        host_name: "Mirco",
        latitude: 45.43449,
        longitude: 12.34963,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34963, 45.43449]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11099949,
        name: "near the Arsenale and the Biennale",
        host_id: 57647197,
        host_name: "Lino",
        latitude: 45.43016,
        longitude: 12.35759,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35759, 45.43016]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11111951,
        name: "CAMERA DEGLI ANGELI",
        host_id: 7739710,
        host_name: "Célia",
        latitude: 45.42932,
        longitude: 12.36198,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.36198, 45.42932]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11112146,
        name: "MODERATAcameraDoppia una piazza&mezzo(150cmx190cm)",
        host_id: 45896811,
        host_name: "Caterina",
        latitude: 45.4363,
        longitude: 12.34161,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34161, 45.4363]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11129665,
        name: "Ca' Del Pittore with roof terrace",
        host_id: 669047,
        host_name: "Viewsonvenice",
        latitude: 45.43746,
        longitude: 12.34245,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34245, 45.43746]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11137522,
        name: "Nuovo a piazza San Marco",
        host_id: 14920499,
        host_name: "Stefano",
        latitude: 45.43337,
        longitude: 12.33637,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33637, 45.43337]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11155794,
        name: "Modern & spacious apt w/terrace in Venice",
        host_id: 11505507,
        host_name: "Alexandra",
        latitude: 45.44264,
        longitude: 12.31962,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31962, 45.44264]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11157108,
        name: "Bright 3bdr 140sqm with terrace in Venice",
        host_id: 11505507,
        host_name: "Alexandra",
        latitude: 45.44222,
        longitude: 12.31911,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31911, 45.44222]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11158719,
        name: "Panoramic 130sqm 3bdr with terrace Venice",
        host_id: 11505507,
        host_name: "Alexandra",
        latitude: 45.44192,
        longitude: 12.31931,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31931, 45.44192]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11159109,
        name: "Charming 2bdr flat in the heart of Venice",
        host_id: 11505507,
        host_name: "Alexandra",
        latitude: 45.44204,
        longitude: 12.319,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.319, 45.44204]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11193552,
        name: "Cozy apartment in San Marco area, free Wifi",
        host_id: 1711822,
        host_name: "Lucia",
        latitude: 45.43316,
        longitude: 12.32867,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32867, 45.43316]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11199519,
        name: "very comfortable ground floor house with wifi",
        host_id: 58314647,
        host_name: "Paula",
        latitude: 45.43938,
        longitude: 12.34274,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34274, 45.43938]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11216430,
        name: "Suite de charme, 3 min from S.Marco",
        host_id: 13827722,
        host_name: "Raffaello",
        latitude: 45.43619,
        longitude: 12.34047,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34047, 45.43619]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11219244,
        name: "GUGGENHEIM NEXT 4pax, Wifi, Aircond",
        host_id: 17534457,
        host_name: "Abaca",
        latitude: 45.43036,
        longitude: 12.32879,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32879, 45.43036]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11219796,
        name: "New Rachel2 85m2 10min Rialto Wifi",
        host_id: 58456083,
        host_name: "Denis",
        latitude: 45.43717,
        longitude: 12.32383,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32383, 45.43717]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11219888,
        name: "GUGGENHEIM NEXT 6pax, Aircond Wifi - cute!",
        host_id: 17534457,
        host_name: "Abaca",
        latitude: 45.42956,
        longitude: 12.32682,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32682, 45.42956]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11227476,
        name: '"Big bed", shared bathroom',
        host_id: 12355491,
        host_name: "Ali",
        latitude: 45.43439,
        longitude: 12.34629,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34629, 45.43439]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11232084,
        name: 'Appartamento " Casa Jazz" con altane e terrazzino',
        host_id: 35353722,
        host_name: "Eliana",
        latitude: 45.43393,
        longitude: 12.32977,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32977, 45.43393]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11234583,
        name: "Casa Renier-Biennale…Exclusive",
        host_id: 28981705,
        host_name: "Consuelo",
        latitude: 45.43327,
        longitude: 12.35454,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35454, 45.43327]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11248399,
        name: "Ca' Giobbe",
        host_id: 58681167,
        host_name: "Beatrice",
        latitude: 45.44509,
        longitude: 12.32425,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32425, 45.44509]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11253605,
        name: "Adormo Digital Nomads Loft with Roof Terrace",
        host_id: 58719846,
        host_name: "Fulvio",
        latitude: 45.42536,
        longitude: 12.33997,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33997, 45.42536]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11267714,
        name: "Loft con giardino Venezia centro",
        host_id: 58826603,
        host_name: "Pietro",
        latitude: 45.43507,
        longitude: 12.32577,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32577, 45.43507]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11269824,
        name: "First room in Margherita",
        host_id: 34130245,
        host_name: "Beatrice",
        latitude: 45.4345,
        longitude: 12.32373,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32373, 45.4345]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11273610,
        name: "CA' ZULIAN: breathtaking canal view",
        host_id: 10988715,
        host_name: "Andrea",
        latitude: 45.43791,
        longitude: 12.34272,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34272, 45.43791]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11278574,
        name: "Ca' Laguna",
        host_id: 58903280,
        host_name: "Anna",
        latitude: 45.44716,
        longitude: 12.32668,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32668, 45.44716]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11288000,
        name: "LIONELLO - 5 mins to Rialto bridge",
        host_id: 10189388,
        host_name: "Raffaella",
        latitude: 45.44217,
        longitude: 12.33391,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33391, 45.44217]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11290573,
        name: "Giardino dei Melograni Three-Bedroom Apartment",
        host_id: 630328,
        host_name: "Kosher House",
        latitude: 45.44548,
        longitude: 12.32545,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32545, 45.44548]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11291528,
        name: "LIKE AT HOME  : Spacious, Full equipment ,Quiet...",
        host_id: 58995591,
        host_name: "Cristina",
        latitude: 45.43805,
        longitude: 12.33017,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33017, 45.43805]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11292610,
        name: "Private house - Tre Archi Bridge/S. Lucia station",
        host_id: 1860412,
        host_name: "Andrea",
        latitude: 45.4444,
        longitude: 12.31988,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31988, 45.4444]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11298621,
        name: "Nice double room in Venice. wifi",
        host_id: 59047694,
        host_name: "Giordano-Bruno",
        latitude: 45.43978,
        longitude: 12.3301,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3301, 45.43978]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11299645,
        name: "MY HOUSE FOR YOU IN VENICE CENTER",
        host_id: 37814406,
        host_name: "Jenny",
        latitude: 45.43576,
        longitude: 12.31792,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31792, 45.43576]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11320046,
        name: "Relaxing place at Rialto",
        host_id: 59205984,
        host_name: "Luisa",
        latitude: 45.43576,
        longitude: 12.33624,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33624, 45.43576]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11329777,
        name: "Charming new apartment",
        host_id: 1646068,
        host_name: "Fabiano",
        latitude: 45.44385,
        longitude: 12.32134,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32134, 45.44385]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11334402,
        name:
          "Ve.N.I.Ce Cera Giudecca Zitelle - M (Phone number hidden by Airbnb)",
        host_id: 37864680,
        host_name: "Ve.N.I.Ce Immobiliare Cera",
        latitude: 45.42572,
        longitude: 12.33677,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33677, 45.42572]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11336842,
        name: "CA' FONDAMENTA ROOM canal view",
        host_id: 9350468,
        host_name: "Antonello",
        latitude: 45.4438,
        longitude: 12.322,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.322, 45.4438]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11349416,
        name: "Cà dei Terrazzi,flat with terraces",
        host_id: 39311197,
        host_name: "Federica",
        latitude: 45.44043,
        longitude: 12.3243,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3243, 45.44043]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11350795,
        name: "STUDIO",
        host_id: 59382495,
        host_name: "Marianna",
        latitude: 45.44304,
        longitude: 12.32263,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32263, 45.44304]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11351234,
        name: "Ca' Milla Apartment",
        host_id: 226598,
        host_name: "Andrea",
        latitude: 45.43671,
        longitude: 12.32782,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32782, 45.43671]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11351331,
        name: "SUITE CANNAREGIO 1",
        host_id: 59382495,
        host_name: "Marianna",
        latitude: 45.44289,
        longitude: 12.32442,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32442, 45.44289]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11351385,
        name: "SUITE CANNAREGIO 2",
        host_id: 59382495,
        host_name: "Marianna",
        latitude: 45.44466,
        longitude: 12.32252,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32252, 45.44466]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11351485,
        name: "PENTA CANNAREGIO",
        host_id: 59382495,
        host_name: "Marianna",
        latitude: 45.44437,
        longitude: 12.32399,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32399, 45.44437]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11352211,
        name: "Appartamento in residence servito",
        host_id: 49321077,
        host_name: "Lorena",
        latitude: 45.43172,
        longitude: 12.33377,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33377, 45.43172]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11352892,
        name:
          "ROOFTOP TERRACE, VENICE, RIALTO Codice M (Phone number hidden by Airbnb)",
        host_id: 59377130,
        host_name: "Francesca",
        latitude: 45.43803,
        longitude: 12.33944,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33944, 45.43803]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11373018,
        name: "Appartamento in centro storico",
        host_id: 59611150,
        host_name: "Luigia",
        latitude: 45.43607,
        longitude: 12.34536,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34536, 45.43607]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11376168,
        name: "Residenza dei Dogi",
        host_id: 59637158,
        host_name: "Marco",
        latitude: 45.43584,
        longitude: 12.34178,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34178, 45.43584]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11383366,
        name: "San Marco 1",
        host_id: 59698316,
        host_name: "Gino",
        latitude: 45.43466,
        longitude: 12.33541,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33541, 45.43466]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11384857,
        name: "Casa dei Bombardieri, amazing view, near Biennale",
        host_id: 59709922,
        host_name: "Anna Maria E Fabio",
        latitude: 45.43805,
        longitude: 12.34762,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34762, 45.43805]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11386399,
        name: "acasetta very central apartment",
        host_id: 59719287,
        host_name: "Luigi",
        latitude: 45.43672,
        longitude: 12.34152,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34152, 45.43672]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11389770,
        name: "Single room (shared bathroom)",
        host_id: 12355491,
        host_name: "Ali",
        latitude: 45.43933,
        longitude: 12.33931,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33931, 45.43933]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11395209,
        name: "accogliente matrimoniale in centro",
        host_id: 59719287,
        host_name: "Luigi",
        latitude: 45.43834,
        longitude: 12.34202,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34202, 45.43834]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11407438,
        name: "B&B LeTerese- Room Fosca with canal view",
        host_id: 1666986,
        host_name: "Antonella",
        latitude: 45.43322,
        longitude: 12.31533,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31533, 45.43322]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11412944,
        name: "Ca' dell'Arco sul Rio",
        host_id: 9350468,
        host_name: "Antonello",
        latitude: 45.4378,
        longitude: 12.33129,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33129, 45.4378]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11417636,
        name: "Corte Bollani Apartment - San Polo",
        host_id: 59506205,
        host_name: "Carlotta",
        latitude: 45.43948,
        longitude: 12.33084,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33084, 45.43948]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11425648,
        name: "Samoro Jacuzzi",
        host_id: 29918538,
        host_name: "Youinvenice",
        latitude: 45.4447,
        longitude: 12.32847,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32847, 45.4447]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11433038,
        name: "Palladio Charmsuite",
        host_id: 2301589,
        host_name: "Vico Tourism",
        latitude: 45.42442,
        longitude: 12.33877,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33877, 45.42442]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11447312,
        name: "APARTMENT VIEWS ON VENICE GRAND CANAL",
        host_id: 28095151,
        host_name: "Caterina",
        latitude: 45.43693,
        longitude: 12.32957,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32957, 45.43693]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11450118,
        name: "Beautiful Central Loft with Garden",
        host_id: 3325744,
        host_name: "Enrica",
        latitude: 45.42905,
        longitude: 12.32831,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32831, 45.42905]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11454122,
        name: "Duplex hyper central and  cozy",
        host_id: 59327194,
        host_name: "Sabine",
        latitude: 45.431,
        longitude: 12.32723,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32723, 45.431]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11465539,
        name: "Lovely Rialto Apartment",
        host_id: 60316902,
        host_name: "Eva",
        latitude: 45.43908,
        longitude: 12.33252,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33252, 45.43908]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11470465,
        name: "Grazioso appartamento restaurato",
        host_id: 60347597,
        host_name: "Silvia",
        latitude: 45.43776,
        longitude: 12.34543,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34543, 45.43776]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11473963,
        name: "SANTA MARTA",
        host_id: 3972291,
        host_name: "Caroline E Marco",
        latitude: 45.43246,
        longitude: 12.316,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.316, 45.43246]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11483569,
        name: "Sailor's flat Accademia",
        host_id: 37955209,
        host_name: "Tea",
        latitude: 45.42909,
        longitude: 12.32868,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32868, 45.42909]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11487600,
        name: "MyVenice Attic (8 minutes from San Marco square)",
        host_id: 60476959,
        host_name: "Roberto",
        latitude: 45.43533,
        longitude: 12.34641,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34641, 45.43533]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11488221,
        name: "Theater Fenice Canal View - Art Apartments Venice",
        host_id: 28162920,
        host_name: "Beatriz",
        latitude: 45.43234,
        longitude: 12.33155,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33155, 45.43234]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11503680,
        name: "CASA SAN MARCO",
        host_id: 60598904,
        host_name: "Gino",
        latitude: 45.43375,
        longitude: 12.3372,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3372, 45.43375]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11517928,
        name: "Between the channels, in San Marco",
        host_id: 27394391,
        host_name: "Davide",
        latitude: 45.43216,
        longitude: 12.33084,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33084, 45.43216]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11526552,
        name: "Venetian style apartment",
        host_id: 60778507,
        host_name: "Viorica & Chris",
        latitude: 45.44399,
        longitude: 12.32989,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32989, 45.44399]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11530067,
        name: "Appartamento Z OrmEsini",
        host_id: 60807005,
        host_name: "Diana",
        latitude: 45.44696,
        longitude: 12.3265,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3265, 45.44696]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11539641,
        name: "Ca' Bembo with Terrace",
        host_id: 669047,
        host_name: "Viewsonvenice",
        latitude: 45.4407,
        longitude: 12.33706,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33706, 45.4407]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11543259,
        name: "LISTA DI SPAGNA - Accogliente apt con vista strada",
        host_id: 10189388,
        host_name: "Raffaella",
        latitude: 45.44287,
        longitude: 12.32452,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32452, 45.44287]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11543360,
        name: "Apt Greci, bright and with a Canal view.",
        host_id: 60488055,
        host_name: "Marco & Andrea",
        latitude: 45.43543,
        longitude: 12.34515,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34515, 45.43543]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11549083,
        name: "Casa Gottardi - Sky Room",
        host_id: 60962235,
        host_name: "Susanna",
        latitude: 45.43877,
        longitude: 12.33501,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33501, 45.43877]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11552314,
        name: "Casanova Flat in Rialto bridge",
        host_id: 48092742,
        host_name: "Roby",
        latitude: 45.43848,
        longitude: 12.33669,
        beds: 7,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33669, 45.43848]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11568011,
        name: "Ca'Ju",
        host_id: 61109776,
        host_name: "Ca'Ju",
        latitude: 45.43184,
        longitude: 12.33036,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33036, 45.43184]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11579384,
        name: "appartamento in Cannaregio",
        host_id: 61212856,
        host_name: "Roberto",
        latitude: 45.44655,
        longitude: 12.33057,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33057, 45.44655]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11614410,
        name: "CA' DELLA PORPORA 2 @ GUGLIE BRIDGE",
        host_id: 16838381,
        host_name: "Arianna",
        latitude: 45.44565,
        longitude: 12.32196,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32196, 45.44565]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11621146,
        name: "DOMUS DEA IN VENICE CENTER",
        host_id: 61544605,
        host_name: "Angela",
        latitude: 45.4329,
        longitude: 12.31706,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31706, 45.4329]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11629964,
        name: "luminoso sul canale con terrazzo",
        host_id: 9202415,
        host_name: "Michela",
        latitude: 45.43506,
        longitude: 12.32244,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32244, 45.43506]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11632203,
        name: "Canalview magic&quiet whole Apt. CadOro-AC-WiFi-CH",
        host_id: 22474452,
        host_name: "Elisa",
        latitude: 45.44217,
        longitude: 12.33694,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33694, 45.44217]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11633753,
        name: "Gorgeous apartment behind S.Mark square.",
        host_id: 5395291,
        host_name: "Beatrice",
        latitude: 45.43675,
        longitude: 12.3414,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3414, 45.43675]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11634229,
        name: "Single room near Rialto",
        host_id: 48669646,
        host_name: "Jing",
        latitude: 45.44223,
        longitude: 12.33603,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33603, 45.44223]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11667494,
        name: "CANAL VIEW, NEAR SAINT MARK SQUARE",
        host_id: 61938982,
        host_name: "Gianna",
        latitude: 45.4372,
        longitude: 12.34053,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34053, 45.4372]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11667850,
        name: "Ca' dei Carpini, 10 minutes from San Marco",
        host_id: 61941622,
        host_name: "Maria",
        latitude: 45.44031,
        longitude: 12.34038,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34038, 45.44031]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11669547,
        name: "Residenza Manin Apartments - La Fenice",
        host_id: 25496626,
        host_name: "Bertoli",
        latitude: 45.43459,
        longitude: 12.3341,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3341, 45.43459]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11672760,
        name: "Strategic position for Venice visiting",
        host_id: 61973863,
        host_name: "Gabriella",
        latitude: 45.43605,
        longitude: 12.32631,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32631, 45.43605]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11696419,
        name: "Venetian Attitude 1 apartment near Rialto Venice",
        host_id: 15682327,
        host_name: "Cristian",
        latitude: 45.4418,
        longitude: 12.33839,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33839, 45.4418]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11696744,
        name: "DOUBLE ROOM - SILVER DREAM",
        host_id: 23598673,
        host_name: "Patricia",
        latitude: 45.43742,
        longitude: 12.33005,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33005, 45.43742]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11712789,
        name: "Appartamento 4 posti (1P) San Marco",
        host_id: 62268572,
        host_name: "Fabio",
        latitude: 45.43365,
        longitude: 12.34749,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34749, 45.43365]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11717002,
        name: "BIENNALE CROCODILE LOFT 5pax, 2beds, Wifi, Aircond",
        host_id: 17534457,
        host_name: "Abaca",
        latitude: 45.43436,
        longitude: 12.35544,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35544, 45.43436]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11732906,
        name: 'Cannaregio "Tiepolo" Apartment 4px',
        host_id: 62407552,
        host_name: "Eleonora",
        latitude: 45.44446,
        longitude: 12.32319,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32319, 45.44446]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11733755,
        name: 'Cannaregio "Bellavista" Apartment',
        host_id: 62407552,
        host_name: "Eleonora",
        latitude: 45.44267,
        longitude: 12.3269,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3269, 45.44267]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11745829,
        name: "Appartamento dell'Arte Ca'd'Oro",
        host_id: 60488055,
        host_name: "Marco & Andrea",
        latitude: 45.44252,
        longitude: 12.33526,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33526, 45.44252]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11746840,
        name: "Luxury SanMarco",
        host_id: 60488055,
        host_name: "Marco & Andrea",
        latitude: 45.43673,
        longitude: 12.34051,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34051, 45.43673]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11784532,
        name: "Quaint & Cozy Apt. | LeConvertite",
        host_id: 15723390,
        host_name: "Alessandro",
        latitude: 45.42651,
        longitude: 12.32294,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32294, 45.42651]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11785500,
        name: "Accademia Design apartment, Dorsoduro",
        host_id: 6631752,
        host_name: "Alberta & Filippo",
        latitude: 45.43033,
        longitude: 12.32658,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32658, 45.43033]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11791588,
        name: '"Nausicaa":a lovely apartment.',
        host_id: 62802490,
        host_name: "Elena",
        latitude: 45.43421,
        longitude: 12.34857,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34857, 45.43421]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11807656,
        name: "Redentore",
        host_id: 12982157,
        host_name: "Locappart",
        latitude: 45.42387,
        longitude: 12.33391,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33391, 45.42387]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11808835,
        name: "Bartolo II",
        host_id: 12982157,
        host_name: "Locappart",
        latitude: 45.43699,
        longitude: 12.33688,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33688, 45.43699]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11825264,
        name: "Ca' Fortuna - canal, balcony, gondolas!",
        host_id: 35888010,
        host_name: "Linda",
        latitude: 45.43883,
        longitude: 12.32922,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32922, 45.43883]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11831460,
        name: "Rialto rooftop, very central view !",
        host_id: 31276705,
        host_name: "Mila",
        latitude: 45.43756,
        longitude: 12.33681,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33681, 45.43756]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11834048,
        name: "NOUVELLE VAGUE APARTMENT",
        host_id: 63049757,
        host_name: "Enrico",
        latitude: 45.43415,
        longitude: 12.32854,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32854, 45.43415]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11837021,
        name: "Ca' Marisa - The balcony on the canal",
        host_id: 63069190,
        host_name: "Antonella",
        latitude: 45.44426,
        longitude: 12.32979,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32979, 45.44426]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11839278,
        name: "Suite Palazzo del Giglio, San Marco",
        host_id: 5171190,
        host_name: "Tommaso",
        latitude: 45.43223,
        longitude: 12.33401,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33401, 45.43223]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11839522,
        name: "amazing location large confortable!",
        host_id: 31276705,
        host_name: "Mila",
        latitude: 45.44423,
        longitude: 12.32678,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32678, 45.44423]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11839935,
        name: "Big room with canal view",
        host_id: 63084631,
        host_name: "Annette And Emma",
        latitude: 45.43696,
        longitude: 12.33954,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33954, 45.43696]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11840346,
        name: "Amazing Canal View Double Room!",
        host_id: 63084631,
        host_name: "Annette And Emma",
        latitude: 45.43717,
        longitude: 12.34111,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34111, 45.43717]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11840507,
        name: "Comfortable Female Dorm minutes from San Marco",
        host_id: 63084631,
        host_name: "Annette And Emma",
        latitude: 45.43713,
        longitude: 12.3389,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3389, 45.43713]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11842650,
        name: "Cosy Private Room in Arsenale for 3!",
        host_id: 63084631,
        host_name: "Annette And Emma",
        latitude: 45.43453,
        longitude: 12.3475,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3475, 45.43453]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11856231,
        name: "Casa Fedora Venice Centre",
        host_id: 63194257,
        host_name: "Edoardo",
        latitude: 45.4406,
        longitude: 12.3394,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3394, 45.4406]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11858307,
        name: "CANAL VIEW, NEAR ST.MARK SQUARE",
        host_id: 63205237,
        host_name: "Francesca",
        latitude: 45.43555,
        longitude: 12.3373,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3373, 45.43555]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11863320,
        name: "Azzurra",
        host_id: 30197008,
        host_name: "Marina",
        latitude: 45.42591,
        longitude: 12.3261,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3261, 45.42591]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11864836,
        name: "LARGE CENTRAL EQUIPPED PRIVATE ROOM",
        host_id: 567508,
        host_name: "Nicola",
        latitude: 45.43684,
        longitude: 12.33865,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33865, 45.43684]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11881380,
        name: "Piuli",
        host_id: 12982157,
        host_name: "Locappart",
        latitude: 45.44391,
        longitude: 12.32126,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32126, 45.44391]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11885542,
        name: "Yellow House in Venice",
        host_id: 63378434,
        host_name: "Giovanna",
        latitude: 45.43985,
        longitude: 12.3309,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3309, 45.43985]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11885577,
        name: "House for 8, San Marco Sq., wi-fi",
        host_id: 6180481,
        host_name: "Stefano",
        latitude: 45.43625,
        longitude: 12.34203,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34203, 45.43625]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11885821,
        name: "Caterina's home - Venetian style",
        host_id: 26404861,
        host_name: "Marika",
        latitude: 45.44073,
        longitude: 12.33111,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33111, 45.44073]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11895211,
        name: "21 STEPS FROM THE VENICE ARSENAL !!",
        host_id: 41559211,
        host_name: "Venice",
        latitude: 45.43398,
        longitude: 12.34902,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34902, 45.43398]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11896779,
        name: "Casa Fedora 2P Venice Centre",
        host_id: 63194257,
        host_name: "Edoardo",
        latitude: 45.44064,
        longitude: 12.34037,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34037, 45.44064]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11900142,
        name: "VeniceVillas Cà del Nonsolo, near Rialto",
        host_id: 294951,
        host_name: "VeniceVillas Di Enzo",
        latitude: 45.44029,
        longitude: 12.32956,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32956, 45.44029]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11904600,
        name: "appartamento luminoso zona Cannaregio/ Ghetto",
        host_id: 63502378,
        host_name: "Bonomelli",
        latitude: 45.44543,
        longitude: 12.32991,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32991, 45.44543]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11917406,
        name: "San Marco Frezzaria 1 Bdrm 1st Fl.",
        host_id: 393913,
        host_name: "Luca",
        latitude: 45.43334,
        longitude: 12.33529,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33529, 45.43334]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11934208,
        name: "Rialto Deluxe, apartment with terrace",
        host_id: 6973711,
        host_name: "Valentina",
        latitude: 45.44014,
        longitude: 12.33302,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33302, 45.44014]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11938988,
        name: "tiepolo's artistic apartment",
        host_id: 63737273,
        host_name: "Albert",
        latitude: 45.43074,
        longitude: 12.35528,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35528, 45.43074]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11943839,
        name: "Stunning house, 3 outside spaces,4 bedrooms",
        host_id: 63769324,
        host_name: "Massimo",
        latitude: 45.4355,
        longitude: 12.34771,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34771, 45.4355]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11954120,
        name: "St. Mark Suite Apartments&Terrace",
        host_id: 1300751,
        host_name: "Frederico",
        latitude: 45.43276,
        longitude: 12.3378,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3378, 45.43276]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11954559,
        name: "Sweet Dreams on Rialto Bridge PERLA",
        host_id: 56593037,
        host_name: "Daniela",
        latitude: 45.43742,
        longitude: 12.33635,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33635, 45.43742]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11957681,
        name: "FAURISSIER",
        host_id: 15337957,
        host_name: "Marie",
        latitude: 45.43042,
        longitude: 12.32854,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32854, 45.43042]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11960840,
        name: "Stefano F3",
        host_id: 12982157,
        host_name: "Locappart",
        latitude: 45.43292,
        longitude: 12.32939,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32939, 45.43292]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11961376,
        name: "Stefano F2",
        host_id: 12982157,
        host_name: "Locappart",
        latitude: 45.43469,
        longitude: 12.3314,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3314, 45.43469]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11961880,
        name: "Stin",
        host_id: 12982157,
        host_name: "Locappart",
        latitude: 45.43795,
        longitude: 12.32615,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32615, 45.43795]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11963837,
        name: "Classy apartment with balcony upon a canal",
        host_id: 4654704,
        host_name: "Nicola",
        latitude: 45.43716,
        longitude: 12.34948,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34948, 45.43716]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11982931,
        name: "UNIQUE ROOFTOP LOFT 360° VIEW IN HISTORICAL VENICE",
        host_id: 64042810,
        host_name: "Caterina",
        latitude: 45.44061,
        longitude: 12.33986,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33986, 45.44061]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11982943,
        name: "Bright typical Venetian apartment in the center",
        host_id: 64042880,
        host_name: "Martina",
        latitude: 45.44541,
        longitude: 12.33,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33, 45.44541]] },
    },
    {
      type: "Feature",
      properties: {
        id: 11989794,
        name: "CA' FONDAMENTA APARTMENT",
        host_id: 9350468,
        host_name: "Antonello",
        latitude: 45.44526,
        longitude: 12.32227,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32227, 45.44526]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12003533,
        name: "Casa Violante (L.T. M (Phone number hidden by Airbnb)",
        host_id: 5618111,
        host_name: "EasySuite",
        latitude: 45.4378,
        longitude: 12.32228,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32228, 45.4378]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12013950,
        name: "Ca' Milena",
        host_id: 64270492,
        host_name: "Samuele",
        latitude: 45.44494,
        longitude: 12.32876,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32876, 45.44494]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12033562,
        name: "Ca del Giglio, Truly Venice Home",
        host_id: 37381363,
        host_name: "Horacio",
        latitude: 45.43903,
        longitude: 12.33127,
        beds: 8,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33127, 45.43903]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12044878,
        name: "2960 Frari 2 (4 beds) wi-fi. a.c.",
        host_id: 1755160,
        host_name: "Davide",
        latitude: 45.43707,
        longitude: 12.32287,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32287, 45.43707]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12047377,
        name: "Spacious Canal View Dorm Room!",
        host_id: 63084631,
        host_name: "Annette And Emma",
        latitude: 45.43735,
        longitude: 12.34041,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34041, 45.43735]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12047744,
        name: "Gold Room",
        host_id: 61291476,
        host_name: "Sarah",
        latitude: 45.444,
        longitude: 12.32803,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32803, 45.444]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12050799,
        name: "Ethnic Room in luxury house",
        host_id: 61291476,
        host_name: "Sarah",
        latitude: 45.44481,
        longitude: 12.3273,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3273, 45.44481]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12059028,
        name: "Southern (sunny) Space",
        host_id: 24683399,
        host_name: "Giovanni",
        latitude: 45.43059,
        longitude: 12.32555,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32555, 45.43059]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12060042,
        name: "Mater Domini",
        host_id: 46904188,
        host_name: "Mirco Optyflat",
        latitude: 45.4382,
        longitude: 12.32946,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32946, 45.4382]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12069846,
        name: "Incantata Casa su 2 piani Giudecca",
        host_id: 2351876,
        host_name: "Ciro",
        latitude: 45.42797,
        longitude: 12.31958,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31958, 45.42797]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12075464,
        name: "Apartment Corte Bragadin",
        host_id: 16117448,
        host_name: "Antonina",
        latitude: 45.43073,
        longitude: 12.32847,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32847, 45.43073]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12076014,
        name: "Private room with kitchen, bathroom",
        host_id: 5074017,
        host_name: "Gianluca",
        latitude: 45.43372,
        longitude: 12.31648,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31648, 45.43372]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12078618,
        name: "Splendid apartment in the center",
        host_id: 64729400,
        host_name: "Lorenzo",
        latitude: 45.43983,
        longitude: 12.32542,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32542, 45.43983]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12084072,
        name: "Ca' Manzoni Apartment in Historic Palace in San Marco",
        host_id: 64765843,
        host_name: "Luisa",
        latitude: 45.43188,
        longitude: 12.33207,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33207, 45.43188]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12087736,
        name: "Alla Botta _ Apartment",
        host_id: 64781321,
        host_name: "Ali",
        latitude: 45.43792,
        longitude: 12.33131,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33131, 45.43792]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12096217,
        name: "Breakfast at San Maurizio's",
        host_id: 26963742,
        host_name: "Enrico",
        latitude: 45.43349,
        longitude: 12.33197,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33197, 45.43349]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12097508,
        name: "Modern Suite City Center",
        host_id: 61291476,
        host_name: "Sarah",
        latitude: 45.44426,
        longitude: 12.32609,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32609, 45.44426]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12100721,
        name: "Double Room in Venice silent area near bus/train",
        host_id: 18151381,
        host_name: "Fran",
        latitude: 45.43367,
        longitude: 12.34188,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34188, 45.43367]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12105133,
        name: "Luxury and cozy home on the canal .",
        host_id: 4323004,
        host_name: "Matteo",
        latitude: 45.42918,
        longitude: 12.3313,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3313, 45.42918]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12107979,
        name: "Lovely  Cuoricino  suite",
        host_id: 44990889,
        host_name: "Anna",
        latitude: 45.44329,
        longitude: 12.32642,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32642, 45.44329]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12120008,
        name: "L'Appartamentino - Cosy apartment in Cannaregio",
        host_id: 52387813,
        host_name: "Elena",
        latitude: 45.44562,
        longitude: 12.32589,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32589, 45.44562]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12122403,
        name: "Very bright room; On First floor",
        host_id: 65035086,
        host_name: "Giampaolo",
        latitude: 45.44493,
        longitude: 12.32348,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32348, 45.44493]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12124036,
        name: "JANUARY PROMOTION: Big flat CANAL VIEW 1 bathroom",
        host_id: 47549577,
        host_name: "Silvia",
        latitude: 45.43763,
        longitude: 12.33042,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33042, 45.43763]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12134974,
        name: "La Boutique Biennale",
        host_id: 62631903,
        host_name: "Andre",
        latitude: 45.43327,
        longitude: 12.35321,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35321, 45.43327]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12162984,
        name: '"La Maddalena" Residence - 2 apartments',
        host_id: 289615,
        host_name: "Valentina",
        latitude: 45.44255,
        longitude: 12.33028,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33028, 45.44255]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12164082,
        name: "Ca' Grassi 3 for 2/3Guests with Terrace",
        host_id: 669047,
        host_name: "Viewsonvenice",
        latitude: 45.43363,
        longitude: 12.32948,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32948, 45.43363]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12164932,
        name: "Ca' Malvasia Venetian Terrace",
        host_id: 669047,
        host_name: "Viewsonvenice",
        latitude: 45.43476,
        longitude: 12.3326,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3326, 45.43476]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12165432,
        name:
          "Spettacolare e ampio appartamento veneziano con terrazza arredata sul tetto",
        host_id: 669047,
        host_name: "Viewsonvenice",
        latitude: 45.43321,
        longitude: 12.33059,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33059, 45.43321]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12167309,
        name: "Cozy apartment in Venice",
        host_id: 65356156,
        host_name: "Alberto",
        latitude: 45.44163,
        longitude: 12.32743,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32743, 45.44163]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12177548,
        name: "Ca' Drio San Marco",
        host_id: 60716907,
        host_name: "Ida",
        latitude: 45.43447,
        longitude: 12.33322,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33322, 45.43447]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12178298,
        name: "Classic Double/Twin Room Venice",
        host_id: 6174080,
        host_name: "Nello",
        latitude: 45.43524,
        longitude: 12.34259,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34259, 45.43524]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12178455,
        name: "Venetian-style Private Room Ensuite",
        host_id: 6174080,
        host_name: "Nello",
        latitude: 45.4377,
        longitude: 12.34243,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34243, 45.4377]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12184605,
        name: "推荐❤威尼斯主岛房间Room ★in heart of venice!",
        host_id: 35144066,
        host_name: "Xie",
        latitude: 45.43348,
        longitude: 12.35217,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35217, 45.43348]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12194076,
        name: "CENTRAL VENICE (Private Room & Shared Toilet )",
        host_id: 65244181,
        host_name: "Emran",
        latitude: 45.43833,
        longitude: 12.34022,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34022, 45.43833]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12200103,
        name: "Dreamy Upscale Abode in the Heart of Venice",
        host_id: 65595019,
        host_name: "Lidia",
        latitude: 45.43798,
        longitude: 12.33541,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33541, 45.43798]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12203407,
        name: "Cà D'Oro Appartamento con terrazza",
        host_id: 26102869,
        host_name: "My Sweetplace S.R.L.",
        latitude: 45.44166,
        longitude: 12.33514,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33514, 45.44166]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12205548,
        name: "Venicedire",
        host_id: 26353331,
        host_name: "Valentina",
        latitude: 45.43788,
        longitude: 12.31761,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31761, 45.43788]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12214043,
        name: "Ca' Widmann",
        host_id: 10329111,
        host_name: "Giorgio",
        latitude: 45.43984,
        longitude: 12.34108,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34108, 45.43984]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12214807,
        name: "Ca' Dell'Ulivo the Venetian House",
        host_id: 669047,
        host_name: "Viewsonvenice",
        latitude: 45.43064,
        longitude: 12.32293,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32293, 45.43064]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12216087,
        name: "DECEMBER PROMOTION Room-flat canal view (Rialto)",
        host_id: 47549577,
        host_name: "Silvia",
        latitude: 45.43927,
        longitude: 12.33044,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33044, 45.43927]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12227489,
        name: "Mascareta Bedroom / Bathroom",
        host_id: 65786550,
        host_name: "Alessandra",
        latitude: 45.44203,
        longitude: 12.33916,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33916, 45.44203]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12228396,
        name: "Venetian Mood: GOLD",
        host_id: 3549494,
        host_name: "Manuela",
        latitude: 45.42677,
        longitude: 12.32195,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32195, 45.42677]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12228429,
        name: "Venice in red wi-fi",
        host_id: 10072655,
        host_name: "Mario Apartment",
        latitude: 45.44096,
        longitude: 12.3341,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3341, 45.44096]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12237229,
        name: "B&B Alla Vera Da Pozzo - Wi-Fi",
        host_id: 65854833,
        host_name: "Emanuele",
        latitude: 45.44364,
        longitude: 12.32086,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32086, 45.44364]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12242429,
        name: "Charme lux apt by Cannaregio Canal",
        host_id: 6019189,
        host_name: "Federico",
        latitude: 45.44436,
        longitude: 12.32107,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32107, 45.44436]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12246471,
        name: "Relax&Sleep1",
        host_id: 65496046,
        host_name: "Kevin",
        latitude: 45.44572,
        longitude: 12.32335,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32335, 45.44572]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12248985,
        name: "Batela Double Bedroom / Bathroom",
        host_id: 65786550,
        host_name: "Alessandra",
        latitude: 45.44164,
        longitude: 12.34015,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34015, 45.44164]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12250136,
        name: "Sanpierota Double Bedroom/Bathroom",
        host_id: 65786550,
        host_name: "Alessandra",
        latitude: 45.44311,
        longitude: 12.34016,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34016, 45.44311]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12258260,
        name: 'VENICE, LUXURY "GIUDECCA"ISLAND',
        host_id: 65850308,
        host_name: "Marina",
        latitude: 45.42461,
        longitude: 12.33264,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33264, 45.42461]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12258798,
        name: "Sweet Dreams on Ca D'oro VELA",
        host_id: 56593037,
        host_name: "Daniela",
        latitude: 45.44144,
        longitude: 12.33696,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33696, 45.44144]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12259570,
        name: "House with private garden",
        host_id: 3146524,
        host_name: "Luca",
        latitude: 45.4395,
        longitude: 12.33745,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33745, 45.4395]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12260581,
        name: "Bellariva Waterfront",
        host_id: 66024275,
        host_name: "Nico",
        latitude: 45.44571,
        longitude: 12.33119,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33119, 45.44571]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12267434,
        name: "Appartamento 4 posti (PT) San Marco",
        host_id: 62268572,
        host_name: "Fabio",
        latitude: 45.43558,
        longitude: 12.34563,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34563, 45.43558]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12272689,
        name: "Alla Botta_Single Shared WC/Shower",
        host_id: 64781321,
        host_name: "Ali",
        latitude: 45.44033,
        longitude: 12.33304,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33304, 45.44033]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12279508,
        name: "Campo dei Gesuiti Apartment",
        host_id: 66163007,
        host_name: "Isotta",
        latitude: 45.44337,
        longitude: 12.33737,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33737, 45.44337]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12284873,
        name: "Central Venice ( Private Room & shared toilet )",
        host_id: 65244181,
        host_name: "Emran",
        latitude: 45.438,
        longitude: 12.34135,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34135, 45.438]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12291085,
        name: "Casetta della Vida Arsenale-Biennale",
        host_id: 23617844,
        host_name: "Paolo",
        latitude: 45.43395,
        longitude: 12.35058,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35058, 45.43395]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12291340,
        name: "Alla Botta_Double Shared WC/Shower",
        host_id: 64781321,
        host_name: "Ali",
        latitude: 45.43949,
        longitude: 12.33191,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33191, 45.43949]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12291353,
        name: "Alla Botta_Double",
        host_id: 64781321,
        host_name: "Ali",
        latitude: 45.43942,
        longitude: 12.33328,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33328, 45.43942]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12300429,
        name: "ALLE BIFORE - Near to Casino' of Venice",
        host_id: 10189388,
        host_name: "Raffaella",
        latitude: 45.44387,
        longitude: 12.32911,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32911, 45.44387]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12302124,
        name: "Apartment San Luca",
        host_id: 16117448,
        host_name: "Antonina",
        latitude: 45.43489,
        longitude: 12.3368,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3368, 45.43489]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12304004,
        name: "Fiorenza Home",
        host_id: 66340573,
        host_name: "Michela",
        latitude: 45.43376,
        longitude: 12.32947,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32947, 45.43376]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12312516,
        name: "appartamento Vivaldi",
        host_id: 4557370,
        host_name: "Giovanna",
        latitude: 45.4369,
        longitude: 12.34062,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34062, 45.4369]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12313694,
        name: "Venetian Style in top location",
        host_id: 8669903,
        host_name: "Caterina",
        latitude: 45.43269,
        longitude: 12.3295,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3295, 45.43269]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12318453,
        name: "Casa Ro.Ni. strategic position",
        host_id: 66451136,
        host_name: "Luisa",
        latitude: 45.4366,
        longitude: 12.31854,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31854, 45.4366]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12319024,
        name: "Romantic Bedroom",
        host_id: 11399969,
        host_name: "Barbara",
        latitude: 45.43412,
        longitude: 12.33342,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33342, 45.43412]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12322103,
        name: "Two rooms with private bathroom.",
        host_id: 11399969,
        host_name: "Barbara",
        latitude: 45.43372,
        longitude: 12.33246,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33246, 45.43372]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12323924,
        name: "Panoramic Suite",
        host_id: 31922692,
        host_name: "Iryna",
        latitude: 45.43819,
        longitude: 12.34898,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34898, 45.43819]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12329486,
        name: "Appartamento Carpaccio",
        host_id: 66538075,
        host_name: "Giovanni",
        latitude: 45.43707,
        longitude: 12.34535,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34535, 45.43707]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12329991,
        name: "Relax private room & bathroom",
        host_id: 5074017,
        host_name: "Gianluca",
        latitude: 45.43385,
        longitude: 12.31888,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31888, 45.43385]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12338672,
        name: "Comodo, silenzioso, con giardino",
        host_id: 14876679,
        host_name: "Marina",
        latitude: 45.44604,
        longitude: 12.32306,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32306, 45.44604]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12339772,
        name: "Grande camera con bagno e salottino",
        host_id: 14876679,
        host_name: "Marina",
        latitude: 45.44552,
        longitude: 12.32295,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32295, 45.44552]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12354843,
        name: "Ve.N.I.Ce Cera, Palazzo Gardella",
        host_id: 37864680,
        host_name: "Ve.N.I.Ce Immobiliare Cera",
        latitude: 45.42946,
        longitude: 12.33217,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33217, 45.42946]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12362312,
        name: "Appartamento Venezia centro",
        host_id: 66775567,
        host_name: "Chiara",
        latitude: 45.43756,
        longitude: 12.33672,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33672, 45.43756]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12371124,
        name: "Typical Venetian apartment",
        host_id: 28755672,
        host_name: "Barbara",
        latitude: 45.44566,
        longitude: 12.32502,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32502, 45.44566]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12372444,
        name: "DolceVita Apartments N. 315 Canal",
        host_id: 8176475,
        host_name: "Eugenia",
        latitude: 45.43359,
        longitude: 12.32018,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32018, 45.43359]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12394585,
        name: "levantina - appartamento con corte privata",
        host_id: 67016891,
        host_name: "Roberto",
        latitude: 45.44383,
        longitude: 12.33034,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33034, 45.44383]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12395018,
        name: "Double room 3 minutes from the Cruise",
        host_id: 67019656,
        host_name: "CaDoge",
        latitude: 45.43727,
        longitude: 12.3168,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3168, 45.43727]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12395757,
        name: "Nel Centro storico di Venezia",
        host_id: 3674980,
        host_name: "Matteo E Luisa",
        latitude: 45.44105,
        longitude: 12.34116,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34116, 45.44105]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12395830,
        name: "Room with FREE parking in Venice Center",
        host_id: 67019656,
        host_name: "CaDoge",
        latitude: 45.43874,
        longitude: 12.31813,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31813, 45.43874]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12396689,
        name: '"CA\' CORDONI" Apartment',
        host_id: 1863344,
        host_name: "Tobia",
        latitude: 45.442,
        longitude: 12.34028,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34028, 45.442]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12400499,
        name: "Large, Biennale zone S. Marco",
        host_id: 4390954,
        host_name: "Carlo",
        latitude: 45.4317,
        longitude: 12.35165,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35165, 45.4317]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12418421,
        name: "WellVenice Fenice",
        host_id: 41898872,
        host_name: "Cristina",
        latitude: 45.43449,
        longitude: 12.33366,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33366, 45.43449]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12419184,
        name: "Ca' Tintoretto Canal View",
        host_id: 669047,
        host_name: "Viewsonvenice",
        latitude: 45.44571,
        longitude: 12.332,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.332, 45.44571]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12421426,
        name: "CA' LUCY - Canal view, 2 bedrooms near Cruise Line",
        host_id: 10189388,
        host_name: "Raffaella",
        latitude: 45.43271,
        longitude: 12.31767,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31767, 45.43271]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12437671,
        name: "A beautiful single room Venice near Bus/Train",
        host_id: 18151381,
        host_name: "Fran",
        latitude: 45.43516,
        longitude: 12.34331,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34331, 45.43516]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12442993,
        name: "Alla Botta _ Triple Room",
        host_id: 64781321,
        host_name: "Ali",
        latitude: 45.43843,
        longitude: 12.33285,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33285, 45.43843]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12443331,
        name: "LUXURY NEW apartment noveno1",
        host_id: 27468706,
        host_name: "Valeria",
        latitude: 45.44331,
        longitude: 12.32738,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32738, 45.44331]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12452977,
        name: "Peaceful apartment - located SALUTE",
        host_id: 13799612,
        host_name: "Barbara",
        latitude: 45.42901,
        longitude: 12.33205,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33205, 45.42901]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12453941,
        name: "Testa d'Oro 3 - View onto the Rialto Steps",
        host_id: 51021330,
        host_name: "Francesco",
        latitude: 45.4374,
        longitude: 12.33602,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33602, 45.4374]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12457386,
        name: "2 apart in Accademia area, canal view and garden",
        host_id: 289615,
        host_name: "Valentina",
        latitude: 45.42957,
        longitude: 12.32895,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32895, 45.42957]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12460190,
        name: "Fantastic luxury flat San Zaccaria",
        host_id: 48092742,
        host_name: "Roby",
        latitude: 45.43477,
        longitude: 12.34126,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34126, 45.43477]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12462391,
        name: "CHARME APARTMENT IN A TRENDY AND AUTHENTIC VENICE",
        host_id: 67440190,
        host_name: "Marta",
        latitude: 45.42699,
        longitude: 12.31847,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31847, 45.42699]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12463214,
        name: "LUXURY NEW apartment Noveno 2",
        host_id: 27468706,
        host_name: "Valeria",
        latitude: 45.44301,
        longitude: 12.32592,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32592, 45.44301]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12468710,
        name: "Very central in Historical Palazzo",
        host_id: 41616121,
        host_name: "Daniela",
        latitude: 45.43223,
        longitude: 12.33174,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33174, 45.43223]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12476919,
        name: "Your Family Home in Venice",
        host_id: 67535917,
        host_name: "Nicole",
        latitude: 45.43883,
        longitude: 12.34976,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34976, 45.43883]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12482811,
        name: "Beautiful Unique Canal front-open modern LOFT",
        host_id: 1466887,
        host_name: "Milena",
        latitude: 45.44625,
        longitude: 12.33349,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33349, 45.44625]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12499355,
        name: "Cozy Apartment for 2/3 Guests Ca' del Monastero 8",
        host_id: 669047,
        host_name: "Viewsonvenice",
        latitude: 45.44178,
        longitude: 12.32685,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32685, 45.44178]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12505135,
        name: "Family Room with Parking in Piazzale Roma",
        host_id: 67019656,
        host_name: "CaDoge",
        latitude: 45.43785,
        longitude: 12.31882,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31882, 45.43785]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12518628,
        name: "Whole RED HOUSE with terrace",
        host_id: 67800703,
        host_name: "Patrizia & Paolo",
        latitude: 45.43153,
        longitude: 12.32054,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32054, 45.43153]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12526589,
        name: "Venice Cà d'eau -  Amazing location perfect for 4!",
        host_id: 3278320,
        host_name: "Adele",
        latitude: 45.44834,
        longitude: 12.32736,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32736, 45.44834]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12530691,
        name: "Singola Venezia centro",
        host_id: 49360286,
        host_name: "Camilla",
        latitude: 45.43832,
        longitude: 12.33089,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33089, 45.43832]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12535980,
        name: "La Musa Luxury - Campo dei Mori",
        host_id: 26404861,
        host_name: "Marika",
        latitude: 45.44601,
        longitude: 12.33134,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33134, 45.44601]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12548963,
        name: "SERENISSIMO PRENCIPE",
        host_id: 65267389,
        host_name: "Claudia",
        latitude: 45.43723,
        longitude: 12.32412,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32412, 45.43723]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12552894,
        name: "Double or triple bedroom  nice view central area",
        host_id: 1910577,
        host_name: "Nikola",
        latitude: 45.44321,
        longitude: 12.32546,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32546, 45.44321]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12554296,
        name: "Lumineux apartement au coeur de Venise",
        host_id: 23263711,
        host_name: "Antonella",
        latitude: 45.43717,
        longitude: 12.33622,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33622, 45.43717]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12556508,
        name: "Panoramic penthouse Lux central",
        host_id: 41889313,
        host_name: "Federica & Alessandro",
        latitude: 45.43296,
        longitude: 12.33391,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33391, 45.43296]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12599363,
        name: "Huge Double Room in Venice near train/bus station",
        host_id: 18151381,
        host_name: "Fran",
        latitude: 45.43907,
        longitude: 12.33776,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33776, 45.43907]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12599913,
        name: "DolceVita Apartments 228",
        host_id: 8176475,
        host_name: "Eugenia",
        latitude: 45.4357,
        longitude: 12.34473,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34473, 45.4357]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12601531,
        name:
          "Rialto Bridge Luxury  in Venice  (M (Phone number hidden by Airbnb)",
        host_id: 13251582,
        host_name: "Riccardo & Chiara",
        latitude: 45.43779,
        longitude: 12.33413,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33413, 45.43779]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12619306,
        name: "FAVOLOSO APPARTAMENTO FRONTE LAGUNA",
        host_id: 68507905,
        host_name: "Massimo",
        latitude: 45.42463,
        longitude: 12.33861,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33861, 45.42463]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12623610,
        name: "Chiaro di Luna - 5 min from St. Mark",
        host_id: 7672609,
        host_name: "Gian Luigi & Nicola",
        latitude: 45.43444,
        longitude: 12.34774,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34774, 45.43444]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12626794,
        name: "Casa dei Guardiani",
        host_id: 31915994,
        host_name: "Olga",
        latitude: 45.43496,
        longitude: 12.32025,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32025, 45.43496]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12627757,
        name: "Biennale Apartment",
        host_id: 68560505,
        host_name: "Mauro",
        latitude: 45.43015,
        longitude: 12.35778,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35778, 45.43015]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12644325,
        name: "Ca' Fiorenza Apartment",
        host_id: 68674629,
        host_name: "Delia",
        latitude: 45.4413,
        longitude: 12.32823,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32823, 45.4413]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12652039,
        name: "Casa Fancy' in the heart of Venice!",
        host_id: 68725132,
        host_name: "Raffaella",
        latitude: 45.44016,
        longitude: 12.3356,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3356, 45.44016]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12660671,
        name: "Ca' Cerchieri Mezzanine",
        host_id: 669047,
        host_name: "Viewsonvenice",
        latitude: 45.43369,
        longitude: 12.32675,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32675, 45.43369]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12671810,
        name: "San Marco, Contemporary Classic",
        host_id: 12333256,
        host_name: "Marco",
        latitude: 45.43519,
        longitude: 12.34161,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34161, 45.43519]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12695570,
        name: "Apartment in Venezia-Giudecca(Quality is my word)",
        host_id: 69004828,
        host_name: "Denise",
        latitude: 45.4255,
        longitude: 12.33856,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33856, 45.4255]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12695596,
        name: "big house next to Ghetto and tipycal venetian life",
        host_id: 4182695,
        host_name: "Claudia",
        latitude: 45.44654,
        longitude: 12.32356,
        beds: 7,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32356, 45.44654]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12708571,
        name: "TOP-NOTCH, TOP-FLOOR 130 sqm beauty",
        host_id: 7167809,
        host_name: "Alessia",
        latitude: 45.43916,
        longitude: 12.33948,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33948, 45.43916]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12717910,
        name: "WONDERFUL-CANAL-VIEW 4pax Wi-Fi aircond",
        host_id: 17534457,
        host_name: "Abaca",
        latitude: 45.43133,
        longitude: 12.32177,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32177, 45.43133]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12719177,
        name: "Residenza San Leonardo - Luxury",
        host_id: 5618111,
        host_name: "EasySuite",
        latitude: 45.44323,
        longitude: 12.32749,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32749, 45.44323]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12732978,
        name: "☞ LittleStudio, intimate flat, centre of Venice.",
        host_id: 6500640,
        host_name: "Luca",
        latitude: 45.43325,
        longitude: 12.3284,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3284, 45.43325]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12744252,
        name: "Ca' Della Luce Roof Terrace",
        host_id: 669047,
        host_name: "Viewsonvenice",
        latitude: 45.43355,
        longitude: 12.32777,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32777, 45.43355]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12750972,
        name: "Romantic Venice",
        host_id: 1974968,
        host_name: "Graziella Itinere Villas",
        latitude: 45.43308,
        longitude: 12.33668,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33668, 45.43308]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12753082,
        name: "CityApartments Venice: Apartment Boteri",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.44173,
        longitude: 12.33576,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33576, 45.44173]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12759470,
        name: "Terrace sunny apartment in residential area ☀️",
        host_id: 69407303,
        host_name: "Alessia & Dagmar",
        latitude: 45.4247,
        longitude: 12.32787,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32787, 45.4247]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12769476,
        name: "CASTELLO GROUND FLOOR",
        host_id: 69477714,
        host_name: "Marco",
        latitude: 45.43524,
        longitude: 12.34192,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34192, 45.43524]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12769585,
        name: "Residence Bragora: 2 apartments/Arsenale-San Marco",
        host_id: 289615,
        host_name: "Valentina",
        latitude: 45.43562,
        longitude: 12.3461,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3461, 45.43562]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12775836,
        name: "Lovely Ca del Sol in Rialto",
        host_id: 289615,
        host_name: "Valentina",
        latitude: 45.44188,
        longitude: 12.34145,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34145, 45.44188]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12785633,
        name: "appartamento Goldoni",
        host_id: 4557370,
        host_name: "Giovanna",
        latitude: 45.43707,
        longitude: 12.33886,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33886, 45.43707]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12790172,
        name: "CASTELLO FIRST FLOOR",
        host_id: 69477714,
        host_name: "Marco",
        latitude: 45.43513,
        longitude: 12.342,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.342, 45.43513]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12790186,
        name: "RUGA GIUFFA FIRST FLOOR",
        host_id: 69477714,
        host_name: "Marco",
        latitude: 45.43715,
        longitude: 12.34261,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34261, 45.43715]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12798706,
        name: "Piano Nobile in Gothic palazzetto Santa Caterina",
        host_id: 22612140,
        host_name: "Odile",
        latitude: 45.44176,
        longitude: 12.3382,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3382, 45.44176]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12798767,
        name: "Mezzanino",
        host_id: 22612140,
        host_name: "Odile",
        latitude: 45.44405,
        longitude: 12.33838,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33838, 45.44405]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12798804,
        name: "Attico",
        host_id: 22612140,
        host_name: "Odile",
        latitude: 45.44258,
        longitude: 12.33707,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33707, 45.44258]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12800030,
        name: "Rialto Canal Grande View",
        host_id: 69737520,
        host_name: "Alberto",
        latitude: 45.43979,
        longitude: 12.33698,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33698, 45.43979]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12806874,
        name: "CA' ANNA",
        host_id: 1755413,
        host_name: "Davide",
        latitude: 45.43415,
        longitude: 12.3563,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3563, 45.43415]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12807965,
        name: "Ve-nice Suite Misericordia C2607B",
        host_id: 22423242,
        host_name: "Stefano",
        latitude: 45.44632,
        longitude: 12.33092,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33092, 45.44632]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12810158,
        name: "Cà Rio Marin",
        host_id: 69624052,
        host_name: "Cristina",
        latitude: 45.43998,
        longitude: 12.32491,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32491, 45.43998]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12810989,
        name: "Colonna apartment heart of Rialto",
        host_id: 69847435,
        host_name: "Paolo",
        latitude: 45.43967,
        longitude: 12.33293,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33293, 45.43967]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12811241,
        name: "Relax&Sleep",
        host_id: 65496046,
        host_name: "Kevin",
        latitude: 45.44649,
        longitude: 12.32144,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32144, 45.44649]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12817309,
        name: "Ca' Venezia",
        host_id: 69914607,
        host_name: "Arianna",
        latitude: 45.43488,
        longitude: 12.33064,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33064, 45.43488]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12818221,
        name: "Luxury Apartment near St. Mark's Square,canal view",
        host_id: 69921858,
        host_name: "Corte Nova S.R.L",
        latitude: 45.43749,
        longitude: 12.34557,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34557, 45.43749]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12818899,
        name: "VeniceVillas Ca dei Arsenaloti",
        host_id: 294951,
        host_name: "VeniceVillas Di Enzo",
        latitude: 45.4313,
        longitude: 12.35336,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35336, 45.4313]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12820193,
        name: "Rialto studio apartment",
        host_id: 69935272,
        host_name: "Ambra",
        latitude: 45.43812,
        longitude: 12.33139,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33139, 45.43812]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12822356,
        name: "Grand Canal Terrace Loft - Amazing View",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.43683,
        longitude: 12.32981,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32981, 45.43683]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12822904,
        name: "Sunny apartment in Dorsoduro",
        host_id: 69947115,
        host_name: "Anna",
        latitude: 45.43137,
        longitude: 12.32611,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32611, 45.43137]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12840461,
        name: "Apartment Baia (Historical Center)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.44461,
        longitude: 12.3215,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3215, 45.44461]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12860347,
        name: "Apartment Canova (500m from  Rialto's Bridge)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.43978,
        longitude: 12.3293,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3293, 45.43978]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12860728,
        name: "Apt. Contarina (100m from St. Mark's Square)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.43411,
        longitude: 12.33607,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33607, 45.43411]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12860900,
        name: "Adorable room in Cannaregio",
        host_id: 70301079,
        host_name: "Claudio",
        latitude: 45.44397,
        longitude: 12.31997,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31997, 45.44397]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12861076,
        name: "Albrizzi Palace - Venice Historical Center",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.44288,
        longitude: 12.33577,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33577, 45.44288]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12864288,
        name: "Apartment Cupido (250m from St. Mark's Square)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.43566,
        longitude: 12.33498,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33498, 45.43566]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12870311,
        name: "TRIPLE-DOUBLE VIEW ROOM - ROOF DREAM",
        host_id: 23598673,
        host_name: "Patricia",
        latitude: 45.43946,
        longitude: 12.3295,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3295, 45.43946]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12870389,
        name: "BIENNALE COMFY APARTMENT",
        host_id: 70383221,
        host_name: "Safwat",
        latitude: 45.43833,
        longitude: 12.34741,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34741, 45.43833]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12878093,
        name: "VINTAGE  FLAT",
        host_id: 70455711,
        host_name: "Elena",
        latitude: 45.43985,
        longitude: 12.33949,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33949, 45.43985]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12878255,
        name: "JAZZ HOUSE",
        host_id: 70455711,
        host_name: "Elena",
        latitude: 45.43305,
        longitude: 12.31594,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31594, 45.43305]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12879781,
        name: "Dream in Venice",
        host_id: 1974968,
        host_name: "Graziella Itinere Villas",
        latitude: 45.4244,
        longitude: 12.3309,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3309, 45.4244]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12881240,
        name: "Apt. Ca' d'Oro Amazing View on Grand Canal",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.44405,
        longitude: 12.33032,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33032, 45.44405]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12881628,
        name: "Silvia's Home Cod. ID M (Phone number hidden by Airbnb)",
        host_id: 45342577,
        host_name: "Daria",
        latitude: 45.44372,
        longitude: 12.32341,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32341, 45.44372]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12894202,
        name: "Summer Discounts! - Dorsoduro Charming Hideaway",
        host_id: 2196999,
        host_name: "Barbara",
        latitude: 45.4322,
        longitude: 12.31594,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31594, 45.4322]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12900098,
        name: "Casa La Perla",
        host_id: 52980180,
        host_name: "Giulia",
        latitude: 45.43505,
        longitude: 12.33954,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33954, 45.43505]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12904509,
        name: "SUITE STELLA - Deluxe Apartment In Venice",
        host_id: 9350468,
        host_name: "Antonello",
        latitude: 45.44099,
        longitude: 12.34077,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34077, 45.44099]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12911542,
        name: "Casa Bella",
        host_id: 46904188,
        host_name: "Mirco Optyflat",
        latitude: 45.44729,
        longitude: 12.3236,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3236, 45.44729]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12915198,
        name: "Apartment With Terrace, an amazing city view",
        host_id: 70816200,
        host_name: "Sante",
        latitude: 45.43817,
        longitude: 12.32869,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32869, 45.43817]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12918964,
        name: "appartamento Casanova",
        host_id: 4557370,
        host_name: "Giovanna",
        latitude: 45.43718,
        longitude: 12.34039,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34039, 45.43718]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12928477,
        name: "Charming Venice Apartment with sea views",
        host_id: 35279206,
        host_name: "LMV - Exclusive Venice Apartments",
        latitude: 45.42971,
        longitude: 12.32817,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32817, 45.42971]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12937474,
        name: "Grazioso monolocale a Venezia",
        host_id: 71058708,
        host_name: "Chiara",
        latitude: 45.4459,
        longitude: 12.32497,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32497, 45.4459]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12949574,
        name: "Ve-nice Suite Giuffa C4834",
        host_id: 22423242,
        host_name: "Stefano",
        latitude: 45.43531,
        longitude: 12.34308,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34308, 45.43531]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12961008,
        name: "Cà Ruffoni Apartment IP (Phone number hidden by Airbnb)",
        host_id: 15005402,
        host_name: "Veronica",
        latitude: 45.43704,
        longitude: 12.32763,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32763, 45.43704]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12961732,
        name: "Zamò Terrace M (Phone number hidden by Airbnb)",
        host_id: 15005402,
        host_name: "Veronica",
        latitude: 45.43806,
        longitude: 12.33921,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33921, 45.43806]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12965595,
        name: "Ca dei libri - Penthouse and Altana",
        host_id: 55364024,
        host_name: "Thierry",
        latitude: 45.43371,
        longitude: 12.34698,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34698, 45.43371]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12968462,
        name: "Molino Stucky Giudecca 55, quiet sunny, luxurious",
        host_id: 71334308,
        host_name: "Nick",
        latitude: 45.42639,
        longitude: 12.31887,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31887, 45.42639]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12976971,
        name: "SAN MARCO STAR 1DS",
        host_id: 14357135,
        host_name: "Rent It Venice",
        latitude: 45.43292,
        longitude: 12.33605,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33605, 45.43292]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12977652,
        name: "SAN MARCO STAR 2D",
        host_id: 14357135,
        host_name: "Rent It Venice",
        latitude: 45.43453,
        longitude: 12.33639,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33639, 45.43453]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12978378,
        name: "Schiavoni Style! 4 bedrooms with A/C - SAN MARCO",
        host_id: 289615,
        host_name: "Valentina",
        latitude: 45.43516,
        longitude: 12.34104,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34104, 45.43516]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12978397,
        name: "TinyLuxury Penthouse S. Marco",
        host_id: 23810951,
        host_name: "Claudio",
        latitude: 45.43445,
        longitude: 12.33825,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33825, 45.43445]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12978839,
        name: "LAST MINUTE RIALTO BRIDGE",
        host_id: 25496626,
        host_name: "Bertoli",
        latitude: 45.43444,
        longitude: 12.33723,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33723, 45.43444]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12980856,
        name: "SAN MARCO STAR 2S",
        host_id: 14357135,
        host_name: "Rent It Venice",
        latitude: 45.43436,
        longitude: 12.33594,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33594, 45.43436]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12981184,
        name: "SAN MARCO STAR 4DS",
        host_id: 14357135,
        host_name: "Rent It Venice",
        latitude: 45.43451,
        longitude: 12.33703,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33703, 45.43451]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12981431,
        name: "SAN MARCO STAR 5",
        host_id: 14357135,
        host_name: "Rent It Venice",
        latitude: 45.43499,
        longitude: 12.33708,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33708, 45.43499]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12981554,
        name: "4 bedrooms apartment",
        host_id: 47683665,
        host_name: "Alberto",
        latitude: 45.43392,
        longitude: 12.33445,
        beds: 8,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33445, 45.43392]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12983557,
        name: "Ca' Doge da Ponte - S.Marco",
        host_id: 71494066,
        host_name: "Monica",
        latitude: 45.43252,
        longitude: 12.33163,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33163, 45.43252]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12987934,
        name: "La terrazza del melograno",
        host_id: 71539325,
        host_name: "Giovanni",
        latitude: 45.43876,
        longitude: 12.34116,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34116, 45.43876]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12988125,
        name: "Santa Croce with Garden - Art Apartments Venice",
        host_id: 28162920,
        host_name: "Beatriz",
        latitude: 45.43698,
        longitude: 12.31932,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31932, 45.43698]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12991975,
        name: "CàNelly,charming room,5min from St.Mark's Square",
        host_id: 47651579,
        host_name: "Annalisa",
        latitude: 45.43457,
        longitude: 12.34793,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34793, 45.43457]] },
    },
    {
      type: "Feature",
      properties: {
        id: 12997739,
        name: "Apartment in venice city center (santo Stefano)",
        host_id: 71624806,
        host_name: "Malika",
        latitude: 45.43295,
        longitude: 12.32911,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32911, 45.43295]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13001053,
        name: "Stanza in ariosa casa con terrazza",
        host_id: 71233060,
        host_name: "Andrea",
        latitude: 45.4388,
        longitude: 12.32381,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32381, 45.4388]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13001409,
        name: "Sink into the Rust-Toned Chesterfield in Lively Cannaregio",
        host_id: 24571049,
        host_name: "Simone",
        latitude: 45.4438,
        longitude: 12.32413,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32413, 45.4438]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13012892,
        name: "DolceVita Apartments N. 329",
        host_id: 8176475,
        host_name: "Eugenia",
        latitude: 45.42525,
        longitude: 12.32581,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32581, 45.42525]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13021925,
        name: "Panoramic roof terrace heart  of Venice",
        host_id: 2399510,
        host_name: "Marina",
        latitude: 45.43788,
        longitude: 12.33874,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33874, 45.43788]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13028592,
        name: "Delizia",
        host_id: 71974434,
        host_name: "Yendy",
        latitude: 45.44332,
        longitude: 12.32708,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32708, 45.44332]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13040517,
        name: "Balcony on SS. Giovanni e Paolo",
        host_id: 72118803,
        host_name: "Sabrina",
        latitude: 45.44064,
        longitude: 12.34009,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34009, 45.44064]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13041076,
        name: "Romantica stanza a due passi dal GHETTO",
        host_id: 4684295,
        host_name: "Francesca",
        latitude: 45.44466,
        longitude: 12.32739,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32739, 45.44466]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13048184,
        name: "Santa Croce - Art Apartments Venice",
        host_id: 28162920,
        host_name: "Beatriz",
        latitude: 45.43528,
        longitude: 12.3176,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3176, 45.43528]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13073161,
        name: "Ca' Arianna Centro Storico",
        host_id: 72267914,
        host_name: "Martina",
        latitude: 45.43713,
        longitude: 12.35092,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35092, 45.43713]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13074432,
        name: "Ca Fenice, a suite from which you can see the gondolas.",
        host_id: 72488647,
        host_name: "Roberto",
        latitude: 45.43456,
        longitude: 12.33376,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33376, 45.43456]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13078027,
        name: "Palazzo del Sale, Rialto",
        host_id: 29588094,
        host_name: "Alberto",
        latitude: 45.43848,
        longitude: 12.33561,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33561, 45.43848]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13087597,
        name: "Ca' de la Comare, amazing  on Canal Grande",
        host_id: 12113015,
        host_name: "Mario",
        latitude: 45.44135,
        longitude: 12.32832,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32832, 45.44135]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13109363,
        name: "Big George Gallery",
        host_id: 46904188,
        host_name: "Mirco Optyflat",
        latitude: 45.4414,
        longitude: 12.33752,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33752, 45.4414]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13113908,
        name: "Giudecca Light Home",
        host_id: 68030097,
        host_name: "Laura",
        latitude: 45.4275,
        longitude: 12.31981,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31981, 45.4275]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13119226,
        name: "Al Campaniel Luxury Apartment",
        host_id: 46904188,
        host_name: "Mirco Optyflat",
        latitude: 45.43879,
        longitude: 12.33304,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33304, 45.43879]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13123956,
        name: "Ca'Bernet in the heart of Venice",
        host_id: 64039606,
        host_name: "Margherita",
        latitude: 45.44055,
        longitude: 12.32483,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32483, 45.44055]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13124597,
        name: "Guglie: private House facing the Canal",
        host_id: 1860412,
        host_name: "Andrea",
        latitude: 45.44298,
        longitude: 12.32215,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32215, 45.44298]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13135654,
        name: "Apartment in a Venetian Palace",
        host_id: 14212454,
        host_name: "Paolo",
        latitude: 45.43974,
        longitude: 12.33588,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33588, 45.43974]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13137220,
        name: "Brand New Apartment in Venice",
        host_id: 43777105,
        host_name: "Gian  Ruggero",
        latitude: 45.44236,
        longitude: 12.33366,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33366, 45.44236]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13146584,
        name: "Romantic Room in centre SAN MARCO2",
        host_id: 48092742,
        host_name: "Roby",
        latitude: 45.43635,
        longitude: 12.34224,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34224, 45.43635]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13148068,
        name: "Cosy studio in Venice city centre",
        host_id: 73331764,
        host_name: "Giulia",
        latitude: 45.43502,
        longitude: 12.32495,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32495, 45.43502]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13150523,
        name: "CA' CAMMELLO: terrace exclusive and canal view",
        host_id: 73358434,
        host_name: "Agata&Andrea",
        latitude: 45.44519,
        longitude: 12.33307,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33307, 45.44519]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13160175,
        name: "Boat & Breakfast in the Venice Lagoon",
        host_id: 56978479,
        host_name: "Ernesto",
        latitude: 45.42841,
        longitude: 12.3666,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3666, 45.42841]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13160675,
        name: "Apt. Malibran (200mt from Rialto's Bridge)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.44116,
        longitude: 12.33725,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33725, 45.44116]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13161601,
        name: "Manin Canal Terrace (200m from St Mark's Square)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.43566,
        longitude: 12.3431,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3431, 45.43566]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13162260,
        name: "BIANCO 4 APARTMENT near BIENNALE Giardini Arsenale",
        host_id: 73508332,
        host_name: "Claudia",
        latitude: 45.43406,
        longitude: 12.35891,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35891, 45.43406]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13162329,
        name: "Ancient Palace Ca' Doge, 500m from Rialto's Bridge",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.43914,
        longitude: 12.33407,
        beds: 8,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33407, 45.43914]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13163550,
        name: "Ca' Cerchieri 3 on the Grand Canal",
        host_id: 669047,
        host_name: "Viewsonvenice",
        latitude: 45.43323,
        longitude: 12.32699,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32699, 45.43323]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13163603,
        name: "Apartment Moro 4 (80mt. from Rialto's Bridge)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.43405,
        longitude: 12.33651,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33651, 45.43405]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13163877,
        name: "Rialto Room on rooftop",
        host_id: 48092742,
        host_name: "Roby",
        latitude: 45.43808,
        longitude: 12.33691,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33691, 45.43808]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13164648,
        name: "4/6 pax new charming apartment.",
        host_id: 8865074,
        host_name: "Valerie",
        latitude: 45.4461,
        longitude: 12.32718,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32718, 45.4461]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13165730,
        name: "Romantic Room in San Marco",
        host_id: 31276705,
        host_name: "Mila",
        latitude: 45.43694,
        longitude: 12.34097,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34097, 45.43694]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13166990,
        name: "Ca' Magno-Luxury apartment, close to the Biennale",
        host_id: 24618095,
        host_name: "Stefania",
        latitude: 45.43684,
        longitude: 12.35032,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35032, 45.43684]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13180330,
        name: "Santa Caterina",
        host_id: 12982157,
        host_name: "Locappart",
        latitude: 45.44209,
        longitude: 12.338,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.338, 45.44209]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13180749,
        name: "Bright loft apartment with stunning canal views",
        host_id: 10126721,
        host_name: "Piero",
        latitude: 45.43304,
        longitude: 12.31728,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31728, 45.43304]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13181481,
        name: "Pretty flat with canal view - WiFi",
        host_id: 73709835,
        host_name: "Francesca",
        latitude: 45.44428,
        longitude: 12.33126,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33126, 45.44428]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13191118,
        name: "flat in Santa Margherita - real Airbnb experience!",
        host_id: 67694299,
        host_name: "Sebastiano",
        latitude: 45.43295,
        longitude: 12.32302,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32302, 45.43295]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13199926,
        name: "Brand New Apartment w/ a private Garden!",
        host_id: 73934712,
        host_name: "Tour Apartments",
        latitude: 45.4247,
        longitude: 12.3392,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3392, 45.4247]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13201733,
        name: "Ca' Dragan, an authentic Venetian house",
        host_id: 37381363,
        host_name: "Horacio",
        latitude: 45.44048,
        longitude: 12.33508,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33508, 45.44048]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13205131,
        name: "Central Suite with private bath",
        host_id: 73990890,
        host_name: "Nina",
        latitude: 45.43796,
        longitude: 12.32595,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32595, 45.43796]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13217613,
        name: "Casa Rometta",
        host_id: 10517856,
        host_name: "Alessandra",
        latitude: 45.44077,
        longitude: 12.32663,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32663, 45.44077]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13218455,
        name: "Ca' Desdemona",
        host_id: 3972291,
        host_name: "Caroline E Marco",
        latitude: 45.4358,
        longitude: 12.34591,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34591, 45.4358]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13228648,
        name: "Apartment Moro 5 (80mt. from Rialto's Bridge)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.43352,
        longitude: 12.3353,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3353, 45.43352]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13229486,
        name: "Residenza dell'Arte",
        host_id: 5618111,
        host_name: "EasySuite",
        latitude: 45.42752,
        longitude: 12.31927,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31927, 45.42752]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13231972,
        name: "Venice central. Cozy, modern new apartment.",
        host_id: 68564211,
        host_name: "Valentina",
        latitude: 45.44295,
        longitude: 12.32892,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32892, 45.44295]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13244064,
        name: "Shared room in Venice !",
        host_id: 35982417,
        host_name: "Giulia",
        latitude: 45.43148,
        longitude: 12.31956,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31956, 45.43148]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13248342,
        name: "Verde Veneziano",
        host_id: 46904188,
        host_name: "Mirco Optyflat",
        latitude: 45.42831,
        longitude: 12.36332,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.36332, 45.42831]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13257764,
        name: "Spacious studio in Venetian Palazzo",
        host_id: 52582054,
        host_name: "Anna",
        latitude: 45.43742,
        longitude: 12.32719,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32719, 45.43742]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13269303,
        name: "Cannaregio Particular Apt",
        host_id: 13027859,
        host_name: "Diego",
        latitude: 45.4436,
        longitude: 12.32796,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32796, 45.4436]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13269699,
        name: "Cannaregio Particular Room",
        host_id: 13027859,
        host_name: "Diego",
        latitude: 45.44406,
        longitude: 12.32813,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32813, 45.44406]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13270571,
        name:
          "Cozy, modern Italian condo, walking distance to all the essentials",
        host_id: 4339678,
        host_name: "Vacasa Italy - Venice",
        latitude: 45.44113,
        longitude: 12.32589,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32589, 45.44113]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13273474,
        name: "LA BIENNALE Suite House",
        host_id: 74794562,
        host_name: "Betty",
        latitude: 45.43239,
        longitude: 12.35372,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35372, 45.43239]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13277389,
        name: "Cozy, spacious, central room above Venetian roofs",
        host_id: 74827876,
        host_name: "Natasa",
        latitude: 45.43381,
        longitude: 12.34632,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34632, 45.43381]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13280248,
        name: "CA' SCARPA Charming, cosy, full of light",
        host_id: 14501025,
        host_name: "Xenia",
        latitude: 45.43234,
        longitude: 12.35577,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35577, 45.43234]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13285492,
        name: "Poveglia - Magical atmosphere in the heart of Venice.",
        host_id: 74943278,
        host_name: "Marta",
        latitude: 45.43016,
        longitude: 12.35709,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35709, 45.43016]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13288744,
        name: "Cosy, R♡mantic & Stylish Studio",
        host_id: 7167809,
        host_name: "Alessia",
        latitude: 45.43983,
        longitude: 12.34009,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34009, 45.43983]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13309034,
        name: 'APARTMENT VENICE PIAZZA SAN MARCO "TINTORETTO"',
        host_id: 51054790,
        host_name: "Anna",
        latitude: 45.43463,
        longitude: 12.33957,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33957, 45.43463]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13315519,
        name: "Casa REGINA Ponte di Rialto",
        host_id: 75268451,
        host_name: "Svetlana",
        latitude: 45.44011,
        longitude: 12.33163,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33163, 45.44011]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13320881,
        name: "Apartment overlooking the rooftops of Venice",
        host_id: 75337369,
        host_name: "Cesare",
        latitude: 45.43807,
        longitude: 12.32596,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32596, 45.43807]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13328190,
        name: "Stay in the heart of Venice.",
        host_id: 75414665,
        host_name: "Lucia",
        latitude: 45.43849,
        longitude: 12.34093,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34093, 45.43849]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13335877,
        name: "BRIGHT APARTMENT 10 MINUTES FROM RIALTO",
        host_id: 75167477,
        host_name: "Martina",
        latitude: 45.43788,
        longitude: 12.32873,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32873, 45.43788]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13335921,
        name: "Cosy room behind Guggenheim Museum",
        host_id: 75514368,
        host_name: "Iside",
        latitude: 45.42988,
        longitude: 12.33129,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33129, 45.42988]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13337354,
        name: "Ca' All'Arco  Luxury Flat for families and couples",
        host_id: 75529111,
        host_name: "Elisabetta",
        latitude: 45.43901,
        longitude: 12.34816,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34816, 45.43901]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13339865,
        name: "Apartment Pisani (400m from St. Mark's Square)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.43443,
        longitude: 12.33541,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33541, 45.43443]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13343640,
        name: "Ca' Meraviglia Canal View",
        host_id: 669047,
        host_name: "Viewsonvenice",
        latitude: 45.43514,
        longitude: 12.32368,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32368, 45.43514]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13346778,
        name: "Budget San stae House Ground Floor",
        host_id: 22940319,
        host_name: "Albatroservices",
        latitude: 45.4399,
        longitude: 12.33042,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33042, 45.4399]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13356740,
        name: "Ca' Gabri Apartment (free WI-FI)",
        host_id: 75544323,
        host_name: "Gabriele",
        latitude: 45.4387,
        longitude: 12.33732,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33732, 45.4387]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13371298,
        name: "The lovely Rosa's House",
        host_id: 75923641,
        host_name: "Rosa",
        latitude: 45.43986,
        longitude: 12.33993,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33993, 45.43986]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13383345,
        name: "Apartment San Girolamo Canal View",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.44405,
        longitude: 12.3257,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3257, 45.44405]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13384176,
        name: "Surian Canal View (200m from St Mark’s Square)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.43464,
        longitude: 12.3395,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3395, 45.43464]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13385546,
        name: "Apt. Santo Stefano (5 min from St. Mark's Square)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.43336,
        longitude: 12.33277,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33277, 45.43336]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13386499,
        name: "Apt. Grand Canal Terrace Scalzi",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.44044,
        longitude: 12.32448,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32448, 45.44044]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13392804,
        name: "Venice City Centre apartment",
        host_id: 54971403,
        host_name: "Pietro",
        latitude: 45.43812,
        longitude: 12.34875,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34875, 45.43812]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13393442,
        name: "Shining luxury flat in giardini",
        host_id: 48092742,
        host_name: "Roby",
        latitude: 45.4294,
        longitude: 12.3591,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3591, 45.4294]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13395330,
        name: "Royal Room, City Centre Venice island",
        host_id: 22974469,
        host_name: "Fede",
        latitude: 45.42981,
        longitude: 12.35732,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35732, 45.42981]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13395792,
        name: "Elegant green gold Flat in Giardini",
        host_id: 31276705,
        host_name: "Mila",
        latitude: 45.43112,
        longitude: 12.35935,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35935, 45.43112]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13406011,
        name: "San Marco Canal View (200m from St. Mark's Square)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.43437,
        longitude: 12.3369,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3369, 45.43437]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13407392,
        name: "CityApartments Venice - Apartment Orchidea",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.44176,
        longitude: 12.32859,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32859, 45.44176]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13419485,
        name: "Giardini Apartment (free WI-FI)",
        host_id: 75544323,
        host_name: "Gabriele",
        latitude: 45.43122,
        longitude: 12.35583,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35583, 45.43122]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13420595,
        name: "Zoia Terrace view on St Mark's Basilica (150mt)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.43457,
        longitude: 12.34025,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34025, 45.43457]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13421119,
        name: "Il sogno di Elena Ca D'oro",
        host_id: 76495366,
        host_name: "Andrea",
        latitude: 45.44179,
        longitude: 12.33431,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33431, 45.44179]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13422476,
        name: "Ca' Martina - Via Garibaldi, Castello - Venice",
        host_id: 76506264,
        host_name: "Martina",
        latitude: 45.43264,
        longitude: 12.35127,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35127, 45.43264]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13424923,
        name: "Apt. Marina (200mt from Rialto's Bridge)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.43817,
        longitude: 12.33832,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33832, 45.43817]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13429431,
        name: "Angelo Raffaele:  incantevole casa per 12 persone",
        host_id: 31915994,
        host_name: "Olga",
        latitude: 45.43316,
        longitude: 12.31927,
        beds: 12,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31927, 45.43316]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13434997,
        name: "In Love In Venice",
        host_id: 76639474,
        host_name: "Francesco",
        latitude: 45.44146,
        longitude: 12.3263,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3263, 45.44146]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13440148,
        name: "Apt. Marina BIS (200mt from Rialto's Bridge)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.43792,
        longitude: 12.33963,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33963, 45.43792]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13442131,
        name: "Dorsoduro461 - Rio",
        host_id: 13396685,
        host_name: "Francesco",
        latitude: 45.43005,
        longitude: 12.33078,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33078, 45.43005]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13446151,
        name: "DolceVita Apartments N. 331 Biennale",
        host_id: 8176475,
        host_name: "Eugenia",
        latitude: 45.42646,
        longitude: 12.36232,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.36232, 45.42646]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13447251,
        name: "CA' PERLA: free wifi & near San Marco",
        host_id: 3736168,
        host_name: "EasyRentals",
        latitude: 45.433039117066798,
        longitude: 12.351126012306644,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35113, 45.43304]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13449046,
        name: "Casa di Anna - Historic House of Giacomo Casanova",
        host_id: 72445649,
        host_name: "Fabrizio & Anna",
        latitude: 45.43886,
        longitude: 12.34328,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34328, 45.43886]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13458293,
        name: "Casa Gottardi - Sun Room",
        host_id: 60962235,
        host_name: "Susanna",
        latitude: 45.43906,
        longitude: 12.33333,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33333, 45.43906]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13470839,
        name: "Marinaressa Terrazza near Arsenale and Biennale",
        host_id: 77059713,
        host_name: "Paola",
        latitude: 45.43126,
        longitude: 12.3527,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3527, 45.43126]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13485923,
        name: "VENICE lovely & sweet home",
        host_id: 9631559,
        host_name: "Giovanni",
        latitude: 45.44174,
        longitude: 12.32989,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32989, 45.44174]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13494024,
        name: "VENICE OLD TOWN CENTRE NEAR RIALTO",
        host_id: 63194257,
        host_name: "Edoardo",
        latitude: 45.44038,
        longitude: 12.33961,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33961, 45.44038]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13509428,
        name: "Lovely three-floors house in the heart of Venice",
        host_id: 77519009,
        host_name: "Federico",
        latitude: 45.43946,
        longitude: 12.32941,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32941, 45.43946]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13515701,
        name: "Charming flat with terrace over the canal",
        host_id: 21812840,
        host_name: "Luigi",
        latitude: 45.43597,
        longitude: 12.31799,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31799, 45.43597]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13518334,
        name: "Apt. Dorsoduro (100m from Guggenheim Museum)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.42998,
        longitude: 12.33231,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33231, 45.42998]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13518885,
        name: "LA BIENNALE SUITE HOUSE - Unit 2",
        host_id: 74794562,
        host_name: "Betty",
        latitude: 45.43168,
        longitude: 12.35674,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35674, 45.43168]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13521294,
        name: "CA MIRACOLI",
        host_id: 77673326,
        host_name: "Monica",
        latitude: 45.44192,
        longitude: 12.33531,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33531, 45.44192]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13522593,
        name: "Apartment ideal for the Biennale, but not only!",
        host_id: 11687040,
        host_name: "Marilia",
        latitude: 45.43186,
        longitude: 12.3527,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3527, 45.43186]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13522790,
        name: "Apartment Avogaria (Historical Centre)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.43296,
        longitude: 12.32415,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32415, 45.43296]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13525352,
        name: '"Conca San Luca" (San Marco/Rialto)',
        host_id: 77717973,
        host_name: "Marco",
        latitude: 45.43514,
        longitude: 12.33599,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33599, 45.43514]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13541786,
        name: "Appartamento GHETTO",
        host_id: 4684295,
        host_name: "Francesca",
        latitude: 45.44484,
        longitude: 12.3256,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3256, 45.44484]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13551446,
        name: "Certosa - Magica atmosfera nel cuore di Venezia",
        host_id: 74943278,
        host_name: "Marta",
        latitude: 45.43178,
        longitude: 12.35808,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35808, 45.43178]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13552264,
        name: "Bovolo Palace (300 mt from St. Mark's Square)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.4335,
        longitude: 12.33516,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33516, 45.4335]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13552961,
        name: "MyPlace Formosa Garden Apartment",
        host_id: 26102869,
        host_name: "My Sweetplace S.R.L.",
        latitude: 45.43673,
        longitude: 12.34176,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34176, 45.43673]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13554529,
        name: "Grand Canal Smeraldo - Terrace Amazing View",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.43943,
        longitude: 12.32305,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32305, 45.43943]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13557482,
        name: "Cozy and romantic flat in Calle del Megio",
        host_id: 44190215,
        host_name: "Nicolo'",
        latitude: 45.44211,
        longitude: 12.32812,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32812, 45.44211]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13559779,
        name: "COCAL - Biennale - free wifi",
        host_id: 1755413,
        host_name: "Davide",
        latitude: 45.42993,
        longitude: 12.35777,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35777, 45.42993]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13560872,
        name: "Lovely Room in Venetian palazzo",
        host_id: 52582054,
        host_name: "Anna",
        latitude: 45.43758,
        longitude: 12.32762,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32762, 45.43758]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13577192,
        name: "ELEGANT FLAT WITH CANAL VIEW NEAR SAN MARCO SQUARE",
        host_id: 78334812,
        host_name: "Stefano",
        latitude: 45.43483,
        longitude: 12.33288,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33288, 45.43483]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13581238,
        name: "AptTeatro: Ancient charm and design at St. Mark's",
        host_id: 28145404,
        host_name: "Marco & Monica",
        latitude: 45.43526,
        longitude: 12.33396,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33396, 45.43526]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13593769,
        name: "Wonderful Luxury Apartment",
        host_id: 78561029,
        host_name: "Cucchiarelli",
        latitude: 45.4431,
        longitude: 12.32562,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32562, 45.4431]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13622514,
        name: "BACIO DI SAN MARCO VENEZIA TI AMO",
        host_id: 78873399,
        host_name: "Florence",
        latitude: 45.43609,
        longitude: 12.34226,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34226, 45.43609]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13622693,
        name: "CASA NOCCIOLA VENEZIA TI AMO",
        host_id: 78873399,
        host_name: "Florence",
        latitude: 45.4367,
        longitude: 12.33976,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33976, 45.4367]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13627670,
        name: "Palazzina Tiepolo, Biennale",
        host_id: 22974469,
        host_name: "Fede",
        latitude: 45.43195,
        longitude: 12.35791,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35791, 45.43195]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13627782,
        name: "GONDOLA BIANCA - VENEZIA TI AMO",
        host_id: 78873399,
        host_name: "Florence",
        latitude: 45.44109,
        longitude: 12.32768,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32768, 45.44109]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13628041,
        name: "PALAZZETTO SAN POLO - VENEZIA TI AMO",
        host_id: 78873399,
        host_name: "Florence",
        latitude: 45.43701,
        longitude: 12.3294,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3294, 45.43701]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13628173,
        name: "GONDOLA VERDE - VENEZIA TI AMO",
        host_id: 78873399,
        host_name: "Florence",
        latitude: 45.43858,
        longitude: 12.32178,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32178, 45.43858]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13628442,
        name: "CASA PISTACCHIO - VENEZIA TI AMO",
        host_id: 78873399,
        host_name: "Florence",
        latitude: 45.43694,
        longitude: 12.338,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.338, 45.43694]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13630645,
        name: "Charming Venice family friendly apartment with sea views",
        host_id: 35279206,
        host_name: "LMV - Exclusive Venice Apartments",
        latitude: 45.4303,
        longitude: 12.32795,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32795, 45.4303]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13631746,
        name: "Great view on Canareggio",
        host_id: 73934712,
        host_name: "Tour Apartments",
        latitude: 45.44598,
        longitude: 12.32317,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32317, 45.44598]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13646800,
        name: "Rooftop terrace apartment at Molino Stucky, Venice",
        host_id: 54717035,
        host_name: "Olivia",
        latitude: 45.42724,
        longitude: 12.32013,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32013, 45.42724]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13648670,
        name: "Amazing sea view & terrace apartment",
        host_id: 35279206,
        host_name: "LMV - Exclusive Venice Apartments",
        latitude: 45.43021,
        longitude: 12.32712,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32712, 45.43021]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13648765,
        name: "Bellissimo Loft Ca' Drasi",
        host_id: 79240697,
        host_name: "Eleonora",
        latitude: 45.43793,
        longitude: 12.34828,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34828, 45.43793]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13650376,
        name: "Charming Apart San Marco with canal views AB",
        host_id: 35279206,
        host_name: "LMV - Exclusive Venice Apartments",
        latitude: 45.43415,
        longitude: 12.33568,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33568, 45.43415]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13651971,
        name: "Charming Apart San Marco with Canal views CD",
        host_id: 35279206,
        host_name: "LMV - Exclusive Venice Apartments",
        latitude: 45.43236,
        longitude: 12.33577,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33577, 45.43236]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13652177,
        name: "IN VENICE WITH LOVE",
        host_id: 79274662,
        host_name: "Francesca",
        latitude: 45.44687,
        longitude: 12.32893,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32893, 45.44687]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13666996,
        name: "VENICE LOFT IN FRONT THEATRE FENICE",
        host_id: 14114346,
        host_name: "Lost In",
        latitude: 45.43312,
        longitude: 12.33473,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33473, 45.43312]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13669027,
        name: "Apartment with a secret and romantic park",
        host_id: 60048146,
        host_name: "Ludovica",
        latitude: 45.44837,
        longitude: 12.32953,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32953, 45.44837]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13691215,
        name: "Ve.N.I.Ce Casa del Giglio",
        host_id: 37864680,
        host_name: "Ve.N.I.Ce Immobiliare Cera",
        latitude: 45.4325,
        longitude: 12.33154,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33154, 45.4325]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13691941,
        name: "Ve.N.I.Ce Cera Ca' Belle Arti",
        host_id: 37864680,
        host_name: "Ve.N.I.Ce Immobiliare Cera",
        latitude: 45.42858,
        longitude: 12.33201,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33201, 45.42858]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13713136,
        name: "RIALTO BRIDGE PENTHOUSE VENICE WITH TERRACES",
        host_id: 5862083,
        host_name: "Silvia",
        latitude: 45.43677,
        longitude: 12.33705,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33705, 45.43677]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13725509,
        name: "Apartment San Luca Dal Pozzo",
        host_id: 16117448,
        host_name: "Antonina",
        latitude: 45.43711,
        longitude: 12.33655,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33655, 45.43711]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13729998,
        name: "MAGICLAGOON BEAUTIFUL APARTMENT IN BIENNALE AREA",
        host_id: 80305638,
        host_name: "Anna",
        latitude: 45.4332,
        longitude: 12.35819,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35819, 45.4332]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13755982,
        name: "CA' DELLE VERGINI Castello 96 next to BIENNALE",
        host_id: 80489825,
        host_name: "Roberto",
        latitude: 45.43538,
        longitude: 12.35716,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35716, 45.43538]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13757863,
        name: "Apt. Guglie in Cannaregio",
        host_id: 39600986,
        host_name: "Christine",
        latitude: 45.4428,
        longitude: 12.32566,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32566, 45.4428]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13762085,
        name: "Altana studio",
        host_id: 3972291,
        host_name: "Caroline E Marco",
        latitude: 45.43307,
        longitude: 12.32411,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32411, 45.43307]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13767121,
        name: "Venice Appartament Salini",
        host_id: 73021997,
        host_name: "Alexandra - Giovanni",
        latitude: 45.43244,
        longitude: 12.35164,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35164, 45.43244]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13768541,
        name: "Casa dell'Arsenalotto",
        host_id: 80773536,
        host_name: "Ema",
        latitude: 45.43371,
        longitude: 12.34991,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34991, 45.43371]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13790079,
        name: "Ca Ruggero",
        host_id: 81031303,
        host_name: "Laura",
        latitude: 45.43593,
        longitude: 12.32212,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32212, 45.43593]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13796214,
        name: "Rialto Market I-COOL APT. VENICE",
        host_id: 4378516,
        host_name: "Cool",
        latitude: 45.43927,
        longitude: 12.33048,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33048, 45.43927]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13807728,
        name: "Camera Singola, Venezia, Santa Croce!",
        host_id: 73717210,
        host_name: "Maddalena",
        latitude: 45.44044,
        longitude: 12.32998,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32998, 45.44044]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13809334,
        name: "Just renewed in the heart of real Venice",
        host_id: 11000049,
        host_name: "Guia",
        latitude: 45.43998,
        longitude: 12.33608,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33608, 45.43998]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13811283,
        name: "6 people flat close to station",
        host_id: 13912696,
        host_name: "Jerome",
        latitude: 45.44277,
        longitude: 12.31979,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31979, 45.44277]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13812868,
        name: "casa dac",
        host_id: 28068235,
        host_name: "Dante",
        latitude: 45.43115,
        longitude: 12.32794,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32794, 45.43115]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13813188,
        name: "Apartment in Dorsoduo con meraviglioso giardino",
        host_id: 39600986,
        host_name: "Christine",
        latitude: 45.43188,
        longitude: 12.32582,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32582, 45.43188]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13816170,
        name: "Beautiful room in Venetian palazzo",
        host_id: 52582054,
        host_name: "Anna",
        latitude: 45.43777,
        longitude: 12.32781,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32781, 45.43777]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13817837,
        name: "Biennale - Arsenale - T.A.N.A. Apartment",
        host_id: 9639934,
        host_name: "Wildes",
        latitude: 45.43401,
        longitude: 12.35134,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35134, 45.43401]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13818173,
        name: "Fully equipped in Cannaregio",
        host_id: 11000049,
        host_name: "Guia",
        latitude: 45.4401,
        longitude: 12.33676,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33676, 45.4401]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13819569,
        name: "your Venetian dream",
        host_id: 76639474,
        host_name: "Francesco",
        latitude: 45.44104,
        longitude: 12.32783,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32783, 45.44104]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13824564,
        name: "Large elegant Room in Rialto",
        host_id: 48092742,
        host_name: "Roby",
        latitude: 45.43749,
        longitude: 12.33681,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33681, 45.43749]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13824694,
        name: "Very Cosy Studio In Authentic Area",
        host_id: 69546164,
        host_name: "Laura",
        latitude: 45.43825,
        longitude: 12.34572,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34572, 45.43825]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13827607,
        name: "Ca' Venusta",
        host_id: 81513057,
        host_name: "Beatrice",
        latitude: 45.44044,
        longitude: 12.33284,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33284, 45.44044]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13831712,
        name: "Dorsoduro Apartment",
        host_id: 4378516,
        host_name: "Cool",
        latitude: 45.43397,
        longitude: 12.32068,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32068, 45.43397]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13835339,
        name: "Apartment Tintoretto (near Biennale)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.43446,
        longitude: 12.34869,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34869, 45.43446]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13839066,
        name: "Ca' del liuto. Charming flat in Venice with view",
        host_id: 18638940,
        host_name: "Emiliano",
        latitude: 45.44338,
        longitude: 12.33457,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33457, 45.44338]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13849881,
        name: "San Polo III Apartment (Canal view)",
        host_id: 4378516,
        host_name: "Cool",
        latitude: 45.43883,
        longitude: 12.33125,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33125, 45.43883]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13852639,
        name: "Apt. Giovanni e Paolo (St Mark's Square: 600m)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.43953,
        longitude: 12.34239,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34239, 45.43953]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13854803,
        name: "Charming Palazzo Mocenigo in the heart of Venice",
        host_id: 76925373,
        host_name: "Virginia",
        latitude: 45.4342,
        longitude: 12.33053,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33053, 45.4342]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13863032,
        name: "Doge's House Sognare a Venezia",
        host_id: 10914869,
        host_name: "Ilia",
        latitude: 45.43714,
        longitude: 12.34116,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34116, 45.43714]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13890989,
        name: "Green Room Private external Bathroom & Garden View",
        host_id: 82270816,
        host_name: "Key Of Venice Guest House",
        latitude: 45.44483,
        longitude: 12.32947,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32947, 45.44483]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13903488,
        name: "Apartment Accademia - Historical Center",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.43082,
        longitude: 12.33146,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33146, 45.43082]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13904016,
        name: "Apartment Beccarie (200m from Rialto's Bridge)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.4391,
        longitude: 12.33431,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33431, 45.4391]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13907155,
        name: "LUXURY APARTMENT ON THE GRAND CANAL",
        host_id: 49329241,
        host_name: "Jacopo",
        latitude: 45.43533,
        longitude: 12.33296,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33296, 45.43533]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13909419,
        name: "CA' SANTA MARINA Large apartment near Rialto",
        host_id: 82492154,
        host_name: "Nicola",
        latitude: 45.4386,
        longitude: 12.34005,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34005, 45.4386]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13918747,
        name: "Amazing water view Loft",
        host_id: 82614309,
        host_name: "Paola",
        latitude: 45.42994,
        longitude: 12.33383,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33383, 45.42994]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13921982,
        name: "Smart flat Arsenale",
        host_id: 40849012,
        host_name: "Clara",
        latitude: 45.43405,
        longitude: 12.34981,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34981, 45.43405]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13929768,
        name: "Ca' Perla d'Acqua",
        host_id: 10528151,
        host_name: "Lorenza",
        latitude: 45.4359,
        longitude: 12.31407,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31407, 45.4359]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13945667,
        name: "Vignole - Magica atmosfera nel cuore di Venezia",
        host_id: 74943278,
        host_name: "Marta",
        latitude: 45.4319,
        longitude: 12.35667,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35667, 45.4319]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13946973,
        name: "Casa Genoveffa apartments",
        host_id: 83002480,
        host_name: "Ema",
        latitude: 45.42599,
        longitude: 12.32612,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32612, 45.42599]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13949126,
        name: "Ai Cordami",
        host_id: 83027158,
        host_name: "Gabriella",
        latitude: 45.42455,
        longitude: 12.32433,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32433, 45.42455]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13949186,
        name: "Miracoli",
        host_id: 12982157,
        host_name: "Locappart",
        latitude: 45.43951,
        longitude: 12.33845,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33845, 45.43951]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13949755,
        name: "CÀ DELL'ARTISTA",
        host_id: 70021012,
        host_name: "Stefano & Karla",
        latitude: 45.43164,
        longitude: 12.35385,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35385, 45.43164]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13951162,
        name: "SIMEONE II",
        host_id: 12982157,
        host_name: "Locappart",
        latitude: 45.44071,
        longitude: 12.32288,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32288, 45.44071]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13954375,
        name: "[ATTENTION]  Flat near St Mary of Health",
        host_id: 82705073,
        host_name: "Marco",
        latitude: 45.43023,
        longitude: 12.33099,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33099, 45.43023]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13964091,
        name: "SIMEONE I",
        host_id: 12982157,
        host_name: "Locappart",
        latitude: 45.43998,
        longitude: 12.32397,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32397, 45.43998]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13965158,
        name: "SIMEONE IV GRANDE",
        host_id: 12982157,
        host_name: "Locappart",
        latitude: 45.43978,
        longitude: 12.3229,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3229, 45.43978]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13965699,
        name: "Ca' d'oro",
        host_id: 12982157,
        host_name: "Locappart",
        latitude: 45.44088,
        longitude: 12.3357,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3357, 45.44088]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13965964,
        name: "La Mansarda",
        host_id: 83243176,
        host_name: "Marco",
        latitude: 45.44492,
        longitude: 12.32396,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32396, 45.44492]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13966111,
        name: "Residenza San Rocco",
        host_id: 5618111,
        host_name: "EasySuite",
        latitude: 45.43754,
        longitude: 12.32685,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32685, 45.43754]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13966332,
        name: "Superb apartment, Rialto",
        host_id: 69935272,
        host_name: "Ambra",
        latitude: 45.44082,
        longitude: 12.32871,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32871, 45.44082]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13968355,
        name: "Apt. Gold Design (300m from Rialto's Bridge)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.44071,
        longitude: 12.33602,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33602, 45.44071]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13972086,
        name: "Chic Venice",
        host_id: 83308729,
        host_name: "Chic",
        latitude: 45.43026,
        longitude: 12.3555,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3555, 45.43026]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13983314,
        name: "Apt. Guggenheim (with Private Courtyard)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.43011,
        longitude: 12.33366,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33366, 45.43011]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13983420,
        name: "Campiello Gorne",
        host_id: 46904188,
        host_name: "Mirco Optyflat",
        latitude: 45.4365,
        longitude: 12.34945,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34945, 45.4365]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13983993,
        name: "Apartment Ormesini: CityApartments Venice",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.44568,
        longitude: 12.32923,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32923, 45.44568]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13986872,
        name: "Real Venice",
        host_id: 53122974,
        host_name: "Stefania",
        latitude: 45.42574,
        longitude: 12.32367,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32367, 45.42574]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13987739,
        name: "Suite Canova a Dorsoduro  - un nido d'amore",
        host_id: 39600986,
        host_name: "Christine",
        latitude: 45.43017,
        longitude: 12.33049,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33049, 45.43017]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13988827,
        name: "WENDY LUXURY APARTMENT",
        host_id: 83501143,
        host_name: "Larisa",
        latitude: 45.43958,
        longitude: 12.33857,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33857, 45.43958]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13995230,
        name: "Canal great view Tolentini apartment",
        host_id: 83581489,
        host_name: "Luigi E Antonello",
        latitude: 45.43886,
        longitude: 12.32171,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32171, 45.43886]] },
    },
    {
      type: "Feature",
      properties: {
        id: 13995957,
        name: "la Tana dall'Orio",
        host_id: 83571460,
        host_name: "Catherine",
        latitude: 45.44178,
        longitude: 12.32898,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32898, 45.44178]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14000486,
        name: 'Apartment "alle Sei Sorelle", Venice',
        host_id: 83651586,
        host_name: "Emma",
        latitude: 45.44252,
        longitude: 12.33208,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33208, 45.44252]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14002063,
        name: "CHARMING IN THE REAL  VENICE",
        host_id: 83666977,
        host_name: "Catharine Francesca",
        latitude: 45.4454,
        longitude: 12.32768,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32768, 45.4454]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14002485,
        name: "Apt. San Marco Bis (300 m. from St. Mark's Square)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.43515,
        longitude: 12.34077,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34077, 45.43515]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14003869,
        name: "Apt. S. Marco Tris (300 m. from St. Mark's Square)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.43431,
        longitude: 12.34284,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34284, 45.43431]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14012712,
        name: "San Polo II-COOL APARTMENTS VENICE",
        host_id: 4378516,
        host_name: "Cool",
        latitude: 45.43646,
        longitude: 12.33068,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33068, 45.43646]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14018411,
        name: "Apartment San Stae Venetian Style",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.44183,
        longitude: 12.3276,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3276, 45.44183]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14018844,
        name: "Modern Venetian Apartment near S.Mark's Square",
        host_id: 193059,
        host_name: "Oliva Nera",
        latitude: 45.43677,
        longitude: 12.34556,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34556, 45.43677]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14021536,
        name: "Apartment Margherita (Historic Center)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.43405,
        longitude: 12.32417,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32417, 45.43405]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14024204,
        name: "Ca 'dei Quadri\" is a typical Venetian apartment.",
        host_id: 83925296,
        host_name: "Alessandra",
        latitude: 45.44131,
        longitude: 12.33688,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33688, 45.44131]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14035254,
        name: "La Casa del Pittore-Biennale Arsenale",
        host_id: 84061549,
        host_name: "Annabella",
        latitude: 45.43532,
        longitude: 12.35613,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35613, 45.43532]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14048952,
        name: "WellVenice Rialto",
        host_id: 41898872,
        host_name: "Cristina",
        latitude: 45.43632,
        longitude: 12.33478,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33478, 45.43632]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14053692,
        name: "Nel cuore di Rialto",
        host_id: 84299232,
        host_name: "Nuccio",
        latitude: 45.43946,
        longitude: 12.33355,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33355, 45.43946]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14069516,
        name: "Enchanting Venice",
        host_id: 84497370,
        host_name: "Francesca",
        latitude: 45.43516,
        longitude: 12.33057,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33057, 45.43516]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14082779,
        name: "Residenza Canal (L.T. M (Phone number hidden by Airbnb)",
        host_id: 5618111,
        host_name: "EasySuite",
        latitude: 45.43166,
        longitude: 12.3208,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3208, 45.43166]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14083538,
        name: "Three Terraces",
        host_id: 3972291,
        host_name: "Caroline E Marco",
        latitude: 45.44034,
        longitude: 12.32732,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32732, 45.44034]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14084192,
        name: "DEPANDANCE PRIULI SANDRIN: FREE WIFI & NEAR RIALTO",
        host_id: 3736168,
        host_name: "EasyRentals",
        latitude: 45.44134,
        longitude: 12.33504,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33504, 45.44134]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14088746,
        name: "Typical Venitian Home",
        host_id: 80901224,
        host_name: "Luigi",
        latitude: 45.44251,
        longitude: 12.33087,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33087, 45.44251]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14090679,
        name: "Cosy room in Venetian apartment with terrace",
        host_id: 5332703,
        host_name: "Giovanna",
        latitude: 45.43904,
        longitude: 12.33829,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33829, 45.43904]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14098636,
        name: "Deluxe Loft with terrace",
        host_id: 84525573,
        host_name: "Atlantic Do Archi Deluxe",
        latitude: 45.43379,
        longitude: 12.3534,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3534, 45.43379]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14098799,
        name: "Apartament with private court",
        host_id: 84525573,
        host_name: "Atlantic Do Archi Deluxe",
        latitude: 45.43343,
        longitude: 12.35414,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35414, 45.43343]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14098889,
        name: "Deluxe Loft up to four",
        host_id: 84525573,
        host_name: "Atlantic Do Archi Deluxe",
        latitude: 45.43338,
        longitude: 12.35409,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35409, 45.43338]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14098981,
        name: "Deluxe Studio",
        host_id: 84525573,
        host_name: "Atlantic Do Archi Deluxe",
        latitude: 45.43329,
        longitude: 12.35237,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35237, 45.43329]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14099102,
        name: "Superior Studio",
        host_id: 84525573,
        host_name: "Atlantic Do Archi Deluxe",
        latitude: 45.43255,
        longitude: 12.35491,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35491, 45.43255]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14099307,
        name: "Apartment Calle Pedrocchi I",
        host_id: 84525573,
        host_name: "Atlantic Do Archi Deluxe",
        latitude: 45.43278,
        longitude: 12.3526,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3526, 45.43278]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14099489,
        name: "Apartament Calle Pedrocchi II",
        host_id: 84525573,
        host_name: "Atlantic Do Archi Deluxe",
        latitude: 45.43123,
        longitude: 12.35287,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35287, 45.43123]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14126465,
        name: "LIO PICCOLO St Mark- Biennale",
        host_id: 12891675,
        host_name: "Mauro",
        latitude: 45.43595,
        longitude: 12.348,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.348, 45.43595]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14129491,
        name: "Appartamento in palazzo storico a Cannaregio",
        host_id: 85235953,
        host_name: "Silvana",
        latitude: 45.44547,
        longitude: 12.33205,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33205, 45.44547]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14129639,
        name: "Large Apartment Ca' Colonne",
        host_id: 84847283,
        host_name: "Atlantic Do Archi Family&Group",
        latitude: 45.43194,
        longitude: 12.35457,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35457, 45.43194]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14129708,
        name: "House with terrace Ca' Serena",
        host_id: 84847283,
        host_name: "Atlantic Do Archi Family&Group",
        latitude: 45.43274,
        longitude: 12.35301,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35301, 45.43274]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14129831,
        name: "Studio Serena",
        host_id: 84847283,
        host_name: "Atlantic Do Archi Family&Group",
        latitude: 45.43093,
        longitude: 12.35356,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35356, 45.43093]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14129905,
        name: "Studio Ca' Archi",
        host_id: 84847283,
        host_name: "Atlantic Do Archi Family&Group",
        latitude: 45.43101,
        longitude: 12.35466,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35466, 45.43101]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14130063,
        name: "Elegant apartment up to four",
        host_id: 84847283,
        host_name: "Atlantic Do Archi Family&Group",
        latitude: 45.43238,
        longitude: 12.35411,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35411, 45.43238]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14130174,
        name: "Elegant Apartment up to six",
        host_id: 84847283,
        host_name: "Atlantic Do Archi Family&Group",
        latitude: 45.43213,
        longitude: 12.35394,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35394, 45.43213]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14130271,
        name: "Elegant apartment up to eight",
        host_id: 84847283,
        host_name: "Atlantic Do Archi Family&Group",
        latitude: 45.4308,
        longitude: 12.35441,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35441, 45.4308]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14130789,
        name: "Executive Apartment with terrace",
        host_id: 84844577,
        host_name: "Atlantic Do Archi Biennale",
        latitude: 45.4318,
        longitude: 12.35644,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35644, 45.4318]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14130891,
        name: "Executive Studio",
        host_id: 84844577,
        host_name: "Atlantic Do Archi Biennale",
        latitude: 45.4303,
        longitude: 12.35721,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35721, 45.4303]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14130981,
        name: "Ground floor apartment with one bedroom",
        host_id: 84844577,
        host_name: "Atlantic Do Archi Biennale",
        latitude: 45.4321,
        longitude: 12.35651,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35651, 45.4321]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14132224,
        name: "Arlecchino Apartment near the Miracoli Church.",
        host_id: 11388964,
        host_name: "Chiara",
        latitude: 45.43974,
        longitude: 12.33826,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33826, 45.43974]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14133260,
        name: "Charming&Chic Room Ensuite Bathroom&Garden View",
        host_id: 82270816,
        host_name: "Key Of Venice Guest House",
        latitude: 45.44655,
        longitude: 12.32812,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32812, 45.44655]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14133464,
        name: "SUPERIOR GOLD Room with Ensuite Bathroom",
        host_id: 82270816,
        host_name: "Key Of Venice Guest House",
        latitude: 45.44532,
        longitude: 12.32508,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32508, 45.44532]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14135084,
        name: "Charming quiet budget apartment close to Biennale",
        host_id: 4654704,
        host_name: "Nicola",
        latitude: 45.43764,
        longitude: 12.34814,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34814, 45.43764]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14144707,
        name: "SAN MARCO LOVELY APARTMENT",
        host_id: 85418052,
        host_name: "Victoria",
        latitude: 45.43447,
        longitude: 12.3362,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3362, 45.43447]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14150140,
        name: "Ca' Dei Bari",
        host_id: 85486291,
        host_name: "Harisc",
        latitude: 45.44133,
        longitude: 12.32432,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32432, 45.44133]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14150396,
        name: "My accommodation",
        host_id: 83002480,
        host_name: "Ema",
        latitude: 45.42671,
        longitude: 12.32462,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32462, 45.42671]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14160502,
        name: "La Corte Dei Baloni, in the heart of Venice.",
        host_id: 85631647,
        host_name: "Vittoria E Filippo",
        latitude: 45.4361,
        longitude: 12.33791,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33791, 45.4361]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14162686,
        name: "RIALTO MARKET NEW 5pax 3bed 2bath Wifi PowerAircnd",
        host_id: 17534457,
        host_name: "Abaca",
        latitude: 45.44099,
        longitude: 12.33172,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33172, 45.44099]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14170793,
        name: "Apartment with private patio / central",
        host_id: 5395291,
        host_name: "Beatrice",
        latitude: 45.44722,
        longitude: 12.32778,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32778, 45.44722]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14172463,
        name: "SANTUZZA with a small balcony to the lagoon",
        host_id: 13019431,
        host_name: "Helga Anna",
        latitude: 45.4389,
        longitude: 12.34463,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34463, 45.4389]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14174314,
        name: "Crea Home - Lovely house in Venice",
        host_id: 85820907,
        host_name: "Giovanni",
        latitude: 45.42986,
        longitude: 12.33246,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33246, 45.42986]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14174697,
        name: "Ross 58 House",
        host_id: 64519769,
        host_name: "Roberto",
        latitude: 45.43579,
        longitude: 12.34074,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34074, 45.43579]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14176565,
        name: "LAGUNA - smart and comfortable",
        host_id: 13019431,
        host_name: "Helga Anna",
        latitude: 45.44203,
        longitude: 12.34047,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34047, 45.44203]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14176750,
        name: "Ca' Canali Garden Giudecca island",
        host_id: 53699315,
        host_name: "Marinella E Stefano",
        latitude: 45.4249,
        longitude: 12.32393,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32393, 45.4249]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14181850,
        name: '"CASA NERINA" Apartment',
        host_id: 1863344,
        host_name: "Tobia",
        latitude: 45.4342,
        longitude: 12.33485,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33485, 45.4342]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14194286,
        name: "ORMESINI - terrace and lovely view",
        host_id: 13019431,
        host_name: "Helga Anna",
        latitude: 45.4465,
        longitude: 12.32904,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32904, 45.4465]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14200666,
        name: "Luxury room with panoramic terrce in Venice - WiFi",
        host_id: 13657045,
        host_name: "Chiara",
        latitude: 45.44104,
        longitude: 12.32982,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32982, 45.44104]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14205371,
        name: "Romeo's apartment, the very center of Venice",
        host_id: 85919731,
        host_name: "Daniele",
        latitude: 45.43606,
        longitude: 12.34067,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34067, 45.43606]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14206150,
        name: "Magic terrace with view of Venice.",
        host_id: 86226695,
        host_name: "Marcello",
        latitude: 45.42601,
        longitude: 12.3258,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3258, 45.42601]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14208001,
        name: "RIALTO SUITE: free wifi",
        host_id: 3736168,
        host_name: "EasyRentals",
        latitude: 45.44374,
        longitude: 12.33427,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33427, 45.44374]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14209739,
        name: "The Venice dream. Room in a historic palace - WiFi",
        host_id: 13657045,
        host_name: "Chiara",
        latitude: 45.43957,
        longitude: 12.32875,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32875, 45.43957]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14215352,
        name: "Ca Leone 3085, the art district in Venice's heart",
        host_id: 20878881,
        host_name: "Massimo",
        latitude: 45.43412,
        longitude: 12.32916,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32916, 45.43412]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14216510,
        name: "Loft in the Heart of Venice - Perfect for Biennale",
        host_id: 4633589,
        host_name: "Giovanna",
        latitude: 45.43174,
        longitude: 12.35242,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35242, 45.43174]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14219175,
        name: "Room w/ private bathroom-Venice historical centre",
        host_id: 1617572,
        host_name: "Silvia",
        latitude: 45.43408,
        longitude: 12.35396,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35396, 45.43408]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14225005,
        name: "Awesome Venice dream - WiFi and terrace 130sm",
        host_id: 13657045,
        host_name: "Chiara",
        latitude: 45.44163,
        longitude: 12.33015,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33015, 45.44163]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14229890,
        name: "1 Minute of San Marco Square: Terrace, WiFi, A / C",
        host_id: 17762135,
        host_name: "Edoardo",
        latitude: 45.43456,
        longitude: 12.33651,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33651, 45.43456]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14245091,
        name: "San Leonardo Mini Apartment",
        host_id: 53454287,
        host_name: "Vale",
        latitude: 45.44364,
        longitude: 12.32773,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32773, 45.44364]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14245145,
        name: "Venice Amazing View (St. Mark's Square 700m)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.43685,
        longitude: 12.34422,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34422, 45.43685]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14245727,
        name: "Stunning Modern Apartment in the Ghetto",
        host_id: 86687688,
        host_name: "Gabriele",
        latitude: 45.44374,
        longitude: 12.32689,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32689, 45.44374]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14249259,
        name: "A typical XVI century venetian house.",
        host_id: 86726132,
        host_name: "Lorenzo",
        latitude: 45.4326,
        longitude: 12.32681,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32681, 45.4326]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14256716,
        name: "Cannaregio Particular Basic Room",
        host_id: 13027859,
        host_name: "Diego",
        latitude: 45.44318,
        longitude: 12.32837,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32837, 45.44318]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14260984,
        name: "Ca' del Vescovo",
        host_id: 86871989,
        host_name: "Francesca",
        latitude: 45.4437,
        longitude: 12.32859,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32859, 45.4437]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14265413,
        name: "Corte Modigliani SUITE con bagno",
        host_id: 86726132,
        host_name: "Lorenzo",
        latitude: 45.43303,
        longitude: 12.32691,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32691, 45.43303]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14265872,
        name: "Attic of 16th century at the Accademia!",
        host_id: 86726132,
        host_name: "Lorenzo",
        latitude: 45.43223,
        longitude: 12.3265,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3265, 45.43223]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14266067,
        name: "SOLE double bedroom with shared bathroom",
        host_id: 86726132,
        host_name: "Lorenzo",
        latitude: 45.43304,
        longitude: 12.32509,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32509, 45.43304]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14266475,
        name: "Luxory in Venice near Rialto",
        host_id: 63194257,
        host_name: "Edoardo",
        latitude: 45.44124,
        longitude: 12.33885,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33885, 45.44124]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14270162,
        name: "Santa Marina 5896 - Venezia Centro Storico",
        host_id: 36767238,
        host_name: "Guido",
        latitude: 45.43806,
        longitude: 12.33802,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33802, 45.43806]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14271344,
        name: "Quarto do Julio - for families - double or twin",
        host_id: 61382489,
        host_name: "Giulio",
        latitude: 45.43286,
        longitude: 12.3138,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3138, 45.43286]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14274915,
        name: "Female domitory in Venice 3",
        host_id: 27990266,
        host_name: "Ai",
        latitude: 45.43647,
        longitude: 12.34082,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34082, 45.43647]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14285734,
        name: "BEAUTY ARTIST FLAT NEAR BIENNALE",
        host_id: 63375420,
        host_name: "Marie",
        latitude: 45.43332,
        longitude: 12.35466,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35466, 45.43332]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14291099,
        name: "Quarto do Filipe - Double bedroom close to St Mark",
        host_id: 61382489,
        host_name: "Giulio",
        latitude: 45.43802,
        longitude: 12.34686,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34686, 45.43802]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14307244,
        name: "CA' PINELLI",
        host_id: 87431454,
        host_name: "Giuliano",
        latitude: 45.43727,
        longitude: 12.34242,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34242, 45.43727]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14309119,
        name: "Apartment Rubino (150m from St. Mark's Square)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.43353,
        longitude: 12.33699,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33699, 45.43353]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14309953,
        name: "Ca' Farnese, beautiful big apartment in trad. area",
        host_id: 6019189,
        host_name: "Federico",
        latitude: 45.44525,
        longitude: 12.32784,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32784, 45.44525]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14329710,
        name: "Apt. Ca' Capitello (250 m from St. Mark's Square)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.43629,
        longitude: 12.33616,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33616, 45.43629]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14332332,
        name: "Stylish 100 meter from San Marco square, sleeps 7",
        host_id: 12113015,
        host_name: "Mario",
        latitude: 45.43549,
        longitude: 12.33665,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33665, 45.43549]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14342515,
        name: "Casa Morosini Tintoretto",
        host_id: 46466051,
        host_name: "Alberto",
        latitude: 45.44129,
        longitude: 12.3285,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3285, 45.44129]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14364131,
        name: "Sant'Angelo for 2",
        host_id: 84497370,
        host_name: "Francesca",
        latitude: 45.43377,
        longitude: 12.33128,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33128, 45.43377]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14366208,
        name: "Leon 1014",
        host_id: 87679056,
        host_name: "Giorgio",
        latitude: 45.43476,
        longitude: 12.33718,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33718, 45.43476]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14374829,
        name: "Venice center, triple room",
        host_id: 87463319,
        host_name: "Tommaso",
        latitude: 45.43371,
        longitude: 12.31782,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31782, 45.43371]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14374864,
        name: "Venice center, double room",
        host_id: 87463319,
        host_name: "Tommaso",
        latitude: 45.43395,
        longitude: 12.31897,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31897, 45.43395]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14375002,
        name: "New apartment Venice Cannaregio San Marcuola",
        host_id: 88168743,
        host_name: "Mario",
        latitude: 45.4423,
        longitude: 12.33179,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33179, 45.4423]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14378683,
        name: "Elegant double bedroom with shared bathroom 1",
        host_id: 86726132,
        host_name: "Lorenzo",
        latitude: 45.43264,
        longitude: 12.32562,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32562, 45.43264]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14380714,
        name: "Ca' Alba",
        host_id: 3972291,
        host_name: "Caroline E Marco",
        latitude: 45.43579,
        longitude: 12.34174,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34174, 45.43579]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14382154,
        name: "San Martino wi-fi in San Marco",
        host_id: 15112827,
        host_name: "Marco",
        latitude: 45.43563,
        longitude: 12.33736,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33736, 45.43563]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14386514,
        name: "Venice and its people",
        host_id: 32521428,
        host_name: "Lara",
        latitude: 45.43359,
        longitude: 12.3248,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3248, 45.43359]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14396276,
        name: "Ca' Forcola welcomes you!",
        host_id: 88476584,
        host_name: "Daria & Damiano",
        latitude: 45.43353,
        longitude: 12.318,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.318, 45.43353]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14409790,
        name: "Apt. Ca' Sturion (130 mt.from Rialto's Bridge)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.43772,
        longitude: 12.33308,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33308, 45.43772]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14411510,
        name: "SOFIA - big terrace with lovely view over Venice",
        host_id: 13019431,
        host_name: "Helga Anna",
        latitude: 45.43593,
        longitude: 12.34515,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34515, 45.43593]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14415097,
        name: "COLOMBINA - fantastic view on the lagoon",
        host_id: 13019431,
        host_name: "Helga Anna",
        latitude: 45.44216,
        longitude: 12.33974,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33974, 45.44216]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14438507,
        name: "Apt. Paganini Terrace (300m form Rialto's Bridge)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.43723,
        longitude: 12.33826,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33826, 45.43723]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14440594,
        name: "THE REAL VENICE",
        host_id: 87178841,
        host_name: "Carlo",
        latitude: 45.44414,
        longitude: 12.33185,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33185, 45.44414]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14442418,
        name: "威尼斯迷人湖景公寓套房",
        host_id: 21885006,
        host_name: "Lisa",
        latitude: 45.44643,
        longitude: 12.31908,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31908, 45.44643]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14446733,
        name: "Confortevole appartamento in incantevole posizione",
        host_id: 88958488,
        host_name: "Ernesto",
        latitude: 45.44655,
        longitude: 12.3204,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3204, 45.44655]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14457785,
        name: "Apartment Moro 6 (80mt. from Rialto's Bridge)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.43682,
        longitude: 12.33592,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33592, 45.43682]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14458673,
        name: "San Canzian Apartment",
        host_id: 46904188,
        host_name: "Mirco Optyflat",
        latitude: 45.43944,
        longitude: 12.33697,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33697, 45.43944]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14459574,
        name: "Al Redentore",
        host_id: 46904188,
        host_name: "Mirco Optyflat",
        latitude: 45.42505,
        longitude: 12.33079,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33079, 45.42505]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14462182,
        name: "Ca' Remer Grand Canal",
        host_id: 669047,
        host_name: "Viewsonvenice",
        latitude: 45.43615,
        longitude: 12.33325,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33325, 45.43615]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14469647,
        name: "Apartamento Zanoni asciugatrice, wifi",
        host_id: 1426634,
        host_name: "Claudia E Giorgio",
        latitude: 45.44045,
        longitude: 12.33535,
        beds: 7,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33535, 45.44045]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14485117,
        name: "ANIMA & CORPO, ca' Tintoretto b&b",
        host_id: 89357007,
        host_name: "Laura",
        latitude: 45.44694,
        longitude: 12.33102,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33102, 45.44694]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14495580,
        name: "Apartment in Venice central area with Terrace",
        host_id: 63752942,
        host_name: "Francesco",
        latitude: 45.43456,
        longitude: 12.3348,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3348, 45.43456]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14498324,
        name: "Cosy Apartment in Adorable Dorsoduro!",
        host_id: 89512390,
        host_name: "G&T",
        latitude: 45.42999,
        longitude: 12.32913,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32913, 45.42999]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14500334,
        name: "Colombina Miracoli Apartment.",
        host_id: 11388964,
        host_name: "Chiara",
        latitude: 45.43692,
        longitude: 12.34527,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34527, 45.43692]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14500851,
        name: "Pantalone Miracoli Apartment.",
        host_id: 11388964,
        host_name: "Chiara",
        latitude: 45.43934,
        longitude: 12.33959,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33959, 45.43934]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14509329,
        name: "Comfy Apartment in Adorable Dorsoduro!",
        host_id: 89512390,
        host_name: "G&T",
        latitude: 45.43009,
        longitude: 12.32715,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32715, 45.43009]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14509523,
        name: "Beautiful home from home in Adorable Dorsoduro!",
        host_id: 89512390,
        host_name: "G&T",
        latitude: 45.42973,
        longitude: 12.32877,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32877, 45.42973]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14520523,
        name: "Ai Giardini de Casteo Biennale singola  Azzurra",
        host_id: 89722282,
        host_name: "Frank",
        latitude: 45.43223,
        longitude: 12.35745,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35745, 45.43223]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14567237,
        name: "Ft. Moro APT Family Deluxe",
        host_id: 26102869,
        host_name: "My Sweetplace S.R.L.",
        latitude: 45.44354,
        longitude: 12.33134,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33134, 45.44354]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14570862,
        name: "Cà dei Greci",
        host_id: 17662713,
        host_name: "Attombri",
        latitude: 45.43477,
        longitude: 12.344,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.344, 45.43477]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14581657,
        name: "ARTE 2 near RIALTO bridge",
        host_id: 60488055,
        host_name: "Marco & Andrea",
        latitude: 45.44171,
        longitude: 12.33676,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33676, 45.44171]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14604853,
        name:
          "Ampio e prezioso appartamento, per vivere un sogno nel cuore di Venezia",
        host_id: 51054790,
        host_name: "Anna",
        latitude: 45.4325,
        longitude: 12.336,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.336, 45.4325]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14617664,
        name: "SAINT MARK & BIENNALE cosy apt FIBER INTERNET A/C",
        host_id: 8720651,
        host_name: "Francesca",
        latitude: 45.43566,
        longitude: 12.34669,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34669, 45.43566]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14621499,
        name: "Selvatico's Palace",
        host_id: 90757404,
        host_name: "Francesca",
        latitude: 45.43626,
        longitude: 12.3374,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3374, 45.43626]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14621872,
        name: "BALCONY AND SEA VIEW",
        host_id: 49930101,
        host_name: "Elena",
        latitude: 45.43427,
        longitude: 12.34568,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34568, 45.43427]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14623672,
        name: "Green Fiabe Central Room in San Marco",
        host_id: 48092742,
        host_name: "Roby",
        latitude: 45.43693,
        longitude: 12.34289,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34289, 45.43693]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14645223,
        name: "Ca'del Mariner, a Cozy Venetian Retreat with Rooftop Terrace",
        host_id: 90921064,
        host_name: "Paolo",
        latitude: 45.44047,
        longitude: 12.32967,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32967, 45.44047]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14663868,
        name: "Flower Colour painting Room 1 San Marcuola-Casinó",
        host_id: 48092742,
        host_name: "Roby",
        latitude: 45.44286,
        longitude: 12.32773,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32773, 45.44286]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14663956,
        name: "Ca' dea Grana-apt in center city-S.Marco (WiFi)",
        host_id: 4338442,
        host_name: "Marina E Federico",
        latitude: 45.43598,
        longitude: 12.3478,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3478, 45.43598]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14670475,
        name: "Flat for holidays in Venice -City Center, S. Marta",
        host_id: 74767724,
        host_name: "Enrico",
        latitude: 45.43402,
        longitude: 12.31249,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31249, 45.43402]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14679084,
        name: "Romantico Cannaregio",
        host_id: 22940319,
        host_name: "Albatroservices",
        latitude: 45.44367,
        longitude: 12.32564,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32564, 45.44367]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14680012,
        name: "Venezia alla finestra",
        host_id: 91261907,
        host_name: "Camilla",
        latitude: 45.44475,
        longitude: 12.32887,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32887, 45.44475]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14684496,
        name: "Luxury one bedroom apartment with roof terrace",
        host_id: 70901050,
        host_name: "Helen & Jamie",
        latitude: 45.43215,
        longitude: 12.31795,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31795, 45.43215]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14702247,
        name: "Cannaregio Apartment",
        host_id: 91427169,
        host_name: "Lorenzo",
        latitude: 45.44659,
        longitude: 12.32976,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32976, 45.44659]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14720712,
        name: "APARTMENT AT THE COURT",
        host_id: 91623419,
        host_name: "Cinzia",
        latitude: 45.4247,
        longitude: 12.32194,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32194, 45.4247]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14720970,
        name: "Bellissima vista su San Rocco-Frari",
        host_id: 91625921,
        host_name: "Sebastiano",
        latitude: 45.43564,
        longitude: 12.32699,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32699, 45.43564]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14735203,
        name: "Cannaregio Leonardo Suite",
        host_id: 91777612,
        host_name: "Leonardo",
        latitude: 45.44472,
        longitude: 12.32249,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32249, 45.44472]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14737084,
        name:
          "Stylish apartment with jacuzzi ID M (Phone number hidden by Airbnb)",
        host_id: 2227088,
        host_name: "Gabriele",
        latitude: 45.43236,
        longitude: 12.33032,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33032, 45.43236]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14751241,
        name: "Double room in a 15th Century palace",
        host_id: 91945371,
        host_name: "Davide",
        latitude: 45.43966,
        longitude: 12.34373,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34373, 45.43966]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14751471,
        name: "Cannaregio Adriana Suite",
        host_id: 91777612,
        host_name: "Leonardo",
        latitude: 45.44448,
        longitude: 12.32245,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32245, 45.44448]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14751663,
        name: "Stanza privata in calle dei Muti, Venezia",
        host_id: 89292797,
        host_name: "David",
        latitude: 45.44603,
        longitude: 12.33308,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33308, 45.44603]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14753310,
        name: "Ca' Malvasia: little apartment closeby Marco sq.",
        host_id: 91653283,
        host_name: "Casamalvasia",
        latitude: 45.43587,
        longitude: 12.33984,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33984, 45.43587]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14755941,
        name: "Ca' della Musica",
        host_id: 91991298,
        host_name: "Sabina",
        latitude: 45.44007,
        longitude: 12.32311,
        beds: 7,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32311, 45.44007]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14756842,
        name: "Where else in Venice?  Cozy home away from home.",
        host_id: 4877513,
        host_name: "Antonio",
        latitude: 45.44337,
        longitude: 12.3288,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3288, 45.44337]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14759891,
        name: "Very Central with view of Theater la Fenice",
        host_id: 16267348,
        host_name: "Elisabetta",
        latitude: 45.43383,
        longitude: 12.32846,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32846, 45.43383]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14768091,
        name: "BIENNALE & S MARK New studio A/C lugg dep.",
        host_id: 92120331,
        host_name: "Snh",
        latitude: 45.43442,
        longitude: 12.34404,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34404, 45.43442]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14771377,
        name: "Fantastic appartament behind San Marci square",
        host_id: 83581489,
        host_name: "Luigi E Antonello",
        latitude: 45.43445,
        longitude: 12.3392,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3392, 45.43445]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14772671,
        name: "Imperial San Marco Suite Ground Floor",
        host_id: 22940319,
        host_name: "Albatroservices",
        latitude: 45.4391,
        longitude: 12.34653,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34653, 45.4391]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14778768,
        name: "Quintuple room in a 15th Century palace",
        host_id: 91945371,
        host_name: "Davide",
        latitude: 45.43803,
        longitude: 12.34464,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34464, 45.43803]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14788035,
        name: "Elegante Appartamento ai Carmini",
        host_id: 43005607,
        host_name: "Lara",
        latitude: 45.43243,
        longitude: 12.32083,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32083, 45.43243]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14792983,
        name: "Quadruple room  in a15th Century palace",
        host_id: 91945371,
        host_name: "Davide",
        latitude: 45.43805,
        longitude: 12.34467,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34467, 45.43805]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14793337,
        name: "Triple Economy in a 15th Century palace",
        host_id: 91945371,
        host_name: "Davide",
        latitude: 45.4388,
        longitude: 12.34507,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34507, 45.4388]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14804594,
        name: "Venezia ,casa indipendente",
        host_id: 83002480,
        host_name: "Ema",
        latitude: 45.44478,
        longitude: 12.3293,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3293, 45.44478]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14805912,
        name: 'Room with "view on the roofs"',
        host_id: 92509248,
        host_name: "Clara",
        latitude: 45.43304,
        longitude: 12.32925,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32925, 45.43304]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14815325,
        name: "Casa del Gondoliere large and bright view on roofs",
        host_id: 20892773,
        host_name: "Alessandra",
        latitude: 45.44734,
        longitude: 12.32678,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32678, 45.44734]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14817433,
        name: "J A KING STUDIO",
        host_id: 92620149,
        host_name: "Samy",
        latitude: 45.43356,
        longitude: 12.32896,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32896, 45.43356]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14824536,
        name: "Al Pozzo",
        host_id: 74550397,
        host_name: "Otti",
        latitude: 45.43594,
        longitude: 12.32448,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32448, 45.43594]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14834974,
        name: "San Marco studio First Floor",
        host_id: 22940319,
        host_name: "Albatroservices",
        latitude: 45.43517,
        longitude: 12.34135,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34135, 45.43517]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14835012,
        name: "Cosy single room in Giudecca - Venezia",
        host_id: 54731034,
        host_name: "Lucio",
        latitude: 45.42584,
        longitude: 12.33654,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33654, 45.42584]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14846353,
        name: "casa a San Marco",
        host_id: 92923071,
        host_name: "Elisabetta",
        latitude: 45.43204,
        longitude: 12.33187,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33187, 45.43204]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14847393,
        name: "ROMANTIC HOUSE VENICE",
        host_id: 12027987,
        host_name: "Michela & Stefano",
        latitude: 45.44323,
        longitude: 12.33596,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33596, 45.44323]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14849652,
        name: "3 bedroom Accademia apartment with canal view",
        host_id: 27081641,
        host_name: "Irene",
        latitude: 45.43019,
        longitude: 12.33091,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33091, 45.43019]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14850440,
        name: 'APARTMENT PIAZZA SAN MARCO "TIEPOLO"',
        host_id: 51054790,
        host_name: "Anna",
        latitude: 45.43433,
        longitude: 12.33606,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33606, 45.43433]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14854126,
        name: "Appartamento Venezia 3",
        host_id: 92996129,
        host_name: "Paola",
        latitude: 45.43656,
        longitude: 12.34159,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34159, 45.43656]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14854150,
        name: "Biennale Art Studio First Floor",
        host_id: 22940319,
        host_name: "Albatroservices",
        latitude: 45.43142,
        longitude: 12.35519,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35519, 45.43142]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14881199,
        name: "Quadruple Room with Private Bathroom",
        host_id: 37356947,
        host_name: "Nicola",
        latitude: 45.43775,
        longitude: 12.34231,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34231, 45.43775]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14904139,
        name: "DolceVita Apartments N. 354 Biennale",
        host_id: 8176475,
        host_name: "Eugenia",
        latitude: 45.43367,
        longitude: 12.35379,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35379, 45.43367]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14913459,
        name: "la Sensa B&B a typical home in the heart of Venice",
        host_id: 93685127,
        host_name: "Giacomo",
        latitude: 45.44453,
        longitude: 12.33161,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33161, 45.44453]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14923946,
        name: "Charming central apartment with garden",
        host_id: 93811177,
        host_name: "Marco",
        latitude: 45.43334,
        longitude: 12.32986,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32986, 45.43334]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14925459,
        name: "MIRACOLI - Romantic canal view - Cozy and spacious",
        host_id: 13019431,
        host_name: "Helga Anna",
        latitude: 45.44143,
        longitude: 12.33986,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33986, 45.44143]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14927241,
        name: "Quiet, private, convenient in heart of Venice",
        host_id: 15643843,
        host_name: "Celia",
        latitude: 45.43723,
        longitude: 12.32713,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32713, 45.43723]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14941265,
        name: "Casa Luigina",
        host_id: 10517856,
        host_name: "Alessandra",
        latitude: 45.43893,
        longitude: 12.32139,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32139, 45.43893]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14944864,
        name: "Art Room 5 in San Marcuola/Casinò",
        host_id: 48092742,
        host_name: "Roby",
        latitude: 45.44316,
        longitude: 12.32794,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32794, 45.44316]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14944876,
        name: "Flowers Room 4 Casinó",
        host_id: 48092742,
        host_name: "Roby",
        latitude: 45.44276,
        longitude: 12.32801,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32801, 45.44276]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14955506,
        name: "Center House of Anna",
        host_id: 72445649,
        host_name: "Fabrizio & Anna",
        latitude: 45.43814,
        longitude: 12.33859,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33859, 45.43814]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14960873,
        name: "Aneto - Licence number: M (Phone number hidden by Airbnb)",
        host_id: 94193482,
        host_name: "Valeria",
        latitude: 45.43794,
        longitude: 12.32678,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32678, 45.43794]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14977859,
        name: "Terrazza Bella Vista",
        host_id: 39600986,
        host_name: "Christine",
        latitude: 45.43496,
        longitude: 12.33757,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33757, 45.43496]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14978168,
        name: "Grand Duca San Marco",
        host_id: 39600986,
        host_name: "Christine",
        latitude: 45.43267,
        longitude: 12.32923,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32923, 45.43267]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14984334,
        name: "SAN MARCO ENTIRE HOME with  WIFI /AC/IDROMASSAGE",
        host_id: 94435359,
        host_name: "Andrea",
        latitude: 45.43245,
        longitude: 12.32922,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32922, 45.43245]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14985775,
        name: "Corner canal ground floor apartment",
        host_id: 13084422,
        host_name: "Michela",
        latitude: 45.43163,
        longitude: 12.32269,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32269, 45.43163]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14988997,
        name: "Stylish, Light-Filled Maisonette set in Canalside Gardens",
        host_id: 94193482,
        host_name: "Valeria",
        latitude: 45.43737,
        longitude: 12.3259,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3259, 45.43737]] },
    },
    {
      type: "Feature",
      properties: {
        id: 14998806,
        name: "Venice center, single room with balcony",
        host_id: 87463319,
        host_name: "Tommaso",
        latitude: 45.43349,
        longitude: 12.31888,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31888, 45.43349]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15003975,
        name: "Venetian Mood: ROSE",
        host_id: 3549494,
        host_name: "Manuela",
        latitude: 45.42439,
        longitude: 12.32949,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32949, 45.42439]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15004169,
        name: "Romantic room",
        host_id: 92509248,
        host_name: "Clara",
        latitude: 45.43321,
        longitude: 12.32963,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32963, 45.43321]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15013127,
        name: "Cayenna - Luxury Apartment in Venice",
        host_id: 94193482,
        host_name: "Valeria",
        latitude: 45.43805,
        longitude: 12.32708,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32708, 45.43805]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15020296,
        name: "SAN BARTOLOMEO APARTMENT",
        host_id: 94804416,
        host_name: "Chiara",
        latitude: 45.43655,
        longitude: 12.33707,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33707, 45.43655]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15021150,
        name: "Authentic Venetian Living",
        host_id: 32521428,
        host_name: "Lara",
        latitude: 45.43406,
        longitude: 12.32247,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32247, 45.43406]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15030492,
        name: "Apt. Ca' Pozzo (8 min from St Mark's Square )",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.4293,
        longitude: 12.33451,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33451, 45.4293]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15031055,
        name: "Apt. Ca' Pozzo Terrace (8 min. St Mark's Square)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.43004,
        longitude: 12.33471,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33471, 45.43004]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15034175,
        name: "Apt. San Marco MCS (100mt from St. Mark's Square)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.43268,
        longitude: 12.33577,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33577, 45.43268]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15036710,
        name: "Beautiful and chic small apartment",
        host_id: 20164796,
        host_name: "Clio",
        latitude: 45.43647,
        longitude: 12.3264,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3264, 45.43647]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15037264,
        name: "Frari intimate apartment",
        host_id: 73934712,
        host_name: "Tour Apartments",
        latitude: 45.43761,
        longitude: 12.32729,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32729, 45.43761]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15038820,
        name: "Ca' Arte (cool home with dehumidifier and fan)",
        host_id: 94996640,
        host_name: "Nada",
        latitude: 45.43237,
        longitude: 12.32877,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32877, 45.43237]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15043557,
        name: "Cà Leda Venezia",
        host_id: 95053004,
        host_name: "Francesca",
        latitude: 45.44752,
        longitude: 12.328,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.328, 45.44752]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15046789,
        name: "La Casa con il Biliardo",
        host_id: 5780736,
        host_name: "Federico",
        latitude: 45.42571,
        longitude: 12.33654,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33654, 45.42571]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15049775,
        name: "SUPERIOR RED Room with Ensuite Bathroom",
        host_id: 82270816,
        host_name: "Key Of Venice Guest House",
        latitude: 45.44511,
        longitude: 12.32904,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32904, 45.44511]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15062047,
        name: "Coriandolo - Luxury Apartment in Venice",
        host_id: 94193482,
        host_name: "Valeria",
        latitude: 45.43787,
        longitude: 12.32686,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32686, 45.43787]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15062148,
        name: "Rafano - Luxury Apartment in Venice",
        host_id: 94193482,
        host_name: "Valeria",
        latitude: 45.43816,
        longitude: 12.32701,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32701, 45.43816]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15062156,
        name: "CA BARBARO",
        host_id: 95234458,
        host_name: "Lucia",
        latitude: 45.44082,
        longitude: 12.33092,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33092, 45.44082]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15062168,
        name: 'Apartment "al Canal"',
        host_id: 4126166,
        host_name: "Gertrude",
        latitude: 45.43695,
        longitude: 12.32756,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32756, 45.43695]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15062264,
        name: "Anice - Luxury Apartment in Venice",
        host_id: 94193482,
        host_name: "Valeria",
        latitude: 45.43808,
        longitude: 12.32712,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32712, 45.43808]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15062321,
        name: "Ginepro - Luxury Apartment in Venice",
        host_id: 94193482,
        host_name: "Valeria",
        latitude: 45.43872,
        longitude: 12.32616,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32616, 45.43872]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15062388,
        name: "Rabarbaro - Luxury Apartment in Venice",
        host_id: 94193482,
        host_name: "Valeria",
        latitude: 45.43767,
        longitude: 12.32641,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32641, 45.43767]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15062697,
        name: "RIALTO BRIDGE ROMANTIC HOUSE",
        host_id: 95232685,
        host_name: "Nicola",
        latitude: 45.43885,
        longitude: 12.33479,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33479, 45.43885]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15063036,
        name: "San Marco MCS BIS (100mt from St. Mark's Square)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.43392,
        longitude: 12.33544,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33544, 45.43392]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15064747,
        name: "Zenzero - Luxury Apartment in Venice",
        host_id: 94193482,
        host_name: "Valeria",
        latitude: 45.4388,
        longitude: 12.32714,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32714, 45.4388]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15078552,
        name: "Home Venice Apartments - S. Giacomo",
        host_id: 7619802,
        host_name: "Stefania",
        latitude: 45.43958,
        longitude: 12.32733,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32733, 45.43958]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15080456,
        name: "Ca' Del Monastero 6 Apartment for 4 Guests!",
        host_id: 669047,
        host_name: "Viewsonvenice",
        latitude: 45.44174,
        longitude: 12.32873,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32873, 45.44174]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15081349,
        name: "Ca' Del Monastero 7 with Private Roof Terrace",
        host_id: 669047,
        host_name: "Viewsonvenice",
        latitude: 45.44212,
        longitude: 12.3269,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3269, 45.44212]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15083670,
        name: "Corte Stupenda",
        host_id: 46904188,
        host_name: "Mirco Optyflat",
        latitude: 45.43519,
        longitude: 12.34127,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34127, 45.43519]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15089564,
        name: "For Family Reunions and Groups of Friends",
        host_id: 91945371,
        host_name: "Davide",
        latitude: 45.43735,
        longitude: 12.34329,
        beds: 12,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34329, 45.43735]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15096994,
        name: "Bright Spacious Apartment with Grand Terrace",
        host_id: 804374,
        host_name: "Fiona",
        latitude: 45.4417,
        longitude: 12.33463,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33463, 45.4417]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15111754,
        name: "Near the railway station, quiet and bright!",
        host_id: 38526944,
        host_name: "Albana",
        latitude: 45.44541,
        longitude: 12.32711,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32711, 45.44541]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15119187,
        name: "Cà Nani",
        host_id: 82233196,
        host_name: "Silvia",
        latitude: 45.4369,
        longitude: 12.34132,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34132, 45.4369]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15129385,
        name: "Angel's Court, an Authentic Home in the Heart of Venice",
        host_id: 56679424,
        host_name: "Anna",
        latitude: 45.43298,
        longitude: 12.35499,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35499, 45.43298]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15135044,
        name: "In the heart of Venice, Calle degli Assassini",
        host_id: 27394391,
        host_name: "Davide",
        latitude: 45.43424,
        longitude: 12.33384,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33384, 45.43424]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15142490,
        name: "San Marco romantic dream",
        host_id: 27394391,
        host_name: "Davide",
        latitude: 45.43308,
        longitude: 12.33104,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33104, 45.43308]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15152983,
        name: "Casa Trecento  apartment - Art house near Rialto",
        host_id: 96127192,
        host_name: "Chiara",
        latitude: 45.43741,
        longitude: 12.33407,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33407, 45.43741]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15158959,
        name: "CA' GIRASOL with wifi and air conditioning",
        host_id: 96174272,
        host_name: "Ani",
        latitude: 45.43318,
        longitude: 12.35064,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35064, 45.43318]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15169037,
        name: "! exceptional location ! Near the cruise terminal",
        host_id: 96264799,
        host_name: "Alberto",
        latitude: 45.43853,
        longitude: 12.3192,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3192, 45.43853]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15173394,
        name: "Double room in a 15th Century Palace in Venice",
        host_id: 91945371,
        host_name: "Davide",
        latitude: 45.43951,
        longitude: 12.34476,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34476, 45.43951]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15175453,
        name: "Views on the Rialto bridge",
        host_id: 11864228,
        host_name: "Orsola",
        latitude: 45.43946,
        longitude: 12.33726,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33726, 45.43946]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15185746,
        name: "Ca' San Lorenzo Biennale Area",
        host_id: 669047,
        host_name: "Viewsonvenice",
        latitude: 45.43805,
        longitude: 12.34639,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34639, 45.43805]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15186089,
        name: "Ca' San Lorenzo 2 Biennale Area",
        host_id: 669047,
        host_name: "Viewsonvenice",
        latitude: 45.43684,
        longitude: 12.34556,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34556, 45.43684]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15186405,
        name: "Corner Canal View (300m from Rialto's Bridge)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.43956,
        longitude: 12.33668,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33668, 45.43956]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15187911,
        name: "Rialto Secret Terrace",
        host_id: 96414297,
        host_name: "Cristina",
        latitude: 45.43849,
        longitude: 12.33205,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33205, 45.43849]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15192913,
        name: "Live Venetian Style in a Charming, Elegant Flat",
        host_id: 54303606,
        host_name: "Massimo",
        latitude: 45.43924,
        longitude: 12.32557,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32557, 45.43924]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15211829,
        name: "Venice,GHETTO,BIENNALE,centre Campo Maddalena",
        host_id: 91932961,
        host_name: "Fabrizio",
        latitude: 45.44394,
        longitude: 12.3305,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3305, 45.44394]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15228371,
        name: "Calle del Forno",
        host_id: 46904188,
        host_name: "Mirco Optyflat",
        latitude: 45.43996,
        longitude: 12.33043,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33043, 45.43996]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15234060,
        name: "Dreaming Venice in a cosy apartment",
        host_id: 96839239,
        host_name: "Fam. Rizzotti",
        latitude: 45.44085,
        longitude: 12.3374,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3374, 45.44085]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15242931,
        name: "Ca' Dei Nomboli Canal View",
        host_id: 669047,
        host_name: "Viewsonvenice",
        latitude: 45.43655,
        longitude: 12.32907,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32907, 45.43655]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15243635,
        name: "Apartment Garibaldi Biennale",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.43346,
        longitude: 12.35386,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35386, 45.43346]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15247390,
        name: "FLAT WITH LIFT, 3 MIN WALKING FROM S.MARCO SQUARE",
        host_id: 96957098,
        host_name: "Francesco",
        latitude: 45.43172,
        longitude: 12.33286,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33286, 45.43172]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15251866,
        name: "CA'BOTTERI- one step from the Rialto Bridge",
        host_id: 96993739,
        host_name: "Giorgia M",
        latitude: 45.43784,
        longitude: 12.3329,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3329, 45.43784]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15254116,
        name: "Campo Ruga - Biennale",
        host_id: 88632783,
        host_name: "Cristiana",
        latitude: 45.43417,
        longitude: 12.3569,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3569, 45.43417]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15270872,
        name: "Artist's House Venice",
        host_id: 97155931,
        host_name: "Katia Paolo",
        latitude: 45.43163,
        longitude: 12.3184,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3184, 45.43163]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15275351,
        name: "the architect's hermitage",
        host_id: 4986069,
        host_name: "Andrea",
        latitude: 45.44256,
        longitude: 12.33749,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33749, 45.44256]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15275797,
        name: "Venetian Mood: SILVER",
        host_id: 3549494,
        host_name: "Manuela",
        latitude: 45.42518,
        longitude: 12.32625,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32625, 45.42518]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15277122,
        name: "DolceVita Apartments N. 358 Terrace Canal View",
        host_id: 8176475,
        host_name: "Eugenia",
        latitude: 45.43182,
        longitude: 12.35874,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35874, 45.43182]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15279977,
        name: "The Office",
        host_id: 97236143,
        host_name: "Isabella",
        latitude: 45.43563,
        longitude: 12.33872,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33872, 45.43563]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15285006,
        name: "Elegant apartment in a palace close to Miracoli",
        host_id: 54594799,
        host_name: "Anna",
        latitude: 45.4407,
        longitude: 12.33976,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33976, 45.4407]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15285553,
        name: "Grande Bellezza Vista Canale",
        host_id: 39600986,
        host_name: "Christine",
        latitude: 45.4291,
        longitude: 12.33225,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33225, 45.4291]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15292404,
        name: "IRIS SINGLE ROOM VENICE CENTER - ST. MARK'S SQUARE",
        host_id: 97355921,
        host_name: "Adriano",
        latitude: 45.43403,
        longitude: 12.33687,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33687, 45.43403]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15293205,
        name: "LILIA ROOM IN VENICE CENTER - ST. MARK'S SQUARE",
        host_id: 97355921,
        host_name: "Adriano",
        latitude: 45.43296,
        longitude: 12.33587,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33587, 45.43296]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15294191,
        name: "Silent Dorsoduro, Patio, AC, Underfloorheating!",
        host_id: 97369278,
        host_name: "Dagmar",
        latitude: 45.43251,
        longitude: 12.31974,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31974, 45.43251]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15295464,
        name: "Ca' del Cafetièr: a haven for family reunions",
        host_id: 5146501,
        host_name: "Stefano",
        latitude: 45.4398,
        longitude: 12.34405,
        beds: 11,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34405, 45.4398]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15295568,
        name:
          "Ai Bareteri Luxury Canal View (L.T. M (Phone number hidden by Airbnb)",
        host_id: 5618111,
        host_name: "EasySuite",
        latitude: 45.4358,
        longitude: 12.33864,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33864, 45.4358]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15297093,
        name: "PEONIA ROOM IN VENICE CENTER - ST. MARK'S SQUARE",
        host_id: 97355921,
        host_name: "Adriano",
        latitude: 45.43314,
        longitude: 12.33724,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33724, 45.43314]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15323744,
        name: "Venice Homestay! Bright Double Room near San Marco",
        host_id: 804374,
        host_name: "Fiona",
        latitude: 45.43836,
        longitude: 12.33044,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33044, 45.43836]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15358059,
        name: "Mario Apartment wi-fi",
        host_id: 10072655,
        host_name: "Mario Apartment",
        latitude: 45.44679,
        longitude: 12.32572,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32572, 45.44679]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15377102,
        name: "APARTMENT VENICE GIARDINI",
        host_id: 87127368,
        host_name: "Marta",
        latitude: 45.43254,
        longitude: 12.35457,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35457, 45.43254]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15402674,
        name: "CA RUBINA cozy apartment near Ghetto",
        host_id: 28804585,
        host_name: "Eleonora",
        latitude: 45.44626,
        longitude: 12.32987,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32987, 45.44626]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15404843,
        name: "Mansarda Magritte",
        host_id: 3972291,
        host_name: "Caroline E Marco",
        latitude: 45.4297,
        longitude: 12.33075,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33075, 45.4297]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15406721,
        name: "Venetian sunny house",
        host_id: 98630145,
        host_name: "Traudy",
        latitude: 45.43926,
        longitude: 12.32202,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32202, 45.43926]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15413817,
        name: "Nido sui tetti veneziani con terrazza incantevole",
        host_id: 2030045,
        host_name: "Francesca",
        latitude: 45.43382,
        longitude: 12.35445,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35445, 45.43382]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15414118,
        name: "La casetta a San Marco",
        host_id: 39600986,
        host_name: "Christine",
        latitude: 45.43307,
        longitude: 12.32949,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32949, 45.43307]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15432544,
        name: "Ca' Donzela comodo appartamento a Rialto Mercato",
        host_id: 98937849,
        host_name: "Attilio",
        latitude: 45.43901,
        longitude: 12.33347,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33347, 45.43901]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15432865,
        name: "Apartment Formosa",
        host_id: 98943279,
        host_name: "Shu Fen",
        latitude: 45.43619,
        longitude: 12.33958,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33958, 45.43619]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15435386,
        name: "Appartamento Venezia 1",
        host_id: 92996129,
        host_name: "Paola",
        latitude: 45.43776,
        longitude: 12.34043,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34043, 45.43776]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15442552,
        name: "Gesuiti 1 - Cozy and central apartment",
        host_id: 5395291,
        host_name: "Beatrice",
        latitude: 45.44241,
        longitude: 12.33823,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33823, 45.44241]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15443516,
        name: "RESIDENCE ON THE LAGUNA",
        host_id: 99045011,
        host_name: "Valentina & Dimitri",
        latitude: 45.43237,
        longitude: 12.33592,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33592, 45.43237]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15456746,
        name: "La Chiesetta Apartment",
        host_id: 46904188,
        host_name: "Mirco Optyflat",
        latitude: 45.43734,
        longitude: 12.34452,
        beds: null,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34452, 45.43734]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15467908,
        name: "Venetian style room  5 mins from Piazza San Marco",
        host_id: 2737238,
        host_name: "Annalisa E Emma",
        latitude: 45.43319,
        longitude: 12.33298,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33298, 45.43319]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15476683,
        name: "Grande appartamento per piccolo budget",
        host_id: 25756873,
        host_name: "Monica",
        latitude: 45.44128,
        longitude: 12.32855,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32855, 45.44128]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15478406,
        name: "Modern&Elegant Apt - 30 mt (98 ft.)St Mark Square!",
        host_id: 99360847,
        host_name: "Francesca",
        latitude: 45.43501,
        longitude: 12.33965,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33965, 45.43501]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15493313,
        name: "..Canal view City Centre..",
        host_id: 35809942,
        host_name: "Daryl",
        latitude: 45.43822,
        longitude: 12.34336,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34336, 45.43822]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15494786,
        name: "J A STUDIO SUITE",
        host_id: 92620149,
        host_name: "Samy",
        latitude: 45.43561,
        longitude: 12.33141,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33141, 45.43561]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15495464,
        name: "Venise comme un Vénitien avec balcon sur un canal",
        host_id: 16995052,
        host_name: "Myriam",
        latitude: 45.44146,
        longitude: 12.3243,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3243, 45.44146]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15496049,
        name: "TOP CENTRAL VENICE with WIFI",
        host_id: 94435359,
        host_name: "Andrea",
        latitude: 45.4324,
        longitude: 12.32619,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32619, 45.4324]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15503759,
        name: "Quintuple room  in a 15th century palace in Venice",
        host_id: 91945371,
        host_name: "Davide",
        latitude: 45.43786,
        longitude: 12.34519,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34519, 45.43786]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15504021,
        name: "Ca' dei Fuseri",
        host_id: 7325760,
        host_name: "Stefano",
        latitude: 45.43558,
        longitude: 12.33461,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33461, 45.43558]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15508990,
        name: "DoMarie",
        host_id: 99638197,
        host_name: "Mariasilvia",
        latitude: 45.43712,
        longitude: 12.34854,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34854, 45.43712]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15516608,
        name: "J A KING PENTHOUSE",
        host_id: 92620149,
        host_name: "Samy",
        latitude: 45.43347,
        longitude: 12.32907,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32907, 45.43347]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15517573,
        name: "Typical Venetian house with canal view",
        host_id: 53977209,
        host_name: "Clara",
        latitude: 45.44,
        longitude: 12.32966,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32966, 45.44]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15518248,
        name: "J A TWO BEDROOMS SUITE",
        host_id: 92620149,
        host_name: "Samy",
        latitude: 45.43462,
        longitude: 12.32837,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32837, 45.43462]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15520950,
        name: "Under the roofs of Venice",
        host_id: 99771875,
        host_name: "Venice",
        latitude: 45.43827,
        longitude: 12.34382,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34382, 45.43827]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15521372,
        name: "DALIA ROOM IN VENICE CENTER - ST. MARK'S SQUARE",
        host_id: 97355921,
        host_name: "Adriano",
        latitude: 45.43449,
        longitude: 12.33738,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33738, 45.43449]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15526599,
        name: "Romantic Apt on the Grand Canal",
        host_id: 44990889,
        host_name: "Anna",
        latitude: 45.44331,
        longitude: 12.32655,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32655, 45.44331]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15530911,
        name: "Ampia mansarda su 2 piani con terrazza e cucina",
        host_id: 96182379,
        host_name: "Valentina",
        latitude: 45.43367,
        longitude: 12.35964,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35964, 45.43367]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15553656,
        name: "Incredible location in San Marco's Square, Venice",
        host_id: 29628194,
        host_name: "Francesca",
        latitude: 45.43481,
        longitude: 12.33667,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33667, 45.43481]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15554695,
        name: "Un angolo nel centro di Venzia",
        host_id: 70766577,
        host_name: "Silvia",
        latitude: 45.44388,
        longitude: 12.32919,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32919, 45.44388]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15580061,
        name: "Appartamento luminoso 2 camere 2 bagni in centro",
        host_id: 100372429,
        host_name: "Azzurra",
        latitude: 45.43948,
        longitude: 12.34314,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34314, 45.43948]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15592376,
        name: "Venice Skyline Loft",
        host_id: 15891711,
        host_name: "Caterina",
        latitude: 45.43249,
        longitude: 12.35159,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35159, 45.43249]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15596983,
        name: "Location location location! charming brand new apt",
        host_id: 5530875,
        host_name: "Maurizio",
        latitude: 45.43475,
        longitude: 12.33513,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33513, 45.43475]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15598064,
        name: "San Marco Apartment",
        host_id: 100521314,
        host_name: "Barbarigo",
        latitude: 45.43515,
        longitude: 12.33649,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33649, 45.43515]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15599226,
        name: "Upper Level Attic Loft with Rooftop Views... My Venice Attic",
        host_id: 60476959,
        host_name: "Roberto",
        latitude: 45.43587,
        longitude: 12.34648,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34648, 45.43587]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15607868,
        name: "Very central flat/loft with terrace",
        host_id: 100618367,
        host_name: "Carlotta",
        latitude: 45.43257,
        longitude: 12.33728,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33728, 45.43257]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15628170,
        name: "CORTE ORMESINI",
        host_id: 100743673,
        host_name: "Donatella",
        latitude: 45.44471,
        longitude: 12.32889,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32889, 45.44471]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15628288,
        name: "Appartamento Venier",
        host_id: 3972291,
        host_name: "Caroline E Marco",
        latitude: 45.43036,
        longitude: 12.32992,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32992, 45.43036]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15629264,
        name: "Ponte Squero Apartment DD1300",
        host_id: 46904188,
        host_name: "Mirco Optyflat",
        latitude: 45.43368,
        longitude: 12.32629,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32629, 45.43368]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15629943,
        name: "Kandinskij House",
        host_id: 3972291,
        host_name: "Caroline E Marco",
        latitude: 45.43001,
        longitude: 12.33166,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33166, 45.43001]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15638592,
        name: "Villetta tipica a Venezia, zona S. Marco (8 pax)",
        host_id: 62268572,
        host_name: "Fabio",
        latitude: 45.43569,
        longitude: 12.3458,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3458, 45.43569]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15660018,
        name: "SAN MARCO CANAL VIEW TWO BEDROOMS",
        host_id: 12244227,
        host_name: "Roberto",
        latitude: 45.43498,
        longitude: 12.34515,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34515, 45.43498]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15669947,
        name: "Corte Sconta M (Phone number hidden by Airbnb)",
        host_id: 15005402,
        host_name: "Veronica",
        latitude: 45.43889,
        longitude: 12.32784,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32784, 45.43889]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15672605,
        name: "Ca' Marcella",
        host_id: 87431454,
        host_name: "Giuliano",
        latitude: 45.43481,
        longitude: 12.34103,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34103, 45.43481]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15673928,
        name: "Compelling Hideaway near the Rialto Bridge",
        host_id: 101210418,
        host_name: "Enrico",
        latitude: 45.43871,
        longitude: 12.33101,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33101, 45.43871]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15674114,
        name: "Small apartment in a green area near Biennale",
        host_id: 57633625,
        host_name: "Nello",
        latitude: 45.42706,
        longitude: 12.36184,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.36184, 45.42706]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15697676,
        name: "Ca Foscari Dorsoduro vista Canale",
        host_id: 39600986,
        host_name: "Christine",
        latitude: 45.43438,
        longitude: 12.32614,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32614, 45.43438]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15701323,
        name: "Incredibile Romantica Venezia",
        host_id: 1408761,
        host_name: "Chiara",
        latitude: 45.43914,
        longitude: 12.33099,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33099, 45.43914]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15729404,
        name: "ROMANTIC SUITE DREAM ROOM WITH VIEW CANAL",
        host_id: 23598673,
        host_name: "Patricia",
        latitude: 45.43884,
        longitude: 12.32995,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32995, 45.43884]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15739988,
        name: '"Lovely Corbusier" Venice apartment',
        host_id: 101670900,
        host_name: "Francesca",
        latitude: 45.44058,
        longitude: 12.33644,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33644, 45.44058]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15750283,
        name: "Attic in S. Marco Square",
        host_id: 10174216,
        host_name: "Furio",
        latitude: 45.43459,
        longitude: 12.33706,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33706, 45.43459]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15763795,
        name: "Quadruple room in a 15th century palace in Venice",
        host_id: 91945371,
        host_name: "Davide",
        latitude: 45.43809,
        longitude: 12.34442,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34442, 45.43809]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15766835,
        name: "Wonderful  apartment in the hearth of Venice",
        host_id: 10118920,
        host_name: "Fabienne",
        latitude: 45.43685,
        longitude: 12.32681,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32681, 45.43685]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15796938,
        name: "Accademia Terrazza",
        host_id: 3972291,
        host_name: "Caroline E Marco",
        latitude: 45.43114,
        longitude: 12.32782,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32782, 45.43114]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15798679,
        name: "San Marco appartamento tipico veneziano",
        host_id: 5033094,
        host_name: "Bruno",
        latitude: 45.43254,
        longitude: 12.33036,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33036, 45.43254]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15798810,
        name: "Luxury Apartment 2/4 people St. Mark's Square",
        host_id: 69921858,
        host_name: "Corte Nova S.R.L",
        latitude: 45.43698,
        longitude: 12.34693,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34693, 45.43698]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15800196,
        name: "Luxury Apartment 3people St. Mark's Square",
        host_id: 69921858,
        host_name: "Corte Nova S.R.L",
        latitude: 45.4386,
        longitude: 12.34685,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34685, 45.4386]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15800362,
        name: "luxury Apartment 4 people St. Mark's Square",
        host_id: 69921858,
        host_name: "Corte Nova S.R.L",
        latitude: 45.43757,
        longitude: 12.34517,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34517, 45.43757]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15812296,
        name: "Luxury Apartment, 5 pax, near St. Mark's Square",
        host_id: 69921858,
        host_name: "Corte Nova S.R.L",
        latitude: 45.43814,
        longitude: 12.34651,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34651, 45.43814]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15812750,
        name: "Luxury Apartment 6 people St. Mark's Square",
        host_id: 69921858,
        host_name: "Corte Nova S.R.L",
        latitude: 45.43622,
        longitude: 12.34563,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34563, 45.43622]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15814303,
        name: "CA' SANDRA - Between the Biennale and St. Mark",
        host_id: 10189388,
        host_name: "Raffaella",
        latitude: 45.4343,
        longitude: 12.3472,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3472, 45.4343]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15824630,
        name: "Biennale apartment with big terrace",
        host_id: 102453942,
        host_name: "Yumi",
        latitude: 45.43374,
        longitude: 12.35181,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35181, 45.43374]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15841996,
        name: "Santa Marina Studio",
        host_id: 46904188,
        host_name: "Mirco Optyflat",
        latitude: 45.43846,
        longitude: 12.33909,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33909, 45.43846]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15851823,
        name: "Apartment with terrace 2.0 in Venice",
        host_id: 10793908,
        host_name: "Leone",
        latitude: 45.44166,
        longitude: 12.32671,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32671, 45.44166]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15857106,
        name: "Casa Valier Luxury home in S.Marco Square",
        host_id: 102762329,
        host_name: "Vanessa",
        latitude: 45.43503,
        longitude: 12.33811,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33811, 45.43503]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15862862,
        name: "Enchanting San Boldo with terrace",
        host_id: 102816709,
        host_name: "Valentina",
        latitude: 45.44064,
        longitude: 12.33001,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33001, 45.44064]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15863506,
        name: "Casa Carmini - typical Venetian apartment",
        host_id: 102818579,
        host_name: "S.",
        latitude: 45.43482,
        longitude: 12.32419,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32419, 45.43482]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15893253,
        name: "Apartment in the heart of the Sestiere di Castello",
        host_id: 103082157,
        host_name: "Paola",
        latitude: 45.43524,
        longitude: 12.35848,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35848, 45.43524]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15894301,
        name: "chambre privée chez habitant, avec petite terrasse",
        host_id: 6713218,
        host_name: "Hugues",
        latitude: 45.44448,
        longitude: 12.32427,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32427, 45.44448]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15896253,
        name: "Dreaming Venice",
        host_id: 103104349,
        host_name: "Giacomo",
        latitude: 45.44186,
        longitude: 12.33551,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33551, 45.44186]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15896366,
        name: "Design House in the centre of Venice",
        host_id: 6678803,
        host_name: "Marco",
        latitude: 45.43571,
        longitude: 12.32681,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32681, 45.43571]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15917146,
        name: "ARSENALE APT ELEGANTE VICINO  BIENNALE",
        host_id: 103269602,
        host_name: "Valeria",
        latitude: 45.43325,
        longitude: 12.34881,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34881, 45.43325]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15921488,
        name: "Elegant and comfortable. In the heart of cannaregio",
        host_id: 20685673,
        host_name: "Gabriel",
        latitude: 45.44267,
        longitude: 12.33011,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33011, 45.44267]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15959753,
        name: "TINTORETTO 1 CHARMING WATER VIEWS!",
        host_id: 103640525,
        host_name: "Team",
        latitude: 45.44569,
        longitude: 12.33292,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33292, 45.44569]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15959898,
        name: "TINTORETTO 2 TERRACE OVER THE WATER",
        host_id: 103640525,
        host_name: "Team",
        latitude: 45.44508,
        longitude: 12.33163,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33163, 45.44508]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15961041,
        name: "Charming studio in Venice",
        host_id: 84525573,
        host_name: "Atlantic Do Archi Deluxe",
        latitude: 45.43398,
        longitude: 12.3527,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3527, 45.43398]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15961959,
        name: "MASTER TINTORETTO FOR GROUPS",
        host_id: 103640525,
        host_name: "Team",
        latitude: 45.44484,
        longitude: 12.33328,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33328, 45.44484]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15963622,
        name: "Relaxing, central location, one bedroom apt. X104",
        host_id: 15178567,
        host_name: "Paolo",
        latitude: 45.43647,
        longitude: 12.34055,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34055, 45.43647]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15964618,
        name: "CA' D'ORO - Next to Strada Nova and Rialto bridge",
        host_id: 10189388,
        host_name: "Raffaella",
        latitude: 45.44137,
        longitude: 12.33613,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33613, 45.44137]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15966205,
        name: "Princess GH Camera Basic confortevole silenziosa",
        host_id: 29619859,
        host_name: "Stefano",
        latitude: 45.44659,
        longitude: 12.32224,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32224, 45.44659]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15966324,
        name: "Princess GH Camera in stile con terrazza privata",
        host_id: 29619859,
        host_name: "Stefano",
        latitude: 45.44499,
        longitude: 12.32246,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32246, 45.44499]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15967127,
        name: "Princess GH Camera Suite vista canale Cannaregio",
        host_id: 29619859,
        host_name: "Stefano",
        latitude: 45.44506,
        longitude: 12.32195,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32195, 45.44506]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15967256,
        name: "Princess GH Camera Ampia con vista canale",
        host_id: 29619859,
        host_name: "Stefano",
        latitude: 45.44653,
        longitude: 12.32166,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32166, 45.44653]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15971186,
        name: "Da Caterina Apartment",
        host_id: 103736592,
        host_name: "Caterina",
        latitude: 45.43387,
        longitude: 12.31815,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31815, 45.43387]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15976595,
        name: "Sunny apartment with terrace canal view",
        host_id: 103336872,
        host_name: "Stefano",
        latitude: 45.43364,
        longitude: 12.32225,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32225, 45.43364]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15985442,
        name: "Marco Polo's House -terrace with view to San Marco",
        host_id: 103806114,
        host_name: "Manuel",
        latitude: 45.42429,
        longitude: 12.33233,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33233, 45.42429]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15992271,
        name: "Appartamento La Bricola",
        host_id: 103935879,
        host_name: "Nabil",
        latitude: 45.43731,
        longitude: 12.34075,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34075, 45.43731]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15993926,
        name: "Ca' delle Furlane Apartment at Giardini Biennale",
        host_id: 10174216,
        host_name: "Furio",
        latitude: 45.43024,
        longitude: 12.35867,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35867, 45.43024]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15994002,
        name: "DAISY - Excellent location in Venice city centre.",
        host_id: 10189388,
        host_name: "Raffaella",
        latitude: 45.43693,
        longitude: 12.33994,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33994, 45.43693]] },
    },
    {
      type: "Feature",
      properties: {
        id: 15998541,
        name: "Authentic Apartment near Rialto Bridge (Venice)",
        host_id: 103977102,
        host_name: "Giò E And",
        latitude: 45.43808,
        longitude: 12.33313,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33313, 45.43808]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16001709,
        name: "Appartamento Calle dei Preti",
        host_id: 104014879,
        host_name: "Giulia",
        latitude: 45.43415,
        longitude: 12.35417,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35417, 45.43415]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16008041,
        name: "Canal View Apartment, very central, 2 bedrooms X81",
        host_id: 15178567,
        host_name: "Paolo",
        latitude: 45.43674,
        longitude: 12.3396,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3396, 45.43674]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16011556,
        name: "CASANOVA - For a romantic stay",
        host_id: 10189388,
        host_name: "Raffaella",
        latitude: 45.43996,
        longitude: 12.33859,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33859, 45.43996]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16012225,
        name: "TERRAZZA - Bright flat with canal view and terrace",
        host_id: 10189388,
        host_name: "Raffaella",
        latitude: 45.44425,
        longitude: 12.33148,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33148, 45.44425]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16012639,
        name: "COQUETTE - Modern flat for two with elevator",
        host_id: 10189388,
        host_name: "Raffaella",
        latitude: 45.43993,
        longitude: 12.33625,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33625, 45.43993]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16017710,
        name: "MARAFONI APARTMENT NEAR BIENNALE WITH CANAL VIEW",
        host_id: 104163392,
        host_name: "Michelle",
        latitude: 45.43258,
        longitude: 12.35781,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35781, 45.43258]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16022389,
        name: "Cosy house at the Basilica dei Frari - Dorsoduro",
        host_id: 97732588,
        host_name: "Anna",
        latitude: 45.43589,
        longitude: 12.32447,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32447, 45.43589]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16022552,
        name: "COLOMBINA - Canal view in St. Mark's area",
        host_id: 10189388,
        host_name: "Raffaella",
        latitude: 45.43392,
        longitude: 12.33026,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33026, 45.43392]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16023990,
        name: "Apt. Avogaria Canal View  (Historical Centre)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.43157,
        longitude: 12.32228,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32228, 45.43157]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16024546,
        name: "CORALLO - Ground floor apartment in Cannaregio",
        host_id: 10189388,
        host_name: "Raffaella",
        latitude: 45.4423,
        longitude: 12.33935,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33935, 45.4423]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16024942,
        name: "SOLARIS - Bright apartment with canal view",
        host_id: 10189388,
        host_name: "Raffaella",
        latitude: 45.44105,
        longitude: 12.33578,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33578, 45.44105]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16036623,
        name: "Venezia San Marco Central Apartment WiFi 8 People",
        host_id: 13012838,
        host_name: "Paola",
        latitude: 45.4342,
        longitude: 12.33853,
        beds: 8,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33853, 45.4342]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16046081,
        name: "Ca' Martinego : A jewel in Venice !",
        host_id: 104450762,
        host_name: "Marco",
        latitude: 45.43667,
        longitude: 12.33773,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33773, 45.43667]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16061001,
        name: "Casa Leoni",
        host_id: 14269771,
        host_name: "Mina",
        latitude: 45.43758,
        longitude: 12.34803,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34803, 45.43758]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16061063,
        name: "Black/white open space with channel view",
        host_id: 41711000,
        host_name: "Betty E Oscar",
        latitude: 45.438,
        longitude: 12.32525,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32525, 45.438]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16067284,
        name: "Super Cosy and new flat near San Mark and Biennale",
        host_id: 104667607,
        host_name: "Paola  E Irene",
        latitude: 45.43574,
        longitude: 12.34639,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34639, 45.43574]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16068452,
        name: "Ca'Cino: Apartment (90 sq m) Simple, Cozy & Clean",
        host_id: 104679356,
        host_name: "Nicolò",
        latitude: 45.42619,
        longitude: 12.36187,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.36187, 45.42619]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16069221,
        name: "Casa Angelina",
        host_id: 104686761,
        host_name: "Giuliana",
        latitude: 45.43434,
        longitude: 12.34998,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34998, 45.43434]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16075263,
        name: "Cozy single house at 5 min walk from St Mark's",
        host_id: 104746063,
        host_name: "Ilaria",
        latitude: 45.43658,
        longitude: 12.33938,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33938, 45.43658]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16091090,
        name: "Artistic and colorful Loft, with private garden",
        host_id: 2108493,
        host_name: "Walfredo",
        latitude: 45.43278,
        longitude: 12.31722,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31722, 45.43278]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16097137,
        name: "Ca Moretta",
        host_id: 101919063,
        host_name: "Elisabetta & Riccardo",
        latitude: 45.43287,
        longitude: 12.33555,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33555, 45.43287]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16105143,
        name: "Ca' Contini - appartamento con terrazza",
        host_id: 58831519,
        host_name: "Federica",
        latitude: 45.44648,
        longitude: 12.32913,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32913, 45.44648]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16105301,
        name: "Venice Gran Design Apt. 1",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.44308,
        longitude: 12.32559,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32559, 45.44308]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16107060,
        name: "Venice Gran Design Apt. 2",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.44321,
        longitude: 12.32744,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32744, 45.44321]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16108270,
        name: "BROCCATO BIS",
        host_id: 27817620,
        host_name: "Alfonso",
        latitude: 45.44067,
        longitude: 12.32595,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32595, 45.44067]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16118424,
        name: "360degrees view suite",
        host_id: 1490179,
        host_name: "Laura",
        latitude: 45.43863,
        longitude: 12.334,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.334, 45.43863]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16118808,
        name: "Venice Gran Design Apt.3",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.44476,
        longitude: 12.32556,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32556, 45.44476]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16119278,
        name: "Rialto Design Suite",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.44453,
        longitude: 12.32755,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32755, 45.44453]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16123590,
        name: "Romanitc suite in San Marco",
        host_id: 51341661,
        host_name: "Maurizio",
        latitude: 45.43623,
        longitude: 12.33912,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33912, 45.43623]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16128089,
        name: "Cà D'Oro Apartment (First Floor)",
        host_id: 25998480,
        host_name: "Cristina",
        latitude: 45.44289,
        longitude: 12.33682,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33682, 45.44289]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16151713,
        name: "GUGGENHEIM ROMANTIC OVERLOOKING 5pax, Wifi Aircond",
        host_id: 17534457,
        host_name: "Abaca",
        latitude: 45.43012,
        longitude: 12.3326,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3326, 45.43012]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16153747,
        name: "house of light",
        host_id: 105430872,
        host_name: "Paul",
        latitude: 45.44005,
        longitude: 12.33622,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33622, 45.44005]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16171246,
        name: "Venice Gran Design Apt. 5",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.44504,
        longitude: 12.32763,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32763, 45.44504]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16172771,
        name: "LOVELY FLAT NEAR ST.MARK AIR CONDITIONING",
        host_id: 105577375,
        host_name: "Isabella",
        latitude: 45.43355,
        longitude: 12.33138,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33138, 45.43355]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16183370,
        name: "Venice Garden View Apt. 1",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.4353,
        longitude: 12.32202,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32202, 45.4353]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16184745,
        name: "Vintage and Classy room Dark Taurquise",
        host_id: 105682164,
        host_name: "Adelina",
        latitude: 45.44035,
        longitude: 12.33722,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33722, 45.44035]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16185520,
        name: "San Marco Sweet Home Cod. ID  M (Phone number hidden by Airbnb)",
        host_id: 45342577,
        host_name: "Daria",
        latitude: 45.4329,
        longitude: 12.33292,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33292, 45.4329]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16189817,
        name: "Terrazza Patriarca - Penthouse in San Marco square",
        host_id: 105717786,
        host_name: "Patrick",
        latitude: 45.43555,
        longitude: 12.34009,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34009, 45.43555]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16191882,
        name: "BALCONY CANAL VIEW RIALTO 6pax, Internet, large",
        host_id: 17534457,
        host_name: "Abaca",
        latitude: 45.44145,
        longitude: 12.33843,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33843, 45.44145]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16198388,
        name: "Venice Garden View Apt. 2",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.43447,
        longitude: 12.32253,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32253, 45.43447]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16199972,
        name: "Venice Grand Canal Style Apt. 1",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.43792,
        longitude: 12.33165,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33165, 45.43792]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16200263,
        name: "Cà Venezia Design Apartment",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.44129,
        longitude: 12.32678,
        beds: 8,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32678, 45.44129]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16210861,
        name: "Venice Style Apartment",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.44375,
        longitude: 12.33309,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33309, 45.44375]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16212091,
        name: "Ca' Delle Comari with Venetian Roof Terrace",
        host_id: 669047,
        host_name: "Viewsonvenice",
        latitude: 45.43369,
        longitude: 12.32577,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32577, 45.43369]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16212141,
        name: "Venice Grand Canal Terrace",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.4386,
        longitude: 12.33432,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33432, 45.4386]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16212389,
        name: "San Marco Venice Apartment 1",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.43686,
        longitude: 12.33532,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33532, 45.43686]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16212630,
        name: "Rialto Deluxe Apt. 1",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.43918,
        longitude: 12.32997,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32997, 45.43918]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16225413,
        name: "Vintage and Classy Venice Room Green",
        host_id: 105682164,
        host_name: "Adelina",
        latitude: 45.44203,
        longitude: 12.33724,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33724, 45.44203]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16225630,
        name: "Vintage and Classy Venice Room Orange Brick",
        host_id: 105682164,
        host_name: "Adelina",
        latitude: 45.44222,
        longitude: 12.33611,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33611, 45.44222]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16227031,
        name: "Angi San Marco  ID M (Phone number hidden by Airbnb)",
        host_id: 106038704,
        host_name: "Enrico",
        latitude: 45.4363,
        longitude: 12.33548,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33548, 45.4363]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16228838,
        name: "Private Room Twin Beds (Shared Bathroom)",
        host_id: 12355491,
        host_name: "Ali",
        latitude: 45.44123,
        longitude: 12.33861,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33861, 45.44123]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16240093,
        name: "Apartment 'Capanna mansarda coccolosa'",
        host_id: 498418,
        host_name: "Luca",
        latitude: 45.43212,
        longitude: 12.35704,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35704, 45.43212]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16247452,
        name: "Rialto Deluxe Apt. 2",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.44061,
        longitude: 12.32968,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32968, 45.44061]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16249037,
        name: "Sunshine Venice! Double bedroom in the center of Venice!",
        host_id: 7978760,
        host_name: "Luca",
        latitude: 45.43674,
        longitude: 12.32193,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32193, 45.43674]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16249596,
        name: "Grand Canal Rialto Palace Lift",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.44264,
        longitude: 12.33328,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33328, 45.44264]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16252069,
        name: "Apartment Calice (100mt. from Rialto's Bridge)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.43734,
        longitude: 12.33657,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33657, 45.43734]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16253215,
        name: "Cà Rosa",
        host_id: 106031055,
        host_name: "Paolo",
        latitude: 45.43316,
        longitude: 12.35167,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35167, 45.43316]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16256132,
        name: "Mario Apartment 3 Wi-Fi",
        host_id: 10072655,
        host_name: "Mario Apartment",
        latitude: 45.43854,
        longitude: 12.32826,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32826, 45.43854]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16267136,
        name: "Vintage Cozy Apartment first floor",
        host_id: 105682164,
        host_name: "Adelina",
        latitude: 45.44041,
        longitude: 12.33753,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33753, 45.44041]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16267842,
        name: "San Marco Square With Terrace",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.43748,
        longitude: 12.33753,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33753, 45.43748]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16279288,
        name: "Apartment Miracoli (500mt from Rialto's Bridge)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.44235,
        longitude: 12.34086,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34086, 45.44235]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16282670,
        name: "Luxury San Marco Do Mori Apartment",
        host_id: 50349340,
        host_name: "Sebastiano",
        latitude: 45.43785,
        longitude: 12.33815,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33815, 45.43785]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16283442,
        name: "Ca' Betta",
        host_id: 34360885,
        host_name: "Samuel",
        latitude: 45.4307,
        longitude: 12.32742,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32742, 45.4307]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16285579,
        name: "nice room",
        host_id: 4635177,
        host_name: "Paolo",
        latitude: 45.43978,
        longitude: 12.32323,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32323, 45.43978]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16291922,
        name: "A.F. Apartments - Ideal for families in Venice",
        host_id: 106583012,
        host_name: "Giorgio",
        latitude: 45.44172,
        longitude: 12.33315,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33315, 45.44172]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16292410,
        name: "Digital Nomads Paradise 2 Bedroom in San Stae",
        host_id: 106586727,
        host_name: "Annamaria",
        latitude: 45.44034,
        longitude: 12.32969,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32969, 45.44034]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16295253,
        name: "A REAL VENETIAN HOME",
        host_id: 106608403,
        host_name: "Giovanna",
        latitude: 45.43655,
        longitude: 12.32881,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32881, 45.43655]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16305548,
        name: "Bragadin della Palma 2 at Dorsoduro 2 pax ( 4max )",
        host_id: 9963282,
        host_name: "Andrea",
        latitude: 45.42909,
        longitude: 12.33058,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33058, 45.42909]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16309277,
        name: "Ca' Rialto",
        host_id: 39240019,
        host_name: "Marcello",
        latitude: 45.43858,
        longitude: 12.33158,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33158, 45.43858]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16313227,
        name: "CASA ACCADEMIA GREEN with air conditioned system",
        host_id: 389780,
        host_name: "De Giudici",
        latitude: 45.42998,
        longitude: 12.3294,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3294, 45.42998]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16317848,
        name: "Lovely Loft in Venice",
        host_id: 106788193,
        host_name: "Giuseppe",
        latitude: 45.44423,
        longitude: 12.32961,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32961, 45.44423]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16318606,
        name: "Charming double room with a private bathroom.",
        host_id: 106790070,
        host_name: "Anna & Emiliano",
        latitude: 45.43932,
        longitude: 12.33798,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33798, 45.43932]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16319889,
        name: "Cosy room in the heart of the old town.",
        host_id: 106790070,
        host_name: "Anna & Emiliano",
        latitude: 45.43886,
        longitude: 12.3382,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3382, 45.43886]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16322931,
        name: "Enchanting double room in the heart of Venice.",
        host_id: 106790070,
        host_name: "Anna & Emiliano",
        latitude: 45.43907,
        longitude: 12.33953,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33953, 45.43907]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16340861,
        name: "Viva la Giudecca viva!",
        host_id: 1242460,
        host_name: "Albert",
        latitude: 45.42627,
        longitude: 12.32405,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32405, 45.42627]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16344864,
        name: "Casa Fontanea Attico Your dream in Venice",
        host_id: 107010081,
        host_name: "Vanessa",
        latitude: 45.44645,
        longitude: 12.3198,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3198, 45.44645]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16356586,
        name: "Apartment in the heart of Venice!",
        host_id: 106880093,
        host_name: "Federica & Doriano",
        latitude: 45.43476,
        longitude: 12.32435,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32435, 45.43476]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16356820,
        name: "Cà Cirulli",
        host_id: 75368043,
        host_name: "Gaia",
        latitude: 45.43397,
        longitude: 12.34656,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34656, 45.43397]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16362139,
        name: "Canal-Side Attic Apartment Overlooking a Gothic Church",
        host_id: 11479309,
        host_name: "Arrigo",
        latitude: 45.44558,
        longitude: 12.33321,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33321, 45.44558]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16366007,
        name: "Casetta privata S. Marco wifi free",
        host_id: 107177361,
        host_name: "Leo",
        latitude: 45.43752,
        longitude: 12.34111,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34111, 45.43752]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16370889,
        name: "Secret Garden Venice",
        host_id: 107222811,
        host_name: "Paolo",
        latitude: 45.44553,
        longitude: 12.33027,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33027, 45.44553]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16375198,
        name: "MaryBeth Residence, Venice",
        host_id: 57249358,
        host_name: "Roberta",
        latitude: 45.43493,
        longitude: 12.31921,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31921, 45.43493]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16375254,
        name: "Chic and cheap near train station with lift",
        host_id: 5980615,
        host_name: "Adriana",
        latitude: 45.44379,
        longitude: 12.32012,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32012, 45.44379]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16375601,
        name: "Orange House",
        host_id: 4279448,
        host_name: "Giacomo",
        latitude: 45.44183,
        longitude: 12.34078,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34078, 45.44183]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16375708,
        name: "Cà Sartor",
        host_id: 4279448,
        host_name: "Giacomo",
        latitude: 45.44108,
        longitude: 12.33533,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33533, 45.44108]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16377409,
        name: "Tiepolo Flat Giardini Biennale of Art Apartment",
        host_id: 104359435,
        host_name: "Annmary",
        latitude: 45.43169,
        longitude: 12.35392,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35392, 45.43169]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16409235,
        name: "New and lovely apartment with balcony.",
        host_id: 41684464,
        host_name: "VeneziaImmobiliare Sas Di",
        latitude: 45.44342,
        longitude: 12.32795,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32795, 45.44342]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16416189,
        name: "Venice from the top...with Lift!",
        host_id: 5332703,
        host_name: "Giovanna",
        latitude: 45.44306,
        longitude: 12.32564,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32564, 45.44306]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16419921,
        name: "Big apartment/big terrace in the center of Venice",
        host_id: 22313424,
        host_name: "Tom",
        latitude: 45.43033,
        longitude: 12.32837,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32837, 45.43033]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16423153,
        name: "Spacious apartment with a balcony",
        host_id: 49930101,
        host_name: "Elena",
        latitude: 45.43787,
        longitude: 12.34888,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34888, 45.43787]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16431773,
        name: "Grand Canal Penthouse: close to Train Station-WIFI",
        host_id: 41699367,
        host_name: "Silvia Carlo",
        latitude: 45.44212,
        longitude: 12.32333,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32333, 45.44212]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16450315,
        name: "Ca' San Salvador",
        host_id: 53699315,
        host_name: "Marinella E Stefano",
        latitude: 45.43526,
        longitude: 12.33712,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33712, 45.43526]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16457977,
        name: "PIGI HOME  nuovissimo e appena restaurato",
        host_id: 107972652,
        host_name: "Pierluigi",
        latitude: 45.44682,
        longitude: 12.32787,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32787, 45.44682]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16461725,
        name: "Super view from romantic flat! ( Biennale area)",
        host_id: 11876634,
        host_name: "Lucia E Riccardo",
        latitude: 45.43373,
        longitude: 12.35249,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35249, 45.43373]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16462344,
        name: "Suite Canal View on Historical Palace 202",
        host_id: 108009371,
        host_name: "Deny",
        latitude: 45.44049,
        longitude: 12.33739,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33739, 45.44049]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16464231,
        name: "Suite Canal View on Historical Palace 205",
        host_id: 108009371,
        host_name: "Deny",
        latitude: 45.43965,
        longitude: 12.33615,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33615, 45.43965]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16472433,
        name: "San Polo Cozy Apartment",
        host_id: 108108295,
        host_name: "Nicola",
        latitude: 45.43717,
        longitude: 12.32601,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32601, 45.43717]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16472578,
        name: "Lovely room in elegant Palace with Canal view",
        host_id: 4181403,
        host_name: "Sara",
        latitude: 45.44284,
        longitude: 12.32555,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32555, 45.44284]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16484438,
        name: "Ca' Della Bottega with private Roof Terrace",
        host_id: 669047,
        host_name: "Viewsonvenice",
        latitude: 45.43335,
        longitude: 12.32427,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32427, 45.43335]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16486029,
        name: "View of Rialto Bridge and Grand Canal",
        host_id: 108244840,
        host_name: "Michela",
        latitude: 45.43894,
        longitude: 12.33566,
        beds: 8,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33566, 45.43894]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16487231,
        name: "Elegant apt - roof City view - elevator",
        host_id: 6019189,
        host_name: "Federico",
        latitude: 45.43304,
        longitude: 12.32368,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32368, 45.43304]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16495593,
        name: "Loft in Campo Santa Margherita.",
        host_id: 108340138,
        host_name: "Claudio",
        latitude: 45.43481,
        longitude: 12.32344,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32344, 45.43481]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16510889,
        name: "WellVenice Campiello",
        host_id: 41898872,
        host_name: "Cristina",
        latitude: 45.43879,
        longitude: 12.33044,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33044, 45.43879]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16511845,
        name: "Lumineux appartement, vue sur canal, terrasse",
        host_id: 34442067,
        host_name: "Béatrice",
        latitude: 45.43358,
        longitude: 12.34974,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34974, 45.43358]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16512433,
        name: "Ca' Passion",
        host_id: 34360885,
        host_name: "Samuel",
        latitude: 45.43766,
        longitude: 12.3262,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3262, 45.43766]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16540222,
        name: "CA' CORTE DELL' ALBERO Free wifi near San Marco",
        host_id: 3736168,
        host_name: "EasyRentals",
        latitude: 45.43389,
        longitude: 12.33033,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33033, 45.43389]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16541087,
        name: "Ca' Badoer - West Studio",
        host_id: 108848739,
        host_name: "Frari 2000 S.A.S.",
        latitude: 45.43849,
        longitude: 12.32736,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32736, 45.43849]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16541260,
        name: "Stanza privata nel cuore di Venezia",
        host_id: 10356311,
        host_name: "Giovanna",
        latitude: 45.43982,
        longitude: 12.33718,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33718, 45.43982]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16542615,
        name: "Stupendo appartamento con vista sul canale",
        host_id: 43777105,
        host_name: "Gian  Ruggero",
        latitude: 45.44175,
        longitude: 12.33314,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33314, 45.44175]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16543917,
        name: "THE ONLY VENICE AIRBNB WITH BOAT TOUR CANAL VIEW",
        host_id: 12437976,
        host_name: "Maria",
        latitude: 45.44158,
        longitude: 12.33787,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33787, 45.44158]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16551579,
        name: "Alloggi Bareteri & Allegri's - WAITING XMAS",
        host_id: 97908044,
        host_name: "Luca",
        latitude: 45.43616,
        longitude: 12.3369,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3369, 45.43616]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16568136,
        name: "Romantic attic with terrace and view of the canal",
        host_id: 109140798,
        host_name: "Laura",
        latitude: 45.43937,
        longitude: 12.32789,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32789, 45.43937]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16568871,
        name: "New relaxing private ensuite room.",
        host_id: 8865074,
        host_name: "Valerie",
        latitude: 45.44092,
        longitude: 12.34014,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34014, 45.44092]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16569455,
        name: "2 pax new charming apartment.",
        host_id: 8865074,
        host_name: "Valerie",
        latitude: 45.44282,
        longitude: 12.33982,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33982, 45.44282]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16574582,
        name: "Ca' Badoer - Attic",
        host_id: 108848739,
        host_name: "Frari 2000 S.A.S.",
        latitude: 45.4384,
        longitude: 12.32544,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32544, 45.4384]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16575767,
        name: "Nice apartment with balcony close to Piazzale Roma",
        host_id: 1779475,
        host_name: "Elisa",
        latitude: 45.43623,
        longitude: 12.32148,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32148, 45.43623]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16577106,
        name: "Ca' Badoer - Frari",
        host_id: 108848739,
        host_name: "Frari 2000 S.A.S.",
        latitude: 45.43733,
        longitude: 12.32687,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32687, 45.43733]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16591384,
        name: "Ca' Elisa a San Marco M (Phone number hidden by Airbnb)",
        host_id: 22319440,
        host_name: "Geremia",
        latitude: 45.4347,
        longitude: 12.33739,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33739, 45.4347]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16594491,
        name: "Topazio : two-room flat near Rialto",
        host_id: 289615,
        host_name: "Valentina",
        latitude: 45.44065,
        longitude: 12.34103,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34103, 45.44065]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16595531,
        name: "Penthouse 10 minutes from Rialto and San Marco!",
        host_id: 289615,
        host_name: "Valentina",
        latitude: 45.44012,
        longitude: 12.33943,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33943, 45.44012]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16597558,
        name: "Ca' Morandi",
        host_id: 109483069,
        host_name: "Nicoletta",
        latitude: 45.44213,
        longitude: 12.33939,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33939, 45.44213]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16597656,
        name: "Home in Cannaregio",
        host_id: 17433943,
        host_name: "Giorgi",
        latitude: 45.44631,
        longitude: 12.32247,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32247, 45.44631]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16606262,
        name:
          "CENTRAL APARTMENT  IN RIALTO    cod:M (Phone number hidden by Airbnb)",
        host_id: 62523490,
        host_name: "Martina",
        latitude: 45.43881,
        longitude: 12.33331,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33331, 45.43881]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16607803,
        name: "MyPlace Rialto Family Apartment",
        host_id: 26102869,
        host_name: "My Sweetplace S.R.L.",
        latitude: 45.43774,
        longitude: 12.33708,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33708, 45.43774]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16613373,
        name: "Rialto superior apartment",
        host_id: 26102869,
        host_name: "My Sweetplace S.R.L.",
        latitude: 45.43544,
        longitude: 12.33789,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33789, 45.43544]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16621848,
        name: "Cozy studio in Cannaregio Venezia",
        host_id: 109755918,
        host_name: "Iolanda",
        latitude: 45.44606,
        longitude: 12.32095,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32095, 45.44606]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16627418,
        name: "Cozy Apartment in Venice",
        host_id: 1564813,
        host_name: "Caterina",
        latitude: 45.43425,
        longitude: 12.33062,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33062, 45.43425]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16633694,
        name: "Three Floors of Perfection with Private Garden",
        host_id: 2196999,
        host_name: "Barbara",
        latitude: 45.43467,
        longitude: 12.32443,
        beds: 10,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32443, 45.43467]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16670683,
        name: "Cà Perdon",
        host_id: 39240019,
        host_name: "Marcello",
        latitude: 45.43746,
        longitude: 12.33148,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33148, 45.43746]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16670834,
        name: "Cozy apartment next to San Marco Square",
        host_id: 109833643,
        host_name: "Nico",
        latitude: 45.43607,
        longitude: 12.34285,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34285, 45.43607]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16687379,
        name: "Cozy studio with terrace - Guglie",
        host_id: 4791745,
        host_name: "Matteo",
        latitude: 45.44378,
        longitude: 12.32441,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32441, 45.44378]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16696537,
        name: "Preziosa 15: a few minutes from Rialto and S.Marco",
        host_id: 289615,
        host_name: "Valentina",
        latitude: 45.4404,
        longitude: 12.3389,
        beds: 8,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3389, 45.4404]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16699871,
        name: "Ve-nice loft Orietta",
        host_id: 110618214,
        host_name: "Orietta",
        latitude: 45.42523,
        longitude: 12.3384,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3384, 45.42523]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16700069,
        name: "Cosy room in centar",
        host_id: 110620261,
        host_name: "Bib",
        latitude: 45.43902,
        longitude: 12.32901,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32901, 45.43902]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16707006,
        name: "Venetian MOOD: Petite",
        host_id: 3549494,
        host_name: "Manuela",
        latitude: 45.42334,
        longitude: 12.3299,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3299, 45.42334]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16707012,
        name: "Room sea view Harry's",
        host_id: 23182155,
        host_name: "Stefano Roberta",
        latitude: 45.44367,
        longitude: 12.33733,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33733, 45.44367]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16713472,
        name: "PREZIOSA 12 - 3 apartments in a lovely area",
        host_id: 289615,
        host_name: "Valentina",
        latitude: 45.4399,
        longitude: 12.33985,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33985, 45.4399]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16717135,
        name: "CONTARINI",
        host_id: 15337957,
        host_name: "Marie",
        latitude: 45.43056,
        longitude: 12.33027,
        beds: 10,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33027, 45.43056]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16720845,
        name: "truly venetian atmosphere with 360° view",
        host_id: 4121339,
        host_name: "Olivia",
        latitude: 45.44089,
        longitude: 12.32415,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32415, 45.44089]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16730201,
        name: "PALAZZO CONTARINI 20 PERSONNES",
        host_id: 15337957,
        host_name: "Marie",
        latitude: 45.43143,
        longitude: 12.32808,
        beds: 16,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32808, 45.43143]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16730931,
        name: "Central apartment close to La Fenice Theatre",
        host_id: 110931856,
        host_name: "Erika",
        latitude: 45.4321,
        longitude: 12.33283,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33283, 45.4321]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16753930,
        name: "My Friend, Venice Canal View 2",
        host_id: 13027859,
        host_name: "Diego",
        latitude: 45.44606,
        longitude: 12.32072,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32072, 45.44606]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16754245,
        name: "My Friends Canal View Lux",
        host_id: 13027859,
        host_name: "Diego",
        latitude: 45.44689,
        longitude: 12.31893,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31893, 45.44689]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16754568,
        name: "Family Canal View",
        host_id: 13027859,
        host_name: "Diego",
        latitude: 45.4471,
        longitude: 12.31914,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31914, 45.4471]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16758413,
        name: "Pineta",
        host_id: 106031055,
        host_name: "Paolo",
        latitude: 45.43158,
        longitude: 12.35846,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35846, 45.43158]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16760743,
        name: "CaMoma - Apartment in Venice",
        host_id: 111100951,
        host_name: "Jacopo",
        latitude: 45.43565,
        longitude: 12.31952,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31952, 45.43565]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16774862,
        name: "SAN SALVADOR APARTMENT",
        host_id: 94804416,
        host_name: "Chiara",
        latitude: 45.43617,
        longitude: 12.33622,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33622, 45.43617]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16776085,
        name: "Cozy small green flat with double and single room",
        host_id: 45066209,
        host_name: "Flavio E Moira",
        latitude: 45.4413,
        longitude: 12.32878,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32878, 45.4413]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16788717,
        name: "RELAXING AND BRIGHT HOME IN DOWNTOWN",
        host_id: 3880254,
        host_name: "Sabina",
        latitude: 45.43238,
        longitude: 12.31933,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31933, 45.43238]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16789967,
        name: "Venezia Biennale via Garibaldi",
        host_id: 86844339,
        host_name: "Alessandro",
        latitude: 45.4339,
        longitude: 12.35603,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35603, 45.4339]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16800381,
        name: "Delizia 2",
        host_id: 71974434,
        host_name: "Yendy",
        latitude: 45.44322,
        longitude: 12.32728,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32728, 45.44322]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16801812,
        name: "Single cozy  Room",
        host_id: 71974434,
        host_name: "Yendy",
        latitude: 45.44387,
        longitude: 12.32698,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32698, 45.44387]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16804031,
        name: "Venice, Biennial area, double bedroom",
        host_id: 18629582,
        host_name: "Luigi",
        latitude: 45.43379,
        longitude: 12.3515,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3515, 45.43379]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16805551,
        name: "cozy room in the heart of Venice-the smiling house",
        host_id: 22872469,
        host_name: "Marzia",
        latitude: 45.43305,
        longitude: 12.3166,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3166, 45.43305]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16807862,
        name: "Happy Venice - Sun and Art",
        host_id: 111770011,
        host_name: "Mauro",
        latitude: 45.43332,
        longitude: 12.35678,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35678, 45.43332]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16808630,
        name: "San Rocco - Huge Single Room - Canal view",
        host_id: 25085773,
        host_name: "Gin",
        latitude: 45.4371,
        longitude: 12.32324,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32324, 45.4371]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16820471,
        name: "Mimosa peaceful apartment with canal view",
        host_id: 27081641,
        host_name: "Irene",
        latitude: 45.4321,
        longitude: 12.32243,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32243, 45.4321]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16833338,
        name: "Appartamento San Giacomo dell'Orio",
        host_id: 111892741,
        host_name: "Massimo",
        latitude: 45.43943,
        longitude: 12.32945,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32945, 45.43943]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16835761,
        name: "The Smiling House",
        host_id: 22872469,
        host_name: "Marzia",
        latitude: 45.43428,
        longitude: 12.31701,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31701, 45.43428]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16848003,
        name: "Casa Gorne Anzolo",
        host_id: 112195559,
        host_name: "Alfio",
        latitude: 45.43658,
        longitude: 12.35016,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35016, 45.43658]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16852483,
        name: "At Canal Grande, bedroom in a palazzo near Rialto",
        host_id: 12748931,
        host_name: "Jacques",
        latitude: 45.43514,
        longitude: 12.33116,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33116, 45.43514]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16863144,
        name: "Ca'Loredan",
        host_id: 60488055,
        host_name: "Marco & Andrea",
        latitude: 45.44532,
        longitude: 12.33122,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33122, 45.44532]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16866964,
        name: "Dave's House, your love nest near Biennale",
        host_id: 112384231,
        host_name: "Cristina",
        latitude: 45.43043,
        longitude: 12.359,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.359, 45.43043]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16867095,
        name: "Tripla al Grey's",
        host_id: 23182155,
        host_name: "Stefano Roberta",
        latitude: 45.4415,
        longitude: 12.3364,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3364, 45.4415]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16867735,
        name: "Camera Doppia al Grey's",
        host_id: 23182155,
        host_name: "Stefano Roberta",
        latitude: 45.44181,
        longitude: 12.33825,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33825, 45.44181]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16868069,
        name: "Monolocale al Grey's",
        host_id: 23182155,
        host_name: "Stefano Roberta",
        latitude: 45.43968,
        longitude: 12.33811,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33811, 45.43968]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16887568,
        name: "Ca' Veronese - Casa dei Pittori",
        host_id: 1384217,
        host_name: "Simone - Francesco",
        latitude: 45.4404,
        longitude: 12.32693,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32693, 45.4404]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16888777,
        name: "View a Centuries-Old Courtyard from a Private Palace Window",
        host_id: 95234458,
        host_name: "Lucia",
        latitude: 45.44003,
        longitude: 12.32978,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32978, 45.44003]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16892109,
        name: "b&b da NINA VENICE, room only, for adult only.",
        host_id: 112696939,
        host_name: "Martina",
        latitude: 45.43847,
        longitude: 12.32156,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32156, 45.43847]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16893897,
        name: "casa biennale",
        host_id: 3237142,
        host_name: "Marta",
        latitude: 45.43156,
        longitude: 12.35599,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35599, 45.43156]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16903225,
        name: '"Conterie Blu" terrace & elegance next to Biennale',
        host_id: 112826559,
        host_name: "Janet",
        latitude: 45.43548,
        longitude: 12.35801,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35801, 45.43548]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16906182,
        name: "Modern and comfortable in the heart of Venice",
        host_id: 60463275,
        host_name: "Marco",
        latitude: 45.44499,
        longitude: 12.33297,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33297, 45.44499]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16907022,
        name: "Ca' Tiziano - Casa dei Pittori",
        host_id: 1384217,
        host_name: "Simone - Francesco",
        latitude: 45.44013,
        longitude: 12.32641,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32641, 45.44013]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16913004,
        name: "Conterie Rosse peace and comfort close to Biennale",
        host_id: 112826559,
        host_name: "Janet",
        latitude: 45.43386,
        longitude: 12.35683,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35683, 45.43386]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16913103,
        name: "CORTE EMO 1",
        host_id: 112925089,
        host_name: "Luisa",
        latitude: 45.44413,
        longitude: 12.32522,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32522, 45.44413]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16913356,
        name: "CORTE EMO 2",
        host_id: 112925089,
        host_name: "Luisa",
        latitude: 45.44417,
        longitude: 12.32758,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32758, 45.44417]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16913810,
        name: "SANTA CROCE",
        host_id: 112930207,
        host_name: "Ruggiero",
        latitude: 45.44081,
        longitude: 12.32614,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32614, 45.44081]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16920968,
        name: "Dominika's House",
        host_id: 1490179,
        host_name: "Laura",
        latitude: 45.44004,
        longitude: 12.33225,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33225, 45.44004]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16921613,
        name: "APPARTAMENTO PER FAMIGLIE CON  VISTA SUL CANALE",
        host_id: 113019812,
        host_name: "Serena",
        latitude: 45.42469,
        longitude: 12.32734,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32734, 45.42469]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16925173,
        name: "Charming bijoux apartment in the heart of Venice",
        host_id: 112088465,
        host_name: "Alice & Michele",
        latitude: 45.43188,
        longitude: 12.35388,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35388, 45.43188]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16934980,
        name: "Venetian antique family palace  San Marco Rialto",
        host_id: 113165530,
        host_name: "Patrizia",
        latitude: 45.43974,
        longitude: 12.34111,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34111, 45.43974]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16938998,
        name: "La Casetta di Venezia",
        host_id: 113209596,
        host_name: "Laura",
        latitude: 45.44677,
        longitude: 12.31986,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31986, 45.44677]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16939384,
        name: "Dimora Giorgione - Casa dei Pittori",
        host_id: 1384217,
        host_name: "Simone - Francesco",
        latitude: 45.44043,
        longitude: 12.3275,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3275, 45.44043]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16943590,
        name: "Ca' Tintor - to discover art and nature in Venice",
        host_id: 113038014,
        host_name: "Francesca",
        latitude: 45.43261,
        longitude: 12.31963,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31963, 45.43261]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16944320,
        name: "Sweet Apartment",
        host_id: 113265814,
        host_name: "Marco",
        latitude: 45.43558,
        longitude: 12.3309,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3309, 45.43558]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16960419,
        name: "Garden in Venice Biennale",
        host_id: 113405578,
        host_name: "Loredana",
        latitude: 45.43311,
        longitude: 12.35023,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35023, 45.43311]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16969220,
        name: "In one of the most beautiful Venetian palaces",
        host_id: 4188070,
        host_name: "Olivier",
        latitude: 45.43983,
        longitude: 12.33239,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33239, 45.43983]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16970805,
        name: "Gondolier's home in center- 2 bedrooms and terrace",
        host_id: 46904188,
        host_name: "Mirco Optyflat",
        latitude: 45.43669,
        longitude: 12.3468,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3468, 45.43669]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16971031,
        name: "Corte dei Pensieri",
        host_id: 46361691,
        host_name: "Irene",
        latitude: 45.43509,
        longitude: 12.31813,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31813, 45.43509]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16978852,
        name: '"La corte di San Marco"',
        host_id: 11955166,
        host_name: "Jenny",
        latitude: 45.43685,
        longitude: 12.34267,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34267, 45.43685]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16984763,
        name: ".Appartamento Arlecchino vicino chiesa Miracoli",
        host_id: 113703606,
        host_name: "Chiara",
        latitude: 45.43736,
        longitude: 12.33943,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33943, 45.43736]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16985478,
        name: "MODERN SWEET HOME GIUDECCA",
        host_id: 110862404,
        host_name: "Alvise & Adriana",
        latitude: 45.426,
        longitude: 12.32553,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32553, 45.426]] },
    },
    {
      type: "Feature",
      properties: {
        id: 16994018,
        name: "Appartamento Ormesini",
        host_id: 51324480,
        host_name: "Laura",
        latitude: 45.44524,
        longitude: 12.32797,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32797, 45.44524]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17003338,
        name: "Appartamento Colombina vicino Chiesa Miracoli",
        host_id: 113703606,
        host_name: "Chiara",
        latitude: 45.43692,
        longitude: 12.33913,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33913, 45.43692]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17003368,
        name: "Alloggi Allegri  - UNDERWATER Venice 2019",
        host_id: 97908044,
        host_name: "Luca",
        latitude: 45.43593,
        longitude: 12.33682,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33682, 45.43593]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17003506,
        name: "Pantalone Apartment near the Miracoli Church",
        host_id: 113703606,
        host_name: "Chiara",
        latitude: 45.43728,
        longitude: 12.33898,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33898, 45.43728]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17005741,
        name: "Ca' Serenissima : 3 bedrooms/3 bathrooms-Castello",
        host_id: 289615,
        host_name: "Valentina",
        latitude: 45.44022,
        longitude: 12.34076,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34076, 45.44022]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17006593,
        name: "Studio 990",
        host_id: 113998273,
        host_name: "Silvana",
        latitude: 45.44584,
        longitude: 12.32325,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32325, 45.44584]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17007565,
        name: "LA CASETTA VENEZIANA",
        host_id: 108108295,
        host_name: "Nicola",
        latitude: 45.44063,
        longitude: 12.34102,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34102, 45.44063]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17010607,
        name: "Samuele lovely apartment",
        host_id: 5240699,
        host_name: "Serena",
        latitude: 45.4341,
        longitude: 12.32875,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32875, 45.4341]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17010978,
        name: "CANAL VIEW APARTMENT",
        host_id: 38346442,
        host_name: "Giancarlo",
        latitude: 45.44025,
        longitude: 12.34085,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34085, 45.44025]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17022029,
        name: 'Garibaldi apartment with private "corte"',
        host_id: 114163769,
        host_name: "Maurizio",
        latitude: 45.43259,
        longitude: 12.35198,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35198, 45.43259]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17022104,
        name: "Luxury Ponte delle Guglie",
        host_id: 46528252,
        host_name: "Alex",
        latitude: 45.44433,
        longitude: 12.32519,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32519, 45.44433]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17026029,
        name: "Venice Centre Few Steps From San Marco Square",
        host_id: 114204751,
        host_name: "Sante Isabella Amadio",
        latitude: 45.43638,
        longitude: 12.33551,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33551, 45.43638]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17040744,
        name: "CA ZIZA",
        host_id: 6759756,
        host_name: "Rudi",
        latitude: 45.44422,
        longitude: 12.32306,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32306, 45.44422]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17040963,
        name: "SUITE ORMESINI",
        host_id: 51324480,
        host_name: "Laura",
        latitude: 45.44545,
        longitude: 12.32827,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32827, 45.44545]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17049214,
        name: "Agata classy apartment",
        host_id: 29735190,
        host_name: "Michele",
        latitude: 45.43189,
        longitude: 12.33273,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33273, 45.43189]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17073806,
        name: "VeniceVillas Orto Luxury Apartment",
        host_id: 294951,
        host_name: "VeniceVillas Di Enzo",
        latitude: 45.44681,
        longitude: 12.33185,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33185, 45.44681]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17074337,
        name: "Ramo delle Moschette",
        host_id: 114446136,
        host_name: "Diana",
        latitude: 45.43989,
        longitude: 12.34406,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34406, 45.43989]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17081780,
        name: "elegant apartment tron",
        host_id: 114621580,
        host_name: "Lorenza",
        latitude: 45.43809,
        longitude: 12.33049,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33049, 45.43809]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17083555,
        name: "Appartamento Intero Ca D’oro ****",
        host_id: 46401656,
        host_name: "Samuele",
        latitude: 45.44192,
        longitude: 12.33538,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33538, 45.44192]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17087414,
        name: "Apartment with interior garden - Ca' Barbaria",
        host_id: 114664320,
        host_name: "Francesco",
        latitude: 45.43987,
        longitude: 12.34355,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34355, 45.43987]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17087686,
        name: "Residence Madame S.Vio canal view & garden",
        host_id: 289615,
        host_name: "Valentina",
        latitude: 45.43001,
        longitude: 12.32865,
        beds: 8,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32865, 45.43001]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17103422,
        name: "Appartamento Rialto - Venezia",
        host_id: 87272071,
        host_name: "Edoardo",
        latitude: 45.438,
        longitude: 12.34037,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34037, 45.438]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17104230,
        name: "San Lorenzo Garden",
        host_id: 113405578,
        host_name: "Loredana",
        latitude: 45.43689,
        longitude: 12.34424,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34424, 45.43689]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17104882,
        name: "Palazzetto San Lio - Affresco",
        host_id: 5530301,
        host_name: "Chiara",
        latitude: 45.43692,
        longitude: 12.33888,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33888, 45.43692]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17112710,
        name: "San Giobbe Apartment",
        host_id: 46904188,
        host_name: "Mirco Optyflat",
        latitude: 45.44436,
        longitude: 12.31999,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31999, 45.44436]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17117601,
        name: "Spacious with stunning views!",
        host_id: 7833708,
        host_name: "Massimo",
        latitude: 45.44825,
        longitude: 12.32612,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32612, 45.44825]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17132127,
        name: "my Venice sweet home",
        host_id: 115156652,
        host_name: "Anna",
        latitude: 45.42579,
        longitude: 12.32753,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32753, 45.42579]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17144987,
        name: '"Marco Polo" Exclusive Apartment',
        host_id: 115278070,
        host_name: "Marilisa",
        latitude: 45.43797,
        longitude: 12.33479,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33479, 45.43797]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17145471,
        name: "Pied-à-terre Calle degli Orbi - San Marco",
        host_id: 115282841,
        host_name: "Luisa",
        latitude: 45.43541,
        longitude: 12.33153,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33153, 45.43541]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17145851,
        name: "DolceVita Apartments N. 373 Terrace",
        host_id: 8176475,
        host_name: "Eugenia",
        latitude: 45.44112,
        longitude: 12.32952,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32952, 45.44112]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17150650,
        name: "Ensuite room with terrace.",
        host_id: 33186747,
        host_name: "Maria Grazia",
        latitude: 45.43586,
        longitude: 12.34271,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34271, 45.43586]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17150866,
        name: "Cà Marta, white modern apartment",
        host_id: 26404861,
        host_name: "Marika",
        latitude: 45.43334,
        longitude: 12.31388,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31388, 45.43334]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17151493,
        name: "CASA MERCA' RIALTO: free wi fi, near Rialto Bridge",
        host_id: 3736168,
        host_name: "EasyRentals",
        latitude: 45.43964,
        longitude: 12.33339,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33339, 45.43964]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17156126,
        name: "RIALTO SAN POLO FLAT IN THE HEART OF VENICE",
        host_id: 114647099,
        host_name: "Luca",
        latitude: 45.43732,
        longitude: 12.32644,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32644, 45.43732]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17164307,
        name:
          "Venice City Biennale Apartment -  M (Phone number hidden by Airbnb)",
        host_id: 7355755,
        host_name: "Sonia",
        latitude: 45.43205,
        longitude: 12.35727,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35727, 45.43205]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17165156,
        name: "San Marco Square With Balcony",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.43581,
        longitude: 12.33541,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33541, 45.43581]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17166304,
        name: "Ramo de la Vida (Campo San Giacomo)",
        host_id: 33708852,
        host_name: "Pietro E Francesco",
        latitude: 45.44077,
        longitude: 12.32663,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32663, 45.44077]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17167135,
        name: "Apartment next to  Rialto  Bridge, Venice",
        host_id: 288785,
        host_name: "Nicola",
        latitude: 45.4405,
        longitude: 12.32927,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32927, 45.4405]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17169152,
        name: "Junior Suite Attic",
        host_id: 25493749,
        host_name: "Laura",
        latitude: 45.44119,
        longitude: 12.32548,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32548, 45.44119]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17175856,
        name: "Lovely Loft in Adorable Dorsoduro",
        host_id: 89512390,
        host_name: "G&T",
        latitude: 45.42989,
        longitude: 12.32696,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32696, 45.42989]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17181010,
        name: "ELEGANT AND WIDE FLAT 5 MIN FROM THE TRAIN STATION",
        host_id: 16838381,
        host_name: "Arianna",
        latitude: 45.44486,
        longitude: 12.32372,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32372, 45.44486]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17181682,
        name: "Ca'Pozzo INN 1- Standard room",
        host_id: 115621013,
        host_name: "Nicola",
        latitude: 45.44341,
        longitude: 12.32474,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32474, 45.44341]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17183316,
        name: "The Golden Tree, apartment in Venice",
        host_id: 73332618,
        host_name: "Giacomo",
        latitude: 45.43132,
        longitude: 12.35425,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35425, 45.43132]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17184483,
        name: "B&b Vista sul Canal Grande Junior suite Canale",
        host_id: 25493749,
        host_name: "Laura",
        latitude: 45.44125,
        longitude: 12.32534,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32534, 45.44125]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17184886,
        name: "Vintage Romantik Venice Room Blue",
        host_id: 105682164,
        host_name: "Adelina",
        latitude: 45.44,
        longitude: 12.33588,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33588, 45.44]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17185336,
        name: "Garden Room",
        host_id: 25493749,
        host_name: "Laura",
        latitude: 45.44141,
        longitude: 12.3258,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3258, 45.44141]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17209013,
        name: "La Casa de Gio",
        host_id: 115824727,
        host_name: "Giomara & Roberto",
        latitude: 45.43974,
        longitude: 12.34562,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34562, 45.43974]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17210624,
        name: "Casa Cavana",
        host_id: 115839316,
        host_name: "Alberto",
        latitude: 45.43491,
        longitude: 12.3239,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3239, 45.43491]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17217098,
        name: "San Marco top Floor",
        host_id: 115913231,
        host_name: "Patrizia",
        latitude: 45.43692,
        longitude: 12.33513,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33513, 45.43692]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17217913,
        name: "VENICE STATION TERRACE",
        host_id: 115921457,
        host_name: "Giovanni",
        latitude: 45.44294,
        longitude: 12.32765,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32765, 45.44294]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17218506,
        name: "DolceVita Apartments N. 372 3 Bedrooms",
        host_id: 8176475,
        host_name: "Eugenia",
        latitude: 45.44084,
        longitude: 12.32998,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32998, 45.44084]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17219413,
        name: "Ca'Fontana 10 min away from PIazza San Marco !!",
        host_id: 115938126,
        host_name: "Mariangela",
        latitude: 45.43488,
        longitude: 12.34878,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34878, 45.43488]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17221039,
        name: "Central mini apartment with garden",
        host_id: 115629152,
        host_name: "Luciano",
        latitude: 45.44483,
        longitude: 12.33353,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33353, 45.44483]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17221992,
        name: '"Eius house" bright two-room at the first floor',
        host_id: 115965397,
        host_name: "Luisa",
        latitude: 45.44091,
        longitude: 12.3267,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3267, 45.44091]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17235172,
        name: "Betta Bondavalli",
        host_id: 116081649,
        host_name: "Betta",
        latitude: 45.43359,
        longitude: 12.31696,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31696, 45.43359]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17242924,
        name: "Long stay, only for excellent references",
        host_id: 688823,
        host_name: "Franco",
        latitude: 45.43707,
        longitude: 12.33826,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33826, 45.43707]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17243220,
        name: "Cannaregio Canal Luxury Apartment",
        host_id: 9173107,
        host_name: "Vedran",
        latitude: 45.44608,
        longitude: 12.32214,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32214, 45.44608]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17244552,
        name:
          "Residenza Giorgio - Canal View (L.T. M (Phone number hidden by Airbnb)",
        host_id: 5618111,
        host_name: "EasySuite",
        latitude: 45.42779,
        longitude: 12.31878,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31878, 45.42779]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17244840,
        name:
          "Hideaway Biennale - Lagoon View (L.T. M (Phone number hidden by Airbnb)",
        host_id: 5618111,
        host_name: "EasySuite",
        latitude: 45.42972,
        longitude: 12.35572,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35572, 45.42972]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17244850,
        name: "MyPlace Campo Santa Margherita Family Deluxe",
        host_id: 26102869,
        host_name: "My Sweetplace S.R.L.",
        latitude: 45.43416,
        longitude: 12.32685,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32685, 45.43416]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17247416,
        name: "STUNNING MODERN APARTMENT IN THE HEART OF VENICE",
        host_id: 5862083,
        host_name: "Silvia",
        latitude: 45.43178,
        longitude: 12.33222,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33222, 45.43178]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17249195,
        name: "Casa Ghezzi in the heart of Venice.",
        host_id: 12386290,
        host_name: "Louise",
        latitude: 45.43635,
        longitude: 12.34107,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34107, 45.43635]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17250746,
        name: "Cosy Nest Apartment in authentic area of Venice",
        host_id: 116251879,
        host_name: "Marco",
        latitude: 45.44518,
        longitude: 12.32824,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32824, 45.44518]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17252516,
        name: '"Ca Del Doge Bo"',
        host_id: 116270768,
        host_name: "Vanessa",
        latitude: 45.44414,
        longitude: 12.32844,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32844, 45.44414]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17259535,
        name: "DolceVita Apartments 372/373 Terrace",
        host_id: 8176475,
        host_name: "Eugenia",
        latitude: 45.43889,
        longitude: 12.32767,
        beds: 7,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32767, 45.43889]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17260704,
        name: "MyPlace Campo Santa Margherita Hydrorelaxing",
        host_id: 26102869,
        host_name: "My Sweetplace S.R.L.",
        latitude: 45.43403,
        longitude: 12.3256,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3256, 45.43403]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17264709,
        name: "MyPlace Campo S. Margherita Family Private Terrace",
        host_id: 26102869,
        host_name: "My Sweetplace S.R.L.",
        latitude: 45.43432,
        longitude: 12.32621,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32621, 45.43432]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17265549,
        name:
          "Corte Nova Apartment-Biennale, S.Marco M (Phone number hidden by Airbnb)",
        host_id: 4654704,
        host_name: "Nicola",
        latitude: 45.43754,
        longitude: 12.34636,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34636, 45.43754]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17274362,
        name: "BIENNALE & S. MARK ideal apt, 2+2, Clim",
        host_id: 116487780,
        host_name: "Federica",
        latitude: 45.43525,
        longitude: 12.34473,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34473, 45.43525]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17275936,
        name: "Dream on the Lagoon with view on the Grand Canal",
        host_id: 116502017,
        host_name: "Chiara",
        latitude: 45.44178,
        longitude: 12.32639,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32639, 45.44178]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17277175,
        name: "LUPO DI MARE APARTMENT",
        host_id: 14357135,
        host_name: "Rent It Venice",
        latitude: 45.42784,
        longitude: 12.36165,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.36165, 45.42784]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17297524,
        name: "Di Gianfranco Piano Nobile con Vista Canale",
        host_id: 46914920,
        host_name: "Andrea",
        latitude: 45.44795,
        longitude: 12.32311,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32311, 45.44795]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17312785,
        name: "Giudecca Suite Overlooking Canal",
        host_id: 78302307,
        host_name: "Lloyd",
        latitude: 45.42794,
        longitude: 12.31865,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31865, 45.42794]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17315548,
        name: "Venice Martina's Room with shared bathroom",
        host_id: 13027859,
        host_name: "Diego",
        latitude: 45.43812,
        longitude: 12.32843,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32843, 45.43812]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17315638,
        name: "Venice Martina's Room II with shared bathroom",
        host_id: 13027859,
        host_name: "Diego",
        latitude: 45.43781,
        longitude: 12.32991,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32991, 45.43781]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17315700,
        name: "Venice Martina's Room with shared bathroom",
        host_id: 13027859,
        host_name: "Diego",
        latitude: 45.43655,
        longitude: 12.33059,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33059, 45.43655]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17324091,
        name: "Rialto Market- Art Apartments Venice",
        host_id: 28162920,
        host_name: "Beatriz",
        latitude: 45.44128,
        longitude: 12.33163,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33163, 45.44128]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17325623,
        name: "CASA BARACCO, apartment LUCIA, DORSODURO",
        host_id: 25235283,
        host_name: "Ugo",
        latitude: 45.43416,
        longitude: 12.32585,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32585, 45.43416]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17325715,
        name: "RESIDENZA MIRACOLI Apartment, close to Rialto",
        host_id: 116955389,
        host_name: "Tiziana",
        latitude: 45.4385,
        longitude: 12.33765,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33765, 45.4385]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17328515,
        name: "Fenice apartment elegant and classic style",
        host_id: 116984120,
        host_name: "Andreas",
        latitude: 45.43394,
        longitude: 12.33454,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33454, 45.43394]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17335313,
        name: "RIALTO few steps to CANAL GRANDE",
        host_id: 117064979,
        host_name: "Santa",
        latitude: 45.44022,
        longitude: 12.33117,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33117, 45.44022]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17337414,
        name: "Perfect for EXCURSION TO THE ISLANDS",
        host_id: 117064979,
        host_name: "Santa",
        latitude: 45.44291,
        longitude: 12.34024,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34024, 45.44291]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17372401,
        name: "MyPlace Campo Santa Margherita Family Apartment",
        host_id: 26102869,
        host_name: "My Sweetplace S.R.L.",
        latitude: 45.43382,
        longitude: 12.3262,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3262, 45.43382]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17373650,
        name: "Goodwind apartment: beautiful apartment in Venice",
        host_id: 117409195,
        host_name: "Pietro",
        latitude: 45.44206,
        longitude: 12.3342,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3342, 45.44206]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17379452,
        name: "VENICE - SENSA APARTMENT",
        host_id: 5405444,
        host_name: "Flavia",
        latitude: 45.44694,
        longitude: 12.32872,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32872, 45.44694]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17392649,
        name: "Central and romantic Venice Apartment",
        host_id: 9712358,
        host_name: "Eleonora",
        latitude: 45.43393,
        longitude: 12.32938,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32938, 45.43393]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17395156,
        name: "Ca Etta - Venice Historical Center",
        host_id: 46904188,
        host_name: "Mirco Optyflat",
        latitude: 45.43691,
        longitude: 12.32514,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32514, 45.43691]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17400411,
        name: "Biennale Terrace (Venice Historical Centre)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.43445,
        longitude: 12.35001,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35001, 45.43445]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17400683,
        name: "MyPlace Campo Santa Margherita Family Loft",
        host_id: 26102869,
        host_name: "My Sweetplace S.R.L.",
        latitude: 45.43552,
        longitude: 12.32637,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32637, 45.43552]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17400931,
        name: "SAN PROVOLO luxury apartment by Saint Mark's",
        host_id: 1438903,
        host_name: "Barbara",
        latitude: 45.43402,
        longitude: 12.34125,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34125, 45.43402]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17415708,
        name: "Venezia centro con corte privata",
        host_id: 66605265,
        host_name: "Novella",
        latitude: 45.4427,
        longitude: 12.32438,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32438, 45.4427]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17417725,
        name: "ca' greco casa su 2 piani calle del terco 351",
        host_id: 95408804,
        host_name: "Alessandra",
        latitude: 45.43552,
        longitude: 12.35824,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35824, 45.43552]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17418076,
        name: "Penthouse: 2 min to the Train Station & free wifi",
        host_id: 41699367,
        host_name: "Silvia Carlo",
        latitude: 45.44243,
        longitude: 12.32243,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32243, 45.44243]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17439410,
        name: '"Charming Venetian House"',
        host_id: 102000995,
        host_name: "Stefano",
        latitude: 45.43401,
        longitude: 12.32925,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32925, 45.43401]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17451743,
        name: "Mezzanino Canal Grande",
        host_id: 31385645,
        host_name: "Massimo",
        latitude: 45.43049,
        longitude: 12.33182,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33182, 45.43049]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17470380,
        name: "★ Spacious and bright - perfect for Biennale",
        host_id: 6040471,
        host_name: "Marina",
        latitude: 45.43216,
        longitude: 12.35549,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35549, 45.43216]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17471612,
        name: "Gondola flat in giardini Tosi 1",
        host_id: 48092742,
        host_name: "Roby",
        latitude: 45.43244,
        longitude: 12.35692,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35692, 45.43244]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17474060,
        name: "Romance& Charm, Bright w/ Private Garden, Central",
        host_id: 4290359,
        host_name: "Hélène",
        latitude: 45.44011,
        longitude: 12.33048,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33048, 45.44011]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17487293,
        name: "BIANCO 3 Apartment Open space  near BIENNALE",
        host_id: 73508332,
        host_name: "Claudia",
        latitude: 45.43266,
        longitude: 12.35737,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35737, 45.43266]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17496200,
        name: "Giudecca Cozy Apartment | Zuecca",
        host_id: 117595031,
        host_name: "Alessandro",
        latitude: 45.42499,
        longitude: 12.33812,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33812, 45.42499]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17496316,
        name: "Balcony Apt-lovely View ( 2 rooms - 2 bathrooms )",
        host_id: 118563520,
        host_name: "Mario",
        latitude: 45.43322,
        longitude: 12.35232,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35232, 45.43322]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17504782,
        name: "Suite al Mercato di Rialto",
        host_id: 114802002,
        host_name: "Golden Pillow",
        latitude: 45.43837,
        longitude: 12.33259,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33259, 45.43837]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17506070,
        name: "Santa Margherita Ground Floor",
        host_id: 22940319,
        host_name: "Albatroservices",
        latitude: 45.43492,
        longitude: 12.32557,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32557, 45.43492]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17509360,
        name: "Double Room in Venice Heart City Center",
        host_id: 118683310,
        host_name: "Elisa Sara",
        latitude: 45.43972,
        longitude: 12.33838,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33838, 45.43972]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17509528,
        name: "Apple House Rialto, appartamento",
        host_id: 118684575,
        host_name: "Melania",
        latitude: 45.43957,
        longitude: 12.3326,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3326, 45.43957]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17509710,
        name: "Double room in Venice City Center",
        host_id: 118683310,
        host_name: "Elisa Sara",
        latitude: 45.43953,
        longitude: 12.34073,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34073, 45.43953]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17510266,
        name: "Comfortable Arsenale Private Room for 3",
        host_id: 63084631,
        host_name: "Annette And Emma",
        latitude: 45.4366,
        longitude: 12.34747,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34747, 45.4366]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17510303,
        name: "Triple Room in Venice City Center",
        host_id: 118683310,
        host_name: "Elisa Sara",
        latitude: 45.44012,
        longitude: 12.34037,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34037, 45.44012]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17512179,
        name: "Kalimera",
        host_id: 118711666,
        host_name: "Giuliano",
        latitude: 45.42588,
        longitude: 12.32706,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32706, 45.42588]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17513006,
        name: "Venetian Attitude 2 apartment near Rialto Venice",
        host_id: 15682327,
        host_name: "Cristian",
        latitude: 45.44211,
        longitude: 12.34034,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34034, 45.44211]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17518726,
        name: "Murano Room",
        host_id: 71974434,
        host_name: "Yendy",
        latitude: 45.44426,
        longitude: 12.32565,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32565, 45.44426]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17528540,
        name: "Beautiful aprt in the heart of Venice",
        host_id: 48139727,
        host_name: "Anna",
        latitude: 45.4446,
        longitude: 12.33065,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33065, 45.4446]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17529068,
        name: "Real Venice live in Castello !  3 Wifi",
        host_id: 31276705,
        host_name: "Mila",
        latitude: 45.44444,
        longitude: 12.32762,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32762, 45.44444]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17536688,
        name: "2 bedroom flat with canal view in HEART of VENICE.",
        host_id: 118947505,
        host_name: "Alessa",
        latitude: 45.43661,
        longitude: 12.33456,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33456, 45.43661]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17539017,
        name: "Tre Archi flat",
        host_id: 118965457,
        host_name: "Luca",
        latitude: 45.44254,
        longitude: 12.32046,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32046, 45.44254]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17539698,
        name: "A Venetian Home - canal view - close to terminals",
        host_id: 118962960,
        host_name: "Roberto",
        latitude: 45.43696,
        longitude: 12.32255,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32255, 45.43696]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17548263,
        name: "SAN MARCO ELEGANT & COZY with WIFI, AC, HIDRO",
        host_id: 119066244,
        host_name: "Alessandra",
        latitude: 45.4343,
        longitude: 12.32893,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32893, 45.4343]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17549215,
        name: "Casina del Volto. A few steps from San Marco",
        host_id: 117313043,
        host_name: "Nicola",
        latitude: 45.43848,
        longitude: 12.33846,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33846, 45.43848]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17553080,
        name: "Casa ai Greci: your Venetian home",
        host_id: 31578183,
        host_name: "Riccardo",
        latitude: 45.43584,
        longitude: 12.34453,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34453, 45.43584]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17553690,
        name: "Sottopiano: the safe haven room",
        host_id: 31578183,
        host_name: "Riccardo",
        latitude: 45.43533,
        longitude: 12.34812,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34812, 45.43533]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17554169,
        name: "Canaletto lagoon view apartment",
        host_id: 119126217,
        host_name: "Enrico",
        latitude: 45.42521,
        longitude: 12.3255,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3255, 45.42521]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17556011,
        name: "Forner House",
        host_id: 119139770,
        host_name: "Gino",
        latitude: 45.43758,
        longitude: 12.32596,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32596, 45.43758]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17556374,
        name: "Ca’ Raffa",
        host_id: 119151129,
        host_name: "Raffaele",
        latitude: 45.44207,
        longitude: 12.32755,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32755, 45.44207]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17557031,
        name: "Milonga apartment- Venezia centro",
        host_id: 47828417,
        host_name: "Maddalena",
        latitude: 45.43955,
        longitude: 12.32792,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32792, 45.43955]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17564312,
        name: "***VENEZIA - DORSODURO - CALLE DE CERCHIERI***",
        host_id: 5732682,
        host_name: "Rocco",
        latitude: 45.4322,
        longitude: 12.32604,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32604, 45.4322]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17566689,
        name: "Confortevole e spazioso Ca'del Vento apartment",
        host_id: 499507,
        host_name: "Giulia",
        latitude: 45.43134,
        longitude: 12.31633,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31633, 45.43134]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17568114,
        name: "Dada apartment nel cuore di Venezia Ca' D'Oro",
        host_id: 97201701,
        host_name: "Alessandro",
        latitude: 45.44265,
        longitude: 12.33516,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33516, 45.44265]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17568367,
        name: "Ca' De Mezo",
        host_id: 43843547,
        host_name: "Matteo",
        latitude: 45.43571,
        longitude: 12.343,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.343, 45.43571]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17568396,
        name: "Central apartment, spacious and bright",
        host_id: 119280053,
        host_name: "Piero",
        latitude: 45.44218,
        longitude: 12.33606,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33606, 45.44218]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17599341,
        name: "Apt. Acquamarina (400 mt. from St. Mark's Square)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.43543,
        longitude: 12.33317,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33317, 45.43543]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17600072,
        name: "b&b da Nina Venice: big room-bathroom private ext.",
        host_id: 112696939,
        host_name: "Martina",
        latitude: 45.43829,
        longitude: 12.31728,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31728, 45.43829]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17603602,
        name: "Ca' Leone XIII - Casa per ferie religiosa",
        host_id: 119635149,
        host_name: "Francesco",
        latitude: 45.43249,
        longitude: 12.35524,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35524, 45.43249]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17607344,
        name: "CANAL VIEWS SAN MARCO 240sqm 8pax 4Dbeds aircnd",
        host_id: 17534457,
        host_name: "Abaca",
        latitude: 45.43681,
        longitude: 12.34453,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34453, 45.43681]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17619280,
        name: "RIO NOVO GORGEOUS TERRACE",
        host_id: 95232685,
        host_name: "Nicola",
        latitude: 45.43452,
        longitude: 12.32293,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32293, 45.43452]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17620271,
        name: "Kalispera",
        host_id: 118711666,
        host_name: "Giuliano",
        latitude: 45.42522,
        longitude: 12.32823,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32823, 45.42522]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17635067,
        name: "Private double bedroom in a Student house",
        host_id: 15005402,
        host_name: "Veronica",
        latitude: 45.43741,
        longitude: 12.33935,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33935, 45.43741]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17654246,
        name: "Luxury Casanova Flat Gold 2",
        host_id: 48092742,
        host_name: "Roby",
        latitude: 45.43043,
        longitude: 12.35681,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35681, 45.43043]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17654398,
        name: "Imperial Top Floor Flat 3",
        host_id: 48092742,
        host_name: "Roby",
        latitude: 45.43072,
        longitude: 12.3576,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3576, 45.43072]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17689935,
        name: "Apartment Malu 5 minutes from Rialto",
        host_id: 3674980,
        host_name: "Matteo E Luisa",
        latitude: 45.44225,
        longitude: 12.34065,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34065, 45.44225]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17695173,
        name: "Casa Giardino",
        host_id: 120550907,
        host_name: "Emmanuela",
        latitude: 45.4362,
        longitude: 12.34495,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34495, 45.4362]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17695481,
        name: "Ca' Aurora",
        host_id: 117414974,
        host_name: "Francisco",
        latitude: 45.4381,
        longitude: 12.3212,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3212, 45.4381]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17706151,
        name:
          "Mellina’s Terrace–Stylish House (L.T. M (Phone number hidden by Airbnb)",
        host_id: 5618111,
        host_name: "EasySuite",
        latitude: 45.44477,
        longitude: 12.32724,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32724, 45.44477]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17706927,
        name: "HOLIDAY HOME LA GONDOLA",
        host_id: 14357135,
        host_name: "Rent It Venice",
        latitude: 45.43735,
        longitude: 12.33627,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33627, 45.43735]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17707710,
        name: "CASA FLO'",
        host_id: 81874747,
        host_name: "Floriana",
        latitude: 45.43565,
        longitude: 12.34588,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34588, 45.43565]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17711572,
        name: "Apartment San Basilio - CityApartments Venice",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.43117,
        longitude: 12.32059,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32059, 45.43117]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17723488,
        name: "BARTHOUSE5486",
        host_id: 120837197,
        host_name: "Cesare",
        latitude: 45.43766,
        longitude: 12.33685,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33685, 45.43766]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17726122,
        name: "Accademia bright cozy apartment in heart of Venice",
        host_id: 1588947,
        host_name: "Angela",
        latitude: 45.42933,
        longitude: 12.32883,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32883, 45.42933]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17726945,
        name: "CA’ LA MARALÙ IN CADORO",
        host_id: 32256549,
        host_name: "Maristella",
        latitude: 45.4417,
        longitude: 12.33486,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33486, 45.4417]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17743304,
        name: "'Sweet Canal' the best view in the heart of Venice",
        host_id: 22943638,
        host_name: "Sam",
        latitude: 45.43408,
        longitude: 12.33228,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33228, 45.43408]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17746305,
        name: "Beautiful Venice",
        host_id: 121065773,
        host_name: "Umberto And Martha",
        latitude: 45.43446,
        longitude: 12.3279,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3279, 45.43446]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17760871,
        name: "CORTE CONTARINA 50 meters to St.Mark's square",
        host_id: 10189388,
        host_name: "Raffaella",
        latitude: 45.43443,
        longitude: 12.3323,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3323, 45.43443]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17775505,
        name: "Ca' Figaro   Venetian apartment",
        host_id: 121365301,
        host_name: "Maria",
        latitude: 45.42991,
        longitude: 12.33264,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33264, 45.42991]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17787691,
        name: "Casa Anita nell'antico quartiere dell'Arsenale",
        host_id: 114163769,
        host_name: "Maurizio",
        latitude: 45.43395,
        longitude: 12.35389,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35389, 45.43395]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17793008,
        name: '"GARDEN OF ROSES" dream terrace in heart of Venice',
        host_id: 120401896,
        host_name: "Davide",
        latitude: 45.44488,
        longitude: 12.32192,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32192, 45.44488]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17800030,
        name: "Elena Suite Guglie (L.T. M (Phone number hidden by Airbnb)",
        host_id: 5618111,
        host_name: "EasySuite",
        latitude: 45.44573,
        longitude: 12.32395,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32395, 45.44573]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17801722,
        name: "Affascinante Monolocale Dorsoduro",
        host_id: 94740854,
        host_name: "Paolo",
        latitude: 45.43051,
        longitude: 12.32365,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32365, 45.43051]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17802624,
        name: "Ca' Nova - Incantevole appartamento a Venezia",
        host_id: 5196424,
        host_name: "Scilla",
        latitude: 45.43381,
        longitude: 12.32433,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32433, 45.43381]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17805394,
        name: "TINTORETTO 3 ATTIC VIEWS ON CANAL",
        host_id: 103640525,
        host_name: "Team",
        latitude: 45.44548,
        longitude: 12.32354,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32354, 45.44548]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17806517,
        name: "Venetian  loft with canal view!!",
        host_id: 121654013,
        host_name: "Piero",
        latitude: 45.43414,
        longitude: 12.35914,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35914, 45.43414]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17816187,
        name: "Typical Venetian apartment in San Marco center",
        host_id: 121794679,
        host_name: "Bepi",
        latitude: 45.43423,
        longitude: 12.33921,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33921, 45.43423]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17820522,
        name: "Boutique San Marco Canal View Dorm",
        host_id: 121829634,
        host_name: "Annette",
        latitude: 45.43659,
        longitude: 12.34017,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34017, 45.43659]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17822509,
        name: "The Orchid Garden. Biennale apartment with Wifi",
        host_id: 121850017,
        host_name: "Laura",
        latitude: 45.43238,
        longitude: 12.3575,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3575, 45.43238]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17828734,
        name: "Central, Comfy & Cozy Female Dorm!",
        host_id: 121829634,
        host_name: "Annette",
        latitude: 45.43717,
        longitude: 12.34017,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34017, 45.43717]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17829286,
        name: "Double Room with Amazing Canal View",
        host_id: 121829634,
        host_name: "Annette",
        latitude: 45.4369,
        longitude: 12.33914,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33914, 45.4369]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17829603,
        name: "Bright Dorm Room minutes from Piazza San Marco",
        host_id: 121829634,
        host_name: "Annette",
        latitude: 45.43663,
        longitude: 12.34014,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34014, 45.43663]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17836173,
        name: "INLAGUNA APARTMENT",
        host_id: 5074017,
        host_name: "Gianluca",
        latitude: 45.43226,
        longitude: 12.31856,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31856, 45.43226]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17852884,
        name: "Santa Margherita Apartment",
        host_id: 70753673,
        host_name: "Sarah",
        latitude: 45.43407,
        longitude: 12.32462,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32462, 45.43407]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17856132,
        name: "Yellow suite on the canal M (Phone number hidden by Airbnb)",
        host_id: 12145490,
        host_name: "Micaela",
        latitude: 45.43775,
        longitude: 12.32563,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32563, 45.43775]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17858649,
        name: "RESIDENZA GARIBALDI",
        host_id: 3736168,
        host_name: "EasyRentals",
        latitude: 45.43266,
        longitude: 12.351,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.351, 45.43266]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17869758,
        name: "Sunny STUDIO in the Art District (PALAZZO GRASSI)",
        host_id: 122328236,
        host_name: "Giorgia",
        latitude: 45.4336,
        longitude: 12.32845,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32845, 45.4336]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17888379,
        name: "A minimal Oasis in the heart of Venice",
        host_id: 122518896,
        host_name: "Brian",
        latitude: 45.44237,
        longitude: 12.34088,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34088, 45.44237]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17902506,
        name: "LA CORTE SEGRETA del Tintoretto (the secret court)",
        host_id: 115195179,
        host_name: "Anna",
        latitude: 45.44472,
        longitude: 12.33418,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33418, 45.44472]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17912581,
        name: "VeniceVillas Cà Marina, Biennale",
        host_id: 294951,
        host_name: "VeniceVillas Di Enzo",
        latitude: 45.43616,
        longitude: 12.34889,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34889, 45.43616]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17913483,
        name: "DolceVita Apartments 382 Dorsoduro",
        host_id: 8176475,
        host_name: "Eugenia",
        latitude: 45.43197,
        longitude: 12.32706,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32706, 45.43197]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17918956,
        name: "Ve Rialto piacevole con bagno in comune Grey's",
        host_id: 29619859,
        host_name: "Stefano",
        latitude: 45.44132,
        longitude: 12.33649,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33649, 45.44132]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17920092,
        name: "Monolocale con uso cucina e bagno in comune Grey's",
        host_id: 29619859,
        host_name: "Stefano",
        latitude: 45.44021,
        longitude: 12.33842,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33842, 45.44021]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17933624,
        name: "TINTORETTO 4 AMAZING CANAL VIEWS",
        host_id: 103640525,
        host_name: "Team",
        latitude: 45.44479,
        longitude: 12.3283,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3283, 45.44479]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17934936,
        name: "LUXURY ROOM With Parking",
        host_id: 14114346,
        host_name: "Lost In",
        latitude: 45.43959,
        longitude: 12.32219,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32219, 45.43959]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17934977,
        name: "S.Marco Luxury Apartment",
        host_id: 122989504,
        host_name: "Marta",
        latitude: 45.43302,
        longitude: 12.33157,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33157, 45.43302]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17942887,
        name: "La Casa Veneziana, lovely view on Canal Cannaregio",
        host_id: 123094972,
        host_name: "Matteo",
        latitude: 45.44622,
        longitude: 12.32193,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32193, 45.44622]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17948976,
        name: "San Trovaso 2 lovely 2 bedrooms in Dorsoduro!",
        host_id: 1438903,
        host_name: "Barbara",
        latitude: 45.43216,
        longitude: 12.32444,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32444, 45.43216]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17949043,
        name: "Casa Cavaleti",
        host_id: 632312,
        host_name: "Guillaume",
        latitude: 45.44393,
        longitude: 12.3191,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3191, 45.44393]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17949889,
        name: "CA' PRIULI modern, bright and close to groceries!",
        host_id: 1438903,
        host_name: "Barbara",
        latitude: 45.44276,
        longitude: 12.3333,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3333, 45.44276]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17955287,
        name: "Ve Sant'Agostin con bagno in comune Home lovers",
        host_id: 29619859,
        host_name: "Stefano",
        latitude: 45.43758,
        longitude: 12.32545,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32545, 45.43758]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17961570,
        name: "21 STEPS FROM THE ST. MARK'S SCHOOL!!!",
        host_id: 41559211,
        host_name: "Venice",
        latitude: 45.43879,
        longitude: 12.34092,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34092, 45.43879]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17968172,
        name: "Romantic for two King Harry's",
        host_id: 29619859,
        host_name: "Stefano",
        latitude: 45.44371,
        longitude: 12.33789,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33789, 45.44371]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17971944,
        name: "Carina House (Seventh Generation Venetian House)",
        host_id: 123417741,
        host_name: "Paolo",
        latitude: 45.43543,
        longitude: 12.34092,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34092, 45.43543]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17972358,
        name: "Il Grande Cocomero",
        host_id: 54155615,
        host_name: "Monica",
        latitude: 45.43758,
        longitude: 12.32665,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32665, 45.43758]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17973778,
        name: "Apple House Rialto, matrimoniale con bagno comune",
        host_id: 118684575,
        host_name: "Melania",
        latitude: 45.43843,
        longitude: 12.33317,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33317, 45.43843]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17974689,
        name: "Apple House Rialto, camera con bagno privato",
        host_id: 118684575,
        host_name: "Melania",
        latitude: 45.43798,
        longitude: 12.33114,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33114, 45.43798]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17974999,
        name: "Apple House Rialto, camera doppia/matrimoniale",
        host_id: 118684575,
        host_name: "Melania",
        latitude: 45.44018,
        longitude: 12.33163,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33163, 45.44018]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17990331,
        name: "Stanza comoda vista città venezia Harry's",
        host_id: 29619859,
        host_name: "Stefano",
        latitude: 45.44388,
        longitude: 12.3357,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3357, 45.44388]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17990470,
        name: "Suite Tramonti con bagno privato Venezia Harry's",
        host_id: 29619859,
        host_name: "Stefano",
        latitude: 45.44393,
        longitude: 12.33675,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33675, 45.44393]] },
    },
    {
      type: "Feature",
      properties: {
        id: 17990622,
        name: "Piacevole moderna Bella posizione Harry's",
        host_id: 29619859,
        host_name: "Stefano",
        latitude: 45.44424,
        longitude: 12.33624,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33624, 45.44424]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18001459,
        name: "secluded apt with balcony,next to the Arsenale",
        host_id: 26830685,
        host_name: "Gaia&Pietro",
        latitude: 45.43459,
        longitude: 12.35615,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35615, 45.43459]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18003687,
        name: "Appartamento Ancore Biennale",
        host_id: 73691289,
        host_name: "Paola",
        latitude: 45.43255,
        longitude: 12.35704,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35704, 45.43255]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18012049,
        name: "La Zògia",
        host_id: 4684434,
        host_name: "Gabriella",
        latitude: 45.44089,
        longitude: 12.33385,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33385, 45.44089]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18016219,
        name: "CASA ACCADEMIA ORANGE with Air conditional system",
        host_id: 123871605,
        host_name: "Angelo",
        latitude: 45.4304,
        longitude: 12.32598,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32598, 45.4304]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18039991,
        name: "Seduction of Venice - Molino Stucky Venice",
        host_id: 103806114,
        host_name: "Manuel",
        latitude: 45.42734,
        longitude: 12.32038,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32038, 45.42734]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18047327,
        name: "Suite for 4 people Canal view with daily service",
        host_id: 98236134,
        host_name: "Marco",
        latitude: 45.43406,
        longitude: 12.32226,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32226, 45.43406]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18048840,
        name: "2 Beds in Canal View Dorm Room!",
        host_id: 121829634,
        host_name: "Annette",
        latitude: 45.43555,
        longitude: 12.34055,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34055, 45.43555]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18065626,
        name: "Residenza Calle Larga San Marco",
        host_id: 17066302,
        host_name: "Claudia",
        latitude: 45.43578,
        longitude: 12.33903,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33903, 45.43578]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18065676,
        name: "Accademia apartment",
        host_id: 124364608,
        host_name: "Novella",
        latitude: 45.43011,
        longitude: 12.32774,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32774, 45.43011]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18067943,
        name:
          "Residenza Marina - Canal View (L.T. M (Phone number hidden by Airbnb)",
        host_id: 5618111,
        host_name: "EasySuite",
        latitude: 45.44003,
        longitude: 12.34053,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34053, 45.44003]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18069585,
        name: "Private House wifi St. Marcuola VENEZIA ROMANTICA",
        host_id: 1860412,
        host_name: "Andrea",
        latitude: 45.44282,
        longitude: 12.32855,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32855, 45.44282]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18072467,
        name: "Cà Gioeli,soggiornare nella tranquilla Venezia",
        host_id: 124420695,
        host_name: "Giovanna",
        latitude: 45.44533,
        longitude: 12.33337,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33337, 45.44533]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18075009,
        name: "Cà Formosa - Near St. Mark's Square",
        host_id: 43854158,
        host_name: "Aristide",
        latitude: 45.43839,
        longitude: 12.33891,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33891, 45.43839]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18075425,
        name: "Cozy studio flat a step away from Rialto bridge",
        host_id: 110931856,
        host_name: "Erika",
        latitude: 45.43697,
        longitude: 12.33664,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33664, 45.43697]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18080652,
        name: "MyVenice Rialto Bridge Attic",
        host_id: 60476959,
        host_name: "Roberto",
        latitude: 45.43844,
        longitude: 12.33946,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33946, 45.43844]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18081982,
        name: "San Rocco",
        host_id: 124363877,
        host_name: "Anna",
        latitude: 45.43758,
        longitude: 12.32372,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32372, 45.43758]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18085337,
        name: "ORMESINI",
        host_id: 12982157,
        host_name: "Locappart",
        latitude: 45.445,
        longitude: 12.32812,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32812, 45.445]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18085932,
        name: "MADDALENA TERRACE in Cannaregio with canal view!",
        host_id: 1438903,
        host_name: "Barbara",
        latitude: 45.44301,
        longitude: 12.33229,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33229, 45.44301]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18086628,
        name: "El Traghetto Ca' D'Oro",
        host_id: 124552483,
        host_name: "Bjorn Lorenzo",
        latitude: 45.4435,
        longitude: 12.33484,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33484, 45.4435]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18089143,
        name: "Ancient venetian apartment with terrace on garden",
        host_id: 9426832,
        host_name: "Aldo",
        latitude: 45.43513,
        longitude: 12.34678,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34678, 45.43513]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18098715,
        name: "COZY APARTMENT IN ST. MARK'S SQUARE",
        host_id: 30283716,
        host_name: "Piero - Andrea",
        latitude: 45.43352,
        longitude: 12.33766,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33766, 45.43352]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18098959,
        name: "Blue suite by the canal M (Phone number hidden by Airbnb)",
        host_id: 12145490,
        host_name: "Micaela",
        latitude: 45.43728,
        longitude: 12.32525,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32525, 45.43728]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18099815,
        name: "Central new apartment old Venice",
        host_id: 5395291,
        host_name: "Beatrice",
        latitude: 45.44538,
        longitude: 12.32734,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32734, 45.44538]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18104931,
        name: "GUGLIE APARTMENT 5 M. TO STATION 4 P. ALL SERVICES",
        host_id: 3973906,
        host_name: "Francesco",
        latitude: 45.44355,
        longitude: 12.32563,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32563, 45.44355]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18117302,
        name: "bright apartment with exclusive terrace",
        host_id: 368293,
        host_name: "Grazia",
        latitude: 45.43351,
        longitude: 12.33336,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33336, 45.43351]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18118444,
        name: "Ca' Gallion 1144",
        host_id: 46904188,
        host_name: "Mirco Optyflat",
        latitude: 45.44112,
        longitude: 12.3264,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3264, 45.44112]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18121124,
        name: "Biancatea sunny quiet flat in the heart of Venice",
        host_id: 124868697,
        host_name: "Marco",
        latitude: 45.43981,
        longitude: 12.33877,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33877, 45.43981]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18128047,
        name:
          "Bright & Quiet apartment in the center a few steps from vaporetti and gondolas",
        host_id: 124938081,
        host_name: "Andrea",
        latitude: 45.43406,
        longitude: 12.3312,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3312, 45.43406]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18135313,
        name: "Flat near San Marco with a nice canal view",
        host_id: 16705466,
        host_name: "Nikos",
        latitude: 45.43564,
        longitude: 12.34247,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34247, 45.43564]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18146188,
        name: "Laguna apartment in the heart of Venice",
        host_id: 39921225,
        host_name: "Stefania",
        latitude: 45.43441,
        longitude: 12.34677,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34677, 45.43441]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18146200,
        name: "Apostoli Flat",
        host_id: 125118329,
        host_name: "Roberta",
        latitude: 45.44218,
        longitude: 12.33764,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33764, 45.44218]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18146823,
        name: "Flat with private Jacuzzi mini-pool",
        host_id: 125120526,
        host_name: "Claudia",
        latitude: 45.43365,
        longitude: 12.3285,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3285, 45.43365]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18153351,
        name: "Porta d'acqua Venice apartment",
        host_id: 125176899,
        host_name: "Vanessa",
        latitude: 45.44439,
        longitude: 12.33633,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33633, 45.44439]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18153796,
        name: "San Lorenzo canal view with balcony",
        host_id: 125180985,
        host_name: "Corinna",
        latitude: 45.4359,
        longitude: 12.34495,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34495, 45.4359]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18156509,
        name: "Biennale Leda's Apartment",
        host_id: 125209081,
        host_name: "Giulio",
        latitude: 45.43218,
        longitude: 12.35504,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35504, 45.43218]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18167312,
        name: "Suite for 2 people Canal view with daily service",
        host_id: 98236134,
        host_name: "Marco",
        latitude: 45.43392,
        longitude: 12.32067,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32067, 45.43392]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18169164,
        name: "Venice Inn Garden",
        host_id: 66003207,
        host_name: "Valentina",
        latitude: 45.44278,
        longitude: 12.32957,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32957, 45.44278]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18171986,
        name: "High Hopes in Venice",
        host_id: 125349621,
        host_name: "Sabrina",
        latitude: 45.43045,
        longitude: 12.3592,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3592, 45.43045]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18183339,
        name: "Cà Rezzonico Apartments Middle - 2° piano",
        host_id: 31637219,
        host_name: "Maria",
        latitude: 45.43223,
        longitude: 12.32607,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32607, 45.43223]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18185410,
        name: "San Marco",
        host_id: 24934729,
        host_name: "Angelo",
        latitude: 45.44341,
        longitude: 12.32562,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32562, 45.44341]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18186196,
        name: "WHITE LIGHT apartment (IP (Phone number hidden by Airbnb)",
        host_id: 125490600,
        host_name: "Enrico",
        latitude: 45.4423,
        longitude: 12.33747,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33747, 45.4423]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18189381,
        name:
          "Residenza Cuor de Rialto (L.T. M (Phone number hidden by Airbnb)",
        host_id: 5618111,
        host_name: "EasySuite",
        latitude: 45.44001,
        longitude: 12.33251,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33251, 45.44001]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18191243,
        name:
          "Micol's tiny room private bathroom ID M (Phone number hidden by Airbnb)",
        host_id: 125530486,
        host_name: "Tiziana",
        latitude: 45.43387,
        longitude: 12.34969,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34969, 45.43387]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18195817,
        name: "Mario apartment Fondamente Nove",
        host_id: 10072655,
        host_name: "Mario Apartment",
        latitude: 45.44366,
        longitude: 12.33842,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33842, 45.44366]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18202796,
        name: "Suite Superior 2 Person Canal View Daily Service",
        host_id: 98236134,
        host_name: "Marco",
        latitude: 45.43332,
        longitude: 12.3225,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3225, 45.43332]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18207290,
        name: "Scala Mata: Unique & Homely 17th Century Apartment",
        host_id: 31703273,
        host_name: "Marika",
        latitude: 45.43065,
        longitude: 12.35523,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35523, 45.43065]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18219060,
        name: "Stunning View on San Marco",
        host_id: 125802521,
        host_name: "Niccolò",
        latitude: 45.43516,
        longitude: 12.3395,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3395, 45.43516]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18223690,
        name: "PONTE STORTO romantic 1 bedroom in San Polo",
        host_id: 1438903,
        host_name: "Barbara",
        latitude: 45.43842,
        longitude: 12.33111,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33111, 45.43842]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18232909,
        name: "GDHOUSE - modern flat few steps from BIENNALE",
        host_id: 125945338,
        host_name: "Graziana E Damiano",
        latitude: 45.42956,
        longitude: 12.35712,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35712, 45.42956]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18235266,
        name: "Cà Felice",
        host_id: 38623763,
        host_name: "Elisabetta",
        latitude: 45.44289,
        longitude: 12.33306,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33306, 45.44289]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18244043,
        name: "CA' MATLDE",
        host_id: 24934729,
        host_name: "Angelo",
        latitude: 45.44338,
        longitude: 12.32353,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32353, 45.44338]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18252454,
        name: "Casa Marcella Realvenice",
        host_id: 126137420,
        host_name: "Alice",
        latitude: 45.43176,
        longitude: 12.35511,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35511, 45.43176]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18252889,
        name: "Galleria Biennale",
        host_id: 62631903,
        host_name: "Andre",
        latitude: 45.44276,
        longitude: 12.34047,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34047, 45.44276]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18270396,
        name: "S. Caterina - Appartamento “Scampo”",
        host_id: 84543765,
        host_name: "Maurizio&Francesca",
        latitude: 45.44325,
        longitude: 12.3361,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3361, 45.44325]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18270505,
        name: 'S. Caterina - Camera "Canocia"',
        host_id: 84543765,
        host_name: "Maurizio&Francesca",
        latitude: 45.44374,
        longitude: 12.33705,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33705, 45.44374]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18270609,
        name: 'S. Caterina - Camera "Masaneta"',
        host_id: 84543765,
        host_name: "Maurizio&Francesca",
        latitude: 45.44443,
        longitude: 12.33745,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33745, 45.44443]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18272519,
        name: 'S. Caterina - Appartamento "Granseola"',
        host_id: 84543765,
        host_name: "Maurizio&Francesca",
        latitude: 45.4434,
        longitude: 12.33637,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33637, 45.4434]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18276766,
        name: "Ruga Giuffa House",
        host_id: 126371182,
        host_name: "Nicoletta",
        latitude: 45.43793,
        longitude: 12.33969,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33969, 45.43793]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18279587,
        name: "Cà Maltese",
        host_id: 39576933,
        host_name: "Giorgia",
        latitude: 45.43442,
        longitude: 12.3263,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3263, 45.43442]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18281647,
        name: "In the heart of Venice (free internet)",
        host_id: 59611150,
        host_name: "Luigia",
        latitude: 45.43034,
        longitude: 12.3566,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3566, 45.43034]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18283239,
        name: "Mansarda luminosa",
        host_id: 16010727,
        host_name: "Ombra",
        latitude: 45.44082,
        longitude: 12.33884,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33884, 45.44082]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18284435,
        name: "SAN TOMA', STYLISH APARTMENT IN GREAT LOCATION",
        host_id: 3880254,
        host_name: "Sabina",
        latitude: 45.43652,
        longitude: 12.32689,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32689, 45.43652]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18304891,
        name: "Grazioso Appartamento Giudecca Venezia",
        host_id: 126600737,
        host_name: "Mattia",
        latitude: 45.42488,
        longitude: 12.32433,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32433, 45.42488]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18338928,
        name: "BIENNALE Charming location nearby the 'Biennale'",
        host_id: 13019431,
        host_name: "Helga Anna",
        latitude: 45.43233,
        longitude: 12.35661,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35661, 45.43233]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18391781,
        name: "La Casa di Goldoni - canal view with tiny terrace",
        host_id: 103806114,
        host_name: "Manuel",
        latitude: 45.42471,
        longitude: 12.32814,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32814, 45.42471]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18393949,
        name: "Ca'Sole Morosini Palace",
        host_id: 76812796,
        host_name: "Pier",
        latitude: 45.4341,
        longitude: 12.32941,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32941, 45.4341]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18398473,
        name: "San Marco Via XXII Marzo - Aria Condizionata/Wifi",
        host_id: 127465887,
        host_name: "Andrea",
        latitude: 45.43343,
        longitude: 12.33464,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33464, 45.43343]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18418921,
        name: "cheap small  room  in biennale-arsenale of venice",
        host_id: 35144066,
        host_name: "Xie",
        latitude: 45.4332,
        longitude: 12.34979,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34979, 45.4332]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18442701,
        name: "Comfy flat in the centre of Venice - WI-FI",
        host_id: 21032404,
        host_name: "Susanna",
        latitude: 45.43212,
        longitude: 12.35205,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35205, 45.43212]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18443529,
        name: "Laguna Dream Apartment",
        host_id: 4097735,
        host_name: "Roberto",
        latitude: 45.4276,
        longitude: 12.35933,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35933, 45.4276]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18454685,
        name: "Rialto Suite 1602",
        host_id: 127946632,
        host_name: "Massimo",
        latitude: 45.43895,
        longitude: 12.33279,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33279, 45.43895]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18456546,
        name: "Campiello-in the heart of Venice",
        host_id: 39921225,
        host_name: "Stefania",
        latitude: 45.43309,
        longitude: 12.34864,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34864, 45.43309]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18459191,
        name: "Bright home with typical Canal view",
        host_id: 127991567,
        host_name: "Francesca",
        latitude: 45.43173,
        longitude: 12.32266,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32266, 45.43173]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18462829,
        name: "Little spot in heart of Venice",
        host_id: 49180039,
        host_name: "Mimi",
        latitude: 45.43227,
        longitude: 12.33399,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33399, 45.43227]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18467575,
        name: "Venice inn Canal",
        host_id: 66003207,
        host_name: "Valentina",
        latitude: 45.44428,
        longitude: 12.33062,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33062, 45.44428]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18468430,
        name: "Ducale apartment top view",
        host_id: 39921225,
        host_name: "Stefania",
        latitude: 45.43417,
        longitude: 12.34779,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34779, 45.43417]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18469368,
        name: "Ca de la Vida",
        host_id: 46904188,
        host_name: "Mirco Optyflat",
        latitude: 45.43478,
        longitude: 12.34878,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34878, 45.43478]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18469923,
        name: "Formosa Charming House",
        host_id: 46904188,
        host_name: "Mirco Optyflat",
        latitude: 45.43881,
        longitude: 12.34268,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34268, 45.43881]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18471005,
        name: "Luminous Apartment with 2 canals view - Casa D'Oro",
        host_id: 114664320,
        host_name: "Francesco",
        latitude: 45.44116,
        longitude: 12.33605,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33605, 45.44116]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18473755,
        name: "Nuovissimo appartamento Venezia Strada Nuova",
        host_id: 88168743,
        host_name: "Mario",
        latitude: 45.4424,
        longitude: 12.33165,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33165, 45.4424]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18478016,
        name: "Gesuiti 2- cozy and central apartment",
        host_id: 5395291,
        host_name: "Beatrice",
        latitude: 45.4423,
        longitude: 12.33912,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33912, 45.4423]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18480324,
        name: "WONDERFUL TERRACE IN OLD TYPICAL BUILDING",
        host_id: 3880254,
        host_name: "Sabina",
        latitude: 45.44684,
        longitude: 12.32864,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32864, 45.44684]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18492950,
        name: "Ca' Dolci, modern and classy at Giudecca",
        host_id: 12113015,
        host_name: "Mario",
        latitude: 45.42739,
        longitude: 12.32155,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32155, 45.42739]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18494196,
        name: "Casa Nova",
        host_id: 121065773,
        host_name: "Umberto And Martha",
        latitude: 45.43466,
        longitude: 12.32855,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32855, 45.43466]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18497574,
        name: "Brand new apartment in the heart of Venice",
        host_id: 128256890,
        host_name: "Justine",
        latitude: 45.43743,
        longitude: 12.33979,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33979, 45.43743]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18498257,
        name: "big double room in luminous apt with artists",
        host_id: 36182991,
        host_name: "Rob",
        latitude: 45.43514,
        longitude: 12.3247,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3247, 45.43514]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18505742,
        name: "Double Room with private bathroom in Cannaregio",
        host_id: 128431140,
        host_name: "Albina",
        latitude: 45.447,
        longitude: 12.32089,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32089, 45.447]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18512662,
        name: "BRAND-NEW, QUIET AND COZY IN SAN MARCO",
        host_id: 128498314,
        host_name: "Matteo",
        latitude: 45.43382,
        longitude: 12.33092,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33092, 45.43382]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18516293,
        name: "Muneghe 3 : S.Marco Luxury Apartment with terrace",
        host_id: 122989504,
        host_name: "Marta",
        latitude: 45.43153,
        longitude: 12.33119,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33119, 45.43153]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18517212,
        name: "Cà Salvarosa - few steps from Saint Mark square",
        host_id: 36189226,
        host_name: "Piero",
        latitude: 45.43814,
        longitude: 12.34208,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34208, 45.43814]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18517817,
        name: "The home of the ship builder",
        host_id: 28572253,
        host_name: "Giacomo",
        latitude: 45.43685,
        longitude: 12.34935,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34935, 45.43685]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18518254,
        name: "Due Leoni Venice Luxury Apartment",
        host_id: 669047,
        host_name: "Viewsonvenice",
        latitude: 45.43407,
        longitude: 12.33972,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33972, 45.43407]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18522054,
        name: "Romantic Loft Ca' Sestrier",
        host_id: 112281311,
        host_name: "Beatrice",
        latitude: 45.43527,
        longitude: 12.34711,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34711, 45.43527]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18530203,
        name: "Double Room in Beautiful Cannaregio Area",
        host_id: 128431140,
        host_name: "Albina",
        latitude: 45.44653,
        longitude: 12.32155,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32155, 45.44653]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18532945,
        name: "POLIGNAC 3",
        host_id: 15337957,
        host_name: "Marie",
        latitude: 45.43021,
        longitude: 12.32813,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32813, 45.43021]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18534145,
        name: "Apartment Puccini (Venice Historical Centre)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.44721,
        longitude: 12.32438,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32438, 45.44721]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18539735,
        name: "S.Marco Luxury & Charme Apartment",
        host_id: 122989504,
        host_name: "Marta",
        latitude: 45.43261,
        longitude: 12.33235,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33235, 45.43261]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18541526,
        name: "Casa Mary a window on Venice",
        host_id: 128703602,
        host_name: "Marina",
        latitude: 45.44115,
        longitude: 12.34102,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34102, 45.44115]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18541756,
        name: "Gheto Novo",
        host_id: 128705533,
        host_name: "Agnieszka",
        latitude: 45.44439,
        longitude: 12.32677,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32677, 45.44439]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18543223,
        name: "Private Rooms in Venice",
        host_id: 128715197,
        host_name: "Cortinovis",
        latitude: 45.44593,
        longitude: 12.33131,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33131, 45.44593]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18556687,
        name: "Romantico ed accogliente, nel cuore di Venezia",
        host_id: 127797229,
        host_name: "Stefano",
        latitude: 45.44579,
        longitude: 12.32957,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32957, 45.44579]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18560879,
        name: "Little Venetian House",
        host_id: 9590762,
        host_name: "Camillo",
        latitude: 45.43828,
        longitude: 12.33178,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33178, 45.43828]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18562905,
        name: "San Luca Terrace",
        host_id: 128863325,
        host_name: "Carla - Interhome",
        latitude: 45.43532,
        longitude: 12.3349,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3349, 45.43532]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18562907,
        name: "Corte Gragolina",
        host_id: 128863325,
        host_name: "Carla - Interhome",
        latitude: 45.43654,
        longitude: 12.33702,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33702, 45.43654]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18562909,
        name: "Cà della Giudecca",
        host_id: 128863325,
        host_name: "Carla - Interhome",
        latitude: 45.42399,
        longitude: 12.32285,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32285, 45.42399]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18562910,
        name: "Judeca Nova",
        host_id: 128863325,
        host_name: "Carla - Interhome",
        latitude: 45.42459,
        longitude: 12.32872,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32872, 45.42459]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18562911,
        name: "2-room apartment 60 m² Iris",
        host_id: 128863325,
        host_name: "Carla - Interhome",
        latitude: 45.42471,
        longitude: 12.32823,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32823, 45.42471]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18580093,
        name: "CANAL DREAM HOUSE",
        host_id: 10988715,
        host_name: "Andrea",
        latitude: 45.44221,
        longitude: 12.34202,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34202, 45.44221]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18592543,
        name: "SAN MARCO MOONLIGHT ATTIC",
        host_id: 129104179,
        host_name: "Massimo",
        latitude: 45.43255,
        longitude: 12.32856,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32856, 45.43255]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18592791,
        name: "Best Find in Venice",
        host_id: 129109527,
        host_name: "Chris & Gio",
        latitude: 45.43996,
        longitude: 12.3314,
        beds: 7,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3314, 45.43996]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18593084,
        name: "Ve.N.I.Ce Cera Casa Santo Stefano",
        host_id: 37864680,
        host_name: "Ve.N.I.Ce Immobiliare Cera",
        latitude: 45.4333,
        longitude: 12.32931,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32931, 45.4333]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18599125,
        name: "Saint Mark's view",
        host_id: 25006206,
        host_name: "Alberto&Giovanna",
        latitude: 45.43549,
        longitude: 12.34062,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34062, 45.43549]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18607433,
        name: "Historic residence located in the heart of Venice",
        host_id: 69412780,
        host_name: "Francesco",
        latitude: 45.43381,
        longitude: 12.33148,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33148, 45.43381]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18613176,
        name: "Bellissimo appartamento con cortile privato",
        host_id: 43777105,
        host_name: "Gian  Ruggero",
        latitude: 45.44289,
        longitude: 12.32994,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32994, 45.44289]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18622861,
        name: "Apartment in the heart of Venice.",
        host_id: 129372365,
        host_name: "Fabio",
        latitude: 45.43474,
        longitude: 12.33933,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33933, 45.43474]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18623271,
        name: "CA' VERNIER Apartment close to Rialto Bridge",
        host_id: 129375052,
        host_name: "Alessandro",
        latitude: 45.43943,
        longitude: 12.33316,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33316, 45.43943]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18627873,
        name: "Room with kitchen in the Centre san marco",
        host_id: 48092742,
        host_name: "Roby",
        latitude: 45.43595,
        longitude: 12.34253,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34253, 45.43595]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18643951,
        name: "Central Brand New Suite",
        host_id: 41545306,
        host_name: "Filippo",
        latitude: 45.43975,
        longitude: 12.32959,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32959, 45.43975]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18646178,
        name: "Venetian Gondolas float by your 4 small terraces",
        host_id: 10678571,
        host_name: "Stefano & Nika",
        latitude: 45.4375,
        longitude: 12.32871,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32871, 45.4375]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18647090,
        name: "Loft with 'altana' on the rooftops of Venice",
        host_id: 127991567,
        host_name: "Francesca",
        latitude: 45.43207,
        longitude: 12.32128,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32128, 45.43207]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18648853,
        name: "DELUXE, TOP CENTRAL, 2 STEPS FROM SAN MARCO!",
        host_id: 3880254,
        host_name: "Sabina",
        latitude: 45.43619,
        longitude: 12.34042,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34042, 45.43619]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18653822,
        name: "Sweet Drasi, due persone, Arsenale/Biennale",
        host_id: 129622611,
        host_name: "Ettore",
        latitude: 45.43715,
        longitude: 12.34944,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34944, 45.43715]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18659070,
        name: "Canal view! The authentic charm of Venice",
        host_id: 6019189,
        host_name: "Federico",
        latitude: 45.43773,
        longitude: 12.33214,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33214, 45.43773]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18659359,
        name: 'S. Caterina - Camera "Capasanta”',
        host_id: 84543765,
        host_name: "Maurizio&Francesca",
        latitude: 45.44326,
        longitude: 12.3363,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3363, 45.44326]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18661992,
        name: "Tranquillo appartamento a Rialto",
        host_id: 129691159,
        host_name: "Francesca",
        latitude: 45.43686,
        longitude: 12.33211,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33211, 45.43686]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18664208,
        name: "Top-floor-flat with great view on  Giudecca",
        host_id: 1542249,
        host_name: "Marco",
        latitude: 45.43116,
        longitude: 12.31928,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31928, 45.43116]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18698908,
        name: "AL CAMPANILE - 3 bedded flat with terrace",
        host_id: 10189388,
        host_name: "Raffaella",
        latitude: 45.44088,
        longitude: 12.3376,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3376, 45.44088]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18713175,
        name: "Venetian House view Grand Canal",
        host_id: 113022863,
        host_name: "Rachele",
        latitude: 45.43907,
        longitude: 12.33239,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33239, 45.43907]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18713245,
        name: "Ca' Momo  apartment",
        host_id: 99514760,
        host_name: "Mohamed",
        latitude: 45.44686,
        longitude: 12.32377,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32377, 45.44686]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18713756,
        name: "Apartment with balcony close to Rialto",
        host_id: 6019189,
        host_name: "Federico",
        latitude: 45.44122,
        longitude: 12.3397,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3397, 45.44122]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18730580,
        name: "La Felice Canal Grande",
        host_id: 4684434,
        host_name: "Gabriella",
        latitude: 45.44211,
        longitude: 12.33354,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33354, 45.44211]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18738918,
        name: "Le Mansarde - deluxe",
        host_id: 14232639,
        host_name: "Stefano",
        latitude: 45.44332,
        longitude: 12.32758,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32758, 45.44332]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18752666,
        name: "Romantic loft in Rialto in the heart of Venice",
        host_id: 766256,
        host_name: "Laura",
        latitude: 45.4395,
        longitude: 12.33171,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33171, 45.4395]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18762068,
        name: "LA CARBONA 2",
        host_id: 24889853,
        host_name: "Sandra",
        latitude: 45.43967,
        longitude: 12.34265,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34265, 45.43967]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18762547,
        name: "Apartment Ca' Mocenigo (600m from Rialto's Bridge)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.44081,
        longitude: 12.32969,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32969, 45.44081]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18763199,
        name: "LA CARBONA",
        host_id: 24889853,
        host_name: "Sandra",
        latitude: 45.43902,
        longitude: 12.34225,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34225, 45.43902]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18767255,
        name: "Palazzo Grassi and Accademia Bridge superb House",
        host_id: 25384210,
        host_name: "Helene",
        latitude: 45.43421,
        longitude: 12.33065,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33065, 45.43421]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18773272,
        name: "Ca' Domino apartment with  terrace city view",
        host_id: 130637964,
        host_name: "Marco",
        latitude: 45.43259,
        longitude: 12.32958,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32958, 45.43259]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18781615,
        name: "CA' GIORGIA VENICE BALCONY APARTMENT",
        host_id: 5862083,
        host_name: "Silvia",
        latitude: 45.44031,
        longitude: 12.33512,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33512, 45.44031]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18783147,
        name: "Refined Apartment in a 16th-century Building",
        host_id: 1363067,
        host_name: "Uto",
        latitude: 45.44074,
        longitude: 12.3361,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3361, 45.44074]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18783883,
        name: "Testa d'Oro 4 - Beautiful City view",
        host_id: 51021330,
        host_name: "Francesco",
        latitude: 45.43748,
        longitude: 12.33707,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33707, 45.43748]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18791270,
        name: "Cozy flat near Miracoli Church",
        host_id: 20732052,
        host_name: "Elia",
        latitude: 45.4408,
        longitude: 12.33966,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33966, 45.4408]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18797332,
        name: "Venezia Ormesini4",
        host_id: 21885006,
        host_name: "Lisa",
        latitude: 45.44456,
        longitude: 12.3269,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3269, 45.44456]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18798969,
        name: "Ca' Giulia - Christmas- No high water",
        host_id: 130542816,
        host_name: "Foscarina",
        latitude: 45.42769,
        longitude: 12.36297,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.36297, 45.42769]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18808142,
        name: "THE PAINTER FLAT IN SAN MARCO",
        host_id: 128684296,
        host_name: "Giovanna",
        latitude: 45.43545,
        longitude: 12.33096,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33096, 45.43545]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18815189,
        name:
          "A dream in Venice  2/5guest Superhost  M (Phone number hidden by Airbnb)",
        host_id: 131004434,
        host_name: "Elena",
        latitude: 45.44035,
        longitude: 12.32817,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32817, 45.44035]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18820900,
        name: "OLD MARKET APARTMENT",
        host_id: 14357135,
        host_name: "Rent It Venice",
        latitude: 45.43899,
        longitude: 12.33378,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33378, 45.43899]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18822767,
        name: "Casa Giuliana: art, history and beautiful views",
        host_id: 131057979,
        host_name: "Marco",
        latitude: 45.43067,
        longitude: 12.35662,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35662, 45.43067]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18823113,
        name: "Piano nobile a San Marco",
        host_id: 26417983,
        host_name: "Marco",
        latitude: 45.43824,
        longitude: 12.3383,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3383, 45.43824]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18827002,
        name: "4Friends private room in heart of Venice",
        host_id: 49180039,
        host_name: "Mimi",
        latitude: 45.43253,
        longitude: 12.33272,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33272, 45.43253]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18831176,
        name: "Santo Stefano Accademia Apartment Venice",
        host_id: 5862083,
        host_name: "Silvia",
        latitude: 45.43355,
        longitude: 12.32872,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32872, 45.43355]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18831422,
        name: "Cà Stagna 1° Piano  - Vista Canale",
        host_id: 131136314,
        host_name: "Isabella",
        latitude: 45.43244,
        longitude: 12.32388,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32388, 45.43244]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18831853,
        name:
          "Ampio appartamento a 50 metri dall'imbarcadero San Stae sul Canal Grande",
        host_id: 6026434,
        host_name: "Antonio",
        latitude: 45.44188,
        longitude: 12.33002,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33002, 45.44188]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18835265,
        name: "Venezia Ormesini 2",
        host_id: 21885006,
        host_name: "Lisa",
        latitude: 45.44419,
        longitude: 12.32834,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32834, 45.44419]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18835398,
        name: "Venezia ormesini 3",
        host_id: 21885006,
        host_name: "Lisa",
        latitude: 45.44438,
        longitude: 12.32681,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32681, 45.44438]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18835410,
        name: "Venezia Ormesini1",
        host_id: 21885006,
        host_name: "Lisa",
        latitude: 45.44405,
        longitude: 12.32827,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32827, 45.44405]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18841548,
        name: "NEAR CASINO' free WIFI",
        host_id: 10319031,
        host_name: "Pier",
        latitude: 45.44261,
        longitude: 12.33073,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33073, 45.44261]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18849668,
        name: "Ca' Sansovino",
        host_id: 131258655,
        host_name: "Fabio",
        latitude: 45.43381,
        longitude: 12.33051,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33051, 45.43381]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18866951,
        name: "Ca Mae - Luxury Experience in Venice (green)",
        host_id: 131447529,
        host_name: "Sandro",
        latitude: 45.43373,
        longitude: 12.32343,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32343, 45.43373]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18872817,
        name: "Cà Stagna 2nd floor Flat - Canal view",
        host_id: 131136314,
        host_name: "Isabella",
        latitude: 45.43261,
        longitude: 12.32446,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32446, 45.43261]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18884860,
        name: "Casa Eletta",
        host_id: 55531875,
        host_name: "Elena",
        latitude: 45.43427,
        longitude: 12.31816,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31816, 45.43427]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18885327,
        name: "Ca' Virginia: living in the heart of Venice",
        host_id: 9396268,
        host_name: "Martina",
        latitude: 45.43594,
        longitude: 12.33814,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33814, 45.43594]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18903312,
        name: "Attico con terrazze ca' Maddalena",
        host_id: 131736272,
        host_name: "Franco",
        latitude: 45.44328,
        longitude: 12.32949,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32949, 45.44328]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18904834,
        name: "Terrazza",
        host_id: 131746520,
        host_name: "Ettore",
        latitude: 45.43011,
        longitude: 12.33397,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33397, 45.43011]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18905564,
        name: "Celeste",
        host_id: 131746520,
        host_name: "Ettore",
        latitude: 45.42998,
        longitude: 12.332,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.332, 45.42998]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18907115,
        name: "Luxury Palazzo Costa Vendramin",
        host_id: 46528252,
        host_name: "Alex",
        latitude: 45.44247,
        longitude: 12.33408,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33408, 45.44247]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18914153,
        name: "Ca' Cinzia Apartment",
        host_id: 131575601,
        host_name: "Cinzia",
        latitude: 45.43927,
        longitude: 12.33408,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33408, 45.43927]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18921034,
        name: "Ca' Arte & Laguna",
        host_id: 131441154,
        host_name: "Gianluca",
        latitude: 45.44567,
        longitude: 12.32273,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32273, 45.44567]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18937668,
        name: "Grazioso monolocale ai Giardini della Biennale",
        host_id: 20939753,
        host_name: "Annamaria",
        latitude: 45.43062,
        longitude: 12.35508,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35508, 45.43062]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18942075,
        name: "Venice 5015, bright stylish modern",
        host_id: 132051429,
        host_name: "Cristina",
        latitude: 45.43534,
        longitude: 12.3424,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3424, 45.43534]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18953962,
        name: "A different Venice: modernity and historicity",
        host_id: 132157724,
        host_name: "Mario & Giovanna",
        latitude: 45.4244,
        longitude: 12.32605,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32605, 45.4244]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18955430,
        name: "Rooftop Terrace Venice Rental: WIFI/AC near Rialto",
        host_id: 127712726,
        host_name: "Viviana",
        latitude: 45.43864,
        longitude: 12.32851,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32851, 45.43864]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18957346,
        name: "APARTMENT IN FRONT OF FRARI CATHEDRAL",
        host_id: 5395291,
        host_name: "Beatrice",
        latitude: 45.43677,
        longitude: 12.32645,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32645, 45.43677]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18960373,
        name: "Casa Maddalena",
        host_id: 58152045,
        host_name: "Jimmy",
        latitude: 45.44374,
        longitude: 12.3307,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3307, 45.44374]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18968716,
        name: "Cassa ALYSSA",
        host_id: 132295055,
        host_name: "Eleonora",
        latitude: 45.44636,
        longitude: 12.32255,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32255, 45.44636]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18968972,
        name: "Green Room",
        host_id: 99514760,
        host_name: "Mohamed",
        latitude: 45.44535,
        longitude: 12.32532,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32532, 45.44535]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18985781,
        name: "Venice Luxury Palace 6",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.43856,
        longitude: 12.33225,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33225, 45.43856]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18994854,
        name: "VeneziAmo apartment - heart of Venice",
        host_id: 59678860,
        host_name: "Martina",
        latitude: 45.43978,
        longitude: 12.32817,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32817, 45.43978]] },
    },
    {
      type: "Feature",
      properties: {
        id: 18996187,
        name: "жилье в историческом центре Венеции",
        host_id: 132513340,
        host_name: "Olga",
        latitude: 45.43978,
        longitude: 12.34249,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34249, 45.43978]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19003624,
        name: "Gondolieri Roof Terrace",
        host_id: 669047,
        host_name: "Viewsonvenice",
        latitude: 45.43037,
        longitude: 12.3302,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3302, 45.43037]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19006935,
        name: "SANT'ELENA GARDEN lovely 2 bedrooms",
        host_id: 1438903,
        host_name: "Barbara",
        latitude: 45.4264,
        longitude: 12.36142,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.36142, 45.4264]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19008448,
        name: "CA' SOL VIEWON CANAL GRANDE",
        host_id: 98937849,
        host_name: "Attilio",
        latitude: 45.43866,
        longitude: 12.3358,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3358, 45.43866]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19017043,
        name: "Mariangela-Artist's Lodge",
        host_id: 9996700,
        host_name: "Giovanni",
        latitude: 45.4449,
        longitude: 12.32948,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32948, 45.4449]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19060006,
        name: "SERENISSIMA. AUTHENTIC VENICE IN QUIET COURTYARD",
        host_id: 133056442,
        host_name: "Lorenzo",
        latitude: 45.44527,
        longitude: 12.32928,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32928, 45.44527]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19064880,
        name: "Monolocale I Loft della Vigna",
        host_id: 133084198,
        host_name: "Riccardo & Matteo",
        latitude: 45.4394,
        longitude: 12.34612,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34612, 45.4394]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19081796,
        name: "CA' LUCIA BRIGHT APARTMENT  VENICE",
        host_id: 5862083,
        host_name: "Silvia",
        latitude: 45.43939,
        longitude: 12.32558,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32558, 45.43939]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19084590,
        name: "Bilocale | loft della Vigna",
        host_id: 133084198,
        host_name: "Riccardo & Matteo",
        latitude: 45.43823,
        longitude: 12.34703,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34703, 45.43823]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19096050,
        name:
          "PIAZZALE ROMA VENICE APARTMENT M (Phone number hidden by Airbnb)",
        host_id: 5862083,
        host_name: "Silvia",
        latitude: 45.43668,
        longitude: 12.31814,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31814, 45.43668]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19113190,
        name: "Ca' Patrizia Noble Floor",
        host_id: 133550414,
        host_name: "Patrizia",
        latitude: 45.43931,
        longitude: 12.33921,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33921, 45.43931]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19117250,
        name: "NEAR CASINO' free WIFI for 2-3 people",
        host_id: 10319031,
        host_name: "Pier",
        latitude: 45.44415,
        longitude: 12.32964,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32964, 45.44415]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19134453,
        name: "Cà Romantic",
        host_id: 106880093,
        host_name: "Federica & Doriano",
        latitude: 45.44368,
        longitude: 12.32752,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32752, 45.44368]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19135994,
        name: "Venezia Gentile",
        host_id: 46904188,
        host_name: "Mirco Optyflat",
        latitude: 45.44253,
        longitude: 12.33984,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33984, 45.44253]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19138743,
        name: "Cosy Brand New Apartment",
        host_id: 41545306,
        host_name: "Filippo",
        latitude: 45.44005,
        longitude: 12.3296,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3296, 45.44005]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19139128,
        name: "Ihouse No1",
        host_id: 64548275,
        host_name: "Ellen",
        latitude: 45.43863,
        longitude: 12.33195,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33195, 45.43863]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19139554,
        name: "2minutes to city center Rialto bridge",
        host_id: 64548275,
        host_name: "Ellen",
        latitude: 45.43829,
        longitude: 12.33319,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33319, 45.43829]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19139816,
        name: "Ihouse No3",
        host_id: 64548275,
        host_name: "Ellen",
        latitude: 45.43703,
        longitude: 12.33333,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33333, 45.43703]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19140166,
        name: "2minutes to city center Rialto bridge",
        host_id: 64548275,
        host_name: "Ellen",
        latitude: 45.43792,
        longitude: 12.3315,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3315, 45.43792]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19157996,
        name: "Venice, San Marco & Rialto",
        host_id: 133789405,
        host_name: "Historical Center",
        latitude: 45.43882,
        longitude: 12.3459,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3459, 45.43882]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19170663,
        name: "Calle Colombina",
        host_id: 126100357,
        host_name: "Giulio",
        latitude: 45.44177,
        longitude: 12.3293,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3293, 45.44177]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19179214,
        name: "Casa con giardino privato a Santa Croce",
        host_id: 1275479,
        host_name: "Giorgia&Michele",
        latitude: 45.44034,
        longitude: 12.32603,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32603, 45.44034]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19190771,
        name: "Casetta Martini ♥ out of the crowd close to all",
        host_id: 128908147,
        host_name: "Ambra",
        latitude: 45.42349,
        longitude: 12.33162,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33162, 45.42349]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19206467,
        name: "Ca' Santa Marta Apartment (Free WI-FI)",
        host_id: 25128793,
        host_name: "_mdm_",
        latitude: 45.43302,
        longitude: 12.31287,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31287, 45.43302]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19210422,
        name: "Ca' Barozzi - Purple double room -",
        host_id: 88553273,
        host_name: "Ca' Barozzi",
        latitude: 45.4332,
        longitude: 12.31826,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31826, 45.4332]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19222102,
        name: "Centre single bedroom from ladies only.",
        host_id: 134543368,
        host_name: "Rayisa",
        latitude: 45.43902,
        longitude: 12.3378,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3378, 45.43902]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19233566,
        name: "Casa Sabotino Sant'Elena Biennale with fiber 1000",
        host_id: 134656502,
        host_name: "Mattia",
        latitude: 45.42723,
        longitude: 12.35999,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35999, 45.42723]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19234303,
        name: "Family Suite Ca' del Dose",
        host_id: 24889853,
        host_name: "Sandra",
        latitude: 45.43694,
        longitude: 12.33889,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33889, 45.43694]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19238536,
        name: 'Camper Volksvagen T4 California "OMER"-In Venice',
        host_id: 7537877,
        host_name: "Fabio And Giulia",
        latitude: 45.43969,
        longitude: 12.31155,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31155, 45.43969]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19241890,
        name:
          "Your window on Venice -id number M (Phone number hidden by Airbnb)",
        host_id: 134706371,
        host_name: "Luigi",
        latitude: 45.43962,
        longitude: 12.33068,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33068, 45.43962]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19243392,
        name: "Cà Lirica",
        host_id: 134095910,
        host_name: "Michiko",
        latitude: 45.43629,
        longitude: 12.35004,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35004, 45.43629]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19246128,
        name: "Ca' Zacco",
        host_id: 134756590,
        host_name: "Nicoletta",
        latitude: 45.44116,
        longitude: 12.34002,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34002, 45.44116]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19247070,
        name: "Duca",
        host_id: 76812796,
        host_name: "Pier",
        latitude: 45.44193,
        longitude: 12.33676,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33676, 45.44193]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19253624,
        name: "Caratteristico appartamento a Dorsoduro",
        host_id: 115387286,
        host_name: "Daniela & Francesca",
        latitude: 45.4341,
        longitude: 12.32218,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32218, 45.4341]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19261699,
        name: "Stylish apartment in the heart of Venice with private courtyard",
        host_id: 4339678,
        host_name: "Vacasa Italy - Venice",
        latitude: 45.43593,
        longitude: 12.34672,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34672, 45.43593]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19262147,
        name: "Little Secret of Venice",
        host_id: 32854955,
        host_name: "Immobil Ca' Minoxi",
        latitude: 45.43619,
        longitude: 12.34303,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34303, 45.43619]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19262607,
        name: "BRAGORA SMOOCHY ATTIC VENICE",
        host_id: 5862083,
        host_name: "Silvia",
        latitude: 45.43544,
        longitude: 12.34749,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34749, 45.43544]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19263534,
        name: "City center - Fiubera Apartment",
        host_id: 9639934,
        host_name: "Wildes",
        latitude: 45.43339,
        longitude: 12.33883,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33883, 45.43339]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19321660,
        name: "CA' DE L'OGIO - Holidays in center of Venice",
        host_id: 135336549,
        host_name: "Silvia",
        latitude: 45.4357,
        longitude: 12.34841,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34841, 45.4357]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19339612,
        name: "Amazing Venice San Marco",
        host_id: 135484965,
        host_name: "Agneska",
        latitude: 45.43206,
        longitude: 12.33461,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33461, 45.43206]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19341796,
        name: "Cà Santa Caterina-an enchanting noble floor",
        host_id: 131228905,
        host_name: "Veronica",
        latitude: 45.44301,
        longitude: 12.33567,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33567, 45.44301]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19352178,
        name: "CASA TUA your flat in Venice",
        host_id: 48581136,
        host_name: "Nardi",
        latitude: 45.43078,
        longitude: 12.33158,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33158, 45.43078]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19361537,
        name: "San Martino Guesthouse",
        host_id: 135523148,
        host_name: "Alyosha",
        latitude: 45.44517,
        longitude: 12.33332,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33332, 45.44517]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19379069,
        name: "CASA DI OSCAR CLOSE TO STATION & AIRPORT FERRY",
        host_id: 135834897,
        host_name: "Michele",
        latitude: 45.44345,
        longitude: 12.32461,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32461, 45.44345]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19382738,
        name: "Venezia , la luna e tu",
        host_id: 135864563,
        host_name: "Maria Laura",
        latitude: 45.43023,
        longitude: 12.3604,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3604, 45.43023]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19384781,
        name: "NEW OPEN TOP LOCATION 3",
        host_id: 4806020,
        host_name: "Iber",
        latitude: 45.43748,
        longitude: 12.33595,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33595, 45.43748]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19404012,
        name: "Venetian bright house over a beautiful canal",
        host_id: 136024505,
        host_name: "Miriam E Giulio",
        latitude: 45.44061,
        longitude: 12.33698,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33698, 45.44061]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19405702,
        name: "Monolocale luminosissimo",
        host_id: 33186747,
        host_name: "Maria Grazia",
        latitude: 45.43616,
        longitude: 12.34273,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34273, 45.43616]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19420893,
        name: "Ca' della Carità - adorable attic in centre",
        host_id: 136163926,
        host_name: "Diana",
        latitude: 45.44183,
        longitude: 12.34106,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34106, 45.44183]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19443703,
        name:
          '"Little garden"- CENTER of VENICE- M (Phone number hidden by Airbnb)',
        host_id: 9443017,
        host_name: "Daniela",
        latitude: 45.43733,
        longitude: 12.32709,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32709, 45.43733]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19446735,
        name:
          "Residenza Al Mercato Grand Canal(L.T. M (Phone number hidden by Airbnb)",
        host_id: 5618111,
        host_name: "EasySuite",
        latitude: 45.43891,
        longitude: 12.33288,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33288, 45.43891]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19452566,
        name: "Sweet Room",
        host_id: 99514760,
        host_name: "Mohamed",
        latitude: 45.44606,
        longitude: 12.32587,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32587, 45.44606]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19462441,
        name: "CA' DEL GIGLIO",
        host_id: 14357135,
        host_name: "Rent It Venice",
        latitude: 45.43175,
        longitude: 12.33094,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33094, 45.43175]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19463105,
        name: "Lovely apartment with garden",
        host_id: 63040458,
        host_name: "Chiara",
        latitude: 45.44565,
        longitude: 12.32371,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32371, 45.44565]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19463718,
        name: "Otto House",
        host_id: 98131866,
        host_name: "Michele",
        latitude: 45.43558,
        longitude: 12.33524,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33524, 45.43558]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19468211,
        name: "Ca' Sara",
        host_id: 136567440,
        host_name: "Paolo",
        latitude: 45.43704,
        longitude: 12.3389,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3389, 45.43704]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19473122,
        name: "Double Room MARCO at RealVenetians House",
        host_id: 136614990,
        host_name: "Kiko",
        latitude: 45.43764,
        longitude: 12.35021,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35021, 45.43764]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19479073,
        name: "Spacious apartment near the Arsenale and Giardini",
        host_id: 97891725,
        host_name: "Alberto",
        latitude: 45.43497,
        longitude: 12.35941,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35941, 45.43497]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19493233,
        name: "Attic GIOVANNI at RealVenetians House",
        host_id: 136614990,
        host_name: "Kiko",
        latitude: 45.43796,
        longitude: 12.34957,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34957, 45.43796]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19496104,
        name: "Ca' Simonne",
        host_id: 34360885,
        host_name: "Samuel",
        latitude: 45.4353,
        longitude: 12.33997,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33997, 45.4353]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19499491,
        name: "Venezia Rialto",
        host_id: 39318682,
        host_name: "Chiara",
        latitude: 45.4382,
        longitude: 12.3328,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3328, 45.4382]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19500248,
        name: "Palazzo Boldù - Ca' Arlecchino",
        host_id: 4557370,
        host_name: "Giovanna",
        latitude: 45.43885,
        longitude: 12.34174,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34174, 45.43885]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19501491,
        name: "SPACIOUS AND BRIGHT APT.IN THE CENTER OF VENICE",
        host_id: 136919873,
        host_name: "Matilde",
        latitude: 45.4367,
        longitude: 12.3367,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3367, 45.4367]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19512069,
        name: "Ca' Fabio",
        host_id: 137032607,
        host_name: "Paolo",
        latitude: 45.43761,
        longitude: 12.34565,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34565, 45.43761]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19518661,
        name: "SAN MARCO ROOF TERRACE APARTMENT",
        host_id: 5862083,
        host_name: "Silvia",
        latitude: 45.43461,
        longitude: 12.33255,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33255, 45.43461]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19527102,
        name:
          "Double room MATTEO at RealVenetians M (Phone number hidden by Airbnb)",
        host_id: 136614990,
        host_name: "Kiko",
        latitude: 45.43723,
        longitude: 12.34807,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34807, 45.43723]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19541958,
        name:
          "Double room LUCA at RealVenetians M (Phone number hidden by Airbnb)",
        host_id: 136614990,
        host_name: "Kiko",
        latitude: 45.43726,
        longitude: 12.35015,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35015, 45.43726]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19543272,
        name: "Apt. Canova al Guggenheim-Museo",
        host_id: 39600986,
        host_name: "Christine",
        latitude: 45.43005,
        longitude: 12.33121,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33121, 45.43005]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19544561,
        name: "Apt. Rialto Mercato",
        host_id: 39600986,
        host_name: "Christine",
        latitude: 45.43851,
        longitude: 12.33256,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33256, 45.43851]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19546787,
        name: "Apartment Mazzoni- Elegant, modern and quiet flat",
        host_id: 137287637,
        host_name: "Roberto & Guadalupe",
        latitude: 45.44259,
        longitude: 12.32259,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32259, 45.44259]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19547536,
        name: "Ca' Valier",
        host_id: 46904188,
        host_name: "Mirco Optyflat",
        latitude: 45.43652,
        longitude: 12.34614,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34614, 45.43652]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19558316,
        name: "CA' ISABELLA modern flat close to the Biennale!",
        host_id: 1438903,
        host_name: "Barbara",
        latitude: 45.4372,
        longitude: 12.34702,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34702, 45.4372]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19560810,
        name: "Honeymoon Suite on the Grande Canal",
        host_id: 137445876,
        host_name: "Alain",
        latitude: 45.43473,
        longitude: 12.33036,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33036, 45.43473]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19569847,
        name: "Apt. San Pantalon con vista Canale",
        host_id: 39600986,
        host_name: "Christine",
        latitude: 45.43665,
        longitude: 12.3249,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3249, 45.43665]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19570008,
        name: "Sweety flat apartment",
        host_id: 137525290,
        host_name: "Giorgio",
        latitude: 45.43831,
        longitude: 12.33467,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33467, 45.43831]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19571245,
        name: "Stanza / Appartamento Agosto Venezia",
        host_id: 90097254,
        host_name: "Lucia",
        latitude: 45.44189,
        longitude: 12.32598,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32598, 45.44189]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19572982,
        name: "Ca' Potterina - Venices historical center",
        host_id: 137552204,
        host_name: "Francesca",
        latitude: 45.43955,
        longitude: 12.33848,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33848, 45.43955]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19579209,
        name: "CASA MARINA",
        host_id: 57249358,
        host_name: "Roberta",
        latitude: 45.43759,
        longitude: 12.32933,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32933, 45.43759]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19580072,
        name: "Tower Suite Cannaregio Canal View 207",
        host_id: 137621997,
        host_name: "Giorgia",
        latitude: 45.44454,
        longitude: 12.32796,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32796, 45.44454]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19584218,
        name: "Tower Suite Cannaregio Canal View 206",
        host_id: 137621997,
        host_name: "Giorgia",
        latitude: 45.44335,
        longitude: 12.32978,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32978, 45.44335]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19586297,
        name: "HOUSE CAMPIELLO DEI MELONI",
        host_id: 137672184,
        host_name: "Angela",
        latitude: 45.43789,
        longitude: 12.33059,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33059, 45.43789]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19603026,
        name: "Dorm Room Minutes from Piazza San Marco!",
        host_id: 121829634,
        host_name: "Annette",
        latitude: 45.43558,
        longitude: 12.34073,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34073, 45.43558]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19603538,
        name: "in the heart of venice , cozy flat with wifi",
        host_id: 368293,
        host_name: "Grazia",
        latitude: 45.43981,
        longitude: 12.34019,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34019, 45.43981]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19612812,
        name: "B&B Gondoletta",
        host_id: 2737768,
        host_name: "Alessandro",
        latitude: 45.43143,
        longitude: 12.35789,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35789, 45.43143]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19614310,
        name: "WellVenice Grand Canal",
        host_id: 41898872,
        host_name: "Cristina",
        latitude: 45.43756,
        longitude: 12.33269,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33269, 45.43756]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19622977,
        name: "Casa Mongolfiere in Venice",
        host_id: 138026852,
        host_name: "Tommaso",
        latitude: 45.43061,
        longitude: 12.35812,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35812, 45.43061]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19652528,
        name: "INN VENICE",
        host_id: 3437195,
        host_name: "Valentina",
        latitude: 45.44298,
        longitude: 12.32944,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32944, 45.44298]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19657744,
        name: "The dream flat (ID M (Phone number hidden by Airbnb)",
        host_id: 138384727,
        host_name: "Marco",
        latitude: 45.44203,
        longitude: 12.33717,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33717, 45.44203]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19669173,
        name: "TWO ROOMS - BIENNALE - SANT'ELENA - CASTELLO-",
        host_id: 138499101,
        host_name: "Alessandro",
        latitude: 45.4285,
        longitude: 12.36036,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.36036, 45.4285]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19674602,
        name: "Unique experience! Canal view with 4 windows!",
        host_id: 9852012,
        host_name: "Paolo",
        latitude: 45.44329,
        longitude: 12.33201,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33201, 45.44329]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19679116,
        name: "San Polo Canal View",
        host_id: 70816200,
        host_name: "Sante",
        latitude: 45.43643,
        longitude: 12.3296,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3296, 45.43643]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19685325,
        name: "Ca'Batongo - Elegant, central and confortable",
        host_id: 40558414,
        host_name: "Simona",
        latitude: 45.44069,
        longitude: 12.32314,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32314, 45.44069]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19688849,
        name: "Residenza Ludovica (L.T. M (Phone number hidden by Airbnb)",
        host_id: 5618111,
        host_name: "EasySuite",
        latitude: 45.4334,
        longitude: 12.33793,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33793, 45.4334]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19688872,
        name: "Your Biennale house",
        host_id: 138685601,
        host_name: "Cristiana",
        latitude: 45.43378,
        longitude: 12.35755,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35755, 45.43378]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19695825,
        name: "Guglia - Ghetto Vecchio-Jewish area",
        host_id: 116794529,
        host_name: "Massimo",
        latitude: 45.44348,
        longitude: 12.32553,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32553, 45.44348]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19711105,
        name:
          "Charming Venetian condo near Grand Canal - walk to Rialto Bridge & more!",
        host_id: 4339678,
        host_name: "Vacasa Italy - Venice",
        latitude: 45.43537,
        longitude: 12.34987,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34987, 45.43537]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19723611,
        name: "DolceVita Apartments N. 393 - Biennale Canal View",
        host_id: 8176475,
        host_name: "Eugenia",
        latitude: 45.43748,
        longitude: 12.35035,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35035, 45.43748]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19723910,
        name: "DolceVita Apartments N. 394 - Biennale Canal View",
        host_id: 8176475,
        host_name: "Eugenia",
        latitude: 45.43649,
        longitude: 12.35025,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35025, 45.43649]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19725076,
        name: "Cà La Tra Centrale",
        host_id: 45058432,
        host_name: "Filippo",
        latitude: 45.43679,
        longitude: 12.34914,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34914, 45.43679]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19725798,
        name: "Ve.N.I.Ce Cera Casa Margherita",
        host_id: 37864680,
        host_name: "Ve.N.I.Ce Immobiliare Cera",
        latitude: 45.43343,
        longitude: 12.32673,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32673, 45.43343]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19729481,
        name: "Secret Garden",
        host_id: 6973711,
        host_name: "Valentina",
        latitude: 45.44493,
        longitude: 12.32339,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32339, 45.44493]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19732024,
        name: "100 steps from the DOGE PALACE !!!!!",
        host_id: 41559211,
        host_name: "Venice",
        latitude: 45.43276,
        longitude: 12.3517,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3517, 45.43276]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19733602,
        name: "Casa Dior - 10 min walking from Rialto",
        host_id: 4493519,
        host_name: "Fabio",
        latitude: 45.44035,
        longitude: 12.32678,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32678, 45.44035]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19748588,
        name: "Appartamento con vista Zattere",
        host_id: 56638014,
        host_name: "Lea",
        latitude: 45.43187,
        longitude: 12.32211,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32211, 45.43187]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19764988,
        name: "Appartamento Biennale a quattro passi da San Marco",
        host_id: 139488423,
        host_name: "Lorenzo",
        latitude: 45.43456,
        longitude: 12.35173,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35173, 45.43456]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19777988,
        name: "Canal view apartment - 15' from St.Mark Square",
        host_id: 139626049,
        host_name: "Sandra",
        latitude: 45.44,
        longitude: 12.34477,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34477, 45.44]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19781008,
        name: "Architect's sunny apartment overlooking canal",
        host_id: 106747260,
        host_name: "Michael",
        latitude: 45.43414,
        longitude: 12.32678,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32678, 45.43414]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19793653,
        name: "Ca'Vénètes",
        host_id: 15708413,
        host_name: "Céline",
        latitude: 45.43659,
        longitude: 12.34996,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34996, 45.43659]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19803325,
        name: "Casa Cendon",
        host_id: 136904331,
        host_name: "Ettore",
        latitude: 45.44532,
        longitude: 12.32155,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32155, 45.44532]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19803392,
        name: "Relax Room",
        host_id: 99514760,
        host_name: "Mohamed",
        latitude: 45.44546,
        longitude: 12.32407,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32407, 45.44546]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19805351,
        name: "LAST MINUTE!!! VENEZIA casa SAN MARCO-RIALTO!",
        host_id: 135231529,
        host_name: "Daniela",
        latitude: 45.43685,
        longitude: 12.33742,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33742, 45.43685]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19818706,
        name: "Venice Ormesini Home",
        host_id: 13027859,
        host_name: "Diego",
        latitude: 45.44665,
        longitude: 12.32881,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32881, 45.44665]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19821738,
        name: "Venezia 2000",
        host_id: 140049194,
        host_name: "Stefano",
        latitude: 45.44134,
        longitude: 12.32554,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32554, 45.44134]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19827613,
        name: "La vita",
        host_id: 140105702,
        host_name: "Dario",
        latitude: 45.43259,
        longitude: 12.32902,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32902, 45.43259]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19836248,
        name: "Regina Flat, 300 m from Rialto bridge, 100 sqm",
        host_id: 73720041,
        host_name: "Giorgio",
        latitude: 45.43793,
        longitude: 12.33316,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33316, 45.43793]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19838910,
        name: "Romantic Venice in Luxurious Palazzo Cristo",
        host_id: 24611101,
        host_name: "Frederic",
        latitude: 45.43821,
        longitude: 12.34098,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34098, 45.43821]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19857782,
        name: "Cà Dell' Ombra nel cuore di Venezia centro storico",
        host_id: 138157088,
        host_name: "Claudio",
        latitude: 45.43912,
        longitude: 12.34006,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34006, 45.43912]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19857882,
        name: "GUGGENHEIM COLLECTION VENICE APARTMENT",
        host_id: 5862083,
        host_name: "Silvia",
        latitude: 45.43063,
        longitude: 12.33109,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33109, 45.43063]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19866097,
        name: "IN VERY CENTER  EXCLUSIVE PRIVATE BATHROOM wifi",
        host_id: 65007872,
        host_name: "Silvia",
        latitude: 45.43254,
        longitude: 12.32861,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32861, 45.43254]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19902640,
        name:
          "Spazioso e centrale appartamento nel sestiere San Marco, caldo e accogliente",
        host_id: 430236,
        host_name: "Paola",
        latitude: 45.43493,
        longitude: 12.33148,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33148, 45.43493]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19905638,
        name: "Al primo piano zona Cannaregio",
        host_id: 140958312,
        host_name: "Federico",
        latitude: 45.44633,
        longitude: 12.32293,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32293, 45.44633]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19906610,
        name: "CA VERBENA",
        host_id: 6759756,
        host_name: "Rudi",
        latitude: 45.43632,
        longitude: 12.32709,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32709, 45.43632]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19922385,
        name: "Gold Room in San Marco",
        host_id: 48092742,
        host_name: "Roby",
        latitude: 45.43739,
        longitude: 12.34308,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34308, 45.43739]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19922431,
        name: "Authentic area&very cosy&full equipment&terrace",
        host_id: 141128252,
        host_name: "Michka",
        latitude: 45.44756,
        longitude: 12.3302,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3302, 45.44756]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19925392,
        name: "ROBI Yellow room fiabe wi-fi casanova",
        host_id: 48092742,
        host_name: "Roby",
        latitude: 45.43729,
        longitude: 12.34231,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34231, 45.43729]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19926827,
        name: "Palazzo Cristo Home Hidden Away in a Quiet Courtyard",
        host_id: 29778828,
        host_name: "Anna Paola",
        latitude: 45.44005,
        longitude: 12.34297,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34297, 45.44005]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19935227,
        name: "Biennale Apartment with Garden, Newly renovated",
        host_id: 141263736,
        host_name: "Pierre",
        latitude: 45.42565,
        longitude: 12.36237,
        beds: 7,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.36237, 45.42565]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19937656,
        name: "ORIONE DESIGN FLAT BETWEEN SAN MARCO AND ARSENALE",
        host_id: 141282928,
        host_name: "Thomas",
        latitude: 45.43795,
        longitude: 12.34385,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34385, 45.43795]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19943803,
        name: "The Other Serenissima (with A/C)",
        host_id: 74299639,
        host_name: "Claudio",
        latitude: 45.43363,
        longitude: 12.35716,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35716, 45.43363]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19955534,
        name: "Lovely alcove on the  rooftops of Venice",
        host_id: 17669402,
        host_name: "Daniela",
        latitude: 45.43414,
        longitude: 12.33656,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33656, 45.43414]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19957924,
        name: "MIRACOLINO",
        host_id: 12982157,
        host_name: "Locappart",
        latitude: 45.43961,
        longitude: 12.33946,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33946, 45.43961]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19960327,
        name: "1 bedroom , Fauré, Venice",
        host_id: 97206133,
        host_name: "An",
        latitude: 45.43096,
        longitude: 12.33011,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33011, 45.43096]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19960767,
        name: "2 bedrooms, Elisa Singer, Venice",
        host_id: 97206133,
        host_name: "An",
        latitude: 45.4309,
        longitude: 12.32953,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32953, 45.4309]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19961867,
        name: "Riva Excelsior Apartment",
        host_id: 141518804,
        host_name: "Alessandra",
        latitude: 45.43075,
        longitude: 12.35374,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35374, 45.43075]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19963722,
        name: "Maison Sophie",
        host_id: 141539265,
        host_name: "Giorgia",
        latitude: 45.44016,
        longitude: 12.32287,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32287, 45.44016]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19980915,
        name: "Giglio - San Marco",
        host_id: 141711650,
        host_name: "Giacomo",
        latitude: 45.43198,
        longitude: 12.33332,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33332, 45.43198]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19994437,
        name: "Sunny House a Venezia",
        host_id: 141859214,
        host_name: "Marco",
        latitude: 45.42711,
        longitude: 12.36041,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.36041, 45.42711]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19995150,
        name: "Gibs & Gibs apartment",
        host_id: 141362605,
        host_name: "Gibs&Gibs",
        latitude: 45.44611,
        longitude: 12.32881,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32881, 45.44611]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19997194,
        name: "Spacious 2nd floor apartment in Cannaregio",
        host_id: 60778507,
        host_name: "Viorica & Chris",
        latitude: 45.44228,
        longitude: 12.33094,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33094, 45.44228]] },
    },
    {
      type: "Feature",
      properties: {
        id: 19998396,
        name: "Beautiful apartment with a terrace",
        host_id: 60778507,
        host_name: "Viorica & Chris",
        latitude: 45.44324,
        longitude: 12.33119,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33119, 45.44324]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20033951,
        name: "Centralissimo tra San Marco e Palazzo Grassi",
        host_id: 21675715,
        host_name: "Flavia Emanuela",
        latitude: 45.43457,
        longitude: 12.32883,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32883, 45.43457]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20061091,
        name: "Grand Canal View and Relax from Deck of the Vivid Apartment",
        host_id: 36053748,
        host_name: "Mick",
        latitude: 45.43136,
        longitude: 12.33182,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33182, 45.43136]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20061484,
        name: "Stunning Studio with Canal Views!",
        host_id: 89512390,
        host_name: "G&T",
        latitude: 45.42975,
        longitude: 12.32933,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32933, 45.42975]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20062264,
        name: "GIARDINO SEGRETO Apartment with terrace - Rialto",
        host_id: 142572789,
        host_name: "Francesco",
        latitude: 45.43746,
        longitude: 12.3221,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3221, 45.43746]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20062559,
        name: "Renovated independent house with  pivate garden",
        host_id: 142576044,
        host_name: "Marco",
        latitude: 45.44296,
        longitude: 12.33951,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33951, 45.44296]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20065575,
        name: "Economy Double Room  Best Holidays",
        host_id: 25022476,
        host_name: "Antonio",
        latitude: 45.43981,
        longitude: 12.33249,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33249, 45.43981]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20087086,
        name: "Michele Home Venice 2",
        host_id: 142812280,
        host_name: "Michele",
        latitude: 45.43423,
        longitude: 12.347,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.347, 45.43423]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20091197,
        name: "Imperial 5 Room in San Marcuola",
        host_id: 13500918,
        host_name: "Mark",
        latitude: 45.44285,
        longitude: 12.32956,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32956, 45.44285]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20092639,
        name: 'Appartamento " SARTORI"',
        host_id: 137144369,
        host_name: "Mario",
        latitude: 45.44462,
        longitude: 12.32765,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32765, 45.44462]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20097236,
        name: "Casa Gaffaro",
        host_id: 142932653,
        host_name: "Elena",
        latitude: 45.43727,
        longitude: 12.32287,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32287, 45.43727]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20102603,
        name: "Michele home Venice 4",
        host_id: 142812280,
        host_name: "Michele",
        latitude: 45.43589,
        longitude: 12.34817,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34817, 45.43589]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20115783,
        name: "SAN MARCO SQUARE top floor! just 30mt from S.Marco",
        host_id: 4007520,
        host_name: "Isabella",
        latitude: 45.43268,
        longitude: 12.33704,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33704, 45.43268]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20118352,
        name: "MAZZONI 15 MODERN FLAT BY VENICE TRAIN STATION",
        host_id: 142999139,
        host_name: "Thomas",
        latitude: 45.44274,
        longitude: 12.31921,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31921, 45.44274]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20129057,
        name: "San Stae Charme Apartment Gran Canal",
        host_id: 142474402,
        host_name: "Fabio E Laura",
        latitude: 45.44087,
        longitude: 12.32929,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32929, 45.44087]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20141836,
        name: "NEW Ca' Magica: unique&spacious, heart of Venice",
        host_id: 36317882,
        host_name: "Elena",
        latitude: 45.44016,
        longitude: 12.32674,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32674, 45.44016]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20153377,
        name: "Open space in Venice city center",
        host_id: 11162656,
        host_name: "Débora",
        latitude: 45.43955,
        longitude: 12.32594,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32594, 45.43955]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20165160,
        name: "Michele Home Venice 1",
        host_id: 142812280,
        host_name: "Michele",
        latitude: 45.43678,
        longitude: 12.34761,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34761, 45.43678]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20185109,
        name: "Traditional  private room",
        host_id: 143554035,
        host_name: "Elias",
        latitude: 45.44138,
        longitude: 12.3255,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3255, 45.44138]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20188748,
        name: "Traditional house",
        host_id: 143554035,
        host_name: "Elias",
        latitude: 45.44042,
        longitude: 12.32632,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32632, 45.44042]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20199725,
        name: "Ca' Cerchieri 1 Garden View",
        host_id: 669047,
        host_name: "Viewsonvenice",
        latitude: 45.43185,
        longitude: 12.32722,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32722, 45.43185]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20201402,
        name: "Appartamento bilocale Santa Marta",
        host_id: 143873157,
        host_name: "Federico",
        latitude: 45.43344,
        longitude: 12.31851,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31851, 45.43344]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20213463,
        name: "Two balconies with canal views",
        host_id: 143987056,
        host_name: "Stefano",
        latitude: 45.44378,
        longitude: 12.33246,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33246, 45.44378]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20223353,
        name: "PETITE MAISON - Cannaregio district",
        host_id: 10189388,
        host_name: "Raffaella",
        latitude: 45.4444,
        longitude: 12.32707,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32707, 45.4444]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20226504,
        name: "Casaeva",
        host_id: 144114141,
        host_name: "Eva",
        latitude: 45.42755,
        longitude: 12.3616,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3616, 45.42755]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20241316,
        name: "Art gold Room 3 San Marco",
        host_id: 13500918,
        host_name: "Mark",
        latitude: 45.43605,
        longitude: 12.34206,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34206, 45.43605]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20249725,
        name: "LA STORICA VENEZIA",
        host_id: 51324480,
        host_name: "Laura",
        latitude: 45.44414,
        longitude: 12.32618,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32618, 45.44414]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20253097,
        name: "Giulietta&Romeo",
        host_id: 143973367,
        host_name: "Giulia",
        latitude: 45.44444,
        longitude: 12.33136,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33136, 45.44444]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20260010,
        name: "Porta del Casino' di Venezia Apartment",
        host_id: 144404317,
        host_name: "Caterina",
        latitude: 45.44249,
        longitude: 12.33076,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33076, 45.44249]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20266985,
        name: "Casanova's Place",
        host_id: 144476546,
        host_name: "Nicola",
        latitude: 45.43701,
        longitude: 12.33979,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33979, 45.43701]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20276894,
        name: "San Polo new apartment with private garden",
        host_id: 41684464,
        host_name: "VeneziaImmobiliare Sas Di",
        latitude: 45.43853,
        longitude: 12.3274,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3274, 45.43853]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20291675,
        name: "Venice Luxury in the Antique Palace of the Doge",
        host_id: 108101003,
        host_name: "Cap",
        latitude: 45.43495,
        longitude: 12.32046,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32046, 45.43495]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20312565,
        name: "HOUSE OF ARTIST - SUPER FOR FAMILIES !!",
        host_id: 144909465,
        host_name: "Alessia",
        latitude: 45.43768,
        longitude: 12.34124,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34124, 45.43768]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20314274,
        name: "7 WINDOWS ON VENICE",
        host_id: 144924176,
        host_name: "Elde",
        latitude: 45.444,
        longitude: 12.33376,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33376, 45.444]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20317766,
        name: "Living in Venice like a local",
        host_id: 14783162,
        host_name: "Francesca Rosalba Lucia",
        latitude: 45.44291,
        longitude: 12.34077,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34077, 45.44291]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20320957,
        name: "Large single room 200 m from S. Mark",
        host_id: 34468601,
        host_name: "Nicola",
        latitude: 45.43599,
        longitude: 12.33918,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33918, 45.43599]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20348665,
        name: "Filippo",
        host_id: 24061697,
        host_name: "Nadia",
        latitude: 45.43418,
        longitude: 12.34263,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34263, 45.43418]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20351874,
        name: "Dream in Venice",
        host_id: 145006511,
        host_name: "Hélène",
        latitude: 45.43986,
        longitude: 12.33659,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33659, 45.43986]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20372338,
        name: "DolceVita Apartments N. 397 - Biennale Canal View",
        host_id: 8176475,
        host_name: "Eugenia",
        latitude: 45.43814,
        longitude: 12.3391,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3391, 45.43814]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20378802,
        name: "Cannaregio Tre Archi Spacious apartment",
        host_id: 41684464,
        host_name: "VeneziaImmobiliare Sas Di",
        latitude: 45.44483,
        longitude: 12.32006,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32006, 45.44483]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20379772,
        name: "Venezia Cà Streta",
        host_id: 145337613,
        host_name: "Lucia",
        latitude: 45.43214,
        longitude: 12.3175,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3175, 45.43214]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20380057,
        name: "Boldù Terrace (L.T. M (Phone number hidden by Airbnb)",
        host_id: 5618111,
        host_name: "EasySuite",
        latitude: 45.44484,
        longitude: 12.33689,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33689, 45.44484]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20391782,
        name: "Ca'Renata",
        host_id: 112263996,
        host_name: "Claudius Andrea",
        latitude: 45.43278,
        longitude: 12.3523,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3523, 45.43278]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20409637,
        name: "Ca del Carro  in the heart of Venice",
        host_id: 141345803,
        host_name: "Samantha",
        latitude: 45.43359,
        longitude: 12.33497,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33497, 45.43359]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20421948,
        name: "Cà dei zoti 3 - SAN MARCO with luggage room",
        host_id: 2825961,
        host_name: "Maria Beatrice",
        latitude: 45.43442,
        longitude: 12.33078,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33078, 45.43442]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20422641,
        name: "Big doubleroom in Cannaregio, SUPER LOCATION!!!",
        host_id: 145682142,
        host_name: "Salvo",
        latitude: 45.44532,
        longitude: 12.32956,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32956, 45.44532]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20429491,
        name: "Apartment near Biennale Teatre",
        host_id: 5395291,
        host_name: "Beatrice",
        latitude: 45.4357,
        longitude: 12.34782,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34782, 45.4357]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20474056,
        name: "Venice cozy studio with canal view",
        host_id: 5395291,
        host_name: "Beatrice",
        latitude: 45.44692,
        longitude: 12.32452,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32452, 45.44692]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20475095,
        name: "2 Central studio city centre",
        host_id: 5395291,
        host_name: "Beatrice",
        latitude: 45.44615,
        longitude: 12.32508,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32508, 45.44615]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20509089,
        name: "Venice Cozy studio with canal view 3",
        host_id: 5395291,
        host_name: "Beatrice",
        latitude: 45.4474,
        longitude: 12.32529,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32529, 45.4474]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20509967,
        name: "City centre apartment/ new 2 bathrooms",
        host_id: 5395291,
        host_name: "Beatrice",
        latitude: 45.44594,
        longitude: 12.32609,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32609, 45.44594]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20510654,
        name: "4 -central new Studio with garden view",
        host_id: 5395291,
        host_name: "Beatrice",
        latitude: 45.44561,
        longitude: 12.32573,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32573, 45.44561]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20514314,
        name: "LUXURY TOP FLOOR LOFT OVERLOOKING ARSENALE + WI-FI",
        host_id: 84505120,
        host_name: "Silvia",
        latitude: 45.43708,
        longitude: 12.34875,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34875, 45.43708]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20522486,
        name: "Rosa House Venezia",
        host_id: 146514548,
        host_name: "Anna",
        latitude: 45.44058,
        longitude: 12.33136,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33136, 45.44058]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20533478,
        name: "Cozy Room with Shared Bathroom",
        host_id: 25022476,
        host_name: "Antonio",
        latitude: 45.4399,
        longitude: 12.33259,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33259, 45.4399]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20533903,
        name: "Cheap Room in Venice",
        host_id: 25022476,
        host_name: "Antonio",
        latitude: 45.43836,
        longitude: 12.3323,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3323, 45.43836]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20537572,
        name: "Clara's Home  - Cod. id. M (Phone number hidden by Airbnb)",
        host_id: 146643793,
        host_name: "Michela",
        latitude: 45.44107,
        longitude: 12.32677,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32677, 45.44107]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20546395,
        name: "Ca' Ponte Vecchio - Rialto",
        host_id: 146715659,
        host_name: "Micol",
        latitude: 45.43925,
        longitude: 12.33673,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33673, 45.43925]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20549903,
        name: "Casa Celsi, 2 bedrooms, Arsenal view, WiFi, A.C.",
        host_id: 4879104,
        host_name: "Giovanni",
        latitude: 45.43757,
        longitude: 12.348,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.348, 45.43757]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20563107,
        name: "Appartamento a Venezia Piazza San Marco",
        host_id: 129835471,
        host_name: "Nicoletta",
        latitude: 45.43492,
        longitude: 12.33919,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33919, 45.43492]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20565757,
        name: "OLIMPIA'S  STUDIO",
        host_id: 146888072,
        host_name: "Cristina",
        latitude: 45.43849,
        longitude: 12.34697,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34697, 45.43849]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20566310,
        name: "The romantic heart of old Venice",
        host_id: 1646068,
        host_name: "Fabiano",
        latitude: 45.43625,
        longitude: 12.32963,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32963, 45.43625]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20584911,
        name: "ATTICO LUMINOSISSIMO MINI APPARTAMENTO A VENEZIA",
        host_id: 144127934,
        host_name: "Marguerite",
        latitude: 45.4356,
        longitude: 12.34656,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34656, 45.4356]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20589372,
        name: "Single room, canal view,SUPER LOCATION!!!",
        host_id: 147104851,
        host_name: "Salvo Casa",
        latitude: 45.44691,
        longitude: 12.32796,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32796, 45.44691]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20593338,
        name: "❤推荐wifi+ARSENALE in HEART OF VENICE Castello",
        host_id: 35144066,
        host_name: "Xie",
        latitude: 45.43248,
        longitude: 12.34994,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34994, 45.43248]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20594841,
        name: "Lagoon View Apartment - WiFi",
        host_id: 77759029,
        host_name: "Francesca",
        latitude: 45.44192,
        longitude: 12.34195,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34195, 45.44192]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20595989,
        name: "SUITE*EXSCLUSIVE~NEAR TRAIN ~WIFI~LARGE BATHROOM",
        host_id: 147169056,
        host_name: "Lucia",
        latitude: 45.4397,
        longitude: 12.32605,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32605, 45.4397]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20614541,
        name: "Your romantic loft in Venice",
        host_id: 87964488,
        host_name: "Luca",
        latitude: 45.42585,
        longitude: 12.32575,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32575, 45.42585]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20616213,
        name: "Little apartment REALLY in Venice",
        host_id: 147357145,
        host_name: "Claudio",
        latitude: 45.43302,
        longitude: 12.32603,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32603, 45.43302]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20627459,
        name: "Avogaria - Very Sunny 2 Bedroom on 2 Floors",
        host_id: 393913,
        host_name: "Luca",
        latitude: 45.43116,
        longitude: 12.32002,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32002, 45.43116]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20644225,
        name: "DolceVita Apartments N. 396 Biennale",
        host_id: 8176475,
        host_name: "Eugenia",
        latitude: 45.4325,
        longitude: 12.35164,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35164, 45.4325]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20648623,
        name: "Apt. Splendid Venice (250m from St. Mark's Square)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.4349,
        longitude: 12.33601,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33601, 45.4349]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20658562,
        name: "Rialto suite top shining flat",
        host_id: 13500918,
        host_name: "Mark",
        latitude: 45.43749,
        longitude: 12.33646,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33646, 45.43749]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20670170,
        name: "Ca' Soranzo",
        host_id: 46904188,
        host_name: "Mirco Optyflat",
        latitude: 45.44366,
        longitude: 12.32675,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32675, 45.44366]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20682753,
        name: "LUXURY APARTMENT WITH CANAL VIEW",
        host_id: 23598673,
        host_name: "Patricia",
        latitude: 45.43912,
        longitude: 12.32856,
        beds: 8,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32856, 45.43912]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20688315,
        name: "Donatello",
        host_id: 148054092,
        host_name: "Steve S.R.L.",
        latitude: 45.43704,
        longitude: 12.33782,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33782, 45.43704]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20688628,
        name: "Design Apartment Suite735",
        host_id: 12784012,
        host_name: "Federica",
        latitude: 45.42961,
        longitude: 12.32979,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32979, 45.42961]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20694515,
        name: "Apartment Life in Venice",
        host_id: 148111203,
        host_name: "Elisa",
        latitude: 45.43935,
        longitude: 12.33716,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33716, 45.43935]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20702051,
        name: "Large Room with bathtube and king size bed",
        host_id: 144616405,
        host_name: "Ruggero",
        latitude: 45.43202,
        longitude: 12.32478,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32478, 45.43202]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20702393,
        name: "APPARTAMENTO VENEZIA SAN SAMUELE",
        host_id: 51054790,
        host_name: "Anna",
        latitude: 45.43451,
        longitude: 12.3303,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3303, 45.43451]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20703707,
        name: "Wi-fi Glamour apartment",
        host_id: 2602970,
        host_name: "Elena",
        latitude: 45.44023,
        longitude: 12.33505,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33505, 45.44023]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20703738,
        name: "PRETTY APARTMENT WI-FI",
        host_id: 2602970,
        host_name: "Elena",
        latitude: 45.44162,
        longitude: 12.33594,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33594, 45.44162]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20703746,
        name: "Attic at East Castello with panoramic altana",
        host_id: 89330482,
        host_name: "Antonio",
        latitude: 45.43178,
        longitude: 12.35911,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35911, 45.43178]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20703831,
        name: "Lovely in Venice.",
        host_id: 2602970,
        host_name: "Elena",
        latitude: 45.43109,
        longitude: 12.31883,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31883, 45.43109]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20704543,
        name: "Elegant and cozy in the heart of Venice",
        host_id: 148203085,
        host_name: "Imelde",
        latitude: 45.43915,
        longitude: 12.33383,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33383, 45.43915]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20704844,
        name: "Ca' de la Palma - Garden house",
        host_id: 148215438,
        host_name: "Marta",
        latitude: 45.44484,
        longitude: 12.33207,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33207, 45.44484]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20706530,
        name: "White Nest Canal View",
        host_id: 148232383,
        host_name: "Domenico",
        latitude: 45.4385,
        longitude: 12.32023,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32023, 45.4385]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20718519,
        name: "Charming Town House with terrace",
        host_id: 5656401,
        host_name: "Manila",
        latitude: 45.43723,
        longitude: 12.33547,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33547, 45.43723]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20720508,
        name: "Ca' dei Orbi",
        host_id: 148365476,
        host_name: "Giulio",
        latitude: 45.43844,
        longitude: 12.34163,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34163, 45.43844]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20752583,
        name: "APARTMENT IN THE HEART OF VENICE!",
        host_id: 148628411,
        host_name: "Valentina",
        latitude: 45.43725,
        longitude: 12.33625,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33625, 45.43725]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20753317,
        name: "Levante room - B&B la Sensa casa tipica a Venezia",
        host_id: 93685127,
        host_name: "Giacomo",
        latitude: 45.44644,
        longitude: 12.33253,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33253, 45.44644]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20758017,
        name: "Casanova View on the Canal 3",
        host_id: 13500918,
        host_name: "Mark",
        latitude: 45.44344,
        longitude: 12.32487,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32487, 45.44344]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20765179,
        name: "Appartamento di charme in zona elegante a Venezia",
        host_id: 28618552,
        host_name: "Alessandra",
        latitude: 45.4325,
        longitude: 12.32894,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32894, 45.4325]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20766090,
        name: "Elegant apartment on Frari's Church",
        host_id: 148761518,
        host_name: "Paola",
        latitude: 45.4389,
        longitude: 12.3275,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3275, 45.4389]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20767915,
        name: "Amazing view on canal and rooftops near Rialto",
        host_id: 57091334,
        host_name: "Cristina E Riccardo",
        latitude: 45.44333,
        longitude: 12.33971,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33971, 45.44333]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20769850,
        name: "Apartment Ca' Tintoretta",
        host_id: 148800509,
        host_name: "Patrizia",
        latitude: 45.44269,
        longitude: 12.32923,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32923, 45.44269]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20770032,
        name: "NEW OPEN TOP LOCATION 4",
        host_id: 4806020,
        host_name: "Iber",
        latitude: 45.43551,
        longitude: 12.33266,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33266, 45.43551]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20772508,
        name: "Ca del Duca , Palazzo storico",
        host_id: 3635673,
        host_name: "Marina",
        latitude: 45.43372,
        longitude: 12.32851,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32851, 45.43372]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20778829,
        name: "Feelin' San Marco",
        host_id: 148905379,
        host_name: "Mattia",
        latitude: 45.43518,
        longitude: 12.33207,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33207, 45.43518]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20779036,
        name: "Ca' Altanella, amazing views from the terrace!",
        host_id: 12113015,
        host_name: "Mario",
        latitude: 45.42471,
        longitude: 12.32679,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32679, 45.42471]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20779102,
        name: "Ca' Delle Colonne",
        host_id: 43843547,
        host_name: "Matteo",
        latitude: 45.44156,
        longitude: 12.32801,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32801, 45.44156]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20779729,
        name: "Venezia Luxury Biennale Design",
        host_id: 127031595,
        host_name: "Dott Borella",
        latitude: 45.43282,
        longitude: 12.3575,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3575, 45.43282]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20800387,
        name: "Huge bedroom with private bathroom in S. Mark",
        host_id: 34468601,
        host_name: "Nicola",
        latitude: 45.43546,
        longitude: 12.33878,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33878, 45.43546]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20805675,
        name: "Ca' Bianca",
        host_id: 149185957,
        host_name: "Federica",
        latitude: 45.43899,
        longitude: 12.34075,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34075, 45.43899]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20851770,
        name: "Venice Friends room 1 with shared bathroom",
        host_id: 13027859,
        host_name: "Diego",
        latitude: 45.44281,
        longitude: 12.32772,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32772, 45.44281]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20854557,
        name: 'Venice Friends room "2" with shared bathroom',
        host_id: 13027859,
        host_name: "Diego",
        latitude: 45.44251,
        longitude: 12.32963,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32963, 45.44251]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20855418,
        name: "Appartamento Sissy*",
        host_id: 81853820,
        host_name: "Dirie",
        latitude: 45.4449,
        longitude: 12.31912,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31912, 45.4449]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20856488,
        name: "CASA FLORA VENEZIA",
        host_id: 149675469,
        host_name: "Gioele",
        latitude: 45.43191,
        longitude: 12.33386,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33386, 45.43191]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20871712,
        name: "Jewel of Venice,suite San Lio",
        host_id: 149831127,
        host_name: "Marino",
        latitude: 45.43709,
        longitude: 12.3381,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3381, 45.43709]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20879280,
        name: "CA' CORREGGIO canal view",
        host_id: 38346442,
        host_name: "Giancarlo",
        latitude: 45.44026,
        longitude: 12.33301,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33301, 45.44026]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20879485,
        name: "Refined brand new apart in the most genuine Venice",
        host_id: 40852487,
        host_name: "Andrew",
        latitude: 45.43633,
        longitude: 12.34325,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34325, 45.43633]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20880533,
        name: "Large bedroom with private bathroom in San Marco",
        host_id: 15695997,
        host_name: "Natalie",
        latitude: 45.43601,
        longitude: 12.33779,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33779, 45.43601]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20883898,
        name: "Elegante camera doppia con bagno privato",
        host_id: 1602219,
        host_name: "Alfonso",
        latitude: 45.42792,
        longitude: 12.35909,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35909, 45.42792]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20885125,
        name: "Tranquilla casa privata a Venezia",
        host_id: 30517332,
        host_name: "Alessia",
        latitude: 45.43589,
        longitude: 12.32389,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32389, 45.43589]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20892682,
        name: "Venezia quadrupla home lovers",
        host_id: 23182155,
        host_name: "Stefano Roberta",
        latitude: 45.43788,
        longitude: 12.32621,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32621, 45.43788]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20895974,
        name: "Suite nuziale Home Lovers",
        host_id: 29619859,
        host_name: "Stefano",
        latitude: 45.43792,
        longitude: 12.32589,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32589, 45.43792]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20922612,
        name: "CA’ DEL GELSO: GREAT VILLA IN THE CENTRE OF VENICE",
        host_id: 113088654,
        host_name: "Guglielmo",
        latitude: 45.44337,
        longitude: 12.33924,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33924, 45.44337]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20945798,
        name: "Residence on the Canal",
        host_id: 149843636,
        host_name: "Dimitri&Valentina",
        latitude: 45.43304,
        longitude: 12.32525,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32525, 45.43304]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20952130,
        name: "CA' DELLE MUNEGHE ANTICO CONVENTO DEL XVI SECOLO",
        host_id: 4350749,
        host_name: "Roberto",
        latitude: 45.44785,
        longitude: 12.32796,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32796, 45.44785]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20955800,
        name: "Panoramic views on the Frari Church with terrace!",
        host_id: 11876634,
        host_name: "Lucia E Riccardo",
        latitude: 45.43557,
        longitude: 12.3251,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3251, 45.43557]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20956190,
        name: "Ca'Lodovica",
        host_id: 10909648,
        host_name: "Francesco",
        latitude: 45.43345,
        longitude: 12.33548,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33548, 45.43345]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20964422,
        name: "Santi Apostoli Apartment",
        host_id: 24669207,
        host_name: "Milo",
        latitude: 45.4408,
        longitude: 12.33985,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33985, 45.4408]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20964814,
        name: "CRUISE HARBOR NEXT 4pax, mob aircond, wifi",
        host_id: 17534457,
        host_name: "Abaca",
        latitude: 45.43112,
        longitude: 12.31921,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31921, 45.43112]] },
    },
    {
      type: "Feature",
      properties: {
        id: 20974646,
        name: 'Campiello - close to terminals and the "vaporetto"',
        host_id: 150917589,
        host_name: "Ada",
        latitude: 45.44195,
        longitude: 12.3275,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3275, 45.44195]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21009379,
        name: "Apartment Ca'D'oro",
        host_id: 60488055,
        host_name: "Marco & Andrea",
        latitude: 45.44299,
        longitude: 12.33429,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33429, 45.44299]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21033588,
        name: "Casa CLIP _ 12 windows",
        host_id: 9199186,
        host_name: "Valentina",
        latitude: 45.43359,
        longitude: 12.32566,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32566, 45.43359]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21038036,
        name: "Damascà - Canal view central apartment",
        host_id: 52495162,
        host_name: "Carlotta",
        latitude: 45.43274,
        longitude: 12.32663,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32663, 45.43274]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21048020,
        name: "CASETTA BIENNALE ARSENALE VENICEILOVEYOU",
        host_id: 78873399,
        host_name: "Florence",
        latitude: 45.43512,
        longitude: 12.34941,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34941, 45.43512]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21049149,
        name: "CA' MARTINA ****   S.Margherita",
        host_id: 134117431,
        host_name: "Casa Martina",
        latitude: 45.43394,
        longitude: 12.3257,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3257, 45.43394]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21051272,
        name: "Nel cuore di venezia",
        host_id: 2602970,
        host_name: "Elena",
        latitude: 45.44134,
        longitude: 12.33501,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33501, 45.44134]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21071543,
        name: "Studio Apartment San Marco 1825.it",
        host_id: 46390885,
        host_name: "Beppe & Amber",
        latitude: 45.43343,
        longitude: 12.3356,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3356, 45.43343]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21084638,
        name: "Casa ELIA",
        host_id: 132295055,
        host_name: "Eleonora",
        latitude: 45.44606,
        longitude: 12.3283,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3283, 45.44606]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21087666,
        name: "ROMANTICO WEEKEND A VENEZIA ××× SPECIAL OFFER!",
        host_id: 152020900,
        host_name: "Bruna",
        latitude: 45.43949,
        longitude: 12.33397,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33397, 45.43949]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21094928,
        name: "Bright new apartment in a great location!",
        host_id: 7960197,
        host_name: "Alberto",
        latitude: 45.44751,
        longitude: 12.32415,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32415, 45.44751]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21101760,
        name: "Apartment on the canal with terrace - X403",
        host_id: 15178567,
        host_name: "Paolo",
        latitude: 45.43746,
        longitude: 12.34122,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34122, 45.43746]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21103512,
        name: "Rialto two bedroom apartment, 2nd floor X601",
        host_id: 15178567,
        host_name: "Paolo",
        latitude: 45.43765,
        longitude: 12.33756,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33756, 45.43765]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21115337,
        name: "VeniceVillas Ca Riolfo, Rialto",
        host_id: 294951,
        host_name: "VeniceVillas Di Enzo",
        latitude: 45.43952,
        longitude: 12.33436,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33436, 45.43952]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21116555,
        name: "Sunny very central apartment X105",
        host_id: 15178567,
        host_name: "Paolo",
        latitude: 45.43676,
        longitude: 12.33878,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33878, 45.43676]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21121221,
        name: "Relax Room 8 central Venice",
        host_id: 48092742,
        host_name: "Roby",
        latitude: 45.44432,
        longitude: 12.32835,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32835, 45.44432]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21122811,
        name: "Cozy room in a welcoming family",
        host_id: 143665697,
        host_name: "Valentina",
        latitude: 45.4308,
        longitude: 12.3251,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3251, 45.4308]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21130243,
        name: "* Attic Bedroom* in Venice Cannaregio",
        host_id: 152425526,
        host_name: "Francesca",
        latitude: 45.44597,
        longitude: 12.3271,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3271, 45.44597]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21131273,
        name: "Picturesque apartment on canals X402",
        host_id: 15178567,
        host_name: "Paolo",
        latitude: 45.43694,
        longitude: 12.34023,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34023, 45.43694]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21132923,
        name: "Very central spacious apartment with terrace X83",
        host_id: 15178567,
        host_name: "Paolo",
        latitude: 45.43736,
        longitude: 12.33751,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33751, 45.43736]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21148397,
        name: "Casa delle Gondole",
        host_id: 152590483,
        host_name: "Priscilla",
        latitude: 45.43886,
        longitude: 12.32736,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32736, 45.43886]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21158987,
        name: "Ca' Dolce: Luxury apartment near Accademia",
        host_id: 60070743,
        host_name: "Maria",
        latitude: 45.43083,
        longitude: 12.32691,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32691, 45.43083]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21169039,
        name: "Ca' Dei Toso",
        host_id: 152810210,
        host_name: "Marco",
        latitude: 45.43019,
        longitude: 12.35751,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35751, 45.43019]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21179728,
        name: "✧Modern comfort with confidential canal view✧",
        host_id: 152930402,
        host_name: "Alessandra",
        latitude: 45.43946,
        longitude: 12.32888,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32888, 45.43946]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21179985,
        name: "Ca' Barozzi - Yellow double room -",
        host_id: 88553273,
        host_name: "Ca' Barozzi",
        latitude: 45.43318,
        longitude: 12.31805,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31805, 45.43318]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21180693,
        name: "CaMeo apartment",
        host_id: 152936384,
        host_name: "Valter",
        latitude: 45.43349,
        longitude: 12.35694,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35694, 45.43349]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21224563,
        name: "Mini loft in Venice",
        host_id: 153364915,
        host_name: "Giovanni",
        latitude: 45.43426,
        longitude: 12.31797,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31797, 45.43426]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21226752,
        name: "Green large silent room in the very center",
        host_id: 31276705,
        host_name: "Mila",
        latitude: 45.44378,
        longitude: 12.33,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33, 45.44378]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21229021,
        name: "Venezia Ormesini @",
        host_id: 21885006,
        host_name: "Lisa",
        latitude: 45.44579,
        longitude: 12.32881,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32881, 45.44579]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21249781,
        name: "S. Lorenzo 5122",
        host_id: 46904188,
        host_name: "Mirco Optyflat",
        latitude: 45.43613,
        longitude: 12.34299,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34299, 45.43613]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21250027,
        name: "99 steps",
        host_id: 116360027,
        host_name: "Viola",
        latitude: 45.43277,
        longitude: 12.33533,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33533, 45.43277]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21271160,
        name: "beautiful apartment in the ancient Jewish ghetto",
        host_id: 37866220,
        host_name: "Piero",
        latitude: 45.44545,
        longitude: 12.32577,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32577, 45.44545]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21288521,
        name: "Cute and romantic apartment near Campo San Polo",
        host_id: 1135650,
        host_name: "Massimo",
        latitude: 45.43697,
        longitude: 12.3283,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3283, 45.43697]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21291206,
        name: "Galizzi Apartment (cod. id. M (Phone number hidden by Airbnb)",
        host_id: 154054024,
        host_name: "Marco",
        latitude: 45.43848,
        longitude: 12.33314,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33314, 45.43848]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21299239,
        name: "Appartamento Venezia vicino Stazione-Ponte Guglie",
        host_id: 152800896,
        host_name: "Patrizia",
        latitude: 45.44348,
        longitude: 12.32448,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32448, 45.44348]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21301149,
        name: "Galizzi  Apartment for 2 people",
        host_id: 154054024,
        host_name: "Marco",
        latitude: 45.43739,
        longitude: 12.33302,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33302, 45.43739]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21303421,
        name: "Double room with shared bathroom @Ca' Bibi Venezia",
        host_id: 61291476,
        host_name: "Sarah",
        latitude: 45.44362,
        longitude: 12.32644,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32644, 45.44362]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21303464,
        name: "Double economy room with shared bathroom @Ca' Bibi",
        host_id: 61291476,
        host_name: "Sarah",
        latitude: 45.44284,
        longitude: 12.32728,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32728, 45.44284]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21318151,
        name: "Accademia Charm Apartment n. 4",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.43043,
        longitude: 12.3341,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3341, 45.43043]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21331811,
        name: "Tagiapiera Spacious Venetian Studio",
        host_id: 669047,
        host_name: "Viewsonvenice",
        latitude: 45.44227,
        longitude: 12.33304,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33304, 45.44227]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21332094,
        name: "Varoter Spacious Venetian Studio",
        host_id: 669047,
        host_name: "Viewsonvenice",
        latitude: 45.44295,
        longitude: 12.33297,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33297, 45.44295]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21332194,
        name: "Sensale Venetian Design Apartment",
        host_id: 669047,
        host_name: "Viewsonvenice",
        latitude: 45.44178,
        longitude: 12.3345,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3345, 45.44178]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21332393,
        name: "Saoner Spacious Venetian Studio",
        host_id: 669047,
        host_name: "Viewsonvenice",
        latitude: 45.44428,
        longitude: 12.32769,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32769, 45.44428]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21332579,
        name: "Apartment Leonardo Venice (Historical Centre)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.44438,
        longitude: 12.32681,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32681, 45.44438]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21348568,
        name: "Venice canal view @Ca' di Paoletta",
        host_id: 43691958,
        host_name: "Marco",
        latitude: 45.43626,
        longitude: 12.32861,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32861, 45.43626]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21355480,
        name: "Stunning apartment in the center of Venice",
        host_id: 6620102,
        host_name: "Emanuele",
        latitude: 45.43486,
        longitude: 12.34384,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34384, 45.43486]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21355550,
        name: "Ca' Nova: Luxury apartment with terrace",
        host_id: 60070743,
        host_name: "Maria",
        latitude: 45.43222,
        longitude: 12.32648,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32648, 45.43222]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21365241,
        name: "Ca' D'oro Apartment - Wi-Fi",
        host_id: 36324248,
        host_name: "Giovanni",
        latitude: 45.44213,
        longitude: 12.3363,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3363, 45.44213]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21388253,
        name: "Apart with terrace, 2 min. from S.Marco -cod X3203",
        host_id: 15178567,
        host_name: "Paolo",
        latitude: 45.43633,
        longitude: 12.34069,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34069, 45.43633]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21390213,
        name: "New apartment with canal view - X202",
        host_id: 15178567,
        host_name: "Paolo",
        latitude: 45.43745,
        longitude: 12.33818,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33818, 45.43745]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21398316,
        name: "Barbaria de le Tole",
        host_id: 128863325,
        host_name: "Carla - Interhome",
        latitude: 45.439,
        longitude: 12.34391,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34391, 45.439]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21398319,
        name: "Isola di San Pietro",
        host_id: 128863325,
        host_name: "Carla - Interhome",
        latitude: 45.43374,
        longitude: 12.3601,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3601, 45.43374]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21398320,
        name: "Campo Santa Maria Formosa",
        host_id: 128863325,
        host_name: "Carla - Interhome",
        latitude: 45.43686,
        longitude: 12.34091,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34091, 45.43686]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21398321,
        name: "Sotoportego Venier",
        host_id: 128863325,
        host_name: "Carla - Interhome",
        latitude: 45.43622,
        longitude: 12.34812,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34812, 45.43622]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21398323,
        name: "Cà dell' Arsenale",
        host_id: 128863325,
        host_name: "Carla - Interhome",
        latitude: 45.43536,
        longitude: 12.34794,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34794, 45.43536]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21398324,
        name: "Fondamenta del Rielo",
        host_id: 128863325,
        host_name: "Carla - Interhome",
        latitude: 45.43434,
        longitude: 12.35617,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35617, 45.43434]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21398325,
        name: "Al Foghèr",
        host_id: 128863325,
        host_name: "Carla - Interhome",
        latitude: 45.43605,
        longitude: 12.32687,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32687, 45.43605]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21398326,
        name: "Cà della Lavanderia",
        host_id: 128863325,
        host_name: "Carla - Interhome",
        latitude: 45.43605,
        longitude: 12.34766,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34766, 45.43605]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21419576,
        name: "Ca' Bellini - Large terrace with  magnificent view",
        host_id: 26404861,
        host_name: "Marika",
        latitude: 45.44174,
        longitude: 12.34053,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34053, 45.44174]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21419792,
        name: "ORANGE",
        host_id: 27817620,
        host_name: "Alfonso",
        latitude: 45.44343,
        longitude: 12.33037,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33037, 45.44343]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21420969,
        name: "archilovers apartment near The Biennale",
        host_id: 8605171,
        host_name: "Enrico",
        latitude: 45.43206,
        longitude: 12.353,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.353, 45.43206]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21431562,
        name: "CA' DANIELA",
        host_id: 155353285,
        host_name: "Luciano",
        latitude: 45.43163,
        longitude: 12.31591,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31591, 45.43163]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21446002,
        name: "Ca' Venere Apartments Cannaregio Venezia (Apart 1)",
        host_id: 29586034,
        host_name: "Ca’ Venere Apartments",
        latitude: 45.44472,
        longitude: 12.3273,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3273, 45.44472]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21457611,
        name: "Appartamento a Venezia a tre minuti da Rialto",
        host_id: 129835471,
        host_name: "Nicoletta",
        latitude: 45.43713,
        longitude: 12.33995,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33995, 45.43713]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21464177,
        name: "CASA CON GIARDINO",
        host_id: 155854145,
        host_name: "Antonio",
        latitude: 45.42836,
        longitude: 12.36156,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.36156, 45.42836]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21466078,
        name: "Live Venice: only for long stay",
        host_id: 688823,
        host_name: "Franco",
        latitude: 45.43923,
        longitude: 12.34184,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34184, 45.43923]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21466585,
        name: "bedroom in Venice centre Saint Mark square",
        host_id: 50193451,
        host_name: "Deb",
        latitude: 45.43462,
        longitude: 12.33732,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33732, 45.43462]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21470390,
        name: "SUITE- Rialto one bedroom Apartment",
        host_id: 107662922,
        host_name: "Marco",
        latitude: 45.43788,
        longitude: 12.33345,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33345, 45.43788]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21480719,
        name: "CARMINI HOUSE WI FI",
        host_id: 154807392,
        host_name: "Nicoletta",
        latitude: 45.43456,
        longitude: 12.32025,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32025, 45.43456]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21481985,
        name: "MADDALENA CANAL HOUSE",
        host_id: 16823421,
        host_name: "Claudia",
        latitude: 45.44282,
        longitude: 12.33189,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33189, 45.44282]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21484487,
        name: "RIALTO BRIDGE LARGE VENETIAN STYLE WITH LIFT",
        host_id: 156051193,
        host_name: "Maurizio",
        latitude: 45.43832,
        longitude: 12.33687,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33687, 45.43832]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21488011,
        name: "'Serendipity' Venice apartment",
        host_id: 156089817,
        host_name: "Elena",
        latitude: 45.43764,
        longitude: 12.34431,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34431, 45.43764]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21508916,
        name: "BRIGHT SKY LOFT CA' D'ORO IN VENICE HEART",
        host_id: 156289698,
        host_name: "Roberto",
        latitude: 45.44308,
        longitude: 12.33649,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33649, 45.44308]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21511390,
        name: "BLUESKY DUPLEX WITH COURT - GHETTO",
        host_id: 289615,
        host_name: "Valentina",
        latitude: 45.44541,
        longitude: 12.33171,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33171, 45.44541]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21512798,
        name: "San Polo Canal View (CityApartments Venice)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.43903,
        longitude: 12.32942,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32942, 45.43903]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21520698,
        name: "ANDY'S APARTMENT",
        host_id: 156397515,
        host_name: "Enrico",
        latitude: 45.43524,
        longitude: 12.33603,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33603, 45.43524]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21524052,
        name: "Apartment San Giorgio degli Schiavoni",
        host_id: 156422092,
        host_name: "Rita",
        latitude: 45.43507,
        longitude: 12.34675,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34675, 45.43507]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21524203,
        name: "Venice Style 4: modern 2 Bedrooms & Private Court",
        host_id: 289615,
        host_name: "Valentina",
        latitude: 45.444,
        longitude: 12.32126,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32126, 45.444]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21533179,
        name: "Camera barocca canal view",
        host_id: 13027859,
        host_name: "Diego",
        latitude: 45.43908,
        longitude: 12.33222,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33222, 45.43908]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21538740,
        name: "Luxury Apartment -5 min from Train Station - Wi-Fi",
        host_id: 133690220,
        host_name: "Silvia-Carlo",
        latitude: 45.4406,
        longitude: 12.32693,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32693, 45.4406]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21542848,
        name: "Palazzeto on the Grand Canal",
        host_id: 137445876,
        host_name: "Alain",
        latitude: 45.43589,
        longitude: 12.32978,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32978, 45.43589]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21543267,
        name: "LUXURY APARTMENT IN THE HEART OF VENICE",
        host_id: 156614175,
        host_name: "Maria",
        latitude: 45.43737,
        longitude: 12.3383,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3383, 45.43737]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21544004,
        name: "Venice Sun Rialto apartment",
        host_id: 13027859,
        host_name: "Diego",
        latitude: 45.43977,
        longitude: 12.33069,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33069, 45.43977]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21550376,
        name: "Ca' Venere Apartments Cannaregio Venezia (Apart 2)",
        host_id: 29586034,
        host_name: "Ca’ Venere Apartments",
        latitude: 45.44619,
        longitude: 12.32858,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32858, 45.44619]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21560150,
        name: "Huge room in Venice Centre(Palazzo Grassi/S.Marco)",
        host_id: 47276175,
        host_name: "Paolo",
        latitude: 45.43383,
        longitude: 12.32967,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32967, 45.43383]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21560188,
        name: "Big cozy room (Palazzo Grassi/San Marco)",
        host_id: 47276175,
        host_name: "Paolo",
        latitude: 45.43239,
        longitude: 12.32899,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32899, 45.43239]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21560567,
        name: "Ca' Della Commedia",
        host_id: 156777282,
        host_name: "Kevin",
        latitude: 45.43728,
        longitude: 12.32767,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32767, 45.43728]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21574104,
        name: "Loft with Canal Grande view and roof terrace",
        host_id: 19860943,
        host_name: "Rita",
        latitude: 45.44248,
        longitude: 12.32304,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32304, 45.44248]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21577008,
        name: "Chich Appartment with terrace  at Biennale",
        host_id: 44994934,
        host_name: "Sara",
        latitude: 45.42987,
        longitude: 12.35795,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35795, 45.42987]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21577826,
        name: "Appartamento Cà Lio",
        host_id: 156917861,
        host_name: "Stefano",
        latitude: 45.43622,
        longitude: 12.34034,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34034, 45.43622]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21585278,
        name: "• grazioso monolocale nel cuore della città •",
        host_id: 8864109,
        host_name: "Sofia",
        latitude: 45.43996,
        longitude: 12.33625,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33625, 45.43996]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21585647,
        name: "San Giorgio e il Drago",
        host_id: 156986431,
        host_name: "Domenico",
        latitude: 45.43402,
        longitude: 12.33949,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33949, 45.43402]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21622124,
        name: "Sweet Apartment Frari",
        host_id: 113265814,
        host_name: "Marco",
        latitude: 45.43881,
        longitude: 12.32705,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32705, 45.43881]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21629076,
        name: "Venice, San Marco Center",
        host_id: 133789405,
        host_name: "Historical Center",
        latitude: 45.43199,
        longitude: 12.32982,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32982, 45.43199]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21629703,
        name: "White Gem",
        host_id: 145813573,
        host_name: "Nicola",
        latitude: 45.44678,
        longitude: 12.32732,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32732, 45.44678]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21641579,
        name: "Dorsoduro/Accademia Apartment",
        host_id: 157492478,
        host_name: "Michele",
        latitude: 45.43019,
        longitude: 12.3301,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3301, 45.43019]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21642551,
        name: "Angelo",
        host_id: 157501674,
        host_name: "Paola",
        latitude: 45.44087,
        longitude: 12.33006,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33006, 45.44087]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21643196,
        name: "Rooftop Terrace Views-Steps to Piazza San Marco!",
        host_id: 1450696,
        host_name: "ItalyPerfect",
        latitude: 45.43525,
        longitude: 12.33902,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33902, 45.43525]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21654494,
        name: "Terrace apartment",
        host_id: 157612083,
        host_name: "Elisa",
        latitude: 45.44197,
        longitude: 12.34237,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34237, 45.44197]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21655545,
        name:
          "A designer apartment in a residence with a garden in the centre of Venice.",
        host_id: 109957923,
        host_name: "Isabelle - BELVILLA",
        latitude: 45.44666,
        longitude: 12.32616,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32616, 45.44666]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21655546,
        name: "Peaceful Apartment in Venice with Garden",
        host_id: 109957923,
        host_name: "Isabelle - BELVILLA",
        latitude: 45.4458,
        longitude: 12.32546,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32546, 45.4458]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21655549,
        name: "Cozy Apartment in Venice with Sitting Room",
        host_id: 109957923,
        host_name: "Isabelle - BELVILLA",
        latitude: 45.43872,
        longitude: 12.33314,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33314, 45.43872]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21664762,
        name: "appartamento al 1° piano in zona Biennale",
        host_id: 73819697,
        host_name: "Claudio",
        latitude: 45.43222,
        longitude: 12.3563,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3563, 45.43222]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21688009,
        name: "Venice Luxury Palace  9",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.43877,
        longitude: 12.33088,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33088, 45.43877]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21699788,
        name: "Ca' Valeria Piano House in Venice! + free Wi-Fi!",
        host_id: 31072784,
        host_name: "Tomas",
        latitude: 45.43421,
        longitude: 12.3167,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3167, 45.43421]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21707519,
        name: "La casa di Nicola",
        host_id: 158036730,
        host_name: "Nicola",
        latitude: 45.43986,
        longitude: 12.33411,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33411, 45.43986]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21707716,
        name: "Superior room Ca' del Dose",
        host_id: 24889853,
        host_name: "Sandra",
        latitude: 45.43774,
        longitude: 12.34101,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34101, 45.43774]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21713917,
        name: "Ca' dei Armeni - Pisana - San Marco - Venezia",
        host_id: 16773988,
        host_name: "Isacco",
        latitude: 45.43432,
        longitude: 12.33726,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33726, 45.43432]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21719502,
        name: "Ca' Barba 24",
        host_id: 215652,
        host_name: "Caterina E Alessandro",
        latitude: 45.43401,
        longitude: 12.32517,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32517, 45.43401]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21723130,
        name: "Apartment Cereri in Venice",
        host_id: 143873157,
        host_name: "Federico",
        latitude: 45.43368,
        longitude: 12.31697,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31697, 45.43368]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21737059,
        name: "Your Venetian Dream",
        host_id: 158313474,
        host_name: "Marco",
        latitude: 45.44341,
        longitude: 12.32099,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32099, 45.44341]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21743254,
        name: "Bissa Nera",
        host_id: 117414974,
        host_name: "Francisco",
        latitude: 45.4377,
        longitude: 12.33708,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33708, 45.4377]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21746738,
        name: "Beautiful Palazzetto Muti with garden!",
        host_id: 151425971,
        host_name: "Luca",
        latitude: 45.44589,
        longitude: 12.33328,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33328, 45.44589]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21747814,
        name: "S Marco,cozy terrace, jacuzzi and shower, 2 bedrms",
        host_id: 4893459,
        host_name: "Roberta",
        latitude: 45.43568,
        longitude: 12.33599,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33599, 45.43568]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21761595,
        name: "Appartamento nel cuore di Venezia",
        host_id: 158542233,
        host_name: "Federica",
        latitude: 45.4398,
        longitude: 12.33839,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33839, 45.4398]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21791335,
        name: "Camera standard Amadeus",
        host_id: 24889853,
        host_name: "Sandra",
        latitude: 45.43691,
        longitude: 12.33949,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33949, 45.43691]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21792549,
        name: "La Perla, indipendent flat near Canal Grande.",
        host_id: 26404861,
        host_name: "Marika",
        latitude: 45.44084,
        longitude: 12.32671,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32671, 45.44084]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21794530,
        name: "casa alba",
        host_id: 158686206,
        host_name: "Stefano",
        latitude: 45.43436,
        longitude: 12.33476,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33476, 45.43436]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21795786,
        name: "Ca Roberta  - Wonderful  2 Steps from  San Marco",
        host_id: 139627704,
        host_name: "Giusy & Fabrizio",
        latitude: 45.43798,
        longitude: 12.33846,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33846, 45.43798]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21807489,
        name: "White loft Giudecca",
        host_id: 37955209,
        host_name: "Tea",
        latitude: 45.42534,
        longitude: 12.32904,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32904, 45.42534]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21807580,
        name: "Holiday apartment Valier in Venice",
        host_id: 128863325,
        host_name: "Carla - Interhome",
        latitude: 45.43386,
        longitude: 12.36011,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.36011, 45.43386]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21807582,
        name: "Holiday apartment Casanas",
        host_id: 128863325,
        host_name: "Carla - Interhome",
        latitude: 45.43206,
        longitude: 12.35331,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35331, 45.43206]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21807583,
        name: "Comfortable holiday apartment Casanas",
        host_id: 128863325,
        host_name: "Carla - Interhome",
        latitude: 45.43258,
        longitude: 12.35161,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35161, 45.43258]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21807584,
        name: "Cozy holiday apartment San Vio",
        host_id: 128863325,
        host_name: "Carla - Interhome",
        latitude: 45.43001,
        longitude: 12.32789,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32789, 45.43001]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21809972,
        name: "White Romantic Studio - VENICE CENTRE - FREE WIFI",
        host_id: 106612750,
        host_name: "Federica",
        latitude: 45.44618,
        longitude: 12.31846,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31846, 45.44618]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21824763,
        name: "Ca' di Nive",
        host_id: 25497334,
        host_name: "Vanni",
        latitude: 45.43383,
        longitude: 12.35696,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35696, 45.43383]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21832227,
        name: "Pantaleone",
        host_id: 159171096,
        host_name: "Svetlana",
        latitude: 45.43628,
        longitude: 12.32336,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32336, 45.43628]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21834014,
        name: "Magic View - WiFi",
        host_id: 36324248,
        host_name: "Giovanni",
        latitude: 45.43279,
        longitude: 12.33543,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33543, 45.43279]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21841739,
        name: "Luxury Apartment -5 min from Train Station - Wi-Fi",
        host_id: 133690220,
        host_name: "Silvia-Carlo",
        latitude: 45.44114,
        longitude: 12.32678,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32678, 45.44114]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21845184,
        name: "High lights Terrace",
        host_id: 159312606,
        host_name: "Lilia",
        latitude: 45.43607,
        longitude: 12.34209,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34209, 45.43607]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21846401,
        name: "Canal Views and a Secret Garden in Giudecca",
        host_id: 159325292,
        host_name: "Paul&Lara",
        latitude: 45.4262,
        longitude: 12.32479,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32479, 45.4262]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21848114,
        name: "House Biennale  Piccolo Leone",
        host_id: 159338625,
        host_name: "Chiara",
        latitude: 45.43285,
        longitude: 12.3503,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3503, 45.43285]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21854616,
        name: "Mascherone Apartment",
        host_id: 141518804,
        host_name: "Alessandra",
        latitude: 45.43604,
        longitude: 12.34202,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34202, 45.43604]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21860862,
        name: "formosa 5193",
        host_id: 3446851,
        host_name: "Marisa",
        latitude: 45.43651,
        longitude: 12.3408,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3408, 45.43651]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21861734,
        name: "Casa di Anna",
        host_id: 471286,
        host_name: "Enrico",
        latitude: 45.43922,
        longitude: 12.33259,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33259, 45.43922]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21870489,
        name: "Giudecca Venezia Redentore real Venice atmosphere",
        host_id: 114135580,
        host_name: "Elena",
        latitude: 45.42549,
        longitude: 12.33461,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33461, 45.42549]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21871969,
        name: "GRAND CANAL LOVE NEST#1  Grand Canal pano view!",
        host_id: 153954052,
        host_name: "Annalisa",
        latitude: 45.4355,
        longitude: 12.32822,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32822, 45.4355]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21874210,
        name: "Venice, Train Station",
        host_id: 133789405,
        host_name: "Historical Center",
        latitude: 45.44509,
        longitude: 12.32555,
        beds: 7,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32555, 45.44509]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21878477,
        name: "Casa Valentina",
        host_id: 91502607,
        host_name: "Valentina",
        latitude: 45.43656,
        longitude: 12.32763,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32763, 45.43656]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21896592,
        name: "Venetian style room RED near train station",
        host_id: 159746853,
        host_name: "Giulia",
        latitude: 45.4445,
        longitude: 12.31902,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31902, 45.4445]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21896975,
        name: "“Laguna” apartment 5 min. from train station",
        host_id: 159746853,
        host_name: "Giulia",
        latitude: 45.44453,
        longitude: 12.32502,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32502, 45.44453]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21904319,
        name: "BELLISSIMO  MONOLOCALE CAMPO RUGA",
        host_id: 26460616,
        host_name: "Gianfranco",
        latitude: 45.43292,
        longitude: 12.35762,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35762, 45.43292]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21905822,
        name: "Red Fashion House",
        host_id: 26404861,
        host_name: "Marika",
        latitude: 45.43991,
        longitude: 12.33281,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33281, 45.43991]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21908478,
        name: "Cà Leon",
        host_id: 159853570,
        host_name: "Amelio",
        latitude: 45.43622,
        longitude: 12.33748,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33748, 45.43622]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21918263,
        name: "Rudy House Venice 1",
        host_id: 118933377,
        host_name: "Patrizia",
        latitude: 45.44349,
        longitude: 12.32181,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32181, 45.44349]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21919233,
        name: "CARDINALE APARTMENT",
        host_id: 1545612,
        host_name: "Enrica",
        latitude: 45.43552,
        longitude: 12.32208,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32208, 45.43552]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21921795,
        name: "Casetta Rossa, 5 minutes to Rialto bridge",
        host_id: 26404861,
        host_name: "Marika",
        latitude: 45.44054,
        longitude: 12.33265,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33265, 45.44054]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21922475,
        name: "IN THE HEART OF AUTHENTIC VENICE",
        host_id: 6040890,
        host_name: "Pafin Srl",
        latitude: 45.43589,
        longitude: 12.34754,
        beds: 9,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34754, 45.43589]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21923491,
        name: "Moretta apartment canal view",
        host_id: 159963948,
        host_name: "Mirella",
        latitude: 45.43978,
        longitude: 12.33904,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33904, 45.43978]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21924470,
        name: "Most Charming Venice",
        host_id: 159973233,
        host_name: "Barbara",
        latitude: 45.43511,
        longitude: 12.32616,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32616, 45.43511]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21929057,
        name: "Venetian Oasi",
        host_id: 5128717,
        host_name: "Alvise",
        latitude: 45.44724,
        longitude: 12.32993,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32993, 45.44724]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21929950,
        name: "Paste apartment, tra Rialto e S.Marco",
        host_id: 3446851,
        host_name: "Marisa",
        latitude: 45.43781,
        longitude: 12.33914,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33914, 45.43781]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21930834,
        name: 'Apartment "Alla Salute"',
        host_id: 77252977,
        host_name: "Chiara",
        latitude: 45.43067,
        longitude: 12.33178,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33178, 45.43067]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21931300,
        name: "Bilocale San Marco Venezia",
        host_id: 160042247,
        host_name: "Antonio Giovanni",
        latitude: 45.4337,
        longitude: 12.33258,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33258, 45.4337]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21934904,
        name: "Santa Marina 5888A Calle - Venezia Centro Storico",
        host_id: 36767238,
        host_name: "Guido",
        latitude: 45.43774,
        longitude: 12.34027,
        beds: 7,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34027, 45.43774]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21939841,
        name: "Venice@Home - Charming Apartment in Rialto Venice",
        host_id: 160130676,
        host_name: "Chiara",
        latitude: 45.43935,
        longitude: 12.33374,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33374, 45.43935]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21940683,
        name: "Ca' Corner dei Tacchi",
        host_id: 149046671,
        host_name: "Pier",
        latitude: 45.43749,
        longitude: 12.32787,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32787, 45.43749]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21941503,
        name: "Double room 5 minutes to San Marco & Biennale",
        host_id: 27272609,
        host_name: "Medi",
        latitude: 45.43694,
        longitude: 12.34435,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34435, 45.43694]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21954348,
        name: 'Aria e Luce - "Mattino" apartment',
        host_id: 10598888,
        host_name: "Arianna & Luca",
        latitude: 45.43731,
        longitude: 12.34157,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34157, 45.43731]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21957018,
        name: "La Maisonette et son Jardin",
        host_id: 26404861,
        host_name: "Marika",
        latitude: 45.44486,
        longitude: 12.32083,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32083, 45.44486]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21957989,
        name: "SAN SEVERO SUITE APARTMENT VENICE ACTUALLY",
        host_id: 5862083,
        host_name: "Silvia",
        latitude: 45.43669,
        longitude: 12.342,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.342, 45.43669]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21963761,
        name: "SUNNY CANALVIEW 4pax, wifi, aircond",
        host_id: 153954052,
        host_name: "Annalisa",
        latitude: 45.44337,
        longitude: 12.33343,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33343, 45.44337]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21971364,
        name: "Economy Double Room",
        host_id: 160412579,
        host_name: "Emanuele",
        latitude: 45.43455,
        longitude: 12.33611,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33611, 45.43455]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21973348,
        name: "CASATI",
        host_id: 1545612,
        host_name: "Enrica",
        latitude: 45.43748,
        longitude: 12.32256,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32256, 45.43748]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21973817,
        name: "Double Room",
        host_id: 160412579,
        host_name: "Emanuele",
        latitude: 45.4353,
        longitude: 12.33544,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33544, 45.4353]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21974382,
        name: "Triple Room",
        host_id: 160412579,
        host_name: "Emanuele",
        latitude: 45.43334,
        longitude: 12.3356,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3356, 45.43334]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21975133,
        name: "Tower Suite - Campo Santa Margherita",
        host_id: 160440981,
        host_name: "Ilaria",
        latitude: 45.43497,
        longitude: 12.32359,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32359, 45.43497]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21979380,
        name: "Rialto Charming House",
        host_id: 46904188,
        host_name: "Mirco Optyflat",
        latitude: 45.43788,
        longitude: 12.33517,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33517, 45.43788]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21989759,
        name: "LA CASA DI VENEZIA",
        host_id: 160564789,
        host_name: "Daniela",
        latitude: 45.44654,
        longitude: 12.32753,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32753, 45.44654]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21996168,
        name: "San Marco - Teatro La Fenice",
        host_id: 87726589,
        host_name: "Sergio",
        latitude: 45.43368,
        longitude: 12.33341,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33341, 45.43368]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21996875,
        name: "Appartamento Venezia Giudecca",
        host_id: 114135580,
        host_name: "Elena",
        latitude: 45.42531,
        longitude: 12.33296,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33296, 45.42531]] },
    },
    {
      type: "Feature",
      properties: {
        id: 21999715,
        name: "Venetian style Golden Room (close Train station)",
        host_id: 159746853,
        host_name: "Giulia",
        latitude: 45.44387,
        longitude: 12.31958,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31958, 45.44387]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22000038,
        name: "Classic room Sparkle near the train station",
        host_id: 159746853,
        host_name: "Giulia",
        latitude: 45.44249,
        longitude: 12.31924,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31924, 45.44249]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22005155,
        name: "Ca'Moro-Salina",
        host_id: 3972291,
        host_name: "Caroline E Marco",
        latitude: 45.43527,
        longitude: 12.33158,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33158, 45.43527]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22022023,
        name: "Rialto Flower House",
        host_id: 160739891,
        host_name: "Francesco",
        latitude: 45.43812,
        longitude: 12.33354,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33354, 45.43812]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22023300,
        name: "Heart of Venice",
        host_id: 65165841,
        host_name: "Sofia",
        latitude: 45.43379,
        longitude: 12.31604,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31604, 45.43379]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22038102,
        name: "Home sweet home",
        host_id: 6620102,
        host_name: "Emanuele",
        latitude: 45.437,
        longitude: 12.32292,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32292, 45.437]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22043099,
        name: "Ca' Garzoni Moro - Appartamento Clemente",
        host_id: 3972291,
        host_name: "Caroline E Marco",
        latitude: 45.43504,
        longitude: 12.33062,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33062, 45.43504]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22043812,
        name: "Ca' Garzoni Moro - appartamento MURANO",
        host_id: 3972291,
        host_name: "Caroline E Marco",
        latitude: 45.43479,
        longitude: 12.32936,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32936, 45.43479]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22047137,
        name: "Cozy apartment nearby Rialto and San Marco",
        host_id: 52530337,
        host_name: "Elly",
        latitude: 45.43813,
        longitude: 12.34241,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34241, 45.43813]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22059062,
        name: "Beautifully appointed, cozy and quiet apartment",
        host_id: 92687,
        host_name: "Antonino Cusimano",
        latitude: 45.43863,
        longitude: 12.34233,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34233, 45.43863]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22062295,
        name: "Spazio Barman",
        host_id: 22744803,
        host_name: "Roberta",
        latitude: 45.43893,
        longitude: 12.34558,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34558, 45.43893]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22073177,
        name: "CA' LESSIA - LOVE NEST IN VENICE",
        host_id: 63336917,
        host_name: "Ca' Dolcetti",
        latitude: 45.44535,
        longitude: 12.32003,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32003, 45.44535]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22073503,
        name: "Serene Spacious Apartment Overlooking Canals",
        host_id: 161246385,
        host_name: "Sophie",
        latitude: 45.44201,
        longitude: 12.33412,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33412, 45.44201]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22091583,
        name: "Ca' Mariarosa",
        host_id: 161384635,
        host_name: "Mirco",
        latitude: 45.44642,
        longitude: 12.32861,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32861, 45.44642]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22092382,
        name: "Raffaello",
        host_id: 148054092,
        host_name: "Steve S.R.L.",
        latitude: 45.43464,
        longitude: 12.34149,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34149, 45.43464]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22095167,
        name: "| Casa Samuele Grand Canal Apartment |",
        host_id: 161410460,
        host_name: "Gabriella",
        latitude: 45.43436,
        longitude: 12.32916,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32916, 45.43436]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22095985,
        name: "RIALTO1679,  3 real minutes to Rialto bridge, wifi",
        host_id: 49847590,
        host_name: "Linda",
        latitude: 45.43972,
        longitude: 12.33289,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33289, 45.43972]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22097818,
        name: "Cozy Apartment Le nuvole",
        host_id: 161429460,
        host_name: "Michela",
        latitude: 45.42721,
        longitude: 12.32085,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32085, 45.42721]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22118287,
        name: "Ca' Soranzo",
        host_id: 161584886,
        host_name: "Anxhela",
        latitude: 45.4362,
        longitude: 12.34705,
        beds: 8,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34705, 45.4362]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22131633,
        name: "Budget small studio near Rialto bridge",
        host_id: 157886607,
        host_name: "Silvia",
        latitude: 45.43778,
        longitude: 12.33188,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33188, 45.43778]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22132149,
        name: "GUGGENHEIM NEXT 10pax, Aircond, Wifi",
        host_id: 153954052,
        host_name: "Annalisa",
        latitude: 45.43009,
        longitude: 12.32779,
        beds: 7,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32779, 45.43009]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22135390,
        name: "ROOM RIALTO 1679, 3 min from Rialto bridge",
        host_id: 49847590,
        host_name: "Linda",
        latitude: 45.43997,
        longitude: 12.3311,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3311, 45.43997]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22136643,
        name: "★NEW! Central position: Palazzo Soranzo!★",
        host_id: 96221395,
        host_name: "Welcome To Veneto & Friuli",
        latitude: 45.44303,
        longitude: 12.33038,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33038, 45.44303]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22141262,
        name: "Holiday apartment with 2 bedrooms on 90m² in Venezia VE",
        host_id: 159971693,
        host_name: "Fabio - NOVASOL",
        latitude: 45.43348,
        longitude: 12.31753,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31753, 45.43348]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22141350,
        name: "Holiday apartment with 2 bedrooms on 83m² in Venezia -VE-",
        host_id: 159971693,
        host_name: "Fabio - NOVASOL",
        latitude: 45.43537,
        longitude: 12.33259,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33259, 45.43537]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22141351,
        name: "Holiday apartment with 2 bedrooms on 65m² in Venezia VE",
        host_id: 159971693,
        host_name: "Fabio - NOVASOL",
        latitude: 45.43754,
        longitude: 12.33018,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33018, 45.43754]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22141355,
        name: "Holiday apartment with 1 bedroom on 60m² in Venezia VE",
        host_id: 159971693,
        host_name: "Fabio - NOVASOL",
        latitude: 45.4362,
        longitude: 12.34951,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34951, 45.4362]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22141357,
        name: "Holiday apartment with 2 bedrooms on 95m² in Venezia VE",
        host_id: 159971693,
        host_name: "Fabio - NOVASOL",
        latitude: 45.4428,
        longitude: 12.32837,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32837, 45.4428]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22154509,
        name: "Rialto Suite Superior",
        host_id: 988816,
        host_name: "Roberta",
        latitude: 45.4375,
        longitude: 12.33356,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33356, 45.4375]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22155566,
        name: "Rialto Suite 707",
        host_id: 988816,
        host_name: "Roberta",
        latitude: 45.437,
        longitude: 12.33318,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33318, 45.437]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22159772,
        name: "3 bathrooms ! New luxury apartment with canal view",
        host_id: 28917209,
        host_name: "Stefano",
        latitude: 45.44123,
        longitude: 12.33907,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33907, 45.44123]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22160522,
        name: "Dimora Furlani ground floor (Canal view)",
        host_id: 632312,
        host_name: "Guillaume",
        latitude: 45.43511,
        longitude: 12.34548,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34548, 45.43511]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22161667,
        name: "Between a quiet courtyard and a private garden!",
        host_id: 7833708,
        host_name: "Massimo",
        latitude: 45.44843,
        longitude: 12.32667,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32667, 45.44843]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22168354,
        name: "CA' DEL CAMPIELLO",
        host_id: 161930352,
        host_name: "Michela",
        latitude: 45.44746,
        longitude: 12.32393,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32393, 45.44746]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22197450,
        name: "Ca' Lucia Apartment",
        host_id: 25128793,
        host_name: "_mdm_",
        latitude: 45.43773,
        longitude: 12.32629,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32629, 45.43773]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22198770,
        name: "Casa dei Miracoli",
        host_id: 23397993,
        host_name: "Valentina",
        latitude: 45.44009,
        longitude: 12.33798,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33798, 45.44009]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22204327,
        name: "Santa Marina 5888B canale - Venezia Centro Storico",
        host_id: 36767238,
        host_name: "Guido",
        latitude: 45.43769,
        longitude: 12.33916,
        beds: 7,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33916, 45.43769]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22214589,
        name: "Venezia Fondamenta Nove",
        host_id: 162321666,
        host_name: "Antonio",
        latitude: 45.44622,
        longitude: 12.33177,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33177, 45.44622]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22216810,
        name: "LA FENICE THEATRE EXCLUSIVE FLAT VENEZIA SAN MARCO",
        host_id: 162242701,
        host_name: "Alessandra",
        latitude: 45.43298,
        longitude: 12.33498,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33498, 45.43298]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22222095,
        name: "Appartamento storico con vista nel cuore di Rialto",
        host_id: 162379644,
        host_name: "Klaus",
        latitude: 45.43947,
        longitude: 12.33403,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33403, 45.43947]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22223913,
        name: "Mario Apartment 964/B",
        host_id: 10072655,
        host_name: "Mario Apartment",
        latitude: 45.43964,
        longitude: 12.3322,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3322, 45.43964]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22224349,
        name: "LA LOGGIA DELLA LUNA JUNIOR SUITE",
        host_id: 51324480,
        host_name: "Laura",
        latitude: 45.44049,
        longitude: 12.32618,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32618, 45.44049]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22248305,
        name: "Vedere Venezia dall'alto",
        host_id: 61615942,
        host_name: "Cristian",
        latitude: 45.44702,
        longitude: 12.3303,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3303, 45.44702]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22256308,
        name: "Luxury Venetian apartment _View on the Grand Canal",
        host_id: 289615,
        host_name: "Valentina",
        latitude: 45.44396,
        longitude: 12.32741,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32741, 45.44396]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22261835,
        name: "Ca' La Dama del Pozzo - Whole Apartment",
        host_id: 162486116,
        host_name: "Maria",
        latitude: 45.43574,
        longitude: 12.33882,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33882, 45.43574]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22274751,
        name: "Appartamento Venezia 1st floor",
        host_id: 60778507,
        host_name: "Viorica & Chris",
        latitude: 45.44219,
        longitude: 12.33127,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33127, 45.44219]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22275629,
        name: "Luxury and romantic secret escape in Venice!",
        host_id: 141388284,
        host_name: "Pietro",
        latitude: 45.43646,
        longitude: 12.34238,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34238, 45.43646]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22278294,
        name: "Majoorel San Marco",
        host_id: 95513046,
        host_name: "Alberto",
        latitude: 45.43489,
        longitude: 12.34469,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34469, 45.43489]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22285134,
        name: "Rialto suite standard",
        host_id: 988816,
        host_name: "Roberta",
        latitude: 45.43857,
        longitude: 12.33418,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33418, 45.43857]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22285718,
        name: "Erbe Canal View Private House",
        host_id: 7035974,
        host_name: "Tommaso",
        latitude: 45.44133,
        longitude: 12.33464,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33464, 45.44133]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22313886,
        name: "Casanova Venetian Style; 400m from Rialto's Bridge",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.43859,
        longitude: 12.33215,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33215, 45.43859]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22315251,
        name: "Ca' Corte Rota Appartamento Indipendente",
        host_id: 145813573,
        host_name: "Nicola",
        latitude: 45.43561,
        longitude: 12.34945,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34945, 45.43561]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22317213,
        name: "Michele Home Venice 3",
        host_id: 142812280,
        host_name: "Michele",
        latitude: 45.43522,
        longitude: 12.34746,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34746, 45.43522]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22319711,
        name: "Ca' Lio apartment",
        host_id: 105704488,
        host_name: "Sara",
        latitude: 45.43718,
        longitude: 12.33692,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33692, 45.43718]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22320535,
        name: "Casa Nina * Quite and cosy apt with sunny terrace",
        host_id: 12310389,
        host_name: "Casa Nina",
        latitude: 45.42437,
        longitude: 12.32821,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32821, 45.42437]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22321913,
        name: "Ca' dei Cinque Rialto Apartment",
        host_id: 117774335,
        host_name: "Paolo",
        latitude: 45.43759,
        longitude: 12.3339,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3339, 45.43759]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22323438,
        name: "Ca’ dei Musei  NEW in Venice",
        host_id: 113351130,
        host_name: "D",
        latitude: 45.44104,
        longitude: 12.33018,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33018, 45.44104]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22334077,
        name: "Love Studio Grand Canal",
        host_id: 289615,
        host_name: "Valentina",
        latitude: 45.4435,
        longitude: 12.32742,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32742, 45.4435]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22336977,
        name: "CARMINI APARTMENT",
        host_id: 1545612,
        host_name: "Enrica",
        latitude: 45.43443,
        longitude: 12.32145,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32145, 45.43443]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22337587,
        name: "MINOTTO",
        host_id: 1545612,
        host_name: "Enrica",
        latitude: 45.43772,
        longitude: 12.32117,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32117, 45.43772]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22338841,
        name: "Casina Mirella wi-fi",
        host_id: 163326870,
        host_name: "Gianni",
        latitude: 45.4425,
        longitude: 12.33398,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33398, 45.4425]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22339893,
        name: "Cozy room canal view with shared bathroom",
        host_id: 13027859,
        host_name: "Diego",
        latitude: 45.44076,
        longitude: 12.33219,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33219, 45.44076]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22340605,
        name: '"La residenza di Carlo" close to Piazza S. Marco',
        host_id: 139257153,
        host_name: "Elisabetta",
        latitude: 45.43673,
        longitude: 12.34224,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34224, 45.43673]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22341567,
        name: "My apartment in the center of Venice",
        host_id: 9017175,
        host_name: "Andrea",
        latitude: 45.43967,
        longitude: 12.34417,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34417, 45.43967]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22355210,
        name: "Elegant & quiet apt  close to train station",
        host_id: 6019189,
        host_name: "Federico",
        latitude: 45.4442,
        longitude: 12.32238,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32238, 45.4442]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22374242,
        name: "Holiday apartment with 2 bedrooms on 95m² in Venezia (VE)",
        host_id: 159971693,
        host_name: "Fabio - NOVASOL",
        latitude: 45.43303,
        longitude: 12.32875,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32875, 45.43303]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22384520,
        name: "Quadruple room  with Canal View",
        host_id: 13027859,
        host_name: "Diego",
        latitude: 45.43977,
        longitude: 12.33193,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33193, 45.43977]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22394279,
        name: "RIALTO ROOFTOP TERRACE MINI LOFT",
        host_id: 163785863,
        host_name: "Tancredi",
        latitude: 45.43848,
        longitude: 12.33433,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33433, 45.43848]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22429748,
        name: "B&B La Terrazza Dei Miracoli",
        host_id: 54299768,
        host_name: "Emanuela",
        latitude: 45.44072,
        longitude: 12.3395,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3395, 45.44072]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22432958,
        name: "LA LOGGIA DELLA LUNA 1",
        host_id: 51324480,
        host_name: "Laura",
        latitude: 45.44149,
        longitude: 12.32501,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32501, 45.44149]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22446362,
        name: "MAZZONI 10 BY VENICE TRAIN STATION MODERN FLAT",
        host_id: 164459123,
        host_name: "Gian Andrea",
        latitude: 45.44261,
        longitude: 12.32054,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32054, 45.44261]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22446511,
        name: "Casa Claudia Newly renovated close to Biennale",
        host_id: 119342181,
        host_name: "Claudia",
        latitude: 45.43033,
        longitude: 12.35633,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35633, 45.43033]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22447010,
        name: "Studio di Lilli",
        host_id: 9278228,
        host_name: "Andrea",
        latitude: 45.43756,
        longitude: 12.3362,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3362, 45.43756]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22448750,
        name: "Golden Apartment, 3bedrooms  near train station",
        host_id: 159746853,
        host_name: "Giulia",
        latitude: 45.44426,
        longitude: 12.32073,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32073, 45.44426]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22461164,
        name: "Piccola Corte - Designer's Nest Cannaregio",
        host_id: 164621261,
        host_name: "Mara",
        latitude: 45.44552,
        longitude: 12.32649,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32649, 45.44552]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22462783,
        name: "Quadruple Room with Canal View",
        host_id: 13027859,
        host_name: "Diego",
        latitude: 45.43894,
        longitude: 12.33151,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33151, 45.43894]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22466407,
        name: "Biennale house in Corte Celsi",
        host_id: 164674166,
        host_name: "Maurizio",
        latitude: 45.43718,
        longitude: 12.34855,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34855, 45.43718]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22471593,
        name: "Very nice central with great view wifii",
        host_id: 31276705,
        host_name: "Mila",
        latitude: 45.43071,
        longitude: 12.35797,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35797, 45.43071]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22482164,
        name: "La casetta di Anna",
        host_id: 164842571,
        host_name: "Anna Maria",
        latitude: 45.44365,
        longitude: 12.32713,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32713, 45.44365]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22484254,
        name: "Sant Alvise Apartment",
        host_id: 142979587,
        host_name: "Atik",
        latitude: 45.44566,
        longitude: 12.32843,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32843, 45.44566]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22489968,
        name: "Double room with shared bathroom",
        host_id: 13027859,
        host_name: "Diego",
        latitude: 45.43973,
        longitude: 12.33159,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33159, 45.43973]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22495655,
        name: "Panorama Roof",
        host_id: 165009396,
        host_name: "Andre",
        latitude: 45.44579,
        longitude: 12.32914,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32914, 45.44579]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22501411,
        name: "Cà Biennale: Discovering the hidden corners!",
        host_id: 17399577,
        host_name: "Fabrizio",
        latitude: 45.43614,
        longitude: 12.34791,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34791, 45.43614]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22525586,
        name: "L'aura Veneziana",
        host_id: 165382151,
        host_name: "Laura",
        latitude: 45.43417,
        longitude: 12.31863,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31863, 45.43417]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22530630,
        name: "BARBA ROOM",
        host_id: 55763295,
        host_name: "Valter",
        latitude: 45.44133,
        longitude: 12.33811,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33811, 45.44133]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22545096,
        name: "Cadillac apartment",
        host_id: 50258912,
        host_name: "Edoardo",
        latitude: 45.44658,
        longitude: 12.32085,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32085, 45.44658]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22558506,
        name: "Ca' Forni Biennale S. Marco",
        host_id: 165763288,
        host_name: "Sandra",
        latitude: 45.43418,
        longitude: 12.34937,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34937, 45.43418]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22566716,
        name: "Charming large apt in Cannaregio",
        host_id: 6019189,
        host_name: "Federico",
        latitude: 45.44509,
        longitude: 12.32962,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32962, 45.44509]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22569011,
        name: "Casa Flavia ai Morosini - Luxury Design Home",
        host_id: 165874453,
        host_name: "Ilaria",
        latitude: 45.43935,
        longitude: 12.34177,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34177, 45.43935]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22575481,
        name:
          "Live like a local at this Venetian apartment - perfect romantic getaway!",
        host_id: 4339678,
        host_name: "Vacasa Italy - Venice",
        latitude: 45.43265,
        longitude: 12.35518,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35518, 45.43265]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22581981,
        name: "Ve.N.I.Ce Cera Ca' Del Gondoliere",
        host_id: 37864680,
        host_name: "Ve.N.I.Ce Immobiliare Cera",
        latitude: 45.43408,
        longitude: 12.32999,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32999, 45.43408]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22591035,
        name: "Suite Depandance",
        host_id: 988816,
        host_name: "Roberta",
        latitude: 45.43763,
        longitude: 12.33349,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33349, 45.43763]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22591775,
        name: "CA' FENICE ROOM: free Wi-Fi - St. Marco Square",
        host_id: 159297002,
        host_name: "Sandra",
        latitude: 45.43267,
        longitude: 12.3338,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3338, 45.43267]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22591937,
        name: "The Library Room",
        host_id: 166141757,
        host_name: "Donatella",
        latitude: 45.43569,
        longitude: 12.3443,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3443, 45.43569]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22596473,
        name: "CA' FENICE ROOM: free Wi-Fi - St. Marco Square",
        host_id: 159297002,
        host_name: "Sandra",
        latitude: 45.43384,
        longitude: 12.33505,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33505, 45.43384]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22596619,
        name: "Apartmnet in Venice center",
        host_id: 166197934,
        host_name: "Onorina",
        latitude: 45.43505,
        longitude: 12.34898,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34898, 45.43505]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22597025,
        name: "An exciting Loft in the historic Arsenal building",
        host_id: 88898098,
        host_name: "Georgii",
        latitude: 45.43286,
        longitude: 12.35541,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35541, 45.43286]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22597064,
        name: "CA' FENICE ROOM 3: free Wi-Fi - St. Marco Square",
        host_id: 159297002,
        host_name: "Sandra",
        latitude: 45.43319,
        longitude: 12.33462,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33462, 45.43319]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22598809,
        name: "San Tomà, central and what a view!",
        host_id: 166226852,
        host_name: "Giovanni",
        latitude: 45.43668,
        longitude: 12.32892,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32892, 45.43668]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22600270,
        name: "Nel cuore di Venezia - In the Heart of Venice",
        host_id: 4302548,
        host_name: "Roberto",
        latitude: 45.44179,
        longitude: 12.34051,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34051, 45.44179]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22607727,
        name: "Terrazza Momon // Over the Canal Grande",
        host_id: 162499451,
        host_name: "Terrazza Momon //",
        latitude: 45.4436,
        longitude: 12.32783,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32783, 45.4436]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22607982,
        name: "***** Five stars! NEW romantic spot ❤",
        host_id: 166355815,
        host_name: "Mela & Vale",
        latitude: 45.43206,
        longitude: 12.32322,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32322, 45.43206]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22624257,
        name: "Plus Apartment in Venice - Grassi",
        host_id: 166543706,
        host_name: "Martha Zbar",
        latitude: 45.43339,
        longitude: 12.32927,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32927, 45.43339]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22625614,
        name: "Residence Pozzo Terrace (8 min. St Mark's Square )",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.42989,
        longitude: 12.33359,
        beds: 8,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33359, 45.42989]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22625706,
        name: "B&B Ca'dor rooms centre Venice",
        host_id: 152285589,
        host_name: "Nicola",
        latitude: 45.44016,
        longitude: 12.33681,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33681, 45.44016]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22627306,
        name: "appartamento indipendente nel cuore di venezia",
        host_id: 142646768,
        host_name: "Isabella",
        latitude: 45.43393,
        longitude: 12.33081,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33081, 45.43393]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22628051,
        name: "Grand Canal  next to Guggenheim",
        host_id: 17290102,
        host_name: "Marialuisa",
        latitude: 45.43022,
        longitude: 12.33018,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33018, 45.43022]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22630747,
        name: "FULL FLAT  -  50sq meters  -  IN VENICE",
        host_id: 152425526,
        host_name: "Francesca",
        latitude: 45.44458,
        longitude: 12.32767,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32767, 45.44458]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22632374,
        name: "Your lovely nest in San Basilio - Zattere",
        host_id: 166630470,
        host_name: "Fabia",
        latitude: 45.43241,
        longitude: 12.31978,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31978, 45.43241]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22642183,
        name: "Benedetto Marcello",
        host_id: 148054092,
        host_name: "Steve S.R.L.",
        latitude: 45.43289,
        longitude: 12.33053,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33053, 45.43289]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22642760,
        name: "CA' PETRIANA canal view",
        host_id: 38346442,
        host_name: "Giancarlo",
        latitude: 45.43669,
        longitude: 12.33143,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33143, 45.43669]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22642826,
        name: "The Altana on San Marco",
        host_id: 166735193,
        host_name: "Silvia",
        latitude: 45.43453,
        longitude: 12.33832,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33832, 45.43453]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22646585,
        name: "CORTE GRANDA",
        host_id: 1545612,
        host_name: "Enrica",
        latitude: 45.43479,
        longitude: 12.32238,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32238, 45.43479]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22650001,
        name: "Cozy room with a view",
        host_id: 9202739,
        host_name: "Anna",
        latitude: 45.43849,
        longitude: 12.33225,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33225, 45.43849]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22664464,
        name: "Venice Apartment for you",
        host_id: 166967982,
        host_name: "Chiara",
        latitude: 45.44619,
        longitude: 12.32109,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32109, 45.44619]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22665602,
        name: "Apt. Ca' Oche Canal View (Historical Centre)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.43858,
        longitude: 12.32816,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32816, 45.43858]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22671798,
        name: "Biennale Art 1886",
        host_id: 127031595,
        host_name: "Dott Borella",
        latitude: 45.43508,
        longitude: 12.35767,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35767, 45.43508]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22681083,
        name: "Ca' Silva, comfy apartment in Venice, Cannaregio",
        host_id: 74157426,
        host_name: "Martina",
        latitude: 45.44264,
        longitude: 12.32305,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32305, 45.44264]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22697263,
        name: "Palazzo Boldù - Ca' Colombina",
        host_id: 4557370,
        host_name: "Giovanna",
        latitude: 45.4382,
        longitude: 12.34252,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34252, 45.4382]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22697638,
        name: "Family's Apartment...",
        host_id: 14084457,
        host_name: "Marcello",
        latitude: 45.43288,
        longitude: 12.35222,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35222, 45.43288]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22699060,
        name: "WITH 2 TERRACES, NEAR THE JEWISH GHETTO",
        host_id: 167369618,
        host_name: "Elena",
        latitude: 45.44449,
        longitude: 12.32786,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32786, 45.44449]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22699454,
        name: "Aquamarina Home",
        host_id: 26404861,
        host_name: "Marika",
        latitude: 45.4329,
        longitude: 12.3191,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3191, 45.4329]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22724674,
        name: "Casa Marina Castello 5820",
        host_id: 167699584,
        host_name: "Benedetta",
        latitude: 45.43793,
        longitude: 12.33912,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33912, 45.43793]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22724998,
        name: "Appartement dans le Palazzo Muazzo",
        host_id: 7354706,
        host_name: "Benjamin",
        latitude: 45.43874,
        longitude: 12.34432,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34432, 45.43874]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22726657,
        name: "Té a Venezia",
        host_id: 1823471,
        host_name: "Michele",
        latitude: 45.43248,
        longitude: 12.32927,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32927, 45.43248]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22743268,
        name: "Cà Trinità 5 min. to S.Marc square (city center)",
        host_id: 160055493,
        host_name: "Luca",
        latitude: 45.43796,
        longitude: 12.348,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.348, 45.43796]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22746763,
        name: "Cae Dea Testa",
        host_id: 13027859,
        host_name: "Diego",
        latitude: 45.44012,
        longitude: 12.341,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.341, 45.44012]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22748170,
        name: "Luxury home with terraces and jacuzzi",
        host_id: 167978086,
        host_name: "Paolo",
        latitude: 45.43923,
        longitude: 12.33747,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33747, 45.43923]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22756131,
        name: "LOLA APARTMENT REDENTOTRE 4 PAX - NEW",
        host_id: 97583266,
        host_name: "Alessia",
        latitude: 45.42371,
        longitude: 12.33059,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33059, 45.42371]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22756777,
        name:
          "Ca' Algi - Luxury San Marco View(L.T. M (Phone number hidden by Airbnb)",
        host_id: 5618111,
        host_name: "EasySuite",
        latitude: 45.43494,
        longitude: 12.34082,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34082, 45.43494]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22757306,
        name: "Do Pozzi waterdoor elegant flat",
        host_id: 13555449,
        host_name: "Fulvia",
        latitude: 45.44151,
        longitude: 12.33461,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33461, 45.44151]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22758436,
        name:
          "Residenza San Marco ai Do Mori (L.T. M (Phone number hidden by Airbnb)",
        host_id: 5618111,
        host_name: "EasySuite",
        latitude: 45.43578,
        longitude: 12.33735,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33735, 45.43578]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22760897,
        name: "Apartment Laura (near Biennale Arsenale)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.43711,
        longitude: 12.34896,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34896, 45.43711]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22769652,
        name: "Santa Marta, un appartamento per le vostre vacanze",
        host_id: 157352183,
        host_name: "Paola",
        latitude: 45.43306,
        longitude: 12.31419,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31419, 45.43306]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22785587,
        name: "Apartment Design Loft (400m from Rialto's Bridge)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.43816,
        longitude: 12.33956,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33956, 45.43816]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22785890,
        name: "Apartment with balcony in the heart of San Marco",
        host_id: 5182839,
        host_name: "Riccardo",
        latitude: 45.43428,
        longitude: 12.33324,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33324, 45.43428]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22799853,
        name: "VIVALDI APARTMENT ON TWO LEVELS WITH ATTIC",
        host_id: 16269342,
        host_name: "Anna",
        latitude: 45.44426,
        longitude: 12.33643,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33643, 45.44426]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22801408,
        name: "DolceVita Apartments 146 San Marco",
        host_id: 8176475,
        host_name: "Eugenia",
        latitude: 45.43286,
        longitude: 12.32908,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32908, 45.43286]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22802207,
        name: "Residenza Ca' Renata (L.T. M (Phone number hidden by Airbnb)",
        host_id: 5618111,
        host_name: "EasySuite",
        latitude: 45.4314,
        longitude: 12.35433,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35433, 45.4314]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22803605,
        name: "DolceVita Apartments 386 San Marco",
        host_id: 8176475,
        host_name: "Eugenia",
        latitude: 45.43533,
        longitude: 12.33037,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33037, 45.43533]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22805743,
        name: "DolceVita Apartments 387 San Marco",
        host_id: 8176475,
        host_name: "Eugenia",
        latitude: 45.43316,
        longitude: 12.32959,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32959, 45.43316]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22805916,
        name: "Ca' San Giacomo",
        host_id: 26404861,
        host_name: "Marika",
        latitude: 45.4406,
        longitude: 12.3278,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3278, 45.4406]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22808565,
        name: "Il tetto di Colombina",
        host_id: 26404861,
        host_name: "Marika",
        latitude: 45.43694,
        longitude: 12.34664,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34664, 45.43694]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22825249,
        name: "LUMINOSO ATTICO",
        host_id: 43929434,
        host_name: "Manuel E Michela",
        latitude: 45.43446,
        longitude: 12.35758,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35758, 45.43446]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22838567,
        name: "Ca Briani - Double Room - Laundry/Aircon/Safe/wifi",
        host_id: 25085773,
        host_name: "Gin",
        latitude: 45.44441,
        longitude: 12.33016,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33016, 45.44441]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22841113,
        name: "San Bartolomeo-Appartamento tra San Marco e Rialto",
        host_id: 28789742,
        host_name: "Michela",
        latitude: 45.43742,
        longitude: 12.337,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.337, 45.43742]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22859652,
        name: "Luminoso con scorci su Canal Grande",
        host_id: 1229136,
        host_name: "Martina",
        latitude: 45.43272,
        longitude: 12.32877,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32877, 45.43272]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22863747,
        name: "Casa dell'Orio 2",
        host_id: 632312,
        host_name: "Guillaume",
        latitude: 45.44063,
        longitude: 12.32834,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32834, 45.44063]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22871428,
        name: "AURORA - Canal view and lift",
        host_id: 10189388,
        host_name: "Raffaella",
        latitude: 45.44185,
        longitude: 12.33571,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33571, 45.44185]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22891489,
        name: "Central Apartment",
        host_id: 141518804,
        host_name: "Alessandra",
        latitude: 45.43737,
        longitude: 12.34036,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34036, 45.43737]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22893182,
        name: "Welc-oM Ca d'oro Venezia",
        host_id: 20717796,
        host_name: "Welc-Om",
        latitude: 45.44702,
        longitude: 12.32757,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32757, 45.44702]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22894317,
        name: "Canal Grande Retreat!",
        host_id: 73934712,
        host_name: "Tour Apartments",
        latitude: 45.43399,
        longitude: 12.32755,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32755, 45.43399]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22896240,
        name: "Citadelle, apartment with terrace, canal view",
        host_id: 169463063,
        host_name: "Carlo",
        latitude: 45.43637,
        longitude: 12.34717,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34717, 45.43637]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22896293,
        name: "Residenza Quaggio Apartment 1 (Calle Longa 2166)",
        host_id: 37356947,
        host_name: "Nicola",
        latitude: 45.44004,
        longitude: 12.33096,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33096, 45.44004]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22905928,
        name: "Ca' Dei Armeni San Marco - Polissena e Morosina",
        host_id: 16773988,
        host_name: "Isacco",
        latitude: 45.43438,
        longitude: 12.33704,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33704, 45.43438]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22913874,
        name: "Rene’s Romantic Apartment",
        host_id: 169636806,
        host_name: "Renato",
        latitude: 45.43042,
        longitude: 12.32891,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32891, 45.43042]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22914196,
        name: "casa alessandra",
        host_id: 169644013,
        host_name: "Michele",
        latitude: 45.44713,
        longitude: 12.3321,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3321, 45.44713]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22915880,
        name: "St. Felice: 5min Rialto only - canal view - wi-fi",
        host_id: 169463063,
        host_name: "Carlo",
        latitude: 45.4418,
        longitude: 12.33314,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33314, 45.4418]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22916390,
        name: "New Penthouse, canal view - free luggage storage",
        host_id: 169463063,
        host_name: "Carlo",
        latitude: 45.44265,
        longitude: 12.33439,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33439, 45.44265]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22919402,
        name: "San Giacomo avec jardin et terrasse",
        host_id: 22632812,
        host_name: "Alain",
        latitude: 45.44032,
        longitude: 12.3254,
        beds: 7,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3254, 45.44032]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22920724,
        name:
          '"Laguna Blu Venice Home" Appartamento in Palazzina storica a Santa Croce',
        host_id: 101018097,
        host_name: "Siria",
        latitude: 45.4401,
        longitude: 12.32538,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32538, 45.4401]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22921882,
        name: "FEELIN’ REZZONICO in the authentic heart of Venice",
        host_id: 169711810,
        host_name: "Filippo",
        latitude: 45.43322,
        longitude: 12.32295,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32295, 45.43322]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22925979,
        name: "威尼斯意家缘家庭旅馆",
        host_id: 7074201,
        host_name: "Bin",
        latitude: 45.43464,
        longitude: 12.35008,
        beds: 8,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35008, 45.43464]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22934044,
        name: "Retreat close to Rialto Bridge",
        host_id: 165805935,
        host_name: "Anna",
        latitude: 45.43975,
        longitude: 12.33609,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33609, 45.43975]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22935165,
        name: "Deluxe palace with amazing view on the Grand Canal",
        host_id: 289615,
        host_name: "Valentina",
        latitude: 45.44332,
        longitude: 12.32735,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32735, 45.44332]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22939568,
        name: "Casa Cecilia - CASANOVA Apartment",
        host_id: 24849926,
        host_name: "Cecilia",
        latitude: 45.4378,
        longitude: 12.34369,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34369, 45.4378]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22951595,
        name: "Biennale Family Apartment in Venice",
        host_id: 4056686,
        host_name: "Michela",
        latitude: 45.43418,
        longitude: 12.35641,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35641, 45.43418]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22952147,
        name: "Ve.N.I.Ce Cera San Marco Terrace",
        host_id: 37864680,
        host_name: "Ve.N.I.Ce Immobiliare Cera",
        latitude: 45.43313,
        longitude: 12.3374,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3374, 45.43313]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22953065,
        name: "Ca' Minetto",
        host_id: 26404861,
        host_name: "Marika",
        latitude: 45.43887,
        longitude: 12.33168,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33168, 45.43887]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22955557,
        name: "CA' DE MEZO",
        host_id: 170059333,
        host_name: "Alessia & Giorgia",
        latitude: 45.43969,
        longitude: 12.32693,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32693, 45.43969]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22956459,
        name: "Casa Cecilia - ARSENALE Apartment with Canal View",
        host_id: 24849926,
        host_name: "Cecilia",
        latitude: 45.43629,
        longitude: 12.34343,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34343, 45.43629]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22958092,
        name: "Il Mercante di Venezia",
        host_id: 86821446,
        host_name: "Antonio",
        latitude: 45.44382,
        longitude: 12.32684,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32684, 45.44382]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22966066,
        name: "Typical Venetian house over a canal",
        host_id: 136024505,
        host_name: "Miriam E Giulio",
        latitude: 45.4407,
        longitude: 12.33571,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33571, 45.4407]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22968875,
        name: "Luxury Apt.1: close to Rialto & Train Station",
        host_id: 133690220,
        host_name: "Silvia-Carlo",
        latitude: 45.44084,
        longitude: 12.32514,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32514, 45.44084]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22978211,
        name:
          "residenza San Stae (codice locazione M (Phone number hidden by Airbnb)",
        host_id: 170351239,
        host_name: "Laura",
        latitude: 45.44134,
        longitude: 12.33005,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33005, 45.44134]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22990903,
        name: "CANAL-DOOR cool, 2pax, Wifi, Aircond, canalview",
        host_id: 17534457,
        host_name: "Abaca",
        latitude: 45.44049,
        longitude: 12.34133,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34133, 45.44049]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22991089,
        name: "SAN POLO 2140 IN THE HEART OF VENICE",
        host_id: 170512190,
        host_name: "Emma",
        latitude: 45.43838,
        longitude: 12.32944,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32944, 45.43838]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22994967,
        name: "Luxury Apartment -5 min from Train Station - Wi-Fi",
        host_id: 133690220,
        host_name: "Silvia-Carlo",
        latitude: 45.44148,
        longitude: 12.32541,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32541, 45.44148]] },
    },
    {
      type: "Feature",
      properties: {
        id: 22998328,
        name: "Cà Rezzonico Apartments Skyline - 3° piano",
        host_id: 31637219,
        host_name: "Maria",
        latitude: 45.43385,
        longitude: 12.3262,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3262, 45.43385]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23000737,
        name: "Cozy and modern apartment in the heart of Venice!",
        host_id: 170593425,
        host_name: "Raffaella",
        latitude: 45.44237,
        longitude: 12.33947,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33947, 45.44237]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23001394,
        name: "Loft soleil",
        host_id: 2790016,
        host_name: "Jyoti  Ch",
        latitude: 45.42632,
        longitude: 12.32665,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32665, 45.42632]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23001640,
        name: "Cà Pepito Lovely Apartment in the heart of S.Marco",
        host_id: 3488715,
        host_name: "Luca",
        latitude: 45.43503,
        longitude: 12.33783,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33783, 45.43503]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23011931,
        name: "Canal view Next to San Marco square and Fenice",
        host_id: 170715583,
        host_name: "Massimo",
        latitude: 45.4342,
        longitude: 12.33129,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33129, 45.4342]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23012039,
        name: "cozy romantic appartament next to San Marco",
        host_id: 170715583,
        host_name: "Massimo",
        latitude: 45.43512,
        longitude: 12.32947,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32947, 45.43512]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23012144,
        name: "Next to Fenice and San Marco square",
        host_id: 170715583,
        host_name: "Massimo",
        latitude: 45.43401,
        longitude: 12.3316,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3316, 45.43401]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23016173,
        name: "San Marco Flat",
        host_id: 170755407,
        host_name: "Raffaele",
        latitude: 45.43466,
        longitude: 12.33929,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33929, 45.43466]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23018252,
        name: "Santacroce flat",
        host_id: 170772341,
        host_name: "Mare",
        latitude: 45.44083,
        longitude: 12.3248,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3248, 45.44083]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23032100,
        name: "Appartamento Soderini",
        host_id: 6304868,
        host_name: "Roberta",
        latitude: 45.43557,
        longitude: 12.34699,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34699, 45.43557]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23033531,
        name: "Ca'Lisa Canal view free Wi-Fi",
        host_id: 67629523,
        host_name: "Lisa",
        latitude: 45.4382,
        longitude: 12.34607,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34607, 45.4382]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23034841,
        name: "Ca Silvia Saint Mark Square Apartment",
        host_id: 5862083,
        host_name: "Silvia",
        latitude: 45.43592,
        longitude: 12.33887,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33887, 45.43592]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23050366,
        name: "Cà Lillu, casa romantica, Venezia Castello",
        host_id: 171077602,
        host_name: "Lucia",
        latitude: 45.4358,
        longitude: 12.34885,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34885, 45.4358]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23052071,
        name: "Ca' Agostina",
        host_id: 22940319,
        host_name: "Albatroservices",
        latitude: 45.43797,
        longitude: 12.32973,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32973, 45.43797]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23059977,
        name: "Cozy ROOM with panoramic GHETTO and CANAL View",
        host_id: 89815184,
        host_name: "Eugenio",
        latitude: 45.44527,
        longitude: 12.32694,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32694, 45.44527]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23082744,
        name: "Residenza Al Giardino (L.T. M (Phone number hidden by Airbnb)",
        host_id: 5618111,
        host_name: "EasySuite",
        latitude: 45.4462,
        longitude: 12.32271,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32271, 45.4462]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23085122,
        name: "SAN POLO APARTMENT",
        host_id: 171426751,
        host_name: "Teresa",
        latitude: 45.43627,
        longitude: 12.32977,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32977, 45.43627]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23085493,
        name: "Casa Cecilia - DUCALE Apartment",
        host_id: 24849926,
        host_name: "Cecilia",
        latitude: 45.436,
        longitude: 12.34306,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34306, 45.436]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23085547,
        name: "Ca Mae - Luxury Experience in Venice - red",
        host_id: 131447529,
        host_name: "Sandro",
        latitude: 45.43575,
        longitude: 12.32401,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32401, 45.43575]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23096292,
        name: "Romantic Venice - 8-min walk from Rialto",
        host_id: 29706566,
        host_name: "Margherita & Valentina",
        latitude: 45.43996,
        longitude: 12.34089,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34089, 45.43996]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23100324,
        name: "sunny apartment Calle della Madonetta Venice",
        host_id: 171598920,
        host_name: "Lorenzo",
        latitude: 45.42462,
        longitude: 12.33656,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33656, 45.42462]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23101534,
        name: "Campo San Provolo Flat",
        host_id: 76965091,
        host_name: "Marina",
        latitude: 45.43455,
        longitude: 12.34309,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34309, 45.43455]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23116862,
        name: "Cà Lulli, casa romantica Venezia Castello Arsenale",
        host_id: 171077602,
        host_name: "Lucia",
        latitude: 45.43409,
        longitude: 12.35232,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35232, 45.43409]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23118034,
        name: "Bisanzio di Nike appartamenti",
        host_id: 171779703,
        host_name: "Elena",
        latitude: 45.4387,
        longitude: 12.34098,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34098, 45.4387]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23122806,
        name: "Venice Biennale Flat Giardini Apartment",
        host_id: 171464445,
        host_name: "Enrico",
        latitude: 45.43233,
        longitude: 12.35327,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35327, 45.43233]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23160219,
        name: "San Marco Canal View “Music” Apartment",
        host_id: 5530875,
        host_name: "Maurizio",
        latitude: 45.43314,
        longitude: 12.33043,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33043, 45.43314]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23160990,
        name: "Full canal view few steps from San Marco Square",
        host_id: 40852487,
        host_name: "Andrew",
        latitude: 45.43359,
        longitude: 12.33583,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33583, 45.43359]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23161941,
        name: "Le Guglie LT",
        host_id: 2985972,
        host_name: "Paolo",
        latitude: 45.44489,
        longitude: 12.32318,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32318, 45.44489]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23174959,
        name: "ROUSSEAU'S APARTMENT",
        host_id: 170750872,
        host_name: "Sara",
        latitude: 45.4446,
        longitude: 12.32017,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32017, 45.4446]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23184613,
        name: "The green room",
        host_id: 172365488,
        host_name: "Camera",
        latitude: 45.43098,
        longitude: 12.32134,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32134, 45.43098]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23192183,
        name: "Venice San Polo Ca' Roky wi-fi",
        host_id: 15112827,
        host_name: "Marco",
        latitude: 45.43616,
        longitude: 12.32895,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32895, 45.43616]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23199170,
        name: "Gherardini Canal View (500m from Rialto's Bridge)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.43795,
        longitude: 12.33082,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33082, 45.43795]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23220282,
        name: 'S. Caterina - Camera "Garusolo"',
        host_id: 84543765,
        host_name: "Maurizio&Francesca",
        latitude: 45.44443,
        longitude: 12.33637,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33637, 45.44443]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23230864,
        name: "Central bright double room",
        host_id: 172838960,
        host_name: "Venice",
        latitude: 45.43275,
        longitude: 12.33275,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33275, 45.43275]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23231116,
        name: "Central Cosy Biennale House with a balcony",
        host_id: 172838960,
        host_name: "Venice",
        latitude: 45.43222,
        longitude: 12.33404,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33404, 45.43222]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23248901,
        name: "CA' TEATRO VECCHIO",
        host_id: 3736168,
        host_name: "EasyRentals",
        latitude: 45.44098,
        longitude: 12.33153,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33153, 45.44098]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23261533,
        name: "Ca'Corte Canal",
        host_id: 14179848,
        host_name: "Alain",
        latitude: 45.43107,
        longitude: 12.32234,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32234, 45.43107]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23261983,
        name: "ARRIVING by TRAIN#1 - quiet, 4pax, gardenview wifi",
        host_id: 17534457,
        host_name: "Abaca",
        latitude: 45.43861,
        longitude: 12.32516,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32516, 45.43861]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23262260,
        name: "ARRIVING by TRAIN#2 - quiet, 4pax, internet",
        host_id: 17534457,
        host_name: "Abaca",
        latitude: 45.4399,
        longitude: 12.32346,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32346, 45.4399]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23262397,
        name: "ARRIVING by TRAIN#12 - quiet 8pax wifi gardenview",
        host_id: 17534457,
        host_name: "Abaca",
        latitude: 45.43957,
        longitude: 12.32473,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32473, 45.43957]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23262740,
        name: "AMAZING CANAL VIEW: free wi-fi & Venice centre",
        host_id: 133690220,
        host_name: "Silvia-Carlo",
        latitude: 45.44244,
        longitude: 12.33232,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33232, 45.44244]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23266099,
        name:
          "RED CARPET APARTMENT_ VENICE CENTER_M (Phone number hidden by Airbnb)",
        host_id: 173186304,
        host_name: "Alessandro",
        latitude: 45.43996,
        longitude: 12.32987,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32987, 45.43996]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23273350,
        name: "Ca' Crea 1",
        host_id: 31064633,
        host_name: "Oxy",
        latitude: 45.4464,
        longitude: 12.32167,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32167, 45.4464]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23281493,
        name:
          "Cà dei Franchi  Dorsoduro Guggenheim (M (Phone number hidden by Airbnb)",
        host_id: 173326533,
        host_name: "Davide",
        latitude: 45.4292,
        longitude: 12.3311,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3311, 45.4292]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23286669,
        name: "Apartment Giovanni (Historical Centre)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.44568,
        longitude: 12.32473,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32473, 45.44568]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23296682,
        name: "Rialto Luxury Flat - Canal View Apartment",
        host_id: 2490984,
        host_name: "Dominique",
        latitude: 45.44011,
        longitude: 12.33809,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33809, 45.44011]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23296820,
        name: "Rialto Luxury Flat - Balcony Apartment",
        host_id: 2490984,
        host_name: "Dominique",
        latitude: 45.43946,
        longitude: 12.3365,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3365, 45.43946]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23297455,
        name: "Ca' Crea 2 B&B/2",
        host_id: 31064633,
        host_name: "Oxy",
        latitude: 45.44485,
        longitude: 12.32124,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32124, 45.44485]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23297901,
        name: "Casa Teresa",
        host_id: 31708437,
        host_name: "Simonetta & Margherita",
        latitude: 45.43159,
        longitude: 12.35582,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35582, 45.43159]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23299294,
        name: "Ca' Crea 2 B&B/3",
        host_id: 31064633,
        host_name: "Oxy",
        latitude: 45.44497,
        longitude: 12.3215,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3215, 45.44497]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23299791,
        name: "Studio Frari",
        host_id: 173200514,
        host_name: "Rent&Relax",
        latitude: 45.4362,
        longitude: 12.32838,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32838, 45.4362]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23299792,
        name: "Zattere Design Loft",
        host_id: 173200514,
        host_name: "Rent&Relax",
        latitude: 45.4295,
        longitude: 12.32727,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32727, 45.4295]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23299797,
        name: "Attic Boutique San Marco",
        host_id: 173200514,
        host_name: "Rent&Relax",
        latitude: 45.43444,
        longitude: 12.34647,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34647, 45.43444]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23299798,
        name: "Rialto Design Boutique Apartment",
        host_id: 173200514,
        host_name: "Rent&Relax",
        latitude: 45.44235,
        longitude: 12.3376,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3376, 45.44235]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23299801,
        name: "Cà Rezzonico Apartment",
        host_id: 173200514,
        host_name: "Rent&Relax",
        latitude: 45.43411,
        longitude: 12.32568,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32568, 45.43411]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23299802,
        name: "Grand Canal Design Apartment",
        host_id: 173200514,
        host_name: "Rent&Relax",
        latitude: 45.43831,
        longitude: 12.33244,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33244, 45.43831]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23299803,
        name: "Arsenale Design Apartment R&R",
        host_id: 173200514,
        host_name: "Rent&Relax",
        latitude: 45.43445,
        longitude: 12.34895,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34895, 45.43445]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23299925,
        name: "Ca' Crea 2 B&B/1",
        host_id: 31064633,
        host_name: "Oxy",
        latitude: 45.4453,
        longitude: 12.32249,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32249, 45.4453]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23303164,
        name: "Appartamento sul rio",
        host_id: 173505151,
        host_name: "Achillina",
        latitude: 45.43604,
        longitude: 12.34261,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34261, 45.43604]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23305172,
        name: "Cà Malù Rooftop in the Heart of Venice!",
        host_id: 3488715,
        host_name: "Luca",
        latitude: 45.43579,
        longitude: 12.3384,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3384, 45.43579]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23307892,
        name: "Monolocale Teresa",
        host_id: 31708437,
        host_name: "Simonetta & Margherita",
        latitude: 45.42991,
        longitude: 12.35594,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35594, 45.42991]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23318035,
        name: "Ca' del Cortile 1,  studio flat with courtyard",
        host_id: 173503437,
        host_name: "Federica",
        latitude: 45.4341,
        longitude: 12.33317,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33317, 45.4341]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23320010,
        name: "Ca' del Cortile 2, flat with courtyard",
        host_id: 173503437,
        host_name: "Federica",
        latitude: 45.43427,
        longitude: 12.33175,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33175, 45.43427]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23321103,
        name: "Ca' del Cortile 3, flat with courtyard",
        host_id: 173503437,
        host_name: "Federica",
        latitude: 45.4339,
        longitude: 12.33319,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33319, 45.4339]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23321706,
        name: "Lovely house with an amazing garden in Venice",
        host_id: 89795375,
        host_name: "Rosario",
        latitude: 45.42631,
        longitude: 12.32405,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32405, 45.42631]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23325098,
        name: "Ca' dei Scorzeri: Modern & Quite apt - free Wifi",
        host_id: 133690220,
        host_name: "Silvia-Carlo",
        latitude: 45.4248,
        longitude: 12.3279,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3279, 45.4248]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23333662,
        name: "Cosy and central apartment",
        host_id: 2902646,
        host_name: "Orial",
        latitude: 45.44302,
        longitude: 12.33753,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33753, 45.44302]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23340789,
        name: "Carina Loft",
        host_id: 123417741,
        host_name: "Paolo",
        latitude: 45.43513,
        longitude: 12.33944,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33944, 45.43513]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23347089,
        name: "Luxury apartment in a strategic position",
        host_id: 27790287,
        host_name: "Luz Karime",
        latitude: 45.43476,
        longitude: 12.32505,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32505, 45.43476]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23349548,
        name: "Palazzo Pisani Nicolaj",
        host_id: 75691230,
        host_name: "Patrizia",
        latitude: 45.43963,
        longitude: 12.34055,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34055, 45.43963]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23355484,
        name: "Melusina Large apartment -groups or families",
        host_id: 9017175,
        host_name: "Andrea",
        latitude: 45.43936,
        longitude: 12.34559,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34559, 45.43936]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23365669,
        name: "Vibrant Updated Apartment with Private Courtyard",
        host_id: 27081641,
        host_name: "Irene",
        latitude: 45.4344,
        longitude: 12.32361,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32361, 45.4344]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23381510,
        name: "27@SMarco boutique apt. 120mt. from S.Marco square",
        host_id: 21001069,
        host_name: "Lucia&Nicola",
        latitude: 45.43343,
        longitude: 12.33597,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33597, 45.43343]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23389718,
        name: "LA CASA DI EMMA - In the heart of Venice",
        host_id: 10189388,
        host_name: "Raffaella",
        latitude: 45.43689,
        longitude: 12.33166,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33166, 45.43689]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23394789,
        name: "La casa di Pì",
        host_id: 174418896,
        host_name: "Mimax",
        latitude: 45.44002,
        longitude: 12.33878,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33878, 45.44002]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23408509,
        name: "Venice Homestay Restful Spacious Bedroom San Marco",
        host_id: 804374,
        host_name: "Fiona",
        latitude: 45.43579,
        longitude: 12.34451,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34451, 45.43579]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23408595,
        name: "NEW APT ** Ca BERENICE / Biennale - Wifi FREE",
        host_id: 174552968,
        host_name: "Beatrice",
        latitude: 45.43254,
        longitude: 12.35812,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35812, 45.43254]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23423438,
        name:
          "COZY APARTMENT IN RIALTO  cod:  M (Phone number hidden by Airbnb)",
        host_id: 62523490,
        host_name: "Martina",
        latitude: 45.43877,
        longitude: 12.33469,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33469, 45.43877]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23427362,
        name: "CA' RIBALDI",
        host_id: 38346442,
        host_name: "Giancarlo",
        latitude: 45.43245,
        longitude: 12.35169,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35169, 45.43245]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23428044,
        name: "Casa Sarria - 8 min walk from Rialto",
        host_id: 174733491,
        host_name: "Gladys E Valentina",
        latitude: 45.44114,
        longitude: 12.34036,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34036, 45.44114]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23441597,
        name: "Chez Rina",
        host_id: 174874518,
        host_name: "Daria",
        latitude: 45.44337,
        longitude: 12.32284,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32284, 45.44337]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23442397,
        name: "Sunny apartment near the Biennale",
        host_id: 174878515,
        host_name: "Graziana",
        latitude: 45.42982,
        longitude: 12.36072,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.36072, 45.42982]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23447149,
        name: "DolceVita Apartments N. 408 Terrace",
        host_id: 8176475,
        host_name: "Eugenia",
        latitude: 45.43804,
        longitude: 12.34458,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34458, 45.43804]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23449647,
        name: "Picenin Apartment",
        host_id: 1617572,
        host_name: "Silvia",
        latitude: 45.43345,
        longitude: 12.35372,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35372, 45.43345]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23462657,
        name: "Budget Room in the historic center of Venice",
        host_id: 1617572,
        host_name: "Silvia",
        latitude: 45.43378,
        longitude: 12.35511,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35511, 45.43378]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23474588,
        name: "Longhi's House Garden",
        host_id: 120946584,
        host_name: "Maria Rebecca",
        latitude: 45.44255,
        longitude: 12.34058,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34058, 45.44255]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23477048,
        name: "Panoramic Suite  “Ca' MONICA “",
        host_id: 147048987,
        host_name: "Monica",
        latitude: 45.43851,
        longitude: 12.3498,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3498, 45.43851]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23512302,
        name: "Ca' Navagero 3-Riva degli Schiavoni (w/terrace)",
        host_id: 50282865,
        host_name: "Alberta",
        latitude: 45.4343,
        longitude: 12.34602,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34602, 45.4343]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23513778,
        name: "Lovely place in the center town, quiet and elegant",
        host_id: 175624502,
        host_name: "Maison D'Elite",
        latitude: 45.44022,
        longitude: 12.33925,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33925, 45.44022]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23518696,
        name: "SAN POLO PAINTINGS 3pax, aircond, WiFi Internet",
        host_id: 36053748,
        host_name: "Mick",
        latitude: 45.4363,
        longitude: 12.32688,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32688, 45.4363]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23532384,
        name: "Concerto in gondola charming apartment",
        host_id: 175801067,
        host_name: "Ele",
        latitude: 45.43321,
        longitude: 12.33497,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33497, 45.43321]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23534726,
        name: "HENRY'S HEAVEN",
        host_id: 175819460,
        host_name: "Maria Gabriella",
        latitude: 45.43706,
        longitude: 12.32619,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32619, 45.43706]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23537328,
        name: "VENICE SMALL CANAL VIEW IN BOUTIQUE APARTMENT",
        host_id: 175840892,
        host_name: "Monica",
        latitude: 45.44479,
        longitude: 12.32664,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32664, 45.44479]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23555071,
        name: "Sofia Residence",
        host_id: 43172176,
        host_name: "Sonia",
        latitude: 45.44416,
        longitude: 12.33022,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33022, 45.44416]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23557291,
        name: "Ca'SofiMar apartment",
        host_id: 173330609,
        host_name: "Luca",
        latitude: 45.44112,
        longitude: 12.33969,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33969, 45.44112]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23569452,
        name: "NEW APT *** Biennale Ca' Lucatello - WiFi Gratis",
        host_id: 123394838,
        host_name: "Luca",
        latitude: 45.43122,
        longitude: 12.35311,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35311, 45.43122]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23570677,
        name: "Palazzo Grassi Flat",
        host_id: 176160976,
        host_name: "Riccardo",
        latitude: 45.43345,
        longitude: 12.32779,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32779, 45.43345]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23620683,
        name: "Calla Apartment",
        host_id: 26404861,
        host_name: "Marika",
        latitude: 45.43509,
        longitude: 12.32367,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32367, 45.43509]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23624143,
        name: "LUXURY BAROQUE CHIC IN SAN MARCO WITH ROOF TERRACE",
        host_id: 176760696,
        host_name: "Caroline",
        latitude: 45.434,
        longitude: 12.33201,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33201, 45.434]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23625561,
        name: "Attic in Venice",
        host_id: 4189569,
        host_name: "Gilda",
        latitude: 45.44137,
        longitude: 12.34162,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34162, 45.44137]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23635043,
        name: "casa a Venezia sul canale tra il verde.",
        host_id: 2906995,
        host_name: "Aniuta",
        latitude: 45.42698,
        longitude: 12.36375,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.36375, 45.42698]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23637108,
        name: "Suite Ai Leoni, cozy flat free wifi",
        host_id: 9609304,
        host_name: "Luca",
        latitude: 45.43367,
        longitude: 12.35021,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35021, 45.43367]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23637443,
        name: "La Marchesa Exquisite Apartment in the Heart of Venice",
        host_id: 669047,
        host_name: "Viewsonvenice",
        latitude: 45.43456,
        longitude: 12.33156,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33156, 45.43456]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23639371,
        name: "Your luxurious and unforgettable place in Venice!",
        host_id: 29461676,
        host_name: "Rebecca",
        latitude: 45.43371,
        longitude: 12.34694,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34694, 45.43371]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23662289,
        name: "APPARTAMENT AITREPONTIVENEZIA",
        host_id: 35689579,
        host_name: "Haleh",
        latitude: 45.4374,
        longitude: 12.31943,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31943, 45.4374]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23674841,
        name:
          "Gem's House, romantica casa veneziana con ingresso indipendente e wi-fi gratuito",
        host_id: 112384231,
        host_name: "Cristina",
        latitude: 45.42882,
        longitude: 12.35785,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35785, 45.42882]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23706778,
        name: "Uma apartment, one step from San Marco square!",
        host_id: 175070397,
        host_name: "Marianna",
        latitude: 45.43596,
        longitude: 12.33627,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33627, 45.43596]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23708462,
        name: "Apartment Anita Terrace - Canal view",
        host_id: 28552652,
        host_name: "Luciana",
        latitude: 45.44345,
        longitude: 12.33491,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33491, 45.44345]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23725563,
        name: "Mater Domini Apartment M (Phone number hidden by Airbnb)",
        host_id: 20806166,
        host_name: "Giovanna",
        latitude: 45.43898,
        longitude: 12.33016,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33016, 45.43898]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23726867,
        name: "Ca' del Magio",
        host_id: 177860441,
        host_name: "Luca",
        latitude: 45.44131,
        longitude: 12.32988,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32988, 45.44131]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23738827,
        name: "Càdorin Apartment",
        host_id: 20256253,
        host_name: "Chiara",
        latitude: 45.44391,
        longitude: 12.33055,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33055, 45.44391]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23739512,
        name: "Molino Stucky Apartment Wi-Fi R&R",
        host_id: 173200514,
        host_name: "Rent&Relax",
        latitude: 45.42741,
        longitude: 12.31833,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31833, 45.42741]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23744275,
        name: "Cozy studio in a central but quiet neighborhood",
        host_id: 567508,
        host_name: "Nicola",
        latitude: 45.43908,
        longitude: 12.34594,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34594, 45.43908]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23758349,
        name: "Ca' del Forner (L.T. M (Phone number hidden by Airbnb)",
        host_id: 5618111,
        host_name: "EasySuite",
        latitude: 45.43754,
        longitude: 12.32288,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32288, 45.43754]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23761804,
        name: "Cae Dea Lana Canal view",
        host_id: 13027859,
        host_name: "Diego",
        latitude: 45.43822,
        longitude: 12.32178,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32178, 45.43822]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23763077,
        name: "Spezier Design Venetian Studio",
        host_id: 669047,
        host_name: "Viewsonvenice",
        latitude: 45.44249,
        longitude: 12.33231,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33231, 45.44249]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23776237,
        name: "Ca' Margherita",
        host_id: 89447127,
        host_name: "Nat",
        latitude: 45.43532,
        longitude: 12.32442,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32442, 45.43532]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23776291,
        name: "Modern Studio / Loft near Rialto Mercato",
        host_id: 114802002,
        host_name: "Golden Pillow",
        latitude: 45.4383,
        longitude: 12.3344,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3344, 45.4383]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23782043,
        name: "130sqm home ideal for large families or groups",
        host_id: 114664320,
        host_name: "Francesco",
        latitude: 45.4382,
        longitude: 12.338,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.338, 45.4382]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23784140,
        name: "Ca' Celestia Arsenale",
        host_id: 178447697,
        host_name: "Enrico",
        latitude: 45.43868,
        longitude: 12.34799,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34799, 45.43868]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23784509,
        name: "SECRET GARDEN APARTMENT",
        host_id: 29792800,
        host_name: "Consuelo",
        latitude: 45.43514,
        longitude: 12.32676,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32676, 45.43514]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23787770,
        name: "Ca' Chioverete",
        host_id: 178485735,
        host_name: "Michela",
        latitude: 45.44361,
        longitude: 12.32391,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32391, 45.44361]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23801953,
        name: "Casanova Garden Apartment",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.4452,
        longitude: 12.334,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.334, 45.4452]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23802869,
        name: "San Marco Suite Apartment",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.43459,
        longitude: 12.34002,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34002, 45.43459]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23806424,
        name: "San Marco amazing view in 80 square meters",
        host_id: 178654816,
        host_name: "Marica, Rossella & Anna",
        latitude: 45.4248,
        longitude: 12.33581,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33581, 45.4248]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23806773,
        name: "Laguna Blu  Venice Cod. ID.M (Phone number hidden by Airbnb)",
        host_id: 45342577,
        host_name: "Daria",
        latitude: 45.4469,
        longitude: 12.32088,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32088, 45.4469]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23807972,
        name: "La Rosa di Venezia - the best place to live Venice",
        host_id: 10417091,
        host_name: "Robert",
        latitude: 45.43476,
        longitude: 12.33893,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33893, 45.43476]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23808739,
        name: "VENICE - Gem in private Palazzo on the canal",
        host_id: 31635037,
        host_name: "Francesco & Daniel",
        latitude: 45.43607,
        longitude: 12.32883,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32883, 45.43607]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23809395,
        name: "Stunning Luxury Loft, with Private Terrace on Canal",
        host_id: 178683750,
        host_name: "Pietro",
        latitude: 45.43819,
        longitude: 12.34528,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34528, 45.43819]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23809727,
        name: "Terrace Luxury Loft, for 6 people",
        host_id: 178683750,
        host_name: "Pietro",
        latitude: 45.43929,
        longitude: 12.34684,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34684, 45.43929]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23810099,
        name: "Terrace Luxury Loft, perfect for 14 people!",
        host_id: 178683750,
        host_name: "Pietro",
        latitude: 45.43884,
        longitude: 12.3461,
        beds: 9,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3461, 45.43884]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23814689,
        name: "Residenza Ca' Matta Venezia",
        host_id: 178751908,
        host_name: "Beatrice",
        latitude: 45.43286,
        longitude: 12.31219,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31219, 45.43286]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23815989,
        name: "Sartor Canal View Apartment",
        host_id: 669047,
        host_name: "Viewsonvenice",
        latitude: 45.44179,
        longitude: 12.33304,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33304, 45.44179]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23816516,
        name: "SweetLuna",
        host_id: 178766660,
        host_name: "Luna",
        latitude: 45.44093,
        longitude: 12.34048,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34048, 45.44093]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23816582,
        name: "Residence Odoni",
        host_id: 157492478,
        host_name: "Michele",
        latitude: 45.43742,
        longitude: 12.32291,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32291, 45.43742]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23818346,
        name: "Scaleter Spacious Venetian Apartment",
        host_id: 669047,
        host_name: "Viewsonvenice",
        latitude: 45.44221,
        longitude: 12.33317,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33317, 45.44221]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23835234,
        name: "GIARDINI BIENNALE APARTMENT",
        host_id: 32887555,
        host_name: "Residence Corte Grimani",
        latitude: 45.43085,
        longitude: 12.35597,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35597, 45.43085]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23835548,
        name: "Ca' ALANSARI",
        host_id: 178959160,
        host_name: "Alessio E Andrea",
        latitude: 45.44427,
        longitude: 12.32823,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32823, 45.44427]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23836753,
        name: "Apartment Corte Biennale",
        host_id: 32887555,
        host_name: "Residence Corte Grimani",
        latitude: 45.43185,
        longitude: 12.35709,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35709, 45.43185]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23837250,
        name: "ROMANTIC COZY FLAT IN THE HEART OF VENICE",
        host_id: 13500918,
        host_name: "Mark",
        latitude: 45.42935,
        longitude: 12.35687,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35687, 45.42935]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23838779,
        name: "Campiello degli Squelini",
        host_id: 46904188,
        host_name: "Mirco Optyflat",
        latitude: 45.43349,
        longitude: 12.32585,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32585, 45.43349]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23838849,
        name: "Cozy townhouse in the Giudecca island",
        host_id: 154169936,
        host_name: "Francesca",
        latitude: 45.4257,
        longitude: 12.32664,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32664, 45.4257]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23846752,
        name: "Bright 2-bedroom flat overlooking Venice roofs",
        host_id: 7545741,
        host_name: "Stefano",
        latitude: 45.43669,
        longitude: 12.33673,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33673, 45.43669]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23848808,
        name: "Family room with terrace",
        host_id: 17684080,
        host_name: "Rupu",
        latitude: 45.43494,
        longitude: 12.3432,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3432, 45.43494]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23848827,
        name: "Palazzo DaPonte 04 - Romantic Balcony Canal View",
        host_id: 2718137,
        host_name: "DaPonte",
        latitude: 45.43756,
        longitude: 12.33839,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33839, 45.43756]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23851167,
        name:
          "Vivaldi Centro Storico  con giardino M (Phone number hidden by Airbnb)",
        host_id: 46466051,
        host_name: "Alberto",
        latitude: 45.44168,
        longitude: 12.32825,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32825, 45.44168]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23853337,
        name: "Evelina Apartment Centro Storico Venezia",
        host_id: 179163258,
        host_name: "Laura",
        latitude: 45.44435,
        longitude: 12.32476,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32476, 45.44435]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23853470,
        name: "THE TRAVELLER’S HOUSE",
        host_id: 3880254,
        host_name: "Sabina",
        latitude: 45.43567,
        longitude: 12.32413,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32413, 45.43567]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23853932,
        name: "A designer apartment in Biennale",
        host_id: 99483488,
        host_name: "Laurence",
        latitude: 45.43272,
        longitude: 12.35704,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35704, 45.43272]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23855690,
        name: "Casa Mori, cozy&central apt",
        host_id: 106389311,
        host_name: "Morena",
        latitude: 45.43929,
        longitude: 12.33843,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33843, 45.43929]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23856164,
        name: "Ve-nice Suite Canal Grande SC1979",
        host_id: 22423242,
        host_name: "Stefano",
        latitude: 45.44121,
        longitude: 12.33043,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33043, 45.44121]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23864617,
        name: "RIALTO-FONDACO DEI TEDESCHI ROMANTIC VENICE HOME",
        host_id: 179297180,
        host_name: "Chiara",
        latitude: 45.43854,
        longitude: 12.34294,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34294, 45.43854]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23866853,
        name: "Double Room in Venice",
        host_id: 179303936,
        host_name: "Giorgia",
        latitude: 45.43963,
        longitude: 12.33307,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33307, 45.43963]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23869218,
        name: "Venice Hazel Locazione Turistica Double Room",
        host_id: 17684080,
        host_name: "Rupu",
        latitude: 45.43627,
        longitude: 12.34391,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34391, 45.43627]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23872715,
        name: "Accademia Charm Apartment n. 3",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.4307,
        longitude: 12.33304,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33304, 45.4307]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23872718,
        name: "Venice Luxury Palace 4",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.43846,
        longitude: 12.33149,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33149, 45.43846]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23874555,
        name: "Venice Luxury Palace 8",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.4373,
        longitude: 12.33272,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33272, 45.4373]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23880274,
        name: "Ve-nice Suite Venier C4856",
        host_id: 22423242,
        host_name: "Stefano",
        latitude: 45.44114,
        longitude: 12.33957,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33957, 45.44114]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23887749,
        name: "Apartment Silvestro Terrace - Venice 4 People",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.438,
        longitude: 12.33346,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33346, 45.438]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23890231,
        name: "SWALLOW'S HOUSE: CHARMING LARGE SPACES IN RIALTO",
        host_id: 3880254,
        host_name: "Sabina",
        latitude: 45.44048,
        longitude: 12.33288,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33288, 45.44048]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23891918,
        name: "Accademia Suite",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.43088,
        longitude: 12.33373,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33373, 45.43088]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23892377,
        name: "Venice  Luxury Palace  10",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.43855,
        longitude: 12.33141,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33141, 45.43855]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23893150,
        name: "Venice Luxury Palace 13",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.4385,
        longitude: 12.33264,
        beds: 8,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33264, 45.4385]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23893769,
        name: "San Marco Penthouse",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.43684,
        longitude: 12.337,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.337, 45.43684]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23894312,
        name: "Venice View on Gran Canal",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.44344,
        longitude: 12.32439,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32439, 45.44344]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23895140,
        name: "Venice Ca' dei Miracoli Apartment",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.44216,
        longitude: 12.34018,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34018, 45.44216]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23897109,
        name: "Ca' Badoer - Family",
        host_id: 108848739,
        host_name: "Frari 2000 S.A.S.",
        latitude: 45.43654,
        longitude: 12.32629,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32629, 45.43654]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23908244,
        name: "Casa Frida For Smart Workers and Tourists",
        host_id: 179354563,
        host_name: "Frida",
        latitude: 45.4297,
        longitude: 12.33091,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33091, 45.4297]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23909323,
        name: "Rialto Project Apartment 3",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.43748,
        longitude: 12.32761,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32761, 45.43748]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23909448,
        name: "San Marco Deluxe Canal View Balcony",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.43787,
        longitude: 12.33881,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33881, 45.43787]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23910139,
        name: "San Marco Deluxe Canal View Terrace",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.43818,
        longitude: 12.34043,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34043, 45.43818]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23910765,
        name: "Santi Apostoli Venice Apartment",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.44175,
        longitude: 12.33615,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33615, 45.44175]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23911122,
        name: "Venice Cà San Marco Canal View",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.43453,
        longitude: 12.33555,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33555, 45.43453]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23911273,
        name: "Suite Deluxe Ca' del Dose",
        host_id: 24889853,
        host_name: "Sandra",
        latitude: 45.43654,
        longitude: 12.34104,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34104, 45.43654]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23914373,
        name: "Poli Grappa Suite",
        host_id: 37864680,
        host_name: "Ve.N.I.Ce Immobiliare Cera",
        latitude: 45.43304,
        longitude: 12.33305,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33305, 45.43304]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23915843,
        name: "Giudecca Bella your house",
        host_id: 41491566,
        host_name: "Franca",
        latitude: 45.42509,
        longitude: 12.32665,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32665, 45.42509]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23918161,
        name: "APPARTAMENTO IN PALAZZO STORICO",
        host_id: 179780899,
        host_name: "Marco",
        latitude: 45.43343,
        longitude: 12.32081,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32081, 45.43343]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23933137,
        name: "Ca' Badoer - East Studio",
        host_id: 108848739,
        host_name: "Frari 2000 S.A.S.",
        latitude: 45.43889,
        longitude: 12.32755,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32755, 45.43889]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23933298,
        name: "Casa dell'Orio1",
        host_id: 632312,
        host_name: "Guillaume",
        latitude: 45.44127,
        longitude: 12.32859,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32859, 45.44127]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23935991,
        name: "Ca Mae - Luxury Experience in Venice",
        host_id: 131447529,
        host_name: "Sandro",
        latitude: 45.43698,
        longitude: 12.32298,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32298, 45.43698]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23936405,
        name: "Camilla apartment in Venice (Molino)",
        host_id: 89073004,
        host_name: "Alberto",
        latitude: 45.42756,
        longitude: 12.3195,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3195, 45.42756]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23938036,
        name: "Casa Dolce Vita - Casa Dolce Vita",
        host_id: 37864680,
        host_name: "Ve.N.I.Ce Immobiliare Cera",
        latitude: 45.43535,
        longitude: 12.33129,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33129, 45.43535]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23939921,
        name: "Palazzo Vendramin-Costa  Artist Studio-Loft",
        host_id: 4896545,
        host_name: "Karolien",
        latitude: 45.44199,
        longitude: 12.33361,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33361, 45.44199]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23940209,
        name: "Cozy double room in the Heart of Venice",
        host_id: 179303936,
        host_name: "Giorgia",
        latitude: 45.43904,
        longitude: 12.3351,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3351, 45.43904]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23950999,
        name: "Ca Vallo, au coeur de Venise",
        host_id: 22632812,
        host_name: "Alain",
        latitude: 45.43609,
        longitude: 12.34778,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34778, 45.43609]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23955078,
        name: "Alberto apartment in Venice (Orseolo)",
        host_id: 89073004,
        host_name: "Alberto",
        latitude: 45.43491,
        longitude: 12.33595,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33595, 45.43491]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23955979,
        name: "Apartment Lara Terrace  (Historical Centre)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.42949,
        longitude: 12.33034,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33034, 45.42949]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23957027,
        name: "Ca' Mercante di Spezie-near Biennale and St. Mark",
        host_id: 180140414,
        host_name: "Luca",
        latitude: 45.43428,
        longitude: 12.34958,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34958, 45.43428]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23957616,
        name: "Best Rialto Palace Apartment 2",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.44327,
        longitude: 12.33329,
        beds: 7,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33329, 45.44327]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23957965,
        name: "Ca Delphine",
        host_id: 31899591,
        host_name: "Michel",
        latitude: 45.43559,
        longitude: 12.32538,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32538, 45.43559]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23970458,
        name: "22 STEPS FROM THE BIENNALE!!!!!",
        host_id: 41559211,
        host_name: "Venice",
        latitude: 45.43016,
        longitude: 12.35625,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35625, 45.43016]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23970578,
        name: "FEW STEPS FROM THE DOGE PALACE!!!!",
        host_id: 41559211,
        host_name: "Venice",
        latitude: 45.4324,
        longitude: 12.35272,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35272, 45.4324]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23977926,
        name: "Ca' Giovanni - Charming apt near stop for BIENNALE",
        host_id: 180096495,
        host_name: "Michela",
        latitude: 45.4386,
        longitude: 12.32506,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32506, 45.4386]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23978494,
        name: "Romantic and bright flat in Venice with wifì",
        host_id: 180096495,
        host_name: "Michela",
        latitude: 45.43871,
        longitude: 12.32333,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32333, 45.43871]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23978582,
        name: "Ca Maria-bright and quite apt with wifi in Venice",
        host_id: 180096495,
        host_name: "Michela",
        latitude: 45.43984,
        longitude: 12.3237,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3237, 45.43984]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23991213,
        name: "Ca' dea Gondoea",
        host_id: 71494066,
        host_name: "Monica",
        latitude: 45.435,
        longitude: 12.31999,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31999, 45.435]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23991350,
        name: "Rossella apartment/flat - Venice Historical Centre",
        host_id: 180468161,
        host_name: "Rossella",
        latitude: 45.44343,
        longitude: 12.32637,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32637, 45.44343]] },
    },
    {
      type: "Feature",
      properties: {
        id: 23996826,
        name: "Ve-nice Suite Rio Marin SC847",
        host_id: 22423242,
        host_name: "Stefano",
        latitude: 45.43924,
        longitude: 12.32512,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32512, 45.43924]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24001558,
        name: "Ve-nice Suite Formosa C5141",
        host_id: 22423242,
        host_name: "Stefano",
        latitude: 45.43713,
        longitude: 12.34252,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34252, 45.43713]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24001727,
        name: "Ve-nice Suite Rialto SP720-4",
        host_id: 22423242,
        host_name: "Stefano",
        latitude: 45.43785,
        longitude: 12.33442,
        beds: 7,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33442, 45.43785]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24026001,
        name: "Apt. Fosca Canal View (Venice Historical Centre)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.44372,
        longitude: 12.33419,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33419, 45.44372]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24038055,
        name: "CA ROMY appartament",
        host_id: 180927137,
        host_name: "Francesco",
        latitude: 45.43477,
        longitude: 12.35698,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35698, 45.43477]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24038627,
        name: "Ca Castello Appartament",
        host_id: 180927137,
        host_name: "Francesco",
        latitude: 45.43415,
        longitude: 12.35766,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35766, 45.43415]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24040559,
        name: "Palazzo DaPonte 03 - Private Balcony Canal View",
        host_id: 2718137,
        host_name: "DaPonte",
        latitude: 45.43729,
        longitude: 12.33831,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33831, 45.43729]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24049094,
        name: "Fondamente Nove Flat",
        host_id: 181034494,
        host_name: "Umberto",
        latitude: 45.44154,
        longitude: 12.33927,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33927, 45.44154]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24050555,
        name: "venice Arsenale",
        host_id: 180478508,
        host_name: "Ismail Khalil",
        latitude: 45.43743,
        longitude: 12.34814,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34814, 45.43743]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24051494,
        name: "Ca' del Giusto",
        host_id: 46904188,
        host_name: "Mirco Optyflat",
        latitude: 45.44158,
        longitude: 12.32528,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32528, 45.44158]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24063839,
        name: "Regina Vittoria Frezzeria",
        host_id: 181168223,
        host_name: "Regina Vittoria",
        latitude: 45.43388,
        longitude: 12.33523,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33523, 45.43388]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24072091,
        name: "Ponte del Megio",
        host_id: 46904188,
        host_name: "Mirco Optyflat",
        latitude: 45.44103,
        longitude: 12.32812,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32812, 45.44103]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24073191,
        name: "2minutes to city center Rialto bridge",
        host_id: 64548275,
        host_name: "Ellen",
        latitude: 45.43773,
        longitude: 12.33321,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33321, 45.43773]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24097559,
        name: "Ca' sull'Acqua Oro",
        host_id: 9372174,
        host_name: "Anahi",
        latitude: 45.44263,
        longitude: 12.34058,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34058, 45.44263]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24114616,
        name: "SIMONA APARTMENT - GIARDINI BIENNALE 3/4 PAX",
        host_id: 97583266,
        host_name: "Alessia",
        latitude: 45.4356,
        longitude: 12.3572,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3572, 45.4356]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24125228,
        name: "Nice Tower Apartment near San Marco Square",
        host_id: 181731578,
        host_name: "Fabrizio",
        latitude: 45.43619,
        longitude: 12.33964,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33964, 45.43619]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24136474,
        name: "Ca' Barozzi  - Red double room  -",
        host_id: 88553273,
        host_name: "Ca' Barozzi",
        latitude: 45.43414,
        longitude: 12.31853,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31853, 45.43414]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24151188,
        name: "A 250 square metres apt in the heart of Venice",
        host_id: 175070397,
        host_name: "Marianna",
        latitude: 45.43493,
        longitude: 12.33605,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33605, 45.43493]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24154421,
        name: "StudiOb&bPied-à-Terre Canal de Cannaregio",
        host_id: 29402382,
        host_name: "Edo",
        latitude: 45.44501,
        longitude: 12.32191,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32191, 45.44501]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24167744,
        name: "Leafy tranquility in Santa Croce",
        host_id: 40718055,
        host_name: "Anna",
        latitude: 45.43701,
        longitude: 12.32176,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32176, 45.43701]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24171828,
        name: "Venezia centro storico",
        host_id: 79868857,
        host_name: "Michela",
        latitude: 45.44273,
        longitude: 12.32585,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32585, 45.44273]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24172577,
        name: "VENICE HOLIDAY TERRACE",
        host_id: 182175132,
        host_name: "Filippo",
        latitude: 45.43456,
        longitude: 12.34775,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34775, 45.43456]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24175564,
        name: "S.Pantalon - 2 steps from San Marco and Rialto",
        host_id: 139627704,
        host_name: "Giusy & Fabrizio",
        latitude: 45.43535,
        longitude: 12.32378,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32378, 45.43535]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24194192,
        name: "Venezia Boat&Breakfast Caicco Freedom TRIPLA",
        host_id: 180640178,
        host_name: "Matteo",
        latitude: 45.42372,
        longitude: 12.32882,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32882, 45.42372]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24195252,
        name: "Vintage Venice",
        host_id: 26404861,
        host_name: "Marika",
        latitude: 45.4378,
        longitude: 12.32195,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32195, 45.4378]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24195364,
        name: "Rosacroce's room",
        host_id: 182382739,
        host_name: "Maria Giovanna",
        latitude: 45.44287,
        longitude: 12.33981,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33981, 45.44287]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24217315,
        name: "LA GONDOLIERA wi.fi and air conditioning",
        host_id: 104686761,
        host_name: "Giuliana",
        latitude: 45.4251,
        longitude: 12.32564,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32564, 45.4251]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24220492,
        name: "BIENNALE - 2 BEDROOMS, WIFI & AIR-CON",
        host_id: 179297180,
        host_name: "Chiara",
        latitude: 45.43074,
        longitude: 12.35876,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35876, 45.43074]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24221216,
        name: "SEAGULL HOUSE, San Marco Square",
        host_id: 182603935,
        host_name: "Rossella",
        latitude: 45.43721,
        longitude: 12.33634,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33634, 45.43721]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24221485,
        name: "Alba - Elegant 1bdr for 4 people with terrace!",
        host_id: 11505507,
        host_name: "Alexandra",
        latitude: 45.43902,
        longitude: 12.32261,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32261, 45.43902]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24222046,
        name: "Renata - Cozy 1bdr in Santa Croce area, Venice",
        host_id: 11505507,
        host_name: "Alexandra",
        latitude: 45.43957,
        longitude: 12.32251,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32251, 45.43957]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24222282,
        name: "Savina - Elegant apartment with Canal view",
        host_id: 11505507,
        host_name: "Alexandra",
        latitude: 45.44009,
        longitude: 12.3228,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3228, 45.44009]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24228801,
        name: "Appartamento luminoso con giardino",
        host_id: 167978086,
        host_name: "Paolo",
        latitude: 45.43821,
        longitude: 12.34471,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34471, 45.43821]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24236869,
        name: "CA SAN LEONARDO",
        host_id: 24440436,
        host_name: "Arianna",
        latitude: 45.44427,
        longitude: 12.32806,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32806, 45.44427]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24242990,
        name: "Residence dei Mori (80m from Rialto's Bridge)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.43655,
        longitude: 12.33639,
        beds: 10,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33639, 45.43655]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24243891,
        name: "Quiet and sunny at Guggenheim district",
        host_id: 182789935,
        host_name: "Mario",
        latitude: 45.42968,
        longitude: 12.33169,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33169, 45.42968]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24246312,
        name: "Big Private Room in the Heart of Venice",
        host_id: 31464362,
        host_name: "Marta & Bibi",
        latitude: 45.44053,
        longitude: 12.33021,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33021, 45.44053]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24256610,
        name: "Penthouse Specchieri with view on St. Mark's",
        host_id: 182908605,
        host_name: "Jacopo",
        latitude: 45.43651,
        longitude: 12.33752,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33752, 45.43651]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24256855,
        name: "RIALTO GLAMOUR PRIVATE HOME 2 bedrooms - Wi-fi",
        host_id: 179297180,
        host_name: "Chiara",
        latitude: 45.43883,
        longitude: 12.33342,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33342, 45.43883]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24272883,
        name: "Sleep in venezia.3",
        host_id: 131261322,
        host_name: "Luca",
        latitude: 45.43245,
        longitude: 12.35648,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35648, 45.43245]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24276039,
        name:
          "DAL GIRAMONDO Locazione turistica IP (Phone number hidden by Airbnb)",
        host_id: 183092089,
        host_name: "Maria",
        latitude: 45.42865,
        longitude: 12.33072,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33072, 45.42865]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24276649,
        name: "Villa Frari in Campiello",
        host_id: 25582770,
        host_name: "Simona",
        latitude: 45.44035,
        longitude: 12.32405,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32405, 45.44035]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24284989,
        name: "Phoenix A",
        host_id: 178963743,
        host_name: "Mike",
        latitude: 45.4355,
        longitude: 12.33339,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33339, 45.4355]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24301823,
        name: "Venezia Boat & Breakfast Caicco Freedom DOPPIA",
        host_id: 180640178,
        host_name: "Matteo",
        latitude: 45.42376,
        longitude: 12.33025,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33025, 45.42376]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24302530,
        name: "Cabina Matrimoniale + Letto Singolo",
        host_id: 180640178,
        host_name: "Matteo",
        latitude: 45.42387,
        longitude: 12.32991,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32991, 45.42387]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24306499,
        name: "Gerry's Home in Venice",
        host_id: 183364028,
        host_name: "Gerry",
        latitude: 45.4419,
        longitude: 12.34049,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34049, 45.4419]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24316032,
        name: "Cozy apartment next to Palazzo Grassi",
        host_id: 3543688,
        host_name: "Ilaria",
        latitude: 45.43376,
        longitude: 12.32926,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32926, 45.43376]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24316984,
        name: "WELCOME AT ZATTERE PIED-A-TERRE LOFT",
        host_id: 179297180,
        host_name: "Chiara",
        latitude: 45.43211,
        longitude: 12.32103,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32103, 45.43211]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24318433,
        name: "CASA DEGLI ANGELI, free wi-fi near San Marco",
        host_id: 3736168,
        host_name: "EasyRentals",
        latitude: 45.43677,
        longitude: 12.34575,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34575, 45.43677]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24318737,
        name: "Mario Apartment Fondamente Nove (2) 5201",
        host_id: 10072655,
        host_name: "Mario Apartment",
        latitude: 45.44281,
        longitude: 12.34079,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34079, 45.44281]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24321672,
        name: "Casa Ormesini",
        host_id: 183499657,
        host_name: "Nadia",
        latitude: 45.44685,
        longitude: 12.32936,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32936, 45.44685]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24324858,
        name: "Regina Vittoria Suite",
        host_id: 181168223,
        host_name: "Regina Vittoria",
        latitude: 45.43397,
        longitude: 12.32935,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32935, 45.43397]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24324892,
        name: "APPARTAMENTO VICINO ALL'ARSENALE",
        host_id: 171397885,
        host_name: "Stefano",
        latitude: 45.43569,
        longitude: 12.3477,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3477, 45.43569]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24326440,
        name: "Bella Vita Charming House",
        host_id: 416351,
        host_name: "Italo",
        latitude: 45.4404,
        longitude: 12.34063,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34063, 45.4404]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24327305,
        name: "Art Colour Room 2 kitchen Super Wifi System",
        host_id: 48092742,
        host_name: "Roby",
        latitude: 45.44393,
        longitude: 12.32845,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32845, 45.44393]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24327855,
        name: "RUGAGIUFFA",
        host_id: 183545329,
        host_name: "Marcello",
        latitude: 45.43614,
        longitude: 12.34268,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34268, 45.43614]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24332391,
        name: "Appartamento Venezia 2",
        host_id: 92996129,
        host_name: "Paola",
        latitude: 45.43299,
        longitude: 12.32079,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32079, 45.43299]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24340488,
        name: "Giudecca Sant'Eufemia",
        host_id: 183662265,
        host_name: "Emilia",
        latitude: 45.42716,
        longitude: 12.32337,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32337, 45.42716]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24340790,
        name: "Piano Nobile Loredan on the Grand Canal",
        host_id: 669047,
        host_name: "Viewsonvenice",
        latitude: 45.43317,
        longitude: 12.32688,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32688, 45.43317]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24342618,
        name: "Appartamento nel cuore di Venezia-Accademia",
        host_id: 183677291,
        host_name: "Giovanni",
        latitude: 45.43343,
        longitude: 12.33114,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33114, 45.43343]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24346598,
        name: "Ca' Colonne, perfect stay in Biennale neighborhood",
        host_id: 12113015,
        host_name: "Mario",
        latitude: 45.43097,
        longitude: 12.35446,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35446, 45.43097]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24348883,
        name: "Ortensia - Hidden place in the heart of Venice",
        host_id: 36540828,
        host_name: "Sibylle Antonia",
        latitude: 45.4432,
        longitude: 12.32717,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32717, 45.4432]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24351388,
        name: "Suite Santa Margherita",
        host_id: 183746605,
        host_name: "Michele",
        latitude: 45.43554,
        longitude: 12.32334,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32334, 45.43554]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24356228,
        name: "Ca' Burcio",
        host_id: 183331666,
        host_name: "Marco",
        latitude: 45.43962,
        longitude: 12.32298,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32298, 45.43962]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24361103,
        name: "LA CASA DEL MERCANTE VENEZIANO  BIENNALE",
        host_id: 16948380,
        host_name: "Savina",
        latitude: 45.43362,
        longitude: 12.3494,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3494, 45.43362]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24361421,
        name: "Great Location - Piazza San Marco",
        host_id: 116722365,
        host_name: "Eloisa",
        latitude: 45.43393,
        longitude: 12.33889,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33889, 45.43393]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24362759,
        name: "Intero appartamento a Venezia",
        host_id: 152280838,
        host_name: "Pierpaolo",
        latitude: 45.43295,
        longitude: 12.33067,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33067, 45.43295]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24363682,
        name: "Modern and cozy apartment in Venice with terrace!",
        host_id: 4403022,
        host_name: "Nicole",
        latitude: 45.42505,
        longitude: 12.33041,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33041, 45.42505]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24365175,
        name: "Ca' Milion Venezia",
        host_id: 183871399,
        host_name: "Giorgio",
        latitude: 45.43713,
        longitude: 12.33836,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33836, 45.43713]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24365181,
        name: "TURQUOISE STUDIO",
        host_id: 2030045,
        host_name: "Francesca",
        latitude: 45.43211,
        longitude: 12.35516,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35516, 45.43211]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24367745,
        name: "Superb Grand Canal 3BR Apart-Views-Terrace-Central",
        host_id: 69613911,
        host_name: "Hugues",
        latitude: 45.43299,
        longitude: 12.32894,
        beds: 7,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32894, 45.43299]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24375806,
        name: "WI FI- CLOSE AIRPORT & TRAIN AND ALL TRANSPORT",
        host_id: 29755603,
        host_name: "Giuliano",
        latitude: 45.446042574301998,
        longitude: 12.325584123744328,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32558, 45.44604]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24386375,
        name: "Phoenix B",
        host_id: 178963743,
        host_name: "Mike",
        latitude: 45.43395,
        longitude: 12.33284,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33284, 45.43395]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24392873,
        name: 'IL ROMANTICO "CASANOVA FLAT"- SAN MARCO, VENEZIA -',
        host_id: 144040958,
        host_name: "Eleonora",
        latitude: 45.44193,
        longitude: 12.34124,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34124, 45.44193]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24407548,
        name: "Casa Dei Toso",
        host_id: 46904188,
        host_name: "Mirco Optyflat",
        latitude: 45.43146,
        longitude: 12.3565,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3565, 45.43146]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24409222,
        name: "2O STEPS FROM SAINT MARK SCHOOL!!!!",
        host_id: 41559211,
        host_name: "Venice",
        latitude: 45.4406,
        longitude: 12.34048,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34048, 45.4406]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24415793,
        name: "Casa San Martin",
        host_id: 46086362,
        host_name: "Marco",
        latitude: 45.43432,
        longitude: 12.34965,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34965, 45.43432]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24419457,
        name: "WellVenice Cà D'Oro",
        host_id: 41898872,
        host_name: "Cristina",
        latitude: 45.44138,
        longitude: 12.33413,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33413, 45.44138]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24435579,
        name: "novecinqueotto",
        host_id: 184539510,
        host_name: "Massimo",
        latitude: 45.43096,
        longitude: 12.35734,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35734, 45.43096]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24436058,
        name: "Nest over San Marco's roofs",
        host_id: 184544878,
        host_name: "Igor",
        latitude: 45.43395,
        longitude: 12.33546,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33546, 45.43395]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24438453,
        name: "Venice Luxury Palace 12",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.43674,
        longitude: 12.33102,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33102, 45.43674]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24438480,
        name: "Ca' Leone XIII - casa vacanza religiosa",
        host_id: 119635149,
        host_name: "Francesco",
        latitude: 45.43104,
        longitude: 12.3534,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3534, 45.43104]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24439560,
        name: "Cà Grandi phototour",
        host_id: 184569285,
        host_name: "Giulio Cesare E Marcello",
        latitude: 45.43293,
        longitude: 12.35212,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35212, 45.43293]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24441974,
        name: "CA’ DELL’ ANGELO VIEWS ON CANAL, WI.FI, CANNAREGIO",
        host_id: 126427384,
        host_name: "Angelo Maria",
        latitude: 45.44549,
        longitude: 12.32631,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32631, 45.44549]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24442737,
        name: "Appartamento con vista mozzafiato",
        host_id: 8605171,
        host_name: "Enrico",
        latitude: 45.43847,
        longitude: 12.34908,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34908, 45.43847]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24446953,
        name: "Suite Casa Nova",
        host_id: 161552405,
        host_name: "Alessandra - Interhome",
        latitude: 45.43627,
        longitude: 12.34239,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34239, 45.43627]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24449507,
        name: "Royal Venice",
        host_id: 184651522,
        host_name: "Vanni",
        latitude: 45.44488,
        longitude: 12.32609,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32609, 45.44488]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24467055,
        name:
          "Upscale central Venice condo perfect for groups looking to explore the city!",
        host_id: 4339678,
        host_name: "Vacasa Italy - Venice",
        latitude: 45.43658,
        longitude: 12.34023,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34023, 45.43658]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24479935,
        name: "Venetian Palazzo with view",
        host_id: 136344566,
        host_name: "Elisabetta",
        latitude: 45.44002,
        longitude: 12.33995,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33995, 45.44002]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24483079,
        name: "Few steps from San Marco Square -Vecio Canal",
        host_id: 184943708,
        host_name: "Luca",
        latitude: 45.43539,
        longitude: 12.34194,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34194, 45.43539]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24485111,
        name: "Residence Guglie -11 people - Perfect for groups",
        host_id: 289615,
        host_name: "Valentina",
        latitude: 45.44402,
        longitude: 12.32849,
        beds: 7,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32849, 45.44402]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24488207,
        name: "Romantic Malvasia",
        host_id: 46904188,
        host_name: "Mirco Optyflat",
        latitude: 45.44561,
        longitude: 12.32717,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32717, 45.44561]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24496064,
        name: "Ca' Pupparin - Spacious Central Home",
        host_id: 121299893,
        host_name: "Irene",
        latitude: 45.43986,
        longitude: 12.33172,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33172, 45.43986]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24509342,
        name: "CA' LINA Apartment close to St.Mark's and Rialto",
        host_id: 185150739,
        host_name: "Andrea",
        latitude: 45.43607,
        longitude: 12.33592,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33592, 45.43607]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24509706,
        name: "Camera Classica",
        host_id: 3437195,
        host_name: "Valentina",
        latitude: 45.44229,
        longitude: 12.33094,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33094, 45.44229]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24510266,
        name: "Ca' Petriana   M (Phone number hidden by Airbnb)",
        host_id: 24440436,
        host_name: "Arianna",
        latitude: 45.43711,
        longitude: 12.33171,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33171, 45.43711]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24511356,
        name: "Salmar San Marco Venice Apartment",
        host_id: 185125554,
        host_name: "Martina",
        latitude: 45.42516,
        longitude: 12.32401,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32401, 45.42516]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24514287,
        name: "ROOFTOP-TERRACE-CANAL 3bed 3bath 6pax airc wifi",
        host_id: 17534457,
        host_name: "Abaca",
        latitude: 45.43361,
        longitude: 12.31938,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31938, 45.43361]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24517535,
        name: "Ca' Linda, beautiful bright apartment on canal",
        host_id: 185204915,
        host_name: "Jean-Pierre",
        latitude: 45.43169,
        longitude: 12.35669,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35669, 45.43169]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24519204,
        name: "10min trainstation, Big2room, SUPER LOCATION!!",
        host_id: 147104851,
        host_name: "Salvo Casa",
        latitude: 45.445,
        longitude: 12.32944,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32944, 45.445]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24520001,
        name: "CA' DEL MAR VENICE",
        host_id: 72725081,
        host_name: "Manuel",
        latitude: 45.44139,
        longitude: 12.33945,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33945, 45.44139]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24529498,
        name: "Have a Night at La Fenice Theater in an Historic Apartment",
        host_id: 184660645,
        host_name: "Valentina",
        latitude: 45.43506,
        longitude: 12.3319,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3319, 45.43506]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24547573,
        name:
          "Sandolo double room with bathroom   (M (Phone number hidden by Airbnb)",
        host_id: 185308513,
        host_name: "Roberto",
        latitude: 45.44758,
        longitude: 12.32931,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32931, 45.44758]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24551361,
        name: "Giardino dei Melograni Superior Room #4",
        host_id: 630328,
        host_name: "Kosher House",
        latitude: 45.4445,
        longitude: 12.32778,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32778, 45.4445]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24553251,
        name: "Romantic room",
        host_id: 131142254,
        host_name: "Ana Maria",
        latitude: 45.43232,
        longitude: 12.33536,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33536, 45.43232]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24563383,
        name: "Antique Biennale Fireplace",
        host_id: 152365893,
        host_name: "Leonardo",
        latitude: 45.43134,
        longitude: 12.35672,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35672, 45.43134]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24566287,
        name:
          "Gondola double room with bathroom   (M (Phone number hidden by Airbnb)",
        host_id: 185308513,
        host_name: "Roberto",
        latitude: 45.44873,
        longitude: 12.32735,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32735, 45.44873]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24586613,
        name: '"CA\' ZAN NOVO" S.MARCO-SAN ZACCARIA',
        host_id: 185800709,
        host_name: "Claudio",
        latitude: 45.43598,
        longitude: 12.34162,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34162, 45.43598]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24588274,
        name: "Ca' Laguna, stunning views on Bacino di San Marco.",
        host_id: 12113015,
        host_name: "Mario",
        latitude: 45.43165,
        longitude: 12.35521,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35521, 45.43165]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24589876,
        name: "La Corte Segreta",
        host_id: 20388459,
        host_name: "Pamela",
        latitude: 45.43416,
        longitude: 12.32135,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32135, 45.43416]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24592715,
        name: "Cosy flat in a lovely tiny square of Venice",
        host_id: 185810699,
        host_name: "Mariarosa",
        latitude: 45.44172,
        longitude: 12.34147,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34147, 45.44172]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24596869,
        name: "Élite Home stunning venetian apt. Close ACCADEMIA",
        host_id: 185872492,
        host_name: "Elite",
        latitude: 45.4318,
        longitude: 12.32017,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32017, 45.4318]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24610567,
        name: "Totally equipped loft in the heart of Venice",
        host_id: 184995776,
        host_name: "Eloisa",
        latitude: 45.43634,
        longitude: 12.3483,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3483, 45.43634]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24618592,
        name: "Junior Suite-Superior-Ensuite with Shower-Indiana",
        host_id: 3429853,
        host_name: "Cinzia",
        latitude: 45.43651,
        longitude: 12.3419,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3419, 45.43651]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24624552,
        name: "Pure bliss",
        host_id: 69322135,
        host_name: "Guido",
        latitude: 45.43314,
        longitude: 12.32293,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32293, 45.43314]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24638284,
        name: "ADMIRAL EMO PALACE OVER CANAL GRANDE",
        host_id: 186202889,
        host_name: "Elena",
        latitude: 45.44289,
        longitude: 12.33163,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33163, 45.44289]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24642752,
        name: "Ca' Papadopoli with garden and terrace",
        host_id: 186231558,
        host_name: "Cinzia",
        latitude: 45.43916,
        longitude: 12.32088,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32088, 45.43916]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24653365,
        name: "Palazzo DaPonte 02 - Cosy, Central, Private WC",
        host_id: 2718137,
        host_name: "DaPonte",
        latitude: 45.43735,
        longitude: 12.33895,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33895, 45.43735]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24663943,
        name: "Giardino dei Melograni Doppia Standard #1",
        host_id: 630328,
        host_name: "Kosher House",
        latitude: 45.44627,
        longitude: 12.3276,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3276, 45.44627]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24670739,
        name: "San Marco 3 central typical large",
        host_id: 185612295,
        host_name: "Lory",
        latitude: 45.43567,
        longitude: 12.34313,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34313, 45.43567]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24671031,
        name: "Artist room1 large and sunny wifii private bath",
        host_id: 185612295,
        host_name: "Lory",
        latitude: 45.4431,
        longitude: 12.32993,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32993, 45.4431]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24675728,
        name: "FENICE: 2 DOUBLE BEDRMS, 2 BATHRMS, aircond, wifi",
        host_id: 17534457,
        host_name: "Abaca",
        latitude: 45.43464,
        longitude: 12.33198,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33198, 45.43464]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24683254,
        name: "DREAM ON THE CANAL",
        host_id: 56386179,
        host_name: "Marco",
        latitude: 45.43889,
        longitude: 12.33271,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33271, 45.43889]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24685250,
        name: "GORGEOUS ON THE CANAL",
        host_id: 56386179,
        host_name: "Marco",
        latitude: 45.4381,
        longitude: 12.33355,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33355, 45.4381]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24694620,
        name:
          "Mezzanino, Campo Santa Margherita M (Phone number hidden by Airbnb)",
        host_id: 31226614,
        host_name: "Elena",
        latitude: 45.43461,
        longitude: 12.32371,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32371, 45.43461]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24704758,
        name: "Venetian Roofs",
        host_id: 35470690,
        host_name: "Tommaso",
        latitude: 45.44252,
        longitude: 12.33083,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33083, 45.44252]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24706204,
        name: "San Marco Central (100m from St Mark's Square)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.43517,
        longitude: 12.3401,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3401, 45.43517]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24712393,
        name: "Casa Laguna Verde Venezia",
        host_id: 2053550,
        host_name: "Stefania",
        latitude: 45.44147,
        longitude: 12.34054,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34054, 45.44147]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24720454,
        name: "Venice Love Suite Romantic in Venice",
        host_id: 139627704,
        host_name: "Giusy & Fabrizio",
        latitude: 45.43787,
        longitude: 12.34895,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34895, 45.43787]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24724511,
        name: "On the Roof, Venice Old Town",
        host_id: 1509668,
        host_name: "Martina",
        latitude: 45.44125,
        longitude: 12.32599,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32599, 45.44125]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24727118,
        name: "Nice and sunny flat in the heart of Venice",
        host_id: 186917113,
        host_name: "Francesca",
        latitude: 45.44532,
        longitude: 12.32284,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32284, 45.44532]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24739313,
        name: "Ca’ Maresa San Marco In the heart of the city!!!",
        host_id: 186867536,
        host_name: "Silvia",
        latitude: 45.43684,
        longitude: 12.33658,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33658, 45.43684]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24741955,
        name:
          "Luxury  Bedroom,in center of Venice (M (Phone number hidden by Airbnb)",
        host_id: 187055522,
        host_name: "Riccardo E Tiziana",
        latitude: 45.4383,
        longitude: 12.34624,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34624, 45.4383]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24744427,
        name: "Appartamento S.Elena",
        host_id: 103561906,
        host_name: "Romano",
        latitude: 45.42649,
        longitude: 12.36292,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.36292, 45.42649]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24747737,
        name: "MIRACOLI",
        host_id: 185295599,
        host_name: "Alberto",
        latitude: 45.43935,
        longitude: 12.33675,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33675, 45.43935]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24750359,
        name: "Pavarotti House-Room 2",
        host_id: 187118579,
        host_name: "Ke",
        latitude: 45.4437,
        longitude: 12.32888,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32888, 45.4437]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24750861,
        name: "Pavarotti House - Room 7",
        host_id: 187118579,
        host_name: "Ke",
        latitude: 45.44373,
        longitude: 12.32911,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32911, 45.44373]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24750938,
        name: "Pavarotti House-Room 3",
        host_id: 187118579,
        host_name: "Ke",
        latitude: 45.44794,
        longitude: 12.32669,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32669, 45.44794]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24751132,
        name: "Pavarotti House-Room 4",
        host_id: 187118579,
        host_name: "Ke",
        latitude: 45.4455,
        longitude: 12.32945,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32945, 45.4455]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24751246,
        name: "Pavarotti House-Room 1",
        host_id: 187118579,
        host_name: "Ke",
        latitude: 45.44737,
        longitude: 12.32594,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32594, 45.44737]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24751948,
        name: "1 calm authentic castello sweet apartment wifii",
        host_id: 185612295,
        host_name: "Lory",
        latitude: 45.43096,
        longitude: 12.3583,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3583, 45.43096]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24751966,
        name: "Pavarotti House-Room 5",
        host_id: 187118579,
        host_name: "Ke",
        latitude: 45.44602,
        longitude: 12.32696,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32696, 45.44602]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24753329,
        name: "Nikki house appartamento Cielo",
        host_id: 187144142,
        host_name: "Alessandro Markku",
        latitude: 45.43529,
        longitude: 12.34227,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34227, 45.43529]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24762027,
        name: "The Orchid Garden, a typical venetian apartment",
        host_id: 121850017,
        host_name: "Laura",
        latitude: 45.43062,
        longitude: 12.35956,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35956, 45.43062]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24766067,
        name: "Cozy apartment in the authentic Venice",
        host_id: 187240436,
        host_name: "Lara",
        latitude: 45.44785,
        longitude: 12.32772,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32772, 45.44785]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24772113,
        name: "SILVY HOUSE - NEAR SAINT MARK SQUARE",
        host_id: 187250826,
        host_name: "Elena",
        latitude: 45.43436,
        longitude: 12.33766,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33766, 45.43436]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24778445,
        name: "Room 2 with kitchen in San Marcuola",
        host_id: 48092742,
        host_name: "Roby",
        latitude: 45.4441,
        longitude: 12.32934,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32934, 45.4441]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24778980,
        name: "Venetian Gold Room near San Marco",
        host_id: 48092742,
        host_name: "Roby",
        latitude: 45.43711,
        longitude: 12.34158,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34158, 45.43711]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24795392,
        name: "Veniceluxury",
        host_id: 187460256,
        host_name: "Shabir",
        latitude: 45.4478,
        longitude: 12.32608,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32608, 45.4478]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24806289,
        name: "Yellow golden room in silent San Marco romantic wf",
        host_id: 185612295,
        host_name: "Lory",
        latitude: 45.43732,
        longitude: 12.34117,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34117, 45.43732]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24813780,
        name: "Ai Turchesi",
        host_id: 3972291,
        host_name: "Caroline E Marco",
        latitude: 45.43207,
        longitude: 12.32882,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32882, 45.43207]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24813791,
        name: "Ca'dell'Architetto",
        host_id: 3972291,
        host_name: "Caroline E Marco",
        latitude: 45.43521,
        longitude: 12.34298,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34298, 45.43521]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24813795,
        name: "Ca' Moro - LIDO",
        host_id: 3972291,
        host_name: "Caroline E Marco",
        latitude: 45.43396,
        longitude: 12.3304,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3304, 45.43396]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24819360,
        name: "Green Romantic Room Fiabe",
        host_id: 48092742,
        host_name: "Roby",
        latitude: 45.43767,
        longitude: 12.34251,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34251, 45.43767]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24820392,
        name: "Ca' Del Monastero 9 Apartment for 4/5 Guests",
        host_id: 669047,
        host_name: "Viewsonvenice",
        latitude: 45.44143,
        longitude: 12.32491,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32491, 45.44143]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24839770,
        name: "Pavarotti House-Room 6",
        host_id: 187118579,
        host_name: "Ke",
        latitude: 45.44279,
        longitude: 12.32944,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32944, 45.44279]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24844059,
        name: "Venice Prince Apartments - Appartamento Celsi",
        host_id: 187809783,
        host_name: "Zillur",
        latitude: 45.43862,
        longitude: 12.34925,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34925, 45.43862]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24844514,
        name: "Venice Prince Apartments - Appartamento Tron",
        host_id: 187809783,
        host_name: "Zillur",
        latitude: 45.43769,
        longitude: 12.35062,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35062, 45.43769]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24844608,
        name: "Venice Prince Apartments - Appartamento Alinardo",
        host_id: 187809783,
        host_name: "Zillur",
        latitude: 45.4383,
        longitude: 12.34941,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34941, 45.4383]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24844838,
        name: "Venice Prince Apartaments - Appartamento Dolfin",
        host_id: 187809783,
        host_name: "Zillur",
        latitude: 45.43792,
        longitude: 12.35043,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35043, 45.43792]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24850214,
        name: "appartamento Rio Marin",
        host_id: 4557370,
        host_name: "Giovanna",
        latitude: 45.43826,
        longitude: 12.32574,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32574, 45.43826]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24850935,
        name: "Giardino dei Melograni Quadruple Room",
        host_id: 630328,
        host_name: "Kosher House",
        latitude: 45.44572,
        longitude: 12.32668,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32668, 45.44572]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24851227,
        name: "SUITE VENICE by Ca del Mar",
        host_id: 72725081,
        host_name: "Manuel",
        latitude: 45.44149,
        longitude: 12.34129,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34129, 45.44149]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24860382,
        name: "Armonie di Casa VeniceVillas",
        host_id: 294951,
        host_name: "VeniceVillas Di Enzo",
        latitude: 45.43472,
        longitude: 12.34183,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34183, 45.43472]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24863203,
        name: "New modern Room 7 in San Marcuola",
        host_id: 48092742,
        host_name: "Roby",
        latitude: 45.44298,
        longitude: 12.3293,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3293, 45.44298]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24864714,
        name: "CeNtraL VEnice (Private room & Shared Toilet)",
        host_id: 65244181,
        host_name: "Emran",
        latitude: 45.4376,
        longitude: 12.34047,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34047, 45.4376]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24880285,
        name: "Explore Venice From a Sophisticated Hideaway in San Polo",
        host_id: 5346783,
        host_name: "Luigi",
        latitude: 45.43812,
        longitude: 12.32911,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32911, 45.43812]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24882070,
        name: '"La Fenice Suite" canal view, 2 min to San Marco',
        host_id: 159746853,
        host_name: "Giulia",
        latitude: 45.43562,
        longitude: 12.33108,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33108, 45.43562]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24883185,
        name: "Alla Biennale da Irma",
        host_id: 125209081,
        host_name: "Giulio",
        latitude: 45.43195,
        longitude: 12.35584,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35584, 45.43195]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24886682,
        name: "Ca' degli Oresi",
        host_id: 188143554,
        host_name: "Emanuela",
        latitude: 45.43265,
        longitude: 12.32878,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32878, 45.43265]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24889097,
        name: "Casa di Luca- Biennale-fast wifi",
        host_id: 27470948,
        host_name: "Luca",
        latitude: 45.42908,
        longitude: 12.36263,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.36263, 45.42908]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24890416,
        name: "Very central 1 love San Marco Romantic Room wifii",
        host_id: 185612295,
        host_name: "Lory",
        latitude: 45.436,
        longitude: 12.34341,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34341, 45.436]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24890745,
        name: "Sweet 2 San Marco very central romantic wifii calm",
        host_id: 185612295,
        host_name: "Lory",
        latitude: 45.43712,
        longitude: 12.34173,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34173, 45.43712]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24901125,
        name:
          "Deluxe Bedroom, in  center of Venice (M (Phone number hidden by Airbnb)",
        host_id: 187055522,
        host_name: "Riccardo E Tiziana",
        latitude: 45.43987,
        longitude: 12.34228,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34228, 45.43987]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24902419,
        name: "Giardino dei Melograni Quadruple Superior Room",
        host_id: 630328,
        host_name: "Kosher House",
        latitude: 45.44763,
        longitude: 12.32539,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32539, 45.44763]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24903402,
        name: "BIENNALE GARDEN ART & ARCHITECTURE VENUE",
        host_id: 188283171,
        host_name: "Maria",
        latitude: 45.4297,
        longitude: 12.35949,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35949, 45.4297]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24911747,
        name: "Giardino dei Melograni Economy with Canal View #1",
        host_id: 630328,
        host_name: "Kosher House",
        latitude: 45.44769,
        longitude: 12.32692,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32692, 45.44769]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24928105,
        name: "Superior Double Room in Venetian style",
        host_id: 98479290,
        host_name: "Daniele",
        latitude: 45.43026,
        longitude: 12.33234,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33234, 45.43026]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24929379,
        name: "BASTIONI",
        host_id: 10903957,
        host_name: "Daniela",
        latitude: 45.43599,
        longitude: 12.34812,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34812, 45.43599]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24929969,
        name: "Spacious modern apt close to train station",
        host_id: 6019189,
        host_name: "Federico",
        latitude: 45.44421,
        longitude: 12.32041,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32041, 45.44421]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24934520,
        name: "Appartamento romantico in Venezia",
        host_id: 188512327,
        host_name: "Silvestri",
        latitude: 45.44006,
        longitude: 12.34006,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34006, 45.44006]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24937841,
        name: "CASA ELENA GUEST HOUSE",
        host_id: 102043955,
        host_name: "Andrea",
        latitude: 45.42819,
        longitude: 12.36069,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.36069, 45.42819]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24942363,
        name: "LOVE SAINT MARK'S BASILICA @200 meters",
        host_id: 188530147,
        host_name: "Cesare",
        latitude: 45.43437,
        longitude: 12.34153,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34153, 45.43437]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24944572,
        name: "CASINÓ Poker Room in San marcuola",
        host_id: 48092742,
        host_name: "Roby",
        latitude: 45.4433,
        longitude: 12.32983,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32983, 45.4433]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24953979,
        name: "Biennale room",
        host_id: 188656407,
        host_name: "Miriam",
        latitude: 45.42753,
        longitude: 12.36288,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.36288, 45.42753]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24956915,
        name: "Green room a Venezia Biennale, vicina a San Marco",
        host_id: 151801710,
        host_name: "Francesco",
        latitude: 45.43157,
        longitude: 12.35365,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35365, 45.43157]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24957976,
        name: "Giardino dei Melograni Economy Canal view #2",
        host_id: 630328,
        host_name: "Kosher House",
        latitude: 45.44648,
        longitude: 12.32566,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32566, 45.44648]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24967985,
        name: "Central cannaregio2 fantastic view great location",
        host_id: 185612295,
        host_name: "Lory",
        latitude: 45.44491,
        longitude: 12.32496,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32496, 45.44491]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24968161,
        name: "Central 5 San Marcuola Casino' comfortable large w",
        host_id: 185612295,
        host_name: "Lory",
        latitude: 45.4442,
        longitude: 12.32859,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32859, 45.4442]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24975101,
        name: "Secret Haven Garden Apartment - Giardino Segreto",
        host_id: 9110492,
        host_name: "Ann",
        latitude: 45.44069,
        longitude: 12.32296,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32296, 45.44069]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24976652,
        name: "Grimani apartment superior",
        host_id: 32887555,
        host_name: "Residence Corte Grimani",
        latitude: 45.43562,
        longitude: 12.33531,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33531, 45.43562]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24984320,
        name:
          "Lussuoso appartamento in palazzo nobiliare con affresco e vista canale",
        host_id: 188875348,
        host_name: "Palazzo Vendramin Costa",
        latitude: 45.44192,
        longitude: 12.33216,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33216, 45.44192]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24985219,
        name: "Terazier Apartment with Balcony and Canal Views",
        host_id: 188875348,
        host_name: "Palazzo Vendramin Costa",
        latitude: 45.44359,
        longitude: 12.3322,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3322, 45.44359]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24992475,
        name: "Rialto Flat in the centre of Venice",
        host_id: 48092742,
        host_name: "Roby",
        latitude: 45.43738,
        longitude: 12.33634,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33634, 45.43738]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24992579,
        name: "Central 3 San Marcuola comfortable sunny large wif",
        host_id: 185612295,
        host_name: "Lory",
        latitude: 45.44444,
        longitude: 12.32828,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32828, 45.44444]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24995658,
        name: "Codega Luxury Design Apartment",
        host_id: 188875348,
        host_name: "Palazzo Vendramin Costa",
        latitude: 45.44341,
        longitude: 12.33421,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33421, 45.44341]] },
    },
    {
      type: "Feature",
      properties: {
        id: 24995734,
        name: "Strolego Attic Apartment with Direct Lift Access",
        host_id: 188875348,
        host_name: "Palazzo Vendramin Costa",
        latitude: 45.44224,
        longitude: 12.3339,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3339, 45.44224]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25000708,
        name: "Luxury Apartment Giardino,near St.Mark's Square",
        host_id: 69921858,
        host_name: "Corte Nova S.R.L",
        latitude: 45.43751,
        longitude: 12.34714,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34714, 45.43751]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25002671,
        name: "Dal Fiore Terrace M (Phone number hidden by Airbnb)",
        host_id: 15005402,
        host_name: "Veronica",
        latitude: 45.44576,
        longitude: 12.329,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.329, 45.44576]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25004283,
        name: "Tommy House",
        host_id: 189022239,
        host_name: "Tommaso",
        latitude: 45.43622,
        longitude: 12.32979,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32979, 45.43622]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25028822,
        name: "Castello Su&Giù",
        host_id: 69477714,
        host_name: "Marco",
        latitude: 45.43541,
        longitude: 12.34246,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34246, 45.43541]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25037965,
        name: '"Al Campiello" appartamento nel cuore di Venezia',
        host_id: 108108295,
        host_name: "Nicola",
        latitude: 45.44018,
        longitude: 12.33581,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33581, 45.44018]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25041072,
        name: "CA' DE LE COLONNETTE - SAINT MARK'S SQUARE",
        host_id: 44060204,
        host_name: "Lorenzo",
        latitude: 45.43424,
        longitude: 12.33698,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33698, 45.43424]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25047117,
        name: "Large Double Room in Venice near bus/train station",
        host_id: 18151381,
        host_name: "Fran",
        latitude: 45.43591,
        longitude: 12.31827,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31827, 45.43591]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25074387,
        name: "Ca' Dalmata, un sogno fra i tetti",
        host_id: 189555381,
        host_name: "Gertrud",
        latitude: 45.4381,
        longitude: 12.33922,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33922, 45.4381]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25078547,
        name: "Ca' Del Forno",
        host_id: 121299893,
        host_name: "Irene",
        latitude: 45.43772,
        longitude: 12.3323,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3323, 45.43772]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25093605,
        name: "Greci Design Terrace",
        host_id: 173200514,
        host_name: "Rent&Relax",
        latitude: 45.43487,
        longitude: 12.34323,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34323, 45.43487]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25103990,
        name: "del Doge Apartment",
        host_id: 2490984,
        host_name: "Dominique",
        latitude: 45.43873,
        longitude: 12.33646,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33646, 45.43873]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25119135,
        name: "Rooftop terrace suite apart",
        host_id: 3320671,
        host_name: "Nicolo'",
        latitude: 45.43326,
        longitude: 12.32939,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32939, 45.43326]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25120648,
        name: "Ca' Monica Apartment, Venice Historic City Center",
        host_id: 189872990,
        host_name: "Monica",
        latitude: 45.43211,
        longitude: 12.32295,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32295, 45.43211]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25121845,
        name: "THE STAR CLOSE TO BIENNALE & ARSENALE",
        host_id: 176216155,
        host_name: "Luca",
        latitude: 45.43359,
        longitude: 12.35593,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35593, 45.43359]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25122734,
        name: "Santa Croce Boutique Hotel",
        host_id: 189480214,
        host_name: "Santa Croce",
        latitude: 45.43911,
        longitude: 12.32586,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32586, 45.43911]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25124165,
        name: "Ca' Cerchieri Terrace Grand Canal",
        host_id: 669047,
        host_name: "Viewsonvenice",
        latitude: 45.4316,
        longitude: 12.3278,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3278, 45.4316]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25125621,
        name: "Cà delle Marie",
        host_id: 15005402,
        host_name: "Veronica",
        latitude: 45.4342,
        longitude: 12.35688,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35688, 45.4342]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25126871,
        name: "Bovolo Dwelling",
        host_id: 13990376,
        host_name: "Tommaso",
        latitude: 45.43458,
        longitude: 12.33183,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33183, 45.43458]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25134881,
        name: "Mirella GOLD",
        host_id: 189963665,
        host_name: "Stm Costruzioni",
        latitude: 45.44203,
        longitude: 12.33442,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33442, 45.44203]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25151535,
        name: "Arsenale",
        host_id: 29216890,
        host_name: "Donatella",
        latitude: 45.433,
        longitude: 12.34877,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34877, 45.433]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25154200,
        name: "3 Bedrooms: 1 Minute of San Marco Square WiFi A/C",
        host_id: 17762135,
        host_name: "Edoardo",
        latitude: 45.43436,
        longitude: 12.33644,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33644, 45.43436]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25159525,
        name: "S.Marco, duplex with courtyard and washing machine",
        host_id: 289615,
        host_name: "Valentina",
        latitude: 45.43603,
        longitude: 12.34079,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34079, 45.43603]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25161114,
        name: "Tosi 2 Castello lovely view Calm authentic central",
        host_id: 185612295,
        host_name: "Lory",
        latitude: 45.43158,
        longitude: 12.3565,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3565, 45.43158]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25161363,
        name: "Luxury rooftop penthouse & terrace - Biennale",
        host_id: 289615,
        host_name: "Valentina",
        latitude: 45.43325,
        longitude: 12.35504,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35504, 45.43325]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25161832,
        name: "3 Castello great view  typical Calm sweet Venice",
        host_id: 185612295,
        host_name: "Lory",
        latitude: 45.43069,
        longitude: 12.35839,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35839, 45.43069]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25163309,
        name: "Sweet San Pietro lory flat's in lovely warm place",
        host_id: 185612295,
        host_name: "Lory",
        latitude: 45.43289,
        longitude: 12.35893,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35893, 45.43289]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25169088,
        name: "Deluxe Sospiri Palace - near San Marco",
        host_id: 289615,
        host_name: "Valentina",
        latitude: 45.43398,
        longitude: 12.34034,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34034, 45.43398]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25173692,
        name: "San Marco Rialto Penthouse 3 bedrooms 2 bathrooms",
        host_id: 289615,
        host_name: "Valentina",
        latitude: 45.43545,
        longitude: 12.33491,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33491, 45.43545]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25174530,
        name: "San Marco Room 2",
        host_id: 48092742,
        host_name: "Roby",
        latitude: 45.43759,
        longitude: 12.34154,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34154, 45.43759]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25174867,
        name: "BECCARIE RESIDENCE IN RIALTO & WIFI",
        host_id: 289615,
        host_name: "Valentina",
        latitude: 45.43852,
        longitude: 12.33306,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33306, 45.43852]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25175013,
        name: "San Marco NEW second floor WI-FI",
        host_id: 15112827,
        host_name: "Marco",
        latitude: 45.43587,
        longitude: 12.33618,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33618, 45.43587]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25176940,
        name: "Dolce Vita Arsenale, duplex -washing machine, WIFI",
        host_id: 289615,
        host_name: "Valentina",
        latitude: 45.4339,
        longitude: 12.34979,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34979, 45.4339]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25177116,
        name: "Casa Furlo",
        host_id: 20653285,
        host_name: "Cristina",
        latitude: 45.43664,
        longitude: 12.34781,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34781, 45.43664]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25178867,
        name: "Cozy flat in the centre of Venice",
        host_id: 190255919,
        host_name: "Azzurra",
        latitude: 45.43822,
        longitude: 12.34537,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34537, 45.43822]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25186114,
        name: "CA RIALTO:IDEALE PER 10 PERSONE / WIFI GRATUITO",
        host_id: 289615,
        host_name: "Valentina",
        latitude: 45.43989,
        longitude: 12.33316,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33316, 45.43989]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25190584,
        name: "RIALTO PALACE FOR 14PAX & FREE WIFI",
        host_id: 289615,
        host_name: "Valentina",
        latitude: 45.44009,
        longitude: 12.33094,
        beds: 8,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33094, 45.44009]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25194501,
        name: "See the Magic of Venice from a Cute Loft",
        host_id: 9701290,
        host_name: "Nicoletta",
        latitude: 45.43975,
        longitude: 12.33971,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33971, 45.43975]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25195523,
        name: "Campo San Giacomo dall'Orio -  groundfloor apt",
        host_id: 289615,
        host_name: "Valentina",
        latitude: 45.44085,
        longitude: 12.32656,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32656, 45.44085]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25195530,
        name: "RESIDENCE LA VIDA: BIENNALE & WIFI",
        host_id: 289615,
        host_name: "Valentina",
        latitude: 45.43468,
        longitude: 12.34828,
        beds: 7,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34828, 45.43468]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25195549,
        name: "Residence SS Giovanni e Paolo- Rialto area",
        host_id: 289615,
        host_name: "Valentina",
        latitude: 45.43979,
        longitude: 12.33844,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33844, 45.43979]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25196862,
        name: "CASA TINTORETTO 4, NUOVO,CENTRO STORICO DI VENEZIA",
        host_id: 190388209,
        host_name: "Pietro",
        latitude: 45.44648,
        longitude: 12.32687,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32687, 45.44648]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25197041,
        name: "Pied-a-terre with courtyard - cozy apartment",
        host_id: 289615,
        host_name: "Valentina",
        latitude: 45.43987,
        longitude: 12.32711,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32711, 45.43987]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25197941,
        name: "CASA TINTORETTO FONTE, 3 GRANDI CAMERE E 2 BAGNI",
        host_id: 190388209,
        host_name: "Pietro",
        latitude: 45.44762,
        longitude: 12.32566,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32566, 45.44762]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25198522,
        name: "CASA TINTORETTO MORI 2 CON BELLA VISTA VENEZIA",
        host_id: 190388209,
        host_name: "Pietro",
        latitude: 45.44721,
        longitude: 12.32682,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32682, 45.44721]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25205637,
        name: "San Marco Apartment",
        host_id: 12707190,
        host_name: "Carlo",
        latitude: 45.43508,
        longitude: 12.33876,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33876, 45.43508]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25209486,
        name: "Alla Marinaressa Apartment e la Biennale",
        host_id: 190474932,
        host_name: "Paola",
        latitude: 45.4325,
        longitude: 12.35262,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35262, 45.4325]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25216041,
        name: "VIA GARIBALDI GIGLI BIENNALE terrace+wash.machine",
        host_id: 289615,
        host_name: "Valentina",
        latitude: 45.43251,
        longitude: 12.35045,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35045, 45.43251]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25220690,
        name: "Castello Apartment in Biennale",
        host_id: 23407211,
        host_name: "Beatrice",
        latitude: 45.42919,
        longitude: 12.35776,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35776, 45.42919]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25245252,
        name: "CHEER SAINT MARK'S BASILICA @200 meters",
        host_id: 188530147,
        host_name: "Cesare",
        latitude: 45.43516,
        longitude: 12.34133,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34133, 45.43516]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25247986,
        name: "Aliki's house",
        host_id: 4496256,
        host_name: "Annamaria",
        latitude: 45.43255,
        longitude: 12.3195,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3195, 45.43255]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25247996,
        name: "Tedeum",
        host_id: 4496256,
        host_name: "Annamaria",
        latitude: 45.43882,
        longitude: 12.34751,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34751, 45.43882]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25247999,
        name: "Venezia - Spaziosa a Sant'Elena vicino alla Biennale",
        host_id: 4496256,
        host_name: "Annamaria",
        latitude: 45.42819,
        longitude: 12.36265,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.36265, 45.42819]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25248098,
        name: "Venezia - Ca' San Lorenzo vista spettacolare",
        host_id: 4496256,
        host_name: "Annamaria",
        latitude: 45.43912,
        longitude: 12.34437,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34437, 45.43912]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25248103,
        name: "Venezia - Spazio e luce nel cuore di Venezia",
        host_id: 4496256,
        host_name: "Annamaria",
        latitude: 45.44071,
        longitude: 12.32939,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32939, 45.44071]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25248105,
        name: "giardini",
        host_id: 4496256,
        host_name: "Annamaria",
        latitude: 45.4316,
        longitude: 12.35379,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35379, 45.4316]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25249323,
        name: "Appartamento stile veneziano, nel cuore di Venezia",
        host_id: 190762295,
        host_name: "Mara & Eugenio",
        latitude: 45.42908,
        longitude: 12.32865,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32865, 45.42908]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25249873,
        name: "Rio Terrà Canal View",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.44553,
        longitude: 12.33046,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33046, 45.44553]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25259441,
        name: "San Marco Arsenale Apartment",
        host_id: 147027860,
        host_name: "G.",
        latitude: 45.43534,
        longitude: 12.34724,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34724, 45.43534]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25260600,
        name: "Casa ballarin++",
        host_id: 43552173,
        host_name: "Antonia",
        latitude: 45.43965,
        longitude: 12.32788,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32788, 45.43965]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25261095,
        name: "la Torre",
        host_id: 190144893,
        host_name: "Andrea",
        latitude: 45.43348,
        longitude: 12.3351,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3351, 45.43348]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25272902,
        name: "Ca' Ketty Apartment",
        host_id: 25128793,
        host_name: "_mdm_",
        latitude: 45.4327,
        longitude: 12.35239,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35239, 45.4327]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25277871,
        name: "DIAMOND Water'sDoor  in the heart of Venice",
        host_id: 190958997,
        host_name: "Maria",
        latitude: 45.43918,
        longitude: 12.33992,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33992, 45.43918]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25281102,
        name: "Ca' Girolamo Apartment with canal view",
        host_id: 25128793,
        host_name: "_mdm_",
        latitude: 45.44816,
        longitude: 12.32472,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32472, 45.44816]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25285290,
        name: "Beautiful flat near Biennale",
        host_id: 16841762,
        host_name: "Sara & Yayoi",
        latitude: 45.43005,
        longitude: 12.36153,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.36153, 45.43005]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25312777,
        name: "Nikki house appartamento Luce",
        host_id: 187144142,
        host_name: "Alessandro Markku",
        latitude: 45.4364,
        longitude: 12.34215,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34215, 45.4364]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25312863,
        name: "S. MARK & BIENNALE, family apt 2BDR 6p LUG DEPOSIT",
        host_id: 191187861,
        host_name: "Federica",
        latitude: 45.43539,
        longitude: 12.34577,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34577, 45.43539]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25322523,
        name: "Venice Room in Centre",
        host_id: 31276705,
        host_name: "Mila",
        latitude: 45.43665,
        longitude: 12.34162,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34162, 45.43665]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25331148,
        name: "Fantastic large room im central Venice 4",
        host_id: 48092742,
        host_name: "Roby",
        latitude: 45.44326,
        longitude: 12.32865,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32865, 45.44326]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25331616,
        name: "Rio Marin Garden View",
        host_id: 27081641,
        host_name: "Irene",
        latitude: 45.44054,
        longitude: 12.32372,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32372, 45.44054]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25339688,
        name: "San Marcuola very central artist large room",
        host_id: 185612295,
        host_name: "Lory",
        latitude: 45.44389,
        longitude: 12.3283,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3283, 45.44389]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25340311,
        name: '"ACAMAR" YACHT MARINA SANT\'ELENA RESORT IN VENICE',
        host_id: 191369211,
        host_name: "Cantiere",
        latitude: 45.42662,
        longitude: 12.36555,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.36555, 45.42662]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25346014,
        name: "House of Sunflowers",
        host_id: 191387651,
        host_name: "Fabio",
        latitude: 45.43344,
        longitude: 12.35625,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35625, 45.43344]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25359893,
        name: "Mario Apartment Fondamente Nove (3) 5214",
        host_id: 10072655,
        host_name: "Mario Apartment",
        latitude: 45.44139,
        longitude: 12.34033,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34033, 45.44139]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25362047,
        name: "DolceVita Apartments 414 Canal View",
        host_id: 8176475,
        host_name: "Eugenia",
        latitude: 45.43872,
        longitude: 12.34555,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34555, 45.43872]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25362760,
        name: "DolceVita Apartments N. 413 WiFi A/C Design",
        host_id: 8176475,
        host_name: "Eugenia",
        latitude: 45.44706,
        longitude: 12.32694,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32694, 45.44706]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25365205,
        name: "Sweet Room San Marco",
        host_id: 191226100,
        host_name: "Milo",
        latitude: 45.43583,
        longitude: 12.34275,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34275, 45.43583]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25369645,
        name: "Marco Polo studio",
        host_id: 114621580,
        host_name: "Lorenza",
        latitude: 45.43966,
        longitude: 12.33196,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33196, 45.43966]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25370939,
        name: "Residenza Colombina",
        host_id: 191559096,
        host_name: "Claudia",
        latitude: 45.43611,
        longitude: 12.34713,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34713, 45.43611]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25374585,
        name: "Venice Sweet Home cod. ID M (Phone number hidden by Airbnb)",
        host_id: 191583000,
        host_name: "Marco",
        latitude: 45.44495,
        longitude: 12.32048,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32048, 45.44495]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25387131,
        name: "ROSA DELLA LAGUNA  Apartment close to St. Mark's",
        host_id: 191665455,
        host_name: "Annamaria",
        latitude: 45.43537,
        longitude: 12.34397,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34397, 45.43537]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25389040,
        name: '"ODYSSEUS III" MARINA SANT\'ELENA RESORT IN VENICE',
        host_id: 191369211,
        host_name: "Cantiere",
        latitude: 45.42754,
        longitude: 12.36398,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.36398, 45.42754]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25392590,
        name: "Apartment gorne",
        host_id: 191694027,
        host_name: "Mirella",
        latitude: 45.43626,
        longitude: 12.3502,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3502, 45.43626]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25395761,
        name: "San Marco Love Gentile",
        host_id: 191559096,
        host_name: "Claudia",
        latitude: 45.43227,
        longitude: 12.33298,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33298, 45.43227]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25410683,
        name: "On the Canal",
        host_id: 4627569,
        host_name: "Francesca",
        latitude: 45.44038,
        longitude: 12.32325,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32325, 45.44038]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25414353,
        name: "Royal Charming Cà Cavalli San Polo Square",
        host_id: 37993131,
        host_name: "Aldo",
        latitude: 45.43798,
        longitude: 12.33055,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33055, 45.43798]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25416144,
        name: "Charming house with canal view Rio Marin",
        host_id: 37993131,
        host_name: "Aldo",
        latitude: 45.44073,
        longitude: 12.32368,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32368, 45.44073]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25436624,
        name: "Casanova Luxury Flat with view on the canal",
        host_id: 13500918,
        host_name: "Mark",
        latitude: 45.4346,
        longitude: 12.34137,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34137, 45.4346]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25437630,
        name: "Suite Marcorà M (Phone number hidden by Airbnb)",
        host_id: 15005402,
        host_name: "Veronica",
        latitude: 45.43184,
        longitude: 12.35354,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35354, 45.43184]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25439483,
        name: "CASA TINTORETTO MORI 1 CON BELLA VISTA",
        host_id: 190388209,
        host_name: "Pietro",
        latitude: 45.44549,
        longitude: 12.33385,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33385, 45.44549]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25439679,
        name: "Attico in centro a Venezia vista San Marco",
        host_id: 192032792,
        host_name: "Andrea",
        latitude: 45.43537,
        longitude: 12.3389,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3389, 45.43537]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25440181,
        name: "Giardino dei Melograni Economy Room #2",
        host_id: 630328,
        host_name: "Kosher House",
        latitude: 45.44653,
        longitude: 12.32601,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32601, 45.44653]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25442963,
        name: "Studio in Cannaregio - ideal for couples",
        host_id: 289615,
        host_name: "Valentina",
        latitude: 45.4398,
        longitude: 12.34115,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34115, 45.4398]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25443000,
        name: "Ca dei Scorsoni - romantic studio",
        host_id: 289615,
        host_name: "Valentina",
        latitude: 45.44107,
        longitude: 12.34162,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34162, 45.44107]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25443375,
        name: "Giardino dei Melograni Doppia Uso Singolo #1",
        host_id: 630328,
        host_name: "Kosher House",
        latitude: 45.44632,
        longitude: 12.32742,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32742, 45.44632]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25446243,
        name: "Al Fontego home-close to Rialto bridge,2 bathrooms",
        host_id: 289615,
        host_name: "Valentina",
        latitude: 45.4397,
        longitude: 12.33284,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33284, 45.4397]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25456301,
        name: "Casetta 500 veniceiloveyou apartment",
        host_id: 78873399,
        host_name: "Florence",
        latitude: 45.42965,
        longitude: 12.33266,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33266, 45.42965]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25472832,
        name: "CASA TINTORETTO 2 CON GIARDINO PRIVATO E GAZEBO",
        host_id: 190388209,
        host_name: "Pietro",
        latitude: 45.44561,
        longitude: 12.33207,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33207, 45.44561]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25473105,
        name: "Beautiful Room with Private Roof Terrace",
        host_id: 192260151,
        host_name: "Ca' Fortuny",
        latitude: 45.43397,
        longitude: 12.33355,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33355, 45.43397]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25475207,
        name: "CASA TINTORETTO MORI 3, NUOVO APPENA RISTRUTTURATO",
        host_id: 190388209,
        host_name: "Pietro",
        latitude: 45.4478,
        longitude: 12.32784,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32784, 45.4478]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25477146,
        name: "CA MALVASIA HOUSE WITH GARDEN",
        host_id: 5862083,
        host_name: "Silvia",
        latitude: 45.43357,
        longitude: 12.3313,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3313, 45.43357]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25479213,
        name: "LOVELY SAN BASILIO",
        host_id: 39240019,
        host_name: "Marcello",
        latitude: 45.43192,
        longitude: 12.31795,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31795, 45.43192]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25496148,
        name: "CASA TINTORETTO CAMPIELLO, NUOVO E CONFORTEVOLE",
        host_id: 190388209,
        host_name: "Pietro",
        latitude: 45.4462,
        longitude: 12.32571,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32571, 45.4462]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25497989,
        name: "CASA ANGELO WITH BALCONY, NEAR RIALTO BRIDGE",
        host_id: 190388209,
        host_name: "Pietro",
        latitude: 45.44044,
        longitude: 12.34096,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34096, 45.44044]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25499052,
        name: "Ca' Spirito Santo",
        host_id: 53699315,
        host_name: "Marinella E Stefano",
        latitude: 45.42917,
        longitude: 12.33245,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33245, 45.42917]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25499654,
        name: "sPALANCAti Giudecca",
        host_id: 192439591,
        host_name: "Elena",
        latitude: 45.42572,
        longitude: 12.32817,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32817, 45.42572]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25500753,
        name: "Ca' Rella",
        host_id: 29216890,
        host_name: "Donatella",
        latitude: 45.43433,
        longitude: 12.34264,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34264, 45.43433]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25500906,
        name: "Elegant design apartment near Saint Mark's Square",
        host_id: 192278231,
        host_name: "Chiara",
        latitude: 45.43312,
        longitude: 12.33314,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33314, 45.43312]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25505241,
        name: "La Bricola Terrace Apartment",
        host_id: 669047,
        host_name: "Viewsonvenice",
        latitude: 45.43124,
        longitude: 12.35383,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35383, 45.43124]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25507341,
        name: "La casa della pace.",
        host_id: 192485416,
        host_name: "Claudia",
        latitude: 45.43796,
        longitude: 12.34855,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34855, 45.43796]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25510599,
        name: "Cà Stae",
        host_id: 192506084,
        host_name: "Giuseppe",
        latitude: 45.43933,
        longitude: 12.32984,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32984, 45.43933]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25513602,
        name: "Palazzo Pisani Nicolai attico",
        host_id: 75691230,
        host_name: "Patrizia",
        latitude: 45.44001,
        longitude: 12.34052,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34052, 45.44001]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25514806,
        name: "San marco Imperial Room 2",
        host_id: 191226100,
        host_name: "Milo",
        latitude: 45.43585,
        longitude: 12.34103,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34103, 45.43585]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25525855,
        name: "Casinó lucky Room San Marcuola 3",
        host_id: 191226100,
        host_name: "Milo",
        latitude: 45.44438,
        longitude: 12.32921,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32921, 45.44438]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25528121,
        name: "Sweet Ca Morgana Home",
        host_id: 192632833,
        host_name: "Maria Cristina",
        latitude: 45.44061,
        longitude: 12.33136,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33136, 45.44061]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25534409,
        name: "Casa Patanella - veniceiloveyou",
        host_id: 78873399,
        host_name: "Florence",
        latitude: 45.4388,
        longitude: 12.32909,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32909, 45.4388]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25536105,
        name: "ANCORE, in the heart of the most beautiful Venice!",
        host_id: 192635744,
        host_name: "Patrizia",
        latitude: 45.43089,
        longitude: 12.35541,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35541, 45.43089]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25537984,
        name: "GIULY'S ROOM  nel cuore di Venezia",
        host_id: 7702022,
        host_name: "Doriana",
        latitude: 45.43949,
        longitude: 12.3376,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3376, 45.43949]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25538752,
        name: "CASA GIUSTINA, romantic retreat on the roofs",
        host_id: 4223020,
        host_name: "Guido",
        latitude: 45.43937,
        longitude: 12.34617,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34617, 45.43937]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25573346,
        name: "Ca’Molin",
        host_id: 28343543,
        host_name: "Jacopo",
        latitude: 45.43392,
        longitude: 12.33035,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33035, 45.43392]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25578733,
        name: "Casa dei Leoni",
        host_id: 632312,
        host_name: "Guillaume",
        latitude: 45.43532,
        longitude: 12.34954,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34954, 45.43532]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25579212,
        name: "Casa dell'Orio for family",
        host_id: 632312,
        host_name: "Guillaume",
        latitude: 45.44068,
        longitude: 12.32808,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32808, 45.44068]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25597867,
        name: "Ciliota Deluxe",
        host_id: 192985700,
        host_name: "Domus",
        latitude: 45.43309,
        longitude: 12.33016,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33016, 45.43309]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25600328,
        name: "Ca' Giulia",
        host_id: 22940319,
        host_name: "Albatroservices",
        latitude: 45.44054,
        longitude: 12.33759,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33759, 45.44054]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25610086,
        name: "Appartamento Alcova",
        host_id: 193025638,
        host_name: "Marco E Floriana",
        latitude: 45.4365,
        longitude: 12.34452,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34452, 45.4365]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25645138,
        name: "lovely view on the most authentic side of Venice.",
        host_id: 31276705,
        host_name: "Mila",
        latitude: 45.43052,
        longitude: 12.35833,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35833, 45.43052]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25648107,
        name: "Ca' Dolci, your oasis of peace at Giudecca.",
        host_id: 12113015,
        host_name: "Mario",
        latitude: 45.42669,
        longitude: 12.32169,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32169, 45.42669]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25652932,
        name: "Apartment in Venice",
        host_id: 128715197,
        host_name: "Cortinovis",
        latitude: 45.44708,
        longitude: 12.32847,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32847, 45.44708]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25657214,
        name: "The romantic Pink House - historic centre -Venice",
        host_id: 166998861,
        host_name: "Sara",
        latitude: 45.43681,
        longitude: 12.33911,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33911, 45.43681]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25657483,
        name: "Romantic dream Flat Ca D'oro",
        host_id: 191226100,
        host_name: "Milo",
        latitude: 45.4421,
        longitude: 12.33289,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33289, 45.4421]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25658949,
        name: "Supercentral italian design close to attractions",
        host_id: 185612295,
        host_name: "Lory",
        latitude: 45.44127,
        longitude: 12.33462,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33462, 45.44127]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25659514,
        name: "Top floor Flat 3 with view on amazing Venice",
        host_id: 191226100,
        host_name: "Milo",
        latitude: 45.43165,
        longitude: 12.35746,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35746, 45.43165]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25662759,
        name: "Central Venice Eu via Garibaldi lovely romantic",
        host_id: 185612295,
        host_name: "Lory",
        latitude: 45.4333,
        longitude: 12.35492,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35492, 45.4333]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25710413,
        name: "Double Room at Casa di Chiara (Cannaregio-Rialto)",
        host_id: 131619336,
        host_name: "Chiara",
        latitude: 45.44052,
        longitude: 12.33734,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33734, 45.44052]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25714126,
        name: "Cà Mascarèta",
        host_id: 27313147,
        host_name: "Valeria",
        latitude: 45.43709,
        longitude: 12.33877,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33877, 45.43709]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25722168,
        name: "Dimora Furlani for family",
        host_id: 632312,
        host_name: "Guillaume",
        latitude: 45.43493,
        longitude: 12.34541,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34541, 45.43493]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25722913,
        name: "4Family spacious apartment",
        host_id: 172838960,
        host_name: "Venice",
        latitude: 45.43963,
        longitude: 12.34573,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34573, 45.43963]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25734005,
        name: "Venice Appartament Salini II",
        host_id: 73021997,
        host_name: "Alexandra - Giovanni",
        latitude: 45.43288,
        longitude: 12.35769,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35769, 45.43288]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25763705,
        name: "Romantic Rialto Tower Suite",
        host_id: 193631173,
        host_name: "Barbara",
        latitude: 45.44113,
        longitude: 12.3366,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3366, 45.44113]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25764271,
        name: "Ca' del Cortile 4, flat with private terrace",
        host_id: 173503437,
        host_name: "Federica",
        latitude: 45.43376,
        longitude: 12.33008,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33008, 45.43376]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25766940,
        name: "RUGA BELLA ( in the heart of Venice)",
        host_id: 1157596,
        host_name: "Gian Maria",
        latitude: 45.44091,
        longitude: 12.32663,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32663, 45.44091]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25768190,
        name: "TINTORETTO 1 CON TERRAZZA IN LEGNO SOPRA IL TETTO",
        host_id: 190388209,
        host_name: "Pietro",
        latitude: 45.44796,
        longitude: 12.32711,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32711, 45.44796]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25778576,
        name: "Al Campaniel apartment - appartamento a Rialto",
        host_id: 193732023,
        host_name: "Elisa",
        latitude: 45.43855,
        longitude: 12.33116,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33116, 45.43855]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25778888,
        name: "At Historic building in the center, 2 apartments",
        host_id: 5332195,
        host_name: "Alessandro",
        latitude: 45.43797,
        longitude: 12.33793,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33793, 45.43797]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25786713,
        name: "CORNARO apartment with private garden",
        host_id: 114621580,
        host_name: "Lorenza",
        latitude: 45.44009,
        longitude: 12.32974,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32974, 45.44009]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25787506,
        name: "Modern Gem, Bright Design Apartment.",
        host_id: 172838960,
        host_name: "Venice",
        latitude: 45.4392,
        longitude: 12.331,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.331, 45.4392]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25794000,
        name:
          "VENETIAN NEST central flat  1st floor M (Phone number hidden by Airbnb)",
        host_id: 11098038,
        host_name: "Isotta",
        latitude: 45.44037,
        longitude: 12.32981,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32981, 45.44037]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25799280,
        name: "Ca' Dandolo",
        host_id: 294951,
        host_name: "VeniceVillas Di Enzo",
        latitude: 45.44054,
        longitude: 12.32468,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32468, 45.44054]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25801428,
        name: "Venice centre, wi-fi free and air conditioning",
        host_id: 193887007,
        host_name: "Giorgia",
        latitude: 45.44226,
        longitude: 12.32108,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32108, 45.44226]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25826988,
        name: "Giardino dei Melograni Double Standard Room #3",
        host_id: 630328,
        host_name: "Kosher House",
        latitude: 45.44619,
        longitude: 12.3271,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3271, 45.44619]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25827254,
        name: "Giardino dei Melograni Double Standard Room #2",
        host_id: 630328,
        host_name: "Kosher House",
        latitude: 45.44503,
        longitude: 12.32713,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32713, 45.44503]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25828551,
        name: "Giardino dei Melograni Double Standard Room #4",
        host_id: 630328,
        host_name: "Kosher House",
        latitude: 45.44659,
        longitude: 12.3264,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3264, 45.44659]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25829764,
        name: "Superior Room",
        host_id: 630328,
        host_name: "Kosher House",
        latitude: 45.44643,
        longitude: 12.32717,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32717, 45.44643]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25829994,
        name: "Triple Room",
        host_id: 630328,
        host_name: "Kosher House",
        latitude: 45.44514,
        longitude: 12.32647,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32647, 45.44514]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25849335,
        name: "TAO - Rialto two bedrooms Apartment",
        host_id: 107662922,
        host_name: "Marco",
        latitude: 45.43908,
        longitude: 12.33373,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33373, 45.43908]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25849656,
        name: "Au Nom De La Rose",
        host_id: 5618111,
        host_name: "EasySuite",
        latitude: 45.43572,
        longitude: 12.34779,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34779, 45.43572]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25857763,
        name: "Triple Room",
        host_id: 630328,
        host_name: "Kosher House",
        latitude: 45.44669,
        longitude: 12.32585,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32585, 45.44669]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25878103,
        name: "Attic Querini-Near San Marco Rialto opening offer",
        host_id: 134656502,
        host_name: "Mattia",
        latitude: 45.43581,
        longitude: 12.34237,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34237, 45.43581]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25880737,
        name: '"TIFFANY" MARINA SANT\'ELENA RESORT IN VENICE',
        host_id: 191369211,
        host_name: "Cantiere",
        latitude: 45.42772,
        longitude: 12.3653,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3653, 45.42772]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25881753,
        name: "elegant design very central apartment ca d'oro",
        host_id: 31276705,
        host_name: "Mila",
        latitude: 45.4419,
        longitude: 12.33467,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33467, 45.4419]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25890051,
        name: "White Design Apartment",
        host_id: 194511985,
        host_name: "Stefano",
        latitude: 45.43341,
        longitude: 12.33541,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33541, 45.43341]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25890497,
        name: "venice center flat",
        host_id: 620628,
        host_name: "Nino",
        latitude: 45.43521,
        longitude: 12.34015,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34015, 45.43521]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25923592,
        name: "Venice Glass Apartment",
        host_id: 26404861,
        host_name: "Marika",
        latitude: 45.44114,
        longitude: 12.32734,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32734, 45.44114]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25926260,
        name: "Under the roof bohémien-style apartment X107",
        host_id: 15178567,
        host_name: "Paolo",
        latitude: 45.43428,
        longitude: 12.3301,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3301, 45.43428]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25928509,
        name: "New refurbished 2 bedrooms with terrace X6201",
        host_id: 15178567,
        host_name: "Paolo",
        latitude: 45.43807,
        longitude: 12.3383,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3383, 45.43807]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25934830,
        name: "Casa Claudia ai Frari",
        host_id: 194933960,
        host_name: "Dimitri & Valentina",
        latitude: 45.43521,
        longitude: 12.32562,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32562, 45.43521]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25937661,
        name: "Palanchetta",
        host_id: 192439591,
        host_name: "Elena",
        latitude: 45.42524,
        longitude: 12.32643,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32643, 45.42524]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25939770,
        name: "Your house in Cannaregio",
        host_id: 115629152,
        host_name: "Luciano",
        latitude: 45.44634,
        longitude: 12.31929,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31929, 45.44634]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25962156,
        name: "Luxury large apartment Tiepolo",
        host_id: 157492478,
        host_name: "Michele",
        latitude: 45.43652,
        longitude: 12.32298,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32298, 45.43652]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25966263,
        name: "Third floor sunny and central, 2 doubles X501",
        host_id: 15178567,
        host_name: "Paolo",
        latitude: 45.43751,
        longitude: 12.34015,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34015, 45.43751]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25987682,
        name: "Venice Luxury Palace 1",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.43695,
        longitude: 12.33234,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33234, 45.43695]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25987684,
        name: "Venice Luxury Palace 5",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.43668,
        longitude: 12.33154,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33154, 45.43668]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25988358,
        name: "friendly house in venice",
        host_id: 195342014,
        host_name: "Debora",
        latitude: 45.42773,
        longitude: 12.36233,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.36233, 45.42773]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25992965,
        name: "Palace Gradenigo Wendy in Venice 200m2",
        host_id: 104948826,
        host_name: "Elida",
        latitude: 45.44138,
        longitude: 12.32474,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32474, 45.44138]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25994758,
        name: "Romantic loft Venice Ca D'oro",
        host_id: 13500918,
        host_name: "Mark",
        latitude: 45.44061,
        longitude: 12.33472,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33472, 45.44061]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25995104,
        name: "Holiday apartment with 1 bedroom on 70m² in Venezia VE",
        host_id: 159965476,
        host_name: "Francesco - NOVASOL",
        latitude: 45.43534,
        longitude: 12.33,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33, 45.43534]] },
    },
    {
      type: "Feature",
      properties: {
        id: 25998885,
        name: "Beautiful room to relax in Venice",
        host_id: 192260151,
        host_name: "Ca' Fortuny",
        latitude: 45.43557,
        longitude: 12.3322,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3322, 45.43557]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26004324,
        name: "Ca' del Magazen  Cattaneo House",
        host_id: 195422400,
        host_name: "Giulio",
        latitude: 45.44401,
        longitude: 12.32676,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32676, 45.44401]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26019399,
        name: "view on the canal Flat Biennale Eu",
        host_id: 13500918,
        host_name: "Mark",
        latitude: 45.43331,
        longitude: 12.35638,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35638, 45.43331]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26019596,
        name: "Giardino dei Melograni Double Superior #1",
        host_id: 630328,
        host_name: "Kosher House",
        latitude: 45.44658,
        longitude: 12.32613,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32613, 45.44658]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26020841,
        name: "Modern romantic San Zaccaria Flat with canal view",
        host_id: 191226100,
        host_name: "Milo",
        latitude: 45.43405,
        longitude: 12.34245,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34245, 45.43405]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26021144,
        name: "Rialto View city Flat",
        host_id: 191226100,
        host_name: "Milo",
        latitude: 45.43684,
        longitude: 12.33702,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33702, 45.43684]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26021536,
        name: "San Pietro Flat in real Venice centre",
        host_id: 191226100,
        host_name: "Milo",
        latitude: 45.43379,
        longitude: 12.3587,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3587, 45.43379]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26023815,
        name: "Casa delle Spezie Centralissimo Rialto Venezia",
        host_id: 195584974,
        host_name: "Patrizia",
        latitude: 45.43891,
        longitude: 12.33265,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33265, 45.43891]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26024613,
        name: "Giardino dei Melograni Doppia Superior #2",
        host_id: 630328,
        host_name: "Kosher House",
        latitude: 45.44633,
        longitude: 12.32635,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32635, 45.44633]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26026483,
        name: "VENICE BEATIFUL CANAL VIEW ROMANTIC PALAZZO",
        host_id: 195603642,
        host_name: "Enrique",
        latitude: 45.4428,
        longitude: 12.33587,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33587, 45.4428]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26026717,
        name: "Venice In The Heart",
        host_id: 195603336,
        host_name: "Patrizia",
        latitude: 45.44025,
        longitude: 12.34002,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34002, 45.44025]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26032582,
        name: "Casa con bellissima vista sul canale",
        host_id: 195646568,
        host_name: "Nadia",
        latitude: 45.44475,
        longitude: 12.33113,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33113, 45.44475]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26046107,
        name: "Triple Room at Casa di Chiara (Cannaregio-Rialto)",
        host_id: 131619336,
        host_name: "Chiara",
        latitude: 45.43911,
        longitude: 12.33688,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33688, 45.43911]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26055196,
        name: "Tiziano room",
        host_id: 22974469,
        host_name: "Fede",
        latitude: 45.43083,
        longitude: 12.35665,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35665, 45.43083]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26056027,
        name: "3 rooms apartment near Rialto bridge, 7 pax",
        host_id: 118683310,
        host_name: "Elisa Sara",
        latitude: 45.44079,
        longitude: 12.33898,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33898, 45.44079]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26088139,
        name: "Sulla coda del pesce, appartamento zona Biennale",
        host_id: 33982550,
        host_name: "Andrea",
        latitude: 45.43206,
        longitude: 12.35622,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35622, 45.43206]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26088883,
        name: "Ca' Giustino appartamento a Venezia centro storico",
        host_id: 196092783,
        host_name: "Christian",
        latitude: 45.4397,
        longitude: 12.33704,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33704, 45.4397]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26089987,
        name: "Art & Architecture - 8 min walk from Rialto",
        host_id: 174733491,
        host_name: "Gladys E Valentina",
        latitude: 45.44698,
        longitude: 12.32565,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32565, 45.44698]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26093592,
        name: "Blue room, casa con vista a Venezia, Biennale.",
        host_id: 151801710,
        host_name: "Francesco",
        latitude: 45.43364,
        longitude: 12.35237,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35237, 45.43364]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26094787,
        name: "Ca' D'Oro Tower",
        host_id: 136039108,
        host_name: "Giulia",
        latitude: 45.44255,
        longitude: 12.33188,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33188, 45.44255]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26101193,
        name: "Ca' del Manin d'oro (2min walking from Gran Canal)",
        host_id: 48040265,
        host_name: "Alessandro",
        latitude: 45.4436,
        longitude: 12.32992,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32992, 45.4436]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26105336,
        name: "Traditional house in the heart of Venice",
        host_id: 196221782,
        host_name: "Rossella",
        latitude: 45.42986,
        longitude: 12.33354,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33354, 45.42986]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26114928,
        name: "CA MODENA",
        host_id: 22632812,
        host_name: "Alain",
        latitude: 45.43857,
        longitude: 12.32769,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32769, 45.43857]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26116420,
        name: "Convenient place, quiet apartment 3 persons",
        host_id: 15178567,
        host_name: "Paolo",
        latitude: 45.43504,
        longitude: 12.34662,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34662, 45.43504]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26117521,
        name: "Cà Flora M (Phone number hidden by Airbnb)",
        host_id: 15005402,
        host_name: "Veronica",
        latitude: 45.43122,
        longitude: 12.35749,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35749, 45.43122]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26121797,
        name: "Calle Annunziata",
        host_id: 191559096,
        host_name: "Claudia",
        latitude: 45.43886,
        longitude: 12.34793,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34793, 45.43886]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26121952,
        name: "San Giacomo Panoramic Dream",
        host_id: 196352746,
        host_name: "Patrizia",
        latitude: 45.43983,
        longitude: 12.32726,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32726, 45.43983]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26122768,
        name: "Cà Cesare",
        host_id: 173330609,
        host_name: "Luca",
        latitude: 45.44238,
        longitude: 12.33929,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33929, 45.44238]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26122914,
        name: "Aqua Apartments - Appartamento con una camera",
        host_id: 196359282,
        host_name: "Aqua Apartments",
        latitude: 45.4406,
        longitude: 12.33536,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33536, 45.4406]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26150279,
        name: "Aqua Apartments -Appartamento con 2 camere e vista",
        host_id: 196359282,
        host_name: "Aqua Apartments",
        latitude: 45.44605,
        longitude: 12.32576,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32576, 45.44605]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26159724,
        name: "Garden View SAN MARCO",
        host_id: 196621538,
        host_name: "Dimitri & Valentina",
        latitude: 45.43736,
        longitude: 12.34532,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34532, 45.43736]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26186108,
        name: "Cozy economy double room in the Centre of Venice",
        host_id: 192260151,
        host_name: "Ca' Fortuny",
        latitude: 45.43519,
        longitude: 12.33301,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33301, 45.43519]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26186800,
        name: "Romantic Venice Experience in SuperiorDouble Room",
        host_id: 192260151,
        host_name: "Ca' Fortuny",
        latitude: 45.43393,
        longitude: 12.33144,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33144, 45.43393]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26187611,
        name: "Enjoy your stay in a comfortable Triple Room",
        host_id: 192260151,
        host_name: "Ca' Fortuny",
        latitude: 45.43397,
        longitude: 12.33332,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33332, 45.43397]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26188104,
        name: "Spacious Triple Room with 2 Bathrooms",
        host_id: 192260151,
        host_name: "Ca' Fortuny",
        latitude: 45.43496,
        longitude: 12.33209,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33209, 45.43496]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26194953,
        name: "VENICE HEAVEN APARTMENTS SAN MARCO 2",
        host_id: 1554828,
        host_name: "Veronica",
        latitude: 45.43306,
        longitude: 12.33685,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33685, 45.43306]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26211358,
        name: "Ca'Lala -Room renting in Cannaregio- 2 Double Beds",
        host_id: 196994766,
        host_name: "Jade",
        latitude: 45.44542,
        longitude: 12.32254,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32254, 45.44542]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26240693,
        name: "Riva Di Biasio 1230/A",
        host_id: 197208199,
        host_name: "Gisella",
        latitude: 45.4404,
        longitude: 12.32398,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32398, 45.4404]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26242197,
        name: "MONOLOCALE LA CORTE BIENNALE",
        host_id: 197224424,
        host_name: "Giulia",
        latitude: 45.4309,
        longitude: 12.35804,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35804, 45.4309]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26249951,
        name: "Tiepolo Rialto Apartment R&R",
        host_id: 173200514,
        host_name: "Rent&Relax",
        latitude: 45.43895,
        longitude: 12.33199,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33199, 45.43895]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26265990,
        name:
          "Luminoso appartamento a Castello, tra San Marco e i Giardini della Biennale",
        host_id: 197447470,
        host_name: "Ilaria",
        latitude: 45.43381,
        longitude: 12.34822,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34822, 45.43381]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26271982,
        name: "VeniceVillas Ca' Sophie",
        host_id: 294951,
        host_name: "VeniceVillas Di Enzo",
        latitude: 45.43488,
        longitude: 12.34528,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34528, 45.43488]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26272876,
        name: "Artemisia Home",
        host_id: 197498671,
        host_name: "Cecilia",
        latitude: 45.43976,
        longitude: 12.33911,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33911, 45.43976]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26273051,
        name: "Ca' Voga - Venitian Big Home",
        host_id: 121299893,
        host_name: "Irene",
        latitude: 45.44037,
        longitude: 12.3236,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3236, 45.44037]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26273201,
        name: "Cenare, such a charming and refined flat",
        host_id: 197478251,
        host_name: "Marta",
        latitude: 45.44563,
        longitude: 12.32665,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32665, 45.44563]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26275245,
        name: "The Hatter's Venice Apartment",
        host_id: 197523323,
        host_name: "Daniele",
        latitude: 45.43333,
        longitude: 12.32492,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32492, 45.43333]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26295992,
        name: "La Terrazza dei Gelsomini",
        host_id: 197712017,
        host_name: "Cosetta",
        latitude: 45.43719,
        longitude: 12.32324,
        beds: 7,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32324, 45.43719]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26312625,
        name: "STELLA MARINA 5 APARTMENT",
        host_id: 21356512,
        host_name: "Cristina",
        latitude: 45.42718,
        longitude: 12.32188,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32188, 45.42718]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26319942,
        name: "“Platinum” apartment, big, 5min to train station",
        host_id: 159746853,
        host_name: "Giulia",
        latitude: 45.44451,
        longitude: 12.32576,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32576, 45.44451]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26321358,
        name:
          "Welcoming studio apt w/ city center view - walk to dining, shopping, & sights",
        host_id: 4339678,
        host_name: "Vacasa Italy - Venice",
        latitude: 45.44032,
        longitude: 12.33487,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33487, 45.44032]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26325765,
        name: "Grande zona Bacino San Marco Biennale",
        host_id: 197975616,
        host_name: "Olga",
        latitude: 45.43359,
        longitude: 12.35207,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35207, 45.43359]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26327062,
        name: "LOVELY HOUSE IN ZATTERE",
        host_id: 197990896,
        host_name: "Anna Maria Teresa",
        latitude: 45.43047,
        longitude: 12.32727,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32727, 45.43047]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26331371,
        name: "Smart Design Apartment",
        host_id: 39893769,
        host_name: "Sebastiano",
        latitude: 45.44026,
        longitude: 12.31435,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31435, 45.44026]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26331896,
        name: "Giudecca Submarine, share venetian life !",
        host_id: 79522175,
        host_name: "Chris",
        latitude: 45.42575,
        longitude: 12.32762,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32762, 45.42575]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26341997,
        name: "Richard's house in Biennale area",
        host_id: 47458448,
        host_name: "Riccardo",
        latitude: 45.4307,
        longitude: 12.35718,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35718, 45.4307]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26343496,
        name: "20 WINDOWS ON VENICE",
        host_id: 198126481,
        host_name: "Thomas",
        latitude: 45.43475,
        longitude: 12.32638,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32638, 45.43475]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26344184,
        name: "Casa Barzizza",
        host_id: 198129333,
        host_name: "Daniele",
        latitude: 45.43784,
        longitude: 12.33186,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33186, 45.43784]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26344782,
        name: "Ca Corner Palazzo Alverà",
        host_id: 190583435,
        host_name: "Michele",
        latitude: 45.43511,
        longitude: 12.33143,
        beds: 8,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33143, 45.43511]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26371316,
        name: "Calle Sacrestia",
        host_id: 191559096,
        host_name: "Claudia",
        latitude: 45.43479,
        longitude: 12.34108,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34108, 45.43479]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26371359,
        name: "Wonderfull Venetian Style Near San Marco/Arsenale",
        host_id: 139627704,
        host_name: "Giusy & Fabrizio",
        latitude: 45.43646,
        longitude: 12.34596,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34596, 45.43646]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26372764,
        name: "Ca' Margiò",
        host_id: 191559096,
        host_name: "Claudia",
        latitude: 45.43308,
        longitude: 12.3286,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3286, 45.43308]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26412590,
        name: "Rialto Grand Canal View  (M (Phone number hidden by Airbnb)",
        host_id: 399883,
        host_name: "Monica",
        latitude: 45.43828,
        longitude: 12.33461,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33461, 45.43828]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26418097,
        name:
          "Accogliente appartamento con terrazzino in un romantico angolo del centro",
        host_id: 198645120,
        host_name: "Roberta",
        latitude: 45.43482,
        longitude: 12.34763,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34763, 45.43482]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26418427,
        name: "The Iconic View",
        host_id: 198647840,
        host_name: "Mira",
        latitude: 45.44143,
        longitude: 12.33626,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33626, 45.44143]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26431134,
        name: "Cannaregio House",
        host_id: 1157596,
        host_name: "Gian Maria",
        latitude: 45.44118,
        longitude: 12.34077,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34077, 45.44118]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26434944,
        name: "Apt. Prestige Canal View (Little Terrace)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.44229,
        longitude: 12.3371,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3371, 45.44229]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26436826,
        name: "BIENNALE APARTMENT",
        host_id: 14357135,
        host_name: "Rent It Venice",
        latitude: 45.43268,
        longitude: 12.35078,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35078, 45.43268]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26436829,
        name: "CASA CONTARINI",
        host_id: 14357135,
        host_name: "Rent It Venice",
        latitude: 45.43722,
        longitude: 12.34769,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34769, 45.43722]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26438279,
        name: '"Cà de Casanova"',
        host_id: 198800503,
        host_name: "Edoardo",
        latitude: 45.43216,
        longitude: 12.32909,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32909, 45.43216]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26438561,
        name: "Ruga Rialto",
        host_id: 198795836,
        host_name: "Fabiano",
        latitude: 45.43953,
        longitude: 12.32982,
        beds: 8,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32982, 45.43953]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26443484,
        name: "VENICE HEAVEN APARTMENTS SAN MARCO 1 /2BEDROOMS",
        host_id: 1554828,
        host_name: "Veronica",
        latitude: 45.43319,
        longitude: 12.3376,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3376, 45.43319]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26456704,
        name: "CA' LUCY VENICE CENTER",
        host_id: 187070661,
        host_name: "Lucia",
        latitude: 45.44022,
        longitude: 12.32546,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32546, 45.44022]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26479744,
        name: "Ale Guggenheim Apartment",
        host_id: 169636806,
        host_name: "Renato",
        latitude: 45.42914,
        longitude: 12.33108,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33108, 45.42914]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26481542,
        name: "Violet Room 6 With Private Bath. San Marcuola",
        host_id: 191226100,
        host_name: "Milo",
        latitude: 45.44263,
        longitude: 12.32792,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32792, 45.44263]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26482318,
        name: "❣️150sqm 3lev & Rooftop Terrace✔️700m to San Marco",
        host_id: 9852012,
        host_name: "Paolo",
        latitude: 45.43333,
        longitude: 12.33207,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33207, 45.43333]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26492094,
        name: "Mario Apartment 2188/A",
        host_id: 10072655,
        host_name: "Mario Apartment",
        latitude: 45.44156,
        longitude: 12.32996,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32996, 45.44156]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26499435,
        name: "Casa delle Gondole",
        host_id: 199296796,
        host_name: "Pietro",
        latitude: 45.43652,
        longitude: 12.32234,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32234, 45.43652]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26506522,
        name: "Entire Building in the Heart of San Marco",
        host_id: 3488715,
        host_name: "Luca",
        latitude: 45.43641,
        longitude: 12.33758,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33758, 45.43641]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26529448,
        name: "CONFORTABLE CENTRAL STAY WITH PRIVATE BATHROOM",
        host_id: 199531195,
        host_name: "Marco&Alina",
        latitude: 45.44371,
        longitude: 12.33181,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33181, 45.44371]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26544219,
        name: "Stroll to St Mark's Square from Casa Verona Luxury Apartment",
        host_id: 6019189,
        host_name: "Federico",
        latitude: 45.43351,
        longitude: 12.33383,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33383, 45.43351]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26549132,
        name: "NEW Ecletic Apartment+ AC+ WiFi+ 2room",
        host_id: 5332195,
        host_name: "Alessandro",
        latitude: 45.43566,
        longitude: 12.34588,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34588, 45.43566]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26550162,
        name: "Miracoli Apartment",
        host_id: 199652145,
        host_name: "Francesco",
        latitude: 45.44047,
        longitude: 12.33869,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33869, 45.44047]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26551169,
        name: "Casa Ro.Ni. Cannaregio",
        host_id: 199645103,
        host_name: "Nicoletta",
        latitude: 45.44309,
        longitude: 12.31975,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31975, 45.44309]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26551817,
        name: "Cà Foscari apartment",
        host_id: 47683665,
        host_name: "Alberto",
        latitude: 45.43425,
        longitude: 12.32513,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32513, 45.43425]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26552709,
        name: "TERRACE Biennale APT ** Lagoon View  **",
        host_id: 199668446,
        host_name: "Alida",
        latitude: 45.43324,
        longitude: 12.35142,
        beds: 8,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35142, 45.43324]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26558085,
        name: "Large Attic Flat close to Train Station - San Stae",
        host_id: 199704489,
        host_name: "Anna",
        latitude: 45.44081,
        longitude: 12.32576,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32576, 45.44081]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26560007,
        name: "Gioiello di Venezia, Suite Calle del Forno",
        host_id: 149831127,
        host_name: "Marino",
        latitude: 45.43216,
        longitude: 12.35437,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35437, 45.43216]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26591718,
        name: "Appartamento san polo",
        host_id: 198795836,
        host_name: "Fabiano",
        latitude: 45.43782,
        longitude: 12.32926,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32926, 45.43782]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26595055,
        name: "Cosy apartment with A/C near Saint Mark Square",
        host_id: 5182839,
        host_name: "Riccardo",
        latitude: 45.43298,
        longitude: 12.33181,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33181, 45.43298]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26603828,
        name: "Casa delle Gondole 2",
        host_id: 199296796,
        host_name: "Pietro",
        latitude: 45.43596,
        longitude: 12.32141,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32141, 45.43596]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26652064,
        name:
          "Appartamento defilato ma profondamente veneziano nella zona di Castello",
        host_id: 33095107,
        host_name: "Barbara",
        latitude: 45.43592,
        longitude: 12.34987,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34987, 45.43592]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26680623,
        name: "CA' FORTUNATO ~ WI~FI",
        host_id: 147169056,
        host_name: "Lucia",
        latitude: 45.43995,
        longitude: 12.32628,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32628, 45.43995]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26684320,
        name: "CA' ZANIN (quiet and romantic apartment)",
        host_id: 200610884,
        host_name: "Norina",
        latitude: 45.44556,
        longitude: 12.32798,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32798, 45.44556]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26686591,
        name: "Casa agli Squellini",
        host_id: 192852514,
        host_name: "Martina",
        latitude: 45.4348,
        longitude: 12.32608,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32608, 45.4348]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26687640,
        name: "WITH AMAZING TERRACE - NEAR THE JEWISH GHETTO",
        host_id: 167369618,
        host_name: "Elena",
        latitude: 45.44466,
        longitude: 12.32769,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32769, 45.44466]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26708377,
        name: "Tipycal Venetial House, 2/3 bedroom, AC, wifi",
        host_id: 5332195,
        host_name: "Alessandro",
        latitude: 45.43516,
        longitude: 12.34793,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34793, 45.43516]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26711483,
        name: "*CASA THEA* ART&DESIGN IN CITY CENTER",
        host_id: 199531195,
        host_name: "Marco&Alina",
        latitude: 45.44282,
        longitude: 12.33315,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33315, 45.44282]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26711850,
        name: "CLEAN&COZY ROOM WITH PRIVATE BATHROOM",
        host_id: 199531195,
        host_name: "Marco&Alina",
        latitude: 45.44251,
        longitude: 12.33204,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33204, 45.44251]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26714398,
        name: "CASA MUCCINI",
        host_id: 200870697,
        host_name: "Laura",
        latitude: 45.42561,
        longitude: 12.32251,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32251, 45.42561]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26731886,
        name: "LA FENICE VENICE APARTMENT IN SAN MARCO",
        host_id: 25582770,
        host_name: "Simona",
        latitude: 45.43316,
        longitude: 12.33239,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33239, 45.43316]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26735087,
        name: "Appartamento GRIMANI",
        host_id: 32887555,
        host_name: "Residence Corte Grimani",
        latitude: 45.43399,
        longitude: 12.33674,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33674, 45.43399]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26739954,
        name: "Stanza delle Civette",
        host_id: 148639120,
        host_name: "Massimiliano",
        latitude: 45.44054,
        longitude: 12.32298,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32298, 45.44054]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26742119,
        name: "Erbaria Boutique Apartment R&R",
        host_id: 173200514,
        host_name: "Rent&Relax",
        latitude: 45.43891,
        longitude: 12.33534,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33534, 45.43891]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26743396,
        name: "Venice Magic, Biennale apartment",
        host_id: 91959957,
        host_name: "Lorella",
        latitude: 45.43115,
        longitude: 12.35783,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35783, 45.43115]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26757881,
        name: "Casa Dogal",
        host_id: 201213137,
        host_name: "Rita",
        latitude: 45.44126,
        longitude: 12.33144,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33144, 45.44126]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26762592,
        name: "Cavanella classic apartment",
        host_id: 201241689,
        host_name: "Anna",
        latitude: 45.4357,
        longitude: 12.34107,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34107, 45.4357]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26775149,
        name: "Spacious, quiet, bright and perfectly located!",
        host_id: 7833708,
        host_name: "Massimo",
        latitude: 45.44595,
        longitude: 12.32579,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32579, 45.44595]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26776190,
        name: "Elegante appartamento immerso nella magia veneziana",
        host_id: 132051429,
        host_name: "Cristina",
        latitude: 45.43667,
        longitude: 12.34285,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34285, 45.43667]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26781063,
        name: "sleep in venezia.110",
        host_id: 131261322,
        host_name: "Luca",
        latitude: 45.43215,
        longitude: 12.35814,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35814, 45.43215]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26792111,
        name: "CA' DEL CORDER - A secret corner of peace",
        host_id: 201476976,
        host_name: "Willer",
        latitude: 45.42527,
        longitude: 12.32497,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32497, 45.42527]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26794738,
        name: "Residenza Ca' Alessandro",
        host_id: 70387837,
        host_name: "Alessandro",
        latitude: 45.4451,
        longitude: 12.33307,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33307, 45.4451]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26795683,
        name: "Large Apartment 5 min from San Marco - Casa Vivian",
        host_id: 139627704,
        host_name: "Giusy & Fabrizio",
        latitude: 45.43306,
        longitude: 12.352,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.352, 45.43306]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26797487,
        name: "Ca’ Norma",
        host_id: 201510064,
        host_name: "Francesca",
        latitude: 45.44197,
        longitude: 12.32085,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32085, 45.44197]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26803416,
        name: "Appartamento “specio” Cannaregio Venezia",
        host_id: 119422620,
        host_name: "Francesco",
        latitude: 45.44247,
        longitude: 12.3329,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3329, 45.44247]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26803904,
        name: "Chiara's Venice Apartment",
        host_id: 201555368,
        host_name: "Francesco",
        latitude: 45.4347,
        longitude: 12.35009,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35009, 45.4347]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26826164,
        name: "The nest, in Venice historical centre",
        host_id: 201742019,
        host_name: "Casa",
        latitude: 45.4365,
        longitude: 12.32577,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32577, 45.4365]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26844976,
        name: "Palazzo on the Grand Canal, SUPPORT an Art Project",
        host_id: 201886177,
        host_name: "Maison",
        latitude: 45.43532,
        longitude: 12.33244,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33244, 45.43532]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26854689,
        name: "Garden House, Sant’Elena Venice",
        host_id: 201975483,
        host_name: "Alessandro",
        latitude: 45.42828,
        longitude: 12.36301,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.36301, 45.42828]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26856282,
        name: "RESIDENZA LETIZIA, free Wi-Fi",
        host_id: 174702096,
        host_name: "Chiara",
        latitude: 45.43277,
        longitude: 12.358,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.358, 45.43277]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26890002,
        name: "FIDELIO super central and modern flat!",
        host_id: 1438903,
        host_name: "Barbara",
        latitude: 45.4385,
        longitude: 12.33733,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33733, 45.4385]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26905174,
        name: "210 MQ -ACCADEMIA BRIDGE - 4 BEDROOMS-3 BATHROOMS",
        host_id: 179297180,
        host_name: "Chiara",
        latitude: 45.43043,
        longitude: 12.32773,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32773, 45.43043]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26914044,
        name: "Deluxe Room in Rialto in AncientPalace on theCanal",
        host_id: 202492873,
        host_name: "Anna",
        latitude: 45.43671,
        longitude: 12.33871,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33871, 45.43671]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26914118,
        name: "Patch of Eden",
        host_id: 84879311,
        host_name: "Francesca",
        latitude: 45.42666,
        longitude: 12.32288,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32288, 45.42666]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26939744,
        name: "La Grancevola is a gorgeous apartment with balcony",
        host_id: 8604186,
        host_name: "James & Amber",
        latitude: 45.44126,
        longitude: 12.32398,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32398, 45.44126]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26972780,
        name: "BEATIFUL CANAL VIEW PALAZZO DOUBLE",
        host_id: 202954108,
        host_name: "Pedro",
        latitude: 45.44177,
        longitude: 12.33489,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33489, 45.44177]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26977558,
        name: "CANAL VIEW NEAR ST.MARK SQUARE FREE WIFI + NETFLIX",
        host_id: 127168590,
        host_name: "Patrizia",
        latitude: 45.43253,
        longitude: 12.35837,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35837, 45.43253]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26979375,
        name: "Ca' Nal A - BIG LUXURY APARTMENT RIALTO / S.MARCO",
        host_id: 49990117,
        host_name: "Alberta",
        latitude: 45.43526,
        longitude: 12.33702,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33702, 45.43526]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26984312,
        name: "Giglio Apartment - Venice Center",
        host_id: 186598572,
        host_name: "Rosanna",
        latitude: 45.43318,
        longitude: 12.33283,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33283, 45.43318]] },
    },
    {
      type: "Feature",
      properties: {
        id: 26998491,
        name: "Whole Apartment near Rialto bridge",
        host_id: 203141373,
        host_name: "Lorenzo",
        latitude: 45.43589,
        longitude: 12.32912,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32912, 45.43589]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27008717,
        name: "Giuditta Home. Stunning ! 3 min BIENNALE",
        host_id: 185872492,
        host_name: "Elite",
        latitude: 45.4317,
        longitude: 12.35642,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35642, 45.4317]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27011653,
        name: "Stanza doppia -  casa religiosa Leone XIII Venezia",
        host_id: 119635149,
        host_name: "Francesco",
        latitude: 45.43173,
        longitude: 12.35481,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35481, 45.43173]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27015907,
        name: "Canal view Flat On Garibaldi Street",
        host_id: 191226100,
        host_name: "Milo",
        latitude: 45.43207,
        longitude: 12.35589,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35589, 45.43207]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27036203,
        name: "Ada's House- stunning view- quiet location",
        host_id: 125940696,
        host_name: "Ada",
        latitude: 45.43647,
        longitude: 12.32392,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32392, 45.43647]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27039372,
        name: "DolceVita Apartments 426 San Marco Square",
        host_id: 8176475,
        host_name: "Eugenia",
        latitude: 45.43434,
        longitude: 12.3376,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3376, 45.43434]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27046981,
        name: "Capannone Redentore",
        host_id: 669047,
        host_name: "Viewsonvenice",
        latitude: 45.4238,
        longitude: 12.32894,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32894, 45.4238]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27056371,
        name: "San Pantalon Canal View",
        host_id: 27081641,
        host_name: "Irene",
        latitude: 45.43721,
        longitude: 12.32328,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32328, 45.43721]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27070576,
        name: "Apartment SAN POLO - HISTORICAL CENTRE",
        host_id: 203696500,
        host_name: "Marco",
        latitude: 45.4383,
        longitude: 12.32903,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32903, 45.4383]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27096532,
        name: "GRAZIOSO APPARTAMENTO MIRACOLI",
        host_id: 11388964,
        host_name: "Chiara",
        latitude: 45.4398,
        longitude: 12.33987,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33987, 45.4398]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27096535,
        name: "Apartamento SANTA CROCE - HISTORICAL CENTRE",
        host_id: 203696500,
        host_name: "Marco",
        latitude: 45.43866,
        longitude: 12.32851,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32851, 45.43866]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27098108,
        name: "Apartment in Ca’ Contarini",
        host_id: 73934712,
        host_name: "Tour Apartments",
        latitude: 45.43384,
        longitude: 12.32928,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32928, 45.43384]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27119115,
        name: "Studio H",
        host_id: 6557403,
        host_name: "Soyoung",
        latitude: 45.43181,
        longitude: 12.35676,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35676, 45.43181]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27124446,
        name: "cute & Comfy  flat in Venice x 2 people",
        host_id: 204178103,
        host_name: "Lorenzo",
        latitude: 45.42421,
        longitude: 12.33057,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33057, 45.42421]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27125153,
        name: "GIUDECCA GALLERY stylish loft with terrace!",
        host_id: 1438903,
        host_name: "Barbara",
        latitude: 45.42584,
        longitude: 12.3236,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3236, 45.42584]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27132248,
        name: "Venice Romantic Petite Rooftop hot tub",
        host_id: 22921103,
        host_name: "Andrea",
        latitude: 45.43479,
        longitude: 12.32424,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32424, 45.43479]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27133962,
        name: "Traditional home with terrace and Jacuzzi showers",
        host_id: 22921103,
        host_name: "Andrea",
        latitude: 45.4351,
        longitude: 12.32575,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32575, 45.4351]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27142442,
        name: "SAN MARCO HOUSE",
        host_id: 1157596,
        host_name: "Gian Maria",
        latitude: 45.43187,
        longitude: 12.33521,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33521, 45.43187]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27142968,
        name: "Studio a Rialto, II",
        host_id: 154467654,
        host_name: "Sara",
        latitude: 45.43832,
        longitude: 12.33652,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33652, 45.43832]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27153302,
        name: "Ca' Delle Gondole - L.T.  M (Phone number hidden by Airbnb)",
        host_id: 204435441,
        host_name: "Mariagiovanna",
        latitude: 45.43817,
        longitude: 12.33028,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33028, 45.43817]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27153900,
        name: "Casa di Chiara - Apartment (Cannaregio-Rialto)",
        host_id: 131619336,
        host_name: "Chiara",
        latitude: 45.44042,
        longitude: 12.3361,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3361, 45.44042]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27154834,
        name: "Lux apartment:2 bedrooms, 2 bathrooms. Canal view",
        host_id: 204432444,
        host_name: "Irene",
        latitude: 45.43575,
        longitude: 12.33663,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33663, 45.43575]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27156892,
        name: '"Otello" Apartment by Fenix',
        host_id: 203929414,
        host_name: "Fenix",
        latitude: 45.43381,
        longitude: 12.35452,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35452, 45.43381]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27159293,
        name: '"Aida" Mansion by Fenix',
        host_id: 203929414,
        host_name: "Fenix",
        latitude: 45.43235,
        longitude: 12.35233,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35233, 45.43235]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27160833,
        name: "Venice’s heart, apartment 2 bedrooms, AC,free Wifi",
        host_id: 204493133,
        host_name: "Raffaele",
        latitude: 45.4419,
        longitude: 12.32724,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32724, 45.4419]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27165598,
        name: "Authentic and Quiet Venetian Apartment",
        host_id: 98479290,
        host_name: "Daniele",
        latitude: 45.42954,
        longitude: 12.33353,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33353, 45.42954]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27166932,
        name: "Ca' Baloni San Marco",
        host_id: 204553448,
        host_name: "Chiara",
        latitude: 45.43372,
        longitude: 12.33916,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33916, 45.43372]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27177981,
        name: "Room with BigTerrace andPrivate Bathroom(in front)",
        host_id: 202492873,
        host_name: "Anna",
        latitude: 45.43694,
        longitude: 12.33884,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33884, 45.43694]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27181823,
        name: "SAN MARCO ATTIC - NEW OPENING!",
        host_id: 204671172,
        host_name: "Pietro",
        latitude: 45.43476,
        longitude: 12.3355,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3355, 45.43476]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27184934,
        name: "Casa Masa - Cozy apartment near the station",
        host_id: 204695892,
        host_name: "Silvia",
        latitude: 45.44576,
        longitude: 12.31942,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31942, 45.44576]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27190051,
        name: "Grand Canal Pearl: palace garden dock terrace!",
        host_id: 27468706,
        host_name: "Valeria",
        latitude: 45.44385,
        longitude: 12.32769,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32769, 45.44385]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27210699,
        name: "WarmHospitality - Appartamento Giglio",
        host_id: 13477708,
        host_name: "Debora",
        latitude: 45.4327,
        longitude: 12.31353,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31353, 45.4327]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27210834,
        name: "WarmHospitality - Appartamento Rosa",
        host_id: 13477708,
        host_name: "Debora",
        latitude: 45.43304,
        longitude: 12.31384,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31384, 45.43304]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27210931,
        name: "WarmHospitality - Appartamento Iris",
        host_id: 13477708,
        host_name: "Debora",
        latitude: 45.43362,
        longitude: 12.31437,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31437, 45.43362]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27211590,
        name: "WarmHospitality - Appartamento Viola",
        host_id: 13477708,
        host_name: "Debora",
        latitude: 45.43317,
        longitude: 12.31425,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31425, 45.43317]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27217406,
        name: "CASA VICKY",
        host_id: 204968006,
        host_name: "Anna",
        latitude: 45.43881,
        longitude: 12.34615,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34615, 45.43881]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27222824,
        name: "Romantic apartment at Rialto bridge.",
        host_id: 97732588,
        host_name: "Anna",
        latitude: 45.44026,
        longitude: 12.33151,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33151, 45.44026]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27231328,
        name: "1 Minute of San Marco Square: Terrace, WiFi, A / C",
        host_id: 17762135,
        host_name: "Edoardo",
        latitude: 45.43591,
        longitude: 12.33665,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33665, 45.43591]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27243573,
        name: "Attico Terrazza",
        host_id: 3972291,
        host_name: "Caroline E Marco",
        latitude: 45.43552,
        longitude: 12.34975,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34975, 45.43552]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27244448,
        name: "Fuseri",
        host_id: 205196965,
        host_name: "Yourflat",
        latitude: 45.43574,
        longitude: 12.33464,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33464, 45.43574]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27244759,
        name: "Charming tile apartment",
        host_id: 4791745,
        host_name: "Matteo",
        latitude: 45.44449,
        longitude: 12.32462,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32462, 45.44449]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27245065,
        name: "\"SOFA'\" MARINA SANT'ELENA RESORT IN VENICE",
        host_id: 191369211,
        host_name: "Cantiere",
        latitude: 45.42787,
        longitude: 12.36566,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.36566, 45.42787]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27257605,
        name: "CaGiorgio House alla Biennale",
        host_id: 58963426,
        host_name: "Gilberto",
        latitude: 45.43165,
        longitude: 12.35694,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35694, 45.43165]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27271176,
        name: "San Maurizio",
        host_id: 205196965,
        host_name: "Yourflat",
        latitude: 45.43223,
        longitude: 12.33079,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33079, 45.43223]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27272684,
        name: "Al Campanile San Marco with terrace",
        host_id: 39600986,
        host_name: "Christine",
        latitude: 45.4363,
        longitude: 12.34149,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34149, 45.4363]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27304289,
        name: "Elegant Apartment x 7",
        host_id: 205703685,
        host_name: "Bricola",
        latitude: 45.43132,
        longitude: 12.35256,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35256, 45.43132]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27308743,
        name: "Small Double Room in Venetian style",
        host_id: 98479290,
        host_name: "Daniele",
        latitude: 45.4298,
        longitude: 12.33224,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33224, 45.4298]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27324465,
        name: "Elegant Apartment x2",
        host_id: 205703685,
        host_name: "Bricola",
        latitude: 45.4305,
        longitude: 12.35388,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35388, 45.4305]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27349334,
        name: "Residenza al Bastion",
        host_id: 206101213,
        host_name: "Antonella",
        latitude: 45.43544,
        longitude: 12.34993,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34993, 45.43544]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27358739,
        name: "VENEZIA SPIRITO SANTO CANAL VIEW",
        host_id: 206170213,
        host_name: "Luca",
        latitude: 45.4299,
        longitude: 12.33175,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33175, 45.4299]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27389018,
        name: "La Baruffa with Private Garden",
        host_id: 669047,
        host_name: "Viewsonvenice",
        latitude: 45.42893,
        longitude: 12.33096,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33096, 45.42893]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27393570,
        name: "Emilio 2395 - Nice apartment with a view",
        host_id: 206444395,
        host_name: "Emilio",
        latitude: 45.43763,
        longitude: 12.32571,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32571, 45.43763]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27412022,
        name: "Ca' Lucilla",
        host_id: 206583339,
        host_name: "Lisa",
        latitude: 45.44288,
        longitude: 12.33109,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33109, 45.44288]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27415405,
        name: "Central Venice Private Room and Bathroom",
        host_id: 206603591,
        host_name: "Giovanna",
        latitude: 45.43229,
        longitude: 12.32661,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32661, 45.43229]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27422071,
        name: "Alloggio Studio",
        host_id: 206408611,
        host_name: "Enrico",
        latitude: 45.44152,
        longitude: 12.32669,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32669, 45.44152]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27423574,
        name: "4Family Central Apartment with a balcony",
        host_id: 172838960,
        host_name: "Venice",
        latitude: 45.43629,
        longitude: 12.34304,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34304, 45.43629]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27454348,
        name: "Casanova Room Romantic with balcony view",
        host_id: 48092742,
        host_name: "Roby",
        latitude: 45.43749,
        longitude: 12.34165,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34165, 45.43749]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27454540,
        name: "Elegant Apartment x 4",
        host_id: 205703685,
        host_name: "Bricola",
        latitude: 45.43054,
        longitude: 12.35431,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35431, 45.43054]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27454590,
        name: "Art Balcony Room In San Marco",
        host_id: 48092742,
        host_name: "Roby",
        latitude: 45.43713,
        longitude: 12.3409,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3409, 45.43713]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27455379,
        name: "22 Marzo",
        host_id: 206380158,
        host_name: "Weekey Rentals",
        latitude: 45.43413,
        longitude: 12.33514,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33514, 45.43413]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27455391,
        name: "Elegant Apartment x 8 (suitable for large groups)",
        host_id: 205703685,
        host_name: "Bricola",
        latitude: 45.43091,
        longitude: 12.35291,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35291, 45.43091]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27455823,
        name: "Cà Colonne x 11 (Apartment for large groups)",
        host_id: 205703685,
        host_name: "Bricola",
        latitude: 45.43218,
        longitude: 12.35415,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35415, 45.43218]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27464967,
        name: "Casanova CASETTA luxury flat view on the canal",
        host_id: 48092742,
        host_name: "Roby",
        latitude: 45.44153,
        longitude: 12.33541,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33541, 45.44153]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27465137,
        name: "Romantic venetian Room 1",
        host_id: 48092742,
        host_name: "Roby",
        latitude: 45.43709,
        longitude: 12.34247,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34247, 45.43709]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27465217,
        name: "Imperial Room in Centre n.1",
        host_id: 48092742,
        host_name: "Roby",
        latitude: 45.43612,
        longitude: 12.34114,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34114, 45.43612]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27481266,
        name: "Barnaba Suite",
        host_id: 207106555,
        host_name: "Mariagrazia",
        latitude: 45.43138,
        longitude: 12.32348,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32348, 45.43138]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27485412,
        name: "very central design",
        host_id: 48092742,
        host_name: "Roby",
        latitude: 45.44246,
        longitude: 12.33331,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33331, 45.44246]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27491536,
        name: "Great view in great location central cannaregio",
        host_id: 185612295,
        host_name: "Lory",
        latitude: 45.44485,
        longitude: 12.32301,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32301, 45.44485]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27498558,
        name: "Your house in Cannaregio",
        host_id: 115629152,
        host_name: "Luciano",
        latitude: 45.44553,
        longitude: 12.32113,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32113, 45.44553]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27499305,
        name: "Casa dalle Contrade",
        host_id: 207291051,
        host_name: "Gianpaolo",
        latitude: 45.44143,
        longitude: 12.32896,
        beds: 8,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32896, 45.44143]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27506451,
        name: "NEW Cosy flat near BIENNALE &St.Mark’s Sq A/C WiFi",
        host_id: 207374827,
        host_name: "Alberto",
        latitude: 45.43813,
        longitude: 12.34623,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34623, 45.43813]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27513243,
        name: '"Otello" Loft by Fenix',
        host_id: 203929414,
        host_name: "Fenix",
        latitude: 45.43304,
        longitude: 12.3526,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3526, 45.43304]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27513530,
        name: '"Do Dogi" Apartment by Fenix',
        host_id: 203929414,
        host_name: "Fenix",
        latitude: 45.43238,
        longitude: 12.35239,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35239, 45.43238]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27515029,
        name: "Ca'Diva",
        host_id: 141121267,
        host_name: "Paola",
        latitude: 45.4467,
        longitude: 12.3322,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3322, 45.4467]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27516492,
        name: '"Armida" Apartment by Fenix',
        host_id: 203929414,
        host_name: "Fenix",
        latitude: 45.43298,
        longitude: 12.35511,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35511, 45.43298]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27517270,
        name: "Suite alla Maddalena - Monolocale",
        host_id: 20685673,
        host_name: "Gabriel",
        latitude: 45.44253,
        longitude: 12.3307,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3307, 45.44253]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27533534,
        name: "Cà Grimana (modern studio apartment for 2)",
        host_id: 205703685,
        host_name: "Bricola",
        latitude: 45.4313,
        longitude: 12.35261,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35261, 45.4313]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27534086,
        name: "Cà Pedrocchi (beutiful apartment with a view)",
        host_id: 205703685,
        host_name: "Bricola",
        latitude: 45.43286,
        longitude: 12.35151,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35151, 45.43286]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27534273,
        name: "Cà Pedrocchi",
        host_id: 205703685,
        host_name: "Bricola",
        latitude: 45.43282,
        longitude: 12.35276,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35276, 45.43282]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27536955,
        name: "Castello Biennale Venezia",
        host_id: 204231846,
        host_name: "Residence",
        latitude: 45.43219,
        longitude: 12.35563,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35563, 45.43219]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27539266,
        name: "Castello Biennale Venezia",
        host_id: 204231846,
        host_name: "Residence",
        latitude: 45.43174,
        longitude: 12.35631,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35631, 45.43174]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27547969,
        name: "Apartment Ramo del Turchese",
        host_id: 207835147,
        host_name: "Elda",
        latitude: 45.44735,
        longitude: 12.32358,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32358, 45.44735]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27548595,
        name: "sleep in venezia.222",
        host_id: 131261322,
        host_name: "Luca",
        latitude: 45.43285,
        longitude: 12.35812,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35812, 45.43285]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27559491,
        name: "Beautiful large apartment in the heart of Venice",
        host_id: 15249983,
        host_name: "Alvise",
        latitude: 45.43649,
        longitude: 12.34604,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34604, 45.43649]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27563565,
        name: "Relax Veneziano",
        host_id: 31731422,
        host_name: "Alessandra",
        latitude: 45.43009,
        longitude: 12.32844,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32844, 45.43009]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27567788,
        name: "TINTORETTO 5 LITTLE GARDEN and CANAL VIEW",
        host_id: 103640525,
        host_name: "Team",
        latitude: 45.44515,
        longitude: 12.3292,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3292, 45.44515]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27576851,
        name: "Ca' Del Capitello 2- Fondamenta Della Misericordia",
        host_id: 45708064,
        host_name: "Giacomo",
        latitude: 45.444,
        longitude: 12.33281,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33281, 45.444]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27576962,
        name:
          "Cá Riva del Vin - codice ident. M (Phone number hidden by Airbnb)",
        host_id: 208021374,
        host_name: "Giulia",
        latitude: 45.43843,
        longitude: 12.33534,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33534, 45.43843]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27578421,
        name: "Amazing Venice Appartament",
        host_id: 163441546,
        host_name: "Valentina",
        latitude: 45.43291,
        longitude: 12.35253,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35253, 45.43291]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27587263,
        name: "Bright & renovated 2bdr in a great location,Venice",
        host_id: 11505507,
        host_name: "Alexandra",
        latitude: 45.4441,
        longitude: 12.31935,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31935, 45.4441]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27605918,
        name: "Contarini - San Francesco",
        host_id: 132992706,
        host_name: "Antonio",
        latitude: 45.43628,
        longitude: 12.3467,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3467, 45.43628]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27615894,
        name: "Contarini - Sant'Erasmo",
        host_id: 132992706,
        host_name: "Antonio",
        latitude: 45.43843,
        longitude: 12.34731,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34731, 45.43843]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27617245,
        name:
          "Appartamento al piano nobile di un edificio del 600 con affaccio su un canale",
        host_id: 10329111,
        host_name: "Giorgio",
        latitude: 45.43698,
        longitude: 12.34459,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34459, 45.43698]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27617451,
        name: "Contarini - Murano",
        host_id: 132992706,
        host_name: "Antonio",
        latitude: 45.43762,
        longitude: 12.34593,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34593, 45.43762]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27618661,
        name: "Contarini - Pellestrina",
        host_id: 132992706,
        host_name: "Antonio",
        latitude: 45.43685,
        longitude: 12.34622,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34622, 45.43685]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27620661,
        name: "Yacht Fortebraccio Venezia - Camere e Colazione",
        host_id: 376806,
        host_name: "Orlando",
        latitude: 45.42823,
        longitude: 12.31778,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31778, 45.42823]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27627714,
        name: "La Camera Romantica - The Romantic Room",
        host_id: 208480633,
        host_name: "Casa",
        latitude: 45.44439,
        longitude: 12.32776,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32776, 45.44439]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27628453,
        name: "La Camera Amici - The Friends Room",
        host_id: 208480633,
        host_name: "Casa",
        latitude: 45.4459,
        longitude: 12.3277,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3277, 45.4459]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27631036,
        name: "La Camera Amici Star - The Friends Room Star",
        host_id: 208480633,
        host_name: "Casa",
        latitude: 45.44366,
        longitude: 12.3295,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3295, 45.44366]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27634092,
        name: "Luxury apartment big lounge fireplace two terraces",
        host_id: 208533198,
        host_name: "Ernesto",
        latitude: 45.44209,
        longitude: 12.33188,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33188, 45.44209]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27636393,
        name: "San Marco Apartment charming Venetian court view",
        host_id: 10989537,
        host_name: "Monica",
        latitude: 45.4334,
        longitude: 12.3323,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3323, 45.4334]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27644378,
        name: "Sumptuous Suite with Canal Views!",
        host_id: 89512390,
        host_name: "G&T",
        latitude: 45.42989,
        longitude: 12.32932,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32932, 45.42989]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27648174,
        name: "LAGUNA BOUTIQUE APARTMENT",
        host_id: 14357135,
        host_name: "Rent It Venice",
        latitude: 45.43103,
        longitude: 12.35497,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35497, 45.43103]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27650005,
        name: "Santo Stefano Apartment",
        host_id: 3060084,
        host_name: "Giacomo",
        latitude: 45.43323,
        longitude: 12.32924,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32924, 45.43323]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27650550,
        name: '"Do Dogi" Loft by Fenix',
        host_id: 203929414,
        host_name: "Fenix",
        latitude: 45.43226,
        longitude: 12.35281,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35281, 45.43226]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27650684,
        name: "Suite @ Locanda Antico Fiore Venice",
        host_id: 3060084,
        host_name: "Giacomo",
        latitude: 45.4338,
        longitude: 12.32967,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32967, 45.4338]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27651070,
        name: 'CANCELLO · "Colombina" Studio by Fenix',
        host_id: 203929414,
        host_name: "Fenix",
        latitude: 45.43334,
        longitude: 12.35254,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35254, 45.43334]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27653794,
        name: "Enjoy Venice in an Oasis of serenity !",
        host_id: 208689815,
        host_name: "Cristiana",
        latitude: 45.43717,
        longitude: 12.34203,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34203, 45.43717]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27653888,
        name: "Like in a movie!",
        host_id: 208690368,
        host_name: "Blaise",
        latitude: 45.42596,
        longitude: 12.33751,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33751, 45.42596]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27653932,
        name: "On the Misericordia Canal - Ca' Lezze",
        host_id: 208690763,
        host_name: "Silvana",
        latitude: 45.44453,
        longitude: 12.33039,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33039, 45.44453]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27687653,
        name: "San Marco Apartment charming Venetian court view 2",
        host_id: 10989537,
        host_name: "Monica",
        latitude: 45.43296,
        longitude: 12.33179,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33179, 45.43296]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27712250,
        name: "Ca' Turchette - Colourful Apartment in Venice",
        host_id: 209215235,
        host_name: "Turchette",
        latitude: 45.43155,
        longitude: 12.32368,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32368, 45.43155]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27715289,
        name: "Apartment San Polo 2167",
        host_id: 209237742,
        host_name: "Patrizia",
        latitude: 45.43757,
        longitude: 12.3288,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3288, 45.43757]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27725650,
        name: "Rialto Suite 707 apartment",
        host_id: 988816,
        host_name: "Roberta",
        latitude: 45.43866,
        longitude: 12.33412,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33412, 45.43866]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27742279,
        name: "Ca'Dorina",
        host_id: 3972291,
        host_name: "Caroline E Marco",
        latitude: 45.44178,
        longitude: 12.33545,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33545, 45.44178]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27768780,
        name: "La tua stanza a Venezia 01",
        host_id: 196163510,
        host_name: "Elvio",
        latitude: 45.43435,
        longitude: 12.31819,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31819, 45.43435]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27770110,
        name: "RELAX HOUSE ANGELA - LOVELY GARDEN IN VENICE",
        host_id: 209670528,
        host_name: "Federico",
        latitude: 45.42523,
        longitude: 12.33114,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33114, 45.42523]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27798269,
        name: "VeniceVillas  Ca' Gamba",
        host_id: 294951,
        host_name: "VeniceVillas Di Enzo",
        latitude: 45.4455,
        longitude: 12.32348,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32348, 45.4455]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27827937,
        name: "Very Charming Quiet 1BedroomTrainStationGuglie",
        host_id: 210137804,
        host_name: "Ilaria",
        latitude: 45.44271,
        longitude: 12.32859,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32859, 45.44271]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27841622,
        name: "CA' BARBARANA -  For a Royal Stay ♔",
        host_id: 210257951,
        host_name: "Greta",
        latitude: 45.4396,
        longitude: 12.33993,
        beds: 7,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33993, 45.4396]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27844520,
        name: "Appartement Bartholdi 8 personnes",
        host_id: 29204201,
        host_name: "Marie-Laure",
        latitude: 45.43174,
        longitude: 12.32816,
        beds: 8,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32816, 45.43174]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27846087,
        name: '"La Bohéme" Suite by Fenix',
        host_id: 203929414,
        host_name: "Fenix",
        latitude: 45.42985,
        longitude: 12.35612,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35612, 45.42985]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27862042,
        name: '"La Bohéme" Studio by Fenix',
        host_id: 203929414,
        host_name: "Fenix",
        latitude: 45.43144,
        longitude: 12.35629,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35629, 45.43144]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27862052,
        name: "Ca'Ginevra&Carolina",
        host_id: 210446933,
        host_name: "Ginevra",
        latitude: 45.43193,
        longitude: 12.3582,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3582, 45.43193]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27862450,
        name: '"La Bohéme" Apartment by Fenix',
        host_id: 203929414,
        host_name: "Fenix",
        latitude: 45.43193,
        longitude: 12.35576,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35576, 45.43193]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27869564,
        name: "NEW! CASTELLO 5173 - centrale, luminoso, elegante!",
        host_id: 210518842,
        host_name: "Trevigroup",
        latitude: 45.43694,
        longitude: 12.34345,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34345, 45.43694]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27873617,
        name: "Venice's Heart",
        host_id: 210549106,
        host_name: "Dakey",
        latitude: 45.43129,
        longitude: 12.35683,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35683, 45.43129]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27884814,
        name: "Ca' Della Frutta Venetian Apartment",
        host_id: 669047,
        host_name: "Viewsonvenice",
        latitude: 45.43446,
        longitude: 12.32202,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32202, 45.43446]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27891542,
        name: "BRAGORA 3524 BETWEEN SAN MARCO AND BIENNALE",
        host_id: 210694224,
        host_name: "Andrea",
        latitude: 45.43495,
        longitude: 12.34699,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34699, 45.43495]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27903191,
        name: "Appartamento Venezia Giudecca Palanca",
        host_id: 210776848,
        host_name: "Franco",
        latitude: 45.42575,
        longitude: 12.32722,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32722, 45.42575]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27905378,
        name: "Stately Home large garden check-in 18>20 treatable",
        host_id: 210798771,
        host_name: "Biancarosa",
        latitude: 45.44154,
        longitude: 12.32668,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32668, 45.44154]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27922189,
        name: "Campo San Maurizio",
        host_id: 161550273,
        host_name: "Alessandra - Interhome",
        latitude: 45.43366,
        longitude: 12.33112,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33112, 45.43366]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27925105,
        name: "MINI SUITE AIT REPONTI VIEW CANALE",
        host_id: 35689579,
        host_name: "Haleh",
        latitude: 45.43515,
        longitude: 12.31784,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31784, 45.43515]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27925305,
        name: "STUNNING APARTMENT IN THE HEART OF VENICE",
        host_id: 5395291,
        host_name: "Beatrice",
        latitude: 45.43639,
        longitude: 12.34684,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34684, 45.43639]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27932431,
        name: "Palazzo DaPonte 01 - Large & Private Best Location",
        host_id: 2718137,
        host_name: "DaPonte",
        latitude: 45.43722,
        longitude: 12.33857,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33857, 45.43722]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27939676,
        name: "Luxury apartment big lounge fireplace 2 terraces B",
        host_id: 208533198,
        host_name: "Ernesto",
        latitude: 45.44335,
        longitude: 12.33071,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33071, 45.44335]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27943543,
        name: "Casa Felice: romantic escape",
        host_id: 6654661,
        host_name: "Rita",
        latitude: 45.44098,
        longitude: 12.33978,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33978, 45.44098]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27945673,
        name: "Appartamento intero - Entire apartment",
        host_id: 208480633,
        host_name: "Casa",
        latitude: 45.44433,
        longitude: 12.32787,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32787, 45.44433]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27974864,
        name: "Ca' Dell' Abate Terrace",
        host_id: 669047,
        host_name: "Viewsonvenice",
        latitude: 45.43085,
        longitude: 12.32901,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32901, 45.43085]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27976579,
        name: '"Giardino" apartment',
        host_id: 211299395,
        host_name: "Silvia",
        latitude: 45.4315,
        longitude: 12.31058,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31058, 45.4315]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27981504,
        name: "Like a miracle",
        host_id: 211323886,
        host_name: "Momi",
        latitude: 45.43977,
        longitude: 12.33852,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33852, 45.43977]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27994615,
        name: "Piano nobile- studio",
        host_id: 47257,
        host_name: "Greta",
        latitude: 45.44016,
        longitude: 12.33922,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33922, 45.44016]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27997549,
        name: "Luxury apartment Palazzetto Querini",
        host_id: 7258600,
        host_name: "Enrico",
        latitude: 45.43501,
        longitude: 12.32979,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32979, 45.43501]] },
    },
    {
      type: "Feature",
      properties: {
        id: 27997932,
        name: "Ca' della Fontanella: centrale, cortile, WI-FI, AC",
        host_id: 211460375,
        host_name: "Giorgio",
        latitude: 45.44268,
        longitude: 12.33344,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33344, 45.44268]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28002843,
        name: "Assassini Apartment",
        host_id: 178963743,
        host_name: "Mike",
        latitude: 45.43571,
        longitude: 12.33277,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33277, 45.43571]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28006077,
        name: "Canal view Giudecca",
        host_id: 211518037,
        host_name: "Saverio",
        latitude: 45.42525,
        longitude: 12.32584,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32584, 45.42525]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28022331,
        name: "Ca’ Zulian Palace - Grand Canal",
        host_id: 153493391,
        host_name: "Pietro And Caterina",
        latitude: 45.44159,
        longitude: 12.33282,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33282, 45.44159]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28038936,
        name: "SAN MARCO CANAL VIEW#2 aircond, 4 pax, 120sqm Wifi",
        host_id: 153954052,
        host_name: "Annalisa",
        latitude: 45.43783,
        longitude: 12.34369,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34369, 45.43783]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28040826,
        name: "Refined brand new apart in the hearth of Venice",
        host_id: 40852487,
        host_name: "Andrew",
        latitude: 45.4342,
        longitude: 12.33751,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33751, 45.4342]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28049180,
        name: "Suite alla Maddalena - Elegante e graziosa camera",
        host_id: 20685673,
        host_name: "Gabriel",
        latitude: 45.44342,
        longitude: 12.33205,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33205, 45.44342]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28059611,
        name: "Stylish flat with a roof terrace in Dorsoduro",
        host_id: 12497228,
        host_name: "Canal Grande",
        latitude: 45.42971,
        longitude: 12.33273,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33273, 45.42971]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28072982,
        name: "Canale",
        host_id: 206380158,
        host_name: "Weekey Rentals",
        latitude: 45.43975,
        longitude: 12.33805,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33805, 45.43975]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28073916,
        name: "CasaSantElena",
        host_id: 135690433,
        host_name: "Marco",
        latitude: 45.42573,
        longitude: 12.36168,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.36168, 45.42573]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28074300,
        name: "Castello",
        host_id: 206380158,
        host_name: "Weekey Rentals",
        latitude: 45.43734,
        longitude: 12.34102,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34102, 45.43734]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28074327,
        name: "San Zulian",
        host_id: 206380158,
        host_name: "Weekey Rentals",
        latitude: 45.43606,
        longitude: 12.33816,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33816, 45.43606]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28074333,
        name: "Testa",
        host_id: 206380158,
        host_name: "Weekey Rentals",
        latitude: 45.44157,
        longitude: 12.34171,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34171, 45.44157]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28074339,
        name: "Giudecca",
        host_id: 206380158,
        host_name: "Weekey Rentals",
        latitude: 45.42547,
        longitude: 12.32809,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32809, 45.42547]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28074353,
        name: "Giudecca 2",
        host_id: 206380158,
        host_name: "Weekey Rentals",
        latitude: 45.42483,
        longitude: 12.3276,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3276, 45.42483]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28075042,
        name: "CANNAREGIO THE REAL VENICE",
        host_id: 95232685,
        host_name: "Nicola",
        latitude: 45.44663,
        longitude: 12.32073,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32073, 45.44663]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28077021,
        name: "Luminosa e ampia zona Biennale-15 min da S Marco",
        host_id: 88661742,
        host_name: "Giulia",
        latitude: 45.43696,
        longitude: 12.346,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.346, 45.43696]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28078000,
        name: "Ampio appartamento in Campo Sant'Angelo",
        host_id: 19319769,
        host_name: "Riccardo",
        latitude: 45.43422,
        longitude: 12.33249,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33249, 45.43422]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28091656,
        name: "La tua stanza a Venezia 02.",
        host_id: 196163510,
        host_name: "Elvio",
        latitude: 45.43369,
        longitude: 12.31801,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31801, 45.43369]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28095591,
        name: "Frari Apartment with terrace",
        host_id: 203141373,
        host_name: "Lorenzo",
        latitude: 45.43592,
        longitude: 12.32885,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32885, 45.43592]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28121953,
        name: "Rio de la Fornace apartment",
        host_id: 16117448,
        host_name: "Antonina",
        latitude: 45.43062,
        longitude: 12.33235,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33235, 45.43062]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28124894,
        name: "NEW SOLE APARTMENT - CA' D'ORO RIALTO 4/6 GUESTS",
        host_id: 97583266,
        host_name: "Alessia",
        latitude: 45.44013,
        longitude: 12.33925,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33925, 45.44013]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28125365,
        name: "Appartamento Giardini alla Biennale",
        host_id: 212443330,
        host_name: "Roberto",
        latitude: 45.42993,
        longitude: 12.35691,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35691, 45.42993]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28126556,
        name: "Real Venice Experience - Appartamento Sant'Alvise",
        host_id: 46637416,
        host_name: "Lucilla",
        latitude: 45.44827,
        longitude: 12.32809,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32809, 45.44827]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28144974,
        name: "La Barena - Appartamento vacanze",
        host_id: 187610887,
        host_name: "Daniele",
        latitude: 45.43897,
        longitude: 12.33978,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33978, 45.43897]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28168626,
        name: "Domus Alba Apartment",
        host_id: 212763422,
        host_name: "Jessica",
        latitude: 45.43998,
        longitude: 12.3395,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3395, 45.43998]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28169157,
        name: "Ca' del Capitano",
        host_id: 3972291,
        host_name: "Caroline E Marco",
        latitude: 45.43534,
        longitude: 12.34811,
        beds: 8,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34811, 45.43534]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28172051,
        name: "SANTA GIUSTINA stunning flat close to the Biennale",
        host_id: 1438903,
        host_name: "Barbara",
        latitude: 45.43829,
        longitude: 12.34694,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34694, 45.43829]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28182580,
        name: "Very central large comfortable Casinò San Marcuola",
        host_id: 185612295,
        host_name: "Lory",
        latitude: 45.44395,
        longitude: 12.32784,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32784, 45.44395]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28191394,
        name: "Casanova Green Room in Centre Venice",
        host_id: 191226100,
        host_name: "Milo",
        latitude: 45.444,
        longitude: 12.3291,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3291, 45.444]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28192358,
        name: "Sant'Angelo G",
        host_id: 205196965,
        host_name: "Yourflat",
        latitude: 45.435,
        longitude: 12.33068,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33068, 45.435]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28208702,
        name: "Arsenale San Marco apartment",
        host_id: 147027860,
        host_name: "G.",
        latitude: 45.4358,
        longitude: 12.34695,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34695, 45.4358]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28211148,
        name: "The secret garden",
        host_id: 213083419,
        host_name: "Sebastiano - Federica",
        latitude: 45.44677,
        longitude: 12.32883,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32883, 45.44677]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28218964,
        name: "Mario Apartment 884",
        host_id: 10072655,
        host_name: "Mario Apartment",
        latitude: 45.4309,
        longitude: 12.35652,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35652, 45.4309]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28256258,
        name: "Appartamento con altana (roof terrace)",
        host_id: 9017175,
        host_name: "Andrea",
        latitude: 45.44156,
        longitude: 12.33801,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33801, 45.44156]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28274023,
        name: "Sestiere Dorsoduro, 2 steps from Ponte dei Pugni",
        host_id: 213535416,
        host_name: "Eleonora",
        latitude: 45.43427,
        longitude: 12.32531,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32531, 45.43427]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28275273,
        name: "San Vidal",
        host_id: 206380158,
        host_name: "Weekey Rentals",
        latitude: 45.4376,
        longitude: 12.32855,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32855, 45.4376]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28275275,
        name: "San Leonardo",
        host_id: 206380158,
        host_name: "Weekey Rentals",
        latitude: 45.44443,
        longitude: 12.32891,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32891, 45.44443]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28275362,
        name: "Venice Nido",
        host_id: 67159683,
        host_name: "Filippo",
        latitude: 45.44668,
        longitude: 12.31838,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31838, 45.44668]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28300442,
        name: "Ca'Nova, overlooking canal apartment",
        host_id: 213715147,
        host_name: "Rent In Venice",
        latitude: 45.44454,
        longitude: 12.33328,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33328, 45.44454]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28320570,
        name: "CaMargherite,  three rooms, private garden,Venice",
        host_id: 213865022,
        host_name: "Alessandro",
        latitude: 45.43551,
        longitude: 12.34869,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34869, 45.43551]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28324122,
        name: "Lovely home with patio and terrace!",
        host_id: 6019189,
        host_name: "Federico",
        latitude: 45.43022,
        longitude: 12.35528,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35528, 45.43022]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28339591,
        name:
          "A  SUNNY 1ST FLOOR VENETIAN HOUSE M (Phone number hidden by Airbnb)",
        host_id: 15497690,
        host_name: "Massimo",
        latitude: 45.44086,
        longitude: 12.33937,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33937, 45.44086]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28350257,
        name: "City center apartment Ca' dei Speci",
        host_id: 214062359,
        host_name: "Sarlux",
        latitude: 45.43633,
        longitude: 12.33817,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33817, 45.43633]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28350576,
        name: "San Marco Rio Dei Greci 3 bedrooms two bath 11 pax",
        host_id: 13012838,
        host_name: "Paola",
        latitude: 45.43704,
        longitude: 12.34777,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34777, 45.43704]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28351818,
        name: "City Center apartment  Ca' alle Gondolette",
        host_id: 214062359,
        host_name: "Sarlux",
        latitude: 45.43424,
        longitude: 12.33587,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33587, 45.43424]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28352967,
        name: "City Center Ca' del Mercato",
        host_id: 214062359,
        host_name: "Sarlux",
        latitude: 45.44028,
        longitude: 12.333,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.333, 45.44028]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28380919,
        name: "Loft Arsenale",
        host_id: 119918135,
        host_name: "Emanuele",
        latitude: 45.4373,
        longitude: 12.3457,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3457, 45.4373]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28398613,
        name: "Ca' Archi",
        host_id: 205703685,
        host_name: "Bricola",
        latitude: 45.43088,
        longitude: 12.35314,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35314, 45.43088]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28402099,
        name: "Appartamento A Venice",
        host_id: 214419905,
        host_name: "Marta",
        latitude: 45.44511,
        longitude: 12.32791,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32791, 45.44511]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28417084,
        name: "Casa ai Greci",
        host_id: 214545837,
        host_name: "Elisabetta",
        latitude: 45.43444,
        longitude: 12.33384,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33384, 45.43444]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28438681,
        name: "Ca' Corte San Rocco «» Charming garden",
        host_id: 214688315,
        host_name: "Claudia",
        latitude: 45.43771,
        longitude: 12.32528,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32528, 45.43771]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28452514,
        name: "Al Piano: only for lovers",
        host_id: 31578183,
        host_name: "Riccardo",
        latitude: 45.43385,
        longitude: 12.34666,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34666, 45.43385]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28455314,
        name: "Huge Flat in the Center, roof view",
        host_id: 76061063,
        host_name: "Carlotta",
        latitude: 45.4431,
        longitude: 12.32649,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32649, 45.4431]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28502404,
        name: "Una tipica casa sul canale",
        host_id: 9594397,
        host_name: "Davide",
        latitude: 45.44087,
        longitude: 12.33509,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33509, 45.44087]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28504396,
        name: "Giudecca outstanding view",
        host_id: 67406087,
        host_name: "Renato",
        latitude: 45.42832,
        longitude: 12.31886,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31886, 45.42832]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28505539,
        name: "Queen Victory",
        host_id: 215156155,
        host_name: "Monica",
        latitude: 45.43343,
        longitude: 12.33283,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33283, 45.43343]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28511036,
        name: "DOMUS BIENNALE modern apartment in Venice centre",
        host_id: 567508,
        host_name: "Nicola",
        latitude: 45.43208,
        longitude: 12.35671,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35671, 45.43208]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28514416,
        name: "Rialto appartment top floor IN CENTRE",
        host_id: 13500918,
        host_name: "Mark",
        latitude: 45.43659,
        longitude: 12.33642,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33642, 45.43659]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28515455,
        name: "Biennale Giardini",
        host_id: 105704488,
        host_name: "Sara",
        latitude: 45.43313,
        longitude: 12.35441,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35441, 45.43313]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28515456,
        name: "Garibaldi Biennale",
        host_id: 105704488,
        host_name: "Sara",
        latitude: 45.43165,
        longitude: 12.35622,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35622, 45.43165]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28515460,
        name: "Ca' coltrera",
        host_id: 105704488,
        host_name: "Sara",
        latitude: 45.43205,
        longitude: 12.35272,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35272, 45.43205]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28515461,
        name: "Beautiful Venice",
        host_id: 105704488,
        host_name: "Sara",
        latitude: 45.43664,
        longitude: 12.33747,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33747, 45.43664]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28515462,
        name: "Terrazza Rialto",
        host_id: 105704488,
        host_name: "Sara",
        latitude: 45.43885,
        longitude: 12.33517,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33517, 45.43885]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28515463,
        name: "Romantic Rialto",
        host_id: 105704488,
        host_name: "Sara",
        latitude: 45.43891,
        longitude: 12.3355,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3355, 45.43891]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28515464,
        name: "Ca' Neldo",
        host_id: 105704488,
        host_name: "Sara",
        latitude: 45.43199,
        longitude: 12.351,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.351, 45.43199]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28515466,
        name: "Ca' Sansoni",
        host_id: 105704488,
        host_name: "Sara",
        latitude: 45.43971,
        longitude: 12.33374,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33374, 45.43971]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28515467,
        name: "Tiepolo apartment",
        host_id: 105704488,
        host_name: "Sara",
        latitude: 45.43075,
        longitude: 12.35594,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35594, 45.43075]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28515468,
        name: "Ca' Melissa",
        host_id: 105704488,
        host_name: "Sara",
        latitude: 45.43267,
        longitude: 12.35098,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35098, 45.43267]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28518319,
        name: "Casa Cricca Venice 5min from Rialto vintage studio",
        host_id: 19032923,
        host_name: "Cristiana",
        latitude: 45.43763,
        longitude: 12.33205,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33205, 45.43763]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28533740,
        name: "White Tulip apartment with lovely canal view",
        host_id: 215351057,
        host_name: "Daniela",
        latitude: 45.43373,
        longitude: 12.33302,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33302, 45.43373]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28554203,
        name: "Large Apartment near San Marco Square",
        host_id: 191226100,
        host_name: "Milo",
        latitude: 45.43683,
        longitude: 12.33642,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33642, 45.43683]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28561525,
        name: "Deluxe Apartment with Canal View",
        host_id: 21094861,
        host_name: "Alberto",
        latitude: 45.44243,
        longitude: 12.33191,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33191, 45.44243]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28562479,
        name: "Stunning Studio in heart of Cannaregio",
        host_id: 21094861,
        host_name: "Alberto",
        latitude: 45.44187,
        longitude: 12.33214,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33214, 45.44187]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28594104,
        name: "Cà Mocenigo Suite",
        host_id: 215806409,
        host_name: "Emanuele",
        latitude: 45.44046,
        longitude: 12.33034,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33034, 45.44046]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28609579,
        name: "Intero appartamento  con ampia terrazza",
        host_id: 169979425,
        host_name: "Sokol E Caterina",
        latitude: 45.43831,
        longitude: 12.34342,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34342, 45.43831]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28629026,
        name: "CA SAN POLO CLOSE TO RIALTO  FISH MARKET",
        host_id: 141121267,
        host_name: "Paola",
        latitude: 45.43957,
        longitude: 12.32961,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32961, 45.43957]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28636522,
        name: "CHRISTMAS & S MARK Family Apt sleeps11 bath3",
        host_id: 116487780,
        host_name: "Federica",
        latitude: 45.43412,
        longitude: 12.34413,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34413, 45.43412]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28651228,
        name: "Cannaregio on the Canal quiet apartment -X504",
        host_id: 15178567,
        host_name: "Paolo",
        latitude: 45.44623,
        longitude: 12.32733,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32733, 45.44623]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28656172,
        name: "St.-Mark's Central by the Bauer - serviced 1BR apt",
        host_id: 510349,
        host_name: "Roberta",
        latitude: 45.43188,
        longitude: 12.33506,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33506, 45.43188]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28675545,
        name: "TINTORETTO VISTA, NUOVO, VERO CENTRO STORICO",
        host_id: 190388209,
        host_name: "Pietro",
        latitude: 45.44414,
        longitude: 12.33214,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33214, 45.44414]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28683675,
        name: "Tower Bridge Of Sighs",
        host_id: 160440981,
        host_name: "Ilaria",
        latitude: 45.43598,
        longitude: 12.34202,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34202, 45.43598]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28687325,
        name: "Bright and comfortable penthouse with 2 bedrooms",
        host_id: 289615,
        host_name: "Valentina",
        latitude: 45.44174,
        longitude: 12.32169,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32169, 45.44174]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28693647,
        name: "Minicasa A Venezia",
        host_id: 131261322,
        host_name: "Luca",
        latitude: 45.44079,
        longitude: 12.33072,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33072, 45.44079]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28706771,
        name: "Secret Loft, with a cozy terrace and amazing view",
        host_id: 216544982,
        host_name: "Secret",
        latitude: 45.43556,
        longitude: 12.32414,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32414, 45.43556]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28711981,
        name: "OPEN SPACE fra architettura e pittura a Venezia",
        host_id: 11869382,
        host_name: "Arianna",
        latitude: 45.43576,
        longitude: 12.34348,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34348, 45.43576]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28727694,
        name: "Modern Apartment in the centre of Venice",
        host_id: 72146639,
        host_name: "Alex",
        latitude: 45.43371,
        longitude: 12.33028,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33028, 45.43371]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28757696,
        name: "Ca' Martinengo de le Pale",
        host_id: 216916937,
        host_name: "Francesco",
        latitude: 45.43778,
        longitude: 12.34,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34, 45.43778]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28767644,
        name: "Luxury Apartment 4 People, near St. Mark's Square",
        host_id: 69921858,
        host_name: "Corte Nova S.R.L",
        latitude: 45.43726,
        longitude: 12.34579,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34579, 45.43726]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28771262,
        name: "Luxury residence laguna - Biennale area",
        host_id: 289615,
        host_name: "Valentina",
        latitude: 45.43253,
        longitude: 12.35685,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35685, 45.43253]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28772380,
        name: "Suite Campo Santa Fosca 2, Private Room Canal View",
        host_id: 217027766,
        host_name: "Adelina",
        latitude: 45.44394,
        longitude: 12.33272,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33272, 45.44394]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28799045,
        name: "Charmy Venice Italy",
        host_id: 217178413,
        host_name: "Andrea",
        latitude: 45.43998,
        longitude: 12.3442,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3442, 45.43998]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28809016,
        name: "Bella Venezia 独立单人间",
        host_id: 21885006,
        host_name: "Lisa",
        latitude: 45.44697,
        longitude: 12.31947,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31947, 45.44697]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28820537,
        name: "Il Mezzanino di Palazzo Torniello",
        host_id: 46914920,
        host_name: "Andrea",
        latitude: 45.44405,
        longitude: 12.33094,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33094, 45.44405]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28820932,
        name: "Attic Room @ Locanda Antico Fiore",
        host_id: 3060084,
        host_name: "Giacomo",
        latitude: 45.43478,
        longitude: 12.32933,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32933, 45.43478]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28835509,
        name: "Venetian Mood: Earth Sky",
        host_id: 3549494,
        host_name: "Manuela",
        latitude: 45.4341,
        longitude: 12.35668,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35668, 45.4341]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28848895,
        name: "Sun Room - Double room with private bath. + AC",
        host_id: 18151381,
        host_name: "Fran",
        latitude: 45.44529,
        longitude: 12.32829,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32829, 45.44529]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28854074,
        name: "Suite Campo Santa Fosca 3, Private Room Canal View",
        host_id: 217027766,
        host_name: "Adelina",
        latitude: 45.44271,
        longitude: 12.33158,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33158, 45.44271]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28857367,
        name: "Moon Room - Double room + Private Bath+Air Con",
        host_id: 18151381,
        host_name: "Fran",
        latitude: 45.44696,
        longitude: 12.32797,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32797, 45.44696]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28858662,
        name: "Suite Campo Santa Fosca 1, Private Room Canal View",
        host_id: 217027766,
        host_name: "Adelina",
        latitude: 45.44453,
        longitude: 12.33258,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33258, 45.44453]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28859548,
        name: "Suite Campo Santa Fosca 4, Private Room Canal View",
        host_id: 217027766,
        host_name: "Adelina",
        latitude: 45.44252,
        longitude: 12.33251,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33251, 45.44252]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28888340,
        name: "Bridge of sights suite - 1 minute from San Marco!",
        host_id: 73934712,
        host_name: "Tour Apartments",
        latitude: 45.4361,
        longitude: 12.3422,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3422, 45.4361]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28928213,
        name: '"NOBLESSE OBLIGE", canal view, elevator, style!',
        host_id: 7167809,
        host_name: "Alessia",
        latitude: 45.44004,
        longitude: 12.33973,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33973, 45.44004]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28958366,
        name: "TOLENTINI CANAL VIEW APARTMENT",
        host_id: 95232685,
        host_name: "Nicola",
        latitude: 45.43782,
        longitude: 12.32046,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32046, 45.43782]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28975352,
        name: "Camera Gianluca",
        host_id: 218382241,
        host_name: "Gianluca",
        latitude: 45.44071,
        longitude: 12.32808,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32808, 45.44071]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28976565,
        name: "Camera Hemingway",
        host_id: 218382241,
        host_name: "Gianluca",
        latitude: 45.43976,
        longitude: 12.32823,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32823, 45.43976]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28978029,
        name: "Casa Fedora dependance Luxury - G",
        host_id: 63194257,
        host_name: "Edoardo",
        latitude: 45.43944,
        longitude: 12.34216,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34216, 45.43944]] },
    },
    {
      type: "Feature",
      properties: {
        id: 28994517,
        name: "Camera Rialto",
        host_id: 218382241,
        host_name: "Gianluca",
        latitude: 45.43954,
        longitude: 12.32809,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32809, 45.43954]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29022618,
        name: "Ca' De Stefano",
        host_id: 46904188,
        host_name: "Mirco Optyflat",
        latitude: 45.44652,
        longitude: 12.32941,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32941, 45.44652]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29023256,
        name: "Amorucci House",
        host_id: 46904188,
        host_name: "Mirco Optyflat",
        latitude: 45.44497,
        longitude: 12.33145,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33145, 45.44497]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29028510,
        name: "Ca' Molin Cuoridoro - Massari",
        host_id: 3972291,
        host_name: "Caroline E Marco",
        latitude: 45.43556,
        longitude: 12.33573,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33573, 45.43556]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29028696,
        name: "Ca' Molin Cuoridoro - Guarana",
        host_id: 3972291,
        host_name: "Caroline E Marco",
        latitude: 45.43391,
        longitude: 12.33399,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33399, 45.43391]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29028873,
        name: "Palazzo Molin Cuoridoro-Tiziano",
        host_id: 3972291,
        host_name: "Caroline E Marco",
        latitude: 45.43351,
        longitude: 12.33577,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33577, 45.43351]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29029184,
        name: "BELLISSIMO APPARTAMENTO NEL CUORE DELLA CITTA'",
        host_id: 113703606,
        host_name: "Chiara",
        latitude: 45.43709,
        longitude: 12.33948,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33948, 45.43709]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29049729,
        name: "Romantic apartment with terrace in heath of Venice",
        host_id: 35686899,
        host_name: "Helene",
        latitude: 45.43449,
        longitude: 12.34858,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34858, 45.43449]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29052589,
        name: "Sammy's Central",
        host_id: 174418896,
        host_name: "Mimax",
        latitude: 45.43486,
        longitude: 12.33777,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33777, 45.43486]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29053977,
        name: "Cà Bellato canal view",
        host_id: 38623763,
        host_name: "Elisabetta",
        latitude: 45.43812,
        longitude: 12.33171,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33171, 45.43812]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29054990,
        name: "A family flat in Rialto",
        host_id: 5602851,
        host_name: "Francesco",
        latitude: 45.43965,
        longitude: 12.33359,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33359, 45.43965]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29072174,
        name: "Cà Paradiso",
        host_id: 188112161,
        host_name: "Enrico",
        latitude: 45.439,
        longitude: 12.33323,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33323, 45.439]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29072193,
        name: "Succombez au charme d'un palazzo classé du XVe siècle",
        host_id: 15337957,
        host_name: "Marie",
        latitude: 45.43406,
        longitude: 12.33122,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33122, 45.43406]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29072377,
        name: "Flat 1 minute from the nicest square of the world",
        host_id: 16705466,
        host_name: "Nikos",
        latitude: 45.43439,
        longitude: 12.34119,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34119, 45.43439]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29072665,
        name: "S & L House with Canal view",
        host_id: 46904188,
        host_name: "Mirco Optyflat",
        latitude: 45.43352,
        longitude: 12.32518,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32518, 45.43352]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29075590,
        name: "BIENNALE & S. MARK brand new apt 6PAX 2BATH",
        host_id: 92120331,
        host_name: "Snh",
        latitude: 45.43475,
        longitude: 12.34572,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34572, 45.43475]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29080015,
        name: "MODERN FLATS IN SAN MARCO 1",
        host_id: 401113,
        host_name: "Elia",
        latitude: 45.4369,
        longitude: 12.335,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.335, 45.4369]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29093366,
        name: "Rialto, Cozy & Charming Venetian Apartment!",
        host_id: 218260862,
        host_name: "Alessio",
        latitude: 45.44064,
        longitude: 12.33221,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33221, 45.44064]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29100670,
        name: "Cozy apartment close to Biennale of Venice",
        host_id: 219291944,
        host_name: "Lila",
        latitude: 45.43004,
        longitude: 12.35947,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35947, 45.43004]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29114942,
        name: "Corner of Paradise - Venice / Venezia",
        host_id: 9183768,
        host_name: "Mario",
        latitude: 45.44215,
        longitude: 12.33036,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33036, 45.44215]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29118704,
        name: "ELSA charming flat close to Rialto Bridge!",
        host_id: 1438903,
        host_name: "Barbara",
        latitude: 45.43842,
        longitude: 12.33338,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33338, 45.43842]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29144881,
        name: "PALAZZO MOROSINI BRANDOLIN  Romantic Apartment",
        host_id: 219611328,
        host_name: "Roberto",
        latitude: 45.43959,
        longitude: 12.332,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.332, 45.43959]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29147428,
        name: "Casa Fedora dependance superior - P",
        host_id: 63194257,
        host_name: "Edoardo",
        latitude: 45.43718,
        longitude: 12.34033,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34033, 45.43718]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29167811,
        name: "Casa della Musica",
        host_id: 219794287,
        host_name: "Luca",
        latitude: 45.44653,
        longitude: 12.3216,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3216, 45.44653]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29171426,
        name: "Mind-blowing view from the 5th highest ℛooftop",
        host_id: 219813748,
        host_name: "Barbara",
        latitude: 45.43599,
        longitude: 12.34008,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34008, 45.43599]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29176552,
        name: "Near BIENNALE & St.Mark's Sq cosy flat WI-FI",
        host_id: 219848114,
        host_name: "Alvise",
        latitude: 45.43648,
        longitude: 12.34812,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34812, 45.43648]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29179456,
        name: "Sant'Angelo P",
        host_id: 205196965,
        host_name: "Yourflat",
        latitude: 45.43486,
        longitude: 12.33085,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33085, 45.43486]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29198645,
        name: "The perfect double room in Venice + private bath",
        host_id: 18151381,
        host_name: "Fran",
        latitude: 45.44492,
        longitude: 12.32798,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32798, 45.44492]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29200429,
        name: "Dorsoduro 232",
        host_id: 91636027,
        host_name: "Donatella",
        latitude: 45.43099,
        longitude: 12.33286,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33286, 45.43099]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29207534,
        name: "Ca' Via Della Seta",
        host_id: 669047,
        host_name: "Viewsonvenice",
        latitude: 45.43265,
        longitude: 12.33459,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33459, 45.43265]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29208463,
        name: "Cruise Studio IP (Phone number hidden by Airbnb)",
        host_id: 15005402,
        host_name: "Veronica",
        latitude: 45.43123,
        longitude: 12.32213,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32213, 45.43123]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29212933,
        name: "RESIDENCE SANTA CROCE",
        host_id: 66497599,
        host_name: "Constantin",
        latitude: 45.43616,
        longitude: 12.32372,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32372, 45.43616]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29255439,
        name: "Susy Biennale Apartment -canal view and gardens",
        host_id: 220407915,
        host_name: "Susanna",
        latitude: 45.43094,
        longitude: 12.35745,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35745, 45.43094]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29258353,
        name: "Ca' dei Nizioleti",
        host_id: 146847079,
        host_name: "Georgia",
        latitude: 45.44157,
        longitude: 12.33999,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33999, 45.44157]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29274894,
        name: "come a casa tua dietro Piazza San Marco",
        host_id: 174569424,
        host_name: "Annita",
        latitude: 45.43737,
        longitude: 12.34193,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34193, 45.43737]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29296827,
        name: "SMART HOLIDAY",
        host_id: 220696036,
        host_name: "Jakob",
        latitude: 45.44482,
        longitude: 12.33035,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33035, 45.44482]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29302422,
        name: "Ve-nice Suite Rialto view RT-12",
        host_id: 22423242,
        host_name: "Stefano",
        latitude: 45.43865,
        longitude: 12.33338,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33338, 45.43865]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29303449,
        name:
          "Venice Biennale Large Apartment M (Phone number hidden by Airbnb)",
        host_id: 7355755,
        host_name: "Sonia",
        latitude: 45.43186,
        longitude: 12.35717,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35717, 45.43186]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29305588,
        name: "Economy Double Shared Bathroom - Venice Center",
        host_id: 25022476,
        host_name: "Antonio",
        latitude: 45.44055,
        longitude: 12.3314,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3314, 45.44055]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29305592,
        name: "Economy Double Shared Bathroom - Venice Center",
        host_id: 25022476,
        host_name: "Antonio",
        latitude: 45.44059,
        longitude: 12.33166,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33166, 45.44059]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29305593,
        name: "Double Shared Bathroom - Venice Center",
        host_id: 25022476,
        host_name: "Antonio",
        latitude: 45.44029,
        longitude: 12.33051,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33051, 45.44029]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29306183,
        name: "Condominio a Venezia Vicino alla Stazione, Comodo",
        host_id: 207719785,
        host_name: "Davide",
        latitude: 45.44445,
        longitude: 12.3235,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3235, 45.44445]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29321591,
        name: "Residence Cavalletti in Cannaregio / 2 apartments",
        host_id: 289615,
        host_name: "Valentina",
        latitude: 45.44354,
        longitude: 12.32048,
        beds: 10,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32048, 45.44354]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29326766,
        name: "5-bedroom accommodation train station",
        host_id: 6174080,
        host_name: "Nello",
        latitude: 45.4378,
        longitude: 12.32363,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32363, 45.4378]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29346336,
        name: "THE LOVE HUT IN VENICE BY SANTA LUCIA STATION",
        host_id: 220670299,
        host_name: "Enrico",
        latitude: 45.44299,
        longitude: 12.32236,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32236, 45.44299]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29346806,
        name: "SUNNY NEST CANAL VIEW IN VENICE CHIC MOVIDA",
        host_id: 220672276,
        host_name: "Fulvio",
        latitude: 45.4461,
        longitude: 12.32216,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32216, 45.4461]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29346879,
        name: "Vivi Venezia appartamento",
        host_id: 220718338,
        host_name: "Stefano",
        latitude: 45.43263,
        longitude: 12.35213,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35213, 45.43263]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29352576,
        name: "Soggiorno in antica Torre Veneziana del VIII",
        host_id: 177480920,
        host_name: "Hotel Santo Stefano",
        latitude: 45.43467,
        longitude: 12.33112,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33112, 45.43467]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29355454,
        name: "Ca' del Ramo D'oro",
        host_id: 3972291,
        host_name: "Caroline E Marco",
        latitude: 45.4371,
        longitude: 12.34403,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34403, 45.4371]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29380959,
        name: "Quadruple Room",
        host_id: 160412579,
        host_name: "Emanuele",
        latitude: 45.43464,
        longitude: 12.33532,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33532, 45.43464]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29410643,
        name: "appartamento da 1 a 4 persone Giazzo",
        host_id: 221545927,
        host_name: "Camilla",
        latitude: 45.4375,
        longitude: 12.33865,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33865, 45.4375]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29411584,
        name: "B&B CA’DOR CENTER VENICE",
        host_id: 152285589,
        host_name: "Nicola",
        latitude: 45.44026,
        longitude: 12.33657,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33657, 45.44026]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29425943,
        name: "Comfortable apartment near St.Mark’s square",
        host_id: 15490832,
        host_name: "Emili",
        latitude: 45.43486,
        longitude: 12.32398,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32398, 45.43486]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29432318,
        name: "SANSONI PALACE - CANAL VIEW",
        host_id: 221701611,
        host_name: "Erika E Cristian",
        latitude: 45.43993,
        longitude: 12.33187,
        beds: 7,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33187, 45.43993]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29440020,
        name: "IL GIGLIO San Marco Luxury Apartment/Amazing View",
        host_id: 211445256,
        host_name: "Paola",
        latitude: 45.43201,
        longitude: 12.33351,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33351, 45.43201]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29445862,
        name: "Apartameto Paola Ca'd'Oro",
        host_id: 219025530,
        host_name: "Jacek",
        latitude: 45.44228,
        longitude: 12.33376,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33376, 45.44228]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29452600,
        name: "Lovely apartment behind Piazza San Marco",
        host_id: 221846090,
        host_name: "Giovanni E Elisabetta",
        latitude: 45.43531,
        longitude: 12.34195,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34195, 45.43531]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29453913,
        name: "Sant'Agostin Apartment",
        host_id: 156216830,
        host_name: "Pietro",
        latitude: 45.43819,
        longitude: 12.32865,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32865, 45.43819]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29473377,
        name: "Apt. Zen Canal View (600m from Rialto's Bridge)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.44258,
        longitude: 12.3371,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3371, 45.44258]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29474922,
        name: "LRM Guest House in Venice Lagoon",
        host_id: 221996161,
        host_name: "Peter",
        latitude: 45.43914,
        longitude: 12.33196,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33196, 45.43914]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29481103,
        name: "RESIDENZA QUADRI",
        host_id: 3736168,
        host_name: "EasyRentals",
        latitude: 45.4343920797794,
        longitude: 12.338953573544488,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33895, 45.43439]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29481316,
        name: "Appartamento tipico con corte privata",
        host_id: 35297989,
        host_name: "Francesca",
        latitude: 45.44034,
        longitude: 12.32719,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32719, 45.44034]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29501265,
        name: "Apartment Rossini (250m from Rialto's Bridge)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.43912,
        longitude: 12.33337,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33337, 45.43912]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29509338,
        name: "Guglie Tower Suite",
        host_id: 107010081,
        host_name: "Vanessa",
        latitude: 45.4453,
        longitude: 12.32227,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32227, 45.4453]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29510973,
        name: "Luxury Garden Mansion R&R",
        host_id: 173200514,
        host_name: "Rent&Relax",
        latitude: 45.43376,
        longitude: 12.3171,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3171, 45.43376]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29528444,
        name: "STUPENDO APPARTAMENTO  GIUDECCA",
        host_id: 113703606,
        host_name: "Chiara",
        latitude: 45.42458,
        longitude: 12.33123,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33123, 45.42458]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29529017,
        name: "Suite Jacuzzi in a 15th century palace",
        host_id: 91945371,
        host_name: "Davide",
        latitude: 45.43856,
        longitude: 12.34382,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34382, 45.43856]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29530142,
        name: "Venice Center for 7 pax",
        host_id: 118683310,
        host_name: "Elisa Sara",
        latitude: 45.44157,
        longitude: 12.34129,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34129, 45.44157]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29532305,
        name: "Large room for young travelers",
        host_id: 222375139,
        host_name: "Andrea",
        latitude: 45.44288,
        longitude: 12.32449,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32449, 45.44288]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29537731,
        name: "Industrial Loft Venice R&R",
        host_id: 173200514,
        host_name: "Rent&Relax",
        latitude: 45.43356,
        longitude: 12.35646,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35646, 45.43356]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29552142,
        name: "Cabina in catamarano a Venezia | B&B Venezia",
        host_id: 222501704,
        host_name: "Paul",
        latitude: 45.42614,
        longitude: 12.36487,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.36487, 45.42614]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29553991,
        name: "Venezia Sogno",
        host_id: 151498300,
        host_name: "Valentina",
        latitude: 45.44303,
        longitude: 12.33874,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33874, 45.44303]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29557936,
        name: "Apartment Foscolo (Venice Historical Centre)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.43613,
        longitude: 12.34655,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34655, 45.43613]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29559420,
        name: "Miracoli Terrace (300mt from Rialto's Bridge)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.43975,
        longitude: 12.33814,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33814, 45.43975]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29567359,
        name: "Appartamento La Forcola Venezia",
        host_id: 21729800,
        host_name: "Francesco",
        latitude: 45.43663,
        longitude: 12.34852,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34852, 45.43663]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29602248,
        name: "Loft Blenner, close to Rialto bridge",
        host_id: 222820121,
        host_name: "Tiziana",
        latitude: 45.44025,
        longitude: 12.33827,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33827, 45.44025]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29617455,
        name: "Ca' Tronconi ai Frari",
        host_id: 172443280,
        host_name: "Monica",
        latitude: 45.43625,
        longitude: 12.3281,
        beds: 7,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3281, 45.43625]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29618043,
        name: "Lovo",
        host_id: 174418896,
        host_name: "Mimax",
        latitude: 45.43653,
        longitude: 12.33557,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33557, 45.43653]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29620022,
        name: "Romantic independent house - view of the Canal",
        host_id: 222956338,
        host_name: "Elena",
        latitude: 45.44679,
        longitude: 12.32076,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32076, 45.44679]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29620857,
        name: "Fontego",
        host_id: 174418896,
        host_name: "Mimax",
        latitude: 45.43735,
        longitude: 12.3359,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3359, 45.43735]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29640692,
        name: "BIENNALE & S. MARK terrace apt TOP LOCATION!",
        host_id: 220738219,
        host_name: "Tim",
        latitude: 45.43597,
        longitude: 12.34553,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34553, 45.43597]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29646046,
        name: "Rialto Comfy",
        host_id: 174418896,
        host_name: "Mimax",
        latitude: 45.43741,
        longitude: 12.33559,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33559, 45.43741]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29653398,
        name: "Double Room near Giardini (Biennale)",
        host_id: 11966215,
        host_name: "Ginevra",
        latitude: 45.43095,
        longitude: 12.35395,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35395, 45.43095]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29691114,
        name: "Palazzetto Cavalli nel cuore della città",
        host_id: 177998145,
        host_name: "Alessandra",
        latitude: 45.43671,
        longitude: 12.32959,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32959, 45.43671]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29695866,
        name: "Residenza Sara",
        host_id: 57249358,
        host_name: "Roberta",
        latitude: 45.43396,
        longitude: 12.32376,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32376, 45.43396]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29700214,
        name: "Carmini Palace Canal View",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.43239,
        longitude: 12.32138,
        beds: 7,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32138, 45.43239]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29707544,
        name: 'S. Tomà - Camera "Sardea"',
        host_id: 84543765,
        host_name: "Maurizio&Francesca",
        latitude: 45.43595,
        longitude: 12.32711,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32711, 45.43595]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29740041,
        name: "Rialto Mercato Melusina apartment 3",
        host_id: 9017175,
        host_name: "Andrea",
        latitude: 45.43855,
        longitude: 12.33448,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33448, 45.43855]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29751297,
        name: "elegant apartment on the canal",
        host_id: 223806870,
        host_name: "Michele",
        latitude: 45.43186,
        longitude: 12.31679,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31679, 45.43186]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29752258,
        name: "PALAZZETTO CAVALLI - WHITE ROOM on the canal",
        host_id: 177998145,
        host_name: "Alessandra",
        latitude: 45.43816,
        longitude: 12.33047,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33047, 45.43816]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29758828,
        name: "AL PICCOLO MORO -  vic.ze Ca D' Oro",
        host_id: 7672609,
        host_name: "Gian Luigi & Nicola",
        latitude: 45.4428,
        longitude: 12.33473,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33473, 45.4428]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29759316,
        name: "TETTI Apartment only 5 Minutes from St Mark's Square",
        host_id: 223894432,
        host_name: "Guido",
        latitude: 45.43703,
        longitude: 12.34552,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34552, 45.43703]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29767649,
        name: "PALAZZETTO CAVALLI- ORANGE ROOM view on the canal",
        host_id: 177998145,
        host_name: "Alessandra",
        latitude: 45.43851,
        longitude: 12.33155,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33155, 45.43851]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29773829,
        name: "Rialto Mercato Melusina Apartment 4",
        host_id: 9017175,
        host_name: "Andrea",
        latitude: 45.43891,
        longitude: 12.33135,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33135, 45.43891]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29774356,
        name: "House of Joy. Luxury Home. Great for Families!",
        host_id: 31967058,
        host_name: "Gioia",
        latitude: 45.43245,
        longitude: 12.32379,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32379, 45.43245]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29774699,
        name: "Rialto Mercato Melusina Apartment 5",
        host_id: 9017175,
        host_name: "Andrea",
        latitude: 45.43846,
        longitude: 12.33106,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33106, 45.43846]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29810262,
        name: "TINTORETTO 6 ATTIC ON SQUARE",
        host_id: 103640525,
        host_name: "Team",
        latitude: 45.44419,
        longitude: 12.32999,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32999, 45.44419]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29815301,
        name: '"Terrace" Apartment 2pax, near St\'Mark Square',
        host_id: 69921858,
        host_name: "Corte Nova S.R.L",
        latitude: 45.43646,
        longitude: 12.34674,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34674, 45.43646]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29821983,
        name: "Ca' della Chiesa in Dorsoduro, Fine Arts district",
        host_id: 12113015,
        host_name: "Mario",
        latitude: 45.42987,
        longitude: 12.33163,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33163, 45.42987]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29827621,
        name: "Ca' Salicornia - Camera “Crevan”",
        host_id: 84543765,
        host_name: "Maurizio&Francesca",
        latitude: 45.43761,
        longitude: 12.34191,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34191, 45.43761]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29841928,
        name: "Casa Luminosa",
        host_id: 3972291,
        host_name: "Caroline E Marco",
        latitude: 45.42929,
        longitude: 12.33091,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33091, 45.42929]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29842075,
        name:
          "Cozy Quiet Venice Guglie Apartment M (Phone number hidden by Airbnb)",
        host_id: 224446903,
        host_name: "Stefano & Pinuccia",
        latitude: 45.44587,
        longitude: 12.32492,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32492, 45.44587]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29844365,
        name: "Ca' Elvira for 2 Guests with Terrace",
        host_id: 669047,
        host_name: "Viewsonvenice",
        latitude: 45.43259,
        longitude: 12.3212,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3212, 45.43259]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29845859,
        name: "a casetta di max",
        host_id: 14529918,
        host_name: "Massimiliano",
        latitude: 45.43653,
        longitude: 12.33149,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33149, 45.43653]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29864694,
        name: "Top class apt close to Piazza San Marco",
        host_id: 83913089,
        host_name: "A.H.C. Dario & Giovanna",
        latitude: 45.43347,
        longitude: 12.33398,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33398, 45.43347]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29868433,
        name: "Cà Robberstad - Luminous, modern, quiet - Rialto",
        host_id: 105720813,
        host_name: "Loredana",
        latitude: 45.44151,
        longitude: 12.33466,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33466, 45.44151]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29875942,
        name: "Casa Michiel nella viva Venezia",
        host_id: 224668654,
        host_name: "Federico E Giovanna",
        latitude: 45.44405,
        longitude: 12.3327,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3327, 45.44405]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29894862,
        name: "Quadruple Room Private Bathroom @ MaisonSanMarco",
        host_id: 224793696,
        host_name: "Claudio",
        latitude: 45.43445,
        longitude: 12.33181,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33181, 45.43445]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29895700,
        name: "Junior suite canal view @ MaisonSanMarco",
        host_id: 224793696,
        host_name: "Claudio",
        latitude: 45.43452,
        longitude: 12.33146,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33146, 45.43452]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29896700,
        name: "le gondole",
        host_id: 224805962,
        host_name: "Elisabetta",
        latitude: 45.4364,
        longitude: 12.32625,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32625, 45.4364]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29896912,
        name: "Cozy Apartment next to Biennale",
        host_id: 43945952,
        host_name: "Arben",
        latitude: 45.43319,
        longitude: 12.35413,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35413, 45.43319]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29900809,
        name: "Double Room with Private Bathroom @ MaisonSanMarco",
        host_id: 224793696,
        host_name: "Claudio",
        latitude: 45.43466,
        longitude: 12.33295,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33295, 45.43466]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29912766,
        name: "Ca' Accademia with Amazing Terrace",
        host_id: 669047,
        host_name: "Viewsonvenice",
        latitude: 45.43311,
        longitude: 12.32704,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32704, 45.43311]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29914882,
        name: "Studio privato con giardino.Fondamente nuove",
        host_id: 18942651,
        host_name: "Marjolaine",
        latitude: 45.44346,
        longitude: 12.32453,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32453, 45.44346]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29940846,
        name: "Comfy and Romantic Apartment with Panoramic Rooftop Views",
        host_id: 223894432,
        host_name: "Guido",
        latitude: 45.43532,
        longitude: 12.3467,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3467, 45.43532]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29952324,
        name: "San Marco Melusina Apartment",
        host_id: 9017175,
        host_name: "Andrea",
        latitude: 45.43401,
        longitude: 12.33534,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33534, 45.43401]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29973848,
        name: "Campiello Chiesa, Venezia",
        host_id: 12182373,
        host_name: "Luca",
        latitude: 45.43882,
        longitude: 12.32909,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32909, 45.43882]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29979715,
        name: "Ca' Vittoria, a different way to stay in Venice...",
        host_id: 12113015,
        host_name: "Mario",
        latitude: 45.43417,
        longitude: 12.3355,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3355, 45.43417]] },
    },
    {
      type: "Feature",
      properties: {
        id: 29985279,
        name: "Apartment/house Mazzoni",
        host_id: 143873157,
        host_name: "Federico",
        latitude: 45.44256,
        longitude: 12.3207,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3207, 45.44256]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30033005,
        name: "Cozy Room in the Heart of Historical Centre",
        host_id: 85797403,
        host_name: "Ilaria",
        latitude: 45.43775,
        longitude: 12.34464,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34464, 45.43775]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30033139,
        name: "Ca' Bellotto",
        host_id: 225723764,
        host_name: "Lorenzo",
        latitude: 45.44792,
        longitude: 12.3289,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3289, 45.44792]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30036447,
        name: "Five Valle Biennale",
        host_id: 224599093,
        host_name: "Sara",
        latitude: 45.43329,
        longitude: 12.36083,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.36083, 45.43329]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30039299,
        name: "Venice Calle Nuova, Biennale, Arsenale",
        host_id: 139627704,
        host_name: "Giusy & Fabrizio",
        latitude: 45.43386,
        longitude: 12.35391,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35391, 45.43386]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30060832,
        name: "Appartamento a Venezia nel Ghetto Ebraico",
        host_id: 129835471,
        host_name: "Nicoletta",
        latitude: 45.44328,
        longitude: 12.32561,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32561, 45.44328]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30067616,
        name: "Watch the Gondolas Float by from a Canal-View Pad",
        host_id: 225954590,
        host_name: "Carla",
        latitude: 45.44216,
        longitude: 12.33131,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33131, 45.44216]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30075622,
        name: "Mario Apartment  2578",
        host_id: 10072655,
        host_name: "Mario Apartment",
        latitude: 45.43563,
        longitude: 12.34962,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34962, 45.43563]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30076812,
        name: "Ca Zianini",
        host_id: 6759756,
        host_name: "Rudi",
        latitude: 45.43555,
        longitude: 12.34656,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34656, 45.43555]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30078293,
        name: "Cozy new apartment on gran canal",
        host_id: 73934712,
        host_name: "Tour Apartments",
        latitude: 45.44012,
        longitude: 12.32486,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32486, 45.44012]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30078544,
        name: "Private stunning views on venice",
        host_id: 73934712,
        host_name: "Tour Apartments",
        latitude: 45.44108,
        longitude: 12.32653,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32653, 45.44108]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30079401,
        name: "Apartment with a view in Rialto area",
        host_id: 226026079,
        host_name: "Salvatore",
        latitude: 45.44087,
        longitude: 12.33058,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33058, 45.44087]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30102306,
        name: "Residenza Emilia - free Wifi near S. Marco square",
        host_id: 53941305,
        host_name: "Francesco",
        latitude: 45.44201,
        longitude: 12.3406,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3406, 45.44201]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30116842,
        name: "Ca’ Corte Bonazza",
        host_id: 226296831,
        host_name: "Michela",
        latitude: 45.43392,
        longitude: 12.32161,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32161, 45.43392]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30118397,
        name: "Séjour au coeur du quartier artistique de Venise",
        host_id: 19881854,
        host_name: "Francesca",
        latitude: 45.42957,
        longitude: 12.32998,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32998, 45.42957]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30137895,
        name: "Ca'Del Doge",
        host_id: 60488055,
        host_name: "Marco & Andrea",
        latitude: 45.44253,
        longitude: 12.33373,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33373, 45.44253]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30138970,
        name: "NICE DOUBLE ROOM IN VENICE",
        host_id: 226458292,
        host_name: "Hotel San Giorgio",
        latitude: 45.43597,
        longitude: 12.33313,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33313, 45.43597]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30139913,
        name: "NICE TWIN ROOM IN VENICE",
        host_id: 226458292,
        host_name: "Hotel San Giorgio",
        latitude: 45.43575,
        longitude: 12.33167,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33167, 45.43575]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30164753,
        name: "Cozy apartment a few steps from Ponte di Rialto",
        host_id: 12920042,
        host_name: "Alessia",
        latitude: 45.43807,
        longitude: 12.33331,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33331, 45.43807]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30167534,
        name: "Ca' della Regina, 4 steps from S. Mark Square",
        host_id: 139627704,
        host_name: "Giusy & Fabrizio",
        latitude: 45.43461,
        longitude: 12.33732,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33732, 45.43461]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30168201,
        name: "Camera tripla budget al Harry's",
        host_id: 23182155,
        host_name: "Stefano Roberta",
        latitude: 45.4443,
        longitude: 12.3372,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3372, 45.4443]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30170959,
        name: "Casa Nini Venezia",
        host_id: 226662003,
        host_name: "Sara",
        latitude: 45.44106,
        longitude: 12.34003,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34003, 45.44106]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30175374,
        name: "Antique, central house only steps from the Bacino",
        host_id: 226686453,
        host_name: "Adriana",
        latitude: 45.43629,
        longitude: 12.35286,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35286, 45.43629]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30198831,
        name: "ECONOMY DOUBLE ROOM IN VENETIAN SYLE",
        host_id: 226458292,
        host_name: "Hotel San Giorgio",
        latitude: 45.43419,
        longitude: 12.33148,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33148, 45.43419]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30199003,
        name: "TRIPLE ROOM IN THE DOGE'S CITY",
        host_id: 226458292,
        host_name: "Hotel San Giorgio",
        latitude: 45.43537,
        longitude: 12.33116,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33116, 45.43537]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30199189,
        name: "SINGLE ROOM IN A HISTORICAL BULDING",
        host_id: 226458292,
        host_name: "Hotel San Giorgio",
        latitude: 45.43563,
        longitude: 12.33264,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33264, 45.43563]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30220513,
        name: "Double room in the heart of Venice",
        host_id: 98284086,
        host_name: "Davide",
        latitude: 45.4353,
        longitude: 12.33717,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33717, 45.4353]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30221534,
        name: "Exclusive single",
        host_id: 226967990,
        host_name: "Majlinda",
        latitude: 45.43865,
        longitude: 12.32416,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32416, 45.43865]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30222075,
        name: "Single Room with Bathroom @ MaisonSanMarco",
        host_id: 224793696,
        host_name: "Claudio",
        latitude: 45.43447,
        longitude: 12.33068,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33068, 45.43447]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30225397,
        name: "Arsenale Lodge",
        host_id: 160440981,
        host_name: "Ilaria",
        latitude: 45.43486,
        longitude: 12.35026,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35026, 45.43486]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30231607,
        name: "CA' LUMINOSA",
        host_id: 227036878,
        host_name: "Giovanna",
        latitude: 45.43211,
        longitude: 12.35418,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35418, 45.43211]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30231817,
        name:
          "Le Petit Jardin in Venice (CIR: M (Phone number hidden by Airbnb)",
        host_id: 227036130,
        host_name: "Christine",
        latitude: 45.43772,
        longitude: 12.32321,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32321, 45.43772]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30241205,
        name: "Rialto Mercato a Family in Venice like at Home",
        host_id: 224771046,
        host_name: "Donato",
        latitude: 45.43969,
        longitude: 12.33361,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33361, 45.43969]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30242655,
        name: "Locanda Ca' Lucrezia - Camera Tripla - Venezia",
        host_id: 223469122,
        host_name: "Locanda Ca' Lucrezia",
        latitude: 45.44405,
        longitude: 12.32363,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32363, 45.44405]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30242873,
        name: "Ca' Lucrezia - Camera Doppia Economy - Venezia",
        host_id: 223469122,
        host_name: "Locanda Ca' Lucrezia",
        latitude: 45.44339,
        longitude: 12.32331,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32331, 45.44339]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30243711,
        name: "2 bedrooms-Apartment close to San Marco Square",
        host_id: 33055304,
        host_name: "San Marco Suite 755",
        latitude: 45.43653,
        longitude: 12.33703,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33703, 45.43653]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30244031,
        name: "Suite with Terrace",
        host_id: 33055304,
        host_name: "San Marco Suite 755",
        latitude: 45.43613,
        longitude: 12.33743,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33743, 45.43613]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30244233,
        name: "Rialto Project Apartment 2.2",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.43867,
        longitude: 12.32716,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32716, 45.43867]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30244254,
        name: "Rialto Deluxe Apt. 3",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.44083,
        longitude: 12.3307,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3307, 45.44083]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30244448,
        name: "Design Suite Apartment close to San Marco Square",
        host_id: 33055304,
        host_name: "San Marco Suite 755",
        latitude: 45.43501,
        longitude: 12.33675,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33675, 45.43501]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30244676,
        name: "Suite Superior Apartment close to S.Marco Square",
        host_id: 33055304,
        host_name: "San Marco Suite 755",
        latitude: 45.43632,
        longitude: 12.33881,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33881, 45.43632]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30245178,
        name: "Accademia Charme Apartment  n. 6",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.43096,
        longitude: 12.334,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.334, 45.43096]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30245233,
        name: "Venice Luxury Palace 7",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.43759,
        longitude: 12.33102,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33102, 45.43759]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30245612,
        name: "Triple Room in the heart of Venice",
        host_id: 98284086,
        host_name: "Davide",
        latitude: 45.43596,
        longitude: 12.33858,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33858, 45.43596]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30245895,
        name: "Venice Luxury Palace 3",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.43841,
        longitude: 12.33245,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33245, 45.43841]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30246041,
        name: "Venice View On Grand Canal 2",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.44218,
        longitude: 12.32457,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32457, 45.44218]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30246337,
        name: "Venice Luxury Palace 11",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.4369,
        longitude: 12.33269,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33269, 45.4369]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30247203,
        name: "Appartamento Zal venice",
        host_id: 35689579,
        host_name: "Haleh",
        latitude: 45.43552,
        longitude: 12.31801,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31801, 45.43552]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30248201,
        name: "BLU APARTMENT",
        host_id: 15337957,
        host_name: "Marie",
        latitude: 45.43268,
        longitude: 12.32822,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32822, 45.43268]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30249214,
        name: "CA VIDA",
        host_id: 15337957,
        host_name: "Marie",
        latitude: 45.43309,
        longitude: 12.32919,
        beds: 10,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32919, 45.43309]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30265360,
        name: "Quadruple room in the heart of Venice",
        host_id: 98284086,
        host_name: "Davide",
        latitude: 45.43538,
        longitude: 12.33675,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33675, 45.43538]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30266882,
        name: "Ca' Lucrezia - Camera Doppia - Venezia",
        host_id: 223469122,
        host_name: "Locanda Ca' Lucrezia",
        latitude: 45.44367,
        longitude: 12.32362,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32362, 45.44367]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30282872,
        name: "Family Room @ MaisonSanMarco",
        host_id: 224793696,
        host_name: "Claudio",
        latitude: 45.43568,
        longitude: 12.33108,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33108, 45.43568]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30283763,
        name: "WellVenice Altana, top view",
        host_id: 41898872,
        host_name: "Cristina",
        latitude: 45.44025,
        longitude: 12.33008,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33008, 45.44025]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30284438,
        name: "Ca' Fenice charming apartment in San Marco",
        host_id: 12113015,
        host_name: "Mario",
        latitude: 45.43623,
        longitude: 12.33423,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33423, 45.43623]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30287227,
        name: "Camera tripla con bagno privato",
        host_id: 31064633,
        host_name: "Oxy",
        latitude: 45.44572,
        longitude: 12.32271,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32271, 45.44572]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30303477,
        name:
          "Il sogno di Pier-Locazione turistica M (Phone number hidden by Airbnb)",
        host_id: 227590778,
        host_name: "Pierluigi",
        latitude: 45.43844,
        longitude: 12.32885,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32885, 45.43844]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30304557,
        name: "Rio Marin 101  ❤ Very special Price!",
        host_id: 198581,
        host_name: "Laura",
        latitude: 45.43966,
        longitude: 12.32295,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32295, 45.43966]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30305555,
        name: "Rio Marin 102  ❤ Very special Price!",
        host_id: 198581,
        host_name: "Laura",
        latitude: 45.44129,
        longitude: 12.32473,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32473, 45.44129]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30305768,
        name: "Rio Marin 103 ❤ Very special Price!",
        host_id: 198581,
        host_name: "Laura",
        latitude: 45.44019,
        longitude: 12.32513,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32513, 45.44019]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30306012,
        name: "Rio Marin 104  ❤ Very special Price!",
        host_id: 198581,
        host_name: "Laura",
        latitude: 45.43957,
        longitude: 12.3234,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3234, 45.43957]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30306245,
        name: "Rio Marin 105 ❤ Very special Price!",
        host_id: 198581,
        host_name: "Laura",
        latitude: 45.44015,
        longitude: 12.32359,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32359, 45.44015]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30330495,
        name: "Palazzo on the Grand Canal",
        host_id: 206353503,
        host_name: "Art Foundation - Support Program",
        latitude: 45.43508,
        longitude: 12.33029,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33029, 45.43508]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30333540,
        name: "Appartamento Ca' Rizzi",
        host_id: 53699315,
        host_name: "Marinella E Stefano",
        latitude: 45.4359,
        longitude: 12.3189,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3189, 45.4359]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30335043,
        name: "Alla Vigna  - Room Only",
        host_id: 308566,
        host_name: "Virginio",
        latitude: 45.43787,
        longitude: 12.33817,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33817, 45.43787]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30335148,
        name: "Alla Vigna  - Room Only",
        host_id: 308566,
        host_name: "Virginio",
        latitude: 45.43705,
        longitude: 12.33868,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33868, 45.43705]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30340692,
        name: "Relaxing apartment Venezia Biennale free wifi",
        host_id: 227815136,
        host_name: "Sara",
        latitude: 45.43319,
        longitude: 12.35091,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35091, 45.43319]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30373141,
        name: "Camera doppia standard con bagni condivisi",
        host_id: 228037198,
        host_name: "Dorsoduro 3171",
        latitude: 45.43388,
        longitude: 12.32409,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32409, 45.43388]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30387364,
        name: "Luxury Bright Spacious 75sqm apt view canal/lagoon",
        host_id: 32196030,
        host_name: "Catherine",
        latitude: 45.42702,
        longitude: 12.32177,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32177, 45.42702]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30387386,
        name: "ALLE COLONNE Two bedrooms Apt.",
        host_id: 159289574,
        host_name: "Monica+Nadia",
        latitude: 45.4339,
        longitude: 12.33502,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33502, 45.4339]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30413020,
        name: "Casa Manina sul Ponte - Your private Canal View",
        host_id: 165874453,
        host_name: "Ilaria",
        latitude: 45.43979,
        longitude: 12.3401,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3401, 45.43979]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30414237,
        name: "Venice lagoon",
        host_id: 65165841,
        host_name: "Sofia",
        latitude: 45.44804,
        longitude: 12.32928,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32928, 45.44804]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30416672,
        name: "Doge's Pantheon & St.Mark School in Hidden Venice",
        host_id: 226852936,
        host_name: "Fabio",
        latitude: 45.439,
        longitude: 12.34286,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34286, 45.439]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30416763,
        name: "Ca' alla Colombina - Apartment for 5 persons",
        host_id: 214062359,
        host_name: "Sarlux",
        latitude: 45.44381,
        longitude: 12.32278,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32278, 45.44381]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30417076,
        name: "New apartment! In the heart of museums District",
        host_id: 81086731,
        host_name: "Pina",
        latitude: 45.42871,
        longitude: 12.33155,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33155, 45.42871]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30420237,
        name: "VENICE DREAM       'CA ZUSTO HOTEL",
        host_id: 227650583,
        host_name: "Antonella",
        latitude: 45.44118,
        longitude: 12.32658,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32658, 45.44118]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30432015,
        name: "Ca' dei Leoni, Aria condizionata, Wi-Fi, PS3",
        host_id: 207958013,
        host_name: "Federico",
        latitude: 45.44102,
        longitude: 12.3343,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3343, 45.44102]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30432470,
        name: "Last Minute 4gg  a  Venezia",
        host_id: 207479164,
        host_name: "Giulio",
        latitude: 45.43156,
        longitude: 12.33194,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33194, 45.43156]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30434232,
        name: "Exclusive triple",
        host_id: 226967990,
        host_name: "Majlinda",
        latitude: 45.43855,
        longitude: 12.32438,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32438, 45.43855]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30434909,
        name: "Exclusive double",
        host_id: 226967990,
        host_name: "Majlinda",
        latitude: 45.43729,
        longitude: 12.32347,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32347, 45.43729]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30437231,
        name: "Charming Loft FIVE STARS *****",
        host_id: 228529437,
        host_name: "Roberto",
        latitude: 45.43299,
        longitude: 12.31791,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31791, 45.43299]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30438659,
        name: "Twin economy · room  with shared bathrooms",
        host_id: 228037198,
        host_name: "Dorsoduro 3171",
        latitude: 45.43426,
        longitude: 12.32546,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32546, 45.43426]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30438944,
        name: "Camera de la Laca",
        host_id: 207291051,
        host_name: "Gianpaolo",
        latitude: 45.43815,
        longitude: 12.32356,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32356, 45.43815]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30439037,
        name: "Camera Matrimoniale 2 piano con bagni condivisi",
        host_id: 228037198,
        host_name: "Dorsoduro 3171",
        latitude: 45.43288,
        longitude: 12.32458,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32458, 45.43288]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30439403,
        name: "Camera Matrimoniale 1 piano con bagni condivisi",
        host_id: 228037198,
        host_name: "Dorsoduro 3171",
        latitude: 45.43362,
        longitude: 12.32551,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32551, 45.43362]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30439585,
        name: "Camera con terrazza privata e bagni condivisi",
        host_id: 228037198,
        host_name: "Dorsoduro 3171",
        latitude: 45.43439,
        longitude: 12.32542,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32542, 45.43439]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30439756,
        name: "Camera Singola con bagni condivisi",
        host_id: 228037198,
        host_name: "Dorsoduro 3171",
        latitude: 45.43429,
        longitude: 12.32561,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32561, 45.43429]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30456635,
        name: "Stanza Matrimoniale a Venezia",
        host_id: 11966215,
        host_name: "Ginevra",
        latitude: 45.43131,
        longitude: 12.35508,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35508, 45.43131]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30463193,
        name: "You are in Venice Apartment",
        host_id: 228709217,
        host_name: "Silvia",
        latitude: 45.43462,
        longitude: 12.35593,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35593, 45.43462]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30467176,
        name: "Bridge of Sighs luxurious apartment",
        host_id: 101016295,
        host_name: "Orsetta",
        latitude: 45.43378,
        longitude: 12.34106,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34106, 45.43378]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30488554,
        name: "Greci View, tra San Marco e la Biennale",
        host_id: 3446851,
        host_name: "Marisa",
        latitude: 45.4342,
        longitude: 12.34577,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34577, 45.4342]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30489654,
        name: "Home Venice Apartments- Bragora 1",
        host_id: 7619802,
        host_name: "Stefania",
        latitude: 45.43626,
        longitude: 12.34733,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34733, 45.43626]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30492650,
        name: "VeniceVillas, Ca' Magno",
        host_id: 294951,
        host_name: "VeniceVillas Di Enzo",
        latitude: 45.44393,
        longitude: 12.33003,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33003, 45.44393]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30517849,
        name: "STUPENDO APPARTAMENTO A SAN LIO",
        host_id: 11388964,
        host_name: "Chiara",
        latitude: 45.43714,
        longitude: 12.33894,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33894, 45.43714]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30525671,
        name: "Airbiennale",
        host_id: 31975170,
        host_name: "Marina Laura",
        latitude: 45.43123,
        longitude: 12.35755,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35755, 45.43123]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30528942,
        name: "SKY SUITE - Spa shower/kitchenette. Biennale",
        host_id: 185872492,
        host_name: "Elite",
        latitude: 45.43204,
        longitude: 12.35802,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35802, 45.43204]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30529544,
        name: "Sunny apartment on a canal",
        host_id: 106747260,
        host_name: "Michael",
        latitude: 45.4349,
        longitude: 12.32195,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32195, 45.4349]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30529807,
        name: "Ca'Ferdinand: peaceful apartment with private yard",
        host_id: 229088558,
        host_name: "Gregory",
        latitude: 45.43197,
        longitude: 12.32111,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32111, 45.43197]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30575006,
        name: "appartamento 2 camere e 2 bagni via XXII Marzo",
        host_id: 47683665,
        host_name: "Alberto",
        latitude: 45.43164,
        longitude: 12.33295,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33295, 45.43164]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30599131,
        name: "FLOWERS Room, ensuite bath- shared kitchenette",
        host_id: 185872492,
        host_name: "Elite",
        latitude: 45.43144,
        longitude: 12.35823,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35823, 45.43144]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30618666,
        name: "Cannaregio apartment, centro storico di Venezia!",
        host_id: 229532248,
        host_name: "Alessandra",
        latitude: 45.44449,
        longitude: 12.32843,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32843, 45.44449]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30628242,
        name: "Casa Venezia Luminosa vista canale",
        host_id: 226681052,
        host_name: "Rocchi",
        latitude: 45.42726,
        longitude: 12.31943,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31943, 45.42726]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30684673,
        name: "Rialto Apartment - The heart of Venice",
        host_id: 6068323,
        host_name: "Fabio",
        latitude: 45.43906,
        longitude: 12.33179,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33179, 45.43906]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30722191,
        name: "TIBET SUITE 1 bath, living area. Shared kitchen",
        host_id: 185872492,
        host_name: "Elite",
        latitude: 45.43184,
        longitude: 12.35797,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35797, 45.43184]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30753150,
        name: "FALCHETTA  HOUSE  IN THE HEART OF VENICE",
        host_id: 48555766,
        host_name: "Federica",
        latitude: 45.44258,
        longitude: 12.33284,
        beds: 7,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33284, 45.44258]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30753359,
        name: "A spasso nel Centro Storico di Venezia",
        host_id: 229189977,
        host_name: "Alessandro",
        latitude: 45.43392,
        longitude: 12.32897,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32897, 45.43392]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30760815,
        name: "FEW STEPS FROM SAINT MARK SQUARE!!!!",
        host_id: 41559211,
        host_name: "Venice",
        latitude: 45.43153,
        longitude: 12.35425,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35425, 45.43153]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30780935,
        name: "BOUTIQUE APARTMENT CA'LIZ",
        host_id: 160888372,
        host_name: "Nicoló",
        latitude: 45.43376,
        longitude: 12.34922,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34922, 45.43376]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30782407,
        name: "Dimora di charme  luminosissima con  vista canale",
        host_id: 230310130,
        host_name: "Antonella",
        latitude: 45.43325,
        longitude: 12.32024,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32024, 45.43325]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30802942,
        name: "Luxury house with secret garden",
        host_id: 148215438,
        host_name: "Marta",
        latitude: 45.44237,
        longitude: 12.3334,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3334, 45.44237]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30803759,
        name: "Venetian Stylish Attic Ca' Micaela",
        host_id: 5862083,
        host_name: "Silvia",
        latitude: 45.44118,
        longitude: 12.33076,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33076, 45.44118]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30810822,
        name: "Ca' Priuli 1",
        host_id: 230491585,
        host_name: "Paolo",
        latitude: 45.44455,
        longitude: 12.329,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.329, 45.44455]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30814867,
        name: "Gold And Red - The Venetian Style With Terrace",
        host_id: 230366611,
        host_name: "Teresa",
        latitude: 45.43725,
        longitude: 12.32723,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32723, 45.43725]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30842652,
        name: "Grazioso appartamento San Lio",
        host_id: 113703606,
        host_name: "Chiara",
        latitude: 45.43663,
        longitude: 12.33889,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33889, 45.43663]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30842856,
        name: "Attic San Bartolomeo, Rialto bridge. X106",
        host_id: 15178567,
        host_name: "Paolo",
        latitude: 45.43834,
        longitude: 12.33665,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33665, 45.43834]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30872719,
        name: "Romantic dreams come true on the way back to the 16th century",
        host_id: 213326446,
        host_name: "Carina E-Domizil",
        latitude: 45.44473,
        longitude: 12.33079,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33079, 45.44473]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30879988,
        name: 'Ca\' Salicornia - Camera "Olivaria"',
        host_id: 84543765,
        host_name: "Maurizio&Francesca",
        latitude: 45.43847,
        longitude: 12.34075,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34075, 45.43847]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30897412,
        name: "Piacevole appartamento veneziano, tra luce e modernità",
        host_id: 230902884,
        host_name: "Casa Cecilia",
        latitude: 45.44314,
        longitude: 12.32151,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32151, 45.44314]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30902429,
        name: "Al Teatro Italia centro Venezia.",
        host_id: 230932659,
        host_name: "Armando",
        latitude: 45.4455,
        longitude: 12.33076,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33076, 45.4455]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30928453,
        name: "Tripla Admiral vista città",
        host_id: 29619859,
        host_name: "Stefano",
        latitude: 45.44119,
        longitude: 12.32605,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32605, 45.44119]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30931102,
        name: "Tripla Admiral Confort",
        host_id: 29619859,
        host_name: "Stefano",
        latitude: 45.44089,
        longitude: 12.32453,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32453, 45.44089]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30931439,
        name: "Queen Royal Guest house con bagno in comune",
        host_id: 29619859,
        host_name: "Stefano",
        latitude: 45.44615,
        longitude: 12.32192,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32192, 45.44615]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30931857,
        name: "Doppia Royal con bagno in comune",
        host_id: 29619859,
        host_name: "Stefano",
        latitude: 45.44587,
        longitude: 12.32189,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32189, 45.44587]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30932269,
        name: "King Royal con bagno in comune",
        host_id: 29619859,
        host_name: "Stefano",
        latitude: 45.44513,
        longitude: 12.32256,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32256, 45.44513]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30932466,
        name: "Tripla Royal con bagno in comune",
        host_id: 29619859,
        host_name: "Stefano",
        latitude: 45.44587,
        longitude: 12.32128,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32128, 45.44587]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30932680,
        name: "Monolocale Royal con cucina privata e terrazza",
        host_id: 29619859,
        host_name: "Stefano",
        latitude: 45.44613,
        longitude: 12.32187,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32187, 45.44613]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30933736,
        name: "Tripla admiral vista city",
        host_id: 23182155,
        host_name: "Stefano Roberta",
        latitude: 45.44134,
        longitude: 12.32638,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32638, 45.44134]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30935052,
        name: "Tripla ADMIRAL Confort",
        host_id: 23182155,
        host_name: "Stefano Roberta",
        latitude: 45.43985,
        longitude: 12.32546,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32546, 45.43985]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30935255,
        name: "Queen Royal con bagno in comune",
        host_id: 23182155,
        host_name: "Stefano Roberta",
        latitude: 45.44502,
        longitude: 12.32048,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32048, 45.44502]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30935478,
        name: "Doppia Royal con bagno in comune",
        host_id: 23182155,
        host_name: "Stefano Roberta",
        latitude: 45.44646,
        longitude: 12.32042,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32042, 45.44646]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30935553,
        name: "King Royal con bagno in comune",
        host_id: 23182155,
        host_name: "Stefano Roberta",
        latitude: 45.44682,
        longitude: 12.3219,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3219, 45.44682]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30935654,
        name: "Tripla Royal con bagno in comune",
        host_id: 23182155,
        host_name: "Stefano Roberta",
        latitude: 45.44475,
        longitude: 12.32036,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32036, 45.44475]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30935748,
        name: "Monolocale Royal con cucina privata e terrazza",
        host_id: 23182155,
        host_name: "Stefano Roberta",
        latitude: 45.44527,
        longitude: 12.32179,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32179, 45.44527]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30935887,
        name: "MODERN FLAT IN SAN MARCO -2 FLATS",
        host_id: 401113,
        host_name: "Elia",
        latitude: 45.43675,
        longitude: 12.33609,
        beds: 9,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33609, 45.43675]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30949350,
        name: "A special view of bell tower",
        host_id: 48490641,
        host_name: "Riccardo",
        latitude: 45.43483,
        longitude: 12.33784,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33784, 45.43483]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30956984,
        name: "Mirandolina Venice Exclusive Guesthouse",
        host_id: 168595776,
        host_name: "Bruna",
        latitude: 45.43789,
        longitude: 12.3415,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3415, 45.43789]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30957166,
        name: "Mirandolina Venice  Exclusive Guesthouse ( 1 )",
        host_id: 168595776,
        host_name: "Bruna",
        latitude: 45.43959,
        longitude: 12.34128,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34128, 45.43959]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30959923,
        name: "Ca' Salicornia - Camera \"Ammiana”",
        host_id: 84543765,
        host_name: "Maurizio&Francesca",
        latitude: 45.4378,
        longitude: 12.34189,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34189, 45.4378]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30972104,
        name: "Panoramic apartment in Campo S. Stefano with Wi-Fi",
        host_id: 7879981,
        host_name: "Eugenio E Bruno",
        latitude: 45.43166,
        longitude: 12.33102,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33102, 45.43166]] },
    },
    {
      type: "Feature",
      properties: {
        id: 30979442,
        name: "Al Teatro Italia centro Venezia",
        host_id: 230932659,
        host_name: "Armando",
        latitude: 45.44501,
        longitude: 12.32768,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32768, 45.44501]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31011634,
        name: "Apartment 1142",
        host_id: 630328,
        host_name: "Kosher House",
        latitude: 45.44542,
        longitude: 12.32777,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32777, 45.44542]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31019742,
        name: "Mirandolina Venice Exclusive Apartment",
        host_id: 168595776,
        host_name: "Bruna",
        latitude: 45.43814,
        longitude: 12.34081,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34081, 45.43814]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31028285,
        name: "Ca' del Bonsai (next S. Marco e Biennale)",
        host_id: 231757090,
        host_name: "Fortunato",
        latitude: 45.43417,
        longitude: 12.35029,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35029, 45.43417]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31031619,
        name: "SG Fine Living",
        host_id: 46904188,
        host_name: "Mirco Optyflat",
        latitude: 45.43291,
        longitude: 12.35677,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35677, 45.43291]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31033615,
        name: "Stairway to Heaven",
        host_id: 12497228,
        host_name: "Canal Grande",
        latitude: 45.42984,
        longitude: 12.33234,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33234, 45.42984]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31033981,
        name: "Casa del Battello",
        host_id: 632312,
        host_name: "Guillaume",
        latitude: 45.44548,
        longitude: 12.32158,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32158, 45.44548]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31034029,
        name: "Big double room",
        host_id: 231594985,
        host_name: "Davide",
        latitude: 45.43993,
        longitude: 12.32548,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32548, 45.43993]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31034544,
        name: "Family quadruple room",
        host_id: 231594985,
        host_name: "Davide",
        latitude: 45.44059,
        longitude: 12.32646,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32646, 45.44059]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31034763,
        name: "Bright single room",
        host_id: 231594985,
        host_name: "Davide",
        latitude: 45.43996,
        longitude: 12.32672,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32672, 45.43996]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31037761,
        name: "Foscarina Apartment , perfect stay for one day",
        host_id: 159746853,
        host_name: "Giulia",
        latitude: 45.43621,
        longitude: 12.32594,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32594, 45.43621]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31040193,
        name: "Exlusive luxury romantic home",
        host_id: 231845493,
        host_name: "Najada",
        latitude: 45.43395,
        longitude: 12.32423,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32423, 45.43395]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31040443,
        name: "Alice's House",
        host_id: 231848772,
        host_name: "Alice",
        latitude: 45.43437,
        longitude: 12.34116,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34116, 45.43437]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31046955,
        name: "Silver Apartment - High Tide Exempt",
        host_id: 29706566,
        host_name: "Margherita & Valentina",
        latitude: 45.43926,
        longitude: 12.33263,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33263, 45.43926]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31062519,
        name: "Double Apartment: private terrace & stunning view",
        host_id: 10988715,
        host_name: "Andrea",
        latitude: 45.43263,
        longitude: 12.32665,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32665, 45.43263]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31066446,
        name: "Attic in the center, 2 double room",
        host_id: 232078368,
        host_name: "Davide",
        latitude: 45.43775,
        longitude: 12.33881,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33881, 45.43775]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31074040,
        name: "Garden house Giudecca Venezia",
        host_id: 143873157,
        host_name: "Federico",
        latitude: 45.42479,
        longitude: 12.32676,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32676, 45.42479]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31079768,
        name: "Casa Santa Caterina",
        host_id: 232198303,
        host_name: "Maura",
        latitude: 45.44304,
        longitude: 12.33826,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33826, 45.44304]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31109392,
        name: "Mario Apartment 1531",
        host_id: 10072655,
        host_name: "Mario Apartment",
        latitude: 45.444,
        longitude: 12.32693,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32693, 45.444]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31109572,
        name: "THE NEW (h)OLDED APT.",
        host_id: 69775060,
        host_name: "Carlo",
        latitude: 45.43651,
        longitude: 12.32319,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32319, 45.43651]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31110671,
        name: "CA' DEL RIO SAN FELICE, free wifi",
        host_id: 3736168,
        host_name: "EasyRentals",
        latitude: 45.442357005434559,
        longitude: 12.332075455526313,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33208, 45.44236]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31134072,
        name: "Art’s Biennale 2",
        host_id: 50739522,
        host_name: "Hanna",
        latitude: 45.43032,
        longitude: 12.35496,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35496, 45.43032]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31143614,
        name: "ADA's SUITE welcomes you in St. Mark's Square",
        host_id: 232772659,
        host_name: "Giorgio",
        latitude: 45.4343,
        longitude: 12.33681,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33681, 45.4343]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31157005,
        name: "Ca’ Marietto",
        host_id: 45370570,
        host_name: "Chiara",
        latitude: 45.43908,
        longitude: 12.34508,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34508, 45.43908]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31158380,
        name: "Pretty apartment at the Venice Biennale",
        host_id: 179326998,
        host_name: "Marta & Chiara",
        latitude: 45.43222,
        longitude: 12.35675,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35675, 45.43222]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31158632,
        name: "CA’ GRIMANI n.1: stunning view and luxury comfort",
        host_id: 10988715,
        host_name: "Andrea",
        latitude: 45.43232,
        longitude: 12.32739,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32739, 45.43232]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31161505,
        name: "CA’ GRIMANI n.2 private terrace",
        host_id: 10988715,
        host_name: "Andrea",
        latitude: 45.43164,
        longitude: 12.32674,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32674, 45.43164]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31168457,
        name: "San Marco apartment",
        host_id: 156216830,
        host_name: "Pietro",
        latitude: 45.43489,
        longitude: 12.34096,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34096, 45.43489]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31186129,
        name: "Romantic Flat In Giardini near San Marco square",
        host_id: 48092742,
        host_name: "Roby",
        latitude: 45.4298,
        longitude: 12.35863,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35863, 45.4298]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31186426,
        name: "Lovely flat in centre of Venice",
        host_id: 13500918,
        host_name: "Mark",
        latitude: 45.43085,
        longitude: 12.35883,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35883, 45.43085]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31186705,
        name: "Mimosa Apartment",
        host_id: 233153110,
        host_name: "Mimosa",
        latitude: 45.43439,
        longitude: 12.32534,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32534, 45.43439]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31187072,
        name: "Large Room in the centre of city 3",
        host_id: 191226100,
        host_name: "Milo",
        latitude: 45.44427,
        longitude: 12.32852,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32852, 45.44427]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31191913,
        name: "NoStress Holiday - Bayview Romantic Apartment",
        host_id: 233209105,
        host_name: "Venice No Stress",
        latitude: 45.44701,
        longitude: 12.31892,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31892, 45.44701]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31196294,
        name: "Mirandolina Venice Exclusive Apartment ( 4+2 )",
        host_id: 168595776,
        host_name: "Bruna",
        latitude: 45.4395,
        longitude: 12.34282,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34282, 45.4395]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31200027,
        name: "Nice view best position comfortable apartment",
        host_id: 1910577,
        host_name: "Nikola",
        latitude: 45.44267,
        longitude: 12.32573,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32573, 45.44267]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31201144,
        name: "Old Ghetto Garden in Venice",
        host_id: 233309979,
        host_name: "Maria Giulia",
        latitude: 45.44299,
        longitude: 12.32717,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32717, 45.44299]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31201799,
        name: "Room for 5-private bathroom- 300 mt from St. Mark",
        host_id: 2737238,
        host_name: "Annalisa E Emma",
        latitude: 45.43251,
        longitude: 12.33209,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33209, 45.43251]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31203307,
        name: "Stupenda casa cannaregio",
        host_id: 39462006,
        host_name: "Cristina",
        latitude: 45.44556,
        longitude: 12.3221,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3221, 45.44556]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31217265,
        name: "Stylish truly Venetian apartment downtown+balcony",
        host_id: 151634876,
        host_name: "Valentina",
        latitude: 45.43556,
        longitude: 12.34446,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34446, 45.43556]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31230578,
        name: "CaSora - Apartment in Venice",
        host_id: 233603703,
        host_name: "Antonio",
        latitude: 45.4364,
        longitude: 12.31809,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31809, 45.4364]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31237485,
        name: "Cà del Sol apartment",
        host_id: 168780179,
        host_name: "Monica",
        latitude: 45.43471,
        longitude: 12.34821,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34821, 45.43471]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31276585,
        name: "Lovely apartment with terrace, very central",
        host_id: 567508,
        host_name: "Nicola",
        latitude: 45.43702,
        longitude: 12.32668,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32668, 45.43702]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31277438,
        name: "Comfort and luxury in Venice: canal view & garden",
        host_id: 179326998,
        host_name: "Marta & Chiara",
        latitude: 45.42985,
        longitude: 12.33012,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33012, 45.42985]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31278754,
        name: "San Marco Style Canal View Apt. 1",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.43692,
        longitude: 12.34205,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34205, 45.43692]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31279606,
        name: "Accademia Charm Apartment n.2.2",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.43059,
        longitude: 12.33429,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33429, 45.43059]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31281116,
        name: "ROMANTICO APPARTAMENTO CALLE DEL VOLTO RIALTO",
        host_id: 26460616,
        host_name: "Gianfranco",
        latitude: 45.43654,
        longitude: 12.33879,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33879, 45.43654]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31286124,
        name: "CASA FIORI 1 - Room with balcony overlooking canal",
        host_id: 20301471,
        host_name: "Casa",
        latitude: 45.44169,
        longitude: 12.33288,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33288, 45.44169]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31288641,
        name: "Teeny Weeny house at Biennale",
        host_id: 18629582,
        host_name: "Luigi",
        latitude: 45.43104,
        longitude: 12.35707,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35707, 45.43104]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31303354,
        name: "Balcone  sul canale",
        host_id: 234289682,
        host_name: "Marco",
        latitude: 45.43984,
        longitude: 12.33259,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33259, 45.43984]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31332376,
        name: "New Rachel 1 - 70m2 - 10min Rialto - Wifi",
        host_id: 58456083,
        host_name: "Denis",
        latitude: 45.43775,
        longitude: 12.32409,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32409, 45.43775]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31333749,
        name: "New Foscari - 120m2 - 10min Rialto - Wifi",
        host_id: 58456083,
        host_name: "Denis",
        latitude: 45.43349,
        longitude: 12.32673,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32673, 45.43349]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31359958,
        name: "MODERN FLAT IN SAN MARCO - 3 FLATS",
        host_id: 401113,
        host_name: "Elia",
        latitude: 45.43496,
        longitude: 12.33648,
        beds: 14,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33648, 45.43496]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31368757,
        name: "VeraVenezia da Stefano e Tiziana",
        host_id: 185827474,
        host_name: "Tiziana",
        latitude: 45.43297,
        longitude: 12.34973,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34973, 45.43297]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31369836,
        name: "Cannaregio venetian court - wifi&washing machine",
        host_id: 179297180,
        host_name: "Chiara",
        latitude: 45.44626,
        longitude: 12.32713,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32713, 45.44626]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31374297,
        name: "La Petite",
        host_id: 37452781,
        host_name: "Federica",
        latitude: 45.43041,
        longitude: 12.32932,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32932, 45.43041]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31376147,
        name: "Ca' amaranta, tra la stazione e il ghetto ebraico",
        host_id: 3446851,
        host_name: "Marisa",
        latitude: 45.44636,
        longitude: 12.32275,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32275, 45.44636]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31394802,
        name: "Corderie de la Tana Biennale Exhibition @Arsenale",
        host_id: 232309532,
        host_name: "Ezio",
        latitude: 45.43225,
        longitude: 12.35555,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35555, 45.43225]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31395801,
        name: "Residence S. Marco (300 m. from St. Mark's Square)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.4357,
        longitude: 12.34297,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34297, 45.4357]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31400853,
        name: "Rialto Studio",
        host_id: 107010081,
        host_name: "Vanessa",
        latitude: 45.44037,
        longitude: 12.33821,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33821, 45.44037]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31400997,
        name: "Duplex with washing machine,quiet area- Cannaregio",
        host_id: 179297180,
        host_name: "Chiara",
        latitude: 45.44605,
        longitude: 12.32788,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32788, 45.44605]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31403379,
        name: "CASA FALCHETTA - APT. PER 4 NEL CUORE DI VENEZIA",
        host_id: 48555766,
        host_name: "Federica",
        latitude: 45.44228,
        longitude: 12.33335,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33335, 45.44228]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31407642,
        name: "Cà Bottacin",
        host_id: 235250100,
        host_name: "Tommaso",
        latitude: 45.43325,
        longitude: 12.35027,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35027, 45.43325]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31409347,
        name: "Vista unica su Venezia dietro La Fenice con altana",
        host_id: 235263076,
        host_name: "Tiziana",
        latitude: 45.43273,
        longitude: 12.33369,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33369, 45.43273]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31414195,
        name: "ExclusiVenice - White House 5280",
        host_id: 235305051,
        host_name: "Massimo",
        latitude: 45.44067,
        longitude: 12.33951,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33951, 45.44067]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31428336,
        name: "San Marco",
        host_id: 4496256,
        host_name: "Annamaria",
        latitude: 45.43521,
        longitude: 12.33898,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33898, 45.43521]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31428338,
        name: "Ca' d'Oro",
        host_id: 4496256,
        host_name: "Annamaria",
        latitude: 45.44213,
        longitude: 12.33355,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33355, 45.44213]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31429316,
        name: "Modern, washing machine, WiFi: BIENNIALE-ARSENALE",
        host_id: 179326998,
        host_name: "Marta & Chiara",
        latitude: 45.43755,
        longitude: 12.34937,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34937, 45.43755]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31432422,
        name: "Apartment  Courtyard View.",
        host_id: 235434745,
        host_name: "Irene",
        latitude: 45.43407,
        longitude: 12.33072,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33072, 45.43407]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31433036,
        name: "Near Accademia Bridge - 2 bathrooms & canal view",
        host_id: 179326998,
        host_name: "Marta & Chiara",
        latitude: 45.43054,
        longitude: 12.3285,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3285, 45.43054]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31436115,
        name: "Canal Tron",
        host_id: 26420663,
        host_name: "Roberto",
        latitude: 45.4409,
        longitude: 12.32835,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32835, 45.4409]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31452810,
        name: "Ca' Tronconi ai Frari",
        host_id: 172443280,
        host_name: "Monica",
        latitude: 45.43462,
        longitude: 12.32901,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32901, 45.43462]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31453021,
        name: "Ca' Contarina,casa singola a 5 minuti da Rialto",
        host_id: 235617845,
        host_name: "Cristina",
        latitude: 45.44144,
        longitude: 12.33989,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33989, 45.44144]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31453478,
        name: "Santa Croce Apartment x5! Magic of Venice!",
        host_id: 96221395,
        host_name: "Welcome To Veneto & Friuli",
        latitude: 45.43722,
        longitude: 12.31999,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31999, 45.43722]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31461231,
        name: "Art Dreams B&B in the heart of Cannaregio-Cà d'Oro",
        host_id: 235677768,
        host_name: "Viola",
        latitude: 45.44482,
        longitude: 12.3282,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3282, 45.44482]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31462087,
        name: "Art Dreams B&B in the heart of Cannaregio-S.Marco",
        host_id: 235677768,
        host_name: "Viola",
        latitude: 45.44417,
        longitude: 12.32763,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32763, 45.44417]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31462928,
        name: "Art Dreams B&B in the heart of Cannaregio-Rialto",
        host_id: 235677768,
        host_name: "Viola",
        latitude: 45.44459,
        longitude: 12.32738,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32738, 45.44459]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31463664,
        name: "WelcomeLAGOVenezia",
        host_id: 8742378,
        host_name: "Paolo",
        latitude: 45.4355,
        longitude: 12.34424,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34424, 45.4355]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31481510,
        name: "Glam Rialto Apartment - Wi-fi and washing machine",
        host_id: 179297180,
        host_name: "Chiara",
        latitude: 45.43909,
        longitude: 12.33298,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33298, 45.43909]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31485177,
        name: "Modern apartament Wi-fi, washing machine Dorsoduro",
        host_id: 179297180,
        host_name: "Chiara",
        latitude: 45.43235,
        longitude: 12.32307,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32307, 45.43235]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31485436,
        name: "Artis Domus",
        host_id: 121204298,
        host_name: "Caroli",
        latitude: 45.43491,
        longitude: 12.32947,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32947, 45.43491]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31486078,
        name: "Arsenale/S.Marco Canal view & courtyard; ground fl",
        host_id: 179326998,
        host_name: "Marta & Chiara",
        latitude: 45.43591,
        longitude: 12.34816,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34816, 45.43591]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31486382,
        name: "San Marco Arsenale design -ideal for couples, Wifi",
        host_id: 179297180,
        host_name: "Chiara",
        latitude: 45.43619,
        longitude: 12.34892,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34892, 45.43619]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31501420,
        name: "Live in a Charming Apartment, close to St. Mark's",
        host_id: 12144430,
        host_name: "Giulia",
        latitude: 45.4323,
        longitude: 12.35205,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35205, 45.4323]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31502550,
        name: "Triple room in Venetian style",
        host_id: 98479290,
        host_name: "Daniele",
        latitude: 45.42882,
        longitude: 12.33262,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33262, 45.42882]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31502664,
        name: "Luxury accomodation in the heart of Venice",
        host_id: 28608013,
        host_name: "Isabella",
        latitude: 45.42524,
        longitude: 12.32472,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32472, 45.42524]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31508921,
        name: "Yellow House Venice",
        host_id: 236078136,
        host_name: "Cristina Luca Alberto",
        latitude: 45.43261,
        longitude: 12.33296,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33296, 45.43261]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31510151,
        name: "Oasi 5503/a",
        host_id: 236098947,
        host_name: "Giovanna",
        latitude: 45.4413,
        longitude: 12.34011,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34011, 45.4413]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31524157,
        name: "Ca' Sole Residence Design",
        host_id: 236232387,
        host_name: "Francesco",
        latitude: 45.43169,
        longitude: 12.3264,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3264, 45.43169]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31524686,
        name: "venezianischer Palazzo mit kostenlosen WLAN",
        host_id: 31974659,
        host_name: "Karl Michael",
        latitude: 45.43541,
        longitude: 12.34773,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34773, 45.43541]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31524832,
        name: "Ca' Nadia Apartment",
        host_id: 25128793,
        host_name: "_mdm_",
        latitude: 45.44339,
        longitude: 12.32693,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32693, 45.44339]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31526177,
        name:
          "M (Phone number hidden by Airbnb) Typical Venetian house with terrace",
        host_id: 236250351,
        host_name: "Lorena",
        latitude: 45.44466,
        longitude: 12.32964,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32964, 45.44466]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31532843,
        name: "Venice Laguna Blu & Garden",
        host_id: 236311898,
        host_name: "Silvia",
        latitude: 45.42616,
        longitude: 12.36013,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.36013, 45.42616]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31532998,
        name: "Venice Celestia apart",
        host_id: 34435200,
        host_name: "Emmanuel",
        latitude: 45.43737,
        longitude: 12.35054,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35054, 45.43737]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31563752,
        name: "St. Mark's Square 15 mins walk, CANAL VIEW",
        host_id: 10989537,
        host_name: "Monica",
        latitude: 45.44275,
        longitude: 12.33836,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33836, 45.44275]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31565477,
        name: "Mario Apartment 635",
        host_id: 10072655,
        host_name: "Mario Apartment",
        latitude: 45.44513,
        longitude: 12.31983,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31983, 45.44513]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31578544,
        name: "Unmissable location near ST MARK'S SQUARE",
        host_id: 179326998,
        host_name: "Marta & Chiara",
        latitude: 45.43447,
        longitude: 12.33821,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33821, 45.43447]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31578663,
        name: "Elegance in Rialto, Wi-fi - washer/dryer",
        host_id: 179298782,
        host_name: "Sabrina",
        latitude: 45.43891,
        longitude: 12.33397,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33397, 45.43891]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31579986,
        name: "Luxury house in Rialto, washingmachine/dryer",
        host_id: 179298782,
        host_name: "Sabrina",
        latitude: 45.43928,
        longitude: 12.33435,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33435, 45.43928]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31579988,
        name: "La TUA casa nel cuore di Venezia!",
        host_id: 159552785,
        host_name: "Stefania",
        latitude: 45.43298,
        longitude: 12.33398,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33398, 45.43298]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31581273,
        name: "Comfort Arsenal canal view, Wi-fi/washing-machine",
        host_id: 179298782,
        host_name: "Sabrina",
        latitude: 45.43743,
        longitude: 12.34868,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34868, 45.43743]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31583604,
        name: "CA' ZEN - ANCIENT FAMILY PALACE",
        host_id: 236750515,
        host_name: "Elena",
        latitude: 45.437,
        longitude: 12.32816,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32816, 45.437]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31586330,
        name: 'AtoLiving "Greci"',
        host_id: 236770524,
        host_name: "AtoLiving",
        latitude: 45.4349,
        longitude: 12.34574,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34574, 45.4349]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31586651,
        name: "Venetian style apartment in Dorsoduro",
        host_id: 98479290,
        host_name: "Daniele",
        latitude: 45.42991,
        longitude: 12.33189,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33189, 45.42991]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31591679,
        name: "Venice in love - Appartamento Blu",
        host_id: 235434745,
        host_name: "Irene",
        latitude: 45.43448,
        longitude: 12.33086,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33086, 45.43448]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31592223,
        name: "Appartamento sai view canal",
        host_id: 35689579,
        host_name: "Haleh",
        latitude: 45.43684,
        longitude: 12.31781,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31781, 45.43684]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31605259,
        name: "Charming apartment in quiet but central area",
        host_id: 41684464,
        host_name: "VeneziaImmobiliare Sas Di",
        latitude: 45.44478,
        longitude: 12.32022,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32022, 45.44478]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31605923,
        name: "Venice in love - Appartamento Le Terrazze",
        host_id: 235434745,
        host_name: "Irene",
        latitude: 45.4342,
        longitude: 12.33111,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33111, 45.4342]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31606029,
        name: "Lovely nest Frari",
        host_id: 236933780,
        host_name: "Ares",
        latitude: 45.43605,
        longitude: 12.32739,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32739, 45.43605]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31606731,
        name: "Angel of Rio Marin,  Apartment with canal-view",
        host_id: 236934615,
        host_name: "Marina",
        latitude: 45.43937,
        longitude: 12.32372,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32372, 45.43937]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31608832,
        name: "Venice in love - Appartamento Rosso",
        host_id: 235434745,
        host_name: "Irene",
        latitude: 45.43511,
        longitude: 12.33132,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33132, 45.43511]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31611142,
        name: "Elegant apartment for 6 (Appa 4)",
        host_id: 205703685,
        host_name: "Bricola",
        latitude: 45.43161,
        longitude: 12.35246,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35246, 45.43161]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31611251,
        name: "Bright San Marco Suite - Wi-fi & wasching machine",
        host_id: 179298782,
        host_name: "Sabrina",
        latitude: 45.43398,
        longitude: 12.33689,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33689, 45.43398]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31615335,
        name: "Golden Suite - Ca' del Figher",
        host_id: 237006141,
        host_name: "Gabriele",
        latitude: 45.43759,
        longitude: 12.332,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.332, 45.43759]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31630375,
        name: "Arsenal prestige, washer & WiFi - family/friends",
        host_id: 179298782,
        host_name: "Sabrina",
        latitude: 45.43628,
        longitude: 12.3482,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3482, 45.43628]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31632665,
        name: "Apartment Vivaldi",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.4385,
        longitude: 12.34629,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34629, 45.4385]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31634443,
        name: "Ca' del Mistero, the charm of the hidden Venice",
        host_id: 294951,
        host_name: "VeniceVillas Di Enzo",
        latitude: 45.44252,
        longitude: 12.33327,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33327, 45.44252]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31635445,
        name: "Silver Suite Ca' del Figher",
        host_id: 237177948,
        host_name: "Gabriele",
        latitude: 45.43789,
        longitude: 12.32994,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32994, 45.43789]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31636011,
        name: "DADA in City Center",
        host_id: 237182372,
        host_name: "Veronica",
        latitude: 45.4426,
        longitude: 12.33597,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33597, 45.4426]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31637350,
        name: "Rialto Penthouse friends &families-washing machine",
        host_id: 179297180,
        host_name: "Chiara",
        latitude: 45.43714,
        longitude: 12.33368,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33368, 45.43714]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31638126,
        name: "Refined San Marco Deluxe - Wifi & washing machine",
        host_id: 179297180,
        host_name: "Chiara",
        latitude: 45.43496,
        longitude: 12.33934,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33934, 45.43496]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31639878,
        name: "Cà Marcello- BIENNALE",
        host_id: 237207073,
        host_name: "Federico",
        latitude: 45.43267,
        longitude: 12.35535,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35535, 45.43267]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31640251,
        name: "Superior double Room in Venice + private bath+ AC",
        host_id: 18151381,
        host_name: "Fran",
        latitude: 45.44491,
        longitude: 12.32859,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32859, 45.44491]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31641546,
        name: "Charming mini-apartment near Biennale Gardens",
        host_id: 40297985,
        host_name: "Annina",
        latitude: 45.43137,
        longitude: 12.3556,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3556, 45.43137]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31641549,
        name: "ca malia",
        host_id: 6759756,
        host_name: "Rudi",
        latitude: 45.44349,
        longitude: 12.3293,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3293, 45.44349]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31657977,
        name: "ExclusiVenice San Stae 1976",
        host_id: 235305051,
        host_name: "Massimo",
        latitude: 45.44048,
        longitude: 12.32957,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32957, 45.44048]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31661947,
        name: "Venezia bella, affaccio su calli e campielli",
        host_id: 294951,
        host_name: "VeniceVillas Di Enzo",
        latitude: 45.44714,
        longitude: 12.32008,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32008, 45.44714]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31662249,
        name: "Apartment on the Grand Canal: the real Venice!",
        host_id: 179326998,
        host_name: "Marta & Chiara",
        latitude: 45.4436,
        longitude: 12.32591,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32591, 45.4436]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31662298,
        name: "Apartment Brunella Venetian Style",
        host_id: 237393798,
        host_name: "Massimo",
        latitude: 45.43695,
        longitude: 12.32791,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32791, 45.43695]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31663433,
        name: "Ca Bacio della Luna",
        host_id: 237399461,
        host_name: "Alberto",
        latitude: 45.43292,
        longitude: 12.32977,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32977, 45.43292]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31669467,
        name: "Charming Waterfront Home",
        host_id: 237450726,
        host_name: "Allegra",
        latitude: 45.44441,
        longitude: 12.33312,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33312, 45.44441]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31677653,
        name: "Bellissima casa vicino Biennale grande Terrazza !",
        host_id: 104746063,
        host_name: "Ilaria",
        latitude: 45.43502,
        longitude: 12.3474,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3474, 45.43502]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31682899,
        name: "CASA MORESCA, cozy apartment close to Rialto",
        host_id: 237572060,
        host_name: "Francesco",
        latitude: 45.43725,
        longitude: 12.33773,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33773, 45.43725]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31683937,
        name: "Biennale design, on the mezzanine with Wi-Fi",
        host_id: 179298782,
        host_name: "Sabrina",
        latitude: 45.43069,
        longitude: 12.35502,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35502, 45.43069]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31684373,
        name: "Balcony Biennale Suite ideal for families, Wi-fi",
        host_id: 179298782,
        host_name: "Sabrina",
        latitude: 45.43211,
        longitude: 12.3517,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3517, 45.43211]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31711897,
        name: "Ca' Gemma",
        host_id: 237858571,
        host_name: "Tommaso",
        latitude: 45.44085,
        longitude: 12.32475,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32475, 45.44085]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31724825,
        name: "Modern Apartment Arsenale/San Marco with Wi-fi",
        host_id: 179298782,
        host_name: "Sabrina",
        latitude: 45.43524,
        longitude: 12.34788,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34788, 45.43524]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31727934,
        name: "Ca'Elena",
        host_id: 237998662,
        host_name: "Allegra",
        latitude: 45.43781,
        longitude: 12.33709,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33709, 45.43781]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31730906,
        name: "Great price! Apartment with washing machine",
        host_id: 179326998,
        host_name: "Marta & Chiara",
        latitude: 45.44186,
        longitude: 12.34244,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34244, 45.44186]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31731975,
        name: "Campo della Bragora - Duplex near San Marco",
        host_id: 179326998,
        host_name: "Marta & Chiara",
        latitude: 45.43542,
        longitude: 12.34752,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34752, 45.43542]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31733458,
        name: "EsclusiVenice Museum 1783",
        host_id: 235305051,
        host_name: "Massimo",
        latitude: 45.44022,
        longitude: 12.32836,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32836, 45.44022]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31733642,
        name: "Home Venice Apartments - Biennale 2",
        host_id: 7619802,
        host_name: "Stefania",
        latitude: 45.43088,
        longitude: 12.35521,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35521, 45.43088]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31742263,
        name: "Charming studio next the laguna, 8' from S. Marcos",
        host_id: 11466318,
        host_name: "Gabriele",
        latitude: 45.43206,
        longitude: 12.35251,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35251, 45.43206]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31773606,
        name: "In the typical Venice, with washer, Wi-Fi & A/C",
        host_id: 179326998,
        host_name: "Marta & Chiara",
        latitude: 45.44353,
        longitude: 12.32655,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32655, 45.44353]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31774075,
        name: "Santa Margherita (L.T. M (Phone number hidden by Airbnb)",
        host_id: 5618111,
        host_name: "EasySuite",
        latitude: 45.43253,
        longitude: 12.32091,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32091, 45.43253]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31774413,
        name: "Venetian house with terrace, oven and WIFI",
        host_id: 179326998,
        host_name: "Marta & Chiara",
        latitude: 45.44343,
        longitude: 12.3274,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3274, 45.44343]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31774605,
        name: "Duplex in S. Marco - ancient palace of the Doges",
        host_id: 179326998,
        host_name: "Marta & Chiara",
        latitude: 45.43456,
        longitude: 12.34797,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34797, 45.43456]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31775006,
        name: "Dreaming On The Water (L.T. M (Phone number hidden by Airbnb)",
        host_id: 5618111,
        host_name: "EasySuite",
        latitude: 45.44538,
        longitude: 12.33192,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33192, 45.44538]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31775920,
        name: "San Moisè",
        host_id: 179326998,
        host_name: "Marta & Chiara",
        latitude: 45.43203,
        longitude: 12.33421,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33421, 45.43203]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31776221,
        name: "Canal view in Cannaregio: great for families",
        host_id: 179326998,
        host_name: "Marta & Chiara",
        latitude: 45.44665,
        longitude: 12.32674,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32674, 45.44665]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31777107,
        name: "STEFANIA",
        host_id: 159552785,
        host_name: "Stefania",
        latitude: 45.43326,
        longitude: 12.33356,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33356, 45.43326]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31777219,
        name: "Sunny on Canal a/c wifi",
        host_id: 4258092,
        host_name: "Sebastiano",
        latitude: 45.43318,
        longitude: 12.32273,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32273, 45.43318]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31777445,
        name: "Alle Guglie: washing machine,large room,WIFI & A/C",
        host_id: 179326998,
        host_name: "Marta & Chiara",
        latitude: 45.44318,
        longitude: 12.32714,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32714, 45.44318]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31777774,
        name: "Rialto Deluxe 2 bedrooms, washer & WIFI",
        host_id: 179326998,
        host_name: "Marta & Chiara",
        latitude: 45.44144,
        longitude: 12.34021,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34021, 45.44144]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31778421,
        name: "Arsenale ground floor canal view, washer & Wi-fi",
        host_id: 179298782,
        host_name: "Sabrina",
        latitude: 45.43732,
        longitude: 12.34611,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34611, 45.43732]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31781299,
        name: "Comfort Biennale with canal view & washing machine",
        host_id: 179298782,
        host_name: "Sabrina",
        latitude: 45.43532,
        longitude: 12.35756,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35756, 45.43532]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31796107,
        name: "Walk on the water ✧ 5 minutes to Rialto Bridge",
        host_id: 237423271,
        host_name: "Alvise",
        latitude: 45.43913,
        longitude: 12.32977,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32977, 45.43913]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31796899,
        name:
          'Ada\'s Hous (Website hidden by Airbnb) near the "3 Arches" bridge',
        host_id: 238280449,
        host_name: "Antonella",
        latitude: 45.44689,
        longitude: 12.31974,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31974, 45.44689]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31799508,
        name: "Angel of Bonlini in the museum district",
        host_id: 236934615,
        host_name: "Marina",
        latitude: 45.42983,
        longitude: 12.32501,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32501, 45.42983]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31805486,
        name: "ExclusiVenice Castle 1536",
        host_id: 235305051,
        host_name: "Massimo",
        latitude: 45.43312,
        longitude: 12.3543,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3543, 45.43312]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31814162,
        name: "Design Suite Apartment close to St. Mark's Square",
        host_id: 33055304,
        host_name: "San Marco Suite 755",
        latitude: 45.43541,
        longitude: 12.33722,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33722, 45.43541]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31816616,
        name: "Ca'Zane with canal and city view",
        host_id: 632312,
        host_name: "Guillaume",
        latitude: 45.44417,
        longitude: 12.3327,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3327, 45.44417]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31819543,
        name: "Residence Giulietta",
        host_id: 238463812,
        host_name: "Fabio",
        latitude: 45.4389,
        longitude: 12.34596,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34596, 45.4389]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31820320,
        name: "RENATO",
        host_id: 159552785,
        host_name: "Stefania",
        latitude: 45.43248,
        longitude: 12.33448,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33448, 45.43248]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31822938,
        name: "Ca' Vallaresso_living San Marco Square!",
        host_id: 238490869,
        host_name: "Ruggero",
        latitude: 45.43337,
        longitude: 12.33431,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33431, 45.43337]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31845241,
        name: "Suite Superior Apartment close to S. Mark's Square",
        host_id: 33055304,
        host_name: "San Marco Suite 755",
        latitude: 45.43487,
        longitude: 12.3383,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3383, 45.43487]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31845443,
        name: "Suite Superior Apartment 300mt St Mark's Square",
        host_id: 33055304,
        host_name: "San Marco Suite 755",
        latitude: 45.4362,
        longitude: 12.33694,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33694, 45.4362]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31846624,
        name: "ANDREA",
        host_id: 159552785,
        host_name: "Stefania",
        latitude: 45.43297,
        longitude: 12.33542,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33542, 45.43297]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31849017,
        name: '"Biennale Palace" close to Piazza S. Marco',
        host_id: 169292841,
        host_name: "Anis",
        latitude: 45.43587,
        longitude: 12.34239,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34239, 45.43587]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31850212,
        name: "IN THE HEART OF VENICE TO FEEL A TRUE VENETIAN",
        host_id: 238697899,
        host_name: "Elisa",
        latitude: 45.43564,
        longitude: 12.33909,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33909, 45.43564]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31850678,
        name: "Welcome to Venice",
        host_id: 97365023,
        host_name: "Camilla",
        latitude: 45.43287,
        longitude: 12.33219,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33219, 45.43287]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31851319,
        name: "Bright and Chic Studio/Apartment Zattere Dorsoduro",
        host_id: 238706298,
        host_name: "Veronica",
        latitude: 45.43102,
        longitude: 12.32199,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32199, 45.43102]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31867391,
        name: "Lovely silent large in authentuc Venice c",
        host_id: 31276705,
        host_name: "Mila",
        latitude: 45.43508,
        longitude: 12.35833,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35833, 45.43508]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31873116,
        name: "ANGEL'S HOUSE - AMAZINGLY QUIET AND ROMANTIC!",
        host_id: 3880254,
        host_name: "Sabina",
        latitude: 45.43087,
        longitude: 12.31985,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31985, 45.43087]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31873365,
        name: "San Marco  Design (250mt. from St Mark's Square)",
        host_id: 237393798,
        host_name: "Massimo",
        latitude: 45.43488,
        longitude: 12.33483,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33483, 45.43488]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31884427,
        name: "ExclusiVenice Ca D’oro 3817",
        host_id: 235305051,
        host_name: "Massimo",
        latitude: 45.44237,
        longitude: 12.33495,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33495, 45.44237]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31898990,
        name: "New beautiful suite near Biennale",
        host_id: 197975616,
        host_name: "Olga",
        latitude: 45.43146,
        longitude: 12.35394,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35394, 45.43146]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31902491,
        name: "Camera Matrimoniale in Hotel Palazzo del Giglio",
        host_id: 30306616,
        host_name: "Gaetano",
        latitude: 45.43317,
        longitude: 12.33233,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33233, 45.43317]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31913168,
        name: "CA ELISA ARSENALE SUITE - WIFI FREE",
        host_id: 21797121,
        host_name: "Thomas",
        latitude: 45.43479,
        longitude: 12.34694,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34694, 45.43479]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31916200,
        name: "Casa Gioia Suite 5",
        host_id: 239268265,
        host_name: "Marianna",
        latitude: 45.4445,
        longitude: 12.331,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.331, 45.4445]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31923796,
        name: "Out of Blue - in the heart of Venice",
        host_id: 18941018,
        host_name: "Enrico",
        latitude: 45.44632,
        longitude: 12.32384,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32384, 45.44632]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31924809,
        name: "Casa Gioia Suite 2",
        host_id: 239268265,
        host_name: "Marianna",
        latitude: 45.44421,
        longitude: 12.3331,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3331, 45.44421]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31928697,
        name: "Casa Gioia Suite 1",
        host_id: 239268265,
        host_name: "Marianna",
        latitude: 45.44244,
        longitude: 12.33276,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33276, 45.44244]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31928702,
        name: "Casa Gioia Suite 4",
        host_id: 239268265,
        host_name: "Marianna",
        latitude: 45.44241,
        longitude: 12.33264,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33264, 45.44241]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31928709,
        name: "Casa Gioia Suite 3",
        host_id: 239268265,
        host_name: "Marianna",
        latitude: 45.44378,
        longitude: 12.33187,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33187, 45.44378]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31940541,
        name: "Venetian style in San Marco - Canal view",
        host_id: 179326998,
        host_name: "Marta & Chiara",
        latitude: 45.43234,
        longitude: 12.33178,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33178, 45.43234]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31941985,
        name: "Canal view at the Arsenale: in the heart of Venice",
        host_id: 179326998,
        host_name: "Marta & Chiara",
        latitude: 45.43599,
        longitude: 12.34835,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34835, 45.43599]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31943610,
        name: "Cannaregio Design:washing machine & WiFi-1st floor",
        host_id: 179326998,
        host_name: "Marta & Chiara",
        latitude: 45.44388,
        longitude: 12.32997,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32997, 45.44388]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31967578,
        name: "100 meters from Piazza San Marco! 2-bedroom flat",
        host_id: 179326998,
        host_name: "Marta & Chiara",
        latitude: 45.43401,
        longitude: 12.33756,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33756, 45.43401]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31968385,
        name: "Luxury flat in Castello: 2 bedrooms & 2 bathrooms",
        host_id: 179326998,
        host_name: "Marta & Chiara",
        latitude: 45.43516,
        longitude: 12.34579,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34579, 45.43516]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31970072,
        name: "Double room with PRIVATE BATHROOM / AC / wi-fi",
        host_id: 239703097,
        host_name: "Martina",
        latitude: 45.42527,
        longitude: 12.32658,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32658, 45.42527]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31971963,
        name: "Ideal location for visiting Venice on foot",
        host_id: 179326998,
        host_name: "Marta & Chiara",
        latitude: 45.44134,
        longitude: 12.34051,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34051, 45.44134]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31973632,
        name: "RIALTO - 2 BRM wit (Website hidden by Airbnb) free Wi-Fi",
        host_id: 179326998,
        host_name: "Marta & Chiara",
        latitude: 45.44272,
        longitude: 12.33561,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33561, 45.44272]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31980808,
        name: "Ca' Cavalier in the Real Venice AC / Wi-Fi",
        host_id: 239755665,
        host_name: "Luca",
        latitude: 45.43637,
        longitude: 12.3482,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3482, 45.43637]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31989293,
        name: "Romantica vista sul canale.",
        host_id: 239840822,
        host_name: "Gabriella",
        latitude: 45.44418,
        longitude: 12.33108,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33108, 45.44418]] },
    },
    {
      type: "Feature",
      properties: {
        id: 31999215,
        name: "Bright apartment for families, great canalview",
        host_id: 179297180,
        host_name: "Chiara",
        latitude: 45.434,
        longitude: 12.35576,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35576, 45.434]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32001484,
        name: "Romantic Venice apartment",
        host_id: 35279206,
        host_name: "LMV - Exclusive Venice Apartments",
        latitude: 45.43449,
        longitude: 12.3317,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3317, 45.43449]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32001488,
        name: "San Marco apartment with canal views",
        host_id: 35279206,
        host_name: "LMV - Exclusive Venice Apartments",
        latitude: 45.43383,
        longitude: 12.33573,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33573, 45.43383]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32001492,
        name: "San Marco attic apartment",
        host_id: 35279206,
        host_name: "LMV - Exclusive Venice Apartments",
        latitude: 45.43219,
        longitude: 12.33029,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33029, 45.43219]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32001579,
        name: "10 Min. from S. Marco-wahser, wi-fi, A/C",
        host_id: 179297180,
        host_name: "Chiara",
        latitude: 45.43708,
        longitude: 12.34656,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34656, 45.43708]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32004094,
        name: "Ca' Bea Venezia - Deluxe Room",
        host_id: 239945746,
        host_name: "Federico",
        latitude: 45.43287,
        longitude: 12.32041,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32041, 45.43287]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32005730,
        name: "Near the station and with a wonderful canal view",
        host_id: 179298782,
        host_name: "Sabrina",
        latitude: 45.43809,
        longitude: 12.32363,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32363, 45.43809]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32006313,
        name: "Corte Briani - Courtyard Room - Aircon&Laundry",
        host_id: 25085773,
        host_name: "Gin",
        latitude: 45.44404,
        longitude: 12.32926,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32926, 45.44404]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32006451,
        name: "Belvedere - Cannaregio, apartment with canalview",
        host_id: 179298782,
        host_name: "Sabrina",
        latitude: 45.44604,
        longitude: 12.32659,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32659, 45.44604]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32006644,
        name: "Ca' Bea Venezia - Deluxe King Room",
        host_id: 239945746,
        host_name: "Federico",
        latitude: 45.43289,
        longitude: 12.32049,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32049, 45.43289]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32007051,
        name: "Ca Briani - Double Room - Laundry/Aircon/Safe",
        host_id: 25085773,
        host_name: "Gin",
        latitude: 45.44541,
        longitude: 12.32889,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32889, 45.44541]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32011427,
        name: "Gondolier's house - 10' from St. Mark Square",
        host_id: 239994907,
        host_name: "Nina",
        latitude: 45.43636,
        longitude: 12.34743,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34743, 45.43636]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32013678,
        name: "Ca' del Principe - Your magic Honeymoon",
        host_id: 240018962,
        host_name: "Laura&Alberto",
        latitude: 45.44042,
        longitude: 12.32326,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32326, 45.44042]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32015610,
        name: "Venetian Studio",
        host_id: 14529918,
        host_name: "Massimiliano",
        latitude: 45.43765,
        longitude: 12.32827,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32827, 45.43765]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32017156,
        name: "TRUE VENICE near RIALTO and ST. MARK'S",
        host_id: 16843824,
        host_name: "Marinella",
        latitude: 45.43998,
        longitude: 12.34086,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34086, 45.43998]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32027559,
        name: "Superior Maison Venitienne near Rialto",
        host_id: 179298782,
        host_name: "Sabrina",
        latitude: 45.4415,
        longitude: 12.34102,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34102, 45.4415]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32028048,
        name: "Biennale canal view, washing machine -for couples",
        host_id: 179298782,
        host_name: "Sabrina",
        latitude: 45.43471,
        longitude: 12.35887,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35887, 45.43471]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32028891,
        name: "Nice studio for 2 ideal to visit Venice",
        host_id: 11505507,
        host_name: "Alexandra",
        latitude: 45.44337,
        longitude: 12.31882,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31882, 45.44337]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32029064,
        name: "Wonderful loft for 2 people in Venice",
        host_id: 11505507,
        host_name: "Alexandra",
        latitude: 45.44278,
        longitude: 12.31893,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31893, 45.44278]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32029319,
        name: "Apartment Modern Design",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.4435,
        longitude: 12.33244,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33244, 45.4435]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32030713,
        name: "Amazing 2bdr for 4 people w/terrace, Venice",
        host_id: 11505507,
        host_name: "Alexandra",
        latitude: 45.44422,
        longitude: 12.32044,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32044, 45.44422]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32033252,
        name: "Wonderful panoramique 3bdr w/terrace, Venice",
        host_id: 11505507,
        host_name: "Alexandra",
        latitude: 45.44246,
        longitude: 12.3206,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3206, 45.44246]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32033854,
        name: "Beautiful 3bdr apartment 2 levels, Venice",
        host_id: 11505507,
        host_name: "Alexandra",
        latitude: 45.4426,
        longitude: 12.31974,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31974, 45.4426]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32038022,
        name: "Santa Giustina suite - 5 mins from Rialto bridge!",
        host_id: 73934712,
        host_name: "Tour Apartments",
        latitude: 45.43866,
        longitude: 12.34615,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34615, 45.43866]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32038676,
        name: "J A STUDIO SUPERIOR - THE DEPENDANCE",
        host_id: 92620149,
        host_name: "Samy",
        latitude: 45.43457,
        longitude: 12.32999,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32999, 45.43457]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32055908,
        name: "Ca' Rettore Rialto Prestige",
        host_id: 294951,
        host_name: "VeniceVillas Di Enzo",
        latitude: 45.43952,
        longitude: 12.33419,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33419, 45.43952]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32059818,
        name: "New room+ private bath near bus/train/boat stop",
        host_id: 18151381,
        host_name: "Fran",
        latitude: 45.44548,
        longitude: 12.32701,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32701, 45.44548]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32062453,
        name: "San Marco Terrace (100mt. from St. Mark's Square)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.43479,
        longitude: 12.33979,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33979, 45.43479]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32063043,
        name: "J A COLLECTION-CUORIDORO PALACE-PRESIDENTIAL SUITE",
        host_id: 92620149,
        host_name: "Samy",
        latitude: 45.43512,
        longitude: 12.33442,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33442, 45.43512]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32067600,
        name: "Art’s Biennale",
        host_id: 50739522,
        host_name: "Hanna",
        latitude: 45.43073,
        longitude: 12.35398,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35398, 45.43073]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32077336,
        name: "Casa Stainer Camera bagno esterno esclusivo",
        host_id: 240563683,
        host_name: "Mario",
        latitude: 45.43599,
        longitude: 12.34155,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34155, 45.43599]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32082447,
        name: "Casanora: in the heart of Venice",
        host_id: 31578183,
        host_name: "Riccardo",
        latitude: 45.43511,
        longitude: 12.3476,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3476, 45.43511]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32083791,
        name: "ExclusiVenice the true Venice 134",
        host_id: 235305051,
        host_name: "Massimo",
        latitude: 45.43005,
        longitude: 12.33395,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33395, 45.43005]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32100114,
        name: "Uno sguardo sull'Arsenale",
        host_id: 7358358,
        host_name: "Giulia",
        latitude: 45.43281,
        longitude: 12.34987,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34987, 45.43281]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32101689,
        name: "alle guglie",
        host_id: 240801218,
        host_name: "Massimo",
        latitude: 45.44425,
        longitude: 12.32567,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32567, 45.44425]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32117401,
        name: "Amazing View on Grand Canal (Apt. Oro)",
        host_id: 237393798,
        host_name: "Massimo",
        latitude: 45.44184,
        longitude: 12.33211,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33211, 45.44184]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32122830,
        name: "Residenza d'artista next to Biennale",
        host_id: 241001823,
        host_name: "Gabriella",
        latitude: 45.43228,
        longitude: 12.35467,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35467, 45.43228]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32123005,
        name: "In the heart of Venice! 2 bedrooms & 2 bathrooms",
        host_id: 241002392,
        host_name: "Nico",
        latitude: 45.44294,
        longitude: 12.3274,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3274, 45.44294]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32125615,
        name: "Residence MCS (50 mt from St. Mark's Square)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.43261,
        longitude: 12.33566,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33566, 45.43261]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32126353,
        name: "J A COLLECTION -CUORIDORO PALACE- THE ROYAL SUITE",
        host_id: 92620149,
        host_name: "Samy",
        latitude: 45.43528,
        longitude: 12.33625,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33625, 45.43528]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32135840,
        name: "Romantic Attic In The Historical Center",
        host_id: 241079630,
        host_name: "Nico",
        latitude: 45.43436,
        longitude: 12.32412,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32412, 45.43436]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32139264,
        name: "J A COLLECTION -CUORIDORO PALACE- AMBASSADOR SUITE",
        host_id: 92620149,
        host_name: "Samy",
        latitude: 45.4339,
        longitude: 12.33499,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33499, 45.4339]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32150019,
        name: "Casa Stainer Camera bagno interno",
        host_id: 240563683,
        host_name: "Mario",
        latitude: 45.43636,
        longitude: 12.34205,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34205, 45.43636]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32151497,
        name: "Casa Alessandra (L.T. M (Phone number hidden by Airbnb)",
        host_id: 5618111,
        host_name: "EasySuite",
        latitude: 45.44535,
        longitude: 12.33235,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33235, 45.44535]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32161928,
        name: "SAN MAURIZIO HOUSE Sestiere San Marco Venice",
        host_id: 241274064,
        host_name: "Enrico",
        latitude: 45.43381,
        longitude: 12.33182,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33182, 45.43381]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32175030,
        name: "“CA' ANDREA GRITTI ”  DORSODURO S.VIO",
        host_id: 185800709,
        host_name: "Claudio",
        latitude: 45.4302,
        longitude: 12.32989,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32989, 45.4302]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32179827,
        name: "Biennale-apt with 2 bathrooms, families or friends",
        host_id: 179298782,
        host_name: "Sabrina",
        latitude: 45.43354,
        longitude: 12.35204,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35204, 45.43354]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32181223,
        name: "Appartamento signorile a Dorsoduro",
        host_id: 105410596,
        host_name: "Francesca",
        latitude: 45.43612,
        longitude: 12.32527,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32527, 45.43612]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32183486,
        name: "Big & Bright Panoramic Apt in the heart of Venezia",
        host_id: 22884126,
        host_name: "Giugi",
        latitude: 45.43983,
        longitude: 12.33777,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33777, 45.43983]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32187713,
        name: "Venice Dreams Home",
        host_id: 241514204,
        host_name: "Shah",
        latitude: 45.4366,
        longitude: 12.32421,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32421, 45.4366]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32192026,
        name:
          "Modern Italian style furnished apartment in a charming corner of peace and tranquillity, with a beautiful garden",
        host_id: 213326446,
        host_name: "Carina E-Domizil",
        latitude: 45.44445,
        longitude: 12.32233,
        beds: 7,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32233, 45.44445]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32201552,
        name: "VENICE SKYLINE VIEW STUDIO APARTMENT",
        host_id: 5862083,
        host_name: "Silvia",
        latitude: 45.44034,
        longitude: 12.33564,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33564, 45.44034]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32201660,
        name: "EXCLUSIVE APARTMENT IN THE HEART OF VENICE",
        host_id: 65007872,
        host_name: "Silvia",
        latitude: 45.4336,
        longitude: 12.32796,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32796, 45.4336]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32206399,
        name: 'Venetian Cottage "La Casetta"',
        host_id: 141994095,
        host_name: "Matteo",
        latitude: 45.43594,
        longitude: 12.32157,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32157, 45.43594]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32230278,
        name: "Sole&Luna Residence Design",
        host_id: 236232387,
        host_name: "Francesco",
        latitude: 45.43193,
        longitude: 12.32603,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32603, 45.43193]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32232290,
        name: "Ca' Luna Residence Design",
        host_id: 236232387,
        host_name: "Francesco",
        latitude: 45.43203,
        longitude: 12.32596,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32596, 45.43203]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32234113,
        name: "Corner Palace Venetian Style (6 people)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.43763,
        longitude: 12.3294,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3294, 45.43763]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32236160,
        name: "CA' GIULIA APARTMENT VENICE",
        host_id: 5862083,
        host_name: "Silvia",
        latitude: 45.44072,
        longitude: 12.32867,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32867, 45.44072]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32241178,
        name: "MODERN FLAT IN SAN MARCO 2ND",
        host_id: 401113,
        host_name: "Elia",
        latitude: 45.43499,
        longitude: 12.33551,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33551, 45.43499]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32241535,
        name: "MODERN FLAT IN SAN MARCO - 3RD",
        host_id: 401113,
        host_name: "Elia",
        latitude: 45.43333,
        longitude: 12.33483,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33483, 45.43333]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32249176,
        name: "San Lorenzo apartment",
        host_id: 22940319,
        host_name: "Albatroservices",
        latitude: 45.4362,
        longitude: 12.34501,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34501, 45.4362]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32250707,
        name: "Venice/ central studio with private terrace",
        host_id: 231775592,
        host_name: "Judite & Beatrice",
        latitude: 45.44505,
        longitude: 12.3183,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3183, 45.44505]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32251017,
        name: "CA' STEFANIA APARTMENT VENICE",
        host_id: 5862083,
        host_name: "Silvia",
        latitude: 45.43267,
        longitude: 12.35489,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35489, 45.43267]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32251435,
        name: "Venice/ Spacious and bright apartment",
        host_id: 231775592,
        host_name: "Judite & Beatrice",
        latitude: 45.4451,
        longitude: 12.31884,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31884, 45.4451]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32251649,
        name: "Romantic Apartment Ca' D'Oro - 5' from Rialto",
        host_id: 198372304,
        host_name: "Alessandro",
        latitude: 45.44258,
        longitude: 12.337,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.337, 45.44258]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32252273,
        name: "Casa Madda Centro Storico Castello Venezia",
        host_id: 239494912,
        host_name: "Maddalena E Valentina",
        latitude: 45.43736,
        longitude: 12.34994,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34994, 45.43736]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32252303,
        name: "BEAUTIFUL LOFT IN THE HEART OF VENICE",
        host_id: 231775592,
        host_name: "Judite & Beatrice",
        latitude: 45.44507,
        longitude: 12.31892,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31892, 45.44507]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32268739,
        name: "Accessible and Convenient Venice",
        host_id: 241219411,
        host_name: "Marco",
        latitude: 45.43753,
        longitude: 12.31853,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31853, 45.43753]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32276749,
        name: "AI FRADEI boutique apartament",
        host_id: 47967886,
        host_name: "Barnaba",
        latitude: 45.43789,
        longitude: 12.33183,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33183, 45.43789]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32287004,
        name: "TERRASSE - VUE IMPRENABLE. Au coeur de Venise",
        host_id: 10260050,
        host_name: "Pierre Marie",
        latitude: 45.43518,
        longitude: 12.35695,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35695, 45.43518]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32297810,
        name: "Giorgione room",
        host_id: 197975616,
        host_name: "Olga",
        latitude: 45.432,
        longitude: 12.35236,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35236, 45.432]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32298521,
        name: "Residence canal view - Biennale",
        host_id: 179298782,
        host_name: "Sabrina",
        latitude: 45.43398,
        longitude: 12.35738,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35738, 45.43398]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32298571,
        name: "Ca' Lunetta - 5' from St. Mark Square",
        host_id: 242451356,
        host_name: "Lara",
        latitude: 45.43648,
        longitude: 12.33925,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33925, 45.43648]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32298943,
        name: "✯Fontego House✯ Live a great experience!",
        host_id: 241894873,
        host_name: "Luisa",
        latitude: 45.43853,
        longitude: 12.34565,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34565, 45.43853]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32299117,
        name: "Cannaregio - Large flat 2 bedrooms/2 bathrooms",
        host_id: 179326998,
        host_name: "Marta & Chiara",
        latitude: 45.44285,
        longitude: 12.32203,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32203, 45.44285]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32299617,
        name: "Canal view near the Guggenheim-Dorsoduro",
        host_id: 179326998,
        host_name: "Marta & Chiara",
        latitude: 45.42953,
        longitude: 12.32846,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32846, 45.42953]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32301497,
        name:
          "Ca'Del Fontego-LUXURY GRAND CANAL(L.T.M (Phone number hidden by Airbnb)",
        host_id: 5618111,
        host_name: "EasySuite",
        latitude: 45.44169,
        longitude: 12.32769,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32769, 45.44169]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32312902,
        name: "Ca Patricia, luxury apartment near San Marco",
        host_id: 242543989,
        host_name: "Patricia & Marc",
        latitude: 45.43777,
        longitude: 12.34488,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34488, 45.43777]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32322762,
        name: "Ca' Alberto Apartment 1",
        host_id: 46904188,
        host_name: "Mirco Optyflat",
        latitude: 45.43747,
        longitude: 12.34063,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34063, 45.43747]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32323055,
        name: "Ca' Alberto Apartments 2",
        host_id: 46904188,
        host_name: "Mirco Optyflat",
        latitude: 45.43693,
        longitude: 12.33907,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33907, 45.43693]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32346572,
        name: "Calle del Forno Apartment",
        host_id: 242868135,
        host_name: "Francesca",
        latitude: 45.44591,
        longitude: 12.32862,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32862, 45.44591]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32348341,
        name: "Sunrise Apartment in Giudecca",
        host_id: 242868135,
        host_name: "Francesca",
        latitude: 45.42381,
        longitude: 12.32844,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32844, 45.42381]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32351869,
        name: "Bella Venezia",
        host_id: 241514204,
        host_name: "Shah",
        latitude: 45.43683,
        longitude: 12.32228,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32228, 45.43683]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32358526,
        name: "Ca' Badoer - San Rocco",
        host_id: 108848739,
        host_name: "Frari 2000 S.A.S.",
        latitude: 45.43518,
        longitude: 12.32415,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32415, 45.43518]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32364252,
        name: "Mezzanino 4438",
        host_id: 243009673,
        host_name: "Paola",
        latitude: 45.44163,
        longitude: 12.33587,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33587, 45.44163]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32372918,
        name: "Sky-Silver Apartment in Rialto - High Tide Exempt",
        host_id: 29706566,
        host_name: "Margherita & Valentina",
        latitude: 45.43949,
        longitude: 12.3313,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3313, 45.43949]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32373678,
        name: "W Venezia 1",
        host_id: 1719616,
        host_name: "Biancamaria",
        latitude: 45.43945,
        longitude: 12.32726,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32726, 45.43945]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32390042,
        name: "Sant' Elena Holiday House. 5min far from Biennale",
        host_id: 52208767,
        host_name: "Lorenzo",
        latitude: 45.42763,
        longitude: 12.36118,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.36118, 45.42763]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32390923,
        name: "Appartamento silenzioso  confortevole con WIFI",
        host_id: 243234944,
        host_name: "Benedetta",
        latitude: 45.44103,
        longitude: 12.32884,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32884, 45.44103]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32392983,
        name: "Welc-om Tre archi rooms",
        host_id: 20717796,
        host_name: "Welc-Om",
        latitude: 45.44472,
        longitude: 12.32343,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32343, 45.44472]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32393777,
        name: "Traditional flat 5 minutes from train Station",
        host_id: 674749,
        host_name: "Riccardo",
        latitude: 45.44012,
        longitude: 12.32605,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32605, 45.44012]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32393904,
        name: "Suite Santacroce, 5 min. from Train - San Stae",
        host_id: 139627704,
        host_name: "Giusy & Fabrizio",
        latitude: 45.44087,
        longitude: 12.32832,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32832, 45.44087]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32394034,
        name: "DolceVita Apartments N. 432 Biennale",
        host_id: 8176475,
        host_name: "Eugenia",
        latitude: 45.43198,
        longitude: 12.35329,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35329, 45.43198]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32395920,
        name: "Residenza Valier 2 bedrooms 2 bathrooms - RIALTO",
        host_id: 289615,
        host_name: "Valentina",
        latitude: 45.43723,
        longitude: 12.33219,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33219, 45.43723]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32396047,
        name: 'Cozy Apartment "La Tana" in Campo San Maurizio',
        host_id: 669047,
        host_name: "Viewsonvenice",
        latitude: 45.43241,
        longitude: 12.33363,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33363, 45.43241]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32396809,
        name: "Ca' Achille Santa Croce wifi",
        host_id: 15112827,
        host_name: "Marco",
        latitude: 45.43945,
        longitude: 12.32726,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32726, 45.43945]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32397651,
        name: "Beautiful appartament in the Heart of Venice",
        host_id: 231616654,
        host_name: "Emanuela Sabrina",
        latitude: 45.44075,
        longitude: 12.32903,
        beds: 7,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32903, 45.44075]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32398905,
        name: '"ai miracoli" strategic apartment',
        host_id: 3471848,
        host_name: "Devid",
        latitude: 45.43903,
        longitude: 12.33854,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33854, 45.43903]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32410664,
        name: "Mercà",
        host_id: 174418896,
        host_name: "Mimax",
        latitude: 45.43939,
        longitude: 12.33363,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33363, 45.43939]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32413922,
        name: "Welc-om Cannaregio room",
        host_id: 20717796,
        host_name: "Welc-Om",
        latitude: 45.44516,
        longitude: 12.32341,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32341, 45.44516]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32414368,
        name: "Welc-om Tre Archi rooms",
        host_id: 20717796,
        host_name: "Welc-Om",
        latitude: 45.44637,
        longitude: 12.32178,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32178, 45.44637]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32414524,
        name: "Apartment Crystal (200m from Rialto's Bridge)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.44009,
        longitude: 12.33684,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33684, 45.44009]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32416576,
        name: "Apartment Marin, Venetian Style",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.43971,
        longitude: 12.32428,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32428, 45.43971]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32417030,
        name: "Palace Ca' Cavalli (400m from Rialto's Bridge)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.43806,
        longitude: 12.3303,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3303, 45.43806]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32417184,
        name: 'Ca\' Salicornia - Appartamento "Poveglia"',
        host_id: 84543765,
        host_name: "Maurizio&Francesca",
        latitude: 45.4373,
        longitude: 12.34066,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34066, 45.4373]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32420114,
        name: "Bosso Palace Venetian Apartment",
        host_id: 5862083,
        host_name: "Silvia",
        latitude: 45.43825,
        longitude: 12.32859,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32859, 45.43825]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32421932,
        name: "Sandy Home",
        host_id: 243499308,
        host_name: "Sandy",
        latitude: 45.43224,
        longitude: 12.35646,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35646, 45.43224]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32430601,
        name: "Ca' Buranella appartamento 5 posti letto",
        host_id: 92665522,
        host_name: "Laura",
        latitude: 45.44103,
        longitude: 12.33006,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33006, 45.44103]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32432570,
        name: "Ca' Dolcetta",
        host_id: 243287973,
        host_name: "Anora",
        latitude: 45.43902,
        longitude: 12.33013,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33013, 45.43902]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32433549,
        name: "Giudecca Dreaming Apartment",
        host_id: 224969988,
        host_name: "Mattia",
        latitude: 45.42502,
        longitude: 12.32796,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32796, 45.42502]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32443439,
        name: "A couple of steps from Rialto",
        host_id: 6068323,
        host_name: "Fabio",
        latitude: 45.43861,
        longitude: 12.33177,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33177, 45.43861]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32444273,
        name: "St. Mark's Square 7 mins walk, CHARMING COURT VIEW",
        host_id: 10989537,
        host_name: "Monica",
        latitude: 45.43558,
        longitude: 12.34433,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34433, 45.43558]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32455103,
        name: "Venetian Cannaregio Apartment",
        host_id: 243816885,
        host_name: "Adelina",
        latitude: 45.44097,
        longitude: 12.34068,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34068, 45.44097]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32456377,
        name: "Welc-om ai Tre Archi Cannaregio",
        host_id: 20717796,
        host_name: "Welc-Om",
        latitude: 45.44544,
        longitude: 12.32262,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32262, 45.44544]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32457263,
        name: "San Marco Alloggi Allegri ---- Venice experience",
        host_id: 97908044,
        host_name: "Luca",
        latitude: 45.43735,
        longitude: 12.33706,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33706, 45.43735]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32457657,
        name: "Ca' Gilly,  Rooftop!",
        host_id: 125530486,
        host_name: "Tiziana",
        latitude: 45.43805,
        longitude: 12.34243,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34243, 45.43805]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32462840,
        name: "Welc-om Cannaregio Guglie",
        host_id: 20717796,
        host_name: "Welc-Om",
        latitude: 45.44645,
        longitude: 12.3223,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3223, 45.44645]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32463159,
        name: "Apartment Conte Bernardo",
        host_id: 3320671,
        host_name: "Nicolo'",
        latitude: 45.43694,
        longitude: 12.33138,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33138, 45.43694]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32463558,
        name: "RED VELVET: apartment in the very heart of Venice",
        host_id: 26831067,
        host_name: "Diana",
        latitude: 45.43821,
        longitude: 12.33106,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33106, 45.43821]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32463817,
        name: "In Venice 1 floor, 10 minutes from Train Station!",
        host_id: 243882660,
        host_name: "Valentina",
        latitude: 45.44666,
        longitude: 12.32032,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32032, 45.44666]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32466060,
        name: "Elegant apartment fully equipped",
        host_id: 136919873,
        host_name: "Matilde",
        latitude: 45.4342,
        longitude: 12.32945,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32945, 45.4342]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32482996,
        name: "Luminoso appartamento a Venezia aria condizionata",
        host_id: 208611161,
        host_name: "Francesca",
        latitude: 45.43681,
        longitude: 12.34814,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34814, 45.43681]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32485147,
        name: "Flower Room Cozy room for 2 people, private toilet",
        host_id: 174333358,
        host_name: "Antonella",
        latitude: 45.43993,
        longitude: 12.33118,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33118, 45.43993]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32485799,
        name: "Starlette Cozy room for 2 people, private toilet",
        host_id: 174333358,
        host_name: "Antonella",
        latitude: 45.43884,
        longitude: 12.33268,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33268, 45.43884]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32485916,
        name: "San Marco Fusion Design Apartment",
        host_id: 244073921,
        host_name: "Olly",
        latitude: 45.43561,
        longitude: 12.34446,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34446, 45.43561]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32486072,
        name: "Welc.om Cannaregio tre archi room",
        host_id: 20717796,
        host_name: "Welc-Om",
        latitude: 45.44691,
        longitude: 12.32135,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32135, 45.44691]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32486358,
        name: "Welc-om Tre Archi room",
        host_id: 20717796,
        host_name: "Welc-Om",
        latitude: 45.44531,
        longitude: 12.32287,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32287, 45.44531]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32488130,
        name: "Airy Hideaway",
        host_id: 13990376,
        host_name: "Tommaso",
        latitude: 45.43884,
        longitude: 12.33412,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33412, 45.43884]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32488312,
        name: "Canal View Luxury Suite Rialto",
        host_id: 50349340,
        host_name: "Sebastiano",
        latitude: 45.43761,
        longitude: 12.33729,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33729, 45.43761]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32489122,
        name: "♧ One step from Biennale Gardens",
        host_id: 243291207,
        host_name: "Arianna",
        latitude: 45.43111,
        longitude: 12.35518,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35518, 45.43111]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32489410,
        name: "DX-Ca'Briani apartment - 150 mt from St.Mark",
        host_id: 5395291,
        host_name: "Beatrice",
        latitude: 45.43576,
        longitude: 12.34253,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34253, 45.43576]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32507950,
        name: "Sweety Mary Apartment",
        host_id: 242868135,
        host_name: "Francesca",
        latitude: 45.42619,
        longitude: 12.32131,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32131, 45.42619]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32510604,
        name: "Cannaregio Cozy Apt x2! CHARM OF VENICE",
        host_id: 96221395,
        host_name: "Welcome To Veneto & Friuli",
        latitude: 45.44718,
        longitude: 12.32912,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32912, 45.44718]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32511130,
        name: "Residenza Formosa (L.T. M (Phone number hidden by Airbnb)",
        host_id: 5618111,
        host_name: "EasySuite",
        latitude: 45.43676,
        longitude: 12.34167,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34167, 45.43676]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32514116,
        name: "SNC1018 MODERN BOUTIQUE APARTMENT",
        host_id: 145813573,
        host_name: "Nicola",
        latitude: 45.44075,
        longitude: 12.32531,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32531, 45.44075]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32517476,
        name: "You are in Rialto Apartment",
        host_id: 228709217,
        host_name: "Silvia",
        latitude: 45.43674,
        longitude: 12.33215,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33215, 45.43674]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32519564,
        name: "COZY APARTMENT NEAR RIALTO BRIDGE/ ST.MARK SQUARE",
        host_id: 231775592,
        host_name: "Judite & Beatrice",
        latitude: 45.44216,
        longitude: 12.33867,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33867, 45.44216]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32534435,
        name: "Room1@WelcomeLAGOVenezia",
        host_id: 8742378,
        host_name: "Paolo",
        latitude: 45.43475,
        longitude: 12.34563,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34563, 45.43475]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32534905,
        name: "Bellezza, comodità e funzionalità alla Giudecca",
        host_id: 42382071,
        host_name: "Susanna",
        latitude: 45.42537,
        longitude: 12.32813,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32813, 45.42537]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32535036,
        name: "Room2@WelcomeLAGOVenezia",
        host_id: 8742378,
        host_name: "Paolo",
        latitude: 45.43526,
        longitude: 12.34576,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34576, 45.43526]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32537957,
        name: "The Zen House, relax and privacy for 2 in Venice!",
        host_id: 6798407,
        host_name: "Monica",
        latitude: 45.44006,
        longitude: 12.3394,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3394, 45.44006]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32560272,
        name: "Piccolo lord",
        host_id: 224805962,
        host_name: "Elisabetta",
        latitude: 45.44251,
        longitude: 12.33392,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33392, 45.44251]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32566300,
        name: "Super Central Loft",
        host_id: 244731682,
        host_name: "Margherita",
        latitude: 45.43359,
        longitude: 12.33106,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33106, 45.43359]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32569716,
        name: "Feel the real atmosphere of Venice",
        host_id: 166741307,
        host_name: "Martin",
        latitude: 45.44446,
        longitude: 12.32244,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32244, 45.44446]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32570517,
        name: "sx- Ca'Briani apartment behind st mark square",
        host_id: 5395291,
        host_name: "Beatrice",
        latitude: 45.43654,
        longitude: 12.34126,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34126, 45.43654]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32573515,
        name: "CASA FIORI 2 - Room with balcony overlooking canal",
        host_id: 20301471,
        host_name: "Casa",
        latitude: 45.44183,
        longitude: 12.33318,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33318, 45.44183]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32573828,
        name: "CASA FIORI 3 - Private Twin Room",
        host_id: 20301471,
        host_name: "Casa",
        latitude: 45.44145,
        longitude: 12.33343,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33343, 45.44145]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32581614,
        name: "CLOSE TO THE  RAILWAY STATION - N.2",
        host_id: 244865064,
        host_name: "Andrea",
        latitude: 45.44321,
        longitude: 12.32423,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32423, 45.44321]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32588597,
        name: "Cá Berlotta",
        host_id: 244857385,
        host_name: "Lucia",
        latitude: 45.44125,
        longitude: 12.34015,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34015, 45.44125]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32591268,
        name: "Rio di San Barnaba Flat in Dorsoduro",
        host_id: 21027135,
        host_name: "Elena",
        latitude: 45.43271,
        longitude: 12.32157,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32157, 45.43271]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32598077,
        name: "Venezia, Vaporetto & Connection to all",
        host_id: 6620102,
        host_name: "Emanuele",
        latitude: 45.43767,
        longitude: 12.31911,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31911, 45.43767]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32598853,
        name: "Superior Double Room in the heart of Venice",
        host_id: 98284086,
        host_name: "Davide",
        latitude: 45.43596,
        longitude: 12.33645,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33645, 45.43596]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32600500,
        name: "Vogue Garden apartment",
        host_id: 245049135,
        host_name: "Jacopo",
        latitude: 45.43705,
        longitude: 12.33045,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33045, 45.43705]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32604532,
        name: "Ca San Felice",
        host_id: 245089118,
        host_name: "Ca'",
        latitude: 45.44224,
        longitude: 12.3332,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3332, 45.44224]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32606418,
        name: "La Casa di Silvia e Nicola. CANAL VIEW!",
        host_id: 245108256,
        host_name: "Nicola",
        latitude: 45.44312,
        longitude: 12.33635,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33635, 45.44312]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32606893,
        name: "Romantic Lagoon - with Family & Friends",
        host_id: 29706566,
        host_name: "Margherita & Valentina",
        latitude: 45.44066,
        longitude: 12.34012,
        beds: 7,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34012, 45.44066]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32607990,
        name: "Il gioiellino di Rialto",
        host_id: 53962979,
        host_name: "Perla Blu S.R.L.",
        latitude: 45.44039,
        longitude: 12.33174,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33174, 45.44039]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32609423,
        name: "Home with canal view",
        host_id: 4791745,
        host_name: "Matteo",
        latitude: 45.44495,
        longitude: 12.3245,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3245, 45.44495]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32622379,
        name: "Apartment Mozart (200m from Rialto's Bridge)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.43834,
        longitude: 12.33416,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33416, 45.43834]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32622748,
        name: "Cozy Room Palazzo on the Grand Canal",
        host_id: 206353503,
        host_name: "Art Foundation - Support Program",
        latitude: 45.43542,
        longitude: 12.33222,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33222, 45.43542]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32631103,
        name: 'Venice "Casa Eva"',
        host_id: 13027859,
        host_name: "Diego",
        latitude: 45.44585,
        longitude: 12.32298,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32298, 45.44585]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32631728,
        name: "✧ Central Venetian apt.✧near Sestiere of Castello",
        host_id: 244543928,
        host_name: "Chicca",
        latitude: 45.43744,
        longitude: 12.34691,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34691, 45.43744]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32632257,
        name: "✧Noblesse Oblige✧ 1300 House on the Canals",
        host_id: 244741071,
        host_name: "Giacinta",
        latitude: 45.4371,
        longitude: 12.34148,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34148, 45.4371]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32632414,
        name: "ART Biennale",
        host_id: 245336217,
        host_name: "Boutique",
        latitude: 45.43314,
        longitude: 12.35327,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35327, 45.43314]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32636727,
        name: "SAN MARCO NEXT TERRACE private pano-view, aircond",
        host_id: 153954052,
        host_name: "Annalisa",
        latitude: 45.43492,
        longitude: 12.3477,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3477, 45.43492]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32638713,
        name: "Your fairytale in Venice - Gold Room",
        host_id: 1408761,
        host_name: "Chiara",
        latitude: 45.43767,
        longitude: 12.3307,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3307, 45.43767]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32647999,
        name: "Your fairytale in Venice - Silver Room",
        host_id: 1408761,
        host_name: "Chiara",
        latitude: 45.43718,
        longitude: 12.33031,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33031, 45.43718]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32649655,
        name: "Tesori di Celestia",
        host_id: 669047,
        host_name: "Viewsonvenice",
        latitude: 45.43704,
        longitude: 12.34916,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34916, 45.43704]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32652998,
        name: "Venice Boat Caicco Akos",
        host_id: 180640178,
        host_name: "Matteo",
        latitude: 45.42378,
        longitude: 12.32887,
        beds: 8,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32887, 45.42378]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32656922,
        name: "Ca' Corte Nova: luxury canal view",
        host_id: 10988715,
        host_name: "Andrea",
        latitude: 45.44192,
        longitude: 12.33857,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33857, 45.44192]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32657522,
        name: "Your fairytale in Venice",
        host_id: 1408761,
        host_name: "Chiara",
        latitude: 45.43855,
        longitude: 12.33062,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33062, 45.43855]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32659273,
        name: "Luxury Studio Apartment",
        host_id: 245561487,
        host_name: "Nicholas",
        latitude: 45.43049,
        longitude: 12.33023,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33023, 45.43049]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32660248,
        name: "Venice Apartments San Marco",
        host_id: 232895059,
        host_name: "Emilio",
        latitude: 45.43608,
        longitude: 12.34627,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34627, 45.43608]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32680295,
        name: 'Venise "La Petite Maison"',
        host_id: 13027859,
        host_name: "Diego",
        latitude: 45.43879,
        longitude: 12.3284,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3284, 45.43879]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32693820,
        name: "Al Teatro Italia  centro Venezia",
        host_id: 230932659,
        host_name: "Armando",
        latitude: 45.44454,
        longitude: 12.32991,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32991, 45.44454]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32694676,
        name: "Ca' Rosetta - Camera al piano nobile",
        host_id: 186222971,
        host_name: "Erica",
        latitude: 45.44156,
        longitude: 12.33604,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33604, 45.44156]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32694867,
        name: "Ca Rossa-Venezia",
        host_id: 6759756,
        host_name: "Rudi",
        latitude: 45.43623,
        longitude: 12.34269,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34269, 45.43623]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32707062,
        name: "CA'BRAGA BIENNALE",
        host_id: 197224424,
        host_name: "Giulia",
        latitude: 45.43052,
        longitude: 12.35766,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35766, 45.43052]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32711432,
        name: "Waterside Apartment With Courtyard Garden",
        host_id: 245561487,
        host_name: "Nicholas",
        latitude: 45.43388,
        longitude: 12.31698,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31698, 45.43388]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32713573,
        name: "relaxing large elegant in Real Venice",
        host_id: 31276705,
        host_name: "Mila",
        latitude: 45.43208,
        longitude: 12.36002,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.36002, 45.43208]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32713701,
        name: "Spectacular view Laguna blu Venice 2019",
        host_id: 245981131,
        host_name: "Elisabeth",
        latitude: 45.42454,
        longitude: 12.32638,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32638, 45.42454]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32716239,
        name: "CA’ BARZIZZA  with private terrace",
        host_id: 38346442,
        host_name: "Giancarlo",
        latitude: 45.43671,
        longitude: 12.33217,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33217, 45.43671]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32721487,
        name: "Per donne viaggiatrici, stanza luminosa e pulita",
        host_id: 34390677,
        host_name: "Laura",
        latitude: 45.445,
        longitude: 12.32728,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32728, 45.445]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32730034,
        name: "Romantic Cozy flat in Venice with balcony",
        host_id: 48092742,
        host_name: "Roby",
        latitude: 45.43311,
        longitude: 12.35813,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35813, 45.43311]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32731616,
        name: "Romantic apartment in heart of Venice",
        host_id: 245561487,
        host_name: "Nicholas",
        latitude: 45.43032,
        longitude: 12.32369,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32369, 45.43032]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32732489,
        name: "LL4425 Penthouse of 200sqm",
        host_id: 246138160,
        host_name: "Chiara",
        latitude: 45.43615,
        longitude: 12.33965,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33965, 45.43615]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32737889,
        name: "La Casa del Pescatore: A lovely escape in venice!!",
        host_id: 66431139,
        host_name: "Tommaso",
        latitude: 45.43447,
        longitude: 12.34597,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34597, 45.43447]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32754098,
        name: "CASANOVA APARTMENT SAN MARCO",
        host_id: 4136657,
        host_name: "Stefano",
        latitude: 45.43314,
        longitude: 12.33726,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33726, 45.43314]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32754132,
        name: "The Longfield Mansion",
        host_id: 229238861,
        host_name: "Carlo",
        latitude: 45.43558,
        longitude: 12.33963,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33963, 45.43558]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32766862,
        name: "New open 6 Art studio in the authentic Venice",
        host_id: 246225406,
        host_name: "Roberto",
        latitude: 45.44367,
        longitude: 12.32643,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32643, 45.44367]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32776892,
        name: "CNR5158 SMALL BOUTIQUE APARTMENT",
        host_id: 145813573,
        host_name: "Nicola",
        latitude: 45.44223,
        longitude: 12.34075,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34075, 45.44223]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32777088,
        name: "San Marco Apartment - Dolce Vita",
        host_id: 244073921,
        host_name: "Olly",
        latitude: 45.43407,
        longitude: 12.34373,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34373, 45.43407]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32788928,
        name: "GREAT LOCATION-Jacuzzi-WiFi, newly renovated, A/C",
        host_id: 239158074,
        host_name: "Mirco",
        latitude: 45.43978,
        longitude: 12.3305,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3305, 45.43978]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32796785,
        name: "Prestigious with Large Private Terrace",
        host_id: 241219411,
        host_name: "Marco",
        latitude: 45.44747,
        longitude: 12.32496,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32496, 45.44747]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32798332,
        name: "Ca' Valmarana - entire apartment",
        host_id: 49167377,
        host_name: "Roberta",
        latitude: 45.43872,
        longitude: 12.33256,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33256, 45.43872]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32799253,
        name:
          "SAN MARCO: Venetian palace (Website hidden by Airbnb) For families",
        host_id: 179326998,
        host_name: "Marta & Chiara",
        latitude: 45.43565,
        longitude: 12.34706,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34706, 45.43565]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32800435,
        name: "Biennale 1585 Alfa",
        host_id: 166297081,
        host_name: "Thomas",
        latitude: 45.43169,
        longitude: 12.35128,
        beds: null,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35128, 45.43169]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32800824,
        name: "CA' DELL'ORTO",
        host_id: 14357135,
        host_name: "Rent It Venice",
        latitude: 45.44726,
        longitude: 12.33304,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33304, 45.44726]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32801705,
        name: "Biennale 1585 Beta",
        host_id: 166297081,
        host_name: "Thomas",
        latitude: 45.43332,
        longitude: 12.35213,
        beds: null,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35213, 45.43332]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32802458,
        name: "2 BDR+2 bathrooms in SAN MARCO: not to be missed!",
        host_id: 179326998,
        host_name: "Marta & Chiara",
        latitude: 45.43575,
        longitude: 12.34708,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34708, 45.43575]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32827605,
        name: "Ca'Rialto Mercato Flat",
        host_id: 238472653,
        host_name: "Giovanni",
        latitude: 45.4397,
        longitude: 12.33439,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33439, 45.4397]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32828240,
        name: "Canal view Apartment close to Bus&Train Stations",
        host_id: 25085773,
        host_name: "Gin",
        latitude: 45.43722,
        longitude: 12.31846,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31846, 45.43722]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32836154,
        name: "BACKHOUSE",
        host_id: 70740960,
        host_name: "Bruno",
        latitude: 45.43191,
        longitude: 12.35722,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35722, 45.43191]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32836206,
        name: "Al Teatro Italia Venezia  Entire Apartment",
        host_id: 230932659,
        host_name: "Armando",
        latitude: 45.44514,
        longitude: 12.32947,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32947, 45.44514]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32844783,
        name: "Suite attico Ca' Rosetta",
        host_id: 186222971,
        host_name: "Erica",
        latitude: 45.44179,
        longitude: 12.33214,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33214, 45.44179]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32844860,
        name: "Camera attico Ca' Rosetta",
        host_id: 186222971,
        host_name: "Erica",
        latitude: 45.44278,
        longitude: 12.33357,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33357, 45.44278]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32854402,
        name: "Venice Tre Archi Near Station S.Lucia Two bedroom",
        host_id: 13012838,
        host_name: "Paola",
        latitude: 45.44671,
        longitude: 12.32107,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32107, 45.44671]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32857874,
        name: "APPARTAMENTO MAURIZIO",
        host_id: 28039040,
        host_name: "Maurizio",
        latitude: 45.43711,
        longitude: 12.33663,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33663, 45.43711]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32858872,
        name: "Residence Marina (200mt from Rialto's Bridge)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.43789,
        longitude: 12.33968,
        beds: 9,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33968, 45.43789]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32859220,
        name: "Fenice Backstage over Canal",
        host_id: 247169257,
        host_name: "Paolo",
        latitude: 45.43459,
        longitude: 12.33357,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33357, 45.43459]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32861256,
        name: "Ca' del Mondo Novo,  classy in Venice's heart",
        host_id: 12113015,
        host_name: "Mario",
        latitude: 45.43657,
        longitude: 12.34132,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34132, 45.43657]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32881906,
        name: "San Girolamo apartament 2",
        host_id: 3957712,
        host_name: "Manuel",
        latitude: 45.44699,
        longitude: 12.3243,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3243, 45.44699]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32883388,
        name: "Ve.N.I.Ce Cera Ca' Amata - M (Phone number hidden by Airbnb)",
        host_id: 37864680,
        host_name: "Ve.N.I.Ce Immobiliare Cera",
        latitude: 45.43555,
        longitude: 12.34248,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34248, 45.43555]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32887803,
        name: '"raggio di sole" dietro piazza San Marco',
        host_id: 174569424,
        host_name: "Annita",
        latitude: 45.43676,
        longitude: 12.34212,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34212, 45.43676]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32889718,
        name: "Sweet Room",
        host_id: 207797808,
        host_name: "Ali",
        latitude: 45.44432,
        longitude: 12.33033,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33033, 45.44432]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32903384,
        name: "Backhouse 1",
        host_id: 70740960,
        host_name: "Bruno",
        latitude: 45.43182,
        longitude: 12.35692,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35692, 45.43182]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32904757,
        name: "San Marco, Modern & Charming Venetian Apartment!",
        host_id: 220032384,
        host_name: "Diana",
        latitude: 45.43271,
        longitude: 12.3292,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3292, 45.43271]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32909927,
        name: "Central Venice Flat near Garden",
        host_id: 191226100,
        host_name: "Milo",
        latitude: 45.43394,
        longitude: 12.35771,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35771, 45.43394]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32910947,
        name: "New modern flat in Real Venice Giardini",
        host_id: 13500918,
        host_name: "Mark",
        latitude: 45.43283,
        longitude: 12.35717,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35717, 45.43283]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32911275,
        name: "♡Terrace on the Roofs of Venice♡",
        host_id: 247241340,
        host_name: "Giacomo",
        latitude: 45.43684,
        longitude: 12.33834,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33834, 45.43684]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32911819,
        name: "Room#1, great position and comfort!",
        host_id: 229046688,
        host_name: "Atanas",
        latitude: 45.43789,
        longitude: 12.32721,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32721, 45.43789]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32925914,
        name: "Garden apartment in Venice",
        host_id: 6620102,
        host_name: "Emanuele",
        latitude: 45.44608,
        longitude: 12.3269,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3269, 45.44608]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32928038,
        name: "The Venetian Observatory",
        host_id: 247749139,
        host_name: "Letizia",
        latitude: 45.4277,
        longitude: 12.32116,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32116, 45.4277]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32928215,
        name: "VENETIAN DREAM APARTMENT ON DORSODURO DISTRICT",
        host_id: 5862083,
        host_name: "Silvia",
        latitude: 45.43269,
        longitude: 12.32673,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32673, 45.43269]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32931830,
        name: "Wonderful lagoon view with terrace over the water!",
        host_id: 22050501,
        host_name: "Severine",
        latitude: 45.42429,
        longitude: 12.32613,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32613, 45.42429]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32932905,
        name: "Luxory Apartment Santa Margherita",
        host_id: 1509668,
        host_name: "Martina",
        latitude: 45.43363,
        longitude: 12.3228,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3228, 45.43363]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32944890,
        name: "Biennale house",
        host_id: 37381363,
        host_name: "Horacio",
        latitude: 45.43151,
        longitude: 12.35879,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35879, 45.43151]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32947081,
        name: "Ca' Fede - Lovely Studio in the  heart of Venice.",
        host_id: 247927868,
        host_name: "Federica",
        latitude: 45.43857,
        longitude: 12.32867,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32867, 45.43857]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32952894,
        name: "Andrea e Valentina's home",
        host_id: 239333542,
        host_name: "Valentina",
        latitude: 45.43255,
        longitude: 12.35282,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35282, 45.43255]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32953804,
        name: "private room in Venice",
        host_id: 247989727,
        host_name: "Ahteek",
        latitude: 45.44693,
        longitude: 12.33281,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33281, 45.44693]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32961373,
        name: "Beautiful stylish apartment in Venice",
        host_id: 175813139,
        host_name: "Marya",
        latitude: 45.4457,
        longitude: 12.33359,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33359, 45.4457]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32973679,
        name: "Residence Terrace Grand Canal",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.43635,
        longitude: 12.32899,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32899, 45.43635]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32974544,
        name: "El Campanil - Few steps from Biennale",
        host_id: 68560505,
        host_name: "Mauro",
        latitude: 45.43059,
        longitude: 12.35835,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35835, 45.43059]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32977122,
        name: "Cà Mocenigo Terrace with an uncomparabable view",
        host_id: 215806409,
        host_name: "Emanuele",
        latitude: 45.44022,
        longitude: 12.32986,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32986, 45.44022]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32977896,
        name: "Carbona - Few steps from Biennale",
        host_id: 68560505,
        host_name: "Mauro",
        latitude: 45.43069,
        longitude: 12.35959,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35959, 45.43069]] },
    },
    {
      type: "Feature",
      properties: {
        id: 32978201,
        name: "BRIGHT AND QUIET ATTIC  255 steps from  San Mark's",
        host_id: 244865064,
        host_name: "Andrea",
        latitude: 45.43486,
        longitude: 12.34256,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34256, 45.43486]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33000376,
        name: "King-size standard bedroom with private bathroom",
        host_id: 248368998,
        host_name: "Adriano",
        latitude: 45.43139,
        longitude: 12.35221,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35221, 45.43139]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33002815,
        name: "CA BIENNALE: 15 min to S. Marco & free Wi-Fi",
        host_id: 133690220,
        host_name: "Silvia-Carlo",
        latitude: 45.43173,
        longitude: 12.35547,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35547, 45.43173]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33003159,
        name: "King-size deluxe room with private bathroom",
        host_id: 248368998,
        host_name: "Adriano",
        latitude: 45.43139,
        longitude: 12.35348,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35348, 45.43139]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33004534,
        name: "Casa tipica San Elena",
        host_id: 248399012,
        host_name: "Michela",
        latitude: 45.42555,
        longitude: 12.36223,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.36223, 45.42555]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33005414,
        name: "Charming Do Torri",
        host_id: 248404297,
        host_name: "Do Torri",
        latitude: 45.43944,
        longitude: 12.3295,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3295, 45.43944]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33007272,
        name: "Fior di Loto Apartment",
        host_id: 248414375,
        host_name: "Fior Di Loto",
        latitude: 45.43329,
        longitude: 12.32332,
        beds: null,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32332, 45.43329]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33010115,
        name: "Rialto apartment with Canal Grande view",
        host_id: 194031854,
        host_name: "Ilaria",
        latitude: 45.43924,
        longitude: 12.33456,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33456, 45.43924]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33025667,
        name: "Casetta Betta centro storico Venezia",
        host_id: 248572647,
        host_name: "Lisa",
        latitude: 45.43796,
        longitude: 12.34255,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34255, 45.43796]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33034278,
        name: "SANTI APOSTOLI HOUSE",
        host_id: 241274064,
        host_name: "Enrico",
        latitude: 45.44028,
        longitude: 12.33729,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33729, 45.44028]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33037671,
        name: "Le Vele Pied-à-Terre, a romantic escape",
        host_id: 87281966,
        host_name: "Cezar",
        latitude: 45.44224,
        longitude: 12.33585,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33585, 45.44224]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33040397,
        name: "Casa dalle Contrade camera matrimoniale",
        host_id: 207291051,
        host_name: "Gianpaolo",
        latitude: 45.44193,
        longitude: 12.32794,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32794, 45.44193]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33040498,
        name: "APPARTAMENTO CHIARA",
        host_id: 28039040,
        host_name: "Maurizio",
        latitude: 45.43819,
        longitude: 12.33762,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33762, 45.43819]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33042027,
        name: "San Tomà Gran Canal",
        host_id: 33282263,
        host_name: "Maurizio",
        latitude: 45.43714,
        longitude: 12.32769,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32769, 45.43714]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33042217,
        name: "CASA CAROLINA AI GIARDINI DELLA BIENNALE",
        host_id: 48081958,
        host_name: "Veronica",
        latitude: 45.432399928143219,
        longitude: 12.356621473042619,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35662, 45.4324]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33044524,
        name: "Santa Fosca luxury 270sqm flat with terrace",
        host_id: 1438903,
        host_name: "Barbara",
        latitude: 45.44281,
        longitude: 12.33262,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33262, 45.44281]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33060312,
        name: "DolceVita Apartments N. 439 Design 2 Bedrooms",
        host_id: 8176475,
        host_name: "Eugenia",
        latitude: 45.44573,
        longitude: 12.32258,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32258, 45.44573]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33068055,
        name: "VENETIAN COURTYARD",
        host_id: 106880093,
        host_name: "Federica & Doriano",
        latitude: 45.43343,
        longitude: 12.33059,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33059, 45.43343]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33086749,
        name: "RIGOLETTO in the heart of VENICE-SAN MARCO SQUARE",
        host_id: 13439503,
        host_name: "Elisabetta",
        latitude: 45.43297,
        longitude: 12.33436,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33436, 45.43297]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33088121,
        name: "Corte Contarina 1 - San Marco",
        host_id: 131142254,
        host_name: "Ana Maria",
        latitude: 45.43278,
        longitude: 12.33607,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33607, 45.43278]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33088314,
        name: "✧Terrace on the Lagoon✧ Luxury apt with Jacuzzi",
        host_id: 247450386,
        host_name: "Pietro",
        latitude: 45.42458,
        longitude: 12.32746,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32746, 45.42458]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33094412,
        name: "Luxury Residence King-S  Venice St. Marco Rialto",
        host_id: 2785704,
        host_name: "Giancarlo",
        latitude: 45.44368,
        longitude: 12.33372,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33372, 45.44368]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33095673,
        name: "Ca' Brunilda: Terrace - Canal View - Free Wi-Fi",
        host_id: 133690220,
        host_name: "Silvia-Carlo",
        latitude: 45.43948,
        longitude: 12.33009,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33009, 45.43948]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33107044,
        name: "Ca' dei zii",
        host_id: 43402592,
        host_name: "Chiara",
        latitude: 45.44037,
        longitude: 12.32657,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32657, 45.44037]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33112561,
        name: "Corte Contarina 2  - San Marco",
        host_id: 131142254,
        host_name: "Ana Maria",
        latitude: 45.4328,
        longitude: 12.33719,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33719, 45.4328]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33113061,
        name: "Room3@WelcomeLAGOVenezia",
        host_id: 8742378,
        host_name: "Paolo",
        latitude: 45.43521,
        longitude: 12.34609,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34609, 45.43521]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33146732,
        name: "Ca' Romite: elegant and welcoming at Zattere",
        host_id: 11864228,
        host_name: "Orsola",
        latitude: 45.43177,
        longitude: 12.32345,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32345, 45.43177]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33153194,
        name: "Monkey-House Venezia",
        host_id: 46240420,
        host_name: "Luca",
        latitude: 45.43341,
        longitude: 12.32361,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32361, 45.43341]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33154233,
        name: "Ca' Fortuny charming penthouse in San Marco",
        host_id: 12113015,
        host_name: "Mario",
        latitude: 45.43614,
        longitude: 12.33335,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33335, 45.43614]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33154365,
        name: "Ca' Leon D'Oro - Private room in Rialto free wifi",
        host_id: 20397596,
        host_name: "Francesco",
        latitude: 45.43767,
        longitude: 12.33648,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33648, 45.43767]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33155474,
        name: "Ca' Leon D'Oro - Private room in Rialto free wifi",
        host_id: 20397596,
        host_name: "Francesco",
        latitude: 45.43773,
        longitude: 12.33631,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33631, 45.43773]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33155967,
        name: "Ca' Leon D'Oro - Private room in Rialto free wifi",
        host_id: 20397596,
        host_name: "Francesco",
        latitude: 45.43775,
        longitude: 12.33749,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33749, 45.43775]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33156138,
        name: "Ca' Leon D'Oro - Terrace S. Marc's view + Wifi",
        host_id: 20397596,
        host_name: "Francesco",
        latitude: 45.43628,
        longitude: 12.33674,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33674, 45.43628]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33158540,
        name: "Mono-Moeca Venezia",
        host_id: 46240420,
        host_name: "Luca",
        latitude: 45.43436,
        longitude: 12.32534,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32534, 45.43436]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33159104,
        name: "Ca' Leon D'Oro - Private room in Rialto free wifi",
        host_id: 20397596,
        host_name: "Francesco",
        latitude: 45.43808,
        longitude: 12.33677,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33677, 45.43808]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33159645,
        name: "Casa Mari nel cuore di Venezia",
        host_id: 104209525,
        host_name: "Rebecca",
        latitude: 45.43807,
        longitude: 12.34056,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34056, 45.43807]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33176251,
        name: "Flower design Room with view",
        host_id: 191226100,
        host_name: "Milo",
        latitude: 45.44376,
        longitude: 12.32785,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32785, 45.44376]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33176407,
        name: "Lovely Arsenale Wifi,washer-air conditioning",
        host_id: 179298782,
        host_name: "Sabrina",
        latitude: 45.43469,
        longitude: 12.34858,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34858, 45.43469]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33177400,
        name: "Ground floor private court, Wi-fi near S.Marco",
        host_id: 179298782,
        host_name: "Sabrina",
        latitude: 45.43303,
        longitude: 12.35024,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35024, 45.43303]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33177771,
        name: "Apt. Beautiful View (Panoramic Terrace)",
        host_id: 237393798,
        host_name: "Massimo",
        latitude: 45.43436,
        longitude: 12.32614,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32614, 45.43436]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33179317,
        name: "San Marco pied-a-terre Accademia, Wi-fi a/c",
        host_id: 179298782,
        host_name: "Sabrina",
        latitude: 45.43287,
        longitude: 12.33,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33, 45.43287]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33180589,
        name: "Ca' d'Oro design 2 bedrooms-washer Wi-Fi",
        host_id: 179298782,
        host_name: "Sabrina",
        latitude: 45.44015,
        longitude: 12.33635,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33635, 45.44015]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33183988,
        name: "In the Heart of Venezia - Elena Place's",
        host_id: 249841180,
        host_name: "Elena",
        latitude: 45.43663,
        longitude: 12.3375,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3375, 45.43663]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33185240,
        name: "Elegant Room 5 with balcony and view",
        host_id: 191226100,
        host_name: "Milo",
        latitude: 45.44383,
        longitude: 12.32926,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32926, 45.44383]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33185503,
        name: "PANORAMIC VIEW MAIN ROAD RIALTO WiFi aircnd balcon",
        host_id: 17534457,
        host_name: "Abaca",
        latitude: 45.43769,
        longitude: 12.3303,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3303, 45.43769]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33185624,
        name: "Great Flat in Venice close to Giardini",
        host_id: 191226100,
        host_name: "Milo",
        latitude: 45.43446,
        longitude: 12.35663,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35663, 45.43446]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33188103,
        name: "Rialto Canal View Deluxe R&R",
        host_id: 173200514,
        host_name: "Rent&Relax",
        latitude: 45.43565,
        longitude: 12.33688,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33688, 45.43565]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33193032,
        name: "Nel cuore di venezia",
        host_id: 249914018,
        host_name: "Vitantonio",
        latitude: 45.43799,
        longitude: 12.3304,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3304, 45.43799]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33205112,
        name: "Imperial Flat with view on the canal",
        host_id: 48092742,
        host_name: "Roby",
        latitude: 45.43594,
        longitude: 12.34224,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34224, 45.43594]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33205440,
        name: "Romantic Apartment in Giardini Biennale",
        host_id: 48092742,
        host_name: "Roby",
        latitude: 45.43056,
        longitude: 12.35883,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35883, 45.43056]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33206380,
        name: "APARTMENT TOP FLOOR IN SAN MARCO AREA",
        host_id: 48092742,
        host_name: "Roby",
        latitude: 45.43694,
        longitude: 12.33661,
        beds: 7,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33661, 45.43694]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33208866,
        name: "Ca' Romite",
        host_id: 34360885,
        host_name: "Samuel",
        latitude: 45.43047,
        longitude: 12.32532,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32532, 45.43047]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33211679,
        name: "San marcuola 5 Private Room and balcony view",
        host_id: 191226100,
        host_name: "Milo",
        latitude: 45.44314,
        longitude: 12.32847,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32847, 45.44314]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33213274,
        name: "Residenza Carampane. Vivere il mercato di Rialto",
        host_id: 250070457,
        host_name: "Roberto",
        latitude: 45.43985,
        longitude: 12.33171,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33171, 45.43985]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33217477,
        name: "Appartamento a Venezia Corte Lucatello",
        host_id: 235839981,
        host_name: "Locanda",
        latitude: 45.43464,
        longitude: 12.33057,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33057, 45.43464]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33217839,
        name: "Casa Egle",
        host_id: 30821541,
        host_name: "Nicola",
        latitude: 45.43894,
        longitude: 12.32244,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32244, 45.43894]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33218396,
        name: "Piccolo Guerrato. Piazza San Marco a pochi passi",
        host_id: 250070457,
        host_name: "Roberto",
        latitude: 45.43531,
        longitude: 12.33772,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33772, 45.43531]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33218681,
        name: "Mercerie. La via che porta al salotto della città",
        host_id: 250070457,
        host_name: "Roberto",
        latitude: 45.43609,
        longitude: 12.33821,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33821, 45.43609]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33235433,
        name: "ROUSSEAU'S APARTMENT SUPER ATTIC GREAT VIEW",
        host_id: 170750872,
        host_name: "Sara",
        latitude: 45.44607,
        longitude: 12.32073,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32073, 45.44607]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33237319,
        name: "BIENNALE HOUSE, Sestiere Castello Venice",
        host_id: 241274064,
        host_name: "Enrico",
        latitude: 45.4353,
        longitude: 12.3505,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3505, 45.4353]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33238776,
        name: "Roulette infinity Room near Casinò",
        host_id: 191226100,
        host_name: "Milo",
        latitude: 45.44385,
        longitude: 12.32984,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32984, 45.44385]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33239231,
        name: "Giardini shining Flat near Biennale Tosi 1",
        host_id: 191226100,
        host_name: "Milo",
        latitude: 45.43213,
        longitude: 12.35746,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35746, 45.43213]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33243412,
        name: "Appartamento Scudi, in affaccio sul mercato",
        host_id: 250070457,
        host_name: "Roberto",
        latitude: 45.4386,
        longitude: 12.33489,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33489, 45.4386]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33262198,
        name: "BILOCALE SMART,  WC PRIVATO,  A/C E ASCENSORE",
        host_id: 250464486,
        host_name: "Denny Alessandro",
        latitude: 45.44116,
        longitude: 12.32343,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32343, 45.44116]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33263782,
        name: "Appartamento a pochi passi da San Marco",
        host_id: 31709922,
        host_name: "Andrea",
        latitude: 45.43788,
        longitude: 12.34535,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34535, 45.43788]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33265474,
        name: "Ap. Frari Canal View (Historical Center)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.43786,
        longitude: 12.32615,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32615, 45.43786]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33265849,
        name: "Casa Nobile",
        host_id: 154289203,
        host_name: "Fabio",
        latitude: 45.43545,
        longitude: 12.32158,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32158, 45.43545]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33283257,
        name: "Ca' Turchette",
        host_id: 34360885,
        host_name: "Samuel",
        latitude: 45.4323,
        longitude: 12.32565,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32565, 45.4323]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33285515,
        name: "Casa in venezia 2019",
        host_id: 250639871,
        host_name: "Manolo",
        latitude: 45.44675,
        longitude: 12.31922,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31922, 45.44675]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33286472,
        name: "San Marco 4893",
        host_id: 250677394,
        host_name: "Marco",
        latitude: 45.437,
        longitude: 12.3371,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3371, 45.437]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33287137,
        name: "Ca' San Trovaso",
        host_id: 34360885,
        host_name: "Samuel",
        latitude: 45.43051,
        longitude: 12.32536,
        beds: 8,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32536, 45.43051]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33310302,
        name: "Your big double room in Venice",
        host_id: 250903267,
        host_name: "Roy",
        latitude: 45.44356,
        longitude: 12.3216,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3216, 45.44356]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33328593,
        name: "Residenza Ducato Corte Contarina",
        host_id: 251054587,
        host_name: "Ducato",
        latitude: 45.43418,
        longitude: 12.33738,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33738, 45.43418]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33330782,
        name: "Your private bedroom in a sailing yacht in Venice",
        host_id: 77330285,
        host_name: "Andrea",
        latitude: 45.42851,
        longitude: 12.3653,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3653, 45.42851]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33338446,
        name: "San Maurizio",
        host_id: 206380158,
        host_name: "Weekey Rentals",
        latitude: 45.43374,
        longitude: 12.33145,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33145, 45.43374]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33357318,
        name: "CA' MOCENICO NOBILE WITH BALCONY",
        host_id: 215806409,
        host_name: "Emanuele",
        latitude: 45.44049,
        longitude: 12.33136,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33136, 45.44049]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33357784,
        name: "sognare a venezia",
        host_id: 250264192,
        host_name: "Stefania",
        latitude: 45.43388,
        longitude: 12.32349,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32349, 45.43388]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33360438,
        name: "Home Venice Apartments - Biennale 1",
        host_id: 7619802,
        host_name: "Stefania",
        latitude: 45.43054,
        longitude: 12.35565,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35565, 45.43054]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33362370,
        name:
          "Luminosa stanza matrimoniale con bagno privato e aria condizionata",
        host_id: 239703097,
        host_name: "Martina",
        latitude: 45.42467,
        longitude: 12.32749,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32749, 45.42467]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33362381,
        name: "Large double room in Arist's House B&B",
        host_id: 245561487,
        host_name: "Nicholas",
        latitude: 45.43769,
        longitude: 12.32182,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32182, 45.43769]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33362845,
        name: "Best View and Terrace of Venice: Wifi - A/C",
        host_id: 17762135,
        host_name: "Edoardo",
        latitude: 45.43707,
        longitude: 12.33108,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33108, 45.43707]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33367785,
        name: "CASA PATTI APARTMENT, IN THE HEART OF VENICE",
        host_id: 246249802,
        host_name: "Paola",
        latitude: 45.43668,
        longitude: 12.3422,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3422, 45.43668]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33385224,
        name: "vivere venezia",
        host_id: 250264192,
        host_name: "Stefania",
        latitude: 45.43461,
        longitude: 12.32279,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32279, 45.43461]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33385990,
        name: "Castello,  great Views, Free WiFi",
        host_id: 283131,
        host_name: "Anunxiata",
        latitude: 45.43626,
        longitude: 12.34654,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34654, 45.43626]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33387873,
        name: "White Ca' Arsenale 1 min from Biennale",
        host_id: 115635752,
        host_name: "Elena",
        latitude: 45.43344,
        longitude: 12.35026,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35026, 45.43344]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33412912,
        name: "IL CAMPO",
        host_id: 250264192,
        host_name: "Stefania",
        latitude: 45.4335,
        longitude: 12.32325,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32325, 45.4335]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33420827,
        name: "Apartment in the heart of Venice",
        host_id: 1731092,
        host_name: "Sabrina",
        latitude: 45.43278,
        longitude: 12.33717,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33717, 45.43278]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33421165,
        name: "✧Arsenale✧ Peaceful Apt on the Canal",
        host_id: 251551162,
        host_name: "Anne Sophie",
        latitude: 45.43355,
        longitude: 12.35599,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35599, 45.43355]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33439364,
        name: "Ca' Degli Armeni Canal View",
        host_id: 669047,
        host_name: "Viewsonvenice",
        latitude: 45.43296,
        longitude: 12.31945,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31945, 45.43296]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33444388,
        name: "Arsenale - Cozy apartment in the heart of Venice",
        host_id: 251406052,
        host_name: "Isabella",
        latitude: 45.43298,
        longitude: 12.34902,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34902, 45.43298]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33447595,
        name: "Zattere Tower Suite",
        host_id: 143456157,
        host_name: "Elena",
        latitude: 45.43028,
        longitude: 12.32749,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32749, 45.43028]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33467054,
        name: "Apartment Ponte Raspi - Canal View",
        host_id: 252145912,
        host_name: "Dimitri & Valentina",
        latitude: 45.43788,
        longitude: 12.33286,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33286, 45.43788]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33485728,
        name: "Cozy central apartment in the heart of Cannaregio",
        host_id: 231775592,
        host_name: "Judite & Beatrice",
        latitude: 45.44496,
        longitude: 12.32806,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32806, 45.44496]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33489263,
        name: "Camera doppia",
        host_id: 131142254,
        host_name: "Ana Maria",
        latitude: 45.43275,
        longitude: 12.33575,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33575, 45.43275]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33490163,
        name: "Easy apartment",
        host_id: 252359626,
        host_name: "Riccardo",
        latitude: 45.43412,
        longitude: 12.34981,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34981, 45.43412]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33516814,
        name: "nido di anna",
        host_id: 252570242,
        host_name: "Silvia",
        latitude: 45.44714,
        longitude: 12.32581,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32581, 45.44714]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33517524,
        name: "Dreamy Twin Room in Artist's House B&B",
        host_id: 245561487,
        host_name: "Nicholas",
        latitude: 45.437,
        longitude: 12.32238,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32238, 45.437]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33535867,
        name: "St. Mark’s Square 13 mins walk- breathtaking views",
        host_id: 10989537,
        host_name: "Monica",
        latitude: 45.43451,
        longitude: 12.34975,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34975, 45.43451]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33540105,
        name: "MAGNIFICA STANZA MIRACOLI",
        host_id: 113703606,
        host_name: "Chiara",
        latitude: 45.44158,
        longitude: 12.33809,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33809, 45.44158]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33541436,
        name: "Ground floor flat overlooking Canal Grande",
        host_id: 12497228,
        host_name: "Canal Grande",
        latitude: 45.43072,
        longitude: 12.33198,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33198, 45.43072]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33544514,
        name: "Gorgeous Retreat in Castello Venice Center",
        host_id: 11607112,
        host_name: "Michele",
        latitude: 45.43371,
        longitude: 12.35005,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35005, 45.43371]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33548391,
        name: "Privacy in Venice - Apartment",
        host_id: 130251926,
        host_name: "Luca",
        latitude: 45.43685,
        longitude: 12.34648,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34648, 45.43685]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33553582,
        name: "VENICE HEAVEN APARTMENTS BIENNALE 2 Bedrooms",
        host_id: 1554828,
        host_name: "Veronica",
        latitude: 45.43442,
        longitude: 12.34567,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34567, 45.43442]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33553944,
        name: "Private room1,bright & close to the train station",
        host_id: 252831569,
        host_name: "Anna",
        latitude: 45.43969,
        longitude: 12.32214,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32214, 45.43969]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33556909,
        name: "PopArt in Biennale",
        host_id: 252857570,
        host_name: "Maurizio",
        latitude: 45.4326,
        longitude: 12.35468,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35468, 45.4326]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33575345,
        name: "Tra piazza san Marco e la Biennale",
        host_id: 252996216,
        host_name: "Barbara",
        latitude: 45.43731,
        longitude: 12.34816,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34816, 45.43731]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33577013,
        name: "RESIDENZA GIULIA VENEZIA SESTIERE CASTELLO",
        host_id: 90810692,
        host_name: "Alessandro",
        latitude: 45.43396,
        longitude: 12.35045,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35045, 45.43396]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33579351,
        name: "Procuratie Uno & Due elegant and bright apartments",
        host_id: 24571049,
        host_name: "Simone",
        latitude: 45.44314,
        longitude: 12.32367,
        beds: 9,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32367, 45.44314]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33579923,
        name: "Casa Venezia alla Marinaressa",
        host_id: 11930764,
        host_name: "Elettra Elena",
        latitude: 45.43164,
        longitude: 12.35419,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35419, 45.43164]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33583865,
        name:
          "Casa Gioeli appartamento con giardino, situato in zona tranquilla, comdo e confortevole",
        host_id: 236351452,
        host_name: "Leon E-Domizil",
        latitude: 45.44536,
        longitude: 12.33314,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33314, 45.44536]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33585571,
        name: "Holiday House in Dorsoduro - Art Apartments Venice",
        host_id: 28162920,
        host_name: "Beatriz",
        latitude: 45.43192,
        longitude: 12.31803,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31803, 45.43192]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33587265,
        name: "VENICE HEAVEN APARTMENT BIENNALE 1",
        host_id: 1554828,
        host_name: "Veronica",
        latitude: 45.4359,
        longitude: 12.34621,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34621, 45.4359]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33596972,
        name: "Apartment A Rialto Venice",
        host_id: 224793696,
        host_name: "Claudio",
        latitude: 45.4382,
        longitude: 12.33441,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33441, 45.4382]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33600966,
        name: "La Cortevecchia Venice 1",
        host_id: 253197082,
        host_name: "Paolo",
        latitude: 45.43568,
        longitude: 12.33136,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33136, 45.43568]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33601646,
        name: "La Cortevecchia Venice 2",
        host_id: 253197082,
        host_name: "Paolo",
        latitude: 45.43544,
        longitude: 12.33025,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33025, 45.43544]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33601874,
        name: "La Cortevecchia Venice 3",
        host_id: 253197082,
        host_name: "Paolo",
        latitude: 45.43482,
        longitude: 12.33045,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33045, 45.43482]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33603955,
        name: "Biennale Dream - Monolocale in zona caratteristica",
        host_id: 253189003,
        host_name: "Pilar",
        latitude: 45.4334,
        longitude: 12.35643,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35643, 45.4334]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33604898,
        name: "Ca Borgoloco - Quiet flat near Santa Maria Formosa",
        host_id: 18209533,
        host_name: "Andrea",
        latitude: 45.43933,
        longitude: 12.34145,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34145, 45.43933]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33611886,
        name: "Arsenale 2352 Home Library by Biennale Exhibition",
        host_id: 252963212,
        host_name: "Gino Maria",
        latitude: 45.43383,
        longitude: 12.34858,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34858, 45.43383]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33625641,
        name: "House Ca' Rosa 2 minutes from Biennale",
        host_id: 115635752,
        host_name: "Elena",
        latitude: 45.43251,
        longitude: 12.35506,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35506, 45.43251]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33630245,
        name: "Cozy Apartment with Private Garden Near Biennale",
        host_id: 43658105,
        host_name: "Marco & Roberta",
        latitude: 45.43258,
        longitude: 12.35914,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35914, 45.43258]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33631964,
        name: 'LUXURIOUS CHARMING APARTMENT "LA FENICE"',
        host_id: 51054790,
        host_name: "Anna",
        latitude: 45.4339,
        longitude: 12.33795,
        beds: 8,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33795, 45.4339]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33632724,
        name: "Cà Rezzonico Apartments Balcony - 1° piano",
        host_id: 31637219,
        host_name: "Maria",
        latitude: 45.43334,
        longitude: 12.32358,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32358, 45.43334]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33655067,
        name: "Private room2, bright & close to the train station",
        host_id: 252831569,
        host_name: "Anna",
        latitude: 45.43962,
        longitude: 12.32203,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32203, 45.43962]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33662371,
        name: "Il Ridotto Venice Apartment Rialto San Marco",
        host_id: 5085044,
        host_name: "Sara",
        latitude: 45.43813,
        longitude: 12.33666,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33666, 45.43813]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33668234,
        name: "Corte del Remer",
        host_id: 174418896,
        host_name: "Mimax",
        latitude: 45.43973,
        longitude: 12.33758,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33758, 45.43973]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33672054,
        name: "Fortuny Loft",
        host_id: 253788828,
        host_name: "Fortuny Loft",
        latitude: 45.43449,
        longitude: 12.33161,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33161, 45.43449]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33673156,
        name: "Maison Angelique - renovated apt with canal view",
        host_id: 253796911,
        host_name: "Marika",
        latitude: 45.43349,
        longitude: 12.316,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.316, 45.43349]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33674153,
        name: "Casa Murrina - terrazza su Venezia",
        host_id: 241023758,
        host_name: "Marika",
        latitude: 45.43661,
        longitude: 12.32194,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32194, 45.43661]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33681239,
        name: "Caravaggio room",
        host_id: 197975616,
        host_name: "Olga",
        latitude: 45.43774,
        longitude: 12.34707,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34707, 45.43774]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33699486,
        name:
          "Ve.N.I.Ce Cera Ca' Corte Sconta - M (Phone number hidden by Airbnb)",
        host_id: 37864680,
        host_name: "Ve.N.I.Ce Immobiliare Cera",
        latitude: 45.43378,
        longitude: 12.33351,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33351, 45.43378]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33700616,
        name: "Ormesini Ghetto Venezia",
        host_id: 168611215,
        host_name: "Paolo E Rita Rossetti",
        latitude: 45.44609,
        longitude: 12.3297,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3297, 45.44609]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33705163,
        name: "Private room3,bright & close to the train station",
        host_id: 252831569,
        host_name: "Anna",
        latitude: 45.43863,
        longitude: 12.32217,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32217, 45.43863]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33729915,
        name: "Terrace S.Lio Luxury (200m from Rialto's Bridge)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.43681,
        longitude: 12.33898,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33898, 45.43681]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33731001,
        name: "Ca' Gioacchino Biennale apartment",
        host_id: 294951,
        host_name: "VeniceVillas Di Enzo",
        latitude: 45.4334,
        longitude: 12.35728,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35728, 45.4334]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33732382,
        name: "Posto letto in cabina condivisa Mista",
        host_id: 23182155,
        host_name: "Stefano Roberta",
        latitude: 45.42675,
        longitude: 12.36571,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.36571, 45.42675]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33732893,
        name: "Posto letto in Cabina condivisa Mista",
        host_id: 23182155,
        host_name: "Stefano Roberta",
        latitude: 45.4281,
        longitude: 12.36475,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.36475, 45.4281]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33733505,
        name: "BIENNALE1215....a Venezia come ospiti!",
        host_id: 254283898,
        host_name: "Christian",
        latitude: 45.43105,
        longitude: 12.3552,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3552, 45.43105]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33740316,
        name: "Suite in Mansarda - Artist's House B&B",
        host_id: 245561487,
        host_name: "Nicholas",
        latitude: 45.43562,
        longitude: 12.32368,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32368, 45.43562]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33741695,
        name: "Giorgione 07 - Casin dei Spiriti",
        host_id: 252964422,
        host_name: "Thomas",
        latitude: 45.44308,
        longitude: 12.33314,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33314, 45.44308]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33741704,
        name: "Tiziano 08 - Casin dei Spiriti",
        host_id: 252964422,
        host_name: "Thomas",
        latitude: 45.44377,
        longitude: 12.33353,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33353, 45.44377]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33741738,
        name: "Veronese 09 - Casin dei Spiriti",
        host_id: 252964422,
        host_name: "Thomas",
        latitude: 45.44511,
        longitude: 12.33364,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33364, 45.44511]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33741760,
        name: "Bellini 10 - Casin dei Spiriti",
        host_id: 252964422,
        host_name: "Thomas",
        latitude: 45.44453,
        longitude: 12.33387,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33387, 45.44453]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33741782,
        name: "Tintoretto 11 - Casin dei Spiriti",
        host_id: 252964422,
        host_name: "Thomas",
        latitude: 45.44377,
        longitude: 12.33373,
        beds: null,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33373, 45.44377]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33758651,
        name: "Ap. Rialto Dream (200m from Rialto's Bridge)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.43993,
        longitude: 12.33239,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33239, 45.43993]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33759620,
        name: "Charming suite in the heart of Venice",
        host_id: 49102512,
        host_name: "Leo",
        latitude: 45.43946,
        longitude: 12.33496,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33496, 45.43946]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33760159,
        name: "Venezia centralissima doppia al Grey's",
        host_id: 29619859,
        host_name: "Stefano",
        latitude: 45.43969,
        longitude: 12.33648,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33648, 45.43969]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33761788,
        name: "FaceVenice Biennale Giardini WiFi",
        host_id: 254491451,
        host_name: "Luigi",
        latitude: 45.43078,
        longitude: 12.35524,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35524, 45.43078]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33762250,
        name: "Yacht Sirius Queen SX",
        host_id: 29619859,
        host_name: "Stefano",
        latitude: 45.42893,
        longitude: 12.36628,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.36628, 45.42893]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33764725,
        name: "Double Room in mansarda - Artist's House B&B",
        host_id: 245561487,
        host_name: "Nicholas",
        latitude: 45.43597,
        longitude: 12.32363,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32363, 45.43597]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33776736,
        name: "Quiet Venice close to Arsenale and Biennale",
        host_id: 9128224,
        host_name: "Chris & Irma",
        latitude: 45.43439,
        longitude: 12.35651,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35651, 45.43439]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33787075,
        name: "Ai Giardini de Casteo Biennale Oro",
        host_id: 89722282,
        host_name: "Frank",
        latitude: 45.43078,
        longitude: 12.35704,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35704, 45.43078]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33787782,
        name: "AI Giardini de Casteo Biennale Bianca",
        host_id: 89722282,
        host_name: "Frank",
        latitude: 45.43375,
        longitude: 12.3528,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3528, 45.43375]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33788237,
        name: "Ai Giardini de Casteo Biennale Verde",
        host_id: 89722282,
        host_name: "Frank",
        latitude: 45.43549,
        longitude: 12.35098,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35098, 45.43549]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33788947,
        name: "CASAMIA",
        host_id: 80002072,
        host_name: "Oscar",
        latitude: 45.43328,
        longitude: 12.35468,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35468, 45.43328]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33791168,
        name: "Bright & Airy Apartment in San Marco",
        host_id: 244073921,
        host_name: "Olly",
        latitude: 45.43566,
        longitude: 12.34517,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34517, 45.43566]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33792749,
        name: "A small place for a perfect staying",
        host_id: 7641199,
        host_name: "Federica",
        latitude: 45.44601,
        longitude: 12.32822,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32822, 45.44601]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33797305,
        name: "Residence Casin dei Spiriti up to 26 people",
        host_id: 252964422,
        host_name: "Thomas",
        latitude: 45.4434,
        longitude: 12.33476,
        beds: 11,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33476, 45.4434]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33819427,
        name: "Romantic room with canopy bed and ensuite bathroom",
        host_id: 255176846,
        host_name: "Luca",
        latitude: 45.43885,
        longitude: 12.33153,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33153, 45.43885]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33825425,
        name: "Charming nest in the Heart of Venice 'San Polo'",
        host_id: 202419,
        host_name: "Cinzia",
        latitude: 45.43771,
        longitude: 12.32971,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32971, 45.43771]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33826153,
        name: "Ca' Stella Luxury",
        host_id: 255389051,
        host_name: "Marika",
        latitude: 45.44219,
        longitude: 12.34049,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34049, 45.44219]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33841306,
        name: "Guggenheim Flat Venice",
        host_id: 226026079,
        host_name: "Salvatore",
        latitude: 45.43204,
        longitude: 12.32752,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32752, 45.43204]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33843201,
        name: "Biennale 1585 AlfaΒ up to 9 persons",
        host_id: 166297081,
        host_name: "Thomas",
        latitude: 45.43163,
        longitude: 12.35285,
        beds: null,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35285, 45.43163]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33845528,
        name: "Cheap, cozy and friendly sofa bed for one",
        host_id: 21094325,
        host_name: "Gianna",
        latitude: 45.42635,
        longitude: 12.32652,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32652, 45.42635]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33847227,
        name: "Le Ancore next to Biennale",
        host_id: 255562655,
        host_name: "Leti&Jo",
        latitude: 45.4319,
        longitude: 12.35697,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35697, 45.4319]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33851957,
        name: "GIGLIO HOUSE Sestiere San Marco Venice Italy",
        host_id: 255606801,
        host_name: "Carlo",
        latitude: 45.43288,
        longitude: 12.33237,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33237, 45.43288]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33863614,
        name: "Ca' degli Oresi - Attico",
        host_id: 188143554,
        host_name: "Emanuela",
        latitude: 45.43271,
        longitude: 12.3288,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3288, 45.43271]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33890037,
        name: "VENEZIA CENTRO STORICO UNA VACANZA DA SOGNO!",
        host_id: 35462271,
        host_name: "Federica",
        latitude: 45.43334,
        longitude: 12.33228,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33228, 45.43334]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33897356,
        name: "Duplex Casin dei Spiriti up to 12 persons",
        host_id: 252964422,
        host_name: "Thomas",
        latitude: 45.4437,
        longitude: 12.33367,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33367, 45.4437]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33905388,
        name: "Castello 5067 boutique apartment",
        host_id: 249101052,
        host_name: "Lorenzo",
        latitude: 45.43812,
        longitude: 12.34413,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34413, 45.43812]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33910003,
        name: "FRARI LUXURY APARTMENT (M (Phone number hidden by Airbnb)",
        host_id: 1384013,
        host_name: "Paola, Dody E Raffaele",
        latitude: 45.43808,
        longitude: 12.32824,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32824, 45.43808]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33910005,
        name: "PALAZZINA ADORATA avec vues Canal - VENISEJETAIME",
        host_id: 78873399,
        host_name: "Florence",
        latitude: 45.44151,
        longitude: 12.33476,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33476, 45.44151]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33910780,
        name: "Biennale - Residenza Corte Maltese Formule STUDIO",
        host_id: 6713218,
        host_name: "Hugues",
        latitude: 45.437,
        longitude: 12.34794,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34794, 45.437]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33911343,
        name: "Residenza Corte Maltese AVEC COUR Proche Biennale",
        host_id: 6713218,
        host_name: "Hugues",
        latitude: 45.4369,
        longitude: 12.34764,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34764, 45.4369]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33931767,
        name: "Regina Terrace_Living Rialto!",
        host_id: 256228866,
        host_name: "Yoav",
        latitude: 45.44112,
        longitude: 12.33052,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33052, 45.44112]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33954971,
        name: "Ca' Marcella",
        host_id: 87431454,
        host_name: "Giuliano",
        latitude: 45.43578,
        longitude: 12.34098,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34098, 45.43578]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33958095,
        name: "Venice Grand Canal Style Apt. 2",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.43841,
        longitude: 12.33245,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33245, 45.43841]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33958308,
        name: "DolceVita Apartments N. 443 Design Calle Varisco",
        host_id: 8176475,
        host_name: "Eugenia",
        latitude: 45.44204,
        longitude: 12.3388,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3388, 45.44204]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33958582,
        name: "Venice Grand Canal Style Apt. 3",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.43814,
        longitude: 12.33215,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33215, 45.43814]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33962707,
        name: "MAISON SANT'ELENA BIENNALE + Garden Venise centre",
        host_id: 78873399,
        host_name: "Florence",
        latitude: 45.42711,
        longitude: 12.36243,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.36243, 45.42711]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33978143,
        name: "NEW!! Central between St. Mark and Biennale. Apt 3",
        host_id: 206569614,
        host_name: "Edoardo",
        latitude: 45.43595,
        longitude: 12.34781,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34781, 45.43595]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33984541,
        name: "Apartment with canal view near Piazzale Roma",
        host_id: 289615,
        host_name: "Valentina",
        latitude: 45.43653,
        longitude: 12.32377,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32377, 45.43653]] },
    },
    {
      type: "Feature",
      properties: {
        id: 33987886,
        name: "RIALTO APT: WIFI - 5 min from Rialto and Station",
        host_id: 133690220,
        host_name: "Silvia-Carlo",
        latitude: 45.44073,
        longitude: 12.32699,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32699, 45.44073]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34004224,
        name: "Splendida e indimenticabile vacanza Veneziana",
        host_id: 256758047,
        host_name: "Alice",
        latitude: 45.44311,
        longitude: 12.32864,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32864, 45.44311]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34006056,
        name: "Ca' Dei Diamanti Grand Canal",
        host_id: 669047,
        host_name: "Viewsonvenice",
        latitude: 45.43708,
        longitude: 12.33045,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33045, 45.43708]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34008264,
        name: "Luxury Duodo Gregolin Palace",
        host_id: 50349340,
        host_name: "Sebastiano",
        latitude: 45.43477,
        longitude: 12.33575,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33575, 45.43477]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34009427,
        name: "Ideal room#1 a few meters from Rialto Bridge",
        host_id: 252831569,
        host_name: "Anna",
        latitude: 45.43731,
        longitude: 12.33385,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33385, 45.43731]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34010398,
        name: "San Marco Deluxe Suite R&R",
        host_id: 173200514,
        host_name: "Rent&Relax",
        latitude: 45.43477,
        longitude: 12.33491,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33491, 45.43477]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34011303,
        name: "Apt. Giudecca Luxury Gallery (with Terrace)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.42717,
        longitude: 12.32134,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32134, 45.42717]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34011767,
        name: "Classy Venice Apartment",
        host_id: 256807399,
        host_name: "Argo",
        latitude: 45.44411,
        longitude: 12.32634,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32634, 45.44411]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34013434,
        name: "Castello Elegant Apartment x5! WONDERFUL VENICE",
        host_id: 96221395,
        host_name: "Welcome To Veneto & Friuli",
        latitude: 45.43729,
        longitude: 12.34224,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34224, 45.43729]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34014328,
        name: "Bacino San Marco Exclusive View R&R",
        host_id: 173200514,
        host_name: "Rent&Relax",
        latitude: 45.43415,
        longitude: 12.34642,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34642, 45.43415]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34014749,
        name: "Ideal room#2 a few meters from Rialto Bridge",
        host_id: 252831569,
        host_name: "Anna",
        latitude: 45.4377,
        longitude: 12.3329,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3329, 45.4377]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34014760,
        name: "Ideal room#3 a few meters from Rialto Bridge",
        host_id: 252831569,
        host_name: "Anna",
        latitude: 45.43748,
        longitude: 12.33407,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33407, 45.43748]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34015356,
        name: "Ideal Loft in Rialto, roofterrace and amazing view",
        host_id: 252831569,
        host_name: "Anna",
        latitude: 45.43904,
        longitude: 12.33257,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33257, 45.43904]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34028162,
        name: "RIALTO SUITE: close to Train Station & free WIFI",
        host_id: 133690220,
        host_name: "Silvia-Carlo",
        latitude: 45.44182,
        longitude: 12.32617,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32617, 45.44182]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34030406,
        name: "Apartment Falier (600m from Rialto's Bridge)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.43821,
        longitude: 12.32954,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32954, 45.43821]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34031789,
        name: "Luxury romantic loft in heart of venice New open 7",
        host_id: 4806020,
        host_name: "Iber",
        latitude: 45.44302,
        longitude: 12.33231,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33231, 45.44302]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34071866,
        name: "Arsenale room#1, big flat, amazing position!!",
        host_id: 257293809,
        host_name: "Andrea",
        latitude: 45.43301,
        longitude: 12.35154,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35154, 45.43301]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34073285,
        name: "Arsenale room#2, big flat, amazing position!!",
        host_id: 257293809,
        host_name: "Andrea",
        latitude: 45.43402,
        longitude: 12.35024,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35024, 45.43402]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34073464,
        name: "Huge flat, 3 bedrooms, Arsenale / San Marco!",
        host_id: 257293809,
        host_name: "Andrea",
        latitude: 45.43446,
        longitude: 12.35238,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35238, 45.43446]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34077101,
        name: "Palazzetto Canossa Beatrice Suite",
        host_id: 257326087,
        host_name: "Roberta",
        latitude: 45.44359,
        longitude: 12.33033,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33033, 45.44359]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34101770,
        name: "Casa Roberta",
        host_id: 257510062,
        host_name: "Lidia",
        latitude: 45.43313,
        longitude: 12.35336,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35336, 45.43313]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34103156,
        name: "CA VERDI DELL'ALTANA",
        host_id: 53699315,
        host_name: "Marinella E Stefano",
        latitude: 45.44035,
        longitude: 12.33485,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33485, 45.44035]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34108248,
        name: "SOGNO DI VENEZIA",
        host_id: 256758047,
        host_name: "Alice",
        latitude: 45.44114,
        longitude: 12.3151,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3151, 45.44114]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34108732,
        name: "Ca' D'Oro Terrace",
        host_id: 204435441,
        host_name: "Mariagiovanna",
        latitude: 45.44123,
        longitude: 12.33605,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33605, 45.44123]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34111980,
        name: "Palazzetto Canossa Matilde Suite",
        host_id: 257326087,
        host_name: "Roberta",
        latitude: 45.44332,
        longitude: 12.32965,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32965, 45.44332]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34113468,
        name: "Palazzetto Canossa Maddalena Suite",
        host_id: 257326087,
        host_name: "Roberta",
        latitude: 45.44505,
        longitude: 12.32853,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32853, 45.44505]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34113887,
        name: "VIEW CANAL AND GONDOLA TOP FLAT LUXURY DESIGN",
        host_id: 13500918,
        host_name: "Mark",
        latitude: 45.43605,
        longitude: 12.34154,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34154, 45.43605]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34119555,
        name: "Casa dei due soli",
        host_id: 257624417,
        host_name: "Mirka",
        latitude: 45.42663,
        longitude: 12.36058,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.36058, 45.42663]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34142591,
        name: "Corte di Elly",
        host_id: 257778103,
        host_name: "Elena",
        latitude: 45.43387,
        longitude: 12.32329,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32329, 45.43387]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34150468,
        name: "Incanto Venice - Rialto neighborhood",
        host_id: 257835653,
        host_name: "Nicola",
        latitude: 45.4402,
        longitude: 12.3367,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3367, 45.4402]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34161228,
        name: "Comfortable & Cozy Apt. near San Marco Square, AC",
        host_id: 257926874,
        host_name: "Andrea",
        latitude: 45.42955,
        longitude: 12.35843,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35843, 45.42955]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34173473,
        name: "Appartamento a San Marco con Vista sulla Basilica",
        host_id: 129835471,
        host_name: "Nicoletta",
        latitude: 45.43422,
        longitude: 12.33858,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33858, 45.43422]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34176841,
        name: "Arsenale room#3, big flat, amazing position!!",
        host_id: 257293809,
        host_name: "Andrea",
        latitude: 45.43359,
        longitude: 12.35113,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35113, 45.43359]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34178446,
        name: "San Lorenzo - Balcony Canal  View",
        host_id: 196621538,
        host_name: "Dimitri & Valentina",
        latitude: 45.43688,
        longitude: 12.34399,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34399, 45.43688]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34179527,
        name: "Great room#1 in super central position!",
        host_id: 258055441,
        host_name: "Niky",
        latitude: 45.43935,
        longitude: 12.32672,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32672, 45.43935]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34179886,
        name: "Great room#2 in super central position!",
        host_id: 258055441,
        host_name: "Niky",
        latitude: 45.43884,
        longitude: 12.32422,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32422, 45.43884]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34190201,
        name: "Residenza MaryAnn",
        host_id: 258137121,
        host_name: "Giacomo",
        latitude: 45.44017,
        longitude: 12.33732,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33732, 45.44017]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34190206,
        name: "Central apartment - Ca' Zaccaria",
        host_id: 214062359,
        host_name: "Sarlux",
        latitude: 45.43715,
        longitude: 12.34046,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34046, 45.43715]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34195927,
        name: "Hotel San Samuele - Suite Apartment 1 (2 bedrooms)",
        host_id: 98028059,
        host_name: "Staff Hotel San Samuele",
        latitude: 45.43339,
        longitude: 12.32875,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32875, 45.43339]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34198520,
        name: "Apt. Terrazza la Fenice a San Marco",
        host_id: 39600986,
        host_name: "Christine",
        latitude: 45.43354,
        longitude: 12.33312,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33312, 45.43354]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34198812,
        name: "NoStress Holiday - Zen - Private Apartment",
        host_id: 233209105,
        host_name: "Venice No Stress",
        latitude: 45.44418,
        longitude: 12.33857,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33857, 45.44418]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34199496,
        name: "Loft with amazing view and contemporary design",
        host_id: 3809491,
        host_name: "Pierluigi",
        latitude: 45.44308,
        longitude: 12.33948,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33948, 45.44308]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34203521,
        name: "Apartment Casa Carolina ai Giardini della Biennale",
        host_id: 48081958,
        host_name: "Veronica",
        latitude: 45.432399928143219,
        longitude: 12.356621473042619,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35662, 45.4324]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34203604,
        name: "Casa Carolina ai Giardini della Biennale",
        host_id: 48081958,
        host_name: "Veronica",
        latitude: 45.432399928143219,
        longitude: 12.356621473042619,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35662, 45.4324]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34204264,
        name: "Apartament Casa Carolina",
        host_id: 48081958,
        host_name: "Veronica",
        latitude: 45.432399928143219,
        longitude: 12.356621473042619,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35662, 45.4324]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34215922,
        name: "Maison Marea, canal view & patio charming house",
        host_id: 258321283,
        host_name: "Roberta",
        latitude: 45.43147,
        longitude: 12.31788,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31788, 45.43147]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34223409,
        name: "Palazzo amazing view on the Grand Canal",
        host_id: 258374156,
        host_name: "Fondazione",
        latitude: 45.43399,
        longitude: 12.3299,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3299, 45.43399]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34229867,
        name: "Ca'dell'Opera 1637 - I Room",
        host_id: 258426902,
        host_name: "Loukas",
        latitude: 45.43975,
        longitude: 12.33172,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33172, 45.43975]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34230533,
        name: "Ca'dell'Opera 1637 - II Room",
        host_id: 258426902,
        host_name: "Loukas",
        latitude: 45.43871,
        longitude: 12.3329,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3329, 45.43871]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34240638,
        name: "Charming and bright comfortable apartment",
        host_id: 258511996,
        host_name: "Luca",
        latitude: 45.44109,
        longitude: 12.33148,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33148, 45.44109]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34244958,
        name: "Palazzo Ca’ Bernardi. Vista su canale, wifi, a/c",
        host_id: 43101354,
        host_name: "Cristiana",
        latitude: 45.43687,
        longitude: 12.33074,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33074, 45.43687]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34249658,
        name: "Cà Degli Amici (our Friends' House)",
        host_id: 47322920,
        host_name: "Mario & Esmeralda",
        latitude: 45.43999,
        longitude: 12.34043,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34043, 45.43999]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34251058,
        name: "Appartamento Carolina ai Giardini della Biennale",
        host_id: 48081958,
        host_name: "Veronica",
        latitude: 45.432399928143219,
        longitude: 12.356621473042619,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35662, 45.4324]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34254696,
        name: "La Bonbonnier",
        host_id: 44994934,
        host_name: "Sara",
        latitude: 45.42917,
        longitude: 12.35877,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35877, 45.42917]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34278631,
        name: "Ca' Federico San Marco Venice Apartment",
        host_id: 226694283,
        host_name: "Paolo",
        latitude: 45.43615,
        longitude: 12.33643,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33643, 45.43615]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34281543,
        name: "NEW!! Central between St. Mark and Biennale. Apt 4",
        host_id: 206569614,
        host_name: "Edoardo",
        latitude: 45.43571,
        longitude: 12.34642,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34642, 45.43571]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34294601,
        name: "✧ Charming Wooden Nest ✧",
        host_id: 258176182,
        host_name: "Giovanna",
        latitude: 45.44156,
        longitude: 12.34049,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34049, 45.44156]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34301675,
        name: "Cozy Suite in the historic centre with Canal View",
        host_id: 258963437,
        host_name: "Antongiulio",
        latitude: 45.44087,
        longitude: 12.32351,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32351, 45.44087]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34322184,
        name: "Santa Lucia, Modern & Charming Venetian Apartment!",
        host_id: 259039981,
        host_name: "Michele",
        latitude: 45.44162,
        longitude: 12.32761,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32761, 45.44162]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34322775,
        name: "DENIS Flat in real Venice Centre",
        host_id: 185612295,
        host_name: "Lory",
        latitude: 45.43623,
        longitude: 12.34737,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34737, 45.43623]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34324101,
        name: "La Bauta",
        host_id: 241023758,
        host_name: "Marika",
        latitude: 45.43491,
        longitude: 12.32131,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32131, 45.43491]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34329419,
        name: "SAN MARCO TORRETTA SUITE - CITY CENTER!",
        host_id: 289615,
        host_name: "Valentina",
        latitude: 45.43564,
        longitude: 12.33785,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33785, 45.43564]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34329420,
        name: "SAN MARCO TERRACE & CANALVIEW: Wi-Fi & Washer",
        host_id: 289615,
        host_name: "Valentina",
        latitude: 45.43424,
        longitude: 12.3416,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3416, 45.43424]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34337379,
        name: "MIRELLA FINE LIVING",
        host_id: 155423628,
        host_name: "Max",
        latitude: 45.42544,
        longitude: 12.33509,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33509, 45.42544]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34345781,
        name: "Stanza singola nel cuore di Venezia",
        host_id: 85797403,
        host_name: "Ilaria",
        latitude: 45.44217,
        longitude: 12.34011,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34011, 45.44217]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34356469,
        name: "Spacious apartment closeby to Basilica Dei Frari",
        host_id: 91653283,
        host_name: "Casamalvasia",
        latitude: 45.43834,
        longitude: 12.32639,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32639, 45.43834]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34367588,
        name: "casa in antico Ghetto ebraico",
        host_id: 34435200,
        host_name: "Emmanuel",
        latitude: 45.44543,
        longitude: 12.32475,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32475, 45.44543]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34370573,
        name: "Room#2, great position and comfort!",
        host_id: 229046688,
        host_name: "Atanas",
        latitude: 45.43894,
        longitude: 12.3275,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3275, 45.43894]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34370683,
        name: "Room#3, great position, comfort & canal view!!!",
        host_id: 229046688,
        host_name: "Atanas",
        latitude: 45.4391,
        longitude: 12.32922,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32922, 45.4391]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34379858,
        name: "♔The Kingdom of Elegance L♡vers",
        host_id: 259375326,
        host_name: "Luisa",
        latitude: 45.43562,
        longitude: 12.34667,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34667, 45.43562]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34380382,
        name: "Cute room#1 near Santa Lucia and Strada Nuova!",
        host_id: 229046688,
        host_name: "Atanas",
        latitude: 45.44563,
        longitude: 12.32965,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32965, 45.44563]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34383692,
        name: "Ca' de l'Arco: Your Home near St. Mark's Square",
        host_id: 259575135,
        host_name: "Franco",
        latitude: 45.43597,
        longitude: 12.34322,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34322, 45.43597]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34383858,
        name: "APPARTAMENTO AL PONTE   M (Phone number hidden by Airbnb)",
        host_id: 259576037,
        host_name: "Tito",
        latitude: 45.43459,
        longitude: 12.33137,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33137, 45.43459]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34385695,
        name: "Appartamento  design con affaccio su campo Widmann",
        host_id: 256807399,
        host_name: "Argo",
        latitude: 45.44042,
        longitude: 12.34058,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34058, 45.44042]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34385715,
        name: "Biennale art Room Venice Casinó n.2",
        host_id: 48092742,
        host_name: "Roby",
        latitude: 45.4432,
        longitude: 12.32943,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32943, 45.4432]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34386218,
        name: "Biennale Art Flat Venice",
        host_id: 145813573,
        host_name: "Nicola",
        latitude: 45.43096,
        longitude: 12.35946,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35946, 45.43096]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34390658,
        name: "SANTI APOSTOLI SUITE, Sestiere Cannaregio Venezia",
        host_id: 241274064,
        host_name: "Enrico",
        latitude: 45.43995,
        longitude: 12.33597,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33597, 45.43995]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34405282,
        name:
          "Raffinato gem in the heart of Venice - M (Phone number hidden by Airbnb)",
        host_id: 20806166,
        host_name: "Giovanna",
        latitude: 45.44308,
        longitude: 12.33078,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33078, 45.44308]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34415792,
        name: "Champagne ensuite bathroom",
        host_id: 255176846,
        host_name: "Luca",
        latitude: 45.43892,
        longitude: 12.33122,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33122, 45.43892]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34419279,
        name: "Imperial Flat Giardini Biennale Tosi 3",
        host_id: 13500918,
        host_name: "Mark",
        latitude: 45.43107,
        longitude: 12.35667,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35667, 45.43107]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34419453,
        name: "Nice Apartment in Biennale tosi3",
        host_id: 31276705,
        host_name: "Mila",
        latitude: 45.43131,
        longitude: 12.35599,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35599, 45.43131]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34427445,
        name: "Guglie Palace",
        host_id: 183602040,
        host_name: "Anna",
        latitude: 45.44422,
        longitude: 12.32596,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32596, 45.44422]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34428160,
        name: "APARTMENT RELAX ART BIENNALE TOSI 1",
        host_id: 48092742,
        host_name: "Roby",
        latitude: 45.43269,
        longitude: 12.35694,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35694, 45.43269]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34429284,
        name: "appartamento Ca'Giuseppa",
        host_id: 29231597,
        host_name: "Alessandro &  Sabrina",
        latitude: 45.43927,
        longitude: 12.32239,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32239, 45.43927]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34429435,
        name: "Cozy and cheap room two steps from the biennial!",
        host_id: 1797463,
        host_name: "Tawo",
        latitude: 45.43078,
        longitude: 12.35829,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35829, 45.43078]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34437867,
        name: "Zattere English Cottage close to Guggenheim",
        host_id: 165990342,
        host_name: "Giovanna",
        latitude: 45.42956,
        longitude: 12.33101,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33101, 45.42956]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34442527,
        name: "Cute room#2 near Santa Lucia and Strada Nuova!",
        host_id: 229046688,
        host_name: "Atanas",
        latitude: 45.44558,
        longitude: 12.32814,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32814, 45.44558]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34442934,
        name: "Cute suite#3 near Santa Lucia and Strada Nuova!",
        host_id: 229046688,
        host_name: "Atanas",
        latitude: 45.44403,
        longitude: 12.32948,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32948, 45.44403]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34457320,
        name: "Ca' Veronese, nice apartment in a premier location",
        host_id: 25128793,
        host_name: "_mdm_",
        latitude: 45.43701,
        longitude: 12.33287,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33287, 45.43701]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34461208,
        name: "CAMPO SAN LORENZO: M (Phone number hidden by Airbnb)",
        host_id: 113405578,
        host_name: "Loredana",
        latitude: 45.4375,
        longitude: 12.34452,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34452, 45.4375]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34462729,
        name: "Charming Studio St. Mark’s Square 12 mins walking",
        host_id: 10989537,
        host_name: "Monica",
        latitude: 45.43356,
        longitude: 12.34816,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34816, 45.43356]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34467028,
        name: "Appartamento Campo Escondido",
        host_id: 260175639,
        host_name: "Filippo",
        latitude: 45.43403,
        longitude: 12.32283,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32283, 45.43403]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34469303,
        name: "Apartment Pistachio Not Air Conditioned",
        host_id: 630328,
        host_name: "Kosher House",
        latitude: 45.44661,
        longitude: 12.32724,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32724, 45.44661]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34489599,
        name: "Venice central, canal view, modern apartment",
        host_id: 179298782,
        host_name: "Sabrina",
        latitude: 45.43375,
        longitude: 12.35669,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35669, 45.43375]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34491973,
        name: "Central Venice-15 minutes from S.Marco, 2 bedrooms",
        host_id: 179298782,
        host_name: "Sabrina",
        latitude: 45.43287,
        longitude: 12.35581,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35581, 45.43287]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34493941,
        name:
          "La corte  San Lorenzo near San Marco M (Phone number hidden by Airbnb)",
        host_id: 260360901,
        host_name: "Francesca",
        latitude: 45.43606,
        longitude: 12.34411,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34411, 45.43606]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34504893,
        name: "Double ensuite bathroom with Wonderfull terrace",
        host_id: 255176846,
        host_name: "Luca",
        latitude: 45.43908,
        longitude: 12.33107,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33107, 45.43908]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34505728,
        name: "Ai due Leoni",
        host_id: 260411602,
        host_name: "Ca",
        latitude: 45.43382,
        longitude: 12.3503,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3503, 45.43382]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34507030,
        name: "Apartment Sunny Venice St. Mark's district",
        host_id: 224793696,
        host_name: "Claudio",
        latitude: 45.4326,
        longitude: 12.32895,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32895, 45.4326]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34509928,
        name: "Suite Luxary piazza San Marco",
        host_id: 260258633,
        host_name: "Robi",
        latitude: 45.4336,
        longitude: 12.33518,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33518, 45.4336]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34520548,
        name: "Spacious Apt 3 Min Walk to RIALTO Bridge & AC+WiFi",
        host_id: 260539153,
        host_name: "July",
        latitude: 45.43657,
        longitude: 12.33189,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33189, 45.43657]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34522386,
        name: "Unique apartment in the centre of Venice with view",
        host_id: 41889313,
        host_name: "Federica & Alessandro",
        latitude: 45.43319,
        longitude: 12.33534,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33534, 45.43319]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34524692,
        name: "La Prima Ancora",
        host_id: 46904188,
        host_name: "Mirco Optyflat",
        latitude: 45.43019,
        longitude: 12.35676,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35676, 45.43019]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34532547,
        name: "Rialto romantic central Room",
        host_id: 48092742,
        host_name: "Roby",
        latitude: 45.43812,
        longitude: 12.33657,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33657, 45.43812]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34533751,
        name: "View on the Venetian lagoon - WiFi - washer - NEW!",
        host_id: 289615,
        host_name: "Valentina",
        latitude: 45.44658,
        longitude: 12.32098,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32098, 45.44658]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34541390,
        name: "Your private cabin in a sailing yacht in Venice",
        host_id: 77330285,
        host_name: "Andrea",
        latitude: 45.42881,
        longitude: 12.36604,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.36604, 45.42881]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34542359,
        name: "Your own private sailing yacht in Cagliari",
        host_id: 77330285,
        host_name: "Andrea",
        latitude: 45.42769,
        longitude: 12.36564,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.36564, 45.42769]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34548080,
        name: "ExclusiVenice San Polo- San Augustin 2312",
        host_id: 235305051,
        host_name: "Massimo",
        latitude: 45.43848,
        longitude: 12.32821,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32821, 45.43848]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34552933,
        name: "Generator - Bed in 10 Female Dorm with Private Bathroom",
        host_id: 251480550,
        host_name: "Generator",
        latitude: 45.42515,
        longitude: 12.33597,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33597, 45.42515]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34554618,
        name: "New San Basilio Suite - Canal view",
        host_id: 135417898,
        host_name: "Chiara",
        latitude: 45.43089,
        longitude: 12.32208,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32208, 45.43089]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34588027,
        name: "♪ Peaceful Nest ♫ Relax along the Canal",
        host_id: 260172347,
        host_name: "Claudia",
        latitude: 45.43015,
        longitude: 12.33205,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33205, 45.43015]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34588717,
        name: "NEW! VENICE Santa Croce Cozy Apt x3",
        host_id: 96221395,
        host_name: "Welcome To Veneto & Friuli",
        latitude: 45.44161,
        longitude: 12.32458,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32458, 45.44161]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34592569,
        name: "Appartamento tra San Marco e l'Arsenale",
        host_id: 17594675,
        host_name: "Davide",
        latitude: 45.43497,
        longitude: 12.34657,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34657, 45.43497]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34593348,
        name: "✧The House in the Court✧  Discovering Cannaregio",
        host_id: 260175891,
        host_name: "Filippo",
        latitude: 45.4461,
        longitude: 12.32541,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32541, 45.4461]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34593813,
        name: "Romance on the roof! Lovely City view. Elevator",
        host_id: 6019189,
        host_name: "Federico",
        latitude: 45.43449,
        longitude: 12.32208,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32208, 45.43449]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34622084,
        name: "Penthouse San Marco Square",
        host_id: 260258633,
        host_name: "Robi",
        latitude: 45.4324,
        longitude: 12.33708,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33708, 45.4324]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34625888,
        name: "S.Lucia Canal&Garden view Wifi/Lift/AC/2Balconies",
        host_id: 255326628,
        host_name: "Gio",
        latitude: 45.44491,
        longitude: 12.31984,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31984, 45.44491]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34632316,
        name: "Suite home piazza san Marco",
        host_id: 260258633,
        host_name: "Robi",
        latitude: 45.43296,
        longitude: 12.3353,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3353, 45.43296]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34633132,
        name: "Cute little room with a balcony",
        host_id: 172838960,
        host_name: "Venice",
        latitude: 45.43176,
        longitude: 12.33233,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33233, 45.43176]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34645201,
        name: "♡ of Venice - Rialto Triple Room",
        host_id: 172838960,
        host_name: "Venice",
        latitude: 45.4383,
        longitude: 12.33162,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33162, 45.4383]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34645571,
        name: "Marco Polo il viaggiatore",
        host_id: 260606982,
        host_name: "Manolo",
        latitude: 45.43754,
        longitude: 12.32948,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32948, 45.43754]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34646643,
        name: "San Marco classy apartment",
        host_id: 98131866,
        host_name: "Michele",
        latitude: 45.43438,
        longitude: 12.33504,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33504, 45.43438]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34672455,
        name: "SAN MAURIZIO APARTMENT     M (Phone number hidden by Airbnb)",
        host_id: 24440436,
        host_name: "Arianna",
        latitude: 45.43285,
        longitude: 12.33021,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33021, 45.43285]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34681031,
        name: "CA' ANGELA VENETIAN APARTMENT",
        host_id: 5862083,
        host_name: "Silvia",
        latitude: 45.43696,
        longitude: 12.3309,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3309, 45.43696]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34698223,
        name: "Generator - Bed in 16 Bed Room with shared Bathroom",
        host_id: 251480550,
        host_name: "Generator",
        latitude: 45.42535,
        longitude: 12.33683,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33683, 45.42535]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34698249,
        name: "♡ of Venice - Private Rialto Double Room",
        host_id: 172838960,
        host_name: "Venice",
        latitude: 45.43696,
        longitude: 12.33224,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33224, 45.43696]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34698761,
        name: "♡ of Venice - Cosy Private Twin Room",
        host_id: 172838960,
        host_name: "Venice",
        latitude: 45.43773,
        longitude: 12.33096,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33096, 45.43773]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34702487,
        name: "Geraldine's Place",
        host_id: 261748264,
        host_name: "Angelo",
        latitude: 45.43964,
        longitude: 12.32455,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32455, 45.43964]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34704980,
        name: '"Viazar descanta"',
        host_id: 31287480,
        host_name: "Ugolini",
        latitude: 45.43447,
        longitude: 12.31854,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31854, 45.43447]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34706739,
        name: "BIENNALEbiancaSINGOLA (1 persona)",
        host_id: 89722282,
        host_name: "Frank",
        latitude: 45.43914,
        longitude: 12.35999,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35999, 45.43914]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34707776,
        name: "BIENNALEverdeSINGOLA  (1 persona)",
        host_id: 89722282,
        host_name: "Frank",
        latitude: 45.43743,
        longitude: 12.36002,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.36002, 45.43743]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34708081,
        name: "BIENNALEoroSINGOLA (1 persona)",
        host_id: 89722282,
        host_name: "Frank",
        latitude: 45.43887,
        longitude: 12.36095,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.36095, 45.43887]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34729184,
        name: "Ca' Brighella, the real venice",
        host_id: 294951,
        host_name: "VeniceVillas Di Enzo",
        latitude: 45.44754,
        longitude: 12.32333,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32333, 45.44754]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34768848,
        name: "Ca' Dei Greci",
        host_id: 669047,
        host_name: "Viewsonvenice",
        latitude: 45.43676,
        longitude: 12.34373,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34373, 45.43676]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34769137,
        name: "Charming Flat in Dorsoduro/Ca' Foscari",
        host_id: 12497228,
        host_name: "Canal Grande",
        latitude: 45.43356,
        longitude: 12.3266,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3266, 45.43356]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34778578,
        name: "Rio Terese flat - great interior & canal view",
        host_id: 1666986,
        host_name: "Antonella",
        latitude: 45.43234,
        longitude: 12.31707,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31707, 45.43234]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34796437,
        name: "The Jewel of Venice Ca' Ragionati",
        host_id: 669047,
        host_name: "Viewsonvenice",
        latitude: 45.43261,
        longitude: 12.33618,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33618, 45.43261]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34796663,
        name: "Laguna View: 10 min from S. Marco and free wi-fi",
        host_id: 133690220,
        host_name: "Silvia-Carlo",
        latitude: 45.43795,
        longitude: 12.35106,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35106, 45.43795]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34798022,
        name: "FLOWERY COURT CLOSE TO RIALTO BRIDGE",
        host_id: 255381872,
        host_name: "I-Home",
        latitude: 45.44031,
        longitude: 12.33933,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33933, 45.44031]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34799281,
        name: "Suite Dream on the Water",
        host_id: 9609304,
        host_name: "Luca",
        latitude: 45.43606,
        longitude: 12.34844,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34844, 45.43606]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34800312,
        name: "Apartment Falier Bis (600m from Rialto's Bridge)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.439,
        longitude: 12.32914,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32914, 45.439]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34805539,
        name: "Charming canal view!",
        host_id: 6019189,
        host_name: "Federico",
        latitude: 45.43901,
        longitude: 12.32218,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32218, 45.43901]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34806371,
        name: "Pavarotti House - Room 8",
        host_id: 187118579,
        host_name: "Ke",
        latitude: 45.44479,
        longitude: 12.33047,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33047, 45.44479]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34806896,
        name: "Romantic gold room in San Marco Area",
        host_id: 191226100,
        host_name: "Milo",
        latitude: 45.43624,
        longitude: 12.34112,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34112, 45.43624]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34807182,
        name: "Romantic gold room centre Venice",
        host_id: 13500918,
        host_name: "Mark",
        latitude: 45.43616,
        longitude: 12.34183,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34183, 45.43616]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34808908,
        name: "APPARTAMENTO NEL CUORE DI VENEZIA",
        host_id: 262432123,
        host_name: "Eva",
        latitude: 45.4402,
        longitude: 12.32512,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32512, 45.4402]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34824024,
        name: "San Giacomo - Giardino",
        host_id: 212239396,
        host_name: "Nunzio",
        latitude: 45.44076,
        longitude: 12.32629,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32629, 45.44076]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34824028,
        name: "Rialto Terrazza",
        host_id: 212239396,
        host_name: "Nunzio",
        latitude: 45.43817,
        longitude: 12.33171,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33171, 45.43817]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34824030,
        name: "San Giacomo - Terrazza",
        host_id: 212239396,
        host_name: "Nunzio",
        latitude: 45.44038,
        longitude: 12.32549,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32549, 45.44038]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34824032,
        name: "San Giacomo - Giardino Due",
        host_id: 212239396,
        host_name: "Nunzio",
        latitude: 45.44172,
        longitude: 12.32643,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32643, 45.44172]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34824033,
        name: "Rialto Due",
        host_id: 212239396,
        host_name: "Nunzio",
        latitude: 45.43758,
        longitude: 12.33084,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33084, 45.43758]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34826106,
        name: "The Hobbit House",
        host_id: 262551790,
        host_name: "Paolo",
        latitude: 45.43492,
        longitude: 12.35015,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35015, 45.43492]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34827691,
        name: "Casa Del Campanile. A 2 passi da Piazza San Marco",
        host_id: 262562074,
        host_name: "Nicola",
        latitude: 45.43329,
        longitude: 12.33532,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33532, 45.43329]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34828586,
        name: "Casa dei Frari. In campo San Stin.........",
        host_id: 262562074,
        host_name: "Nicola",
        latitude: 45.43736,
        longitude: 12.32788,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32788, 45.43736]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34832555,
        name: "Appartamento Carolina ai Giardini della Biennale",
        host_id: 48081958,
        host_name: "Veronica",
        latitude: 45.432399928143219,
        longitude: 12.356621473042619,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35662, 45.4324]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34854270,
        name: "Arabesque Cozy Room for 2 people, private toilet",
        host_id: 174333358,
        host_name: "Antonella",
        latitude: 45.43969,
        longitude: 12.33186,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33186, 45.43969]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34885033,
        name: "*NEW* Canal view, bright apartment in Cannaregio",
        host_id: 847706,
        host_name: "Selma",
        latitude: 45.44497,
        longitude: 12.32918,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32918, 45.44497]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34885131,
        name: "Residence Falier (600m from Rialto's Bridge)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.43798,
        longitude: 12.32818,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32818, 45.43798]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34886179,
        name: "Roof La Torre",
        host_id: 262956094,
        host_name: "Andre",
        latitude: 45.43469,
        longitude: 12.33518,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33518, 45.43469]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34894489,
        name: "San Maurizio",
        host_id: 98131866,
        host_name: "Michele",
        latitude: 45.43366,
        longitude: 12.33171,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33171, 45.43366]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34898425,
        name: "Cà Rosa Apartment Canal View",
        host_id: 263033826,
        host_name: "Federico",
        latitude: 45.42794,
        longitude: 12.31322,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31322, 45.42794]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34902410,
        name: "Noble House Grand Canal",
        host_id: 231841228,
        host_name: "Giuliano Kim",
        latitude: 45.44318,
        longitude: 12.32547,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32547, 45.44318]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34918557,
        name: "DADA STUDIO 1st",
        host_id: 237182372,
        host_name: "Veronica",
        latitude: 45.44147,
        longitude: 12.33613,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33613, 45.44147]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34918902,
        name: "SFF2 PENTHOUSE WITH CANAL VIEW",
        host_id: 263158598,
        host_name: "Carlo",
        latitude: 45.44195,
        longitude: 12.33339,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33339, 45.44195]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34922875,
        name: "Ca' Piery, Venezia autentica",
        host_id: 263176089,
        host_name: "Federica",
        latitude: 45.44334,
        longitude: 12.32145,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32145, 45.44334]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34925628,
        name: "Residence Rialto (200m from Rialto's Bridge)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.43886,
        longitude: 12.33384,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33384, 45.43886]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34931306,
        name: "DolceVita Apartments N. 444 Biennale Canal View",
        host_id: 8176475,
        host_name: "Eugenia",
        latitude: 45.43203,
        longitude: 12.35642,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35642, 45.43203]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34932005,
        name: "Residenza Santacroce, nel cuore di Venezia",
        host_id: 173628967,
        host_name: "Anna",
        latitude: 45.44009,
        longitude: 12.32715,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32715, 45.44009]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34934745,
        name: "Casetta della Fontana",
        host_id: 34360885,
        host_name: "Samuel",
        latitude: 45.42926,
        longitude: 12.33168,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33168, 45.42926]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34940673,
        name: "Ca’ Bellato Canal view",
        host_id: 38623763,
        host_name: "Elisabetta",
        latitude: 45.43664,
        longitude: 12.33042,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33042, 45.43664]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34947945,
        name: "Luxury & Romance on the Grand Canal",
        host_id: 238706298,
        host_name: "Veronica",
        latitude: 45.43467,
        longitude: 12.33014,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33014, 45.43467]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34953659,
        name: "Elegant and comfortable 5 pax in Cannaregio",
        host_id: 5261385,
        host_name: "Susi",
        latitude: 45.44642,
        longitude: 12.33169,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33169, 45.44642]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34958447,
        name: "Corte Regina Loft - Living Rialto!",
        host_id: 263403245,
        host_name: "Ivano",
        latitude: 45.44047,
        longitude: 12.33093,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33093, 45.44047]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34963751,
        name: "Palazzetto del Pozzo",
        host_id: 34360885,
        host_name: "Samuel",
        latitude: 45.43097,
        longitude: 12.32994,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32994, 45.43097]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34964568,
        name: "All the magic of Venice in San Provolo 4718..",
        host_id: 263178922,
        host_name: "Benedetta",
        latitude: 45.43429,
        longitude: 12.34299,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34299, 45.43429]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34976771,
        name: "DENIS FLAT near Arsenale entrance art/biennale",
        host_id: 191226100,
        host_name: "Milo",
        latitude: 45.43638,
        longitude: 12.34814,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34814, 45.43638]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34985536,
        name: '"Cà de le ole"   Cordialità e Disponibilità',
        host_id: 219316297,
        host_name: "Massimo",
        latitude: 45.4329,
        longitude: 12.35741,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35741, 45.4329]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34992635,
        name: "MH805 APARTMENT",
        host_id: 251170471,
        host_name: "Manola",
        latitude: 45.44453,
        longitude: 12.31835,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31835, 45.44453]] },
    },
    {
      type: "Feature",
      properties: {
        id: 34993950,
        name: "Accademia Charm Apartment  n. 5",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.42932,
        longitude: 12.33309,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33309, 45.42932]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35004752,
        name: "Ca' San Rocco",
        host_id: 25022476,
        host_name: "Antonio",
        latitude: 45.43685,
        longitude: 12.32615,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32615, 45.43685]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35027799,
        name: "Casa Garibaldi",
        host_id: 66316802,
        host_name: "Margherita",
        latitude: 45.43171,
        longitude: 12.35576,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35576, 45.43171]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35028067,
        name:
          "Cà XXII Marzo Boutique - codice ident. M (Phone number hidden by Airbnb)",
        host_id: 208021374,
        host_name: "Giulia",
        latitude: 45.43199,
        longitude: 12.33552,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33552, 45.43199]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35081980,
        name: "Venezia Ormesini *****",
        host_id: 21885006,
        host_name: "Lisa",
        latitude: 45.44472,
        longitude: 12.32719,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32719, 45.44472]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35089220,
        name: "Mario apartment 458",
        host_id: 10072655,
        host_name: "Mario Apartment",
        latitude: 45.43377,
        longitude: 12.35517,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35517, 45.43377]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35104872,
        name: "Venetian 3Bdr Typical Apartment Campo S. Ternita",
        host_id: 139627704,
        host_name: "Giusy & Fabrizio",
        latitude: 45.43833,
        longitude: 12.34796,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34796, 45.43833]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35108525,
        name: "Ca Derai 2",
        host_id: 21973212,
        host_name: "Ca Derai",
        latitude: 45.44395,
        longitude: 12.32908,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32908, 45.44395]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35114056,
        name: "At the foot of  Biennale+view lagune+comfort+A/C",
        host_id: 264484427,
        host_name: "Stefano",
        latitude: 45.43048,
        longitude: 12.35488,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35488, 45.43048]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35118356,
        name: "Apartment in Venice",
        host_id: 247989727,
        host_name: "Ahteek",
        latitude: 45.44515,
        longitude: 12.32821,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32821, 45.44515]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35140653,
        name: "Hotel Palazzo Martinelli - Deluxe Suite",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.43559,
        longitude: 12.31719,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31719, 45.43559]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35140656,
        name: "Hotel Palazzo Martinelli  - Junior Suite",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.43571,
        longitude: 12.31723,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31723, 45.43571]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35142159,
        name: "Ca' die Tetti, bright apartment Cannaregio",
        host_id: 294951,
        host_name: "VeniceVillas Di Enzo",
        latitude: 45.44312,
        longitude: 12.33467,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33467, 45.44312]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35143492,
        name: "Ca' Silva near Biennale",
        host_id: 294951,
        host_name: "VeniceVillas Di Enzo",
        latitude: 45.43568,
        longitude: 12.3488,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3488, 45.43568]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35144152,
        name: "Hotel Palazzo Martinelli - Canal View Quadruple",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.43685,
        longitude: 12.31624,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31624, 45.43685]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35145021,
        name: "Grifoni Boutique Hotel - Triple Deluxe",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.4379,
        longitude: 12.32686,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32686, 45.4379]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35145429,
        name: "Dimora Cà Rezzonico",
        host_id: 1028258,
        host_name: "Sandra",
        latitude: 45.43427,
        longitude: 12.32552,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32552, 45.43427]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35146333,
        name: "Grand Canal Suites - Deluxe Canal View",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.43904,
        longitude: 12.3216,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3216, 45.43904]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35146406,
        name: "Hotel Palazzo Martinelli - Deluxe Junior Suite",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.43689,
        longitude: 12.31621,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31621, 45.43689]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35146479,
        name: "Grifoni Boutique Hotel - Deluxe Quadruple",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.43758,
        longitude: 12.32699,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32699, 45.43758]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35147184,
        name: "Palazzo Martinelli - Quadruple Deluxe",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.43699,
        longitude: 12.3172,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3172, 45.43699]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35147278,
        name: 'Apt. "Carlo Scarpa" (Residence Artisti)',
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.44023,
        longitude: 12.32663,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32663, 45.44023]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35147410,
        name: "Grifoni Boutique Hotel - Junior Suite Deluxe",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.43699,
        longitude: 12.32728,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32728, 45.43699]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35148009,
        name: "Hotel Palazzo Martinelli  - Triple Deluxe",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.43719,
        longitude: 12.31599,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31599, 45.43719]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35148025,
        name: "Grand Canal Suites - Junior Suite Canal View",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.43957,
        longitude: 12.32212,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32212, 45.43957]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35148363,
        name: "Grifoni Boutique Hotel - Junior Suite Deluxe",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.43652,
        longitude: 12.32857,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32857, 45.43652]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35148471,
        name: "Hotel Palazzo Martinelli - Tripla Deluxe",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.43533,
        longitude: 12.31715,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31715, 45.43533]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35148527,
        name: "Grand Canal Suites - Suite Canal View",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.43902,
        longitude: 12.32082,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32082, 45.43902]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35149041,
        name: "Grifoni Boutique Hotel - Quadruple City View",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.43623,
        longitude: 12.32882,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32882, 45.43623]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35149047,
        name: "Hotel Palazzo Martinelli  - Canal View Deluxe",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.43705,
        longitude: 12.31639,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31639, 45.43705]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35149546,
        name: "Hotel Palazzo Martinelli - Deluxe Suite",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.43733,
        longitude: 12.31755,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31755, 45.43733]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35149694,
        name: "Grifoni Boutique Hotel - Junior Suite City View",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.43674,
        longitude: 12.32764,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32764, 45.43674]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35149814,
        name: "Hotel Palazzo Martinelli - Triple Deluxe",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.43699,
        longitude: 12.31702,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31702, 45.43699]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35150040,
        name: "Grand Canal Suites - Junior Suite",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.43842,
        longitude: 12.32053,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32053, 45.43842]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35150175,
        name: "Hotel Palazzo Martinelli  - Canal View Deluxe",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.43718,
        longitude: 12.31621,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31621, 45.43718]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35150591,
        name: "Grifoni Boutique Hotel  - Triple Deluxe",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.43824,
        longitude: 12.32902,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32902, 45.43824]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35153719,
        name: "Brand new apartment in the heart of Venice",
        host_id: 264745267,
        host_name: "Harpo",
        latitude: 45.43773,
        longitude: 12.32522,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32522, 45.43773]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35154637,
        name: "Ca' Sottana, due passi da Piazzale Roma",
        host_id: 294951,
        host_name: "VeniceVillas Di Enzo",
        latitude: 45.43603,
        longitude: 12.31986,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31986, 45.43603]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35155676,
        name: "Ca' Soresin Biennale Apartment",
        host_id: 294951,
        host_name: "VeniceVillas Di Enzo",
        latitude: 45.42996,
        longitude: 12.35588,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35588, 45.42996]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35157959,
        name: "San Marco Flat #222",
        host_id: 226026079,
        host_name: "Salvatore",
        latitude: 45.43378,
        longitude: 12.33388,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33388, 45.43378]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35174621,
        name: "Grifoni Boutique Hotel - Deluxe Suite with terrace",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.43816,
        longitude: 12.32832,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32832, 45.43816]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35174672,
        name: "APPARTAMENTO COCCOLA   M (Phone number hidden by Airbnb)",
        host_id: 259576037,
        host_name: "Tito",
        latitude: 45.43492,
        longitude: 12.33019,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33019, 45.43492]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35174796,
        name: "Grand Canal Suites - Double Deluxe",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.43835,
        longitude: 12.32031,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32031, 45.43835]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35175291,
        name: "Grifoni Boutique Hotel - Quadruple with terrace",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.43622,
        longitude: 12.32844,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32844, 45.43622]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35175806,
        name: "Grand Canal Suites - Suite Canal View",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.4387,
        longitude: 12.3203,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3203, 45.4387]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35176923,
        name: "Accogliente appartamento a San Marco",
        host_id: 50499932,
        host_name: "Milo",
        latitude: 45.43414,
        longitude: 12.33198,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33198, 45.43414]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35178289,
        name: "Agnusdio Apartment - Patrician Residence",
        host_id: 264914005,
        host_name: "Sabina",
        latitude: 45.4413,
        longitude: 12.33123,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33123, 45.4413]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35181831,
        name: "Private room with private bathroom and terrace",
        host_id: 48036718,
        host_name: "Federico",
        latitude: 45.4318,
        longitude: 12.31768,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31768, 45.4318]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35202031,
        name: "Holiday apartment with 2 bedrooms on 75m² in Venezia (VE)",
        host_id: 159965476,
        host_name: "Francesco - NOVASOL",
        latitude: 45.43784,
        longitude: 12.34797,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34797, 45.43784]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35202065,
        name: "Holiday apartment with 2 bedrooms on 54m² in Venezia",
        host_id: 159965476,
        host_name: "Francesco - NOVASOL",
        latitude: 45.43644,
        longitude: 12.32351,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32351, 45.43644]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35202080,
        name: "Holiday apartment with 2 bedrooms on 70m² in Venezia (VE)",
        host_id: 159965476,
        host_name: "Francesco - NOVASOL",
        latitude: 45.43805,
        longitude: 12.33313,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33313, 45.43805]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35202149,
        name: "Holiday apartment with 2 bedrooms on 75m² in Venezia (VE)",
        host_id: 159965476,
        host_name: "Francesco - NOVASOL",
        latitude: 45.43811,
        longitude: 12.34808,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34808, 45.43811]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35210979,
        name: "Cà della Grana Apartment",
        host_id: 242868135,
        host_name: "Francesca",
        latitude: 45.4365,
        longitude: 12.34789,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34789, 45.4365]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35244903,
        name: "La Dimora di San Maurizio 1",
        host_id: 669047,
        host_name: "Viewsonvenice",
        latitude: 45.43353,
        longitude: 12.3318,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3318, 45.43353]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35244906,
        name: "La Dimora di San Maurizio 3",
        host_id: 669047,
        host_name: "Viewsonvenice",
        latitude: 45.43175,
        longitude: 12.33267,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33267, 45.43175]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35244908,
        name: "La Dimora di San Maurizio 2",
        host_id: 669047,
        host_name: "Viewsonvenice",
        latitude: 45.43154,
        longitude: 12.33109,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33109, 45.43154]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35244911,
        name: "La Dimora di San Maurizio 4",
        host_id: 669047,
        host_name: "Viewsonvenice",
        latitude: 45.4317,
        longitude: 12.33232,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33232, 45.4317]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35251575,
        name: "J A Elite Studio - 11th",
        host_id: 92620149,
        host_name: "Samy",
        latitude: 45.43352,
        longitude: 12.32927,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32927, 45.43352]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35256533,
        name: '"Tosca" superior room with canal view',
        host_id: 159360992,
        host_name: "Principe",
        latitude: 45.43601,
        longitude: 12.32428,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32428, 45.43601]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35258311,
        name: '"Boheme Doubleroom" private panoramic  balcony',
        host_id: 159360992,
        host_name: "Principe",
        latitude: 45.43696,
        longitude: 12.32377,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32377, 45.43696]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35258617,
        name: '"AIDA" amazing PANORAMIC room ontheVenetian roofs!',
        host_id: 159360992,
        host_name: "Principe",
        latitude: 45.43707,
        longitude: 12.32321,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32321, 45.43707]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35259357,
        name: '"PRINCIPE PANORAMIC SUITE"private rooftopBalconies',
        host_id: 159360992,
        host_name: "Principe",
        latitude: 45.43594,
        longitude: 12.32408,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32408, 45.43594]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35298700,
        name: "Luxury Home in Center of Venice",
        host_id: 23563693,
        host_name: "Marco",
        latitude: 45.43908,
        longitude: 12.32607,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32607, 45.43908]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35316083,
        name: "J A Elite Studio - 7th",
        host_id: 92620149,
        host_name: "Samy",
        latitude: 45.43974,
        longitude: 12.31527,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31527, 45.43974]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35316328,
        name: "J A Elite Studio - 5th",
        host_id: 92620149,
        host_name: "Samy",
        latitude: 45.44135,
        longitude: 12.31464,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31464, 45.44135]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35359944,
        name: "Ca' Pesaro apt with wifi, A/C in an ancient palace",
        host_id: 266213959,
        host_name: "Gina",
        latitude: 45.43994,
        longitude: 12.33033,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33033, 45.43994]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35362999,
        name: "Casa Graziosa",
        host_id: 3972291,
        host_name: "Caroline E Marco",
        latitude: 45.43437,
        longitude: 12.33119,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33119, 45.43437]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35392471,
        name: "San Marco terrace",
        host_id: 205196965,
        host_name: "Yourflat",
        latitude: 45.43456,
        longitude: 12.33896,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33896, 45.43456]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35408588,
        name: "Rialto bridge Venice House",
        host_id: 266503667,
        host_name: "Luigina",
        latitude: 45.43664,
        longitude: 12.33595,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33595, 45.43664]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35415266,
        name: "BONA DEA IN VENICE CENTER - ST. MARK'S SQUARE",
        host_id: 97355921,
        host_name: "Adriano",
        latitude: 45.43464,
        longitude: 12.33733,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33733, 45.43464]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35416253,
        name: "CA' BATTAGLIA",
        host_id: 22940319,
        host_name: "Albatroservices",
        latitude: 45.43918,
        longitude: 12.32985,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32985, 45.43918]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35420232,
        name: "Sunny room in Rialto Market , best short stay !",
        host_id: 159746853,
        host_name: "Giulia",
        latitude: 45.4392,
        longitude: 12.33359,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33359, 45.4392]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35421151,
        name: "Blu Marine Room, in  Rialto Market,nice short stay",
        host_id: 159746853,
        host_name: "Giulia",
        latitude: 45.43898,
        longitude: 12.33394,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33394, 45.43898]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35435071,
        name: "CASA ELENA splendido, nel cuore di Venezia",
        host_id: 107972652,
        host_name: "Pierluigi",
        latitude: 45.44499,
        longitude: 12.32979,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32979, 45.44499]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35436425,
        name: "Apt. Longhi (Residence Artisti)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.44023,
        longitude: 12.3265,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3265, 45.44023]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35437221,
        name: "DolceVita Apartments N. 445 Biennale",
        host_id: 8176475,
        host_name: "Eugenia",
        latitude: 45.43466,
        longitude: 12.35967,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35967, 45.43466]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35439243,
        name: "Apt. De' Barbari (Residence Artisti)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.43998,
        longitude: 12.32509,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32509, 45.43998]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35439882,
        name: "Residence dei 3 Artisti (18 people)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.44025,
        longitude: 12.32638,
        beds: 7,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32638, 45.44025]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35447947,
        name: "Casa con cortile nel cuore di Dorsoduro",
        host_id: 5526397,
        host_name: "Alessandra",
        latitude: 45.43345,
        longitude: 12.32544,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32544, 45.43345]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35451811,
        name: "La Gondola-beautiful canal view",
        host_id: 22940319,
        host_name: "Albatroservices",
        latitude: 45.43933,
        longitude: 12.3452,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3452, 45.43933]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35476486,
        name: "Ca Migio view on the S.Simeon dome",
        host_id: 1275479,
        host_name: "Giorgia&Michele",
        latitude: 45.43924,
        longitude: 12.32443,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32443, 45.43924]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35479161,
        name: "CORTE SCONTA MINI-LOFT",
        host_id: 63949349,
        host_name: "Enrico",
        latitude: 45.43897,
        longitude: 12.3437,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3437, 45.43897]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35480863,
        name: "Apt. Morandis (Residence Artisti)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.44023,
        longitude: 12.32702,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32702, 45.44023]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35485810,
        name: "GRIMANI 2",
        host_id: 32887555,
        host_name: "Residence Corte Grimani",
        latitude: 45.43485,
        longitude: 12.33468,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33468, 45.43485]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35505069,
        name: "ROSA SALVA HOTEL, DOUBLE COMFORT",
        host_id: 268351967,
        host_name: "Rosa Salva Hotel",
        latitude: 45.4356,
        longitude: 12.3388,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3388, 45.4356]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35505572,
        name: "HOTEL TIZIANO, DOUBLE ROOM",
        host_id: 268364351,
        host_name: "Hotel Tiziano",
        latitude: 45.43363,
        longitude: 12.3166,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3166, 45.43363]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35508219,
        name: "Ca' dea Speransa",
        host_id: 22940319,
        host_name: "Albatroservices",
        latitude: 45.43924,
        longitude: 12.33209,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33209, 45.43924]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35510333,
        name: "Grimani appartamento classic 2",
        host_id: 32887555,
        host_name: "Residence Corte Grimani",
        latitude: 45.43412,
        longitude: 12.33455,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33455, 45.43412]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35515435,
        name: "Beautiful home in upscale Giudecca neighborhood",
        host_id: 44314099,
        host_name: "Anna Laura",
        latitude: 45.42398,
        longitude: 12.32702,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32702, 45.42398]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35516555,
        name: "RED canopy room, in Rialto market , 24/h access",
        host_id: 159746853,
        host_name: "Giulia",
        latitude: 45.4391,
        longitude: 12.3328,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3328, 45.4391]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35543804,
        name: "Arlecchino house",
        host_id: 75690281,
        host_name: "Anna",
        latitude: 45.44328,
        longitude: 12.32409,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32409, 45.44328]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35552141,
        name: "CA' MAREA IN VENICE CENTER - ST. MARK'S SQUARE",
        host_id: 97355921,
        host_name: "Adriano",
        latitude: 45.43267,
        longitude: 12.33644,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33644, 45.43267]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35590953,
        name: "Deluxe Doble Room",
        host_id: 264480002,
        host_name: "Bellevue & Canaletto Suites",
        latitude: 45.43529,
        longitude: 12.33864,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33864, 45.43529]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35591378,
        name: "Superior Double overlooking San Marco Square",
        host_id: 264480002,
        host_name: "Bellevue & Canaletto Suites",
        latitude: 45.43462,
        longitude: 12.34007,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34007, 45.43462]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35592767,
        name: "Arte & Relax",
        host_id: 116360027,
        host_name: "Viola",
        latitude: 45.43981,
        longitude: 12.33857,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33857, 45.43981]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35599693,
        name: "Ca' Vivaldi. Vicino a San Marco e alla Biennale.",
        host_id: 105704488,
        host_name: "Sara",
        latitude: 45.43447,
        longitude: 12.3461,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3461, 45.43447]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35611685,
        name: "HOTEL TIZIANO, Tripla",
        host_id: 268364351,
        host_name: "Hotel Tiziano",
        latitude: 45.4332,
        longitude: 12.32568,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32568, 45.4332]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35611767,
        name: "HOTEL TIZIANO, Family",
        host_id: 268364351,
        host_name: "Hotel Tiziano",
        latitude: 45.43226,
        longitude: 12.32494,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32494, 45.43226]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35611837,
        name: "HOTEL TIZIANO, Doppia Annex",
        host_id: 268364351,
        host_name: "Hotel Tiziano",
        latitude: 45.4334,
        longitude: 12.32354,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32354, 45.4334]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35614006,
        name: "Incantevole Suite, Hotel Giudecca, Venezia",
        host_id: 52243570,
        host_name: "Amelia",
        latitude: 45.42451,
        longitude: 12.32659,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32659, 45.42451]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35614986,
        name: "Margy's Studio",
        host_id: 98131866,
        host_name: "Michele",
        latitude: 45.43417,
        longitude: 12.31931,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31931, 45.43417]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35626321,
        name: "Elegant private double room (Venetian style)",
        host_id: 267537367,
        host_name: "Hotel",
        latitude: 45.43617,
        longitude: 12.33751,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33751, 45.43617]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35636059,
        name: "Romio's",
        host_id: 174418896,
        host_name: "Mimax",
        latitude: 45.442,
        longitude: 12.33505,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33505, 45.442]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35637361,
        name: "Junior Suite",
        host_id: 160412579,
        host_name: "Emanuele",
        latitude: 45.43445,
        longitude: 12.33513,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33513, 45.43445]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35637887,
        name: "Camera Quadrupla",
        host_id: 160412579,
        host_name: "Emanuele",
        latitude: 45.43523,
        longitude: 12.33493,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33493, 45.43523]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35638844,
        name: "Junior suite with private external bathroom",
        host_id: 160412579,
        host_name: "Emanuele",
        latitude: 45.43444,
        longitude: 12.33519,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33519, 45.43444]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35643358,
        name: "Gallery Art",
        host_id: 245336217,
        host_name: "Boutique",
        latitude: 45.44125,
        longitude: 12.34187,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34187, 45.44125]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35647378,
        name: "Costa Real Venice. A Venetian place in the centre",
        host_id: 34212651,
        host_name: "Costantino",
        latitude: 45.426,
        longitude: 12.33749,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33749, 45.426]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35666597,
        name: "Residenza Laguna",
        host_id: 5618111,
        host_name: "EasySuite",
        latitude: 45.44414,
        longitude: 12.3384,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3384, 45.44414]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35679500,
        name: "Ca'Moro - your authentic home on the canal",
        host_id: 7789712,
        host_name: "Regina",
        latitude: 45.44686,
        longitude: 12.32284,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32284, 45.44686]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35696458,
        name: 'GUESTHOUSE 40.17 SANMARCO "ROOM TRIPLE BAUTA BLU"',
        host_id: 268516722,
        host_name: "40.17sanmarco",
        latitude: 45.43612,
        longitude: 12.33432,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33432, 45.43612]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35700654,
        name: "Venice Martina's Home Basic Room Shared Bathroom",
        host_id: 13027859,
        host_name: "Diego",
        latitude: 45.43824,
        longitude: 12.32563,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32563, 45.43824]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35702179,
        name: "✧Extravagant Design✧ In the Coolest Place to Be!",
        host_id: 266968708,
        host_name: "Silvia",
        latitude: 45.44464,
        longitude: 12.33185,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33185, 45.44464]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35704763,
        name: "✧Fine Italian Taste with Secret Garden✧",
        host_id: 266970361,
        host_name: "Elena",
        latitude: 45.43919,
        longitude: 12.33004,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33004, 45.43919]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35710639,
        name: "2 minutes to city center Rialto bridge No1 离市中心2分钟",
        host_id: 64548275,
        host_name: "Ellen",
        latitude: 45.43749,
        longitude: 12.33354,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33354, 45.43749]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35711067,
        name: "2 minutes to city center Rialto bridge No3 离市中心2分钟",
        host_id: 64548275,
        host_name: "Ellen",
        latitude: 45.4382,
        longitude: 12.33345,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33345, 45.4382]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35727606,
        name: "Canaletto Apartment with canal view",
        host_id: 268742426,
        host_name: "Davide",
        latitude: 45.44568,
        longitude: 12.33182,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33182, 45.44568]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35743044,
        name: "NoStress Holiday - Zen Private Ensuite Room A",
        host_id: 233209105,
        host_name: "Venice No Stress",
        latitude: 45.44196,
        longitude: 12.33881,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33881, 45.44196]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35751504,
        name: "Casa Stainer, camera con bagno privato",
        host_id: 240563683,
        host_name: "Mario",
        latitude: 45.43563,
        longitude: 12.3438,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3438, 45.43563]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35753661,
        name: "Double Suite  San Marco Square",
        host_id: 264480002,
        host_name: "Bellevue & Canaletto Suites",
        latitude: 45.43516,
        longitude: 12.34019,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34019, 45.43516]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35753767,
        name: "Double suite with terrace",
        host_id: 264480002,
        host_name: "Bellevue & Canaletto Suites",
        latitude: 45.43595,
        longitude: 12.33801,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33801, 45.43595]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35753888,
        name: "Family Suite San Marco Square",
        host_id: 264480002,
        host_name: "Bellevue & Canaletto Suites",
        latitude: 45.43431,
        longitude: 12.34016,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34016, 45.43431]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35756060,
        name: "ANGEL TERRACE M (Phone number hidden by Airbnb)",
        host_id: 15005402,
        host_name: "Veronica",
        latitude: 45.4349,
        longitude: 12.3319,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3319, 45.4349]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35763854,
        name: "Charming  cozy apart with wonderful venetian view",
        host_id: 16312632,
        host_name: "Barbara",
        latitude: 45.44586,
        longitude: 12.32249,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32249, 45.44586]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35786750,
        name: "Villetta del Figaretto (near the biennale)",
        host_id: 7791000,
        host_name: "Nicholas",
        latitude: 45.43342,
        longitude: 12.35572,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35572, 45.43342]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35787436,
        name:
          "Ca'Pellegrini Luxury Grand Canal (L.T.M (Phone number hidden by Airbnb)",
        host_id: 5618111,
        host_name: "EasySuite",
        latitude: 45.44044,
        longitude: 12.33718,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33718, 45.44044]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35787532,
        name: "Beautiful apt in Venezia & Wifi",
        host_id: 107247539,
        host_name: "Loic, Estelle & Co",
        latitude: 45.44704,
        longitude: 12.33059,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33059, 45.44704]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35788797,
        name: "Ca' Formosa, nice canal views close to San Marco",
        host_id: 12113015,
        host_name: "Mario",
        latitude: 45.43798,
        longitude: 12.33989,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33989, 45.43798]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35820369,
        name: "CORTE CAVALLO quiet typical apt in Cannaregio",
        host_id: 567508,
        host_name: "Nicola",
        latitude: 45.4475,
        longitude: 12.33059,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33059, 45.4475]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35828091,
        name: "Palazzo Cristo Master Apartment",
        host_id: 29778828,
        host_name: "Anna Paola",
        latitude: 45.4378,
        longitude: 12.34143,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34143, 45.4378]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35831259,
        name: "Maryloft With great view of Venice !well designed",
        host_id: 3809491,
        host_name: "Pierluigi",
        latitude: 45.44199,
        longitude: 12.33871,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33871, 45.44199]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35837463,
        name: "Large room in the heart of Venice",
        host_id: 6034449,
        host_name: "Luisa",
        latitude: 45.4343,
        longitude: 12.32451,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32451, 45.4343]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35863233,
        name: "Biennale/Sant'Elena; light, airy stylish apartment",
        host_id: 7690844,
        host_name: "Liz",
        latitude: 45.42733,
        longitude: 12.36099,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.36099, 45.42733]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35875177,
        name: "Elegant Triple Room in the center of Venice",
        host_id: 267537367,
        host_name: "Hotel",
        latitude: 45.43458,
        longitude: 12.33745,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33745, 45.43458]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35902529,
        name: "Twin room in mansarda - Artist's House B&B",
        host_id: 245561487,
        host_name: "Nicholas",
        latitude: 45.43576,
        longitude: 12.32348,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32348, 45.43576]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35904895,
        name: "Graziosa DOPPIA 2 letti singoli Bagno Condiviso",
        host_id: 269941046,
        host_name: "Hotel Allafava",
        latitude: 45.43696,
        longitude: 12.33728,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33728, 45.43696]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35922875,
        name: "Dorsoduro, Venezia",
        host_id: 12182373,
        host_name: "Luca",
        latitude: 45.43543,
        longitude: 12.32105,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32105, 45.43543]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35927494,
        name: "Residenza Sant’Alvise",
        host_id: 132205890,
        host_name: "Edoardo Maria",
        latitude: 45.4477,
        longitude: 12.32802,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32802, 45.4477]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35932352,
        name: "Santa Fosca Canal View R&R",
        host_id: 173200514,
        host_name: "Rent&Relax",
        latitude: 45.44202,
        longitude: 12.33177,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33177, 45.44202]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35955129,
        name: "Appartamento Ca'Martina",
        host_id: 60488055,
        host_name: "Marco & Andrea",
        latitude: 45.42698,
        longitude: 12.36339,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.36339, 45.42698]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35982357,
        name: "Venetian Attic, Biennale, vicina a San Marco",
        host_id: 151801710,
        host_name: "Francesco",
        latitude: 45.43303,
        longitude: 12.35273,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35273, 45.43303]] },
    },
    {
      type: "Feature",
      properties: {
        id: 35984171,
        name: "Ca'Margherita",
        host_id: 60488055,
        host_name: "Marco & Andrea",
        latitude: 45.4318,
        longitude: 12.32793,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32793, 45.4318]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36023070,
        name: "Laguna View lovely modern flat with altana!",
        host_id: 1438903,
        host_name: "Barbara",
        latitude: 45.44195,
        longitude: 12.33955,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33955, 45.44195]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36060683,
        name: "Gdhouse 806 - modern flat few steps from Biennale",
        host_id: 125945338,
        host_name: "Graziana E Damiano",
        latitude: 45.42965,
        longitude: 12.35807,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35807, 45.42965]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36065811,
        name: "ROSA SALVA HOTEL, ELEGANT",
        host_id: 268351967,
        host_name: "Rosa Salva Hotel",
        latitude: 45.43541,
        longitude: 12.33966,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33966, 45.43541]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36066436,
        name: "ROSA SALVA HOTEL, Junior Suite",
        host_id: 268351967,
        host_name: "Rosa Salva Hotel",
        latitude: 45.43434,
        longitude: 12.33381,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33381, 45.43434]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36066515,
        name: "ROSA SALVA HOTEL, Economy",
        host_id: 268351967,
        host_name: "Rosa Salva Hotel",
        latitude: 45.43489,
        longitude: 12.33366,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33366, 45.43489]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36067100,
        name: "Ca' Puccetti (Venice Historical Centre)",
        host_id: 271321543,
        host_name: "Mauro",
        latitude: 45.44208,
        longitude: 12.34065,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34065, 45.44208]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36068063,
        name: "Venice Prince Apartments - Appartamento Foscari",
        host_id: 187809783,
        host_name: "Zillur",
        latitude: 45.43413,
        longitude: 12.34997,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34997, 45.43413]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36086566,
        name: "Confortevole SINGOLA nel Cuore di Venezia",
        host_id: 269941046,
        host_name: "Hotel Allafava",
        latitude: 45.43775,
        longitude: 12.33709,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33709, 45.43775]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36089560,
        name: "❤️Just listed! 180sqm & 5 windows on Canal View✔️",
        host_id: 9852012,
        host_name: "Paolo",
        latitude: 45.44453,
        longitude: 12.33026,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33026, 45.44453]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36092522,
        name: "Angolo Fiorito - Camera Matrimoniale",
        host_id: 269965740,
        host_name: "Giampaolo",
        latitude: 45.44051,
        longitude: 12.33919,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33919, 45.44051]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36095237,
        name: "Angolo Fiorito - Camera Matrimoniale Deluxe",
        host_id: 269965740,
        host_name: "Giampaolo",
        latitude: 45.44005,
        longitude: 12.34067,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34067, 45.44005]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36095428,
        name: "Piccola Camera matrimoniale",
        host_id: 269941046,
        host_name: "Hotel Allafava",
        latitude: 45.43698,
        longitude: 12.33661,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33661, 45.43698]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36095570,
        name: "Angolo Fiorito - Camera Matrimoniale Mansardata",
        host_id: 269965740,
        host_name: "Giampaolo",
        latitude: 45.44237,
        longitude: 12.3412,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3412, 45.44237]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36095688,
        name: "GRAZIOSA Doppia 2letti singoli Bagno PRIVATO",
        host_id: 269941046,
        host_name: "Hotel Allafava",
        latitude: 45.43717,
        longitude: 12.33714,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33714, 45.43717]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36096243,
        name: "Ca' Riccio - Camera Matrimoniale/Letti Separati",
        host_id: 269965740,
        host_name: "Giampaolo",
        latitude: 45.441,
        longitude: 12.34074,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34074, 45.441]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36096562,
        name: "Ca' Riccio - Camera Tripla",
        host_id: 269965740,
        host_name: "Giampaolo",
        latitude: 45.44098,
        longitude: 12.33953,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33953, 45.44098]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36096590,
        name: "TRIPLA camera con Bagno",
        host_id: 269941046,
        host_name: "Hotel Allafava",
        latitude: 45.43714,
        longitude: 12.3368,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3368, 45.43714]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36096694,
        name: "Ca' Riccio - Suite",
        host_id: 269965740,
        host_name: "Giampaolo",
        latitude: 45.43943,
        longitude: 12.339,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.339, 45.43943]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36097388,
        name: "Appartamento Rachele",
        host_id: 269965740,
        host_name: "Giampaolo",
        latitude: 45.44016,
        longitude: 12.33968,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33968, 45.44016]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36098967,
        name: "Appartamento Elena",
        host_id: 269965740,
        host_name: "Giampaolo",
        latitude: 45.44099,
        longitude: 12.33886,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33886, 45.44099]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36122940,
        name: "Cà Guido",
        host_id: 271721794,
        host_name: "Carlo",
        latitude: 45.43321,
        longitude: 12.32159,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32159, 45.43321]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36131597,
        name: "Venetian Roof View",
        host_id: 271768617,
        host_name: "Fabio",
        latitude: 45.43251,
        longitude: 12.35036,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35036, 45.43251]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36131761,
        name: "SUPERIOR matrimoniale vista canale",
        host_id: 269941046,
        host_name: "Hotel Allafava",
        latitude: 45.43784,
        longitude: 12.33718,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33718, 45.43784]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36132013,
        name: "Family room Qudrupla  con bagno privato",
        host_id: 269941046,
        host_name: "Hotel Allafava",
        latitude: 45.43779,
        longitude: 12.33728,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33728, 45.43779]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36146205,
        name: "The Little House in Venice near the Rialto Bridge",
        host_id: 271766093,
        host_name: "Francesco",
        latitude: 45.43723,
        longitude: 12.32781,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32781, 45.43723]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36156365,
        name: "Remer",
        host_id: 98131866,
        host_name: "Michele",
        latitude: 45.43996,
        longitude: 12.33586,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33586, 45.43996]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36157612,
        name: "Le Moschette 6651 Apartment",
        host_id: 242868135,
        host_name: "Francesca",
        latitude: 45.43964,
        longitude: 12.34408,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34408, 45.43964]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36158599,
        name: "Santa Giustina 2810 Apartment",
        host_id: 242868135,
        host_name: "Francesca",
        latitude: 45.4401,
        longitude: 12.31627,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31627, 45.4401]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36159531,
        name: "Casa del Mandolino",
        host_id: 242868135,
        host_name: "Francesca",
        latitude: 45.43498,
        longitude: 12.31832,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31832, 45.43498]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36160736,
        name: "La Celestia Suite AC/Wi-Fi",
        host_id: 271619143,
        host_name: "Marina",
        latitude: 45.43806,
        longitude: 12.34865,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34865, 45.43806]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36170102,
        name: "Tower Suite San Stae",
        host_id: 143456157,
        host_name: "Elena",
        latitude: 45.43991,
        longitude: 12.32763,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32763, 45.43991]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36193020,
        name: "Fully furnished apartment with two terraces",
        host_id: 48587419,
        host_name: "Stefano",
        latitude: 45.4341,
        longitude: 12.33939,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33939, 45.4341]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36199632,
        name: "Venice Home Holidays",
        host_id: 272249078,
        host_name: "Gemini S.A.S.",
        latitude: 45.43253,
        longitude: 12.35308,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35308, 45.43253]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36202300,
        name: "Luxurious entirely renovated 2-bedroom apartment",
        host_id: 272270451,
        host_name: "Matteo Filippo",
        latitude: 45.43784,
        longitude: 12.32359,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32359, 45.43784]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36214889,
        name: "Glicine Suite - Romantic and refined apartment",
        host_id: 129288696,
        host_name: "Chiara",
        latitude: 45.44021,
        longitude: 12.3404,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3404, 45.44021]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36219112,
        name: "Spacious Room Rialto Bridge (Venice City Center)",
        host_id: 103977102,
        host_name: "Giò E And",
        latitude: 45.43848,
        longitude: 12.33447,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33447, 45.43848]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36220046,
        name: "100 STEPS FROM RIALTO BRIDGE!!!!",
        host_id: 41559211,
        host_name: "Venice",
        latitude: 45.44127,
        longitude: 12.33601,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33601, 45.44127]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36252019,
        name: "Room Rialto Bridge (Venice City Center)",
        host_id: 103977102,
        host_name: "Giò E And",
        latitude: 45.43812,
        longitude: 12.33481,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33481, 45.43812]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36255079,
        name: '"Vendramin Exclusive Apartment"',
        host_id: 77717973,
        host_name: "Marco",
        latitude: 45.44252,
        longitude: 12.33016,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33016, 45.44252]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36299056,
        name: "Apt. Canaletto (Residence Artisti)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.43966,
        longitude: 12.32417,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32417, 45.43966]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36300663,
        name: "The 500 Years Old Central Charming Courtyard",
        host_id: 272960237,
        host_name: "Anya & Salvatore",
        latitude: 45.43589,
        longitude: 12.3415,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3415, 45.43589]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36303170,
        name: "Orange Casanova",
        host_id: 19284314,
        host_name: "Esther",
        latitude: 45.42495,
        longitude: 12.32912,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32912, 45.42495]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36312754,
        name: "A Brilliant Chic Dwelling",
        host_id: 272960237,
        host_name: "Anya & Salvatore",
        latitude: 45.43598,
        longitude: 12.34279,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34279, 45.43598]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36328344,
        name: "Cozy room in venice",
        host_id: 17994582,
        host_name: "Pierluigi",
        latitude: 45.43362,
        longitude: 12.31754,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31754, 45.43362]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36329434,
        name: "PONTE DEI GRECI charming flat with small garden!",
        host_id: 1438903,
        host_name: "Barbara",
        latitude: 45.43555,
        longitude: 12.34308,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34308, 45.43555]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36333890,
        name: "Reginella Apartment",
        host_id: 13027859,
        host_name: "Diego",
        latitude: 45.44043,
        longitude: 12.33108,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33108, 45.44043]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36334306,
        name: "HOTEL TINTORETTO, TRIPLE ROOM",
        host_id: 97883767,
        host_name: "Gabriella",
        latitude: 45.4437,
        longitude: 12.33126,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33126, 45.4437]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36334329,
        name: "HOTEL TINTORETTO, STANDARD DOUBLE",
        host_id: 97883767,
        host_name: "Gabriella",
        latitude: 45.44305,
        longitude: 12.33263,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33263, 45.44305]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36334350,
        name: "HOTEL TINTORETTO, FRENCH ECONOMY ANNEX",
        host_id: 97883767,
        host_name: "Gabriella",
        latitude: 45.44354,
        longitude: 12.33306,
        beds: null,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33306, 45.44354]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36346923,
        name: "BELLEVUE - Stunning Canal View",
        host_id: 226993560,
        host_name: "Laura",
        latitude: 45.44681,
        longitude: 12.32117,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32117, 45.44681]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36371672,
        name: "Apt. Licata (Residence Artisti)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.4398,
        longitude: 12.32559,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32559, 45.4398]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36371874,
        name: "Incanto Veneziano, spazioso con ampia terrazza",
        host_id: 31731422,
        host_name: "Alessandra",
        latitude: 45.42911,
        longitude: 12.32948,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32948, 45.42911]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36372355,
        name: "Residence dei 2 Artisti (12 people)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.43966,
        longitude: 12.32527,
        beds: 8,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32527, 45.43966]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36374973,
        name: "Family in Rialto - full optional central town",
        host_id: 169722919,
        host_name: "Walter",
        latitude: 45.43963,
        longitude: 12.33478,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33478, 45.43963]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36375859,
        name: "Venezia Ormesini 独立双人房",
        host_id: 21885006,
        host_name: "Lisa",
        latitude: 45.44344,
        longitude: 12.3278,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3278, 45.44344]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36377866,
        name: "Ca'dell'Opera 1637  No.3 Room",
        host_id: 258426902,
        host_name: "Loukas",
        latitude: 45.44041,
        longitude: 12.33262,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33262, 45.44041]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36379184,
        name: "Typical Venetian apartment near San Marco",
        host_id: 273283215,
        host_name: "Host",
        latitude: 45.44088,
        longitude: 12.33556,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33556, 45.44088]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36382727,
        name: "Greci Canal View Apartment R&R",
        host_id: 173200514,
        host_name: "Rent&Relax",
        latitude: 45.43533,
        longitude: 12.34393,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34393, 45.43533]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36395726,
        name: "Comfortable flat near San Marco and Biennale.",
        host_id: 271696621,
        host_name: "Nicola",
        latitude: 45.43703,
        longitude: 12.34759,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34759, 45.43703]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36396209,
        name: "Cà Olivo e il suo giardino alla Giudecca",
        host_id: 273674272,
        host_name: "Ubaldo",
        latitude: 45.42405,
        longitude: 12.3281,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3281, 45.42405]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36399915,
        name: "Ca San Leonardo  M (Phone number hidden by Airbnb)",
        host_id: 273696891,
        host_name: "Matteo",
        latitude: 45.44483,
        longitude: 12.32985,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32985, 45.44483]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36419466,
        name: "Appartamento TreVi",
        host_id: 108507559,
        host_name: "Stefano",
        latitude: 45.4356,
        longitude: 12.34763,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34763, 45.4356]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36421647,
        name: "Cà San Stae",
        host_id: 273779421,
        host_name: "Sabina",
        latitude: 45.44154,
        longitude: 12.33038,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33038, 45.44154]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36437652,
        name: "Nordic Cottage a Venezia",
        host_id: 3455373,
        host_name: "Luigi",
        latitude: 45.4332,
        longitude: 12.35744,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35744, 45.4332]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36450432,
        name: "Standard Double Bathroom PRIVATE",
        host_id: 269941046,
        host_name: "Hotel Allafava",
        latitude: 45.43715,
        longitude: 12.3373,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3373, 45.43715]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36458223,
        name: "Contemporary & Baroque House",
        host_id: 272960237,
        host_name: "Anya & Salvatore",
        latitude: 45.43663,
        longitude: 12.34579,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34579, 45.43663]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36465769,
        name: "Casa Minestra",
        host_id: 274172066,
        host_name: "Francesca",
        latitude: 45.43224,
        longitude: 12.31114,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31114, 45.43224]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36497612,
        name: "Romance in Rialto -downtown central full optional",
        host_id: 169722919,
        host_name: "Walter",
        latitude: 45.43789,
        longitude: 12.33471,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33471, 45.43789]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36505261,
        name: "San Giacomo dell'Orio Studio",
        host_id: 143456157,
        host_name: "Elena",
        latitude: 45.44047,
        longitude: 12.32751,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32751, 45.44047]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36505766,
        name: "Apartment Venice Guglie (2 bedrooms, 2 bathrooms)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.44319,
        longitude: 12.32625,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32625, 45.44319]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36515752,
        name: "Gorgeous near San Marco / Arsenale in Venice",
        host_id: 273283215,
        host_name: "Host",
        latitude: 45.43645,
        longitude: 12.34568,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34568, 45.43645]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36540222,
        name: '"CARMEN" tiny Panoramic room on the venetian roofs',
        host_id: 159360992,
        host_name: "Principe",
        latitude: 45.437,
        longitude: 12.32319,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32319, 45.437]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36545463,
        name: "Le Petit Loft",
        host_id: 274702364,
        host_name: "Petit Loft",
        latitude: 45.44035,
        longitude: 12.3315,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3315, 45.44035]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36546692,
        name: "San Basilio Flat",
        host_id: 2504885,
        host_name: "Simone",
        latitude: 45.43289,
        longitude: 12.3199,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3199, 45.43289]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36553463,
        name: "Corte Torretta San Marco",
        host_id: 46904188,
        host_name: "Mirco Optyflat",
        latitude: 45.4339,
        longitude: 12.33748,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33748, 45.4339]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36557684,
        name: "FANTASTICO APPARTAMENTO MIRACOLI",
        host_id: 26460616,
        host_name: "Gianfranco",
        latitude: 45.43908,
        longitude: 12.33813,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33813, 45.43908]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36563425,
        name: "Ca'dell'Opera  No.1 Room",
        host_id: 258426902,
        host_name: "Loukas",
        latitude: 45.43853,
        longitude: 12.33166,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33166, 45.43853]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36577589,
        name: "Attic Design Terrace (Venice Historical Centre)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.43014,
        longitude: 12.33052,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33052, 45.43014]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36586211,
        name: "Ca' dei Diamanti",
        host_id: 277342330,
        host_name: "Views On Venice",
        latitude: 45.43696,
        longitude: 12.32782,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32782, 45.43696]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36586801,
        name: "Gondolieri",
        host_id: 277342330,
        host_name: "Views On Venice",
        latitude: 45.43377,
        longitude: 12.32398,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32398, 45.43377]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36587106,
        name: "Ca' dell'opera",
        host_id: 277342330,
        host_name: "Views On Venice",
        latitude: 45.42994,
        longitude: 12.32919,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32919, 45.42994]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36587603,
        name: "Cerchieri Loredan",
        host_id: 277342330,
        host_name: "Views On Venice",
        latitude: 45.4338,
        longitude: 12.32583,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32583, 45.4338]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36592419,
        name: "Ca'Rosaroll Gold",
        host_id: 275050064,
        host_name: "Ca' Rosaroll",
        latitude: 45.43163,
        longitude: 12.33336,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33336, 45.43163]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36593458,
        name: "il nido sui tetti - roof top apartment",
        host_id: 275054752,
        host_name: "Colombina",
        latitude: 45.43639,
        longitude: 12.34614,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34614, 45.43639]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36619122,
        name: "Santa Fosca Design Apartment R&R",
        host_id: 173200514,
        host_name: "Rent&Relax",
        latitude: 45.44248,
        longitude: 12.33317,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33317, 45.44248]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36624980,
        name: "Lovely apartment close to Rialto Bridge",
        host_id: 121886385,
        host_name: "Martina",
        latitude: 45.4393,
        longitude: 12.33787,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33787, 45.4393]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36628493,
        name: "Sunny apartment in San Marcuola area",
        host_id: 121886385,
        host_name: "Martina",
        latitude: 45.4429,
        longitude: 12.32737,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32737, 45.4429]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36661406,
        name: "Stefany's Home -  Venice Apartment",
        host_id: 275477548,
        host_name: "Stefania",
        latitude: 45.44172,
        longitude: 12.32286,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32286, 45.44172]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36664001,
        name: "San Stae Studio",
        host_id: 143456157,
        host_name: "Elena",
        latitude: 45.44028,
        longitude: 12.32779,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32779, 45.44028]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36669917,
        name: "Ca'dell'Opera 1637  No.2 Room",
        host_id: 258426902,
        host_name: "Loukas",
        latitude: 45.43694,
        longitude: 12.32592,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32592, 45.43694]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36671351,
        name: "Ca'dell'Opera 1637 - III Room",
        host_id: 258426902,
        host_name: "Loukas",
        latitude: 45.43822,
        longitude: 12.32576,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32576, 45.43822]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36678559,
        name: "Giudecca art Venice",
        host_id: 86439077,
        host_name: "Alberto",
        latitude: 45.42553,
        longitude: 12.32473,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32473, 45.42553]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36723155,
        name: "Ca'Rosaroll Turquoise",
        host_id: 275050064,
        host_name: "Ca' Rosaroll",
        latitude: 45.43331,
        longitude: 12.33571,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33571, 45.43331]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36724836,
        name: "Ca'Rosaroll Bordeaux",
        host_id: 275050064,
        host_name: "Ca' Rosaroll",
        latitude: 45.43207,
        longitude: 12.33354,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33354, 45.43207]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36742616,
        name:
          "La corte di San Vio M (Phone number hidden by Airbnb) with smart lock",
        host_id: 260360901,
        host_name: "Francesca",
        latitude: 45.4305,
        longitude: 12.3319,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3319, 45.4305]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36752641,
        name: "Zenzero",
        host_id: 94193482,
        host_name: "Valeria",
        latitude: 45.43734,
        longitude: 12.32759,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32759, 45.43734]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36752936,
        name: "Coriandolo",
        host_id: 94193482,
        host_name: "Valeria",
        latitude: 45.43752,
        longitude: 12.32897,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32897, 45.43752]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36753530,
        name: "La Terrasse (L.T. M (Phone number hidden by Airbnb)",
        host_id: 5618111,
        host_name: "EasySuite",
        latitude: 45.44617,
        longitude: 12.32235,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32235, 45.44617]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36755340,
        name: "Ca' Romantica Terrace and Canal View",
        host_id: 669047,
        host_name: "Viewsonvenice",
        latitude: 45.43333,
        longitude: 12.32414,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32414, 45.43333]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36757744,
        name: "The Palace 5613, Lo Studio. Private Apartment",
        host_id: 202492873,
        host_name: "Anna",
        latitude: 45.43832,
        longitude: 12.33875,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33875, 45.43832]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36761948,
        name: "S. Mark Venice Dream",
        host_id: 25085773,
        host_name: "Gin",
        latitude: 45.43439,
        longitude: 12.34537,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34537, 45.43439]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36781912,
        name: "Casa Fedora Dependance near San Marco - Rialto",
        host_id: 63194257,
        host_name: "Edoardo",
        latitude: 45.43737,
        longitude: 12.34098,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34098, 45.43737]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36782247,
        name: "CA' MARCELLA",
        host_id: 87431454,
        host_name: "Giuliano",
        latitude: 45.43505,
        longitude: 12.34091,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34091, 45.43505]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36792085,
        name: "Mozart - 5 min. from Rialto Bridge",
        host_id: 7672609,
        host_name: "Gian Luigi & Nicola",
        latitude: 45.43939,
        longitude: 12.33152,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33152, 45.43939]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36814198,
        name: "San marcuola - Venice cozy studio 1- Guardi",
        host_id: 231775592,
        host_name: "Judite & Beatrice",
        latitude: 45.44314,
        longitude: 12.32768,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32768, 45.44314]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36819331,
        name: "Ca' Priuli 2",
        host_id: 230491585,
        host_name: "Paolo",
        latitude: 45.44132,
        longitude: 12.33427,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33427, 45.44132]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36824144,
        name: "Grande ed Elegante in San Marco",
        host_id: 189903592,
        host_name: "Tiziana",
        latitude: 45.43623,
        longitude: 12.33778,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33778, 45.43623]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36828161,
        name: "Lio",
        host_id: 98131866,
        host_name: "Michele",
        latitude: 45.4372,
        longitude: 12.33904,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33904, 45.4372]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36828367,
        name: "Residenza Ca' Giacomo (L.T. M (Phone number hidden by Airbnb)",
        host_id: 5618111,
        host_name: "EasySuite",
        latitude: 45.44575,
        longitude: 12.32731,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32731, 45.44575]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36830325,
        name: "Ca' d'Oro: bella casa con terrazzi",
        host_id: 189903592,
        host_name: "Tiziana",
        latitude: 45.44193,
        longitude: 12.33314,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33314, 45.44193]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36834919,
        name: "Ca' della Misericordia",
        host_id: 22940319,
        host_name: "Albatroservices",
        latitude: 45.4399,
        longitude: 12.33436,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33436, 45.4399]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36857336,
        name: "Tedeum",
        host_id: 189903592,
        host_name: "Tiziana",
        latitude: 45.43869,
        longitude: 12.3458,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3458, 45.43869]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36860301,
        name: "San Marco - apartment with canal view with washer",
        host_id: 179298782,
        host_name: "Sabrina",
        latitude: 45.43532,
        longitude: 12.34237,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34237, 45.43532]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36862343,
        name: "Apartment near the casino, for couples or friends",
        host_id: 179298782,
        host_name: "Sabrina",
        latitude: 45.44763,
        longitude: 12.33001,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33001, 45.44763]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36863973,
        name: "San marcuola / Venice cozy studio 2 - Longhi",
        host_id: 231775592,
        host_name: "Judite & Beatrice",
        latitude: 45.44321,
        longitude: 12.32733,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32733, 45.44321]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36864884,
        name: "San Stae - Spazio e luce nel cuore di Venezia",
        host_id: 189903592,
        host_name: "Tiziana",
        latitude: 45.43952,
        longitude: 12.32864,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32864, 45.43952]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36865289,
        name: "Rialto Luxury - spacious and bright apartment",
        host_id: 179298782,
        host_name: "Sabrina",
        latitude: 45.44173,
        longitude: 12.33219,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33219, 45.44173]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36868462,
        name: "Family vacation in the lively Cannaregio district",
        host_id: 179298782,
        host_name: "Sabrina",
        latitude: 45.44458,
        longitude: 12.33004,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33004, 45.44458]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36868590,
        name: "3 min. from St. Mark's Square!!!",
        host_id: 265667180,
        host_name: "Roberto",
        latitude: 45.43522,
        longitude: 12.34365,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34365, 45.43522]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36868668,
        name: "Aliki's house, Dorsoduro",
        host_id: 189903592,
        host_name: "Tiziana",
        latitude: 45.43445,
        longitude: 12.31983,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31983, 45.43445]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36870552,
        name: "Ca' San Lorenzo vista spettacolare",
        host_id: 189903592,
        host_name: "Tiziana",
        latitude: 45.4392,
        longitude: 12.34355,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34355, 45.4392]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36875571,
        name: "Casa Flora",
        host_id: 149675469,
        host_name: "Gioele",
        latitude: 45.43352,
        longitude: 12.33372,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33372, 45.43352]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36876346,
        name: "NoStress Holiday - Zen - Private Ensuite Room B",
        host_id: 233209105,
        host_name: "Venice No Stress",
        latitude: 45.44204,
        longitude: 12.33748,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33748, 45.44204]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36893524,
        name: "Apartament near the train station with canal view",
        host_id: 179298782,
        host_name: "Sabrina",
        latitude: 45.43665,
        longitude: 12.3234,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3234, 45.43665]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36895094,
        name: "St Mark's Suite - zona Frari, vicino la stazione",
        host_id: 179298782,
        host_name: "Sabrina",
        latitude: 45.43744,
        longitude: 12.3245,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3245, 45.43744]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36895545,
        name: "Ninetta 1 bedroom ground floor apartment",
        host_id: 27081641,
        host_name: "Irene",
        latitude: 45.43518,
        longitude: 12.32383,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32383, 45.43518]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36905835,
        name: "Nuovo Appartamento nel Centro Storico di Venezia",
        host_id: 71765118,
        host_name: "Alexandre",
        latitude: 45.44299,
        longitude: 12.32882,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32882, 45.44299]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36937633,
        name: "San Marco Red Nest",
        host_id: 277651292,
        host_name: "Tatiana",
        latitude: 45.43154,
        longitude: 12.33174,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33174, 45.43154]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36965652,
        name: "Carmini Canal View and balcony with Lift",
        host_id: 141282928,
        host_name: "Thomas",
        latitude: 45.43414,
        longitude: 12.31916,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31916, 45.43414]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36968069,
        name: "Your cozy apartment in Venice",
        host_id: 277892063,
        host_name: "Giorgio",
        latitude: 45.43512,
        longitude: 12.34603,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34603, 45.43512]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36989710,
        name: "Artists'_Tana",
        host_id: 106880093,
        host_name: "Federica & Doriano",
        latitude: 45.43339,
        longitude: 12.35146,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35146, 45.43339]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36997514,
        name:
          "Aparment in the heart of Venice, ideally situaded for visiting the city",
        host_id: 270230010,
        host_name: "Iris - BELVILLA",
        latitude: 45.43646,
        longitude: 12.31966,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31966, 45.43646]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36997524,
        name: "Spacious Holiday Home in Venice",
        host_id: 270230010,
        host_name: "Iris - BELVILLA",
        latitude: 45.4449,
        longitude: 12.33266,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33266, 45.4449]] },
    },
    {
      type: "Feature",
      properties: {
        id: 36999064,
        name: "RIALTO DESIGN - COMFORT IN CANNAREGIO",
        host_id: 179297180,
        host_name: "Chiara",
        latitude: 45.44338,
        longitude: 12.33364,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33364, 45.44338]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37003237,
        name: "Near Sospiri Bridge - San Marco",
        host_id: 179297180,
        host_name: "Chiara",
        latitude: 45.43527,
        longitude: 12.34203,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34203, 45.43527]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37010096,
        name: "Noble House Grand Canal 2",
        host_id: 231841228,
        host_name: "Giuliano Kim",
        latitude: 45.44195,
        longitude: 12.3238,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3238, 45.44195]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37010736,
        name: "La Marchesa",
        host_id: 277342330,
        host_name: "Views On Venice",
        latitude: 45.43363,
        longitude: 12.33627,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33627, 45.43363]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37029331,
        name: "Near the historic Ghetto - Pied-a-terre canal view",
        host_id: 179297180,
        host_name: "Chiara",
        latitude: 45.44625,
        longitude: 12.33007,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33007, 45.44625]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37044219,
        name: "CA' REALI  Bright, elegant, airy,  spacious, STYLE",
        host_id: 4893459,
        host_name: "Roberta",
        latitude: 45.44252,
        longitude: 12.3384,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3384, 45.44252]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37046237,
        name: "Riva De Biasio Charming Apartment R&R",
        host_id: 173200514,
        host_name: "Rent&Relax",
        latitude: 45.44036,
        longitude: 12.32496,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32496, 45.44036]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37074564,
        name: "Casa Surian",
        host_id: 154289203,
        host_name: "Fabio",
        latitude: 45.43603,
        longitude: 12.3222,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3222, 45.43603]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37080047,
        name: "Secret Garden apartment in the heart  of Venice",
        host_id: 132051429,
        host_name: "Cristina",
        latitude: 45.43602,
        longitude: 12.34246,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34246, 45.43602]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37081472,
        name: "Miki's Place",
        host_id: 174418896,
        host_name: "Mimax",
        latitude: 45.43281,
        longitude: 12.3233,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3233, 45.43281]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37089996,
        name: "Ca' Splendore del Sole",
        host_id: 278979828,
        host_name: "Elena",
        latitude: 45.4462,
        longitude: 12.32255,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32255, 45.4462]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37090374,
        name: "Ca' Brazzo",
        host_id: 278975264,
        host_name: "Carlo",
        latitude: 45.4467,
        longitude: 12.3323,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3323, 45.4467]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37115080,
        name: "Maddalena House, with air conditioning and Wi-Fi",
        host_id: 7879981,
        host_name: "Eugenio E Bruno",
        latitude: 45.44201,
        longitude: 12.33238,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33238, 45.44201]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37119592,
        name: "Ca' San Marco Flat",
        host_id: 226026079,
        host_name: "Salvatore",
        latitude: 45.43432,
        longitude: 12.33536,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33536, 45.43432]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37132163,
        name: "Ca' Roberta: close to train station & free wifi",
        host_id: 133690220,
        host_name: "Silvia-Carlo",
        latitude: 45.44178,
        longitude: 12.32678,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32678, 45.44178]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37142540,
        name: "Ca' Frizier (modern apartment up to 4)",
        host_id: 205703685,
        host_name: "Bricola",
        latitude: 45.43378,
        longitude: 12.35447,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35447, 45.43378]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37142608,
        name: "Hotel  Herion - Triple 3A",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.44268,
        longitude: 12.32737,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32737, 45.44268]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37142609,
        name: "Hotel Herion - double room 1A",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.44412,
        longitude: 12.32755,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32755, 45.44412]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37142856,
        name: "Hotel Herion -Quadruple",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.44321,
        longitude: 12.32719,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32719, 45.44321]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37143686,
        name: "Hotel Herion - triple room 1B",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.44444,
        longitude: 12.32713,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32713, 45.44444]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37143695,
        name: "Hotel Herion - Quadruple",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.44333,
        longitude: 12.32711,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32711, 45.44333]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37143768,
        name: "Hotel Herion - double room 6a",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.44393,
        longitude: 12.32755,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32755, 45.44393]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37144062,
        name: "Hotel Herion - double room 2A",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.44283,
        longitude: 12.32698,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32698, 45.44283]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37144104,
        name: "Hotel Herion - Double Room 4A",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.4442,
        longitude: 12.32843,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32843, 45.4442]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37144436,
        name: "Hotel Herion - double room 2C",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.44411,
        longitude: 12.32695,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32695, 45.44411]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37144538,
        name: "Hotel Herion - Double Room 4B",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.44309,
        longitude: 12.32904,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32904, 45.44309]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37144552,
        name: "Punta Della Dogana Luxury suite (penthouse up to8)",
        host_id: 205703685,
        host_name: "Bricola",
        latitude: 45.43018,
        longitude: 12.33404,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33404, 45.43018]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37144728,
        name: "Hotel Herion - Triple",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.44454,
        longitude: 12.32712,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32712, 45.44454]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37144955,
        name: "Hotel Herion - Quadruple",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.44325,
        longitude: 12.32894,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32894, 45.44325]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37145090,
        name: "Hotel Herion - Triple",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.44429,
        longitude: 12.32894,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32894, 45.44429]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37145524,
        name: "Hotel Herion - double room",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.44383,
        longitude: 12.32883,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32883, 45.44383]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37145886,
        name: "Hotel Herion - double room",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.44286,
        longitude: 12.32902,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32902, 45.44286]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37145917,
        name: "Punta della Dogana Luxury Suite up to 5",
        host_id: 205703685,
        host_name: "Bricola",
        latitude: 45.42978,
        longitude: 12.33395,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33395, 45.42978]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37173105,
        name: "San Marco Flat. In the center of Venice.",
        host_id: 279720034,
        host_name: "Alessandro",
        latitude: 45.43569,
        longitude: 12.33823,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33823, 45.43569]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37177926,
        name: "Tre Archi Garden Apartment",
        host_id: 24669207,
        host_name: "Milo",
        latitude: 45.44397,
        longitude: 12.32082,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32082, 45.44397]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37179966,
        name: "Rio Marin Apartment",
        host_id: 24669207,
        host_name: "Milo",
        latitude: 45.43748,
        longitude: 12.32577,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32577, 45.43748]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37199977,
        name: "Mimi's loft",
        host_id: 26671279,
        host_name: "Pietro",
        latitude: 45.42969,
        longitude: 12.33339,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33339, 45.42969]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37201663,
        name: "Nikki House Venice Apartment Canal",
        host_id: 187144142,
        host_name: "Alessandro Markku",
        latitude: 45.43545,
        longitude: 12.344,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.344, 45.43545]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37225514,
        name: "Residenza Pomponi Deluxe",
        host_id: 14117590,
        host_name: "Moreno",
        latitude: 45.44033,
        longitude: 12.3251,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3251, 45.44033]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37250702,
        name: "Charming Cozy and fully furnished apartment Venice",
        host_id: 26944819,
        host_name: "Alice",
        latitude: 45.44659,
        longitude: 12.33132,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33132, 45.44659]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37251803,
        name: "Netflix & Gondolas",
        host_id: 198977243,
        host_name: "Jelmer",
        latitude: 45.42702,
        longitude: 12.36234,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.36234, 45.42702]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37272676,
        name: "Venetian luxury apartment in a Palazzo.",
        host_id: 262538578,
        host_name: "Roberta",
        latitude: 45.43468,
        longitude: 12.33007,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33007, 45.43468]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37275812,
        name: "Ve.N.I.Ce Cera Remer Suite",
        host_id: 37864680,
        host_name: "Ve.N.I.Ce Immobiliare Cera",
        latitude: 45.44166,
        longitude: 12.33822,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33822, 45.44166]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37294552,
        name: "Grande Suite Accademia Venice",
        host_id: 14743308,
        host_name: "Jacopo",
        latitude: 45.42984,
        longitude: 12.33246,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33246, 45.42984]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37304122,
        name: "The room of Angels",
        host_id: 159503043,
        host_name: "Agata",
        latitude: 45.44108,
        longitude: 12.32579,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32579, 45.44108]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37305904,
        name: "Lovely Formosa House + free WI-FI",
        host_id: 31072784,
        host_name: "Tomas",
        latitude: 45.43835,
        longitude: 12.34222,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34222, 45.43835]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37311421,
        name: "Tranquillità e giardinetto in un quartiere tipico",
        host_id: 13710186,
        host_name: "Federica",
        latitude: 45.44613,
        longitude: 12.32435,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32435, 45.44613]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37311455,
        name: "ROOFTOP APARTMENT",
        host_id: 14357135,
        host_name: "Rent It Venice",
        latitude: 45.43371,
        longitude: 12.33681,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33681, 45.43371]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37311606,
        name: "CA’ LUIGI with canal view",
        host_id: 38346442,
        host_name: "Giancarlo",
        latitude: 45.43243,
        longitude: 12.32958,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32958, 45.43243]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37321772,
        name: "Rialto Bridge - Art Apartments Venice",
        host_id: 28162920,
        host_name: "Beatriz",
        latitude: 45.4381,
        longitude: 12.33399,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33399, 45.4381]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37344095,
        name: 'AtoLiving "Arsenale"',
        host_id: 236770524,
        host_name: "AtoLiving",
        latitude: 45.43112,
        longitude: 12.35609,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35609, 45.43112]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37345979,
        name: "Casteo Basso 914",
        host_id: 180656673,
        host_name: "Francesco",
        latitude: 45.43037,
        longitude: 12.35585,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35585, 45.43037]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37379188,
        name: "SAN BASILIO STUDIO",
        host_id: 14357135,
        host_name: "Rent It Venice",
        latitude: 45.43286,
        longitude: 12.31426,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31426, 45.43286]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37382259,
        name: "RIALTO DELUXE-3 bedrooms, washer, a/c",
        host_id: 289615,
        host_name: "Valentina",
        latitude: 45.43854,
        longitude: 12.33471,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33471, 45.43854]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37387024,
        name: "Appartamento a Riva de Biasio",
        host_id: 277386874,
        host_name: "Claudia",
        latitude: 45.44152,
        longitude: 12.32711,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32711, 45.44152]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37387530,
        name: "I 4 Mori-apartment downtown with private court",
        host_id: 224934118,
        host_name: "Giorgia",
        latitude: 45.44459,
        longitude: 12.3328,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3328, 45.44459]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37389851,
        name: "Al Remer",
        host_id: 163424561,
        host_name: "Massimiliano",
        latitude: 45.4385,
        longitude: 12.33787,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33787, 45.4385]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37390564,
        name: "Cà San Lio",
        host_id: 163424561,
        host_name: "Massimiliano",
        latitude: 45.43855,
        longitude: 12.33943,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33943, 45.43855]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37397900,
        name: "Prima Suite Accademia Venice",
        host_id: 14743308,
        host_name: "Jacopo",
        latitude: 45.43032,
        longitude: 12.33088,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33088, 45.43032]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37398941,
        name: "Accademia inn Palace Venice",
        host_id: 14743308,
        host_name: "Jacopo",
        latitude: 45.43024,
        longitude: 12.33064,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33064, 45.43024]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37409419,
        name: "San Maurizio",
        host_id: 163424561,
        host_name: "Massimiliano",
        latitude: 45.4353,
        longitude: 12.3298,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3298, 45.4353]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37428415,
        name: "Venice Skyview Deluxe Apartment",
        host_id: 282211605,
        host_name: "Sammer",
        latitude: 45.43806,
        longitude: 12.34277,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34277, 45.43806]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37430951,
        name: "Angela's Ca'D'Oro",
        host_id: 282254270,
        host_name: "Angela",
        latitude: 45.44151,
        longitude: 12.33479,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33479, 45.44151]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37445128,
        name: "Authentic Venice!",
        host_id: 281049402,
        host_name: "Christian",
        latitude: 45.43189,
        longitude: 12.32534,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32534, 45.43189]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37456358,
        name: "Townhouse StudioGiardini excl design artist home",
        host_id: 1228713,
        host_name: "Paulina",
        latitude: 45.42957,
        longitude: 12.35664,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35664, 45.42957]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37456863,
        name: "Casa di Laura - High Tide Exempt",
        host_id: 282525014,
        host_name: "Laura & Valentina",
        latitude: 45.44378,
        longitude: 12.32321,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32321, 45.44378]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37486835,
        name: "Best location in Venice",
        host_id: 27990266,
        host_name: "Ai",
        latitude: 45.4369,
        longitude: 12.3394,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3394, 45.4369]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37489290,
        name: "Appartamento Giglio",
        host_id: 282838433,
        host_name: "Liana",
        latitude: 45.43392,
        longitude: 12.33918,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33918, 45.43392]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37491028,
        name: "Ca' Pozzo INN 2- Standard room",
        host_id: 115621013,
        host_name: "Nicola",
        latitude: 45.44317,
        longitude: 12.32644,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32644, 45.44317]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37495189,
        name: "Residenza Ducato",
        host_id: 251054587,
        host_name: "Ducato",
        latitude: 45.43462,
        longitude: 12.33755,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33755, 45.43462]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37508369,
        name: "❤Welcome to ➺″Bella Corte″❤ Two Bedrooms & Garden",
        host_id: 281782044,
        host_name: "Roberta",
        latitude: 45.43696,
        longitude: 12.34324,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34324, 45.43696]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37515526,
        name: "Sunnyroom",
        host_id: 282426109,
        host_name: "Farid",
        latitude: 45.44633,
        longitude: 12.32223,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32223, 45.44633]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37516511,
        name: "San Marco Penthouse 2",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.43762,
        longitude: 12.33608,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33608, 45.43762]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37516663,
        name: "Blueroom",
        host_id: 282426109,
        host_name: "Farid",
        latitude: 45.44632,
        longitude: 12.3234,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3234, 45.44632]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37546034,
        name: "♛✧ Luxury & Refined Apartment in Cannaregio ✧♛",
        host_id: 282795197,
        host_name: "Susanna",
        latitude: 45.4426,
        longitude: 12.33177,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33177, 45.4426]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37551636,
        name: "Residenza Biennale (L.T. M (Phone number hidden by Airbnb) )",
        host_id: 5618111,
        host_name: "EasySuite",
        latitude: 45.43273,
        longitude: 12.35787,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35787, 45.43273]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37558407,
        name: "YOUR FLAT IN VENICE.",
        host_id: 196163510,
        host_name: "Elvio",
        latitude: 45.43432,
        longitude: 12.31752,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31752, 45.43432]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37563876,
        name: "Sweet Venice - Exclusive near San Marco - WiFi",
        host_id: 36324248,
        host_name: "Giovanni",
        latitude: 45.43947,
        longitude: 12.34303,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34303, 45.43947]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37576701,
        name: "Cà del Mar",
        host_id: 38346442,
        host_name: "Giancarlo",
        latitude: 45.43573,
        longitude: 12.34608,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34608, 45.43573]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37584583,
        name: "Cozy Ca' Minetto",
        host_id: 283943164,
        host_name: "Abitarenext",
        latitude: 45.4391,
        longitude: 12.33322,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33322, 45.4391]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37596483,
        name: "Enchanting mirror on the water",
        host_id: 284044182,
        host_name: "Grazia",
        latitude: 45.4409,
        longitude: 12.34033,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34033, 45.4409]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37613867,
        name: "Apt. Fidelio (150m from Rialto's Bridge)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.43962,
        longitude: 12.33799,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33799, 45.43962]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37616409,
        name: "Palazzetto Canossa Intera Struttura",
        host_id: 257326087,
        host_name: "Roberta",
        latitude: 45.43826,
        longitude: 12.32449,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32449, 45.43826]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37620004,
        name: "Palazzo Fosca Prestige Terrace",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.44247,
        longitude: 12.33195,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33195, 45.44247]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37624531,
        name: "Private House on 3 levels in the centre of Venice",
        host_id: 63752942,
        host_name: "Francesco",
        latitude: 45.43849,
        longitude: 12.32748,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32748, 45.43849]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37627130,
        name: "The Venetian Canal View - Off the beaten track",
        host_id: 141282928,
        host_name: "Thomas",
        latitude: 45.43332,
        longitude: 12.35576,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35576, 45.43332]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37630452,
        name: "Lovely Room in Venice's center",
        host_id: 44194709,
        host_name: "Dafne",
        latitude: 45.43377,
        longitude: 12.31849,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31849, 45.43377]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37656582,
        name: "Venice Suite Cannaregio",
        host_id: 264096231,
        host_name: "Loredana",
        latitude: 45.44338,
        longitude: 12.32332,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32332, 45.44338]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37658422,
        name: "Erasmus  Student Apartment No.1",
        host_id: 258426902,
        host_name: "Loukas",
        latitude: 45.43806,
        longitude: 12.32588,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32588, 45.43806]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37658986,
        name: "Erasmus Student Apartment No.2",
        host_id: 258426902,
        host_name: "Loukas",
        latitude: 45.43783,
        longitude: 12.32566,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32566, 45.43783]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37660691,
        name: "ExclusiVenice San Marco 1578",
        host_id: 235305051,
        host_name: "Massimo",
        latitude: 45.43487,
        longitude: 12.33691,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33691, 45.43487]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37669721,
        name: "Calle Sacrestia super central flat with terrace!",
        host_id: 1438903,
        host_name: "Barbara",
        latitude: 45.43495,
        longitude: 12.34171,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34171, 45.43495]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37680832,
        name: "SAN LORENZO GIARDINO – apartment with garden",
        host_id: 22632812,
        host_name: "Alain",
        latitude: 45.43671,
        longitude: 12.3452,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3452, 45.43671]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37682258,
        name: "Guesthouse Al Profeta - Camera 3",
        host_id: 59950737,
        host_name: "Simone",
        latitude: 45.43987,
        longitude: 12.3371,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3371, 45.43987]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37697360,
        name: "Leonardo Canal View (Venice Historical Center)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.44215,
        longitude: 12.34128,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34128, 45.44215]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37698337,
        name: "San Provolo Luxury (300m from St. Mark's Square)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.43596,
        longitude: 12.34341,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34341, 45.43596]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37742336,
        name: "Elegant Fornasa Vecia, canal view with garden R&R",
        host_id: 173200514,
        host_name: "Rent&Relax",
        latitude: 45.44719,
        longitude: 12.32661,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32661, 45.44719]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37773011,
        name: "GRANDCANAL-RED, new, 3 people, fiber free wifi",
        host_id: 153954052,
        host_name: "Annalisa",
        latitude: 45.43673,
        longitude: 12.32776,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32776, 45.43673]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37791108,
        name: "APARTMENT WITH TERRACE 1",
        host_id: 285989536,
        host_name: "Andrea",
        latitude: 45.43816,
        longitude: 12.33911,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33911, 45.43816]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37796507,
        name: "VENETIAN DREA APARTMENT",
        host_id: 84841054,
        host_name: "Francesca",
        latitude: 45.43296,
        longitude: 12.32557,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32557, 45.43296]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37801547,
        name: "Ca Falier Apartment",
        host_id: 276201478,
        host_name: "Davide",
        latitude: 45.43642,
        longitude: 12.32414,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32414, 45.43642]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37819069,
        name: "PUPPARIN HISTORIC CITY CENTER APARTMENT",
        host_id: 286260380,
        host_name: "Irene E Valentina",
        latitude: 45.4367,
        longitude: 12.32489,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32489, 45.4367]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37819611,
        name: "Luxury apartment with roof terrace Ca' Venar",
        host_id: 86702142,
        host_name: "Antonina",
        latitude: 45.43439,
        longitude: 12.3214,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3214, 45.43439]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37823970,
        name: "Venice Sweet Home",
        host_id: 13027859,
        host_name: "Diego",
        latitude: 45.44614,
        longitude: 12.32189,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32189, 45.44614]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37844259,
        name: "Central shining Flat Venice",
        host_id: 13500918,
        host_name: "Mark",
        latitude: 45.43586,
        longitude: 12.34824,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34824, 45.43586]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37844631,
        name: "Central Flat near Arsenale Entrance biennale",
        host_id: 191226100,
        host_name: "Milo",
        latitude: 45.43637,
        longitude: 12.3487,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3487, 45.43637]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37845331,
        name: "Imperial confortable Flat closed to San Marco Area",
        host_id: 48092742,
        host_name: "Roby",
        latitude: 45.43741,
        longitude: 12.34684,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34684, 45.43741]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37852921,
        name: "GRANDCANAL-GREEN new, 3pax, 2bath, fiber free wifi",
        host_id: 153954052,
        host_name: "Annalisa",
        latitude: 45.43645,
        longitude: 12.32774,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32774, 45.43645]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37866890,
        name: "Piccolo appartamento vicino Piazza San Marco",
        host_id: 286812539,
        host_name: "Edoardo",
        latitude: 45.44386,
        longitude: 12.32793,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32793, 45.44386]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37869168,
        name: "Castello 3597, Sotoportego dei Preti",
        host_id: 286828523,
        host_name: "Marco",
        latitude: 45.43356,
        longitude: 12.34751,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34751, 45.43356]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37869732,
        name: "The Painters' House near St. Marks Square",
        host_id: 286831869,
        host_name: "Angelina",
        latitude: 45.43602,
        longitude: 12.34215,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34215, 45.43602]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37870019,
        name: "Singola a 5 minuti dai Giardini della Biennale",
        host_id: 58438057,
        host_name: "Claudia",
        latitude: 45.42687,
        longitude: 12.35975,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35975, 45.42687]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37872451,
        name:
          "Santo Stefano Contemporary chic Loc.T  MO (Phone number hidden by Airbnb)",
        host_id: 12419335,
        host_name: "Annalisa",
        latitude: 45.43446,
        longitude: 12.33026,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33026, 45.43446]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37878996,
        name: "The WOW - Exclusive Home in Venice",
        host_id: 198126481,
        host_name: "Thomas",
        latitude: 45.44014,
        longitude: 12.32491,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32491, 45.44014]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37895764,
        name: "BAROCCO VENEZIANO 2doubles, location, wifi aircond",
        host_id: 17534457,
        host_name: "Abaca",
        latitude: 45.43783,
        longitude: 12.33227,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33227, 45.43783]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37895918,
        name: "Suite Battello - Luxury Experience - Cannaregio",
        host_id: 180302830,
        host_name: "Nicola",
        latitude: 45.44551,
        longitude: 12.32356,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32356, 45.44551]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37899634,
        name: "Ca' Facchin, incantevole mansarda con terrazzo",
        host_id: 294951,
        host_name: "VeniceVillas Di Enzo",
        latitude: 45.44385,
        longitude: 12.33352,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33352, 45.44385]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37903822,
        name: "Ca Cici - Venice Loft Apartment",
        host_id: 287133851,
        host_name: "Monica",
        latitude: 45.43267,
        longitude: 12.35243,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35243, 45.43267]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37922366,
        name: "Casa Stainer, camera familiare con bagno privato",
        host_id: 240563683,
        host_name: "Mario",
        latitude: 45.43483,
        longitude: 12.34148,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34148, 45.43483]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37932487,
        name: "Ca' Pantalon Terrace",
        host_id: 669047,
        host_name: "Viewsonvenice",
        latitude: 45.4365,
        longitude: 12.32446,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32446, 45.4365]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37932488,
        name: "Ca' Fornoni Grand Canal",
        host_id: 669047,
        host_name: "Viewsonvenice",
        latitude: 45.43802,
        longitude: 12.33469,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33469, 45.43802]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37935199,
        name: "Nazario Sauro Field",
        host_id: 263510782,
        host_name: "Emanuele",
        latitude: 45.44136,
        longitude: 12.32623,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32623, 45.44136]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37955200,
        name: "Bloom B&B, Triple Superior",
        host_id: 268299513,
        host_name: "Alessandra",
        latitude: 45.43349,
        longitude: 12.3299,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3299, 45.43349]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37959777,
        name: "Chic and cheap near San Marzo Square and Biennale",
        host_id: 5980615,
        host_name: "Adriana",
        latitude: 45.43655,
        longitude: 12.34492,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34492, 45.43655]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37961712,
        name:
          "Ca' Neola - Centro Storico  Cod. M (Phone number hidden by Airbnb)",
        host_id: 287801548,
        host_name: "Mauro",
        latitude: 45.43942,
        longitude: 12.33057,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33057, 45.43942]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37969661,
        name: "Blue Venice Shared Rooms",
        host_id: 287865339,
        host_name: "Meitham",
        latitude: 45.44774,
        longitude: 12.33176,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33176, 45.44774]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37980243,
        name: "Bright, modern apartment. Close to La Biennale",
        host_id: 68564211,
        host_name: "Valentina",
        latitude: 45.43272,
        longitude: 12.35598,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35598, 45.43272]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37981321,
        name: "Stefano's sweet home",
        host_id: 273218149,
        host_name: "Fam. Pasini",
        latitude: 45.44245,
        longitude: 12.33838,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33838, 45.44245]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37983092,
        name: "Hotel Locanda Fiorita, Classic Double",
        host_id: 98495553,
        host_name: "Paolo",
        latitude: 45.4349,
        longitude: 12.32978,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32978, 45.4349]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37984387,
        name: "Hotel Locanda Fiorita, Triple Comfort",
        host_id: 98495553,
        host_name: "Paolo",
        latitude: 45.43337,
        longitude: 12.33098,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33098, 45.43337]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37989417,
        name: "Private Room",
        host_id: 287865339,
        host_name: "Meitham",
        latitude: 45.44646,
        longitude: 12.33265,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33265, 45.44646]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37989884,
        name: "Dimora San Maurizio 2",
        host_id: 277342330,
        host_name: "Views On Venice",
        latitude: 45.43464,
        longitude: 12.33538,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33538, 45.43464]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37989975,
        name: "Dimora San Maurizio 3",
        host_id: 277342330,
        host_name: "Views On Venice",
        latitude: 45.4346,
        longitude: 12.33361,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33361, 45.4346]] },
    },
    {
      type: "Feature",
      properties: {
        id: 37992675,
        name: "Luminoso Attico Capparozzola 2+2. Biennale",
        host_id: 35266342,
        host_name: "Davide",
        latitude: 45.43399,
        longitude: 12.35784,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35784, 45.43399]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38005740,
        name: "San pietro elegant Flat",
        host_id: 191226100,
        host_name: "Milo",
        latitude: 45.43377,
        longitude: 12.35911,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35911, 45.43377]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38009282,
        name: "MASCARETA HISTORIC CITY CENTER APARTMENT",
        host_id: 286260380,
        host_name: "Irene E Valentina",
        latitude: 45.43805,
        longitude: 12.3241,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3241, 45.43805]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38011063,
        name: "Single room in cute comfy apartment central Venice",
        host_id: 3522363,
        host_name: "Rebecca",
        latitude: 45.44321,
        longitude: 12.3189,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3189, 45.44321]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38011158,
        name: "San Marco Comfy",
        host_id: 163424561,
        host_name: "Massimiliano",
        latitude: 45.43418,
        longitude: 12.3357,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3357, 45.43418]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38012087,
        name: "Casa Murrina - lovely terrace on Venice",
        host_id: 241023758,
        host_name: "Marika",
        latitude: 45.43634,
        longitude: 12.32188,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32188, 45.43634]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38014530,
        name: "SAN MARCO CANAL VIEW#1 aircond, 4 pax, 120sqm Wifi",
        host_id: 153954052,
        host_name: "Annalisa",
        latitude: 45.43718,
        longitude: 12.34314,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34314, 45.43718]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38014881,
        name: "Mimì",
        host_id: 13990376,
        host_name: "Tommaso",
        latitude: 45.4331,
        longitude: 12.3256,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3256, 45.4331]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38015646,
        name: "Venice Shared Room",
        host_id: 287865339,
        host_name: "Meitham",
        latitude: 45.44664,
        longitude: 12.33322,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33322, 45.44664]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38019149,
        name: "STUNNING! SUNSET BALCONY JUTTING 5pax WIFI aircond",
        host_id: 17534457,
        host_name: "Abaca",
        latitude: 45.4246,
        longitude: 12.32658,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32658, 45.4246]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38023410,
        name: "Private Rooms in Venice",
        host_id: 287865339,
        host_name: "Meitham",
        latitude: 45.44772,
        longitude: 12.33174,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33174, 45.44772]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38036739,
        name: "Ca’Ghironda",
        host_id: 206352876,
        host_name: "Aurora",
        latitude: 45.42733,
        longitude: 12.32137,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32137, 45.42733]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38039440,
        name: "ROOFTOP SAN MARCO - TOWER VIEW",
        host_id: 283417881,
        host_name: "Roberta",
        latitude: 45.43706,
        longitude: 12.33965,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33965, 45.43706]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38040482,
        name: "San Marco, Elegant & Spacious Venetian Apartment!",
        host_id: 218260862,
        host_name: "Alessio",
        latitude: 45.4383,
        longitude: 12.34254,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34254, 45.4383]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38045091,
        name: "Absolute arsenal flat",
        host_id: 28199198,
        host_name: "Ai",
        latitude: 45.43501,
        longitude: 12.35045,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35045, 45.43501]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38063535,
        name: "Room N.5 - Design and canal view.",
        host_id: 54746036,
        host_name: "Dada",
        latitude: 45.43992,
        longitude: 12.34034,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34034, 45.43992]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38078165,
        name: "Blue Venice Private Rooms",
        host_id: 287865339,
        host_name: "Meitham",
        latitude: 45.44751,
        longitude: 12.332,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.332, 45.44751]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38080794,
        name: "Appartamento con giardino privato - private garden",
        host_id: 126600737,
        host_name: "Mattia",
        latitude: 45.42423,
        longitude: 12.32399,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32399, 45.42423]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38083709,
        name: "Canaletto Apartment Rialto Gran Canal view",
        host_id: 268742426,
        host_name: "Davide",
        latitude: 45.4391,
        longitude: 12.33648,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33648, 45.4391]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38113133,
        name: "Ca' Terese (M (Phone number hidden by Airbnb)",
        host_id: 289331838,
        host_name: "Nathalie",
        latitude: 45.43345,
        longitude: 12.31537,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31537, 45.43345]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38118898,
        name: "Deluxe Studio Apartment in Venice Cannaregio",
        host_id: 289391962,
        host_name: "Margherita",
        latitude: 45.44014,
        longitude: 12.33727,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33727, 45.44014]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38120578,
        name: "Exclusive Suite Apartment in Venice Cannaregio",
        host_id: 289391962,
        host_name: "Margherita",
        latitude: 45.44234,
        longitude: 12.33624,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33624, 45.44234]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38123135,
        name: "Antique, central house only steps from the Bacino",
        host_id: 226686453,
        host_name: "Adriana",
        latitude: 45.43494,
        longitude: 12.34226,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34226, 45.43494]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38136240,
        name: "In the city center of San Marco",
        host_id: 241299390,
        host_name: "Gios Place",
        latitude: 45.43457,
        longitude: 12.33465,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33465, 45.43457]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38136686,
        name: "San Marco Square Venice",
        host_id: 241299390,
        host_name: "Gios Place",
        latitude: 45.43317,
        longitude: 12.33511,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33511, 45.43317]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38147303,
        name: "Maison Marea canal view private room with bathroom",
        host_id: 258321283,
        host_name: "Roberta",
        latitude: 45.43294,
        longitude: 12.31918,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31918, 45.43294]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38148201,
        name: "Sweet runaway Venice #2 Ai Sogni",
        host_id: 73860334,
        host_name: "Anna",
        latitude: 45.43873,
        longitude: 12.32852,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32852, 45.43873]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38157591,
        name: "Ca' Mathilda",
        host_id: 287735540,
        host_name: "Eleonora",
        latitude: 45.4464,
        longitude: 12.32025,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32025, 45.4464]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38190119,
        name: "Gio’s Place S.Marco",
        host_id: 241299390,
        host_name: "Gios Place",
        latitude: 45.43483,
        longitude: 12.33625,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33625, 45.43483]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38197357,
        name: "Perle Veneziane",
        host_id: 290024728,
        host_name: "Vincenzo",
        latitude: 45.44143,
        longitude: 12.32744,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32744, 45.44143]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38208643,
        name: "Sweet runaway Venice #3 Ai Sogni",
        host_id: 73860334,
        host_name: "Anna",
        latitude: 45.43725,
        longitude: 12.32891,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32891, 45.43725]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38237000,
        name: "Shared Room",
        host_id: 287865339,
        host_name: "Meitham",
        latitude: 45.44772,
        longitude: 12.33162,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33162, 45.44772]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38237339,
        name: "Wellness Magno Luxury Apartment",
        host_id: 147048987,
        host_name: "Monica",
        latitude: 45.43514,
        longitude: 12.34773,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34773, 45.43514]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38248931,
        name: "SARAS'S LUXURY HOME few minutes from San Marco!",
        host_id: 120401896,
        host_name: "Davide",
        latitude: 45.43982,
        longitude: 12.34386,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34386, 45.43982]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38249892,
        name: "Accademia liberty apartment",
        host_id: 3972291,
        host_name: "Caroline E Marco",
        latitude: 45.43028,
        longitude: 12.32896,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32896, 45.43028]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38252037,
        name: "Garden Apartment",
        host_id: 3972291,
        host_name: "Caroline E Marco",
        latitude: 45.43533,
        longitude: 12.34374,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34374, 45.43533]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38254951,
        name: "Spacious apartment 2 minutes from Biennale",
        host_id: 109096295,
        host_name: "Marco",
        latitude: 45.42996,
        longitude: 12.35737,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35737, 45.42996]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38265051,
        name: "AL TEATRO ITALIA 1",
        host_id: 230932659,
        host_name: "Armando",
        latitude: 45.43736,
        longitude: 12.33822,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33822, 45.43736]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38312376,
        name: "Luxury San Marco Terrace",
        host_id: 50349340,
        host_name: "Sebastiano",
        latitude: 45.43797,
        longitude: 12.34284,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34284, 45.43797]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38313479,
        name: "CA' BAJOCCHI SAN MARCO",
        host_id: 185800709,
        host_name: "Claudio",
        latitude: 45.43547,
        longitude: 12.34049,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34049, 45.43547]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38314374,
        name: "Ca' Lara, Rialto Mercato",
        host_id: 294951,
        host_name: "VeniceVillas Di Enzo",
        latitude: 45.43983,
        longitude: 12.33261,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33261, 45.43983]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38315019,
        name:
          "Bragora - Apt. Rosso Veneziano - M (Phone number hidden by Airbnb)",
        host_id: 100521314,
        host_name: "Barbarigo",
        latitude: 45.43549,
        longitude: 12.34839,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34839, 45.43549]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38317332,
        name: "SUITE 1241 TERRACE - a/c & canal view in Dorsoduro",
        host_id: 289615,
        host_name: "Valentina",
        latitude: 45.43161,
        longitude: 12.32541,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32541, 45.43161]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38317987,
        name: "Romantic Studio in the heart of Venice w/free wifi!",
        host_id: 4339678,
        host_name: "Vacasa Italy - Venice",
        latitude: 45.43351,
        longitude: 12.31563,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31563, 45.43351]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38318795,
        name:
          "Nani Pistor  in Dorsoduro S. Trovaso (M (Phone number hidden by Airbnb)",
        host_id: 9963282,
        host_name: "Andrea",
        latitude: 45.43074,
        longitude: 12.32741,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32741, 45.43074]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38319829,
        name: '"Palazzina Bandiera e Moro"',
        host_id: 77717973,
        host_name: "Marco",
        latitude: 45.43598,
        longitude: 12.34742,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34742, 45.43598]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38323540,
        name: "Casa Letizia e il Campo della Madonna dell'Orto",
        host_id: 291522769,
        host_name: "Letizia",
        latitude: 45.44509,
        longitude: 12.33193,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33193, 45.44509]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38342890,
        name:
          "Bragora - Appartamento Ai Corazzeri - M (Phone number hidden by Airbnb)",
        host_id: 100521314,
        host_name: "Barbarigo",
        latitude: 45.43614,
        longitude: 12.34893,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34893, 45.43614]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38343775,
        name:
          "Bragora - Appartamento con Terrazza - M (Phone number hidden by Airbnb)",
        host_id: 100521314,
        host_name: "Barbarigo",
        latitude: 45.43443,
        longitude: 12.3488,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3488, 45.43443]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38345152,
        name: "Flat Blue Arsenale",
        host_id: 291796207,
        host_name: "Maria Elisa",
        latitude: 45.43607,
        longitude: 12.35027,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35027, 45.43607]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38350909,
        name: "Dimora San Maurizo 1",
        host_id: 277342330,
        host_name: "Views On Venice",
        latitude: 45.43312,
        longitude: 12.33371,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33371, 45.43312]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38351047,
        name: "Dimora San Maurizio 4",
        host_id: 277342330,
        host_name: "Views On Venice",
        latitude: 45.43523,
        longitude: 12.3339,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3339, 45.43523]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38356909,
        name: '"Biennale Exclusive Apartment"',
        host_id: 77717973,
        host_name: "Marco",
        latitude: 45.43619,
        longitude: 12.34786,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34786, 45.43619]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38364832,
        name: "Sam's House",
        host_id: 154175498,
        host_name: "Samuel",
        latitude: 45.43661,
        longitude: 12.3379,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3379, 45.43661]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38366188,
        name: "Bloom B&B, Double Charme",
        host_id: 268299513,
        host_name: "Alessandra",
        latitude: 45.43464,
        longitude: 12.3316,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3316, 45.43464]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38392723,
        name: "Residence La Turret of Venice",
        host_id: 292465618,
        host_name: "Georges",
        latitude: 45.44103,
        longitude: 12.32975,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32975, 45.44103]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38403046,
        name: "Romantic Venetian home 5 mins from Piazza S. Marco",
        host_id: 2737238,
        host_name: "Annalisa E Emma",
        latitude: 45.43402,
        longitude: 12.33271,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33271, 45.43402]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38404331,
        name: "Flat between St.Mark square and Rialto .",
        host_id: 5128717,
        host_name: "Alvise",
        latitude: 45.4346,
        longitude: 12.32972,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32972, 45.4346]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38412485,
        name: "QUIET HOME  M (Phone number hidden by Airbnb)",
        host_id: 292696822,
        host_name: "Alex",
        latitude: 45.43807,
        longitude: 12.34909,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34909, 45.43807]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38424163,
        name: "Denis Flat in Arsenale area",
        host_id: 48092742,
        host_name: "Roby",
        latitude: 45.43721,
        longitude: 12.34875,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34875, 45.43721]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38432009,
        name: 'Design House "alla biennale"',
        host_id: 290252285,
        host_name: "Debora",
        latitude: 45.43009,
        longitude: 12.35714,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35714, 45.43009]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38443423,
        name: "Your home near San marco",
        host_id: 22555548,
        host_name: "JiaHang",
        latitude: 45.43473,
        longitude: 12.34625,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34625, 45.43473]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38443505,
        name: "Zen apartment",
        host_id: 165469310,
        host_name: "Stefania",
        latitude: 45.44397,
        longitude: 12.33637,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33637, 45.44397]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38445340,
        name: "SPACIOUS APARTMENT WITH THREE TERRACES",
        host_id: 293072201,
        host_name: "Filippo",
        latitude: 45.4299,
        longitude: 12.3264,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3264, 45.4299]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38451864,
        name: "PRECIOUS MINI-LOFT WITH TERRACE",
        host_id: 293072201,
        host_name: "Filippo",
        latitude: 45.4302,
        longitude: 12.32632,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32632, 45.4302]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38452285,
        name: "APPARTAMENTO MIRACOLI",
        host_id: 113703606,
        host_name: "Chiara",
        latitude: 45.43963,
        longitude: 12.33995,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33995, 45.43963]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38469718,
        name: "❃Изысканный старинный стиль❃ ►350 м от San Marco◄",
        host_id: 292160041,
        host_name: "Tullio",
        latitude: 45.43493,
        longitude: 12.33793,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33793, 45.43493]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38474108,
        name: "Double channel view room",
        host_id: 700800,
        host_name: "Federico",
        latitude: 45.44035,
        longitude: 12.31462,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31462, 45.44035]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38474548,
        name: "Residenza Quaggio Apartment 2 (Calle Longa 2166)",
        host_id: 37356947,
        host_name: "Nicola",
        latitude: 45.43875,
        longitude: 12.33072,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33072, 45.43875]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38476728,
        name: "Holiday apartment with 2 bedrooms on 50m² in Venezia",
        host_id: 159970627,
        host_name: "Roberta - NOVASOL",
        latitude: 45.43649,
        longitude: 12.34961,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34961, 45.43649]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38478623,
        name: "CA SAN BIAGIO",
        host_id: 242868135,
        host_name: "Francesca",
        latitude: 45.42658,
        longitude: 12.32426,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32426, 45.42658]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38479542,
        name: "HEART OF VENICE HOME",
        host_id: 14357135,
        host_name: "Rent It Venice",
        latitude: 45.44114,
        longitude: 12.32876,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32876, 45.44114]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38490854,
        name: '"Arsenale Suite Apartment"',
        host_id: 77717973,
        host_name: "Marco",
        latitude: 45.43617,
        longitude: 12.34754,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34754, 45.43617]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38501589,
        name: "✯Enjoy The Magic World of Cannaregio✯",
        host_id: 293321078,
        host_name: "Angela",
        latitude: 45.44545,
        longitude: 12.32141,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32141, 45.44545]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38503092,
        name: "Casanova large Romantic Room private bathroom",
        host_id: 191226100,
        host_name: "Milo",
        latitude: 45.44289,
        longitude: 12.32823,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32823, 45.44289]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38503338,
        name: "The ❝Water Door❞ apt. in the ♥ of Venice",
        host_id: 293324138,
        host_name: "Eugenio",
        latitude: 45.43504,
        longitude: 12.33188,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33188, 45.43504]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38507576,
        name: "Sky Apartment Giudecca",
        host_id: 3769279,
        host_name: "Anna",
        latitude: 45.4237,
        longitude: 12.32427,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32427, 45.4237]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38532198,
        name: "Love colour Room in Centre",
        host_id: 191226100,
        host_name: "Milo",
        latitude: 45.43537,
        longitude: 12.34252,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34252, 45.43537]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38532338,
        name: "Royal  Gold Palace",
        host_id: 278484093,
        host_name: "Lorenzo & Co",
        latitude: 45.44103,
        longitude: 12.34011,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34011, 45.44103]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38532744,
        name: "luxury gold flat 2 Venice dreams",
        host_id: 191226100,
        host_name: "Milo",
        latitude: 45.44098,
        longitude: 12.33871,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33871, 45.44098]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38533045,
        name: "Shining Flat lovely Venice",
        host_id: 191226100,
        host_name: "Milo",
        latitude: 45.43585,
        longitude: 12.34831,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34831, 45.43585]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38534050,
        name: "Fantastic modern Flat in Arsenale area",
        host_id: 48092742,
        host_name: "Roby",
        latitude: 45.43727,
        longitude: 12.34861,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34861, 45.43727]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38534130,
        name: "Double Bedrooms in Cannaregio, near the Station",
        host_id: 293906389,
        host_name: "Benito",
        latitude: 45.4446,
        longitude: 12.32457,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32457, 45.4446]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38544136,
        name: "Antique house close to Bacino and Arsenale",
        host_id: 226686453,
        host_name: "Adriana",
        latitude: 45.4349,
        longitude: 12.34362,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34362, 45.4349]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38563576,
        name: "garden house",
        host_id: 93422838,
        host_name: "Rafael",
        latitude: 45.44527,
        longitude: 12.32672,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32672, 45.44527]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38563984,
        name: "CA' FRANCESCA super central flat by Saint-Mark's!",
        host_id: 1438903,
        host_name: "Barbara",
        latitude: 45.43626,
        longitude: 12.33744,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33744, 45.43626]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38565806,
        name: "Fashion Flat in centre close to san marco",
        host_id: 13500918,
        host_name: "Mark",
        latitude: 45.43788,
        longitude: 12.3482,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3482, 45.43788]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38568014,
        name: "Sweet runaway Venice #1 Ai Sogni",
        host_id: 73860334,
        host_name: "Anna",
        latitude: 45.43708,
        longitude: 12.32844,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32844, 45.43708]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38568111,
        name: "Stile Veneziano",
        host_id: 182952535,
        host_name: "Ain",
        latitude: 45.44288,
        longitude: 12.3284,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3284, 45.44288]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38569107,
        name: "5 minutes San Marco Room",
        host_id: 13500918,
        host_name: "Mark",
        latitude: 45.43536,
        longitude: 12.34099,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34099, 45.43536]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38569437,
        name: "Supercentral Design Room San Marcuola",
        host_id: 13500918,
        host_name: "Mark",
        latitude: 45.44464,
        longitude: 12.32773,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32773, 45.44464]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38572940,
        name: "Residenza CasaNova",
        host_id: 294313280,
        host_name: "Maria",
        latitude: 45.42576,
        longitude: 12.32656,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32656, 45.42576]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38579937,
        name: "SWEET APARTMENT",
        host_id: 23367216,
        host_name: "Romy",
        latitude: 45.43687,
        longitude: 12.33778,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33778, 45.43687]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38593509,
        name: "SAN MARCO LOOK - NEL CUORE DI VENEZIA",
        host_id: 161333534,
        host_name: "Michele",
        latitude: 45.43465,
        longitude: 12.3339,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3339, 45.43465]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38595674,
        name: "♡Special Venetian Frame close to Ca' D'Oro♡",
        host_id: 294320110,
        host_name: "Elia Giovanni",
        latitude: 45.44207,
        longitude: 12.33374,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33374, 45.44207]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38598827,
        name: "Ca' Ragionati",
        host_id: 277342330,
        host_name: "Views On Venice",
        latitude: 45.43476,
        longitude: 12.33486,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33486, 45.43476]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38601271,
        name: "Ai tre Archi apartment - Cannaregio",
        host_id: 6068323,
        host_name: "Fabio",
        latitude: 45.4467,
        longitude: 12.3194,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3194, 45.4467]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38609894,
        name: "SunnyMeggy ai Garzoti",
        host_id: 294812074,
        host_name: "Maria Grazia",
        latitude: 45.43992,
        longitude: 12.32673,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32673, 45.43992]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38611215,
        name: "Luminoso ed accogliente nella città labirinto",
        host_id: 2679513,
        host_name: "Elena",
        latitude: 45.44725,
        longitude: 12.32908,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32908, 45.44725]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38613040,
        name: "San Marco (Website hidden by Airbnb) the earth of Venice !!!",
        host_id: 294840606,
        host_name: "Ettore",
        latitude: 45.43475,
        longitude: 12.33386,
        beds: 7,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33386, 45.43475]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38617988,
        name: "Stile Veneziano 2",
        host_id: 182952535,
        host_name: "Ain",
        latitude: 45.44314,
        longitude: 12.32819,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32819, 45.44314]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38621138,
        name: "Double bedroom / private bathroom  St Marc Square",
        host_id: 218728234,
        host_name: "Emanuele",
        latitude: 45.43544,
        longitude: 12.34661,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34661, 45.43544]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38640659,
        name: "in san marco",
        host_id: 295162511,
        host_name: "Francesco",
        latitude: 45.43681,
        longitude: 12.33534,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33534, 45.43681]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38646839,
        name: "Apartment Dreamland Venice",
        host_id: 295227472,
        host_name: "Mannan",
        latitude: 45.43357,
        longitude: 12.34742,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34742, 45.43357]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38655737,
        name: "Giudecca Marisa on the Channel.",
        host_id: 67406087,
        host_name: "Renato",
        latitude: 45.42757,
        longitude: 12.31899,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31899, 45.42757]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38663708,
        name: "Chiesa dei Miracoli Tower Suite",
        host_id: 46528252,
        host_name: "Alex",
        latitude: 45.44108,
        longitude: 12.33949,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33949, 45.44108]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38691838,
        name: "Anice",
        host_id: 94193482,
        host_name: "Valeria",
        latitude: 45.438,
        longitude: 12.32559,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32559, 45.438]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38712948,
        name: "Casa Corte Delfina 5 Stars brand-new apartment",
        host_id: 119342181,
        host_name: "Claudia",
        latitude: 45.43239,
        longitude: 12.35204,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35204, 45.43239]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38712983,
        name: "Ca' Pozzo INN 3 - triple comfort room",
        host_id: 115621013,
        host_name: "Nicola",
        latitude: 45.44497,
        longitude: 12.3247,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3247, 45.44497]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38724367,
        name: "Appartamento treVi 2",
        host_id: 108507559,
        host_name: "Stefano",
        latitude: 45.4338,
        longitude: 12.3479,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3479, 45.4338]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38726171,
        name: "OLIVOLO apartment PRIVATE COURT",
        host_id: 296123704,
        host_name: "Amos",
        latitude: 45.43309,
        longitude: 12.35379,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35379, 45.43309]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38737052,
        name: "Ca'Girasole",
        host_id: 279720034,
        host_name: "Alessandro",
        latitude: 45.44314,
        longitude: 12.33041,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33041, 45.44314]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38737274,
        name: "Arcangelo - Fenice Apartments in Venice",
        host_id: 32253239,
        host_name: "Fenice Hotels",
        latitude: 45.4331,
        longitude: 12.33144,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33144, 45.4331]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38743122,
        name: "Canal View Apartment",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.43582,
        longitude: 12.31734,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31734, 45.43582]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38744040,
        name: "Rialto Project Apartment 5",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.43862,
        longitude: 12.32764,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32764, 45.43862]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38744136,
        name: "San Marco Style Canal View Apt. 3",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.43597,
        longitude: 12.34204,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34204, 45.43597]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38746040,
        name: "Suite Apartment with courtyard",
        host_id: 98044501,
        host_name: "Gianluca",
        latitude: 45.43607,
        longitude: 12.33274,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33274, 45.43607]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38746883,
        name: "Suite Apartment",
        host_id: 98044501,
        host_name: "Gianluca",
        latitude: 45.43464,
        longitude: 12.33075,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33075, 45.43464]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38773195,
        name: "Appartamento Luxury Design Venezia",
        host_id: 296520024,
        host_name: "Marco",
        latitude: 45.43478,
        longitude: 12.32459,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32459, 45.43478]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38789722,
        name: "giudecca art apartment",
        host_id: 242868135,
        host_name: "Francesca",
        latitude: 45.42417,
        longitude: 12.33062,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33062, 45.42417]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38799670,
        name: "GROUNDFLOOR APARTMENT",
        host_id: 296801957,
        host_name: "Franca",
        latitude: 45.44006,
        longitude: 12.32986,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32986, 45.44006]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38834987,
        name: "CASA GIULIO",
        host_id: 242868135,
        host_name: "Francesca",
        latitude: 45.4258,
        longitude: 12.32421,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32421, 45.4258]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38836083,
        name: "Luvmyhomy",
        host_id: 151080881,
        host_name: "Marina",
        latitude: 45.43681,
        longitude: 12.33933,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33933, 45.43681]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38840858,
        name: "A 2 passi da Basilica dei Frari, sestiere San Polo",
        host_id: 213535416,
        host_name: "Eleonora",
        latitude: 45.43878,
        longitude: 12.3262,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3262, 45.43878]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38860153,
        name: "La laguna di Venezia e le Dolomiti sullo sfondo",
        host_id: 297550824,
        host_name: "Andrea",
        latitude: 45.44064,
        longitude: 12.3411,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3411, 45.44064]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38916158,
        name: "SAN MARCO JOY",
        host_id: 166297081,
        host_name: "Thomas",
        latitude: 45.434,
        longitude: 12.33598,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33598, 45.434]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38917976,
        name: "Stately room in Rialto's heart",
        host_id: 44194709,
        host_name: "Dafne",
        latitude: 45.43898,
        longitude: 12.33372,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33372, 45.43898]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38942122,
        name: "✰Discover Venice surrounded by local Treasures✰",
        host_id: 271517062,
        host_name: "Francesco",
        latitude: 45.43368,
        longitude: 12.34834,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34834, 45.43368]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38945918,
        name: "Luxury Campo Santa Maria Formosa",
        host_id: 46528252,
        host_name: "Alex",
        latitude: 45.43852,
        longitude: 12.34172,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34172, 45.43852]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38948604,
        name: "Arte e Relax",
        host_id: 154170198,
        host_name: "Roberto",
        latitude: 45.43973,
        longitude: 12.33882,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33882, 45.43973]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38952006,
        name: "Private studio art Room near Casinò Venice",
        host_id: 48092742,
        host_name: "Roby",
        latitude: 45.44399,
        longitude: 12.3299,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3299, 45.44399]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38957151,
        name: "Close to pz.le Roma and Santa Lucia Railway",
        host_id: 143699747,
        host_name: "Matteo",
        latitude: 45.43774,
        longitude: 12.32419,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32419, 45.43774]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38987546,
        name: "CINQUE TESTE LUXURY HOME",
        host_id: 246529758,
        host_name: "Lisia",
        latitude: 45.43985,
        longitude: 12.32369,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32369, 45.43985]] },
    },
    {
      type: "Feature",
      properties: {
        id: 38992678,
        name:
          "Rialto Mercato Apartment e suite (M (Phone number hidden by Airbnb)",
        host_id: 1384013,
        host_name: "Paola, Dody E Raffaele",
        latitude: 45.43845,
        longitude: 12.33452,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33452, 45.43845]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39002507,
        name: "Canal-View Charming Apartment in central location",
        host_id: 12097452,
        host_name: "Lorenzo",
        latitude: 45.44262,
        longitude: 12.33751,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33751, 45.44262]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39024661,
        name: "Gemma a Venezia",
        host_id: 8524766,
        host_name: "Pietro",
        latitude: 45.44065,
        longitude: 12.32451,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32451, 45.44065]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39040234,
        name: "SPLENDIDA RESIDENZA SUITE subito PIAZZA SAN MARCO",
        host_id: 271809098,
        host_name: "Rosa",
        latitude: 45.43552,
        longitude: 12.34057,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34057, 45.43552]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39047433,
        name: "Flower artist Room Venice Casinò",
        host_id: 191226100,
        host_name: "Milo",
        latitude: 45.44373,
        longitude: 12.32769,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32769, 45.44373]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39048175,
        name: "Venice colour Room with kitchen in centre",
        host_id: 13500918,
        host_name: "Mark",
        latitude: 45.44397,
        longitude: 12.32759,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32759, 45.44397]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39050081,
        name: "The Secret Garden",
        host_id: 154170198,
        host_name: "Roberto",
        latitude: 45.43267,
        longitude: 12.32707,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32707, 45.43267]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39065580,
        name: "Terà Apartment",
        host_id: 24669207,
        host_name: "Milo",
        latitude: 45.44381,
        longitude: 12.3262,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3262, 45.44381]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39072609,
        name: "CARLO'S STUDIO IN VENICE",
        host_id: 299476862,
        host_name: "Sonia",
        latitude: 45.43676,
        longitude: 12.32967,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32967, 45.43676]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39074453,
        name: "Trearchi muro rosso apartment 三拱桥红墙公寓",
        host_id: 42184166,
        host_name: "Qian Yun千芸",
        latitude: 45.44558,
        longitude: 12.32141,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32141, 45.44558]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39074907,
        name: "A 2 passi dall'antico Ghetto, sestiere Cannaregio",
        host_id: 213535416,
        host_name: "Eleonora",
        latitude: 45.4475,
        longitude: 12.3203,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3203, 45.4475]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39076767,
        name: "LOFT PIAZZA S. MARCO small typical venetian house",
        host_id: 271809098,
        host_name: "Rosa",
        latitude: 45.43565,
        longitude: 12.34265,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34265, 45.43565]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39096697,
        name: "Rialto Corte del Sansoni - canal view, 2 bedroom",
        host_id: 289615,
        host_name: "Valentina",
        latitude: 45.43978,
        longitude: 12.33383,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33383, 45.43978]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39097335,
        name: "Relais San Marco  Deluxe room overlooks the Square",
        host_id: 296502604,
        host_name: "Relais",
        latitude: 45.43605,
        longitude: 12.33879,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33879, 45.43605]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39102120,
        name: "Lovely Room in Venice's center",
        host_id: 44194709,
        host_name: "Dafne",
        latitude: 45.43377,
        longitude: 12.3183,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3183, 45.43377]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39103552,
        name: "STATELY MANSION IN A NOBLE PALACE WITH CANAL VIEW",
        host_id: 299714239,
        host_name: "Guglielmo",
        latitude: 45.43968,
        longitude: 12.33879,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33879, 45.43968]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39105683,
        name: "Lovely room in Venice's center (n°2)",
        host_id: 44194709,
        host_name: "Dafne",
        latitude: 45.43362,
        longitude: 12.31842,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31842, 45.43362]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39129948,
        name: "Luxury Flat in Perfect Location",
        host_id: 11695804,
        host_name: "Kathleen",
        latitude: 45.43263,
        longitude: 12.3265,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3265, 45.43263]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39133562,
        name: "Stylish BIENNALE Huge Balconies Open Views!",
        host_id: 2718137,
        host_name: "DaPonte",
        latitude: 45.4326,
        longitude: 12.34975,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34975, 45.4326]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39151055,
        name: "Luxurious & Cozy Apt. San Marco Square, WiFi",
        host_id: 257926874,
        host_name: "Andrea",
        latitude: 45.43224,
        longitude: 12.33204,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33204, 45.43224]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39151768,
        name: "Charming penthouse behind San Marco",
        host_id: 85278182,
        host_name: "Stefania",
        latitude: 45.43614,
        longitude: 12.34661,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34661, 45.43614]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39167931,
        name: "Cozy & Comfortable Apt. San Marco Square, WiFi",
        host_id: 257926874,
        host_name: "Andrea",
        latitude: 45.43162,
        longitude: 12.33278,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33278, 45.43162]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39168628,
        name: 'Luxurious & Spacious Apt. San Marco Square "WiFi"',
        host_id: 257926874,
        host_name: "Andrea",
        latitude: 45.43314,
        longitude: 12.33405,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33405, 45.43314]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39169774,
        name: "Cozy & NEAR Santa Lucia Train  ☆Wifi ☆Smart TV☆",
        host_id: 260539153,
        host_name: "July",
        latitude: 45.43289,
        longitude: 12.32171,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32171, 45.43289]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39187748,
        name: "Ca’ Anna Rialto Apartment",
        host_id: 5862083,
        host_name: "Silvia",
        latitude: 45.44,
        longitude: 12.33787,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33787, 45.44]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39191043,
        name: "Artistic house - vista su canale, Dorsoduro",
        host_id: 29851621,
        host_name: "Marta",
        latitude: 45.4337,
        longitude: 12.32155,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32155, 45.4337]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39194939,
        name: "Private apartment for two in the heart of Venice",
        host_id: 237795682,
        host_name: "Marc&Bi",
        latitude: 45.44392,
        longitude: 12.32754,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32754, 45.44392]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39198203,
        name: "NEW YEAR Celebration 2020 in THEE CENTRE of Venice",
        host_id: 835558,
        host_name: "Nikita",
        latitude: 45.43441,
        longitude: 12.33385,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33385, 45.43441]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39202392,
        name: "La Renaissance de Madame Irene",
        host_id: 300819280,
        host_name: "Irene",
        latitude: 45.433181104033537,
        longitude: 12.325779599168696,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32578, 45.43318]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39220567,
        name: "Vicino a San Marco, un  quieto angolo veneziano.",
        host_id: 13094721,
        host_name: "Donatella",
        latitude: 45.42459,
        longitude: 12.33177,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33177, 45.42459]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39223592,
        name:
          "Spacious Venetian style apartment with free wifi & full kitchen!",
        host_id: 4339678,
        host_name: "Vacasa Italy - Venice",
        latitude: 45.43357,
        longitude: 12.34936,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34936, 45.43357]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39246594,
        name: "Piazza San Marco - Cozy and warm apartment",
        host_id: 301271745,
        host_name: "Stefania Francesca",
        latitude: 45.43303,
        longitude: 12.33374,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33374, 45.43303]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39287285,
        name: "San Marco Gallery (80m from St Mark's Square)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.43443,
        longitude: 12.33889,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33889, 45.43443]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39292523,
        name: "Shabby chic room",
        host_id: 301666307,
        host_name: "Judy",
        latitude: 45.43903,
        longitude: 12.32638,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32638, 45.43903]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39298847,
        name: "Ca' delle Pizzocchere, a perfect spot in San Marco",
        host_id: 12113015,
        host_name: "Mario",
        latitude: 45.43394,
        longitude: 12.33163,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33163, 45.43394]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39307840,
        name: "Ca'Doge Grand Canal",
        host_id: 22921103,
        host_name: "Andrea",
        latitude: 45.43629,
        longitude: 12.32656,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32656, 45.43629]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39311570,
        name: "Ca' Teresa Arsenale-San Marco-Biennale",
        host_id: 9290329,
        host_name: "Michela",
        latitude: 45.4329,
        longitude: 12.35056,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35056, 45.4329]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39312344,
        name: "Domus Croce Apartment",
        host_id: 212763422,
        host_name: "Jessica",
        latitude: 45.438,
        longitude: 12.32993,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32993, 45.438]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39315702,
        name: "QUIET RETREAT near RIALTO with CANAL VIEW",
        host_id: 159289574,
        host_name: "Monica+Nadia",
        latitude: 45.43768,
        longitude: 12.33702,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33702, 45.43768]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39315759,
        name: "Ca' Melidissa",
        host_id: 259823358,
        host_name: "Giovanna",
        latitude: 45.43249,
        longitude: 12.35295,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35295, 45.43249]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39329674,
        name: "Ca' Olga",
        host_id: 189963665,
        host_name: "Stm Costruzioni",
        latitude: 45.44081,
        longitude: 12.33433,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33433, 45.44081]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39332252,
        name: "Muse Studio",
        host_id: 302095566,
        host_name: "Tatiana",
        latitude: 45.44193,
        longitude: 12.32916,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32916, 45.44193]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39337343,
        name: "Romantic rooftop with ensuite tub",
        host_id: 22921103,
        host_name: "Andrea",
        latitude: 45.43606,
        longitude: 12.32704,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32704, 45.43606]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39338025,
        name: "Venice court Grand Canal with jacuzzi showers",
        host_id: 22921103,
        host_name: "Andrea",
        latitude: 45.43666,
        longitude: 12.32812,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32812, 45.43666]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39338631,
        name: "Venice luxury rooftop Grand Canal",
        host_id: 22921103,
        host_name: "Andrea",
        latitude: 45.43636,
        longitude: 12.32675,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32675, 45.43636]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39353773,
        name: "Exclusive proposal, design and deluxe flat",
        host_id: 302281234,
        host_name: "Paolo",
        latitude: 45.42425,
        longitude: 12.3255,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3255, 45.42425]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39357522,
        name: "Venice downtown city center. 4 pax.",
        host_id: 68564211,
        host_name: "Valentina",
        latitude: 45.44502,
        longitude: 12.32387,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32387, 45.44502]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39357632,
        name: "Light and lagoon",
        host_id: 302303212,
        host_name: "Marzia",
        latitude: 45.43572,
        longitude: 12.33437,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33437, 45.43572]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39379450,
        name: "Ca' Del Santo",
        host_id: 669047,
        host_name: "Viewsonvenice",
        latitude: 45.43457,
        longitude: 12.34761,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34761, 45.43457]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39379920,
        name: "CoZy House close to Biennale and St. Mark's Square",
        host_id: 302482634,
        host_name: "Armanda",
        latitude: 45.43146,
        longitude: 12.35887,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35887, 45.43146]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39381291,
        name: "Apt. Ca' Puccetti (350mt from Rialto's Bridge)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.44022,
        longitude: 12.33977,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33977, 45.44022]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39384737,
        name:
          "APPARTAMENTO PARADISO - CA' GIULIA-id. M (Phone number hidden by Airbnb)",
        host_id: 208021374,
        host_name: "Giulia",
        latitude: 45.44222,
        longitude: 12.34052,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34052, 45.44222]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39402725,
        name: "Live Your Time Travel in the ♡ of Venice!",
        host_id: 302463824,
        host_name: "Giovanni",
        latitude: 45.4382,
        longitude: 12.34239,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34239, 45.4382]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39407769,
        name: "Secret Garden apartments",
        host_id: 302693591,
        host_name: "Martina",
        latitude: 45.42599,
        longitude: 12.34008,
        beds: 8,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34008, 45.42599]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39409001,
        name: "STUDIO WITH TERRACE",
        host_id: 285989536,
        host_name: "Andrea",
        latitude: 45.43744,
        longitude: 12.33905,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33905, 45.43744]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39428378,
        name: "Large studio apartment, 3 minutes from St.Mark's",
        host_id: 15178567,
        host_name: "Paolo",
        latitude: 45.43847,
        longitude: 12.34662,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34662, 45.43847]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39430444,
        name: "Spacious Penthouse 5 min Train station - Rialto",
        host_id: 273283215,
        host_name: "Host",
        latitude: 45.43942,
        longitude: 12.3267,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3267, 45.43942]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39430489,
        name: "Superb Rialto Apartment 2 Steps from San Marco",
        host_id: 273283215,
        host_name: "Host",
        latitude: 45.43545,
        longitude: 12.33574,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33574, 45.43545]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39430516,
        name: "S.Pantalon 2 steps from Rialto, San Marco, Station",
        host_id: 273283215,
        host_name: "Host",
        latitude: 45.43463,
        longitude: 12.32441,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32441, 45.43463]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39430545,
        name: "Ca' della Regina Venezia S. Marco",
        host_id: 273283215,
        host_name: "Host",
        latitude: 45.43914,
        longitude: 12.33092,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33092, 45.43914]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39430631,
        name: "Monolocale con balcone e vista su campo",
        host_id: 6304868,
        host_name: "Roberta",
        latitude: 45.43856,
        longitude: 12.33872,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33872, 45.43856]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39430764,
        name: "Hotel Herion - double room 1C",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.44183,
        longitude: 12.32894,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32894, 45.44183]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39436064,
        name: "Ca' Dei Da Mosto Studio x2 AUTHENTIC VENICE",
        host_id: 96221395,
        host_name: "Welcome To Veneto & Friuli",
        latitude: 45.44339,
        longitude: 12.32635,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32635, 45.44339]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39454678,
        name: "Venice Luxury Terrace and Balcony View San Marco",
        host_id: 13012838,
        host_name: "Paola",
        latitude: 45.43427,
        longitude: 12.35107,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35107, 45.43427]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39462939,
        name: "Apartment Calle Raspi",
        host_id: 303124344,
        host_name: "Dimitri & Valentina",
        latitude: 45.43875,
        longitude: 12.33169,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33169, 45.43875]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39477493,
        name: "Luna's bedroom",
        host_id: 303243815,
        host_name: "Anina",
        latitude: 45.441,
        longitude: 12.32853,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32853, 45.441]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39479715,
        name: "La stanza di Luna",
        host_id: 301308509,
        host_name: "Serena",
        latitude: 45.44105,
        longitude: 12.3276,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3276, 45.44105]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39480397,
        name: "Donna Mathilde apt",
        host_id: 303268623,
        host_name: "Rosanna",
        latitude: 45.43506,
        longitude: 12.33239,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33239, 45.43506]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39491758,
        name: "The soul of Venice",
        host_id: 6019189,
        host_name: "Federico",
        latitude: 45.4369,
        longitude: 12.34756,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34756, 45.4369]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39503591,
        name: "Cozy Bedroom Venice City Center",
        host_id: 303243815,
        host_name: "Anina",
        latitude: 45.43982,
        longitude: 12.32712,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32712, 45.43982]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39523064,
        name: "New design apartment quite place",
        host_id: 303642748,
        host_name: "Barbara",
        latitude: 45.4325,
        longitude: 12.35562,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35562, 45.4325]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39523201,
        name: "Il nostro è un appartamento spazioso e luminoso.",
        host_id: 204950732,
        host_name: "Carla",
        latitude: 45.43552,
        longitude: 12.32195,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32195, 45.43552]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39526841,
        name: "Camera Matrimoniale zona Rialto",
        host_id: 252870578,
        host_name: "Federico",
        latitude: 45.43968,
        longitude: 12.33351,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33351, 45.43968]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39542311,
        name: "Cannaregio Double Room with Ensuite small Bathroom",
        host_id: 196333156,
        host_name: "Michele Udi",
        latitude: 45.44612,
        longitude: 12.32397,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32397, 45.44612]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39543092,
        name: "Arsenale View Bright White Loft",
        host_id: 303819792,
        host_name: "Marina",
        latitude: 45.43342,
        longitude: 12.35037,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35037, 45.43342]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39544972,
        name: "Residenza San Marco",
        host_id: 632312,
        host_name: "Guillaume",
        latitude: 45.43654,
        longitude: 12.33554,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33554, 45.43654]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39557774,
        name: "To be relax in Venice. A",
        host_id: 303938866,
        host_name: "Matthew",
        latitude: 45.43393,
        longitude: 12.35635,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35635, 45.43393]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39584578,
        name: "La Perla Grigia",
        host_id: 56593037,
        host_name: "Daniela",
        latitude: 45.44752,
        longitude: 12.33024,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33024, 45.44752]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39584790,
        name: "To be relax in Venice. B",
        host_id: 303938866,
        host_name: "Matthew",
        latitude: 45.43263,
        longitude: 12.35637,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35637, 45.43263]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39594972,
        name: "Ca Guglie - 2 steps from the Station and Vaporetto",
        host_id: 139627704,
        host_name: "Giusy & Fabrizio",
        latitude: 45.44421,
        longitude: 12.3252,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3252, 45.44421]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39597903,
        name: "GUESTHOUSE40.17 SANMARCO MORETA ECONOMY SMALL ROOM",
        host_id: 268516722,
        host_name: "40.17sanmarco",
        latitude: 45.43562,
        longitude: 12.33275,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33275, 45.43562]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39597951,
        name: "GUESTHOUSE 40.17 SANMARCO CORALLINA DELUXE ROOM",
        host_id: 268516722,
        host_name: "40.17sanmarco",
        latitude: 45.43568,
        longitude: 12.33413,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33413, 45.43568]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39598177,
        name: "GUESTHOUSE40.17SANMARCO PANTALON DOUBLE STANDARD",
        host_id: 268516722,
        host_name: "40.17sanmarco",
        latitude: 45.43423,
        longitude: 12.33291,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33291, 45.43423]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39605647,
        name: "40.17SANMARCO SUITE CASANOVA VIEW CANAL/GONDOLA",
        host_id: 268516722,
        host_name: "40.17sanmarco",
        latitude: 45.43567,
        longitude: 12.3332,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3332, 45.43567]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39605785,
        name: "40.17 SANMARCO SUITE COLOMBINA VIEW ON THE WATER",
        host_id: 268516722,
        host_name: "40.17sanmarco",
        latitude: 45.43407,
        longitude: 12.33233,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33233, 45.43407]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39606075,
        name: "Elegant appartament la bauta",
        host_id: 224805962,
        host_name: "Elisabetta",
        latitude: 45.44026,
        longitude: 12.34098,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34098, 45.44026]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39616651,
        name: "ROMANTICO STUDIO DE LUXE",
        host_id: 24889853,
        host_name: "Sandra",
        latitude: 45.43744,
        longitude: 12.34051,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34051, 45.43744]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39626910,
        name: "21 STEPS FROM RIALTO BRIDGE!!!!",
        host_id: 41559211,
        host_name: "Venice",
        latitude: 45.43742,
        longitude: 12.33295,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33295, 45.43742]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39641535,
        name: "Palazzo DaPonte up to 8 people",
        host_id: 2718137,
        host_name: "DaPonte",
        latitude: 45.43743,
        longitude: 12.33846,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33846, 45.43743]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39644023,
        name: "Fenix Turandot Penthouse",
        host_id: 203929414,
        host_name: "Fenix",
        latitude: 45.43299,
        longitude: 12.3504,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3504, 45.43299]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39651191,
        name: "APARTMENT WITH TERRACE 2",
        host_id: 285989536,
        host_name: "Andrea",
        latitude: 45.43733,
        longitude: 12.33965,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33965, 45.43733]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39651648,
        name: "TERRAZZA APARTMENTS 1 & 2",
        host_id: 285989536,
        host_name: "Andrea",
        latitude: 45.43759,
        longitude: 12.33843,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33843, 45.43759]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39661627,
        name: "Gorgeous canal view apartment/ Venice city centre",
        host_id: 231775592,
        host_name: "Judite & Beatrice",
        latitude: 45.44127,
        longitude: 12.34022,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34022, 45.44127]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39666291,
        name: "Accogliente appartamento nel centro di Venezia",
        host_id: 304850397,
        host_name: "Fiorella",
        latitude: 45.438,
        longitude: 12.32737,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32737, 45.438]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39680786,
        name: "40.17 SANMARCO DOUBLE ROOM WITH BALCON",
        host_id: 268516722,
        host_name: "40.17sanmarco",
        latitude: 45.43607,
        longitude: 12.33452,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33452, 45.43607]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39686632,
        name: "Cannaregio Double Room with Ensuite Bathroom 1",
        host_id: 196333156,
        host_name: "Michele Udi",
        latitude: 45.44504,
        longitude: 12.32185,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32185, 45.44504]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39687471,
        name: "Cannaregio Double Room with Ensuite Bathroom",
        host_id: 196333156,
        host_name: "Michele Udi",
        latitude: 45.44609,
        longitude: 12.32352,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32352, 45.44609]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39740936,
        name: "splendid widman",
        host_id: 1426634,
        host_name: "Claudia E Giorgio",
        latitude: 45.44014,
        longitude: 12.34064,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34064, 45.44014]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39750531,
        name: "Appartamento di lusso Venezia 3bd spazioso",
        host_id: 305520267,
        host_name: "Cataldo",
        latitude: 45.43345,
        longitude: 12.33643,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33643, 45.43345]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39757775,
        name: "Ca' Baglioni, intero appartamento",
        host_id: 187962482,
        host_name: "Morena",
        latitude: 45.43821,
        longitude: 12.33224,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33224, 45.43821]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39768484,
        name: "RESIDENCE IN A NOBLE PALACE IN THE VENICE'S EARTH.",
        host_id: 299714239,
        host_name: "Guglielmo",
        latitude: 45.43877,
        longitude: 12.34027,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34027, 45.43877]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39769189,
        name: "Muneghete Suite in Cinqueteste Luxury Home",
        host_id: 246529758,
        host_name: "Lisia",
        latitude: 45.43907,
        longitude: 12.32392,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32392, 45.43907]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39784449,
        name: "Cà Milla",
        host_id: 223405847,
        host_name: "Roberta",
        latitude: 45.44741,
        longitude: 12.32812,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32812, 45.44741]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39784999,
        name: "Ca' Ferrari, tranquility and comfort in Venice",
        host_id: 106583012,
        host_name: "Giorgio",
        latitude: 45.44349,
        longitude: 12.33486,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33486, 45.44349]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39789890,
        name: "Lo Bortolo: 50 steps from the Rialto's Bridge.",
        host_id: 299714239,
        host_name: "Guglielmo",
        latitude: 45.4363,
        longitude: 12.33642,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33642, 45.4363]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39792585,
        name: "CA' ORSO apt near RIALTO with CANAL VIEW",
        host_id: 159289574,
        host_name: "Monica+Nadia",
        latitude: 45.4376,
        longitude: 12.33747,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33747, 45.4376]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39800722,
        name: "Al Campanile: Appartamento Monolocale B2",
        host_id: 394892,
        host_name: "Hossep",
        latitude: 45.44699,
        longitude: 12.33215,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33215, 45.44699]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39808007,
        name: "Colombina Suite in Cinqueteste Luxury Home",
        host_id: 246529758,
        host_name: "Lisia",
        latitude: 45.43751,
        longitude: 12.32276,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32276, 45.43751]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39812198,
        name: "Sant Angelo - Fenice Apartments in Venice",
        host_id: 32253239,
        host_name: "Fenice Hotels",
        latitude: 45.43336,
        longitude: 12.33187,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33187, 45.43336]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39813815,
        name: "Lo 559: Lovely flat lulled by the Rialto's hearth.",
        host_id: 299714239,
        host_name: "Guglielmo",
        latitude: 45.43942,
        longitude: 12.33489,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33489, 45.43942]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39817260,
        name: "Room in Venice",
        host_id: 369642,
        host_name: "Valter",
        latitude: 45.44181,
        longitude: 12.32661,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32661, 45.44181]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39829705,
        name: "New , 2 floors apartment old style",
        host_id: 303642748,
        host_name: "Barbara",
        latitude: 45.43203,
        longitude: 12.35518,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35518, 45.43203]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39831434,
        name: "Casa Zadam",
        host_id: 14432675,
        host_name: "Silvia",
        latitude: 45.43834,
        longitude: 12.33238,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33238, 45.43834]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39849297,
        name: "Ca' dei Fuseri 4",
        host_id: 7325760,
        host_name: "Stefano",
        latitude: 45.43404,
        longitude: 12.33627,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33627, 45.43404]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39852764,
        name: "CA ALMA BIENNALE HOME WI FI FREE",
        host_id: 21797121,
        host_name: "Thomas",
        latitude: 45.43244,
        longitude: 12.35365,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35365, 45.43244]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39857726,
        name: "Ampio appartamento in centro Venezia",
        host_id: 242663651,
        host_name: "Guesthero",
        latitude: 45.43993,
        longitude: 12.32961,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32961, 45.43993]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39861404,
        name: "Rialto Central Modern&Cozy apt CourtView Wifi/AC",
        host_id: 255326628,
        host_name: "Gio",
        latitude: 45.4393,
        longitude: 12.33684,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33684, 45.4393]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39861865,
        name: "Canal View, Appartmento  Ai Greci",
        host_id: 60488055,
        host_name: "Marco & Andrea",
        latitude: 45.43763,
        longitude: 12.34577,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34577, 45.43763]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39863196,
        name: "Cà Falier Apartment 1",
        host_id: 276201478,
        host_name: "Davide",
        latitude: 45.43669,
        longitude: 12.32384,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32384, 45.43669]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39868558,
        name: "DELUXE RIALTO 3 BEDROOM FLAT",
        host_id: 307007425,
        host_name: "Moreno",
        latitude: 45.43809,
        longitude: 12.33018,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33018, 45.43809]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39868916,
        name: '"Rose Apartment-Room1" canal view, San Marco &LIFT',
        host_id: 159746853,
        host_name: "Giulia",
        latitude: 45.43516,
        longitude: 12.3473,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3473, 45.43516]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39882499,
        name: "Ca' Turlona",
        host_id: 294951,
        host_name: "VeniceVillas Di Enzo",
        latitude: 45.44689,
        longitude: 12.32741,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32741, 45.44689]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39891377,
        name: "Antiques Filled Venetian Apartment",
        host_id: 11931743,
        host_name: "Toma",
        latitude: 45.43268,
        longitude: 12.32987,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32987, 45.43268]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39907998,
        name: "Ca' del Pozzo Loft Apartment",
        host_id: 307486637,
        host_name: "Eleonora",
        latitude: 45.4397,
        longitude: 12.33686,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33686, 45.4397]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39917106,
        name: "LionHost Ancore 1 #Biennale",
        host_id: 141282928,
        host_name: "Thomas",
        latitude: 45.43298,
        longitude: 12.35474,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35474, 45.43298]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39917127,
        name: "LionHost Ancore 2 #Biennale",
        host_id: 141282928,
        host_name: "Thomas",
        latitude: 45.4331,
        longitude: 12.35549,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35549, 45.4331]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39935647,
        name: "LionHost Ancore up to 8 persons",
        host_id: 141282928,
        host_name: "Thomas",
        latitude: 45.43201,
        longitude: 12.35708,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35708, 45.43201]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39958651,
        name: "Ca' Samuele",
        host_id: 169463063,
        host_name: "Carlo",
        latitude: 45.44029,
        longitude: 12.33511,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33511, 45.44029]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39959054,
        name: "Venice Sweet Home Double Room",
        host_id: 13027859,
        host_name: "Diego",
        latitude: 45.4399,
        longitude: 12.3163,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3163, 45.4399]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39961857,
        name: "Venice Sweet Home Double Room 2",
        host_id: 13027859,
        host_name: "Diego",
        latitude: 45.44678,
        longitude: 12.32256,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32256, 45.44678]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39962187,
        name: "Venice Sweet Home Single Room",
        host_id: 13027859,
        host_name: "Diego",
        latitude: 45.44463,
        longitude: 12.32156,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32156, 45.44463]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39980696,
        name: "Luxury Ca D'Oro",
        host_id: 136039108,
        host_name: "Giulia",
        latitude: 45.44109,
        longitude: 12.33381,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33381, 45.44109]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39981407,
        name: "Cozy Double on the Fondamenta",
        host_id: 308258686,
        host_name: "Josh",
        latitude: 45.44228,
        longitude: 12.34014,
        beds: null,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34014, 45.44228]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39982816,
        name: "Doge's Palace Suite R&R",
        host_id: 173200514,
        host_name: "Rent&Relax",
        latitude: 45.43538,
        longitude: 12.3405,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3405, 45.43538]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39990155,
        name: "“Rose Apartmnet” Room2 , in San Marco with LIFT!!",
        host_id: 159746853,
        host_name: "Giulia",
        latitude: 45.4349,
        longitude: 12.34503,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34503, 45.4349]] },
    },
    {
      type: "Feature",
      properties: {
        id: 39993989,
        name: "“Rose Apartment” Room3, 5 min San Marco, with LIFT",
        host_id: 159746853,
        host_name: "Giulia",
        latitude: 45.43618,
        longitude: 12.34647,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34647, 45.43618]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40021587,
        name: "Grande Terrazza - Dorsoduro Venezia Procuratie",
        host_id: 139627704,
        host_name: "Giusy & Fabrizio",
        latitude: 45.43457,
        longitude: 12.31882,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31882, 45.43457]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40024306,
        name: "Giudecca Sky Apartment",
        host_id: 151652480,
        host_name: "Francesca",
        latitude: 45.42553,
        longitude: 12.32343,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32343, 45.42553]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40029635,
        name: "Double Room 5 min from train station",
        host_id: 118683310,
        host_name: "Elisa Sara",
        latitude: 45.43853,
        longitude: 12.32948,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32948, 45.43853]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40031799,
        name: "Indimenticabile Venezia San Marco a due passi",
        host_id: 105180859,
        host_name: "Maria Grazia",
        latitude: 45.43316,
        longitude: 12.33313,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33313, 45.43316]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40034884,
        name: "El va El Vien",
        host_id: 4628341,
        host_name: "Camilla",
        latitude: 45.43263,
        longitude: 12.32558,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32558, 45.43263]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40045852,
        name: "Appartamento tra laguna e tetti",
        host_id: 5128717,
        host_name: "Alvise",
        latitude: 45.44687,
        longitude: 12.33314,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33314, 45.44687]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40057340,
        name: "Venice Gallery",
        host_id: 46904188,
        host_name: "Mirco Optyflat",
        latitude: 45.43993,
        longitude: 12.34224,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34224, 45.43993]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40057910,
        name: "Il Pozzo Magico",
        host_id: 46904188,
        host_name: "Mirco Optyflat",
        latitude: 45.44074,
        longitude: 12.32922,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32922, 45.44074]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40077728,
        name: "✴Enjoy my Fanciful House in Giudecca✴",
        host_id: 308955837,
        host_name: "Ilaria",
        latitude: 45.42676,
        longitude: 12.33847,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33847, 45.42676]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40106788,
        name: "Palace Fosca Prestige Terrace",
        host_id: 309509614,
        host_name: "City Apartments Prestige",
        latitude: 45.44245,
        longitude: 12.33205,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33205, 45.44245]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40123698,
        name: "Apartment Altana Prestige",
        host_id: 309509614,
        host_name: "City Apartments Prestige",
        latitude: 45.44006,
        longitude: 12.32344,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32344, 45.44006]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40124678,
        name: "Apartment Grand Canal Terrace (Loft )",
        host_id: 309509614,
        host_name: "City Apartments Prestige",
        latitude: 45.43718,
        longitude: 12.33049,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33049, 45.43718]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40189098,
        name: "La casa dell'architetto, design e deluxe flat",
        host_id: 302281234,
        host_name: "Paolo",
        latitude: 45.42456,
        longitude: 12.32715,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32715, 45.42456]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40190700,
        name: "VELVET FLAT",
        host_id: 39900949,
        host_name: "Enrico",
        latitude: 45.44593,
        longitude: 12.33342,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33342, 45.44593]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40207987,
        name: "SanMarco1658 Apt.Suite 31 - in the earth of Venice",
        host_id: 294840606,
        host_name: "Ettore",
        latitude: 45.43356,
        longitude: 12.33399,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33399, 45.43356]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40209444,
        name: "SanMarco1658 Suite 32 - in the earth of Venice",
        host_id: 294840606,
        host_name: "Ettore",
        latitude: 45.43458,
        longitude: 12.33458,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33458, 45.43458]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40209648,
        name: "SanMarco1658 Jr. Suite 33 - in the earth of Venice",
        host_id: 294840606,
        host_name: "Ettore",
        latitude: 45.43291,
        longitude: 12.33594,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33594, 45.43291]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40217658,
        name: "El va el vien b&b",
        host_id: 4628341,
        host_name: "Camilla",
        latitude: 45.43189,
        longitude: 12.32408,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32408, 45.43189]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40223688,
        name: "Hotel Herion - 4A Matrimoniale Standard",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.44327,
        longitude: 12.32912,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32912, 45.44327]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40284784,
        name: "Intero Appartamento Rialto Centro",
        host_id: 44194709,
        host_name: "Dafne",
        latitude: 45.43879,
        longitude: 12.33555,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33555, 45.43879]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40335639,
        name: "CANNAREGIO 3341",
        host_id: 311703445,
        host_name: "Veronica",
        latitude: 45.44494,
        longitude: 12.33181,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33181, 45.44494]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40357883,
        name: "La Malvasia",
        host_id: 56593037,
        host_name: "Daniela",
        latitude: 45.43913,
        longitude: 12.34019,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34019, 45.43913]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40358158,
        name: 'Design House"alla Biennale"',
        host_id: 290252285,
        host_name: "Debora",
        latitude: 45.43207,
        longitude: 12.35738,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35738, 45.43207]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40361042,
        name: "La Bissa",
        host_id: 56593037,
        host_name: "Daniela",
        latitude: 45.43831,
        longitude: 12.33719,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33719, 45.43831]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40361807,
        name: "Wonderful view over Venetian Lagoon",
        host_id: 5862083,
        host_name: "Silvia",
        latitude: 45.42423,
        longitude: 12.32618,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32618, 45.42423]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40363052,
        name: "VENICE SUITE DORSODURO",
        host_id: 264096231,
        host_name: "Loredana",
        latitude: 45.43206,
        longitude: 12.32421,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32421, 45.43206]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40371705,
        name: "Ca' Angiolo ai Frari",
        host_id: 260537263,
        host_name: "Angiolo",
        latitude: 45.4361,
        longitude: 12.32749,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32749, 45.4361]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40373148,
        name: '"Rose Apartment", San Marco, spacious with LIFT',
        host_id: 159746853,
        host_name: "Giulia",
        latitude: 45.43487,
        longitude: 12.34518,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34518, 45.43487]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40384813,
        name: "Il Giardino di Giulia B&B, Venice, Tangerine room",
        host_id: 312166502,
        host_name: "Marco",
        latitude: 45.43981,
        longitude: 12.32553,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32553, 45.43981]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40386983,
        name: "LionHost Ruga Giuffa 4834 #SanMarco",
        host_id: 166297081,
        host_name: "Thomas",
        latitude: 45.43766,
        longitude: 12.34322,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34322, 45.43766]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40391339,
        name: "out from the crowd 1",
        host_id: 143699747,
        host_name: "Matteo",
        latitude: 45.43123,
        longitude: 12.32486,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32486, 45.43123]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40398778,
        name: "out from the crowd 2",
        host_id: 143699747,
        host_name: "Matteo",
        latitude: 45.43248,
        longitude: 12.31976,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31976, 45.43248]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40410937,
        name: "Apt. Panoramic Terrace - Amazing City View",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.43428,
        longitude: 12.32617,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32617, 45.43428]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40419856,
        name: "Corte della Pietà apartment in the heart of Venice",
        host_id: 7665431,
        host_name: "Pierre",
        latitude: 45.43692,
        longitude: 12.34778,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34778, 45.43692]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40426288,
        name: "CA' ELEONORA",
        host_id: 312628153,
        host_name: "Antonio",
        latitude: 45.43938,
        longitude: 12.32888,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32888, 45.43938]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40437093,
        name: "LUNA APARTMENT 5/6 POSTI 5 M. DA RIALTO - CENTRALE",
        host_id: 312776064,
        host_name: "Claudia",
        latitude: 45.4401,
        longitude: 12.33854,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33854, 45.4401]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40438797,
        name: "Casa Raquel. Splendida vista su Venezia",
        host_id: 312771387,
        host_name: "Nicola",
        latitude: 45.43697,
        longitude: 12.33943,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33943, 45.43697]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40444065,
        name: "Ca' Lorenzo con vista su Campo Santa Maria Formosa",
        host_id: 312771387,
        host_name: "Nicola",
        latitude: 45.43857,
        longitude: 12.33955,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33955, 45.43857]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40469116,
        name: "Cozy room",
        host_id: 203325897,
        host_name: "Aliye",
        latitude: 45.44601,
        longitude: 12.32227,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32227, 45.44601]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40478999,
        name: "Calle dei Meloni -",
        host_id: 7665431,
        host_name: "Pierre",
        latitude: 45.43993,
        longitude: 12.34032,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34032, 45.43993]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40479052,
        name: "Guesthouse Al Profeta - Camera 4",
        host_id: 59950737,
        host_name: "Simone",
        latitude: 45.43965,
        longitude: 12.33797,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33797, 45.43965]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40487481,
        name: "Sunny room",
        host_id: 203325897,
        host_name: "Aliye",
        latitude: 45.4463,
        longitude: 12.32307,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32307, 45.4463]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40498328,
        name: "Luxury Apartment Prince-Suite new Venezia SanMarco",
        host_id: 2785704,
        host_name: "Giancarlo",
        latitude: 45.44565,
        longitude: 12.33391,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33391, 45.44565]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40507678,
        name: "SHOME LUXURY APARTMENT live the authentic Venice!",
        host_id: 313603214,
        host_name: "Caterina",
        latitude: 45.43873,
        longitude: 12.32089,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32089, 45.43873]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40509016,
        name: "natale e capodanno a Venezia",
        host_id: 1688982,
        host_name: "Elio",
        latitude: 45.43307,
        longitude: 12.33381,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33381, 45.43307]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40522407,
        name: "CA’ AMALIA SAN MARCO VENETIAN APARTMENT",
        host_id: 5862083,
        host_name: "Silvia",
        latitude: 45.43641,
        longitude: 12.33745,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33745, 45.43641]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40528884,
        name: "Hotel Antiche Figure - Superior Double",
        host_id: 313797107,
        host_name: "Hotel Antiche",
        latitude: 45.43915,
        longitude: 12.32125,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32125, 45.43915]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40532355,
        name:
          "Ca' Teresa Roof Terrace Deluxe (cod. M (Phone number hidden by Airbnb)",
        host_id: 312880835,
        host_name: "Fabio & Teresa",
        latitude: 45.43299,
        longitude: 12.32943,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32943, 45.43299]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40544607,
        name: "ROOM WITH TERRACE TO ENJOY A REAL LOCAL EXPERIENCE",
        host_id: 5113473,
        host_name: "Sara E Giovanni",
        latitude: 45.4418,
        longitude: 12.3273,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3273, 45.4418]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40554360,
        name: "Charming house with private garden",
        host_id: 314161099,
        host_name: "Sebastiano",
        latitude: 45.43167,
        longitude: 12.32778,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32778, 45.43167]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40560476,
        name: "Santa Lucia, Modern & Large Venetian Home! 3 rooms",
        host_id: 259039981,
        host_name: "Michele",
        latitude: 45.44278,
        longitude: 12.3251,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3251, 45.44278]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40562325,
        name: "IN VENICE",
        host_id: 313511918,
        host_name: "Jacob",
        latitude: 45.44165,
        longitude: 12.33244,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33244, 45.44165]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40575038,
        name: "Apartment Traghetto Amazing Terrace",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.42996,
        longitude: 12.33426,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33426, 45.42996]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40611594,
        name: "Fondamente Nove, Charming Venetian Apartment!",
        host_id: 218260862,
        host_name: "Alessio",
        latitude: 45.44329,
        longitude: 12.3393,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3393, 45.44329]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40637113,
        name: "Luxury Queen-Suite new  Venezia San Marco",
        host_id: 2785704,
        host_name: "Giancarlo",
        latitude: 45.4451,
        longitude: 12.33285,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33285, 45.4451]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40648348,
        name: "Ormesini Double bed room with shared bathroom",
        host_id: 196333156,
        host_name: "Michele Udi",
        latitude: 45.44725,
        longitude: 12.32805,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32805, 45.44725]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40648750,
        name: "Biennale Venice Charme Apartment",
        host_id: 267288660,
        host_name: "Enzo",
        latitude: 45.43169,
        longitude: 12.35295,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35295, 45.43169]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40651262,
        name: "Sweet Venice Apartment",
        host_id: 313794485,
        host_name: "Tommy",
        latitude: 45.4408,
        longitude: 12.32962,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32962, 45.4408]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40656460,
        name:
          "Квартира в центре Венеции 4-6 спальных места Appartamento in centro di Venezia 4-6 posti da letto",
        host_id: 256936488,
        host_name: "Larisa",
        latitude: 45.43464,
        longitude: 12.31686,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.31686, 45.43464]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40669146,
        name: "Double room with private external bathroom",
        host_id: 218728234,
        host_name: "Emanuele",
        latitude: 45.43434,
        longitude: 12.34891,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34891, 45.43434]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40699099,
        name: "Camera Familiare Vista Canale, Bagno Condiviso",
        host_id: 17684080,
        host_name: "Rupu",
        latitude: 45.43451,
        longitude: 12.34477,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34477, 45.43451]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40699794,
        name: "Camera Twin con Bagno Condiviso",
        host_id: 17684080,
        host_name: "Rupu",
        latitude: 45.43447,
        longitude: 12.34483,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34483, 45.43447]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40703860,
        name: "NEW ROOM TO ENJOY A LOCAL EXPERIENCE IN VENICE",
        host_id: 5113473,
        host_name: "Sara E Giovanni",
        latitude: 45.44108,
        longitude: 12.3278,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3278, 45.44108]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40706129,
        name: "Grand Casa delle Gondole",
        host_id: 199296796,
        host_name: "Pietro",
        latitude: 45.43226,
        longitude: 12.32517,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32517, 45.43226]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40727494,
        name: "Dorm Female Only",
        host_id: 17684080,
        host_name: "Rupu",
        latitude: 45.43616,
        longitude: 12.34354,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34354, 45.43616]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40748129,
        name: "Venice Mirrors Luxury Apartment",
        host_id: 98034168,
        host_name: "Andrea",
        latitude: 45.43339,
        longitude: 12.33158,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33158, 45.43339]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40769396,
        name: "CA' ZIA MARIA",
        host_id: 316721925,
        host_name: "Nicoletta",
        latitude: 45.43368,
        longitude: 12.32353,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32353, 45.43368]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40772933,
        name: "Venice Luxury Palace  2",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.43868,
        longitude: 12.33291,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33291, 45.43868]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40774747,
        name: "Venice Luxury San Marco Palace",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.44073,
        longitude: 12.33619,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33619, 45.44073]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40777478,
        name: "Design studio apartment with a canal view",
        host_id: 316786685,
        host_name: "Combo",
        latitude: 45.44414,
        longitude: 12.33768,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33768, 45.44414]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40781098,
        name: "Casa delle Botteghe San Marco Venezia",
        host_id: 164821863,
        host_name: "Luca",
        latitude: 45.43472,
        longitude: 12.32932,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32932, 45.43472]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40789413,
        name: "Venitian charming house",
        host_id: 7297893,
        host_name: "Alexandre",
        latitude: 45.43896,
        longitude: 12.34462,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34462, 45.43896]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40792155,
        name: "Accademia Charm Apartment n.1",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.43042,
        longitude: 12.3342,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3342, 45.43042]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40792418,
        name: "Amazing apartment on the Grand Canal",
        host_id: 753296,
        host_name: "B&B Numero25",
        latitude: 45.43464,
        longitude: 12.33233,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33233, 45.43464]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40792766,
        name: "Best Rialto Palace Apartment",
        host_id: 104994977,
        host_name: "My Ovatta Srl",
        latitude: 45.44179,
        longitude: 12.33288,
        beds: 6,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33288, 45.44179]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40797841,
        name: "Welc-om Tre Archi Big",
        host_id: 20717796,
        host_name: "Welc-Om",
        latitude: 45.4469,
        longitude: 12.32371,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32371, 45.4469]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40804801,
        name: "NEW SINGLE ROOM TO ENJOY LOCAL EXPERIENCE VENICE",
        host_id: 5113473,
        host_name: "Sara E Giovanni",
        latitude: 45.44191,
        longitude: 12.32616,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32616, 45.44191]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40819642,
        name: "Apartment La Centrale-  Spacious and quiet",
        host_id: 137287637,
        host_name: "Roberto & Guadalupe",
        latitude: 45.44288,
        longitude: 12.32151,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32151, 45.44288]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40855773,
        name: "Appartamento Leon Bianco on the Grand Canal",
        host_id: 318004893,
        host_name: "Appartamento Leon Bianco",
        latitude: 45.44093,
        longitude: 12.33701,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33701, 45.44093]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40878406,
        name: "❤ Sweet dream in Venice ❤",
        host_id: 317120854,
        host_name: "Giulia",
        latitude: 45.43958,
        longitude: 12.33316,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33316, 45.43958]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40888655,
        name: "Piccola mansarda luminosa, accogliente e centrale",
        host_id: 27108798,
        host_name: "Sandra",
        latitude: 45.43418,
        longitude: 12.34505,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34505, 45.43418]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40912933,
        name: "La Loggia Grand Canal",
        host_id: 669047,
        host_name: "Viewsonvenice",
        latitude: 45.44308,
        longitude: 12.32588,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32588, 45.44308]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40923943,
        name: "Loft with terrace 10 minutes from S. Marco",
        host_id: 201739458,
        host_name: "Your.Rentals",
        latitude: 45.43606,
        longitude: 12.34831,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34831, 45.43606]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40928289,
        name: "IN THE REAL VENICE WITH LOVE",
        host_id: 318884855,
        host_name: "Fabiana",
        latitude: 45.44039,
        longitude: 12.33878,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33878, 45.44039]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40938392,
        name: "Beautiful apt near the beach & Wifi",
        host_id: 107247539,
        host_name: "Loic, Estelle & Co",
        latitude: 45.43826,
        longitude: 12.32952,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32952, 45.43826]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40938413,
        name: "RESIDENZA CA' BOTTERI - SAN MARCO CAMERA ROSA",
        host_id: 318960555,
        host_name: "Selena",
        latitude: 45.44007,
        longitude: 12.33164,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33164, 45.44007]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40939404,
        name: "Ca' Degli Specchi Grand Canal",
        host_id: 669047,
        host_name: "Viewsonvenice",
        latitude: 45.44364,
        longitude: 12.32595,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32595, 45.44364]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40955902,
        name: "Gold Venetian New Style @Ca' D'Oro",
        host_id: 188530147,
        host_name: "Cesare",
        latitude: 45.44122,
        longitude: 12.33531,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33531, 45.44122]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40956476,
        name: "RESIDENZA CA' BOTTERI - TORCELLO CAMERE ORO",
        host_id: 318960555,
        host_name: "Selena",
        latitude: 45.43812,
        longitude: 12.33226,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33226, 45.43812]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40960987,
        name: "Double Room with canal view@Antico Fiore Venice",
        host_id: 3060084,
        host_name: "Giacomo",
        latitude: 45.43419,
        longitude: 12.3299,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3299, 45.43419]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40960999,
        name: "Superior Double Room @ Antico Fiore Venice",
        host_id: 3060084,
        host_name: "Giacomo",
        latitude: 45.43418,
        longitude: 12.32918,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32918, 45.43418]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40961260,
        name: "Double Room with canal view@Antico Fiore Venice",
        host_id: 3060084,
        host_name: "Giacomo",
        latitude: 45.43337,
        longitude: 12.33092,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33092, 45.43337]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40961562,
        name: "RESIDENZA CA' BOTTERI - GIUDECCA CAMERE AZZURRE",
        host_id: 318960555,
        host_name: "Selena",
        latitude: 45.43841,
        longitude: 12.32975,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32975, 45.43841]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40961887,
        name: "RESIDENZA CA' BOTTERI - CA' REZZONICO CAMERA ROSSA",
        host_id: 318960555,
        host_name: "Selena",
        latitude: 45.43689,
        longitude: 12.33151,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33151, 45.43689]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40962380,
        name: "Camera doppia spaziosa @Antico Fiore Venice",
        host_id: 3060084,
        host_name: "Giacomo",
        latitude: 45.43461,
        longitude: 12.32981,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32981, 45.43461]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40962599,
        name: "Vanilla House",
        host_id: 252534840,
        host_name: "Giorgia",
        latitude: 45.43816,
        longitude: 12.34454,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34454, 45.43816]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40977045,
        name: "CASA CANAL nel cuore di Venezia",
        host_id: 319514776,
        host_name: "Angela",
        latitude: 45.43477,
        longitude: 12.32843,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32843, 45.43477]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40980582,
        name: "Luxury Zattere Canal View",
        host_id: 46528252,
        host_name: "Alex",
        latitude: 45.42987,
        longitude: 12.32661,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32661, 45.42987]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40985062,
        name: "RESIDENZA AI MARZIALI, free WI-FI CANAL view",
        host_id: 3736168,
        host_name: "EasyRentals",
        latitude: 45.44415,
        longitude: 12.33255,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33255, 45.44415]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40988264,
        name:
          "Calle Del Paradiso 702 - L. T. M (Phone number hidden by Airbnb)",
        host_id: 204435441,
        host_name: "Mariagiovanna",
        latitude: 45.4378,
        longitude: 12.33309,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33309, 45.4378]] },
    },
    {
      type: "Feature",
      properties: {
        id: 40994160,
        name: "Hotel Antiche Figure-Superior room + extra bed",
        host_id: 313797107,
        host_name: "Hotel Antiche",
        latitude: 45.4399,
        longitude: 12.32256,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32256, 45.4399]] },
    },
    {
      type: "Feature",
      properties: {
        id: 41016237,
        name: "RESIDENZA CA' BOTTERI - BURANO CAMERA NERA",
        host_id: 318960555,
        host_name: "Selena",
        latitude: 45.44005,
        longitude: 12.33339,
        beds: 0,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33339, 45.44005]] },
    },
    {
      type: "Feature",
      properties: {
        id: 41016437,
        name: "Apartment Grand Canal View (with lift)",
        host_id: 2634978,
        host_name: "City Apartments",
        latitude: 45.43651,
        longitude: 12.32861,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32861, 45.43651]] },
    },
    {
      type: "Feature",
      properties: {
        id: 41017200,
        name: "Black Venetian New Style @Ca' d'Oro",
        host_id: 188530147,
        host_name: "Cesare",
        latitude: 45.44309,
        longitude: 12.33401,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33401, 45.44309]] },
    },
    {
      type: "Feature",
      properties: {
        id: 41017317,
        name: "San Marco Apartment",
        host_id: 117573810,
        host_name: "Alessa",
        latitude: 45.43353,
        longitude: 12.33513,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33513, 45.43353]] },
    },
    {
      type: "Feature",
      properties: {
        id: 41017407,
        name: "Suite luxury-grey",
        host_id: 117573810,
        host_name: "Alessa",
        latitude: 45.43463,
        longitude: 12.33495,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33495, 45.43463]] },
    },
    {
      type: "Feature",
      properties: {
        id: 41017509,
        name: "San Polo Apartment",
        host_id: 117573810,
        host_name: "Alessa",
        latitude: 45.43453,
        longitude: 12.33503,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33503, 45.43453]] },
    },
    {
      type: "Feature",
      properties: {
        id: 41017556,
        name: "Double deluxe room-Mansarda",
        host_id: 117573810,
        host_name: "Alessa",
        latitude: 45.4329,
        longitude: 12.33382,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33382, 45.4329]] },
    },
    {
      type: "Feature",
      properties: {
        id: 41021822,
        name: "Hotel Antiche Figure - Deluxe double room",
        host_id: 313797107,
        host_name: "Hotel Antiche",
        latitude: 45.43949,
        longitude: 12.32176,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32176, 45.43949]] },
    },
    {
      type: "Feature",
      properties: {
        id: 41022122,
        name: "Hotel Antiche Figure Junior Suite deluxe+extra bed",
        host_id: 313797107,
        host_name: "Hotel Antiche",
        latitude: 45.43965,
        longitude: 12.32154,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32154, 45.43965]] },
    },
    {
      type: "Feature",
      properties: {
        id: 41022648,
        name: "Hotel Antiche Figure - Residence Suite",
        host_id: 313797107,
        host_name: "Hotel Antiche",
        latitude: 45.43936,
        longitude: 12.32252,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32252, 45.43936]] },
    },
    {
      type: "Feature",
      properties: {
        id: 41041017,
        name: "luxury venice gold Flat Venice centre",
        host_id: 191226100,
        host_name: "Milo",
        latitude: 45.44108,
        longitude: 12.3403,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3403, 45.44108]] },
    },
    {
      type: "Feature",
      properties: {
        id: 41042834,
        name: "A POCHI PASSI DALLA STAZIONE - N. 3",
        host_id: 244865064,
        host_name: "Andrea",
        latitude: 45.44443,
        longitude: 12.3297,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3297, 45.44443]] },
    },
    {
      type: "Feature",
      properties: {
        id: 41075762,
        name: "Ambra superior suite with kitchen",
        host_id: 321173046,
        host_name: "Monica",
        latitude: 45.43352,
        longitude: 12.33938,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33938, 45.43352]] },
    },
    {
      type: "Feature",
      properties: {
        id: 41093996,
        name: "Apartment Ca' dei Mercanti",
        host_id: 214062359,
        host_name: "Sarlux",
        latitude: 45.4385,
        longitude: 12.33442,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33442, 45.4385]] },
    },
    {
      type: "Feature",
      properties: {
        id: 41100346,
        name: "VENEZIA SUI TETTI / VENICE ON THE ROOFS",
        host_id: 298247165,
        host_name: "Enrico",
        latitude: 45.43904,
        longitude: 12.34368,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34368, 45.43904]] },
    },
    {
      type: "Feature",
      properties: {
        id: 41100765,
        name: "Smon' Secret",
        host_id: 321485673,
        host_name: "Simone",
        latitude: 45.43528,
        longitude: 12.33583,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33583, 45.43528]] },
    },
    {
      type: "Feature",
      properties: {
        id: 41102981,
        name: "APPARTAMENTO VISTA CANALE PER COPPIE E FAMIGLIE",
        host_id: 321508263,
        host_name: "Fabio",
        latitude: 45.43094,
        longitude: 12.32554,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32554, 45.43094]] },
    },
    {
      type: "Feature",
      properties: {
        id: 41103670,
        name: "Residences Barbaria",
        host_id: 321519762,
        host_name: "Fabio",
        latitude: 45.43984,
        longitude: 12.34598,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34598, 45.43984]] },
    },
    {
      type: "Feature",
      properties: {
        id: 41110196,
        name: "A POCHI PASSI DALLA STAZIONE - N. 1",
        host_id: 244865064,
        host_name: "Andrea",
        latitude: 45.44297,
        longitude: 12.32821,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32821, 45.44297]] },
    },
    {
      type: "Feature",
      properties: {
        id: 41121054,
        name: "CA' MARIN VENICE APARTMENT",
        host_id: 5862083,
        host_name: "Silvia",
        latitude: 45.43665,
        longitude: 12.32655,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32655, 45.43665]] },
    },
    {
      type: "Feature",
      properties: {
        id: 41124182,
        name: "Balcon sur le ciel - appartement de charme",
        host_id: 2061710,
        host_name: "Valence",
        latitude: 45.43681,
        longitude: 12.34709,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34709, 45.43681]] },
    },
    {
      type: "Feature",
      properties: {
        id: 41124718,
        name: "CasaGiardini - Full typical Venetian house",
        host_id: 248368998,
        host_name: "Adriano",
        latitude: 45.43246,
        longitude: 12.35392,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35392, 45.43246]] },
    },
    {
      type: "Feature",
      properties: {
        id: 41129106,
        name: "Selva superior suite",
        host_id: 321173046,
        host_name: "Monica",
        latitude: 45.43483,
        longitude: 12.33242,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33242, 45.43483]] },
    },
    {
      type: "Feature",
      properties: {
        id: 41143165,
        name: "Venice Ca' Rosy, 1 minuto vero da Piazza San Marco",
        host_id: 26191936,
        host_name: "Manuela",
        latitude: 45.43518,
        longitude: 12.34292,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34292, 45.43518]] },
    },
    {
      type: "Feature",
      properties: {
        id: 41174922,
        name: "Luna di miele",
        host_id: 224805962,
        host_name: "Elisabetta",
        latitude: 45.43574,
        longitude: 12.33142,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33142, 45.43574]] },
    },
    {
      type: "Feature",
      properties: {
        id: 41186648,
        name: "San Marco Square - Studio Apartment 1386",
        host_id: 321429178,
        host_name: "Riccardo",
        latitude: 45.433498044353101,
        longitude: 12.337763017908346,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33776, 45.4335]] },
    },
    {
      type: "Feature",
      properties: {
        id: 41189893,
        name: "Nice studio in Venise & Wifi",
        host_id: 107247539,
        host_name: "Loic, Estelle & Co",
        latitude: 45.43241,
        longitude: 12.35669,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35669, 45.43241]] },
    },
    {
      type: "Feature",
      properties: {
        id: 41190027,
        name: "Big apt with terrace & Wifi",
        host_id: 107247539,
        host_name: "Loic, Estelle & Co",
        latitude: 45.4258,
        longitude: 12.33948,
        beds: 7,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33948, 45.4258]] },
    },
    {
      type: "Feature",
      properties: {
        id: 41190057,
        name: "Nice apt in Venezia & Wifi",
        host_id: 107247539,
        host_name: "Loic, Estelle & Co",
        latitude: 45.43691,
        longitude: 12.32473,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32473, 45.43691]] },
    },
    {
      type: "Feature",
      properties: {
        id: 41190074,
        name: "Beautiful apt in Venezia & Wifi",
        host_id: 107247539,
        host_name: "Loic, Estelle & Co",
        latitude: 45.43092,
        longitude: 12.35509,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35509, 45.43092]] },
    },
    {
      type: "Feature",
      properties: {
        id: 41190108,
        name: "Nice apt with sea view & Wifi",
        host_id: 107247539,
        host_name: "Loic, Estelle & Co",
        latitude: 45.43302,
        longitude: 12.35447,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35447, 45.43302]] },
    },
    {
      type: "Feature",
      properties: {
        id: 41193563,
        name: "Romantico nido nella città dell' amore",
        host_id: 41684464,
        host_name: "VeneziaImmobiliare Sas Di",
        latitude: 45.44295,
        longitude: 12.32029,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32029, 45.44295]] },
    },
    {
      type: "Feature",
      properties: {
        id: 41206284,
        name: "Rio Marin Apartment",
        host_id: 276201478,
        host_name: "Davide",
        latitude: 45.43965,
        longitude: 12.32751,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32751, 45.43965]] },
    },
    {
      type: "Feature",
      properties: {
        id: 41230237,
        name: "S. MARK & BIENNALE, family apt 2BDR 6p LUG DEPOSIT",
        host_id: 191187861,
        host_name: "Federica",
        latitude: 45.43395,
        longitude: 12.34387,
        beds: 5,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34387, 45.43395]] },
    },
    {
      type: "Feature",
      properties: {
        id: 41250584,
        name: "Bovolo Luxury",
        host_id: 98131866,
        host_name: "Michele",
        latitude: 45.43367,
        longitude: 12.33136,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33136, 45.43367]] },
    },
    {
      type: "Feature",
      properties: {
        id: 41258135,
        name: "charming apartment Venezia Center4 people",
        host_id: 9129990,
        host_name: "Sebastiano",
        latitude: 45.43229,
        longitude: 12.33188,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33188, 45.43229]] },
    },
    {
      type: "Feature",
      properties: {
        id: 41301335,
        name: "Rialto-Saint Mark ☀️ attic historic center Wi-Fi",
        host_id: 321289284,
        host_name: "Top Italy",
        latitude: 45.43663,
        longitude: 12.33861,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33861, 45.43663]] },
    },
    {
      type: "Feature",
      properties: {
        id: 41305361,
        name: "Biennale modern apartment up to 4 by Bricola",
        host_id: 205703685,
        host_name: "Bricola",
        latitude: 45.43233,
        longitude: 12.35462,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35462, 45.43233]] },
    },
    {
      type: "Feature",
      properties: {
        id: 41331820,
        name: "La Galerie",
        host_id: 84879311,
        host_name: "Francesca",
        latitude: 45.43861,
        longitude: 12.35079,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35079, 45.43861]] },
    },
    {
      type: "Feature",
      properties: {
        id: 41361004,
        name: "Casa Canal",
        host_id: 46086362,
        host_name: "Marco",
        latitude: 45.433789461118046,
        longitude: 12.356380717289161,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35638, 45.43379]] },
    },
    {
      type: "Feature",
      properties: {
        id: 41362455,
        name: "Emotions Venice 1",
        host_id: 29619859,
        host_name: "Stefano",
        latitude: 45.437212257025585,
        longitude: 12.3288693850361,
        beds: null,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32887, 45.43721]] },
    },
    {
      type: "Feature",
      properties: {
        id: 41366898,
        name: "Biannale Venezia",
        host_id: 258215830,
        host_name: "Hamzah",
        latitude: 45.437221948827201,
        longitude: 12.346347649884885,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.34635, 45.43722]] },
    },
    {
      type: "Feature",
      properties: {
        id: 41369158,
        name: "Emotions Venice 2",
        host_id: 29619859,
        host_name: "Stefano",
        latitude: 45.442726027640965,
        longitude: 12.325450647810356,
        beds: 4,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32545, 45.44273]] },
    },
    {
      type: "Feature",
      properties: {
        id: 41379762,
        name: "Attico Veneziano",
        host_id: 31731422,
        host_name: "Alessandra",
        latitude: 45.430680155060202,
        longitude: 12.327704754082438,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3277, 45.43068]] },
    },
    {
      type: "Feature",
      properties: {
        id: 41395106,
        name: "☀︎San Marco Experience☀︎ 5-Bed Female Dorm",
        host_id: 22943638,
        host_name: "Sam",
        latitude: 45.434125533461987,
        longitude: 12.335902111058116,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3359, 45.43413]] },
    },
    {
      type: "Feature",
      properties: {
        id: 41395740,
        name: "☀︎San Marco Experience☀︎ 5-Bed Female Dorm",
        host_id: 22943638,
        host_name: "Sam",
        latitude: 45.434125533461987,
        longitude: 12.335902111058116,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3359, 45.43413]] },
    },
    {
      type: "Feature",
      properties: {
        id: 41396011,
        name: "☀︎San Marco Experience☀︎ 3-Bed Female Dorm",
        host_id: 22943638,
        host_name: "Sam",
        latitude: 45.434125533461987,
        longitude: 12.335902111058116,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3359, 45.43413]] },
    },
    {
      type: "Feature",
      properties: {
        id: 41396266,
        name: "CÀ BARNABA",
        host_id: 38346442,
        host_name: "Giancarlo",
        latitude: 45.433883034905662,
        longitude: 12.325257573524915,
        beds: 3,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.32526, 45.43388]] },
    },
    {
      type: "Feature",
      properties: {
        id: 41396338,
        name: "☀︎San Marco Experience☀︎ 2-Bed Female Dorm",
        host_id: 22943638,
        host_name: "Sam",
        latitude: 45.434125533461987,
        longitude: 12.335902111058116,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.3359, 45.43413]] },
    },
    {
      type: "Feature",
      properties: {
        id: 41396728,
        name: "☼San Marco Experience☼ Bright Private Double Room",
        host_id: 22943638,
        host_name: "Sam",
        latitude: 45.434742443252176,
        longitude: 12.335034089745019,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33503, 45.43474]] },
    },
    {
      type: "Feature",
      properties: {
        id: 41397120,
        name: "☼San Marco Experience☼ Comfy Private Single Room",
        host_id: 22943638,
        host_name: "Sam",
        latitude: 45.434742443252176,
        longitude: 12.335034089745019,
        beds: 1,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33503, 45.43474]] },
    },
    {
      type: "Feature",
      properties: {
        id: 41415216,
        name: "☀ Central Apt. near Biennale Gardens ☀",
        host_id: 325264034,
        host_name: "Simone",
        latitude: 45.431958178237124,
        longitude: 12.35438410266476,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.35438, 45.43196]] },
    },
    {
      type: "Feature",
      properties: {
        id: 41425605,
        name: "Ca’ Zulian Apartment - Grand Canal",
        host_id: 153493391,
        host_name: "Pietro And Caterina",
        latitude: 45.441088888482675,
        longitude: 12.331486413029085,
        beds: 2,
      },
      geometry: { type: "MultiPoint", coordinates: [[12.33149, 45.44109]] },
    },
  ],
};
